import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An arbitrary precision signed decimal */
  BigDecimal: { input: any; output: any; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: any; output: any; }
  /** Custom scalar definitions */
  DateTime: { input: any; output: any; }
  /** ISO-8601 duration (e.g., PT1H30M for 1 hour 30 minutes) */
  Duration: { input: any; output: any; }
  /** A JSON scalar */
  JSON: { input: any; output: any; }
  /** 24-hour clock time value string in the format `hh:mm:ss` or `hh:mm:ss.sss`. */
  LocalTime: { input: any; output: any; }
  /** A 64-bit signed integer */
  Long: { input: any; output: any; }
};

/** An acquisition source representing a marketing campaign, partnership, or other acquisition channel. */
export type AcquisitionSource = {
  __typename: 'AcquisitionSource';
  active: Scalars['Boolean']['output'];
  couponCodes: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerCount: Scalars['Int']['output'];
  defaultSegment: CustomerSegment;
  endDate?: Maybe<Scalars['Date']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  partnerName?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AcquisitionSourceConnection = {
  __typename: 'AcquisitionSourceConnection';
  edges: Array<AcquisitionSourceEdge>;
  pageInfo: AcquisitionSourcePageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * One acquisition source's revenue in ONE currency (YOJO-3018). A source that sold in several currencies has one
 * entry per currency; amounts are never added across currencies (ADR 0010). Revenue is the customers' first
 * purchase only (YOJO-2754).
 */
export type AcquisitionSourceCurrencyRevenue = {
  __typename: 'AcquisitionSourceCurrencyRevenue';
  /** ISO 4217 code, uppercase (e.g. "GBP"). A null or blank payment currency is counted as GBP, like Monthly Revenue. */
  currency: Scalars['String']['output'];
  /** Customers of the source whose payment was in `currency`. */
  customerCount: Scalars['Int']['output'];
  /** Sum of amountPaid in `currency`, major units. */
  totalAmount: Scalars['BigDecimal']['output'];
};

export type AcquisitionSourceEdge = {
  __typename: 'AcquisitionSourceEdge';
  cursor: Scalars['String']['output'];
  node: AcquisitionSource;
};

export type AcquisitionSourceFilter = {
  /** Include inactive sources (default false) */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Text search across name, partner name, and coupon codes */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type AcquisitionSourcePageInfo = {
  __typename: 'AcquisitionSourcePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type AcquisitionSourceStats = {
  __typename: 'AcquisitionSourceStats';
  activeCustomers: Scalars['Int']['output'];
  /** @deprecated Removed upon YOJO-3552 */
  currency: Scalars['String']['output'];
  customerCount: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  partnerName?: Maybe<Scalars['String']['output']>;
  pendingCustomers: Scalars['Int']['output'];
  /** Revenue per currency, ordered by currency code. Customers without a payment are in no entry. */
  revenueByCurrency: Array<AcquisitionSourceCurrencyRevenue>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  sourceName: Scalars['String']['output'];
  /** @deprecated Removed upon YOJO-3552 */
  totalRevenue: Scalars['BigDecimal']['output'];
};

/** Result of entitlement activation mutation. */
export type ActivateEntitlementResult = {
  __typename: 'ActivateEntitlementResult';
  entitlement?: Maybe<Entitlement>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * Activation email status for an entitlement.
 * Shows whether the activation code email was successfully delivered.
 */
export type ActivationEmailStatus = {
  __typename: 'ActivationEmailStatus';
  /** Number of send attempts */
  attemptCount: Scalars['Int']['output'];
  /** When delivery was confirmed (if available from provider webhook) */
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Recipient email address */
  emailAddress: Scalars['String']['output'];
  /** Entitlement this email was sent for */
  entitlementId: Scalars['ID']['output'];
  /** Error message if the email failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** When the email failed (if status is FAILED) */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the email was sent */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current delivery status */
  status: EmailStatus;
};

/** Represents an unrolled activity for a specific date and time block */
export type Activity = {
  __typename: 'Activity';
  /** Whether this activity is still active */
  active: Scalars['Boolean']['output'];
  /** The content reference that needs to be performed */
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  /** When this activity was created */
  createdAt: Scalars['DateTime']['output'];
  /** The date this activity is scheduled for */
  date: Scalars['Date']['output'];
  /** When this activity was last completed, if ever */
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Human readable name of the activity (resolved from contentReference) */
  name: Scalars['String']['output'];
  /** Reference to the planned activity this instance was created from */
  plannedActivityId: Scalars['ID']['output'];
  /**
   * Who planned this activity: the starter list every new member gets, someone on the care team, or the
   * member. Null when unknown.
   */
  plannedBy?: Maybe<PlanningOrigin>;
  /**
   * What the member's app serves for the planned mode now, and why. Null when no mode is planned, or
   * when the member's modes cannot be known right now (keep the last known). Read by the member only.
   */
  plannedMode?: Maybe<PlannedModeCard>;
  /**
   * The Stone mode the care team planned for this vns_session, as planned (never swapped). Null = the
   * member chooses.
   */
  plannedModeId?: Maybe<Scalars['ID']['output']>;
  /**
   * The resolved content for this activity
   * @deprecated Use contentReference.hydratedContent instead
   */
  resolvedContent: ActivityVideo | Article | ArticleTeaser | CustomActivity | DojoArticle | DojoChecklist | DojoNugget | DojoQuiz | DojoQuote | JourneyVideo | Lesson | MobileWidget | Story | StoryTeaser | VideoTeaser;
  /** The time block this activity is scheduled for */
  timeBlock: TimeBlock;
};

/** Represents a user's activity planning containing all their planned activities */
export type ActivityPlanning = {
  __typename: 'ActivityPlanning';
  /** Unique identifier for the planning */
  activityPlanningId: Scalars['ID']['output'];
  /** When this planning was created */
  createdAt: Scalars['DateTime']['output'];
  /** Custom activities defined for this planning */
  customActivities: Array<CustomActivity>;
  /** All planned activities for this user */
  plannedActivities: Array<PlannedActivity>;
  /** When this planning was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user this planning belongs to */
  userId: Scalars['ID']['output'];
};

/** Defines when an activity should be performed */
export type ActivityTimeSlot = {
  __typename: 'ActivityTimeSlot';
  /** Day of the week this slot applies to */
  dayOfWeek: WeekDay;
  /** Time block when activity should be performed */
  timeBlock: TimeBlock;
};

export type ActivityTimeSlotInput = {
  /** Day of week for this time slot */
  dayOfWeek: WeekDay;
  /** Time block for the activity */
  timeBlock: TimeBlock;
};

export type ActivityVideo = BaseArticle & BaseVideo & CmsDocument & Content & {
  __typename: 'ActivityVideo';
  biopsychosocialScores: Array<BiopsychosocialScore>;
  caption?: Maybe<VideoCaption>;
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  impactedVitals?: Maybe<Array<ImpactedVital>>;
  interventionType?: Maybe<InterventionType>;
  mediaType?: Maybe<MediaType>;
  metadata: Metadata;
  protocols?: Maybe<Array<Protocol>>;
  reviewer?: Maybe<Reviewer>;
  subprotocols?: Maybe<Array<Subprotocol>>;
  suggestedContentIds?: Maybe<Array<Scalars['String']['output']>>;
  thumbnail?: Maybe<Image>;
  /** Title of the article as defined in the CMS. */
  title: Scalars['String']['output'];
  userIntent?: Maybe<UserIntent>;
  videoFile?: Maybe<Video>;
};

export type Actor = {
  __typename: 'Actor';
  displayName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AddNotificationTokenCommand = {
  token: Scalars['String']['input'];
  type: NotificationTokenType;
};

/** Participant Notes - Input Types */
export type AddParticipantNoteInput = {
  categories?: InputMaybe<Array<NoteCategory>>;
  content: Scalars['String']['input'];
  flagReason?: InputMaybe<Scalars['String']['input']>;
  flagStatus?: InputMaybe<FlagStatus>;
  linkedConsultNumber?: InputMaybe<Scalars['Int']['input']>;
  linkedToMessageId?: InputMaybe<Scalars['String']['input']>;
  participantId: Scalars['ID']['input'];
};

export type AddPathToLearningJourneyCommand = {
  learningJourneyId: Scalars['ID']['input'];
  learningPathId: Scalars['ID']['input'];
  optional: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  unlockStrategy: UnlockStrategy;
};

/** Input for adopting a Stripe-created Payment Link */
export type AdoptPaymentLinkInput = {
  /** The Stripe Payment Link ID to adopt (e.g., plink_xxx) */
  id: Scalars['ID']['input'];
  /** Internal reference name for the payment link */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Purpose/campaign identifier */
  purpose?: InputMaybe<Scalars['String']['input']>;
};

export type AgeAdjustedThreshold = {
  __typename: 'AgeAdjustedThreshold';
  ageBracket: AgeBracket;
  threshold: Scalars['Float']['output'];
};

/** PII related type definitions */
export enum AgeBracket {
  Age_25_34 = 'age_25_34',
  Age_35_44 = 'age_35_44',
  Age_45_54 = 'age_45_54',
  Age_55_64 = 'age_55_64',
  Over_65 = 'over_65',
  Under_25 = 'under_25'
}

/** Cohort data for a specific age bracket */
export type AgeBracketCohort = {
  __typename: 'AgeBracketCohort';
  /** The age bracket this cohort represents */
  ageBracket: AgeBracket;
  /** Area Under Curve summary for this age bracket's percentage change trend */
  auc?: Maybe<CohortAuc>;
  /** Time series data points for this age bracket */
  dataPoints: Array<CohortAnalysisDataPoint>;
  /** Number of users in this age bracket */
  userCount: Scalars['Int']['output'];
};

/** Strategy for aggregating stat values */
export enum AggregationStrategy {
  /** Average value over time period */
  Average = 'average',
  /** Best value over time period */
  Best = 'best',
  /** Sum of values over time period */
  Sum = 'sum',
  /** Worst value over time period */
  Worst = 'worst'
}

/** A counted budget for one period. */
export type Allowance = {
  __typename: 'Allowance';
  /** Null = unlimited. */
  limit?: Maybe<Scalars['Int']['output']>;
  period: AllowancePeriod;
  /** New ones that may still be started this period, never below 0. Null = unlimited. */
  remaining?: Maybe<Scalars['Int']['output']>;
  /** When used returns to 0, as an absolute instant. Always set for day. */
  resetsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Used this period. Never negative. */
  used: Scalars['Int']['output'];
};

/** Parse tolerantly: values may be added. */
export enum AllowancePeriod {
  /** A UTC day, 00:00Z to the next 00:00Z; not the member's local midnight. */
  Day = 'day'
}

/** One named field per allowance; fields may be added. */
export type Allowances = {
  __typename: 'Allowances';
  /**
   * Face scans. One unit is a scan occasion: a session's before and after together, or one standalone capture.
   * Joining an occasion already counted spends nothing and is never refused.
   */
  faceScans: Allowance;
};

export enum AlphaEvidence {
  InHand = 'in_hand',
  InUseNotOnFile = 'in_use_not_on_file',
  NoneKnown = 'none_known',
  Retired = 'retired',
  UsedBefore = 'used_before'
}

/** User feedback about the yojo app */
export type AppFeedback = {
  __typename: 'AppFeedback';
  comment?: Maybe<Scalars['String']['output']>;
  feedbackId: Scalars['ID']['output'];
  pii?: Maybe<Pii>;
  sentiment?: Maybe<AppFeedbackSentiment>;
  submittedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** Sentiment options for app feedback */
export enum AppFeedbackSentiment {
  IdLove = 'id_love',
  LovedThis = 'loved_this',
  NeedsLove = 'needs_love'
}

export type AppLifecycle = {
  __typename: 'AppLifecycle';
  /** Either blocks or frames are provided */
  blocks?: Maybe<Array<Maybe<ContentBlock>>>;
  /** Either blocks or frames are provided */
  frames?: Maybe<Array<Maybe<ContentFrame>>>;
  id: Scalars['ID']['output'];
  moment?: Maybe<LifecycleMoment>;
  timing?: Maybe<LifecycleTiming>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Provenance of a bulk-assignment approval. */
export enum ApprovedVia {
  CarePortal = 'care_portal'
}

export type ArchiveParticipantNoteInput = {
  noteId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Article = BaseArticle & CmsDocument & Content & {
  __typename: 'Article';
  biopsychosocialScores: Array<BiopsychosocialScore>;
  blocks?: Maybe<Array<Maybe<ContentBlock>>>;
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  impactedVitals?: Maybe<Array<ImpactedVital>>;
  interventionType?: Maybe<InterventionType>;
  mediaType?: Maybe<MediaType>;
  metadata: Metadata;
  protocols?: Maybe<Array<Protocol>>;
  reviewer?: Maybe<Reviewer>;
  subprotocols?: Maybe<Array<Subprotocol>>;
  thumbnail?: Maybe<Image>;
  /** Title of the article as defined in the CMS. */
  title: Scalars['String']['output'];
  userIntent?: Maybe<UserIntent>;
};

/** Connection type for paginated articles */
export type ArticleConnection = {
  __typename: 'ArticleConnection';
  /** List of articles in this page */
  articles: Array<ActivityVideo | Article | JourneyVideo | Lesson | Story>;
  /** Page info for ID-based pagination */
  pageInfo: PageInfo;
  /**
   * Search ID for CTR analytics tracking.
   * Present when search was performed, used by client to report clicks.
   */
  searchId?: Maybe<Scalars['String']['output']>;
};

export type ArticleFilter = {
  /** Filter by content references */
  contentReferences?: InputMaybe<Array<ContentReferenceInput>>;
  /** Filter by content type (Article, Story, Lesson) */
  contentTypes?: InputMaybe<Array<ContentType>>;
  /** Filter by duration range in minutes */
  duration?: InputMaybe<DurationFilter>;
  /** Filter by impacted vitals */
  impactedVitals?: InputMaybe<Array<ImpactedVital>>;
  /** Filter by intervention type */
  interventionType?: InputMaybe<InterventionType>;
  /** Filter by metadata attributes */
  metadata?: InputMaybe<MetadataFilter>;
  /** Filter by protocols */
  protocols?: InputMaybe<Array<Protocol>>;
  /** Search term for text-based search on article titles */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Filter by subprotocols */
  subprotocols?: InputMaybe<Array<Subprotocol>>;
  /** Filter by user intents - matches if article has any of the specified intents */
  userIntents?: InputMaybe<Array<UserIntent>>;
};

export enum ArticleSortField {
  CreatedAt = 'created_at',
  Duration = 'duration',
  Random = 'random',
  Title = 'title'
}

export type ArticleSortInput = {
  /** Sort direction */
  direction: SortDirection;
  /** Field to sort by */
  field: ArticleSortField;
};

export type ArticleTeaser = BaseTeaser & CmsDocument & Content & DojoElement & {
  __typename: 'ArticleTeaser';
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  ctaButtonLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkedContent?: Maybe<CustomActivityId | ExternalContentId | MobileWidgetId>;
  media?: Maybe<File | Image | Video | VideoCaption>;
  /** @deprecated Renamed to `title` */
  name?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AssertExperiencesSeenCommand = {
  /** Governed experiences the member has now seen. Idempotent; first-seen time preserved. */
  experiences: Array<ExperienceName>;
};

export type AssignRolesInput = {
  /** The account ID to assign roles to (act_ prefix) */
  accountId: Scalars['ID']['input'];
  /**
   * Roles to assign (admin, nurse, content, developer, analyst, operations, sales, growth)
   * Cannot include 'participant' or 'user' roles
   */
  roles: Array<Role>;
};

export type AssignUserToJourneyCommand = {
  learningJourneyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type AttachBlock = {
  __typename: 'AttachBlock';
  description: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export type AudioBlock = {
  __typename: 'AudioBlock';
  altText: Scalars['String']['output'];
  audioUrl: Scalars['String']['output'];
};

/** The OS background-app-refresh permission state as observed at heartbeat time. */
export enum BackgroundAppRefreshStatus {
  Available = 'available',
  Denied = 'denied',
  Restricted = 'restricted'
}

export type BaseArticle = {
  biopsychosocialScores: Array<BiopsychosocialScore>;
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  impactedVitals?: Maybe<Array<ImpactedVital>>;
  interventionType?: Maybe<InterventionType>;
  mediaType?: Maybe<MediaType>;
  metadata: Metadata;
  protocols?: Maybe<Array<Protocol>>;
  reviewer?: Maybe<Reviewer>;
  subprotocols?: Maybe<Array<Subprotocol>>;
  thumbnail?: Maybe<Image>;
  /** Title of the article as defined in the CMS. */
  title: Scalars['String']['output'];
  userIntent?: Maybe<UserIntent>;
};

/** Common interface for all metrics recorded in the system */
export type BaseMetric = {
  /** Unique identifier for this metric */
  id: Scalars['ID']['output'];
  /** When the metric was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** User who recorded the metric */
  userId: Scalars['String']['output'];
  /** The recorded value */
  value: Scalars['Float']['output'];
};

export type BaseTeaser = {
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  ctaButtonLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Reference to the linked content (article/story/video) for navigation. */
  linkedContent?: Maybe<CustomActivityId | ExternalContentId | MobileWidgetId>;
  media?: Maybe<File | Image | Video | VideoCaption>;
  /** @deprecated Renamed to `title` */
  name?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type BaseVideo = {
  biopsychosocialScores: Array<BiopsychosocialScore>;
  /** Caption file for this content */
  caption?: Maybe<VideoCaption>;
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  impactedVitals?: Maybe<Array<ImpactedVital>>;
  interventionType?: Maybe<InterventionType>;
  mediaType?: Maybe<MediaType>;
  metadata: Metadata;
  protocols?: Maybe<Array<Protocol>>;
  reviewer?: Maybe<Reviewer>;
  subprotocols?: Maybe<Array<Subprotocol>>;
  /** List of suggested content IDs */
  suggestedContentIds?: Maybe<Array<Scalars['String']['output']>>;
  thumbnail?: Maybe<Image>;
  /** Title of the article as defined in the CMS. */
  title: Scalars['String']['output'];
  userIntent?: Maybe<UserIntent>;
  /** Video file for this content */
  videoFile?: Maybe<Video>;
};

export type BestScores = {
  __typename: 'BestScores';
  cognitiveAccuracy?: Maybe<QuickStat>;
  commitmentStreak?: Maybe<QuickStat>;
  heartRate?: Maybe<QuickStat>;
  hrv?: Maybe<QuickStat>;
  processingSpeed?: Maybe<QuickStat>;
  reactionTime?: Maybe<QuickStat>;
  stressIndex?: Maybe<QuickStat>;
  vnsTime?: Maybe<QuickStat>;
};

/** The payer's current billing contact (the Stripe Customer's own name and address). */
export type BillingContact = {
  __typename: 'BillingContact';
  address?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum BillingPortalFlow {
  Cancel = 'cancel',
  ChangePlan = 'change_plan',
  UpdatePayment = 'update_payment'
}

export enum BillingPortalRefusal {
  BillingEnded = 'billing_ended',
  NoOwnBilling = 'no_own_billing',
  PortalUnavailable = 'portal_unavailable',
  ReturnUrlNotAllowed = 'return_url_not_allowed'
}

/** Exactly one of url / refusal is set. */
export type BillingPortalSessionResult = {
  __typename: 'BillingPortalSessionResult';
  refusal?: Maybe<BillingPortalRefusal>;
  /** Short-lived (Stripe: 5 minutes unused, then 1 hour after last use): ask again per tap. Never logged. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Records a biofeedback session with pre/post vital measurements */
export type BiofeedbackSession = {
  __typename: 'BiofeedbackSession';
  /** The activity performed during this session */
  activity?: Maybe<CustomActivityId | ExternalContentId | MobileWidgetId>;
  /** Unique identifier for this session */
  biofeedbackSessionId: Scalars['ID']['output'];
  /** When the session ended */
  endTime: Scalars['DateTime']['output'];
  /** Vital measurements taken after the activity */
  postVitals?: Maybe<Array<VitalMeasurement>>;
  /** Vital measurements taken before the activity */
  preVitals?: Maybe<Array<VitalMeasurement>>;
  /** When the session started */
  startTime: Scalars['DateTime']['output'];
  /** Time block when this session occurred */
  timeBlock: TimeBlock;
  /** User who recorded the session */
  userId: Scalars['String']['output'];
};

/** The three dimensions of biopsychosocial health */
export enum Biopsychosocial {
  /** Physical/biological health */
  Biological = 'biological',
  /** Mental/psychological health */
  Psychological = 'psychological',
  /** Social health and connections */
  Social = 'social'
}

export type BiopsychosocialScore = {
  __typename: 'BiopsychosocialScore';
  biopsychosocial: Biopsychosocial;
  relevance: Relevance;
};

export enum BlockStyle {
  Normal = 'normal'
}

export type BlurbBlock = {
  __typename: 'BlurbBlock';
  content?: Maybe<RichContent>;
};

/** Represents a body measurement like height or weight */
export type BodyMetric = BaseMetric & {
  __typename: 'BodyMetric';
  /** Unique identifier for the metric */
  id: Scalars['ID']['output'];
  /** When the measurement was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** Type of body measurement */
  type: BodyMetricType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** User who recorded the metric */
  userId: Scalars['String']['output'];
  /** Numeric value of the measurement */
  value: Scalars['Float']['output'];
};

/** Types of body measurements that can be recorded */
export enum BodyMetricType {
  /** Age in years */
  Age = 'age',
  /** Body Mass Index (kg/m²) */
  Bmi = 'bmi',
  /** Height in cm or inches */
  Height = 'height',
  /** Weight in kg or lb */
  Weight = 'weight'
}

export type BroadcastAllActiveParticipants = {
  __typename: 'BroadcastAllActiveParticipants';
  /** Marker type. Always returns true. Presence of this variant means 'all active participants'. */
  isAllActive: Scalars['Boolean']['output'];
};

export type BroadcastCohort = {
  __typename: 'BroadcastCohort';
  cohortId: Scalars['ID']['output'];
};

/** Paginated list of broadcasts. Cursor-based. */
export type BroadcastConnection = {
  __typename: 'BroadcastConnection';
  /** Opaque cursor for the next page (null when no more results). */
  nextCursor?: Maybe<Scalars['String']['output']>;
  nodes: Array<BroadcastEntry>;
  totalCount: Scalars['Int']['output'];
};

/** A single bulk-message broadcast initiated by a care-team member. */
export type BroadcastEntry = {
  __typename: 'BroadcastEntry';
  /** Message body the care-team member sent. */
  body: Scalars['String']['output'];
  broadcastId: Scalars['ID']['output'];
  /** Set when the broadcast transitions to a terminal state (completed/failed). Null otherwise. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Summary of who was excluded and why. */
  excludedSummary: ResolvedRecipientsSummary;
  /** Count of messages that failed to deliver (populated when status=completed/failed). */
  failedCount: Scalars['Int']['output'];
  /**
   * YOJO-1783: the recipient user IDs whose delivery genuinely failed, so the care team
   * can see exactly who did not receive the broadcast. Empty until completion (and empty
   * for a fully-successful broadcast).
   */
  failedUserIds: Array<Scalars['ID']['output']>;
  /** Free-text failure reason (populated when status=failed). */
  failureReason?: Maybe<Scalars['String']['output']>;
  /**
   * YOJO-1754: number of recipients who will see the fallback greeting ("Hi there, …")
   * because no usable first name is on file. Drives the review-modal warning line.
   * Zero for broadcasts that carry no per-recipient personalisation snapshot.
   */
  fallbackRecipientCount: Scalars['Int']['output'];
  /** GetStream campaign ID (set once Phase 3 fan-out is wired in YOJO-1728). */
  getstreamCampaignId?: Maybe<Scalars['String']['output']>;
  initiatedAt: Scalars['DateTime']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Final list of recipient user IDs after filters. */
  recipientUserIds: Array<Scalars['ID']['output']>;
  /** The audience-selection rule snapshot (as captured at initiation). */
  selection: BroadcastSelection;
  /**
   * Best-effort display name of the sender, looked up from PII at query time.
   * Null when no PII record is reachable; UI falls back to senderUserId.
   */
  senderDisplayName?: Maybe<Scalars['String']['output']>;
  senderUserId: Scalars['ID']['output'];
  /** Count of messages successfully delivered (populated when status=completed). */
  sentCount: Scalars['Int']['output'];
  /**
   * YOJO-3474 [a Free member's care chat pauses — broadcasts skip paused channels]: recipients
   * skipped at delivery because their care chat had paused since the broadcast was initiated
   * (original send + retries). Not sent to, and not failures (never in failedUserIds).
   * 0 for broadcasts recorded before this field existed.
   */
  skippedPaused: Scalars['Int']['output'];
  /** Set when the broadcast transitions to in_progress (Phase 3+ fan-out start). Null while pending. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: BroadcastStatus;
};

export type BroadcastHandPicked = {
  __typename: 'BroadcastHandPicked';
  userIds: Array<Scalars['ID']['output']>;
};

/**
 * The audience-selection rule the sender chose. GraphQL union form of the
 * domain `BroadcastSelection` sealed type.
 */
export type BroadcastSelection = BroadcastAllActiveParticipants | BroadcastCohort | BroadcastHandPicked;

/**
 * Sum-type input mirroring the domain `BroadcastSelection`. GraphQL doesn't
 * have native union inputs, so this is a flat shape with optional fields.
 * Exactly one of allActive, cohortId or handPickedUserIds must be set.
 */
export type BroadcastSelectionInput = {
  /** Set true to broadcast to every active participant. */
  allActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Broadcast to the named cohort. */
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  /** Broadcast to exactly this list of user IDs. */
  handPickedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Lifecycle states for a broadcast. Terminal states (completed, failed) are
 * immutable.
 */
export enum BroadcastStatus {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  Pending = 'pending'
}

export type BulkAssignUsersToLearningJourneyCommand = {
  learningJourneyId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type BulkAssignmentAllActiveParticipants = {
  __typename: 'BulkAssignmentAllActiveParticipants';
  /** Marker. Always true. Presence of this variant means 'all active participants'. */
  isAllActive: Scalars['Boolean']['output'];
};

export type BulkAssignmentCohort = {
  __typename: 'BulkAssignmentCohort';
  cohortId: Scalars['ID']['output'];
};

/** Paginated list of bulk assignments. Cursor-based. */
export type BulkAssignmentConnection = {
  __typename: 'BulkAssignmentConnection';
  /** Opaque cursor for the next page (null when no more results). */
  nextCursor?: Maybe<Scalars['String']['output']>;
  nodes: Array<BulkAssignmentEntry>;
  totalCount: Scalars['Int']['output'];
};

/**
 * Approve-time consent / safety re-filter delta (YOJO-1816). The fan-out re-runs
 * the shared RecipientSafetyFilter against LIVE participant / preferences state at
 * approve time; this records exactly what changed since the cohort was frozen at
 * prepare time.
 */
export type BulkAssignmentConsentDelta = {
  __typename: 'BulkAssignmentConsentDelta';
  /** Recipients removed by the approve-time re-filter, each tagged with the single reason that removed it. */
  droppedSincePrepare: Array<BulkAssignmentDroppedRecipient>;
  /** Size of the frozen prepared cohort. */
  preparedCount: Scalars['Int']['output'];
  /** Size of the kept (sent) set = preparedCount - droppedSincePrepare. */
  willSendCount: Scalars['Int']['output'];
};

/**
 * Why a candidate was dropped by the approve-time RecipientSafetyFilter re-filter.
 * Precedence (first match wins): TEST_USER → SUSPENDED → OPTED_OUT.
 */
export enum BulkAssignmentDropReason {
  OptedOut = 'OPTED_OUT',
  Suspended = 'SUSPENDED',
  TestUser = 'TEST_USER'
}

/** A single recipient dropped by the approve-time re-filter, tagged with the reason. */
export type BulkAssignmentDroppedRecipient = {
  __typename: 'BulkAssignmentDroppedRecipient';
  reason: BulkAssignmentDropReason;
  userId: Scalars['ID']['output'];
};

/** A single bulk content assignment initiated by a care-team member. */
export type BulkAssignmentEntry = {
  __typename: 'BulkAssignmentEntry';
  /** When the assignment was approved. Null until approved. */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who approved this assignment. Null until approved. */
  approvedBy?: Maybe<Scalars['ID']['output']>;
  /** How the assignment was approved (care_portal). Null until approved. */
  approvedVia?: Maybe<ApprovedVia>;
  bulkAssignmentId: Scalars['ID']['output'];
  /** Set when the aggregate transitions to a terminal state. Null otherwise. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Approve-time consent / safety re-filter delta (YOJO-1816). Records who
   * dropped out between prepare and approve (suspended, opted-out, test). Null on
   * the legacy Initiate path and on any pre-Phase-3 completed assignment.
   */
  consentDelta?: Maybe<BulkAssignmentConsentDelta>;
  /** Summary of who was excluded and the duplicate-warning count. */
  excludedSummary: BulkAssignmentExcludedSummary;
  /** Free-text failure reason (populated when status=failed). */
  failureReason?: Maybe<Scalars['String']['output']>;
  initiatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** The single-content payload the care-team member confirmed. */
  payload: SingleContentPayload;
  /** Per-recipient outcomes (populated when status=completed). */
  perRecipientOutcomes: Array<BulkAssignmentRecipientOutcomeEntry>;
  /** When the assignment was prepared. Null on the legacy Initiate path. */
  preparedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who prepared this assignment. Null on the legacy Initiate path. */
  preparedBy?: Maybe<Scalars['ID']['output']>;
  /** How the assignment was prepared (mcp | composer). Null on the legacy Initiate path. */
  preparedVia?: Maybe<PreparedVia>;
  /** Final list of recipient user IDs after filters. */
  recipientUserIds: Array<Scalars['ID']['output']>;
  /** When the assignment was rejected. Null unless rejected. */
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who rejected this assignment. Null unless rejected. */
  rejectedBy?: Maybe<Scalars['ID']['output']>;
  /** Free-text rejection reason. Null unless rejected. */
  rejectedReason?: Maybe<Scalars['String']['output']>;
  /** Audience-selection rule snapshot (as captured at initiation). */
  selection: BulkAssignmentSelection;
  /**
   * Best-effort display name of the sender, resolved from PII at query time.
   * Null when no PII record is reachable; UI falls back to senderUserId.
   */
  senderDisplayName?: Maybe<Scalars['String']['output']>;
  senderUserId: Scalars['ID']['output'];
  /** Set when the aggregate transitions to in_progress. Null while pending. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Roll-up of per-recipient outcomes (populated when status=completed). */
  stats?: Maybe<BulkAssignmentStats>;
  status: BulkAssignmentStatus;
};

/**
 * Counts of excluded recipients, broken out by exclusion rule. The
 * alreadyPlanned count is a WARNING — those users are still in
 * recipientUserIds (re-assignment is intentional per locked decision #17).
 */
export type BulkAssignmentExcludedSummary = {
  __typename: 'BulkAssignmentExcludedSummary';
  alreadyPlanned: Scalars['Int']['output'];
  excludedOptOut: Scalars['Int']['output'];
  /** Members left out because the planned Stone mode is refused for them (YOJO-3301). */
  excludedPlannedMode: Scalars['Int']['output'];
  /** Users excluded because their account is suspended (YOJO-1814). Surfaced on the prepared/approved lifecycle. */
  excludedSuspended: Scalars['Int']['output'];
  excludedTestUsers: Scalars['Int']['output'];
  /** Who was left out for the planned Stone mode, and why — at most 100; the true total is excludedPlannedMode. */
  plannedModeExclusions: Array<BulkAssignmentPlannedModeExclusion>;
  /** How many members were left out for the planned Stone mode, per reason (the true totals). */
  plannedModeReasonCounts: Array<BulkAssignmentPlannedModeReasonCount>;
};

export type BulkAssignmentHandPicked = {
  __typename: 'BulkAssignmentHandPicked';
  userIds: Array<Scalars['ID']['output']>;
};

export type BulkAssignmentOutcomeAssigned = {
  __typename: 'BulkAssignmentOutcomeAssigned';
  /** Marker. Always true. Presence of this variant means the per-user dispatch succeeded. */
  success: Scalars['Boolean']['output'];
};

export type BulkAssignmentOutcomeCommandRejected = {
  __typename: 'BulkAssignmentOutcomeCommandRejected';
  reason: Scalars['String']['output'];
};

export type BulkAssignmentOutcomeDispatchFailed = {
  __typename: 'BulkAssignmentOutcomeDispatchFailed';
  reason: Scalars['String']['output'];
};

/** One member left out of a bulk assignment because the planned Stone mode is refused for them (YOJO-3301). */
export type BulkAssignmentPlannedModeExclusion = {
  __typename: 'BulkAssignmentPlannedModeExclusion';
  reason: PlannedModeRefusalReason;
  userId: Scalars['ID']['output'];
};

/** How many members a planned Stone mode was refused for, for one reason (YOJO-3301). */
export type BulkAssignmentPlannedModeReasonCount = {
  __typename: 'BulkAssignmentPlannedModeReasonCount';
  count: Scalars['Int']['output'];
  reason: PlannedModeRefusalReason;
};

export type BulkAssignmentRecipientOutcome = BulkAssignmentOutcomeAssigned | BulkAssignmentOutcomeCommandRejected | BulkAssignmentOutcomeDispatchFailed;

/**
 * Per-recipient outcome on a completed bulk assignment. Exposed as a list
 * (rather than a Map) so GraphQL can render it ergonomically; downstream
 * consumers can index by userId.
 */
export type BulkAssignmentRecipientOutcomeEntry = {
  __typename: 'BulkAssignmentRecipientOutcomeEntry';
  outcome: BulkAssignmentRecipientOutcome;
  userId: Scalars['ID']['output'];
};

/**
 * Output of resolveBulkAssignmentRecipients: filter pipeline preview for the
 * Review modal.
 */
export type BulkAssignmentResolvedRecipients = {
  __typename: 'BulkAssignmentResolvedRecipients';
  /** Users in userIds who already have this content planned active (warning, not exclusion). */
  alreadyPlannedUserIds: Array<Scalars['ID']['output']>;
  excludedOptOut: Scalars['Int']['output'];
  excludedTestUsers: Scalars['Int']['output'];
  /** Human-readable description of the selection rule (e.g. 'cohort:at_risk_users'). */
  sourceRule: Scalars['String']['output'];
  /** Final recipient user IDs after all filters applied. */
  userIds: Array<Scalars['ID']['output']>;
};

/**
 * The audience-selection rule the operator chose. GraphQL union form of the
 * domain BulkAssignmentSelection sealed type.
 */
export type BulkAssignmentSelection = BulkAssignmentAllActiveParticipants | BulkAssignmentCohort | BulkAssignmentHandPicked;

/**
 * Sum-type input mirroring the domain BulkAssignmentSelection. GraphQL doesn't
 * have native union inputs, so this is a flat shape with optional fields.
 * Exactly one of allActive, cohortId or handPickedUserIds must be set.
 */
export type BulkAssignmentSelectionInput = {
  /** Set true to fan out to every active participant. */
  allActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fan out to the named cohort. */
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  /** Fan out to exactly this list of user IDs. */
  handPickedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Roll-up counts on a completed bulk assignment. */
export type BulkAssignmentStats = {
  __typename: 'BulkAssignmentStats';
  /** Recipients whose per-user PlanActivityCommand dispatched cleanly (or was an idempotent no-op). */
  assigned: Scalars['Int']['output'];
  /** Recipients whose outcome was command_rejected or dispatch_failed. */
  failed: Scalars['Int']['output'];
};

/**
 * Lifecycle states for a bulk assignment. Terminal states (completed, failed,
 * rejected) are immutable.
 */
export enum BulkAssignmentStatus {
  Approved = 'approved',
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  Pending = 'pending',
  Prepared = 'prepared',
  Rejected = 'rejected'
}

export type BulkUnassignUsersFromLearningJourneyCommand = {
  learningJourneyId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type BulletListBlock = {
  __typename: 'BulletListBlock';
  items: Array<Scalars['String']['output']>;
};

/**
 * Member Subscription Management (YOJO-2361 — care-portal subscription cancel)
 * Care-portal admin/support actions that ONLY call Stripe. The existing Stripe webhook cascade
 * (customer.subscription.updated / deleted) owns ALL of our own entitlement/membership state.
 * Gated to admin + operations ("Support"); nurse (care team) and other roles are denied.
 *
 * The target subscription is passed EXPLICITLY (customerId + subscriptionId). The backend verifies the
 * subscriptionId belongs to that customer and is eligible (entitlement not revoked AND billing status in
 * active/trialing/past_due), so a multi-entitlement member's operator acts on exactly the subscription
 * they selected — not a server re-derived "the" subscription.
 */
export type CancelMemberSubscriptionInput = {
  /** CRM customer (member) that owns the subscription. */
  customerId: Scalars['ID']['input'];
  /** false (default) => cancel_at_period_end=true (keep access until period end); true => cancel now. */
  immediate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional note; logged AND stamped on Stripe cancellation_details.comment (no lifecycle write). */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The EXPLICIT Stripe subscription to cancel; verified to belong to customerId and be eligible. */
  subscriptionId: Scalars['ID']['input'];
};

export type CancelServiceCaseInput = {
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  performedBy: Scalars['String']['input'];
  serviceCaseId: Scalars['ID']['input'];
};

/**
 * A named, gateable feature (YOJO-2446 [capability tiering], domain-model.md §4.1).
 *
 * CLIENT GUARDRAIL: consume this enum as a MEMBERSHIP TEST (`capabilities.contains(x)`). Never map it
 * through a hand-rolled, throwing string→enum conversion — a capability added server-side must degrade
 * an old client gracefully, never crash it.
 */
export enum Capability {
  /** Coach access (messaging + video notes), no consults. */
  CoachAccess = 'coach_access',
  /** Full coach access including consults. */
  CoachConsults = 'coach_consults',
  /** The daily reflection — floor. */
  ContentDailyReflection = 'content_daily_reflection',
  /** Scheduled learning journeys. */
  ContentJourneysScheduled = 'content_journeys_scheduled',
  /** Personal journals. */
  ContentPersonalJournals = 'content_personal_journals',
  /** Full data history (beyond the floor's rolling window). */
  DataHistoryFull = 'data_history_full',
  /** Custom data reports — any window the member asks for, which is why it also covers annual ones. */
  DataReportCustom = 'data_report_custom',
  /** Periodic health reports on a quarterly cadence — produced FOR the member, not asked for. */
  DataReportQuarterly = 'data_report_quarterly',
  /** The 30-second face scan — floor. */
  FaceScanBasic = 'face_scan_basic',
  /** Face scan surfaces blood pressure (beta) — systolic and diastolic. */
  FaceScanMetricBloodPressure = 'face_scan_metric_blood_pressure',
  /** Face scan surfaces respiratory rate. */
  FaceScanMetricBreathingRate = 'face_scan_metric_breathing_rate',
  /** Face scan surfaces cardiac workload (HR × SBP). */
  FaceScanMetricCardiacWorkload = 'face_scan_metric_cardiac_workload',
  /** Face scan surfaces heart rate. */
  FaceScanMetricHeartRate = 'face_scan_metric_heart_rate',
  /** Face scan surfaces heart-rate variability (SDNN + lnRMSSD). Usable at 30s, validated at 60s. */
  FaceScanMetricHrv = 'face_scan_metric_hrv',
  /**
   * Face scan surfaces parasympathetic activity. Needs a 60-second scan: it is a frequency-domain
   * ratio that cannot resolve in a shorter window — physics, not pricing.
   */
  FaceScanMetricParasympatheticActivity = 'face_scan_metric_parasympathetic_activity',
  /** Face scan surfaces the Baevsky stress index. */
  FaceScanMetricStressIndex = 'face_scan_metric_stress_index',
  /** The 60-second supercharged face scan. */
  FaceScanSupercharged = 'face_scan_supercharged',
  /** Face scan enriched with wearable integration. */
  FaceScanWearableIntegration = 'face_scan_wearable_integration',
  /** Balance stimulation mode — the never-dark floor mode. Device-bound (Alpha and Stone). */
  StimulationModeBalance = 'stimulation_mode_balance',
  /** Personalised mode configuration. Device-bound (Stone only). */
  StimulationModePersonalised = 'stimulation_mode_personalised',
  /** All six stimulation modes. Device-bound (Stone-capable). */
  StimulationModesAll = 'stimulation_modes_all'
}

/**
 * ONE capability, described (YOJO-2566 [Q15 metric-config], domain-model.md Q15.8) — vocabulary plus the
 * hardware and SDK truths that constrain it. Static per deploy, computed rather than stored.
 */
export type CapabilityDescriptor = {
  __typename: 'CapabilityDescriptor';
  capability: Capability;
  /** True when the member's registered hardware must be able to execute it (resolver intersects). */
  deviceBound: Scalars['Boolean']['output'];
  /** For a scan-duration capability: the scan length it grants, in seconds. Null otherwise. */
  grantsScanSeconds?: Maybe<Scalars['Int']['output']>;
  group: CapabilityGroup;
  /**
   * HARD constraint. Below this scan length the metric is not a weaker reading, it is meaningless —
   * a package granting less may not list it, and a member resolving less does not receive it.
   * Code-owned SDK truth, never admin-editable (ADR-0005:20). Null for non-scan capabilities.
   */
  minDerivableScanSeconds?: Maybe<Scalars['Int']['output']>;
  /**
   * SOFT constraint. Below this the value is real but outside the vendor's validated envelope —
   * surfaced as a caveat on the reading, never a reason to refuse configuration. Readings taken at
   * different scan lengths are NOT comparable and must not share a trend line.
   */
  validatedAtScanSeconds?: Maybe<Scalars['Int']['output']>;
};

/** How a capability groups in the admin checklist. Presentational only — nothing branches on it. */
export enum CapabilityGroup {
  Content = 'content',
  Data = 'data',
  FaceScan = 'face_scan',
  FaceScanMetric = 'face_scan_metric',
  Human = 'human',
  Sessions = 'sessions',
  Stimulation = 'stimulation'
}

/** What removing ONE capability would cost. */
export type CapabilityImpact = {
  __typename: 'CapabilityImpact';
  /** Holders in scope whose effective capabilities would genuinely shrink. */
  affectedHolderCount: Scalars['Int']['output'];
  capability: Capability;
  /**
   * Holders in scope who keep it anyway — from the floor, a second package, or an individual grant.
   * affected + retained need not equal holdersInScope: a member whose hardware cannot execute a
   * device-bound capability never had it, so they are in neither column.
   */
  retainedHolderCount: Scalars['Int']['output'];
  /** A bounded sample of the affected members, so the admin can spot-check who — not an export. */
  sampleSubjectIds: Array<Scalars['ID']['output']>;
};

/**
 * WHERE one of a member's effective capabilities came from (YOJO-2598 [custom capability grants]) — the
 * provenance vocabulary behind `MemberCapabilities.provenance`.
 *
 * This names the SHAPE of the source, not the door it came through: read `grantSource` alongside for
 * that. There are exactly three shapes because there are exactly three ways a capability can enter the
 * effective set.
 */
export enum CapabilityOrigin {
  /**
   * A live INLINE grant — a frozen capability set held directly by the member. Read `grantSource` to
   * tell the kinds apart: `custom` is a per-member set an ops user composed (always with a reason),
   * `comp` is the older capability comp, `grandfather` is a set preserved by a shrink or the D7
   * migration. All three are revoked one row at a time.
   */
  CustomGrant = 'custom_grant',
  /**
   * The FREE floor — resolved from the configured floor package, never granted. It has no grantId and
   * no reason, which is exactly why nothing can revoke it.
   */
  Floor = 'floor',
  /** A live PACKAGE grant. Carries packageKey and packageName — it follows admin edits to that tier. */
  PackageGrant = 'package_grant'
}

/**
 * A tier bundle (Free / Activate / Elevate) — authored by an admin in the care-portal, stored purely as
 * events. Contents are explicit and flat: there is no resolve-time inheritance between tiers.
 */
export type CapabilityPackage = {
  __typename: 'CapabilityPackage';
  /** An archived package keeps its history but contributes no capabilities to anyone. */
  archived: Scalars['Boolean']['output'];
  /** The package's CURRENT contents. */
  capabilities: Array<Capability>;
  /** Fingerprint of the current contents — the idempotency key for edits. */
  contentHash: Scalars['String']['output'];
  definedAt: Scalars['DateTime']['output'];
  definedBy: Scalars['ID']['output'];
  /**
   * The package's numeric dials (YOJO-2559 [scans/day package dial]). EMPTY for a package nobody has
   * dialled — never zero: an undialled package inherits the floor's number for its holders. A package
   * that means "no limit for my holders" carries the dial with the value `-1`.
   */
  dials: Array<CapabilityPackageDial>;
  displayName: Scalars['String']['output'];
  /** Whether the member's own personalised mode is open on this plan. */
  includesPersonalised: Scalars['Boolean']['output'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['ID']['output']>;
  /**
   * The Stone modes this plan names, by mode id, sorted by id. Null = not set: the plan's
   * stimulation capabilities are mapped to modes by data until that mapping is retired. An empty list
   * names no modes. The default mode is open on every Stone whatever this says.
   */
  modeIds?: Maybe<Array<Scalars['ID']['output']>>;
  packageId: Scalars['ID']['output'];
  /** The stable business key — also the seed the package's id is derived from. */
  packageKey: Scalars['ID']['output'];
  /** Provider price references, one per billing cadence. */
  priceRefs: Array<CapabilityPriceRef>;
  /**
   * The key of the plan this one sits directly above. Null only on the floor (or on a package not yet
   * placed). Order only: contents and capability resolution are unaffected.
   */
  sitsAbove?: Maybe<Scalars['ID']['output']>;
};

/**
 * One `dial → value` pair. A list of typed pairs rather than a map, because GraphQL has no untyped map.
 * A pair that is absent from the list is not zero — see `PackageDial`.
 */
export type CapabilityPackageDial = {
  __typename: 'CapabilityPackageDial';
  dial: PackageDial;
  /**
   * The limit per period. 0 is legal and means 'none of these, ever'. `-1` is UNLIMITED — the single
   * canonical encoding; there is no nullable-means-unlimited spelling, because absence already means
   * something else (inherit the floor).
   */
  value: Scalars['Int']['output'];
};

/**
 * One provider price reference on a package. yojo stores a REFERENCE, never an amount — money lives in
 * the payment provider.
 */
export type CapabilityPriceRef = {
  __typename: 'CapabilityPriceRef';
  /** The billing cadence this reference is for, e.g. monthly / annual. */
  cadence: Scalars['String']['output'];
  /** The provider's price identifier, e.g. a Stripe price id. */
  priceRef: Scalars['String']['output'];
};

/** One cadence → provider price reference pair. Sent as a list because GraphQL has no untyped map. */
export type CapabilityPriceRefInput = {
  cadence: Scalars['String']['input'];
  priceRef: Scalars['String']['input'];
};

/**
 * One EFFECTIVE capability and every live reason the member has it (YOJO-2598 [custom capability
 * grants]).
 *
 * Ordered by the `Capability` declaration order, the same order `effectiveCapabilities` uses, so the two
 * lists render as one story rather than two.
 */
export type CapabilityProvenance = {
  __typename: 'CapabilityProvenance';
  capability: Capability;
  /** Every live source, floor first, then grants newest first. Never empty. */
  sources: Array<CapabilityProvenanceSource>;
};

/**
 * ONE reason a member currently has ONE capability (YOJO-2598 [custom capability grants]).
 *
 * Read `origin` for the shape (floor / package / inline grant) and `grantSource` for the door it came
 * through. `grantId` is what a revoke names — null for the floor, which is precisely why the floor cannot
 * be revoked.
 */
export type CapabilityProvenanceSource = {
  __typename: 'CapabilityProvenanceSource';
  /** When this source stops giving it. Null means the floor, or a grant that lasts until revoked. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The ledger row this source is. Null ONLY for the floor. For a `custom` grant this is exactly what
   * `revokeCustomCapabilityGrant` takes.
   */
  grantId?: Maybe<Scalars['ID']['output']>;
  /** The door the grant came through. Null for the floor — nobody granted it. */
  grantSource?: Maybe<GrantSource>;
  /** The ops identity that granted it. Null on the floor and on every background grant. */
  grantedBy?: Maybe<Scalars['ID']['output']>;
  origin: CapabilityOrigin;
  /** The package behind it. Set for `floor` and `package_grant`; null for an inline grant. */
  packageKey?: Maybe<Scalars['ID']['output']>;
  /** That package's display name, so the screen says 'Elevate' rather than 'elevate'. */
  packageName?: Maybe<Scalars['String']['output']>;
  /** The ops sentence behind a human grant. Null on the floor and on every background grant. */
  reason?: Maybe<Scalars['String']['output']>;
};

/**
 * The cross-package dials (ADR-0003 / ADR-0007) — policy the admin owns, not environment variables.
 * Absent entirely until an admin bootstraps the system.
 */
export type CapabilitySettings = {
  __typename: 'CapabilitySettings';
  /** The product a purchase entitlement is assumed to be for while the CRM records no product ref. */
  defaultPurchaseProduct?: Maybe<Scalars['String']['output']>;
  /**
   * The per-gate allowlist (B-49): the gate call-sites individually switched on. A gate is live for a
   * member iff its key is here AND (`enforcementActive` OR the member is a Stone Access tester). Empty
   * until an admin adds one — every environment starts with nothing enforced; empty = every gate off for
   * everyone, testers included. The master switch never touches this list.
   */
  enforcedGates: Array<GateKey>;
  /**
   * Whether capability enforcement is switched on here for everyone. False means the listed gates stay
   * live for Stone Access testers only (YOJO-3332) and everyone else keeps legacy behaviour — the
   * reversibility lever, held separately from the dials so that switching enforcement off never means
   * destroying the configuration. The FULL off (nobody gated) is an empty `enforcedGates`.
   */
  enforcementActive: Scalars['Boolean']['output'];
  /** The package every member resolves for free (ADR-0001). Resolved, never granted. */
  floorPackageKey: Scalars['ID']['output'];
  settingsId: Scalars['ID']['output'];
  /** Extra days on top of the trial, so a late first charge cannot blink a member down to the floor. */
  trialGraceDays: Scalars['Int']['output'];
  /** Months of trial granted on device activation. */
  trialMonths: Scalars['Int']['output'];
  /** The package the device trial grants. */
  trialPackageKey?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['ID']['output'];
};

/**
 * A member's care chat. When paused the member keeps their history and keeps receiving the care team's messages, but
 * cannot post. The reason never names the member's plan.
 */
export type CareChat = {
  __typename: 'CareChat';
  /** True when the member cannot post in their care chat. */
  paused: Scalars['Boolean']['output'];
  /** Why the chat is paused. Null when it is open. */
  pausedReason?: Maybe<CareChatPausedReason>;
};

export enum CareChatPausedReason {
  /** The member's plan does not include the care team chat. */
  NeedsPlan = 'needs_plan'
}

/** One health area the care team recorded for a member: which area, who recorded it, and when (YOJO-3288). */
export type CareTeamReading = {
  __typename: 'CareTeamReading';
  /** The health area */
  healthArea: NeedsDomain;
  /** When it was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** Who recorded it: the member themself (reserved; not written today), a coach, or Claude */
  source: NeedsSource;
};

export type Carrier = {
  __typename: 'Carrier';
  active: Scalars['Boolean']['output'];
  carrierId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  trackingUrlTemplate?: Maybe<Scalars['String']['output']>;
};

/** C1 cause call-out: sessions climbed from → to per month, ~multiplier× more. */
export type CauseCallout = {
  __typename: 'CauseCallout';
  fromSessions: Scalars['Int']['output'];
  multiplier: Scalars['Float']['output'];
  toSessions: Scalars['Int']['output'];
};

/** The shaded 'since you got consistent' era band shared by C1 and C2. */
export type ChangePointBand = {
  __typename: 'ChangePointBand';
  detected: Scalars['Boolean']['output'];
  fromIndex: Scalars['Int']['output'];
  fromMonth?: Maybe<Scalars['String']['output']>;
};

/** C1 change-point hero — adherence ramp paired with the headline result metric (cause+effect). */
export type ChangePointHeroPayload = {
  __typename: 'ChangePointHeroPayload';
  band: ChangePointBand;
  cause: CauseCallout;
  effect: EffectCallout;
  headline: Scalars['String']['output'];
  resultMetric: Scalars['String']['output'];
  resultSeries: Array<MonthlyPoint>;
  resultUnit: Scalars['String']['output'];
  sessionsPerMonth: Array<MonthlyPoint>;
};

export type ChatChannel = {
  __typename: 'ChatChannel';
  /** The channel ID to use with GetStream */
  channelId: Scalars['String']['output'];
  /**
   * Whether the member of this care-team channel is paused. When true the member keeps their history and
   * keeps receiving the care team's messages, but cannot post.
   */
  paused: Scalars['Boolean']['output'];
};

export type ChatInbox = {
  __typename: 'ChatInbox';
  items: Array<ChatInboxItem>;
  totalCount: Scalars['Int']['output'];
};

export type ChatInboxInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatInboxItem = {
  __typename: 'ChatInboxItem';
  channelId: Scalars['String']['output'];
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessagePreview?: Maybe<Scalars['String']['output']>;
  participantId: Scalars['String']['output'];
  pii?: Maybe<Pii>;
  status: ChatInboxStatus;
  unreadCount: Scalars['Int']['output'];
};

export enum ChatInboxStatus {
  NeedsResponse = 'needs_response',
  Responded = 'responded',
  Unread = 'unread'
}

export type ChatLog = {
  __typename: 'ChatLog';
  /** ID of the channel where the message was sent */
  channelId: Scalars['String']['output'];
  /** Unique identifier for this chat message */
  id: Scalars['ID']['output'];
  /** The personal identifiable information of the user that sent the message */
  pii?: Maybe<Pii>;
  /** When the message was received */
  receivedAt: Scalars['DateTime']['output'];
  /** ID of the user who sent the message */
  userId: Scalars['String']['output'];
};

/** Rolling chat responsiveness metrics over 90-day windows. */
export type ChatResponsiveness = {
  __typename: 'ChatResponsiveness';
  /** Number of care team messages sent in the current window */
  currentOutbound: Scalars['Int']['output'];
  /** Response rate in the current 90-day window (0.0 - 1.0) */
  currentRate: Scalars['Float']['output'];
  /** Number of care team messages the participant replied to in the current window */
  currentResponded: Scalars['Int']['output'];
  /** Number of care team messages sent in the previous window */
  previousOutbound: Scalars['Int']['output'];
  /** Response rate in the previous 90-day window (0.0 - 1.0) */
  previousRate: Scalars['Float']['output'];
  /** Number of care team messages the participant replied to in the previous window */
  previousResponded: Scalars['Int']['output'];
  /** Trend: improving, declining, stable, or new */
  trend: Scalars['String']['output'];
};

/** AI-generated insight from a check-in session */
export type CheckinInsight = {
  __typename: 'CheckinInsight';
  /** Category of the insight */
  category: InsightCategory;
  /** When this insight was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this insight */
  id: Scalars['ID']['output'];
  /** Personalized message with specific recommendation */
  message: Scalars['String']['output'];
  /** Priority level of the insight */
  priority: InsightPriority;
  /** Specific action to take */
  recommendation: Scalars['String']['output'];
  /** Recommended content IDs that might help the user */
  recommendedContent?: Maybe<Array<CustomActivityId | ExternalContentId | MobileWidgetId>>;
  /** Short, engaging title */
  title: Scalars['String']['output'];
};

/** Records a checkin session with vital and feeling measurements */
export type CheckinSession = {
  __typename: 'CheckinSession';
  /** Unique identifier for this session */
  checkinSessionId: Scalars['ID']['output'];
  /** Cognitive measurements taken during the session */
  cognitiveMeasurements?: Maybe<Array<CognitiveMeasurement>>;
  /** When the session ended */
  endTime: Scalars['DateTime']['output'];
  /** Feeling measurements taken during the session */
  feelingMeasurements?: Maybe<Array<FeelingMeasurement>>;
  /**
   * AI-generated insights based on this check-in and historic data
   * @deprecated Generation intentionally disabled (YOJO-2590) — always answers []. Check-in insights come from the checkinInsight engine surface instead.
   */
  insights?: Maybe<Array<CheckinInsight>>;
  /** When the session started */
  startTime: Scalars['DateTime']['output'];
  /** User who recorded the session */
  userId: Scalars['String']['output'];
  /** Vital measurements taken during the session */
  vitalMeasurements?: Maybe<Array<VitalMeasurement>>;
};

/**
 * Classification for user categorization.
 * Determines how a user is treated in analytics and engagement segments.
 */
export enum Classification {
  /** User marked as lost/churned - excluded from active segments */
  Churned = 'churned',
  /** Normal user - included in all analytics */
  Regular = 'regular',
  /** Test or internal account - excluded from production analytics */
  TestAccount = 'test_account',
  /** High-touch user requiring special attention */
  Vip = 'vip'
}

/** Input for classifying a user. */
export type ClassifyUserInput = {
  /** Optional reason for the classification change */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The new classification */
  status: Classification;
  /** The user ID to classify */
  userId: Scalars['ID']['input'];
};

export enum Cms {
  MobileNative = 'mobile_native',
  Sanity = 'sanity'
}

export type CmsDocument = {
  /** Content reference for the document */
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  /** Unique identifier for the document */
  id: Scalars['ID']['output'];
  /** Title of the document */
  title: Scalars['String']['output'];
};

/** Per-participant coach engagement data for analytics export. */
export type CoachEngagementEntry = {
  __typename: 'CoachEngagementEntry';
  /** Number of consults with outcome=attended */
  attendedConsults: Scalars['Int']['output'];
  /** Rolling 90-day chat responsiveness details */
  chatResponsiveness?: Maybe<ChatResponsiveness>;
  /** Whether the participant is in the coach_engaged cohort */
  coachEngaged: Scalars['Boolean']['output'];
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Date of first consult (ISO date string) */
  firstConsultDate?: Maybe<Scalars['String']['output']>;
  /** Date of most recent consult (ISO date string) */
  lastConsultDate?: Maybe<Scalars['String']['output']>;
  /** Segment IDs this participant belongs to */
  segments: Array<Scalars['String']['output']>;
  /** Total number of consults (all outcomes) */
  totalConsults: Scalars['Int']['output'];
  /** User ID */
  userId: Scalars['ID']['output'];
  /** Display name (first + last) */
  userName?: Maybe<Scalars['String']['output']>;
};

/** Input for the coachEngagementExport query controlling GDPR anonymization. */
export type CoachEngagementExportInput = {
  /** When true (default), userIds are hashed and userName/email are nulled. */
  anonymize?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required (>=10 chars) when anonymize=false unless a recent justification TTL is active for the actor. */
  gdprJustification?: InputMaybe<Scalars['String']['input']>;
};

/** A single cognitive measurement taken during a checkin session */
export type CognitiveMeasurement = {
  __typename: 'CognitiveMeasurement';
  /** Test attempts if any */
  attempts?: Maybe<Array<CognitiveTestAttempt>>;
  /** When the measurement was taken */
  recordedAt: Scalars['DateTime']['output'];
  /** Source of the measurement */
  source: MetricSource;
  /** Type of cognitive metric being measured */
  type: CognitiveMetricType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** The measured value */
  value: Scalars['Float']['output'];
};

/** Input for recording a cognitive measurement */
export type CognitiveMeasurementInput = {
  /** Test attempts if any */
  attempts: Array<CognitiveTestAttemptInput>;
  /** When the measurement was taken */
  recordedAt: Scalars['DateTime']['input'];
  /** Source of the measurement */
  source: MetricSource;
  /** Type of cognitive metric being measured */
  type: CognitiveMetricType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** The measured value */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents a cognitive test metric measurement */
export type CognitiveMetric = BaseMetric & {
  __typename: 'CognitiveMetric';
  /** Individual test attempts */
  attempts?: Maybe<Array<CognitiveTestAttempt>>;
  /** Unique identifier for the metric */
  id: Scalars['ID']['output'];
  /** When the measurement was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** Type of cognitive measurement */
  type: CognitiveMetricType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** User who recorded the metric */
  userId: Scalars['String']['output'];
  /** Numeric value of the measurement */
  value: Scalars['Float']['output'];
};

/** Types of cognitive tests available in the system */
export enum CognitiveMetricType {
  DsstAccuracy = 'dsst_accuracy',
  DsstCompletionTime = 'dsst_completion_time',
  PvtReactionTime = 'pvt_reaction_time',
  StroopAccuracy = 'stroop_accuracy',
  StroopReactionTime = 'stroop_reaction_time'
}

/** Individual attempt data for cognitive tests */
export type CognitiveTestAttempt = {
  __typename: 'CognitiveTestAttempt';
  /** Whether this attempt was valid */
  isValid: Scalars['Boolean']['output'];
  /** When this attempt was made */
  timestamp: Scalars['DateTime']['output'];
  /** Type of cognitive test this attempt belongs to */
  type: CognitiveMetricType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** Measured value (reaction time, accuracy, or completion time) */
  value: Scalars['Float']['output'];
};

/** Input for a single cognitive test attempt */
export type CognitiveTestAttemptInput = {
  /** Whether this attempt was valid */
  isValid: Scalars['Boolean']['input'];
  /** When this attempt was made */
  timestamp: Scalars['DateTime']['input'];
  /** Type of cognitive test this attempt belongs to */
  type: CognitiveMetricType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** Measured value (reaction time, accuracy, or completion time) */
  value: Scalars['Float']['input'];
};

/** A composable cohort with AND/OR logic (Amplitude-style). */
export type Cohort = {
  __typename: 'Cohort';
  /** Description of what this cohort represents */
  description: Scalars['String']['output'];
  /** Unique cohort identifier (e.g., 'power_users', 'onboarding_stuck') */
  id: Scalars['ID']['output'];
  /** Number of users currently in this cohort */
  memberCount: Scalars['Int']['output'];
  /** Human-readable cohort name */
  name: Scalars['String']['output'];
};

/** Cohort progression analysis for a specific health metric */
export type CohortAnalysis = {
  __typename: 'CohortAnalysis';
  /** Area Under Curve summary for this cohort's percentage change trend */
  auc?: Maybe<CohortAuc>;
  /**
   * Average baseline value (Day 0) across all users
   * This is the averaged measurement at each user's start date
   */
  baselineValue?: Maybe<Scalars['Float']['output']>;
  /** Time series data points showing progression from Day 0 to Day N */
  dataPoints: Array<CohortAnalysisDataPoint>;
  /** Name of the metric being analyzed */
  metric: Scalars['String']['output'];
  /** Unit of measurement */
  unit: Scalars['String']['output'];
};

/** Cohort progression analysis segmented by age bracket */
export type CohortAnalysisByAgeBracket = {
  __typename: 'CohortAnalysisByAgeBracket';
  /** Cohort data for each age bracket */
  brackets: Array<AgeBracketCohort>;
  /** Name of the metric being analyzed */
  metric: Scalars['String']['output'];
  /** Unit of measurement */
  unit: Scalars['String']['output'];
};

/** Cohort progression analysis segmented by one or more dimensions (composite segmentation) */
export type CohortAnalysisByCompositeSegment = {
  __typename: 'CohortAnalysisByCompositeSegment';
  /** Average baseline value (Day 0) across all users */
  baselineValue?: Maybe<Scalars['Float']['output']>;
  /** The dimensions used for segmentation */
  dimensions: Array<SegmentDimension>;
  /** Name of the metric being analyzed */
  metric: Scalars['String']['output'];
  /** Cohort data for each composite segment */
  segments: Array<CompositeSegmentCohort>;
  /** Unit of measurement */
  unit: Scalars['String']['output'];
};

/** Cohort progression analysis segmented by gender */
export type CohortAnalysisByGender = {
  __typename: 'CohortAnalysisByGender';
  /** Cohort data for each gender */
  genders: Array<GenderCohort>;
  /** Name of the metric being analyzed */
  metric: Scalars['String']['output'];
  /** Unit of measurement */
  unit: Scalars['String']['output'];
};

/** Cohort progression analysis segmented by RMSSD group (baseline HRV level) */
export type CohortAnalysisByRmssdGroup = {
  __typename: 'CohortAnalysisByRmssdGroup';
  /** Cohort data for each RMSSD group */
  groups: Array<RmssdGroupCohort>;
  /** Name of the metric being analyzed */
  metric: Scalars['String']['output'];
  /** Unit of measurement */
  unit: Scalars['String']['output'];
};

/** A single data point in the cohort analysis showing aggregate metrics for a specific day since user start */
export type CohortAnalysisDataPoint = {
  __typename: 'CohortAnalysisDataPoint';
  /**
   * Average absolute change from baseline across all cohorts at this day
   * Formula: value - baseline
   * Null when no users have data for this day
   */
  absoluteChange?: Maybe<Scalars['Float']['output']>;
  /**
   * Average actual measured value across all users for this day
   * This is the real averaged measurement (not derived from baseline + change)
   */
  actualValue?: Maybe<Scalars['Float']['output']>;
  /**
   * Per-day baseline value for this cohort
   * This is the Day 0 baseline for users who have data on this specific day.
   * Differs from CohortAnalysis.baselineValue which is the global baseline.
   * Helps explain why absoluteChange = actualValue - baselineValue for each day's cohort.
   */
  baselineValue?: Maybe<Scalars['Float']['output']>;
  /** Number of distinct cohorts (unique user start dates) included in calculation */
  cohortCount: Scalars['Int']['output'];
  /** Number of days since the user started (Day 0 = baseline) */
  daysSinceStart: Scalars['Int']['output'];
  /**
   * Average percentage change from baseline across all cohorts at this day
   * Formula: ((value - baseline) / baseline) * 100
   * Null when no users have data for this day
   */
  percentageChange?: Maybe<Scalars['Float']['output']>;
  /** Number of users with data at this specific day */
  userCount: Scalars['Int']['output'];
};

/** Filter for cohort analysis query */
export type CohortAnalysisFilter = {
  /**
   * Number of days used to calculate baseline (median of first N days)
   * If null, defaults to 3 days
   */
  baselineDays?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of days to analyze (e.g., 30, 45, 60, 90) */
  maxDays: Scalars['Int']['input'];
  /**
   * Maximum allowed gap (in days) between consecutive measurements
   * Users with gaps longer than this are excluded. Defaults to 7 days
   */
  maxMeasurementGapDays?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the metric to analyze (e.g., "hrv", "stressIndex", "parasympathetic") */
  metricName: Scalars['String']['input'];
  /**
   * Minimum number of measurements required in baseline window
   * Users with fewer measurements are excluded. Defaults to 2
   */
  minBaselineMeasurements?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Minimum start date (Day 0) for users to be included in cohort analysis.
   * Users whose unified Day 0 is before this date are excluded.
   * Format: ISO date string (e.g., "2025-10-01")
   * Defaults to 2025-10-01 to exclude early beta users with incomplete metrics.
   * Set to null to include all users regardless of start date.
   */
  minStartDate?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Area Under Curve (AUC) summary for a cohort's percentage change over time.
 * Computed via the trapezoidal rule, split at zero crossings.
 */
export type CohortAuc = {
  __typename: 'CohortAuc';
  /** Accumulated area below the zero line, as an absolute value (always >= 0) */
  negativeAuc: Scalars['Float']['output'];
  /** Net AUC (positiveAuc - negativeAuc). Positive means net improvement. */
  netAuc: Scalars['Float']['output'];
  /** Accumulated area above the zero line (always >= 0) */
  positiveAuc: Scalars['Float']['output'];
};

/** A member of a cohort with optional PII. */
export type CohortMember = {
  __typename: 'CohortMember';
  /** Personal information (requires PII access) */
  pii?: Maybe<Pii>;
  /** User ID of the cohort member */
  userId: Scalars['ID']['output'];
};

export enum CohortType {
  All = 'all',
  ExperiencedUsers = 'experienced_users',
  NewUsers = 'new_users'
}

/** Detailed cohort information including members. */
export type CohortWithMembers = {
  __typename: 'CohortWithMembers';
  /** Cohort metadata */
  cohort: Cohort;
  /** User IDs in this cohort */
  memberIds: Array<Scalars['ID']['output']>;
  /** Members with PII data */
  members: Array<CohortMember>;
};

/**
 * Revenue for ONE settlement currency (YOJO-2603). accounting-api aggregates per (month, currency);
 * non-base currencies are reported here rather than summed into the GBP headline, because their
 * amounts are minor units of a different currency and no historic FX rate is available.
 */
export type CompanyKpiCurrencyRevenue = {
  __typename: 'CompanyKpiCurrencyRevenue';
  /** Three-letter currency code, lowercase (e.g. "gbp", "zar"). */
  currency: Scalars['String']['output'];
  grossLastFullMonth: Scalars['BigDecimal']['output'];
  grossLifetime: Scalars['BigDecimal']['output'];
  grossMonthToDate: Scalars['BigDecimal']['output'];
  netLastFullMonth: Scalars['BigDecimal']['output'];
  netLifetime: Scalars['BigDecimal']['output'];
  netMonthToDate: Scalars['BigDecimal']['output'];
};

/**
 * Engagement KPI: members with at least one EngagementProfile/Account event in the 7-day
 * window ending at the snapshot date.
 */
export type CompanyKpiEngagementMetrics = {
  __typename: 'CompanyKpiEngagementMetrics';
  activeLast7DaysCurrent: Scalars['Int']['output'];
  activeLast7DaysHistory: Array<MonthlyKpiPoint>;
  activeLast7DaysLastFullMonth: Scalars['Int']['output'];
  activeLast7DaysPriorMonth: Scalars['Int']['output'];
};

/**
 * Member-related KPIs: total members, paying members, churn.
 * - `totalMembers` is cumulative (lifetime headline).
 * - `payingMembers` is a snapshot (current headline). YOJO-1699: computed from CRM entitlements that
 *   are claim-active AND billing-status active (active ONLY — trialing/past_due excluded), non-test owner.
 * - `churn` is a flow (this-month headline): CRM entitlements that were paying at end of last month
 *   but are no longer paying at end of this month.
 */
export type CompanyKpiMemberMetrics = {
  __typename: 'CompanyKpiMemberMetrics';
  churnHistory: Array<MonthlyKpiPoint>;
  churnLastFullMonth: Scalars['Int']['output'];
  churnMonthToDate: Scalars['Int']['output'];
  churnPriorMonth: Scalars['Int']['output'];
  newSignupsHistory: Array<MonthlyKpiPoint>;
  newSignupsLastFullMonth: Scalars['Int']['output'];
  newSignupsMonthToDate: Scalars['Int']['output'];
  newSignupsPriorMonth: Scalars['Int']['output'];
  payingMembersCurrent: Scalars['Int']['output'];
  payingMembersHistory: Array<MonthlyKpiPoint>;
  payingMembersLastFullMonth: Scalars['Int']['output'];
  payingMembersPriorMonth: Scalars['Int']['output'];
  totalMembersLifetime: Scalars['Int']['output'];
};

/**
 * Revenue KPIs from accounting-api: gross (total processed) and net (after Stripe fees).
 *
 * YOJO-2603: the amount fields are ONLY meaningful when `revenueUnavailable` is false. When
 * accounting-api cannot be reached or rejects the forwarded JWT they are zero-valued placeholders and
 * the UI must render "unavailable", never £0.00. Headline figures are GBP-only; see `byCurrency`.
 */
export type CompanyKpiRevenueMetrics = {
  __typename: 'CompanyKpiRevenueMetrics';
  /**
   * Per-settlement-currency revenue, including the base currency. Empty when revenue is unavailable.
   * More than one entry means the GBP-only headline does not tell the whole story.
   */
  byCurrency: Array<CompanyKpiCurrencyRevenue>;
  /** Three-letter currency code of the headline figures below — always the GBP settlement base. */
  currency: Scalars['String']['output'];
  grossHistory: Array<MonthlyKpiPoint>;
  grossLastFullMonth: Scalars['BigDecimal']['output'];
  grossLifetime: Scalars['BigDecimal']['output'];
  grossMonthToDate: Scalars['BigDecimal']['output'];
  grossPriorMonth: Scalars['BigDecimal']['output'];
  /**
   * True when every currency in the window is `currency`, i.e. the headline figures are the complete
   * picture. False means revenue also (or only) settled in another currency — the headline is then
   * partial, and with no base-currency rows at all it reads 0.00 while real money sits in
   * `byCurrency`. Do not present the headline as the total when this is false.
   */
  headlineCoversAllRevenue: Scalars['Boolean']['output'];
  netHistory: Array<MonthlyKpiPoint>;
  netLastFullMonth: Scalars['BigDecimal']['output'];
  netLifetime: Scalars['BigDecimal']['output'];
  netMonthToDate: Scalars['BigDecimal']['output'];
  netPriorMonth: Scalars['BigDecimal']['output'];
  /**
   * True when accounting-api could not be reached / authenticated / is unconfigured. The amounts
   * below are then NOT a measured zero — render "unavailable".
   */
  revenueUnavailable: Scalars['Boolean']['output'];
  /** Short human-readable reason when `revenueUnavailable`; null otherwise. */
  revenueUnavailableReason?: Maybe<Scalars['String']['output']>;
};

/**
 * Session KPIs: VNS sessions completed (device + manual) and % of members who have
 * ever started VNS. Legacy VnsSessionRecordedEvent is intentionally excluded.
 */
export type CompanyKpiSessionMetrics = {
  __typename: 'CompanyKpiSessionMetrics';
  percentStartedVnsCurrent: Scalars['BigDecimal']['output'];
  percentStartedVnsHistory: Array<MonthlyKpiPoint>;
  percentStartedVnsLastFullMonth: Scalars['BigDecimal']['output'];
  percentStartedVnsPriorMonth: Scalars['BigDecimal']['output'];
  sessionsCompletedHistory: Array<MonthlyKpiPoint>;
  sessionsCompletedLastFullMonth: Scalars['Int']['output'];
  sessionsCompletedLifetime: Scalars['Int']['output'];
  sessionsCompletedMonthToDate: Scalars['Int']['output'];
  sessionsCompletedPriorMonth: Scalars['Int']['output'];
};

/** Top-level canonical company KPIs. */
export type CompanyKpis = {
  __typename: 'CompanyKpis';
  /** Canonical written definition of each metric, keyed by `metric`. */
  definitions: Array<KpiDefinition>;
  engagement: CompanyKpiEngagementMetrics;
  members: CompanyKpiMemberMetrics;
  revenue: CompanyKpiRevenueMetrics;
  sessions: CompanyKpiSessionMetrics;
};

export type CompleteActivityCommand = {
  /** When the activity was actually completed */
  completedAt: Scalars['DateTime']['input'];
  /** The date this activity was scheduled for */
  date: Scalars['Date']['input'];
  /** ID of the planned activity being completed */
  plannedActivityId: Scalars['ID']['input'];
  /** The time block this activity was scheduled for */
  timeBlock: TimeBlock;
};

/**
 * The data-only payload of a component. A union of the five v1 component payload shapes — no markup,
 * only typed numbers/series/labels the renderer styles (ADR-0005, D2).
 */
export type ComponentPayloadData = ChangePointHeroPayload | KeepGoingPayload | TrendSmallMultiplesPayload | WatchCardPayload | WithinSessionPayload;

/** The component catalogue keys (ADR-0005). C4 is reserved (folded into C1 in v1). */
export enum ComponentType {
  C1ChangePointHero = 'C1_CHANGE_POINT_HERO',
  C2TrendSmallMultiples = 'C2_TREND_SMALL_MULTIPLES',
  C3WithinSession = 'C3_WITHIN_SESSION',
  C5WatchCard = 'C5_WATCH_CARD',
  C6KeepGoing = 'C6_KEEP_GOING'
}

/** A single composite segment cohort with its key, label, user count, and data points */
export type CompositeSegmentCohort = {
  __typename: 'CompositeSegmentCohort';
  /** Area Under Curve summary for this composite segment's percentage change trend */
  auc?: Maybe<CohortAuc>;
  /** Time series data points for this composite segment */
  dataPoints: Array<CohortAnalysisDataPoint>;
  /** Canonical key string for grouping (e.g. "ageBracket=age_35_44,gender=female") */
  segmentKey: Scalars['String']['output'];
  /** Human-readable label (e.g. "35-44 / Female") */
  segmentLabel: Scalars['String']['output'];
  /** Number of users in this composite segment */
  userCount: Scalars['Int']['output'];
};

/** Participant Consults - Type Definitions */
export type Consult = {
  __typename: 'Consult';
  consultNumber: Scalars['Int']['output'];
  consultType: ConsultType;
  /**
   * Participant notes whose linkedConsultNumber matches this consult's consultNumber,
   * for the same participant (e.g. the consult transcript). Empty if none are linked.
   */
  linkedNotes: Array<ParticipantNote>;
  notes?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<ConsultOutcome>;
  participantId: Scalars['ID']['output'];
  scheduledBy: Scalars['ID']['output'];
  scheduledDate: Scalars['String']['output'];
};

export enum ConsultOutcome {
  Attended = 'attended',
  Cancelled = 'cancelled',
  NoShow = 'no_show',
  Rescheduled = 'rescheduled'
}

/**
 * One participant's row on the cross-participant consult roster. Names/emails are real PII
 * (nurse/admin are authorised) — no anonymisation, no GDPR-justification gate.
 */
export type ConsultRosterEntry = {
  __typename: 'ConsultRosterEntry';
  attendedConsults: Scalars['Int']['output'];
  consultStatus: ConsultStatus;
  /** Real email; null if no PII / contact info on record. */
  email?: Maybe<Scalars['String']['output']>;
  /** ISO date of the latest consult by scheduled date; null if none. */
  lastConsultDate?: Maybe<Scalars['String']['output']>;
  /** Real display name; null if no PII on record. */
  name?: Maybe<Scalars['String']['output']>;
  /** True unless the participant has at least one 'attended' consult. */
  needsInitialConsult: Scalars['Boolean']['output'];
  /** ISO date of the earliest upcoming (no-outcome) consult; null if none. */
  nextScheduledDate?: Maybe<Scalars['String']['output']>;
  participantId: Scalars['ID']['output'];
  totalConsults: Scalars['Int']['output'];
};

/** Roster-level consult status for a participant (the care-team "have they been seen?" view). */
export enum ConsultStatus {
  /** Has at least one consult with outcome 'attended'. */
  Attended = 'attended',
  /** Zero consults of any kind. */
  None = 'none',
  /** Has an upcoming consult (future / no outcome) but no attended consult yet. */
  Scheduled = 'scheduled'
}

export enum ConsultType {
  DataDeepDive = 'data_deep_dive',
  FollowUp = 'follow_up',
  Initial = 'initial'
}

/** Where a buyer contact change came from. */
export enum ContactChangeSource {
  Checkout = 'checkout',
  Imported = 'imported',
  Operator = 'operator',
  Other = 'other',
  StripePortal = 'stripe_portal'
}

export type ContactInformation = {
  __typename: 'ContactInformation';
  address?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<PhoneNumber>;
};

/**
 * Interface for all content types that can be resolved from a ContentReference.
 * All CmsDocument implementations automatically implement this interface.
 */
export type Content = {
  /** Display title for the content */
  title: Scalars['String']['output'];
};

/** Content analytics overview - aggregated stats about content consumption */
export type ContentAnalytics = {
  __typename: 'ContentAnalytics';
  /** Average time spent on content (seconds) */
  averageTimeSpentSeconds: Scalars['Float']['output'];
  /** Breakdown by content source (coach, AI, organic) */
  completionsBySource: Array<ContentSourceStats>;
  /** Breakdown by content type (article, story, video) */
  completionsByType: Array<ContentTypeStats>;
  /** Completions over time for charting */
  completionsOverTime: Array<ContentTimeSeriesPoint>;
  /** Top performing content pieces */
  topContent: Array<ContentStats>;
  /** Total content completions in the date range */
  totalCompletions: Scalars['Int']['output'];
  /** Number of unique users who completed content */
  uniqueUsers: Scalars['Int']['output'];
  /** User discovery patterns (assigned only vs explores organically) */
  userDiscoveryPatterns: UserDiscoveryPatterns;
};

/** Input for content analytics query */
export type ContentAnalyticsInput = {
  /** End date for the analytics period */
  endDate: Scalars['DateTime']['input'];
  /** Start date for the analytics period */
  startDate: Scalars['DateTime']['input'];
  /** Maximum number of top content items to return (default: 10) */
  topContentLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentBlock = AttachBlock | AudioBlock | BlurbBlock | BulletListBlock | EmbedBlock | HeadingBlock | ImageCenteredBlock | ImageWithHeadingBlock | ImageWithSubheadingBlock | ImportantNoteBlock | NumberedListBlock | ParagraphBlock | ParagraphWithHeadingBlock | ParagraphWithSubheadingBlock | PopoutWithImageBlock | PopoutWithTextBlock | SubheadingBlock | VideoBlock;

/** A category of content based on protocol */
export type ContentCategory = {
  __typename: 'ContentCategory';
  /** Content pieces in this category, paginated */
  content: Array<ActivityVideo | Article | JourneyVideo | Lesson | Story>;
  /** Whether there are more items that can be loaded */
  hasMore: Scalars['Boolean']['output'];
  /** The protocol this category represents */
  protocol: Protocol;
  /** Total number of content pieces in this category */
  totalCount: Scalars['Int']['output'];
};

/** Input for content category pagination */
export type ContentCategoryRequest = {
  /**
   * Cursor for pagination within a specific protocol category
   * Only used when protocol is specified
   */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Number of items to show per category
   * Default is 3
   */
  itemsPerCategory?: InputMaybe<Scalars['Int']['input']>;
  /** When loading more items for a specific category, specify which protocol */
  protocol?: InputMaybe<Protocol>;
};

export type ContentFrame = {
  __typename: 'ContentFrame';
  media: File | Image | Video | VideoCaption;
};

/** Interface for content references that can be either external CMS content, mobile widgets, or custom activities */
export type ContentReference = {
  /** The hydrated content for this reference */
  hydratedContent?: Maybe<ActivityVideo | Article | ArticleTeaser | CustomActivity | DojoArticle | DojoChecklist | DojoNugget | DojoQuiz | DojoQuote | JourneyVideo | Lesson | MobileWidget | Story | StoryTeaser | VideoTeaser>;
};

export type ContentReferenceInput = {
  /** Populated if kind == custom_activity */
  customActivity?: InputMaybe<CustomActivityIdInput>;
  /** Populated if kind == external */
  external?: InputMaybe<ExternalContentIdInput>;
  /** Indicates which type of content reference is being sent. */
  kind: ContentReferenceKind;
  /** Populated if kind == mobile_widget */
  mobileWidget?: InputMaybe<MobileWidgetIdInput>;
};

export enum ContentReferenceKind {
  CustomActivity = 'custom_activity',
  External = 'external',
  MobileWidget = 'mobile_widget'
}

/**
 * Tracks where content engagement originated from in the application.
 * Used for analytics to understand which features drive content consumption.
 */
export enum ContentSource {
  /** Content suggested by AI insights */
  AiInsight = 'ai_insight',
  /** Content recommended by a coach */
  CoachRecommendation = 'coach_recommendation',
  /** Content accessed from the dojo */
  Dojo = 'dojo',
  /** Content discovered through the explore page */
  ExplorePage = 'explore_page',
  /** Content from a learning path */
  LearningPath = 'learning_path',
  /** Mobile widget content (VNS sessions, meditations, etc.) */
  MobileWidget = 'mobile_widget',
  /** Content found via search */
  Search = 'search',
  /** Content from the storefront */
  Storefront = 'storefront'
}

/** Statistics for content completions by source (coach, AI, or organic) */
export type ContentSourceStats = {
  __typename: 'ContentSourceStats';
  /** Average completions per user from this source */
  avgPerUser: Scalars['Float']['output'];
  /** Number of completions from this source */
  completions: Scalars['Int']['output'];
  /** Source of the content assignment (coach, ai, organic) */
  source: Scalars['String']['output'];
  /** Number of unique users completing content from this source */
  uniqueUsers: Scalars['Int']['output'];
};

/** Statistics for a specific content piece */
export type ContentStats = {
  __typename: 'ContentStats';
  /** Average time spent (seconds) */
  averageTimeSpentSeconds: Scalars['Float']['output'];
  /** Number of completions */
  completions: Scalars['Int']['output'];
  /** Content reference with hydrated content details */
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  /** Content type (article, story, video) */
  contentType: Scalars['String']['output'];
  /** Number of unique users */
  uniqueUsers: Scalars['Int']['output'];
};

/** Time series data point for content completions */
export type ContentTimeSeriesPoint = {
  __typename: 'ContentTimeSeriesPoint';
  /** Number of completions on this date */
  count: Scalars['Int']['output'];
  /** Date (YYYY-MM-DD format) */
  date: Scalars['String']['output'];
};

/** Content delivery method */
export enum ContentType {
  Activity = 'activity',
  Article = 'article',
  Dojo = 'dojo',
  Lesson = 'lesson',
  Quiz = 'quiz',
  Story = 'story',
  Video = 'video'
}

/** Distribution of content types in a learning path */
export type ContentTypeCount = {
  __typename: 'ContentTypeCount';
  /** Number of items of this type */
  count: Scalars['Int']['output'];
  /** The type of content (e.g. article, quiz, etc) */
  type: Scalars['String']['output'];
};

/** Statistics for a specific content type */
export type ContentTypeStats = {
  __typename: 'ContentTypeStats';
  /** Average time spent (seconds) */
  averageTimeSpentSeconds: Scalars['Float']['output'];
  /** Number of completions */
  completions: Scalars['Int']['output'];
  /** Content type (article, story, video) */
  contentType: Scalars['String']['output'];
  /** Number of unique users */
  uniqueUsers: Scalars['Int']['output'];
};

/** Statistical correlation result */
export type CorrelationResult = {
  __typename: 'CorrelationResult';
  /** Pearson correlation coefficient (-1 to 1) */
  correlationCoefficient: Scalars['Float']['output'];
  /** Statistical significance (p-value) */
  pValue?: Maybe<Scalars['Float']['output']>;
  /** Number of data points used in calculation */
  sampleSize: Scalars['Int']['output'];
  /** Qualitative strength of correlation */
  strength: CorrelationStrength;
};

/** Strength of correlation coefficient */
export enum CorrelationStrength {
  /** 0.5 <= |r| < 0.7 - moderate correlation */
  Moderate = 'moderate',
  /** |r| < 0.3 - little to no correlation */
  None = 'none',
  /** 0.7 <= |r| <= 1.0 - strong correlation */
  Strong = 'strong',
  /** 0.3 <= |r| < 0.5 - weak correlation */
  Weak = 'weak'
}

export type Course = {
  __typename: 'Course';
  benefits?: Maybe<Array<ContentBlock>>;
  completion?: Maybe<CourseCompletion>;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  lessons?: Maybe<Array<Lesson>>;
  metadata: Metadata;
  reviewer?: Maybe<Reviewer>;
  thumbnail?: Maybe<Image>;
  title: Scalars['String']['output'];
};

export type CourseCompletion = {
  __typename: 'CourseCompletion';
  lessonsProgress?: Maybe<Array<LessonProgress>>;
  percentage?: Maybe<Scalars['Int']['output']>;
};

/**
 * Input for creating a new acquisition source.
 * Maps 1:1 to CreateAcquisitionSourceCommand (minus server-generated sourceId).
 */
export type CreateAcquisitionSourceInput = {
  defaultSegment: CustomerSegment;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  partnerName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateBillingPortalSessionInput = {
  /** Open straight at one action; absent = the portal's home page. */
  flow?: InputMaybe<BillingPortalFlow>;
  /** Where the portal's 'back' link returns. Must match the server's allow-list, otherwise refused. */
  returnUrl: Scalars['String']['input'];
};

export type CreateCarrierInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  trackingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomActivityCommand = {
  /** ID of the planning to add custom activity to */
  activityPlanningId: Scalars['ID']['input'];
  /** Description of what the activity entails */
  description: Scalars['String']['input'];
  /** Optional vitals this activity may impact */
  impactedVitals?: InputMaybe<Array<ImpactedVital>>;
  /** Optional protocols this activity relates to */
  protocols?: InputMaybe<Array<Protocol>>;
  /** Optional subprotocols this activity relates to */
  subprotocols?: InputMaybe<Array<Subprotocol>>;
  /** Title of the custom activity */
  title: Scalars['String']['input'];
};

export type CreateLearningJourneyCommand = {
  assignDuringOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  steps: Array<LearningJourneyStepInput>;
};

export type CreateLearningPathCommand = {
  contentItems: Array<ContentReferenceInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Input for creating a new Payment Link */
export type CreatePaymentLinkInput = {
  /** Optional redirect URL after successful payment */
  afterCompletionUrl?: InputMaybe<Scalars['String']['input']>;
  /** Whether to allow promotion codes at checkout */
  allowPromotionCodes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allowed shipping destination countries (ISO 3166-1 alpha-2 codes, e.g., GB, DE, US) */
  allowedCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Internal reference name for the payment link (e.g., Device Bundle Q1 2025) */
  name: Scalars['String']['input'];
  /** Payment strategy (PAY_NOW for cards, PAY_LATER for Klarna) */
  paymentStrategy?: InputMaybe<PaymentLinkStrategy>;
  /** Purpose/campaign identifier (e.g., marketing_campaign_q1) */
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Create a member's personalised Stone mode: its name, an optional description and the eight values. There is no
 * mode id (the backend generates it) and no curve.
 */
export type CreatePersonalisedStoneModeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  parameters: StimulationParameterValuesInput;
};

/**
 * Input for creating a new shipment.
 * Maps 1:1 to CreateShipmentCommand (minus server-generated shipmentId).
 */
export type CreateShipmentInput = {
  customerId: Scalars['ID']['input'];
  items: Array<ShipmentItemInput>;
  shippingAddress: ShipmentAddressInput;
};

export type CreateStaffUserInput = {
  /** The work address the person signs in with (@yojo.health or @luminapain.com) */
  email: Scalars['String']['input'];
  /** The staff roles to give: one or more of admin, nurse, content, developer, analyst, operations, sales, growth */
  roles: Array<Role>;
  /** The person's timezone as an IANA name, for example Europe/Amsterdam */
  timezone: Scalars['String']['input'];
};

/**
 * Create a Stone mode (YOJO-3258). There is no id field: the backend generates every mode id. `position`
 * (0-based, the full ordering incl. disabled modes) places it; omitted means at the end.
 */
export type CreateStoneModeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  generation: StoneDeviceGeneration;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Basic information about the currently authenticated user.
 * Includes account ID, roles, and email from auth context (not PII).
 * Does NOT expose PII or medical data.
 * Safe for all authenticated users.
 */
export type CurrentUser = {
  __typename: 'CurrentUser';
  /** Account ID (act_ prefix) */
  accountId: Scalars['ID']['output'];
  /** Email from authentication context (not from PII vault) */
  email: Scalars['String']['output'];
  /** User's assigned roles */
  roles: Array<Role>;
  /** Account status */
  status: UserStatus;
};

/** Represents a custom activity defined by a user */
export type CustomActivity = Content & {
  __typename: 'CustomActivity';
  /** When this custom activity was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this custom activity */
  customActivityId: Scalars['ID']['output'];
  /** Description of what the activity entails */
  description: Scalars['String']['output'];
  /** Optional vitals this activity may impact */
  impactedVitals?: Maybe<Array<ImpactedVital>>;
  /** Optional protocols this activity relates to */
  protocols?: Maybe<Array<Protocol>>;
  /** Optional subprotocols this activity relates to */
  subprotocols?: Maybe<Array<Subprotocol>>;
  /** Title of the custom activity */
  title: Scalars['String']['output'];
};

/** Reference to a custom activity */
export type CustomActivityId = ContentReference & {
  __typename: 'CustomActivityId';
  /** ID of the custom activity being referenced */
  customActivityId: Scalars['ID']['output'];
  hydratedContent?: Maybe<ActivityVideo | Article | ArticleTeaser | CustomActivity | DojoArticle | DojoChecklist | DojoNugget | DojoQuiz | DojoQuote | JourneyVideo | Lesson | MobileWidget | Story | StoryTeaser | VideoTeaser>;
};

/** Because GraphQL does not allow unions as inputs, we use a 'discriminated' input type. */
export type CustomActivityIdInput = {
  /** ID of the custom activity */
  customActivityId: Scalars['ID']['input'];
};

/** Customer record representing a purchase/subscription in the CRM system. */
export type Customer = {
  __typename: 'Customer';
  /**
   * Acquisition source resolved live from this Customer's coupon code (YOJO-2351). Read-only: the same
   * couponCode -> AcquisitionSource lookup provisioning runs to pick the segment. Null when the Customer
   * has no coupon code, or the code matches no active source.
   */
  acquisitionSource?: Maybe<CustomerAcquisitionSource>;
  amountPaid?: Maybe<Scalars['BigDecimal']['output']>;
  /** One customer's contact history: a full audited read per customer; single-customer screens only, never in a list. */
  contactHistory?: Maybe<CustomerContactHistory>;
  /**
   * Buyer contact (name not included — email/address/phone/country) read from the governed PII vault
   * for this Customer's own cust_-owned Pii (YOJO-2094 [governed buyer PII at checkout]). Available
   * before activation (no linked User required); audited + masked-per-policy by the vault. Null for a
   * historical Customer that has no cust_-owned Pii. Additive to — never a replacement for — linkedUser → pii.
   */
  contactInformation?: Maybe<ContactInformation>;
  country?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customerId: Scalars['ID']['output'];
  /**
   * Buyer email. Nullable since YOJO-2094 [governed buyer PII at checkout]: email is now optional
   * in the model (emailHash is the matchable identifier — ADR-0006 D4/D9; owner-polymorphic cust_
   * buyers). A historical or no-email Customer returns null here; the paginated list must not bubble.
   */
  email?: Maybe<Scalars['String']['output']>;
  /** Engagement statistics for the linked user (resolved via DataLoader). */
  engagement?: Maybe<EngagementStats>;
  entitlements: Array<Entitlement>;
  financialSummary?: Maybe<FinancialSummary>;
  /** Date of first coaching consult (if recorded) */
  firstConsultDate?: Maybe<Scalars['Date']['output']>;
  /** Time of the most recent recorded Stripe refund (YOJO-2360). Null when no refund has been recorded. */
  lastStripeRefundAt?: Maybe<Scalars['DateTime']['output']>;
  /** User linked via activated entitlement (cross-context resolution). */
  linkedUser?: Maybe<Participant>;
  /**
   * The first activated entitlement (if any).
   * Helper for common use case.
   */
  primaryEntitlement?: Maybe<Entitlement>;
  /**
   * YOJO-3607 — true while a recorded refund still awaits an ops decision: stripeRefundCount > 0 AND the
   * primaryEntitlement has no keep review covering every refund recorded so far. Any refund RECORDED after the
   * review makes it true again, whatever its refund date. False when no refund is recorded, or when there is no
   * active (primary) entitlement.
   */
  refundReviewPending: Scalars['Boolean']['output'];
  /**
   * YOJO-3607 [refunded buyers: ops records "keep access + reason" so the Refunded badge clears] — the latest
   * refund review recorded per entitlement (the ops decision after a refund, with the reason, who and when).
   * Empty when no review was ever recorded. Admin / operations only: any other caller gets an authorization error.
   */
  refundReviews: Array<RefundReview>;
  segment: CustomerSegment;
  /** Service cases associated with this customer. */
  serviceCases: Array<ServiceCase>;
  /**
   * Whether the backing Stripe customer has been deleted (YOJO-2359). Record-only fact — no lifecycle
   * change; stripeCustomerId is retained for audit. Defaults false for historical / current customers.
   */
  stripeCustomerDeleted: Scalars['Boolean']['output'];
  /**
   * Stripe customer id. Nullable (YOJO-2294): a payment-link/customer-less checkout or a backfilled/
   * care-team Customer can legitimately have none, and the projection can momentarily hold null between
   * create and association — a non-null (String!) here NULLs the whole row and hides the Customer.
   */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Stripe payment-intent id. Nullable (YOJO-2294): a backfilled/care-team Customer may have none. */
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  /**
   * Number of Stripe charge.refunded facts recorded on this Customer (YOJO-2360). Record-only (a refund
   * is not a revoke). Defaults 0 for customers with no recorded refund.
   */
  stripeRefundCount: Scalars['Int']['output'];
  transactions?: Maybe<Array<TransactionDetail>>;
};

/**
 * Thin acquisition-source view resolved for a Customer from its coupon code (YOJO-2351).
 * Carries only the ops-facing subset; the full record stays behind the acquisitionSource(sourceId) query.
 */
export type CustomerAcquisitionSource = {
  __typename: 'CustomerAcquisitionSource';
  defaultSegment: CustomerSegment;
  name: Scalars['String']['output'];
  /** Partner name (B2B2C sources only); null otherwise. */
  partnerName?: Maybe<Scalars['String']['output']>;
};

/** Paginated customer results using cursor-based pagination. */
export type CustomerConnection = {
  __typename: 'CustomerConnection';
  edges: Array<CustomerEdge>;
  pageInfo: CustomerPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** The buyer's contact as it stands now. A card with no value is null. */
export type CustomerContactCards = {
  __typename: 'CustomerContactCards';
  billing?: Maybe<BillingContact>;
  delivery?: Maybe<DeliveryContact>;
  email?: Maybe<Scalars['String']['output']>;
};

/**
 * One change to one buyer contact field. A pending change is a field a Stripe observation decided to apply that no
 * change from that Stripe event shows yet (no values). A removed change has no new value.
 */
export type CustomerContactChange = {
  __typename: 'CustomerContactChange';
  changedAt: Scalars['DateTime']['output'];
  /** The operator's display name of an operator change. */
  changedBy?: Maybe<Scalars['String']['output']>;
  field: CustomerContactField;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  /** Decided by the Customer, no Pii event carries this event id: not landed yet, or the value was already equal at write time. */
  pending: Scalars['Boolean']['output'];
  /** The Stripe event id (evt_) of a stripe_portal change. */
  providerEventId?: Maybe<Scalars['String']['output']>;
  removed: Scalars['Boolean']['output'];
  source: ContactChangeSource;
};

/** A buyer contact field shown in the contact history (the Pii field names). */
export enum CustomerContactField {
  Address = 'address',
  BillingAddress = 'billing_address',
  BillingCountry = 'billing_country',
  BillingName = 'billing_name',
  Country = 'country',
  Email = 'email',
  FirstName = 'first_name',
  LastName = 'last_name',
  MiddleName = 'middle_name',
  PhoneNumber = 'phone_number'
}

/** The buyer's contact history: current cards, changes (oldest first), Stripe observations (oldest first). */
export type CustomerContactHistory = {
  __typename: 'CustomerContactHistory';
  changes: Array<CustomerContactChange>;
  current: CustomerContactCards;
  observations: Array<ExternalContactObservation>;
};

export type CustomerDashboard = {
  __typename: 'CustomerDashboard';
  deviceStatus: DeviceStatusMatrix;
  monthlyRevenue: Array<MonthlyRevenue>;
  overview: CustomerOverview;
  serviceCaseOverview: ServiceCaseOverview;
  statusMatrix: CustomerStatusMatrix;
  topAcquisitionSources: Array<AcquisitionSourceStats>;
};


export type CustomerDashboardMonthlyRevenueArgs = {
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerDashboardTopAcquisitionSourcesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerEdge = {
  __typename: 'CustomerEdge';
  cursor: Scalars['String']['output'];
  node: Customer;
};

/** Filter options for customer queries. */
export type CustomerFilter = {
  /** Filter by activation code (partial match) */
  activationCode?: InputMaybe<Scalars['String']['input']>;
  /** Filter by country codes (ISO 3166-1 alpha-2) */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by email address (partial match) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Filter by entitlement status (any entitlement matches) */
  entitlementStatuses?: InputMaybe<Array<EntitlementStatus>>;
  /** Filter by whether customer has activated entitlement */
  hasActivatedEntitlement?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether customer has had their first coaching consult */
  hasFirstConsult?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by purchase date (provisioned at) on or after this date */
  purchasedAfter?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by purchase date (provisioned at) on or before this date */
  purchasedBefore?: InputMaybe<Scalars['Date']['input']>;
  /** Text search across email and activation codes */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Filter by customer segments */
  segments?: InputMaybe<Array<CustomerSegment>>;
  /**
   * Filter by shipping statuses (matches customers with at least one shipment in
   * given status, or no_shipment for customers with zero shipments)
   */
  shippingStatuses?: InputMaybe<Array<ShippingFilterOption>>;
  /** Filter by user status (active/suspended) */
  userStatuses?: InputMaybe<Array<UserStatus>>;
};

/**
 * Customer Dashboard GraphQL Schema - Slice 5
 * Dashboard and reporting for the care team
 */
export type CustomerOverview = {
  __typename: 'CustomerOverview';
  activeEntitlements: Scalars['Int']['output'];
  pendingEntitlements: Scalars['Int']['output'];
  revokedEntitlements: Scalars['Int']['output'];
  suspendedEntitlements: Scalars['Int']['output'];
  totalCustomers: Scalars['Int']['output'];
};

export type CustomerPageInfo = {
  __typename: 'CustomerPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Customer segmentation based on acquisition channel. */
export enum CustomerSegment {
  B2b2c = 'b2b2c',
  D2c = 'd2c',
  Internal = 'internal',
  Investor = 'investor',
  Pilot = 'pilot'
}

export enum CustomerSortField {
  Country = 'country',
  CreatedAt = 'created_at',
  Email = 'email',
  LastActivity = 'last_activity',
  Segment = 'segment',
  ShippingStatus = 'shipping_status'
}

/** Sorting options for customer list. */
export type CustomerSortInput = {
  direction: SortDirection;
  field: CustomerSortField;
};

export type CustomerStatusMatrix = {
  __typename: 'CustomerStatusMatrix';
  b2b2c: SegmentStats;
  d2c: SegmentStats;
  internal: SegmentStats;
  investor: SegmentStats;
  pilot: SegmentStats;
};

export type DailyJournal = {
  __typename: 'DailyJournal';
  dailyJournalId: Scalars['ID']['output'];
  /**
   * The retired per-day diary: always answers []. Journal notes are Query.journalNotes.
   * @deprecated Removed upon YOJO-3602
   */
  logs: Array<DailyLog>;
  /**
   * The retired per-day diary: always answers []. Journal notes are Query.journalNotes.
   * @deprecated Removed upon YOJO-3602
   */
  painLevels: Array<DailyPainLevel>;
  participantId: Scalars['String']['output'];
};

export type DailyLog = {
  __typename: 'DailyLog';
  day: Scalars['Date']['output'];
  log: Scalars['String']['output'];
};

export type DailyPainLevel = {
  __typename: 'DailyPainLevel';
  day: Scalars['Date']['output'];
  painLevel: Scalars['Int']['output'];
};

/** A single daily reflection entry */
export type DailyReflection = {
  __typename: 'DailyReflection';
  /** Answers for each wellness metric */
  answers: Array<ReflectAnswer>;
  /** When the user completed the reflection */
  completedAt: Scalars['DateTime']['output'];
  /** When the reflection was persisted */
  createdAt: Scalars['DateTime']['output'];
  /** Date of the reflection */
  date: Scalars['Date']['output'];
  /** Optional free-text note */
  note?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this reflection */
  reflectionId: Scalars['ID']['output'];
};

export type DataExportAuditResult = {
  __typename: 'DataExportAuditResult';
  error?: Maybe<Scalars['String']['output']>;
  exportId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input for date range queries */
export type DateRangeInput = {
  start: Scalars['Date']['input'];
  until: Scalars['Date']['input'];
};

/**
 * Create a capability package. There is no packageId: it is derived server-side from packageKey, so the
 * same key addresses the same package in every environment and a retried create is not a second package.
 */
export type DefineCapabilityPackageInput = {
  capabilities: Array<Capability>;
  /**
   * The package's numeric dials. Omit the list for a package that expresses no opinion (its holders
   * inherit the floor's numbers); send a dial with `-1` for a package that lifts a limit entirely.
   */
  dials?: InputMaybe<Array<PackageDialInput>>;
  displayName: Scalars['String']['input'];
  /** Whether the member's own personalised mode is open on the plan. Needs `modeIds`. */
  includesPersonalised?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The Stone modes the plan gives, by mode id. Omit it to leave the list not set (the plan names no
   * modes and gives nothing but the default — YOJO-3313); an empty list names no modes. Each id must be an enabled
   * Stone mode from the catalogue.
   */
  modeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  packageKey: Scalars['ID']['input'];
  priceRefs?: InputMaybe<Array<CapabilityPriceRefInput>>;
  /**
   * The key of the plan this one sits directly above, which puts it in the plan ladder (Free ← Activate
   * ← Elevate). Required: every plan except the floor sits above another. The one exception is the
   * bootstrap — the very first package, defined while no floor is configured and no live package exists
   * yet, which then becomes the floor. Must name a defined, non-archived package other than this one.
   * Order only: contents and capability resolution are unaffected.
   */
  sitsAbove?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for deleting a manually logged VNS session */
export type DeleteManualVnsSessionInput = {
  /** Reason for deletion (optional, for audit trail) */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The session ID to delete (required) */
  sessionId: Scalars['ID']['input'];
};

/** Command for deleting a planned activity */
export type DeletePlannedActivityCommand = {
  plannedActivityId: Scalars['ID']['input'];
};

/** The buyer's current delivery contact. Phone number as E.164. */
export type DeliveryContact = {
  __typename: 'DeliveryContact';
  address?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum DesiredState {
  Balance = 'balance',
  Calm = 'calm',
  Clarity = 'clarity',
  Energy = 'energy',
  Habits = 'habits',
  MentalResilience = 'mental_resilience',
  NotSure = 'not_sure',
  Relationships = 'relationships',
  Rest = 'rest'
}

/**
 * The Stone's offline settings — how it behaves when it cannot reach yojo. Kept apart from the
 * capability settings: setting one of these never switches capability enforcement on.
 *
 * Each setting is null until somebody sets it: null means "not configured", never zero.
 */
export type DeviceOfflineSettings = {
  __typename: 'DeviceOfflineSettings';
  /** The most offline sessions the device itself accepts (from the vendor). Admin only. The allowance is clamped to it. */
  deviceOfflineCap?: Maybe<DeviceSettingValue>;
  /**
   * Days every member's Stone record runs from now, at least. A member with current paid coverage gets
   * the later of this and their coverage end + 7 days. The app renews the record before then. One window
   * for every member. Admin only.
   */
  deviceRecordWindowDays?: Maybe<DeviceSettingValue>;
  /**
   * How many sessions the Stone may start from its own button without the phone before the app must
   * be opened again. Set by admin or operations. When it is above `deviceOfflineCap`, the device is
   * served the cap instead — the allowance is clamped to the cap.
   */
  offlineSessionAllowance?: Maybe<DeviceSettingValue>;
};

/**
 * YOJO-2393 (ADR-0013) — the pre-registration overlay for a searched serial: the Entitlement a shipped serial
 * was pre-registered on, and whether that pre-registration is still open (redeemable) or consumed (linked).
 */
export type DeviceSerialPreRegistration = {
  __typename: 'DeviceSerialPreRegistration';
  customerId: Scalars['ID']['output'];
  entitlementId: Scalars['ID']['output'];
  preRegisteredAt?: Maybe<Scalars['DateTime']['output']>;
  preRegisteredBy?: Maybe<Scalars['ID']['output']>;
  serialNumber: Scalars['String']['output'];
  state: PreRegistrationState;
};

/** One device offline setting as it stands: the number, who last set it, and when. */
export type DeviceSettingValue = {
  __typename: 'DeviceSettingValue';
  updatedAt: Scalars['DateTime']['output'];
  /** The staff member who last set it. */
  updatedBy: Scalars['ID']['output'];
  /**
   * The display name of the staff member in `updatedBy` (full name: first, middle and last), as the caller may
   * read it (YOJO-3391; operations staff may read a staff colleague's name, YOJO-3455). Never their email. Their id
   * (`updatedBy`) when no name can be shown: the account is unknown, has no name, or its name is not readable by
   * the caller.
   */
  updatedByName?: Maybe<Scalars['String']['output']>;
  /** A whole number of 1 or more. */
  value: Scalars['Int']['output'];
};

export enum DeviceSituation {
  Alpha = 'alpha',
  AwaitingDelivery = 'awaiting_delivery',
  NoDevice = 'no_device',
  Stone = 'stone',
  Unknown = 'unknown'
}

export type DeviceStatusMatrix = {
  __typename: 'DeviceStatusMatrix';
  deliveredShipments: Scalars['Int']['output'];
  pendingShipments: Scalars['Int']['output'];
  shipmentsNeedingSerial: Scalars['Int']['output'];
  shippedShipments: Scalars['Int']['output'];
  totalShipments: Scalars['Int']['output'];
};

/** Analysis of direct physiological impact from pre to post VNS measurements */
export type DirectImpactAnalysis = {
  __typename: 'DirectImpactAnalysis';
  /** Confidence in the measurements (0-1) */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Overall impact score (0-100) */
  directImpactScore?: Maybe<Scalars['Int']['output']>;
  /** Brief description of overall physiological response */
  impactSummary?: Maybe<Scalars['String']['output']>;
  /** Vitals showing significant improvement */
  significantChanges?: Maybe<Array<Scalars['String']['output']>>;
};

export type DisputeDetail = {
  __typename: 'DisputeDetail';
  amountInCents: Scalars['Long']['output'];
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  disputeId: Scalars['ID']['output'];
  evidenceDueBy?: Maybe<Scalars['DateTime']['output']>;
  networkReasonCode?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['DateTime']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type DojoArticle = CmsDocument & Content & DojoElement & {
  __typename: 'DojoArticle';
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  id: Scalars['ID']['output'];
  media?: Maybe<File | Image | Video | VideoCaption>;
  /**
   * @deprecated Use title instead
   * @deprecated Renamed to `title`
   */
  name?: Maybe<Scalars['String']['output']>;
  protocols?: Maybe<Array<Protocol>>;
  title: Scalars['String']['output'];
};

export type DojoChecklist = CmsDocument & Content & DojoElement & {
  __typename: 'DojoChecklist';
  completionMessage: Scalars['String']['output'];
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  id: Scalars['ID']['output'];
  items: Array<Scalars['String']['output']>;
  /**
   * @deprecated Use title instead
   * @deprecated Renamed to `title`
   */
  name?: Maybe<Scalars['String']['output']>;
  paragraph?: Maybe<Scalars['String']['output']>;
  protocols?: Maybe<Array<Protocol>>;
  title: Scalars['String']['output'];
};

/**
 * Interface for all possible elements that can appear in the dojo feed
 * Now inherits base fields from CmsDocument
 */
export type DojoElement = {
  /** Content reference for the document */
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  /** Unique identifier for the document */
  id: Scalars['ID']['output'];
  /** Title of the document */
  title: Scalars['String']['output'];
};

export type DojoNugget = CmsDocument & Content & DojoElement & {
  __typename: 'DojoNugget';
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  id: Scalars['ID']['output'];
  media?: Maybe<File | Image | Video | VideoCaption>;
  /**
   * @deprecated Use title instead
   * @deprecated Renamed to `title`
   */
  name?: Maybe<Scalars['String']['output']>;
  protocols?: Maybe<Array<Protocol>>;
  title: Scalars['String']['output'];
};

export type DojoQuiz = CmsDocument & Content & DojoElement & {
  __typename: 'DojoQuiz';
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * @deprecated Use title instead
   * @deprecated Renamed to `title`
   */
  name?: Maybe<Scalars['String']['output']>;
  options: Array<DojoQuizAnswerOption>;
  question: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DojoQuizAnswerOption = {
  __typename: 'DojoQuizAnswerOption';
  isCorrect: Scalars['Boolean']['output'];
  /**
   * @deprecated Use title instead
   * @deprecated Renamed to `title`
   */
  name?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type DojoQuote = CmsDocument & Content & DojoElement & {
  __typename: 'DojoQuote';
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  id: Scalars['ID']['output'];
  media?: Maybe<File | Image | Video | VideoCaption>;
  protocols?: Maybe<Array<Protocol>>;
  title: Scalars['String']['output'];
};

export type DurationFilter = {
  /** Maximum duration in minutes (inclusive) */
  max?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum duration in minutes (inclusive) */
  min?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for editing a manually logged VNS session */
export type EditManualVnsSessionInput = {
  /** Updated duration in minutes (optional, 1-120 minutes) */
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Updated intensity level 0-30 (optional) */
  intensity?: InputMaybe<Scalars['Int']['input']>;
  /** Updated VNS mode (optional) */
  mode?: InputMaybe<VnsMode>;
  /** The session ID to edit (required) */
  sessionId: Scalars['ID']['input'];
  /** Updated start time (optional, must be within 2 weeks) */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** C1 effect call-out: the result metric moved from → to. */
export type EffectCallout = {
  __typename: 'EffectCallout';
  fromValue: Scalars['Float']['output'];
  toValue: Scalars['Float']['output'];
};

/**
 * The goal that applies to a member (YOJO-3288). Exactly one field is set, and which one says whose goal it is:
 * memberGoal when it is the member's own goal, healthArea when it is the care team's primary health area.
 */
export type EffectiveGoal = {
  __typename: 'EffectiveGoal';
  /** The care team's primary health area, when the member has no goal of their own */
  healthArea?: Maybe<NeedsDomain>;
  /** The member's own goal, when that is the goal that applies */
  memberGoal?: Maybe<MemberGoal>;
};

/** Email delivery status. */
export enum EmailStatus {
  Bounced = 'BOUNCED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type EmbedBlock = {
  __typename: 'EmbedBlock';
  description: Scalars['String']['output'];
  iframeSnippet?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** Records a qualitative emotional state using descriptive words */
export type EmotionalState = {
  __typename: 'EmotionalState';
  /** List of feeling words describing the emotional state */
  feelings: Array<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** When the emotional state was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** User who recorded the state */
  userId: Scalars['String']['output'];
};

/** Word cloud data for emotional states */
export type EmotionalWordCloudEntry = {
  __typename: 'EmotionalWordCloudEntry';
  /** Number of times this word has been used */
  count: Scalars['Int']['output'];
  /** The feeling word */
  word: Scalars['String']['output'];
};

/** Input for ending a previously started VNS therapy session. */
export type EndVnsSessionCommand = {
  /** The device record's complete flag (optional) */
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The device record's contact-loss flag (optional) */
  contactLost?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The serial of the Stone the session ran on, as the app read it. Optional. Same
   * as on Start: if it differs from the Start's, the Start's serial and crediting
   * are kept — ADR 0016, YOJO-3557.
   */
  deviceSerial?: InputMaybe<Scalars['String']['input']>;
  /** When the session ended */
  endTime: Scalars['DateTime']['input'];
  /** Same as on Start. If it differs from the Start, the Start's value is kept. */
  origin?: InputMaybe<VnsSessionOrigin>;
  /** Individual phases within the session */
  phases: Array<VnsPhaseInput>;
  /** Optional delay for post-vitals reminder (defaults to 30 minutes) */
  postVitalsReminderDelay?: InputMaybe<Scalars['Duration']['input']>;
  /** Session ID to end (received from startVnsSession) */
  sessionId: Scalars['String']['input'];
  /** Status of the session completion */
  status: VnsSessionStatus;
  /** Total duration of the session */
  totalDuration: Scalars['Duration']['input'];
};

export type EngagementProfile = {
  __typename: 'EngagementProfile';
  /**
   * Best scores are the highest scores achieved by the user across different metrics. These are
   * the personal bests that the user has achieved in various physiological metrics.
   */
  bestScores?: Maybe<BestScores>;
  /**
   * A biofeedback session is a recorded activity where the user engages in a specific task
   * and measures their vitals before and after the activity.
   */
  biofeedbackSessions: Array<BiofeedbackSession>;
  /**
   * Check-in sessions are recorded moments where the user logs their vitals, feelings, and
   * cognitive state. A user is expected to check in at least once a day.
   */
  checkinSessions: Array<CheckinSession>;
  engagementProfileId: Scalars['ID']['output'];
  finishedContent: Array<CustomActivityId | ExternalContentId | MobileWidgetId>;
  likedContent: Array<CustomActivityId | ExternalContentId | MobileWidgetId>;
  /** The user's onboarding session */
  onboardingSession?: Maybe<OnboardingSession>;
  /** Wellness scores for the user */
  scores: Array<Score>;
  /** All participant sessions for the user, where a session is defined as a single login period. */
  sessions30Days: Array<ParticipantSession>;
  startedContent: Array<CustomActivityId | ExternalContentId | MobileWidgetId>;
  /** All VNS therapy sessions recorded by the user */
  vnsSessions: Array<VnsSession>;
};


export type EngagementProfileBiofeedbackSessionsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type EngagementProfileCheckinSessionsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type EngagementProfileVnsSessionsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  sessionStates?: InputMaybe<Array<VnsSessionState>>;
};

/** Engagement statistics computed from the user's engagement profile. */
export type EngagementStats = {
  __typename: 'EngagementStats';
  currentProgram?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastAppActivity?: Maybe<Scalars['DateTime']['output']>;
  lastVnsSession?: Maybe<Scalars['DateTime']['output']>;
  totalVnsSessions: Scalars['Int']['output'];
};

/** Entitlement record representing access rights to the yojo system. */
export type Entitlement = {
  __typename: 'Entitlement';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who activated this entitlement (cross-context resolution). */
  activatedBy?: Maybe<Participant>;
  activatedByUserId?: Maybe<Scalars['String']['output']>;
  activationCode: Scalars['String']['output'];
  /** Billing status, orthogonal to the lifecycle status (driven by the subscription provider) */
  billingStatus?: Maybe<EntitlementBillingStatus>;
  /**
   * YOJO-2904 (ADR 0014) — Stripe's LIVE cancel_at_period_end flag (nullable): true when a pending
   * period-end cancellation is already scheduled (possibly by a prior session), so the Extend dialog can
   * disable Extend. Lazily resolved from the same Stripe read as currentPeriodEnd; null when there is no
   * subscription or Stripe is unreachable.
   */
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  /**
   * YOJO-2904 (ADR 0014) — the subscription's LIVE current_period_end from Stripe (nullable). Lazily
   * resolved: read (at most one Stripe call, shared with cancelAtPeriodEnd) ONLY when selected. Lets the
   * care-portal Extend dialog preview currentPeriodEnd + N months on a member's first extension. Null when
   * the entitlement has no subscription, or when Stripe is unreachable.
   */
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Status of the activation email sent for this entitlement */
  emailStatus?: Maybe<ActivationEmailStatus>;
  entitlementId: Scalars['ID']['output'];
  /**
   * YOJO-2976 [member sees their own plan] (plan ADR 0002 Amendment 1) — was this purchase a gift to its current
   * holder: true = gift, false = self-bought, null = unknown or never marked (a mark left by a previous holder also
   * reads null).
   * Admin / operations only: any other caller gets an authorization error.
   */
  gift?: Maybe<Scalars['Boolean']['output']>;
  /**
   * YOJO-2976 [member sees their own plan] — why gift reads as it does: email_hash_equal, email_hash_differs,
   * holder_has_no_email, buyer_has_no_email_hash or ops. Null when there is no
   * mark for the current holder. Admin / operations only.
   */
  giftBasis?: Maybe<Scalars['String']['output']>;
  /**
   * The most recent operator cancellation action (a cancel or a reverse), if any (null when never cancelled).
   * Convenience for the common care-portal case — the same data as the last element of subscriptionCancellations.
   */
  lastSubscriptionCancellation?: Maybe<SubscriptionCancellation>;
  /**
   * The most recent operator subscription extension, if any (null when never extended). Convenience for
   * the common care-portal case — the same data as the last element of subscriptionExtensions.
   */
  lastSubscriptionExtension?: Maybe<SubscriptionExtension>;
  /**
   * YOJO-2393 (ADR-0013) — device pre-registration overlay: the shipped serial recorded on this
   * entitlement ahead of pairing, with open (redeemable) or consumed (already linked) state.
   * Null when no serial was ever pre-registered.
   */
  preRegistration?: Maybe<DeviceSerialPreRegistration>;
  provisionedAt: Scalars['DateTime']['output'];
  status: EntitlementStatus;
  /**
   * YOJO-2866 (ADR 0014) — operator subscription-cancellation timeline (cancel + reverse facts interleaved;
   * audit-only, drives no billing lifecycle). Append-ordered (oldest first); empty when the subscription was
   * never operator-cancelled.
   */
  subscriptionCancellations: Array<SubscriptionCancellation>;
  /**
   * YOJO-2865/2867 (ADR 0014) — operator subscription-extension timeline (audit-only; drives no billing
   * lifecycle). Append-ordered (oldest first); empty when the subscription was never operator-extended.
   */
  subscriptionExtensions: Array<SubscriptionExtension>;
  /** External subscription ID (e.g., Stripe sub_xxx) */
  subscriptionId?: Maybe<Scalars['String']['output']>;
};

/**
 * Entitlement billing status, orthogonal to the lifecycle status.
 * Driven by the subscription provider (e.g., Stripe).
 */
export enum EntitlementBillingStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Incomplete = 'incomplete',
  None = 'none',
  PastDue = 'past_due',
  /**
   * Collection is paused: Stripe pause_collection set on a live subscription (active/trialing/past_due).
   * Stripe status "paused" is NOT covered. NOT paying, and the entitlement carries no next billing date
   * while paused (YOJO-2759).
   */
  Paused = 'paused',
  Trialing = 'trialing'
}

/** Entitlement lifecycle status. */
export enum EntitlementStatus {
  Active = 'active',
  Provisioned = 'provisioned',
  Revoked = 'revoked',
  Suspended = 'suspended'
}

/** The note to erase (YOJO-3118), in the caller's own journal. */
export type EraseJournalNoteInput = {
  /** The note's server id (jnote_…), as recordJournalNote answered it and journalNotes serves it. */
  noteId: Scalars['ID']['input'];
};

/**
 * Backend-governed catalogue of first-time experiences. Adding an entry is a deliberate
 * backend change (no free-form keys). v1 wires `session_guide`; `device_setup` and
 * `home_tour` are reserved for Phase 3.
 */
export enum ExperienceName {
  DeviceSetup = 'device_setup',
  HomeTour = 'home_tour',
  SessionGuide = 'session_guide'
}

/**
 * The governed, typed member experience-state surface. Per governed experience it exposes
 * ONE baked semantic value the client dispatches on — never a raw count, never the
 * underlying booleans for the client to combine.
 */
export type ExperienceState = {
  __typename: 'ExperienceState';
  /**
   * Reserved onboarding / stateful-progression container. Minimal in v1 (mirrors the
   * member's event-sourced onboarding status, read-only) so later onboarding enrichment is
   * additive, never a breaking restructure of this surface.
   */
  onboarding: OnboardingExperienceState;
  /**
   * Whether the VNS session guide should be shown. SHOW only for a member who has neither
   * been shown it nor ever completed a live in-app VNS session; SUPPRESS otherwise.
   */
  sessionGuide: ExperienceVisibility;
};

/** The single baked, client-dispatchable decision for a governed experience. */
export enum ExperienceVisibility {
  Show = 'show',
  Suppress = 'suppress'
}

/** Input for specifying columns to include in the export. */
export type ExportColumnsInput = {
  /**
   * List of column names to include in the export.
   * Allowed columns: customerId, email, segment, createdAt, amountPaid,
   * currency, entitlementStatus, activationCode, activatedAt
   */
  columns: Array<Scalars['String']['input']>;
};

/** Result of a CSV export operation. */
export type ExportResult = {
  __typename: 'ExportResult';
  /** CSV content (only present on success). */
  csv?: Maybe<Scalars['String']['output']>;
  /** Error message (only present on failure). */
  error?: Maybe<Scalars['String']['output']>;
  /** Number of records exported. */
  recordCount: Scalars['Int']['output'];
  /** Whether the export was successful. */
  success: Scalars['Boolean']['output'];
};

/**
 * Operator subscription EXTEND (YOJO-2865/2867, ADR 0014). Stripe-first, then a domain audit event —
 * unlike cancel (which records nothing on our side), extend records who/why/what on the Customer aggregate.
 */
export type ExtendMemberSubscriptionInput = {
  /** CRM customer (member) that owns the subscription. */
  customerId: Scalars['ID']['input'];
  /** How many months to push the renewal out (1..12; full-year comps stay manual). */
  months: Scalars['Int']['input'];
  /** Required audit note (>= 10 chars); stamped on the Stripe subscription metadata and the audit event. */
  reason: Scalars['String']['input'];
  /** The EXPLICIT Stripe subscription to extend; verified to belong to customerId (resolves the entitlement). */
  subscriptionId: Scalars['ID']['input'];
};

/**
 * Result of an operator subscription extension. Returns the Stripe-confirmed period boundaries so the
 * care-portal renders the new renewal date without a refetch (the durable record lands via the audit event).
 */
export type ExtendMemberSubscriptionResponse = {
  __typename: 'ExtendMemberSubscriptionResponse';
  months: Scalars['Int']['output'];
  /** The new renewal anchor (trial_end = previousPeriodEnd + months) set at Stripe. */
  newPeriodEnd: Scalars['DateTime']['output'];
  /** The subscription's current_period_end BEFORE the extension (nullable). */
  previousPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  subscriptionId: Scalars['ID']['output'];
};

/** What the Customer decided about one Stripe contact observation. */
export enum ExternalContactDisposition {
  Applied = 'applied',
  Stale = 'stale',
  Unchanged = 'unchanged'
}

/** One Stripe customer.updated the Customer recorded: names and decisions only, never values. */
export type ExternalContactObservation = {
  __typename: 'ExternalContactObservation';
  /** Top-level (billing) attributes Stripe reported changed: name, address, phone. */
  billingChanged: Array<Scalars['String']['output']>;
  /** Shipping (delivery) attributes Stripe reported changed: name, address, phone, block_added, block_removed. */
  deliveryChanged: Array<Scalars['String']['output']>;
  disposition: ExternalContactDisposition;
  fieldsToApply: Array<CustomerContactField>;
  observedAt: Scalars['DateTime']['output'];
  providerEventId: Scalars['String']['output'];
  staleFields: Array<CustomerContactField>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
};

/** Reference to external CMS content */
export type ExternalContentId = ContentReference & {
  __typename: 'ExternalContentId';
  cms: Cms;
  contentType: ContentType;
  hydratedContent?: Maybe<ActivityVideo | Article | ArticleTeaser | CustomActivity | DojoArticle | DojoChecklist | DojoNugget | DojoQuiz | DojoQuote | JourneyVideo | Lesson | MobileWidget | Story | StoryTeaser | VideoTeaser>;
  reference: Scalars['String']['output'];
};

export type ExternalContentIdInput = {
  cms: Cms;
  contentType: ContentType;
  reference: Scalars['String']['input'];
};

export type FeeDetail = {
  __typename: 'FeeDetail';
  amountInCents: Scalars['Long']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/**
 * A member's thumbs reaction to a Member Health Report component or to the report as a whole
 * (YOJO-1947, the report's learning loop). A `down` REQUIRES a reasonCode; `up` does not.
 */
export enum FeedbackReaction {
  Down = 'down',
  Up = 'up'
}

/**
 * The structured "why" attached to a thumbs-DOWN (required for `down`, never sent with `up`).
 * The product vocabulary is not-relevant | confusing | too-clinical | already-knew | don't-trust;
 * GraphQL enum identifiers cannot contain hyphens or apostrophes, so each maps to a snake-cased value:
 * not_relevant, confusing, too_clinical, already_knew, dont_trust.
 */
export enum FeedbackReasonCode {
  AlreadyKnew = 'already_knew',
  Confusing = 'confusing',
  DontTrust = 'dont_trust',
  NotRelevant = 'not_relevant',
  TooClinical = 'too_clinical'
}

/** A single feeling measurement taken during a checkin session */
export type FeelingMeasurement = {
  __typename: 'FeelingMeasurement';
  /** When the measurement was taken */
  recordedAt: Scalars['DateTime']['output'];
  /** Source of the measurement */
  source: MetricSource;
  /** Type of feeling being measured */
  type: FeelingType;
  /** The measured value, must be between 0 and 10 */
  value: Scalars['Float']['output'];
};

/** Input for recording a feeling measurement */
export type FeelingMeasurementInput = {
  /** When the measurement was taken */
  recordedAt: Scalars['DateTime']['input'];
  /** Source of the measurement */
  source: MetricSource;
  /** Type of feeling being measured */
  type: FeelingType;
  /** The measured value */
  value: Scalars['Float']['input'];
};

/** Represents a subjective feeling or state measurement */
export type FeelingMetric = BaseMetric & {
  __typename: 'FeelingMetric';
  /** Optional additional details or notes */
  details?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the metric */
  id: Scalars['ID']['output'];
  /** ID of the originating activity or session */
  originId?: Maybe<Scalars['String']['output']>;
  /** When the feeling was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** Source of the measurement */
  source: MetricSource;
  /** Type of feeling measurement */
  type: FeelingType;
  /** User who recorded the metric */
  userId: Scalars['String']['output'];
  /** Numeric value representing the intensity/level */
  value: Scalars['Float']['output'];
};

/** Types of subjective feelings that can be recorded */
export enum FeelingType {
  /** Morning check-in: How energized do you feel? */
  Energized = 'energized',
  /** Morning check-in: How rested do you feel? */
  Rested = 'rested',
  /** Morning check-in: How tense do you feel? */
  Tense = 'tense'
}

export type File = Media & {
  __typename: 'File';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * Customer Financial Data (Slice 20 enrichment)
 * Extends Customer type with financial summary and transaction history
 */
export type FinancialSummary = {
  __typename: 'FinancialSummary';
  currency: Scalars['String']['output'];
  disputeAmountInCents: Scalars['Long']['output'];
  disputeCount: Scalars['Int']['output'];
  hasActualFees: Scalars['Boolean']['output'];
  refundCount: Scalars['Int']['output'];
  refundRate?: Maybe<Scalars['BigDecimal']['output']>;
  totalFeesInCents: Scalars['Long']['output'];
  totalNetInCents: Scalars['Long']['output'];
  totalPaidInCents: Scalars['Long']['output'];
  totalRefundedInCents: Scalars['Long']['output'];
  transactionCount: Scalars['Int']['output'];
};

/** Command for finishing content */
export type FinishContentCommand = {
  /** Content to finish */
  contentId: ContentReferenceInput;
  /**
   * When the content was finished (optional).
   *
   * Defaults to current time if not provided.
   */
  recordedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional source indicating where this content engagement originated from */
  source?: InputMaybe<ContentSource>;
  /** Time spent on this content in minutes */
  timeSpent: Scalars['Duration']['input'];
};

export enum FlagStatus {
  EscalateToDoctor = 'escalate_to_doctor',
  FollowUpNeeded = 'follow_up_needed',
  NeedsReview = 'needs_review',
  None = 'none',
  Urgent = 'urgent'
}

/**
 * A server-side capability gate CALL-SITE — where the server checks a capability, named so an admin can
 * switch gates on one at a time (B-49). Not a capability: `content_personal_journals` is what a member
 * holds, `daily_journal` is where it is checked. A gate is LIVE for a member iff its key is in
 * `CapabilitySettings.enforcedGates` AND (`CapabilitySettings.enforcementActive` OR the member is a Stone
 * Access tester, YOJO-3332); absent from the list = dormant for everyone, exactly legacy behaviour.
 */
export enum GateKey {
  /** The care-team chat pause: a member without coach_access reads their care chat as paused (history kept, cannot post). */
  CareChat = 'care_chat',
  /** The custom / annual report generator (reserved — no surface yet). */
  CustomReport = 'custom_report',
  /**
   * The member's own daily journal — the dailyJournal query only (the retired
   * recordDaily* mutations are refused before it). The journal notes
   * (journalNotes, recordJournalNote, eraseJournalNote) never take this gate:
   * every plan writes notes (YOJO-3118 D1 A).
   */
  DailyJournal = 'daily_journal',
  /** The history-depth clamp on a member's own vitals reads (data_history_full). */
  DataHistory = 'data_history',
  /** The quarterly report producer (reserved — no surface yet). */
  QuarterlyReport = 'quarterly_report',
  /** The face-scan length at every member scan write path the daily scan limit gates (not the deprecated one-time onboarding): a scan longer than 30 s needs face_scan_supercharged. */
  ScanDuration = 'scan_duration',
  /** The member-facing scan-metric read filter (withholds un-held scan metrics from own reads). */
  ScanMetricRead = 'scan_metric_read',
  /** The scans-per-day dial at every scan-submitting engagement mutation. */
  ScansPerDay = 'scans_per_day'
}

/** Gender enumeration */
export enum Gender {
  Female = 'female',
  Male = 'male',
  PreferNotToSay = 'prefer_not_to_say'
}

/** Cohort data for a specific gender */
export type GenderCohort = {
  __typename: 'GenderCohort';
  /** Area Under Curve summary for this gender group's percentage change trend */
  auc?: Maybe<CohortAuc>;
  /** Time series data points for this gender group */
  dataPoints: Array<CohortAnalysisDataPoint>;
  /** The gender this cohort represents */
  gender: Gender;
  /** Number of users in this gender group */
  userCount: Scalars['Int']['output'];
};

/**
 * The member's goal beside the care team's reading of them (YOJO-3288). Care team only: served on
 * Participant.goalOverview to nurses and admins, never on Preferences. The member's own goal is on
 * Preferences.memberGoal.
 */
export type GoalOverview = {
  __typename: 'GoalOverview';
  /** The primary health area the care team recorded for the member. Empty when they have recorded none */
  careTeamPrimary?: Maybe<CareTeamReading>;
  /**
   * The secondary health area the care team recorded for the member. Empty when
   * they have recorded none. It never becomes the effective goal
   */
  careTeamSecondary?: Maybe<CareTeamReading>;
  /**
   * The goal that applies: the member's own goal when they have one, otherwise the
   * care team's primary health area. Empty when there is neither
   */
  effectiveGoal?: Maybe<EffectiveGoal>;
  /**
   * True when the member picked their goal after the care team last recorded a
   * health area, so the care team's reading may need a fresh look
   */
  memberStatedAfterCareTeam: Scalars['Boolean']['output'];
};

/**
 * Comp a capability to one member. There is no holderId: it is derived server-side from subjectId, so a
 * retried comp lands on the same ledger and no client can address someone else's by guessing an id.
 */
export type GrantCompCapabilityInput = {
  /** What they get. The enum is code-shipped, so the UI can only compose capabilities that exist. */
  capabilities: Array<Capability>;
  /** Optional time-box. Null means the comp lasts until it is revoked. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The ticket or actor reference this comp is booked against. REQUIRED — it is the audit trail, and
   * it is the key the matching revoke refcounts on.
   */
  sourceRef: Scalars['ID']['input'];
  /** The member being comped. */
  subjectId: Scalars['ID']['input'];
};

/**
 * Comp a whole TIER to one member (YOJO-2555 [manual grant admin]). There is no holderId and no
 * sourceRef: the holder is derived from subjectId and the ref from ticketRef (or minted), so a client can
 * neither address someone else's ledger nor collide with a ref it does not own.
 */
export type GrantCompPackageInput = {
  /** Optional time-box. Null means the comp lasts until it is revoked. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The tier they get — must name a defined, non-archived package. */
  packageKey: Scalars['ID']['input'];
  /**
   * Why. REQUIRED, and persisted on the event with the granting identity — a ticket id points into a
   * system that may not outlive the grant, this is the sentence a person reads in a year's time.
   */
  reason: Scalars['String']['input'];
  /** The member being comped. */
  subjectId: Scalars['ID']['input'];
  /**
   * Optional ticket reference. When supplied it becomes the refcount key, which makes the comp
   * idempotent and gives the revoke something a human can retype.
   */
  ticketRef?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Grant ONE member a CUSTOM inline set (YOJO-2598 [custom capability grants]) — capabilities and/or
 * dials, with no package behind them.
 *
 * There is no holderId and no sourceRef: the holder is derived from subjectId and the ref from the
 * CONTENTS (`custom_{hash}`), so a redelivered grant — or a double-clicked form — mints exactly one row,
 * and no client can address someone else's ledger or collide with a key it does not own.
 *
 * `capabilities` and `dials` are BOTH optional and at least one must be non-empty. Either alone is a real
 * grant ("two more scans a day and nothing else"); both empty is refused with an error naming both
 * fields, because a grant that gives nothing still reads as "they were given something" on every screen
 * that lists it.
 */
export type GrantCustomCapabilitiesInput = {
  /** The frozen set. The enum is code-shipped, so the UI can only compose capabilities that exist. */
  capabilities?: InputMaybe<Array<Capability>>;
  /**
   * The numeric dials. `-1` is unlimited and beats every number in the member's MAX; omitting a dial
   * leaves their other sources to decide it. Additive only — a custom dial can never cap anything.
   */
  dials?: InputMaybe<Array<PackageDialInput>>;
  /**
   * Optional time-box. Null means until revoked; when set, the ordinary nightly sweep expires it and the
   * grant reads inactive from the instant it passes, sweep or no sweep.
   */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Why. REQUIRED, and persisted on the event with the granting identity — a custom set names no tier
   * anybody can look up later, so this sentence is the only thing that will explain it.
   */
  reason: Scalars['String']['input'];
  /** The member being granted. */
  subjectId: Scalars['ID']['input'];
  /**
   * Optional ticket reference. When supplied it becomes the refcount key instead of the content-derived
   * one. Absent is the normal case and is still idempotent — the derived ref does that job.
   */
  ticketRef?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Where a grant came from — half of the refcount key a revoke matches on (domain-model.md §2, P2).
 *
 * There is deliberately NO `floor` value: the Free floor is resolved from settings, never granted, which
 * is what makes it structurally un-revokable (ADR-0001).
 */
export enum GrantSource {
  /** An ops comp — audited and reversible. */
  Comp = 'comp',
  /**
   * A per-member CUSTOM inline set (YOJO-2598 [custom capability grants]) — capabilities and/or dials
   * granted directly to one member, with no package behind them and a mandatory reason.
   *
   * The only grant kind that carries `dials`, and the only one revoked by ROW id
   * (`revokeCustomCapabilityGrant`) rather than by ref. `revokeCompCapability` can never touch one, and
   * this can never touch a comp — the narrow blast radius is the feature.
   */
  Custom = 'custom',
  /** Preserved on a package shrink or the D7 migration — a frozen set no later edit can shrink. */
  Grandfather = 'grandfather',
  /** Paid — the member's recurring money is on a price bound to this package. */
  Subscription = 'subscription',
  /** The device bundle's free months. Always carries an expiry. */
  Trial = 'trial'
}

/** The member's E1 baseline summary. */
export type HabituationBaseline = {
  __typename: 'HabituationBaseline';
  /** The per-metric baselines that were computed (only metrics that appeared). */
  metrics: Array<HabituationMetricBaseline>;
  /** Total readings in the baseline window (present even when not sufficient). */
  readingCount: Scalars['Int']['output'];
  /** Whether the reading count met the baseline minimum. */
  sufficient: Scalars['Boolean']['output'];
};

/**
 * The de-identified cohort roll-up (overview decisions 3 & 10). Safe by SHAPE: this type carries NO
 * member id/name/email field anywhere — the analyst tier cannot leak an identity because there is no
 * field to carry one.
 */
export type HabituationCohort = {
  __typename: 'HabituationCohort';
  /** Median duration (weeks) of return episodes; null when fewer than two exist. */
  medianDriftToBaselineWeeks?: Maybe<Scalars['Float']['output']>;
  /** Median duration (weeks) of drift episodes; null when fewer than two exist. */
  medianPlateauToDriftWeeks?: Maybe<Scalars['Float']['output']>;
  /** Members whose state is insufficient_baseline (not yet evaluable). */
  notEvaluableInsufficientBaseline: Scalars['Int']['output'];
  /** Members whose state is no_plateau (not yet evaluable). */
  notEvaluableNoPlateau: Scalars['Int']['output'];
  /** One anonymous scatter point per plateaued member. */
  quadrant: Array<HabituationQuadrantPoint>;
  /** Count of members currently in each state (all states, including zeros). */
  stateCounts: Array<HabituationStateCount>;
  /** The threshold-set the cohort was computed under (e.g. hsp-v0.2). */
  thresholdsVersion: Scalars['String']['output'];
  /** One anonymous plateau-aligned trajectory per plateaued member. */
  trajectories: Array<HabituationTrajectory>;
};

/** A drift/return episode below a plateau. */
export type HabituationEpisode = {
  __typename: 'HabituationEpisode';
  /** P − min(14-day mean over the episode), in z. */
  depth: Scalars['Float']['output'];
  durationWeeks: Scalars['Int']['output'];
  endWeek: Scalars['Int']['output'];
  /** drift or return. */
  kind: Scalars['String']['output'];
  startWeek: Scalars['Int']['output'];
};

/** The nurse/admin per-member detail — the Figure-1 triptych's data plus the optional overnight overlay. */
export type HabituationMemberDetail = {
  __typename: 'HabituationMemberDetail';
  baseline: HabituationBaseline;
  episodes: Array<HabituationEpisode>;
  memberId: Scalars['ID']['output'];
  /** The optional weekly overnight-RMSSD overlay (empty when the member has no wearable). */
  overnight: Array<HabituationOvernightWeek>;
  /** The called plateau (level P + week), or null if never plateaued. */
  plateau?: Maybe<HabituationPlateau>;
  state: HabituationState;
  /** The CUSUM-style tally series aligned to weeks (a value only — never a trigger). */
  tally: Array<Scalars['Float']['output']>;
  thresholdsVersion: Scalars['String']['output'];
  weeks: Array<HabituationWeeklyRow>;
};

/** One row of the nurse/admin member table (identified — nurse/admin only). */
export type HabituationMemberSummary = {
  __typename: 'HabituationMemberSummary';
  /** The most recent covered 14-day mean (z), or null if none. */
  currentMean14?: Maybe<Scalars['Float']['output']>;
  /** The depth (P − min) of the most recent episode (z), or null if none. */
  depth?: Maybe<Scalars['Float']['output']>;
  memberId: Scalars['ID']['output'];
  /** The plateau level P (z above baseline), or null if never plateaued. */
  plateauLevel?: Maybe<Scalars['Float']['output']>;
  /** ISO-8601 date the current state run began (best-effort). */
  since?: Maybe<Scalars['String']['output']>;
  state: HabituationState;
  thresholdsVersion: Scalars['String']['output'];
  /** The F1 exposure ratio as of the last week, or null if never plateaued. */
  useRatio?: Maybe<Scalars['Float']['output']>;
};

/** One ARI metric's E1 baseline (median = z 0, plus raw MAD). */
export type HabituationMetricBaseline = {
  __typename: 'HabituationMetricBaseline';
  mad: Scalars['Float']['output'];
  median: Scalars['Float']['output'];
  /** The metric key: ln_rmssd / heart_rate / stress_index. */
  metric: Scalars['String']['output'];
  presentCount: Scalars['Int']['output'];
};

/**
 * One week of the optional overnight-baseline overlay — weekly median wearable RMSSD from gold_sleep.
 * Visually separate from the ARI and NEVER used to confirm or veto a state.
 */
export type HabituationOvernightWeek = {
  __typename: 'HabituationOvernightWeek';
  /** The week's median overnight RMSSD (ms). */
  medianRmssd?: Maybe<Scalars['Float']['output']>;
  /** The wearable provider for the week (whoop / oura / apple …). */
  provider?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 date the wearable week starts. */
  weekStart?: Maybe<Scalars['String']['output']>;
};

/** The member's called plateau: level P and the week it was first armed. */
export type HabituationPlateau = {
  __typename: 'HabituationPlateau';
  level: Scalars['Float']['output'];
  weekIndex: Scalars['Int']['output'];
};

/** One anonymous point on the four-quadrant scatter for a plateaued member (no identifier). */
export type HabituationQuadrantPoint = {
  __typename: 'HabituationQuadrantPoint';
  /** The member's current 14-day mean minus their own plateau level P (z above baseline). */
  responseDelta: Scalars['Float']['output'];
  state: HabituationState;
  /** The F1 exposure ratio: trailing 4-week use ÷ (avg plateau-period sessions/week × 4). */
  useRatio: Scalars['Float']['output'];
};

/**
 * The habituation operational (E15) state (YOJO-2876 / YOJO-2880). Lowercase wire values matching the
 * Java enum constants; every payload also names the threshold version it was computed under.
 */
export enum HabituationState {
  /** From plateau: the same shortfall but use fell (F1 failed) — not habituation. */
  Disengaging = 'disengaging',
  /** From plateau: the response faded while use held (F1 passed) — observe, do not act yet. */
  Drifting = 'drifting',
  /** Baseline established, no plateau yet, day 84 not reached. */
  Improving = 'improving',
  /** Fewer than the baseline-minimum readings in the first baseline-window days. */
  InsufficientBaseline = 'insufficient_baseline',
  /** Day 84 reached without ever calling a plateau (reported honestly). */
  NoPlateau = 'no_plateau',
  /** A plateau has been called (or re-armed) at level P. */
  Plateau = 'plateau',
  /** From drifting: the gains eroded back to baseline. */
  ReturnedToBaseline = 'returned_to_baseline'
}

/** One state tile of the cohort roll-up: how many members are currently in this state. */
export type HabituationStateCount = {
  __typename: 'HabituationStateCount';
  count: Scalars['Int']['output'];
  state: HabituationState;
};

/** One member's anonymous plateau-aligned trajectory. */
export type HabituationTrajectory = {
  __typename: 'HabituationTrajectory';
  points: Array<HabituationTrajectoryPoint>;
};

/** One point of a plateau-aligned trajectory. Blank (uncovered) weeks are omitted, never zero-filled. */
export type HabituationTrajectoryPoint = {
  __typename: 'HabituationTrajectoryPoint';
  /** The week's 14-day mean minus the member's own plateau level P (z). */
  ariMinusP: Scalars['Float']['output'];
  /** Weeks since the member's plateau week (0 = the plateau week). */
  weekSincePlateau: Scalars['Int']['output'];
};

/** One fixed 7-day week of the member's trajectory. A blank (F8-failing) week has null ari and mean14. */
export type HabituationWeeklyRow = {
  __typename: 'HabituationWeeklyRow';
  ari?: Maybe<Scalars['Float']['output']>;
  f8Pass: Scalars['Boolean']['output'];
  mean14?: Maybe<Scalars['Float']['output']>;
  meanIntensity?: Maybe<Scalars['Float']['output']>;
  readings: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  state: HabituationState;
  weekIndex: Scalars['Int']['output'];
  /** ISO-8601 instant the week starts. */
  weekStartDate?: Maybe<Scalars['String']['output']>;
};

/**
 * The trajectory window for the cohort roll-up, measured in weeks SINCE the member's plateau (not the
 * rolling date range).
 */
export enum HabituationWindow {
  /** Every covered week since plateau. */
  All = 'ALL',
  /** The first 12 weeks since plateau. */
  Weeks_12 = 'WEEKS_12',
  /** The first 26 weeks since plateau. */
  Weeks_26 = 'WEEKS_26',
  /** The first 52 weeks since plateau. */
  Weeks_52 = 'WEEKS_52'
}

export type HeadingBlock = {
  __typename: 'HeadingBlock';
  text: Scalars['String']['output'];
};

/** Input type for height measurements */
export type Height = {
  __typename: 'Height';
  unit: HeightUnit;
  value: Scalars['Int']['output'];
};

/** Input type for height measurements */
export type HeightInput = {
  unit: HeightUnit;
  value: Scalars['Int']['input'];
};

export enum HeightUnit {
  Cm = 'cm',
  Inch = 'inch'
}

/** Where a member's own visible history starts, and whether anything older is kept (YOJO-3379). */
export type HistoryWindow = {
  __typename: 'HistoryWindow';
  /**
   * The first day (yyyy-MM-dd, the member's own day) their history reads return — exactly where the
   * reads start. Null = nothing is limited: the member sees all their history.
   */
  from?: Maybe<Scalars['Date']['output']>;
  /**
   * True when the history is limited AND the member has own records older than `from`. Those records
   * are kept, and return on a paid plan. Always false when `from` is null. Wearable sleep counts: it is
   * checked last, and a failed check answers as if there were no older sleep. A height never counts: the
   * window never hides it.
   */
  olderDataKept: Scalars['Boolean']['output'];
};

export type IdentityInformation = {
  __typename: 'IdentityInformation';
  ageBracket?: Maybe<AgeBracket>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  /**
   * We may not know the exact date of birth, since
   * the user may have only provided the year of birth
   */
  yearOfBirth?: Maybe<Scalars['Int']['output']>;
};

export type Image = Media & {
  __typename: 'Image';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ImageCenteredBlock = {
  __typename: 'ImageCenteredBlock';
  altText: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
};

export type ImageWithHeadingBlock = {
  __typename: 'ImageWithHeadingBlock';
  altText: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
};

export type ImageWithSubheadingBlock = {
  __typename: 'ImageWithSubheadingBlock';
  altText: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  subheading: Scalars['String']['output'];
};

export enum ImpactedVital {
  ActiveEnergy = 'active_energy',
  BloodPressure = 'blood_pressure',
  BodyMassIndex = 'body_mass_index',
  BreathingRate = 'breathing_rate',
  CardiacWorkload = 'cardiac_workload',
  Emotions = 'emotions',
  HeartRate = 'heart_rate',
  HeartRateVariability = 'heart_rate_variability',
  Height = 'height',
  MenstruationCycle = 'menstruation_cycle',
  Moods = 'moods',
  ParasympatheticActivity = 'parasympathetic_activity',
  Sleep = 'sleep',
  Steps = 'steps',
  StressIndex = 'stress_index',
  WalkingRunningDistance = 'walking_running_distance',
  Weight = 'weight'
}

export type ImportantNoteBlock = {
  __typename: 'ImportantNoteBlock';
  note: Scalars['String']['output'];
};

/**
 * Input for `initiateBroadcast`. The recipient resolver runs server-side; the
 * client only supplies the selection rule + message body. The broadcastId is
 * optional (server generates if absent) but exposed so the client can choose
 * it ahead of time for idempotency (re-firing with the same ID is a no-op).
 */
export type InitiateBroadcastInput = {
  body: Scalars['String']['input'];
  broadcastId?: InputMaybe<Scalars['ID']['input']>;
  selection: BroadcastSelectionInput;
};

/**
 * Input for initiateBulkAssignment. The recipient resolver runs server-side.
 * The bulkAssignmentId is optional (server generates if absent) but exposed so
 * the care-portal Review modal can pick a deterministic `bla_<uuid>` up front
 * for idempotency (locked decision #21).
 *
 * YOJO-1817 — initiate is now the composer one-click prepare+approve. It dispatches
 * a PrepareBulkAssignmentCommand; autoApprove (default true) makes prepare and
 * approve atomic so the fan-out fires immediately on Approved.
 */
export type InitiateBulkAssignmentInput = {
  /**
   * When true (default), prepare and approve atomically (composer one-click). When
   * false, stop at prepared and await an explicit approve.
   */
  autoApprove?: Scalars['Boolean']['input'];
  bulkAssignmentId?: InputMaybe<Scalars['ID']['input']>;
  payload: SingleContentPayloadInput;
  selection: BulkAssignmentSelectionInput;
};

export type InitiateReturnInput = {
  performedBy: Scalars['String']['input'];
  returnCarrier?: InputMaybe<Scalars['String']['input']>;
  returnTrackingNumber?: InputMaybe<Scalars['String']['input']>;
  serviceCaseId: Scalars['ID']['input'];
};

/** Common response type for mutations */
export type InputAcceptedResponse = {
  __typename: 'InputAcceptedResponse';
  /** Identifier for tracking the operation */
  id: Scalars['ID']['output'];
};

/** Categories for check-in insights */
export enum InsightCategory {
  Cardiovascular = 'cardiovascular',
  /**
   * Deprecated: cognitive testing removed. Kept for backward-compatible event replay.
   * @deprecated Cognitive testing removed
   */
  Cognitive = 'cognitive',
  NervousSystem = 'nervous_system',
  TargetVitals = 'target_vitals'
}

/** Priority levels for check-in insights */
export enum InsightPriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type IntensityBandEntry = {
  __typename: 'IntensityBandEntry';
  avgHrvDelta?: Maybe<Scalars['Float']['output']>;
  band: Scalars['String']['output'];
  maxIntensity: Scalars['Int']['output'];
  minIntensity: Scalars['Int']['output'];
  sampleSize: Scalars['Int']['output'];
};

/** The intensity curve: one value per intensity level 0 to 30. */
export type IntensityCurve = {
  __typename: 'IntensityCurve';
  levels: Array<Scalars['Int']['output']>;
};

export type Interaction = {
  __typename: 'Interaction';
  actor: Actor;
  actorId: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  importance: InteractionImportance;
  interaction: Scalars['String']['output'];
  targetId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export enum InteractionImportance {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type InteractionTimeline = {
  __typename: 'InteractionTimeline';
  interactions: Array<Interaction>;
};

/** Input for filtering interaction timeline */
export type InteractionTimelineFilter = {
  dateRange: DateRangeInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum InterventionType {
  Proactive = 'proactive',
  Reactive = 'reactive',
  ReactiveAndProactive = 'reactive_and_proactive'
}

/** Type of issue for a service case. */
export enum IssueType {
  DeviceReturn = 'device_return',
  LostShipment = 'lost_shipment',
  Replacement = 'replacement'
}

/**
 * One note in a member's journal (YOJO-3118). Only the member reads their notes; staff screens show at most that a
 * note was added.
 */
export type JournalNote = {
  __typename: 'JournalNote';
  /** The note's server id (jnote_…), as recordJournalNote answered it. */
  noteId: Scalars['ID']['output'];
  noteText: Scalars['String']['output'];
  /** Where the note came from; null = a standalone note. */
  origin?: Maybe<JournalNoteOrigin>;
  /** The VNS session or check-in the note is about, when it has one. */
  originRef?: Maybe<Scalars['ID']['output']>;
  /** When the member wrote it, on their own clock. */
  writtenAt: Scalars['DateTime']['output'];
};

/** Where a journal note came from. */
export enum JournalNoteOrigin {
  CheckIn = 'check_in',
  Coach = 'coach',
  VnsSession = 'vns_session'
}

export type JourneyVideo = BaseArticle & BaseVideo & CmsDocument & Content & {
  __typename: 'JourneyVideo';
  biopsychosocialScores: Array<BiopsychosocialScore>;
  caption?: Maybe<VideoCaption>;
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  impactedVitals?: Maybe<Array<ImpactedVital>>;
  interventionType?: Maybe<InterventionType>;
  mediaType?: Maybe<MediaType>;
  metadata: Metadata;
  protocols?: Maybe<Array<Protocol>>;
  reviewer?: Maybe<Reviewer>;
  subprotocols?: Maybe<Array<Subprotocol>>;
  suggestedContentIds?: Maybe<Array<Scalars['String']['output']>>;
  thumbnail?: Maybe<Image>;
  /** Title of the article as defined in the CMS. */
  title: Scalars['String']['output'];
  userIntent?: Maybe<UserIntent>;
  videoFile?: Maybe<Video>;
};

/** C6 keep-going (CTA) — the always-present reinforcement at the foot of the report. */
export type KeepGoingPayload = {
  __typename: 'KeepGoingPayload';
  body: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  totalSessions: Scalars['Long']['output'];
};

/**
 * The canonical written definition of one KPI, served alongside the numbers so the dashboard can
 * show "what does this count?" behind an info icon. Defined in code next to the calculation.
 */
export type KpiDefinition = {
  __typename: 'KpiDefinition';
  /** The calculation specifics: inputs, exclusions, window, timestamp basis. */
  detail: Scalars['String']['output'];
  /** When the team last reviewed this definition. */
  lastReviewedAt?: Maybe<Scalars['Date']['output']>;
  /** Which KPI this describes. */
  metric: KpiMetric;
  /** The canonical code path that produced the number. */
  sourceOfTruth: Scalars['String']['output'];
  /** One plain-English sentence. */
  summary: Scalars['String']['output'];
};

/**
 * Identifies one of the eight canonical KPIs. Used as the key on KpiDefinition so the dashboard
 * can match each card to its definition.
 */
export enum KpiMetric {
  ActiveEngagement = 'active_engagement',
  Churn = 'churn',
  GrossRevenue = 'gross_revenue',
  NetRevenue = 'net_revenue',
  PayingMembers = 'paying_members',
  PercentStartedVns = 'percent_started_vns',
  TotalMembers = 'total_members',
  VnsSessionsCompleted = 'vns_sessions_completed'
}

/** Represents a learning journey containing ordered learning paths */
export type LearningJourney = {
  __typename: 'LearningJourney';
  /** If true, this journey will be automatically assigned to users during onboarding */
  assignDuringOnboarding: Scalars['Boolean']['output'];
  /** List of user IDs currently assigned to this journey */
  assignedUserIds: Array<Scalars['ID']['output']>;
  /**
   * Average time in seconds users take to complete this journey
   * Calculated across all users who have completed the journey
   */
  averageCompletionTimeSeconds: Scalars['Int']['output'];
  /** Number of paths the current user has fully completed */
  completedPaths: Scalars['Int']['output'];
  /**
   * Total number of users who have completed the entire journey (100% progress)
   * @deprecated Use progressDistribution.completed instead
   */
  completedUserCount: Scalars['Int']['output'];
  /** When this journey was created */
  createdAt: Scalars['DateTime']['output'];
  /** Optional description of the learning journey's content and goals */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Percentage of assigned users actively engaging with the journey
   * Calculated as: (users with any progress / total assigned users) * 100
   */
  engagementRate: Scalars['Float']['output'];
  /** Timestamp of when the current user last accessed any content in this journey */
  lastAccessedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the learning journey */
  learningJourneyId: Scalars['ID']['output'];
  /** Name of the learning journey */
  name: Scalars['String']['output'];
  /**
   * Overall completion percentage (0-100) for the current user
   * Calculated as: (completed paths / total paths) * 100
   */
  progress: Scalars['Int']['output'];
  /**
   * Distribution of user progress across the journey
   * Shows how many users are in each stage (not started, in progress, completed)
   */
  progressDistribution: ProgressDistribution;
  /** Ordered list of learning paths that make up this journey */
  steps: Array<LearningJourneyStep>;
  /**
   * Total time in seconds the current user has spent on this journey's content
   * Includes time spent on all completed and in-progress paths
   */
  timeSpentSeconds: Scalars['Int']['output'];
  /** Total number of paths in this journey */
  totalPaths: Scalars['Int']['output'];
  /** When this journey was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Represents a single step (learning path) within a journey */
export type LearningJourneyStep = {
  __typename: 'LearningJourneyStep';
  /** The learning path associated with this step */
  learningPath: LearningPath;
  /** The order/position of this step in the journey sequence */
  order: Scalars['Int']['output'];
  /**
   * Current unlock status for a specific user
   * If userId is not provided, returns status for current user
   * Nurses can view status for any user, participants can only view their own
   */
  unlockStatus: UnlockStatus;
  /** Strategy determining when this step becomes available to users */
  unlockStrategy: UnlockStrategy;
};


/** Represents a single step (learning path) within a journey */
export type LearningJourneyStepUnlockStatusArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type LearningJourneyStepInput = {
  learningPathId: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
  unlockStrategy: UnlockStrategy;
};

/** Represents a learning path containing ordered educational content */
export type LearningPath = {
  __typename: 'LearningPath';
  /** Number of users currently assigned to this path */
  assignedUserCount: Scalars['Int']['output'];
  /** Average time in seconds users spend completing this path */
  averageCompletionTimeSeconds: Scalars['Int']['output'];
  /** List of content items that have been completed by a specific user */
  completedContentItems?: Maybe<Array<CustomActivityId | ExternalContentId | MobileWidgetId>>;
  /** Percentage of assigned users who have completed the path */
  completionRate: Scalars['Float']['output'];
  /** Ordered list of content items (articles, quizzes, etc.) in this path */
  contentItems?: Maybe<Array<CustomActivityId | ExternalContentId | MobileWidgetId>>;
  /** Distribution of different content types in the path */
  contentTypeDistribution: Array<ContentTypeCount>;
  /** When this path was created */
  createdAt: Scalars['DateTime']['output'];
  /** Optional description of the path's content and learning objectives */
  description?: Maybe<Scalars['String']['output']>;
  /** Number of learning journeys this path is part of */
  journeyCount: Scalars['Int']['output'];
  /** Unique identifier for the learning path */
  learningPathId: Scalars['ID']['output'];
  /** Name of the learning path */
  name: Scalars['String']['output'];
  /**
   * Distribution of user progress across the path
   * Shows how many users are in each stage (not started, in progress, completed)
   */
  progressDistribution: ProgressDistribution;
  /** When this path was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Represents a learning path containing ordered educational content */
export type LearningPathCompletedContentItemsArgs = {
  userId: Scalars['ID']['input'];
};

/** The answers of the earlier onboarding (before the four-question onboarding). Every value is optional. */
export type LegacyOnboardingAnswers = {
  __typename: 'LegacyOnboardingAnswers';
  /** User's age (deprecated) */
  age?: Maybe<Scalars['Int']['output']>;
  /** User's age bracket */
  ageBracket?: Maybe<AgeBracket>;
  /** Feeling measurements taken during onboarding */
  feelingMeasurements?: Maybe<Array<FeelingMeasurement>>;
  /** User's height */
  height?: Maybe<Height>;
  /** Lung test results */
  lungTest?: Maybe<LungTest>;
  /** User's overall health assessment */
  overallHealth?: Maybe<OverallHealth>;
  /** Vital measurements taken during onboarding */
  vitalMeasurements?: Maybe<Array<VitalMeasurement>>;
  /** User's weight */
  weight?: Maybe<Weight>;
};

export type Lesson = BaseArticle & CmsDocument & Content & {
  __typename: 'Lesson';
  biopsychosocialScores: Array<BiopsychosocialScore>;
  blocks?: Maybe<Array<Maybe<ContentBlock>>>;
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  impactedVitals?: Maybe<Array<ImpactedVital>>;
  interventionType?: Maybe<InterventionType>;
  mediaType?: Maybe<MediaType>;
  metadata: Metadata;
  protocols?: Maybe<Array<Protocol>>;
  reviewer?: Maybe<Reviewer>;
  subprotocols?: Maybe<Array<Subprotocol>>;
  thumbnail?: Maybe<Image>;
  /** Title of the article as defined in the CMS. */
  title: Scalars['String']['output'];
  userIntent?: Maybe<UserIntent>;
};

export type LessonProgress = {
  __typename: 'LessonProgress';
  lessonId: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
};

export type LessonProgressInput = {
  lessonId: Scalars['String']['input'];
  progress: Scalars['Int']['input'];
};

export type LessonsProgress = {
  __typename: 'LessonsProgress';
  lessonsProgress: Array<LessonProgress>;
  progressId: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export enum LifecycleMoment {
  DiagnosisConfirmed = 'diagnosis_confirmed',
  DiagnosticAid = 'diagnostic_aid',
  Login = 'login',
  Onboarding = 'onboarding',
  Signup = 'signup'
}

export enum LifecycleTiming {
  After = 'after',
  Before = 'before'
}

/** Command for liking content */
export type LikeContentCommand = {
  /** Content to like */
  contentId: ContentReferenceInput;
};

export type LinkReplacementShipmentInput = {
  performedBy: Scalars['String']['input'];
  replacementShipmentId: Scalars['ID']['input'];
  serviceCaseId: Scalars['ID']['input'];
};

/** How a membership was linked to a user */
export enum LinkingMethod {
  /** Automatically linked by email match */
  Automatic = 'AUTOMATIC',
  /** Auto-linked from a CRM entitlement (YOJO-1699) */
  CrmEntitlementLinked = 'CRM_ENTITLEMENT_LINKED',
  /** Manually linked by care team */
  Manual = 'MANUAL'
}

/** Input for logging a manual VNS session (retrospective, single-step) */
export type LogManualVnsSessionInput = {
  /** Session duration in minutes (required, 1-120 minutes) */
  durationMinutes: Scalars['Int']['input'];
  /** Intensity level 0-30 (required) */
  intensity: Scalars['Int']['input'];
  /** VNS mode used (required) */
  mode: VnsMode;
  /** When the session started (required, must be within last 2 weeks) */
  startTime: Scalars['DateTime']['input'];
};

/** Analysis of long-term trends over 0-13 weeks of VNS treatment */
export type LongTermTrendAnalysis = {
  __typename: 'LongTermTrendAnalysis';
  /** How session consistency affects outcomes */
  adherenceImpact?: Maybe<Scalars['String']['output']>;
  /** Vitals showing positive long-term trends */
  improvingVitals?: Maybe<Array<Scalars['String']['output']>>;
  /** Overall trend score (0-100) */
  longTermTrendScore?: Maybe<Scalars['Int']['output']>;
  /** Vitals that have stabilized */
  plateauedVitals?: Maybe<Array<Scalars['String']['output']>>;
  /** Description of overall long-term progress */
  trendSummary?: Maybe<Scalars['String']['output']>;
  /** Estimated weeks to next significant improvement */
  weeksToNextMilestone?: Maybe<Scalars['Int']['output']>;
};

export type LungTest = {
  __typename: 'LungTest';
  lungScore?: Maybe<Scalars['Int']['output']>;
  lungTestDurationSeconds?: Maybe<Scalars['Int']['output']>;
  recordedAt: Scalars['DateTime']['output'];
};

export type LungTestInput = {
  lungScore?: InputMaybe<Scalars['Int']['input']>;
  lungTestDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  recordedAt: Scalars['DateTime']['input'];
};

/** YOJO-2976 [member sees their own plan] — input for markEntitlementGift: the entitlement, the new mark and why. */
export type MarkEntitlementGiftInput = {
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  gift: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
};

export type MarkReturnReceivedInput = {
  inspectionNotes?: InputMaybe<Scalars['String']['input']>;
  performedBy: Scalars['String']['input'];
  receivedAt: Scalars['DateTime']['input'];
  serviceCaseId: Scalars['ID']['input'];
};

export type MarkReturnShippedInput = {
  performedBy: Scalars['String']['input'];
  returnCarrier: Scalars['String']['input'];
  returnTrackingNumber: Scalars['String']['input'];
  serviceCaseId: Scalars['ID']['input'];
};

/** Input for marking a shipment as shipped. */
export type MarkShipmentShippedInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  itemSerials?: InputMaybe<Scalars['JSON']['input']>;
  shipmentId: Scalars['ID']['input'];
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum MarkType {
  Em = 'em',
  Strong = 'strong'
}

/** Units used for measurements */
export enum MeasurementUnit {
  /**
   * For lung capacity test duration
   * Rate-based measurements
   */
  BeatsPerMinute = 'beats_per_minute',
  /** For heart rate */
  BreathsPerMinute = 'breaths_per_minute',
  /**
   * For blood pressure in millimeters of mercury
   * Distance measurements
   */
  Cm = 'cm',
  /** For height in centimeters */
  Inch = 'inch',
  /**
   * For height in inches
   * Weight measurements
   */
  Kg = 'kg',
  /** For weight in pounds */
  KgPerM2 = 'kg_per_m2',
  /** For weight in kilograms */
  Lb = 'lb',
  /**
   * For simple numeric values
   * Time-based measurements
   */
  Milliseconds = 'milliseconds',
  /**
   * For breathing rate
   * Pressure measurements
   */
  Mmhg = 'mmhg',
  /** Basic numbers */
  NaturalNumber = 'natural_number',
  /**
   * For 10-point scale ratings
   * Cognitive measurement units
   */
  Percentage = 'percentage',
  /**
   * For BMI in kg/m²
   * Subjective scale measurements
   */
  Scale_1_5 = 'scale_1_5',
  /** For 5-point scale ratings */
  Scale_1_10 = 'scale_1_10',
  /** For HRV measurements, reaction times and completion times */
  Seconds = 'seconds'
}

export type Media = {
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MediaType = {
  __typename: 'MediaType';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Image>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Everything ops needs about ONE member's capabilities (YOJO-2555 [manual grant admin], domain-model.md
 * §5) — the read behind the manual grant/revoke screen.
 *
 * Three answers to three different questions, and the GAP between them is the diagnosis:
 * `effectiveCapabilities` is what the member can actually do right now, `grants` is every reason they
 * were ever given anything, and `scheduledChanges` is what is booked to happen next. A capability that
 * appears in a live grant but NOT in the effective set is a hardware fact (the device intersection), not
 * a billing one — which is the difference between a device swap and a refund.
 *
 * A member with no grant ledger at all is a normal answer, not an error: `holderId` is null, `grants` is
 * empty, and `effectiveCapabilities` is the free floor intersected with their devices.
 */
export type MemberCapabilities = {
  __typename: 'MemberCapabilities';
  /**
   * (floor ∪ live grants) ∩ what their registered devices can execute — the SAME resolver the member's
   * own app calls, so this screen can never disagree with their phone.
   */
  effectiveCapabilities: Array<Capability>;
  /**
   * The NUMERIC limits in force for this member (YOJO-2559 [scans/day package dial]) — the MAX over
   * their floor package's dials, every live package grant's dials, and every live CUSTOM grant's dials
   * (YOJO-2598 [custom capability grants] — the -1 unlimited encoding applies there too). Frozen-set
   * individual grants (comp/grandfather) carry no dials.
   *
   * A dial ABSENT from this list is UNLIMITED, not zero, so an empty list means "no limits" — which is
   * the ordinary answer for the whole fleet until an admin dials a package. A dial PRESENT with the
   * value `-1` is unlimited too: one of the member's packages says so out loud (YOJO-2588 [B-43
   * unlimited dial value]). Support reads both as "no limit"; only `>= 0` is a number to spend.
   *
   * Admin/ops surface only: this is here so support can answer "why was my scan refused?" on the same
   * screen that answers "why can't I do X?". The MEMBER-facing contract is myProfile.allowances
   * (YOJO-3663 [members (and staff) read the member's plan allowances]): each allowance's limit, used,
   * remaining and reset, as the member reads it.
   */
  effectiveDials?: Maybe<Array<CapabilityPackageDial>>;
  /** Every grant, newest first, active AND historical — a revoked grant is usually the explanation. */
  grants: Array<MemberCapabilityGrant>;
  /** The member's grant ledger. Null when they have never been granted anything. */
  holderId?: Maybe<Scalars['ID']['output']>;
  /**
   * Per-capability PROVENANCE (YOJO-2598 [custom capability grants]) — for each EFFECTIVE capability,
   * EVERY live source that gives it: the floor, a named package, or an inline grant with its reason.
   *
   * A list per capability, not one source, because resolution is a UNION and the question underneath is
   * always "if I revoke this row, do they lose it?". A capability with two live sources survives losing
   * one of them, and only the full list says so. Capabilities the member holds but their DEVICE cannot
   * execute are absent here (they are in `grants`) — that gap is the device conversation.
   */
  provenance: Array<CapabilityProvenance>;
  /** Every booked change, soonest first, including terminal ones. */
  scheduledChanges: Array<MemberScheduledChange>;
  subjectId: Scalars['ID']['output'];
};

/**
 * One reason this member holds something (domain-model.md §2/§5).
 *
 * `packageKey` and `capabilities` are an XOR: a package grant follows the tier as an admin edits it, an
 * individual grant is a frozen set that no later package edit can shrink.
 */
export type MemberCapabilityGrant = {
  __typename: 'MemberCapabilityGrant';
  /**
   * Whether this grant COUNTS RIGHT NOW — not merely "was never revoked". Expiry is honoured at read
   * time, so a grant whose expiresAt passed at 03:00 is inactive from 03:00, whether or not the nightly
   * sweep has written that fact into history yet.
   */
  active: Scalars['Boolean']['output'];
  /** Set on an individual grant; null on a package one. */
  capabilities?: Maybe<Array<Capability>>;
  /**
   * The numeric dials THIS ROW carries (YOJO-2598 [custom capability grants]). Non-empty only on a
   * `custom` grant — no other grant kind has dials — and null everywhere else.
   *
   * Same client guardrail as everywhere a dial appears: absent is never zero, and `-1` is unlimited.
   * These merge into `effectiveDials` through the ordinary MAX, so a custom grant can only ever raise a
   * member's number, never cap it.
   */
  dials?: Maybe<Array<CapabilityPackageDial>>;
  /** Null means the grant lasts until it is revoked. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  grantId: Scalars['ID']['output'];
  grantedAt: Scalars['DateTime']['output'];
  /** The ops identity that granted it. Null on every background grant. */
  grantedBy?: Maybe<Scalars['ID']['output']>;
  /** Set on a package grant; null on an individual one. */
  packageKey?: Maybe<Scalars['ID']['output']>;
  /** Free text from the ops user who granted it. Null on every background grant. */
  reason?: Maybe<Scalars['String']['output']>;
  source: GrantSource;
  /** The refcount key a revoke matches on — what the screen's revoke button sends back. */
  sourceRef: Scalars['ID']['output'];
};

/**
 * The goal a member picks for themselves (YOJO-3286): the member's own choice, separate from the care team's reading.
 * The names mirror the Stone mode names, but a goal never picks a mode. "Not sure yet" is no goal.
 */
export enum MemberGoal {
  Balance = 'balance',
  Calm = 'calm',
  Energize = 'energize',
  Recover = 'recover',
  Sleep = 'sleep',
  Soothe = 'soothe'
}

/** The member's own goal and when they stated it (YOJO-3286). */
export type MemberGoalStatement = {
  __typename: 'MemberGoalStatement';
  /** The goal the member picked */
  goal: MemberGoal;
  /** When the member picked it */
  statedAt: Scalars['DateTime']['output'];
};

/**
 * The Member Health Report (YOJO-1894, epic YOJO-1882). A data-only payload — NO markup on the wire
 * (ADR-0005, D2); presentation is the my.yojo.health renderer's job. Recompute-on-view from BigQuery
 * gold (ADR-0004): no stored snapshot.
 */
export type MemberHealthReport = {
  __typename: 'MemberHealthReport';
  /** Whether a real report is offered (true) or this is the holding state (false). */
  available: Scalars['Boolean']['output'];
  /** The calm holding-state copy when NOT available; null when a report is offered. */
  holdingMessage?: Maybe<Scalars['String']['output']>;
  /** The detector verdict state (e.g. in_window, warming_up, out_of_window, lapsed, excluded). */
  lifecycleState: Scalars['String']['output'];
  /** The owning member (usr_…); reports are strictly own-data-only. */
  memberId: Scalars['ID']['output'];
  /** true when this report is shown via a preview window-bypass rather than a real in-window offering. */
  preview: Scalars['Boolean']['output'];
  /**
   * The deterministic synthetic report identity the feedback mutations (submitReportFeedback /
   * submitComponentFeedback) key on (YOJO-1882). Derived deterministically from the member + the
   * lifecycle window — re-viewing the SAME report yields the SAME id; a NEW uptick window yields a new
   * one. Null in the holding state (out-of-window): there is no report, hence no feedback target.
   */
  reportId?: Maybe<Scalars['String']['output']>;
  /** The ordered report zones when available; empty in the holding state (never a fixed card count). */
  sections: Array<ReportSection>;
};

/** The four-question onboarding (YOJO-3283): name, sex at birth, birthday and, optionally, a goal. */
export type MemberOnboardingInput = {
  /** The full birthday. */
  dateOfBirth: Scalars['Date']['input'];
  /** Sex at birth, as the onboarding screen asks it. Same list and same personal-data field as today. */
  gender: Gender;
  /** One of the six goals. Absent = "I'll choose a goal later": nothing is recorded. */
  goal?: InputMaybe<MemberGoal>;
  name: Scalars['String']['input'];
};

/** What the member gets, who pays, and whether it is running. Display only: never gate on it. */
export type MemberPlan = {
  __typename: 'MemberPlan';
  /** The dates and amounts this line needs. */
  details: PlanDetails;
  /** Payment you, on a price that is no longer the plan's current one. */
  legacyPrice: Scalars['Boolean']['output'];
  /** One step ahead; null when nothing changes. */
  next?: Maybe<PlanStep>;
  /** Who pays. */
  payment: PlanPayment;
  /** What the member gets. */
  plan: PlanTier;
  /** Whether it is running. */
  state: PlanState;
};

/**
 * One booked tier change (domain-model.md §3.2/§5, M3). Terminal changes are shown, not hidden: a change
 * that ended as `superseded` is exactly what explains "I booked a downgrade and it never happened".
 */
export type MemberScheduledChange = {
  __typename: 'MemberScheduledChange';
  changeId: Scalars['ID']['output'];
  effectiveAt: Scalars['DateTime']['output'];
  fromPackageKey: Scalars['ID']['output'];
  source: GrantSource;
  sourceRef: Scalars['ID']['output'];
  status: ScheduledChangeStatus;
  /** Null means down to the Free floor, which is resolved rather than granted. */
  toPackageKey?: Maybe<Scalars['ID']['output']>;
};

/** One mode on the member's device, in its slot. */
export type MemberStoneMode = {
  __typename: 'MemberStoneMode';
  /** The mode's description; null when it has none. */
  description?: Maybe<Scalars['String']['output']>;
  /** The name the member sees. */
  displayName: Scalars['String']['output'];
  /** Why it is locked; null when open. */
  lockReason?: Maybe<StoneModeLockReason>;
  /** The mode's id. */
  modeId: Scalars['ID']['output'];
  /** The current parameter set to write to the device; on open modes only, null on locked ones. */
  parameters?: Maybe<StimulationParameters>;
  /** The version of the mode's current parameter set, open or locked; null when it has none. */
  parametersVersion?: Maybe<Scalars['Int']['output']>;
  /** True only for the member's own personalised mode. */
  personalised: Scalars['Boolean']['output'];
  /** Its slot on the device: 0..n-1, the member's personalised mode first when offered. */
  slot: Scalars['Int']['output'];
  /** Whether the member may run it on this device now. */
  standing: StoneModeStanding;
  /**
   * Locked by the member's plan, and the member could change their plan to open it. False for everything else, and
   * when the plan cannot be known.
   */
  upgradeable: Scalars['Boolean']['output'];
};

/**
 * The default-mode setting as it reads now. Unusable when never set, or when it names a disabled mode or one without a
 * parameter set; then usable is false with a reason, and no other mode is named in its place.
 */
export type MemberStoneModeDefault = {
  __typename: 'MemberStoneModeDefault';
  /** The mode the setting names; null when it was never set. */
  modeId?: Maybe<Scalars['ID']['output']>;
  /** The default mode's current parameter set, when usable and the answer is for a Stone. */
  parameters?: Maybe<StimulationParameters>;
  /** The default mode's current parameter-set version, when usable and the answer is for a Stone. */
  parametersVersion?: Maybe<Scalars['Int']['output']>;
  /** Why it cannot be run (begins "no default set"); null when usable. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Whether the default can be run. */
  usable: Scalars['Boolean']['output'];
};

/**
 * A member's Stone modes on one device (YOJO-3261). The list never names a plan: a locked mode says why, and whether
 * the member could change their plan to open it.
 */
export type MemberStoneModes = {
  __typename: 'MemberStoneModes';
  /**
   * The catalogue's default mode. The setting is the same for every member; its settings (parametersVersion,
   * parameters) are served only for a Stone.
   */
  defaultMode: MemberStoneModeDefault;
  /** Which device the answer is for. */
  device: StoneModesDevice;
  /**
   * On a Stone answer: whether the member's plan includes a personalised mode. True with no personalised row in modes
   * means it is not set up (yet, or any more): their coach has not made one, or removed it. False when there is no
   * linked device of this generation, on an Alpha, or on an unknown device, even if the plan includes one, so false
   * never means the plan lacks one (YOJO-3100).
   */
  includesPersonalised: Scalars['Boolean']['output'];
  /**
   * The mode and parameter-set version the app last reported writing to the device this answer is for. Null until one
   * is recorded, and when no device is linked.
   */
  lastWritten?: Maybe<StoneModeWrite>;
  /** In slot order, 0..n-1 with no gap. A mode an admin disabled is absent. Empty for an unknown device. */
  modes: Array<MemberStoneMode>;
  /**
   * The open mode whose name is the member's goal; several → the lowest slot. Null when there is no goal, the goal
   * names only a locked mode, or no mode is open.
   */
  preselectedModeId?: Maybe<Scalars['ID']['output']>;
  /**
   * On a Stone answer: the allowed session length in minutes, from the catalogue's current session_length limit, both
   * inclusive; the same for every member. A mode's own parameters.sessionMinutes stays its default and may lie outside
   * a range tightened after the mode was saved. Null on any other answer (no linked device, an Alpha, an unknown
   * device) and when no session-length limit is set: offer the member no choice of length, run the mode's own
   * sessionMinutes (YOJO-3473 [member's Stone-modes read carries the allowed session-length range]).
   */
  sessionMinutesRange?: Maybe<SessionMinutesRange>;
};

/** Represents a membership purchased through Stripe */
export type Membership = {
  __typename: 'Membership';
  /** Stripe checkout session ID */
  checkoutSessionId?: Maybe<Scalars['String']['output']>;
  /** When the membership was created */
  createdAt: Scalars['DateTime']['output'];
  /** Customer's email from Stripe checkout */
  customerEmail?: Maybe<Scalars['String']['output']>;
  /** Customer's name from Stripe checkout */
  customerName?: Maybe<Scalars['String']['output']>;
  /** When the membership was linked to a user */
  linkedAt?: Maybe<Scalars['DateTime']['output']>;
  /** How the membership was linked to a user */
  linkingMethod?: Maybe<LinkingMethod>;
  /** Unique identifier for the membership */
  membershipId: Scalars['ID']['output'];
  nextBillingDate?: Maybe<Scalars['Date']['output']>;
  paymentAmount?: Maybe<Scalars['Long']['output']>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  /** Year 1 payment information */
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  /** CRM entitlement this membership derives from (YOJO-1699 per-entitlement re-key; null for legacy memberships) */
  sourceEntitlementId?: Maybe<Scalars['ID']['output']>;
  /** Current status of the membership */
  status?: Maybe<MembershipStatus>;
  /** Stripe customer ID */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Year 2+ subscription information */
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionStartDate?: Maybe<Scalars['Date']['output']>;
  subscriptionStatus?: Maybe<SubscriptionStatus>;
  /** User ID if linked to a user account (null if unlinked) */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Status of a membership */
export enum MembershipStatus {
  /** Membership is active and linked to a user account */
  Active = 'ACTIVE',
  /** Subscription was cancelled */
  Cancelled = 'CANCELLED',
  /** Membership has expired (past Year 1 and no active subscription) */
  Expired = 'EXPIRED',
  /** Membership is active but not linked to a user account */
  Unlinked = 'UNLINKED'
}

export enum MessageReadStatus {
  Read = 'read',
  Unread = 'unread'
}

export enum MessagingProvider {
  GetstreamIo = 'getstream_io'
}

export type MessagingToken = {
  __typename: 'MessagingToken';
  provider: MessagingProvider;
  token: Scalars['String']['output'];
};

export type Metadata = {
  __typename: 'Metadata';
  impactedVitals?: Maybe<Array<ImpactedVital>>;
  original: Scalars['Boolean']['output'];
  sourceCredit?: Maybe<SourceCredit>;
  sourcePermission?: Maybe<File>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type MetadataFilter = {
  /** Filter by content with specific vital impacts */
  hasSourceCredit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for original content only */
  originalOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Whether a metric improving means its value going up or down. */
export enum MetricDirection {
  Down = 'down',
  Up = 'up'
}

export type MetricInsight = {
  __typename: 'MetricInsight';
  createdAt: Scalars['DateTime']['output'];
  currentValue: Scalars['Float']['output'];
  historicAverage: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  metricId: Scalars['ID']['output'];
  priority: InsightPriority;
  recommendation: Scalars['String']['output'];
  recommendedContent: Array<CustomActivityId | ExternalContentId | MobileWidgetId>;
  title: Scalars['String']['output'];
  trend: MetricTrend;
  vitalType: VitalType;
};

/** One small-multiple panel: a metric's monthly trend with its direction and a caption. */
export type MetricPanel = {
  __typename: 'MetricPanel';
  caption: Scalars['String']['output'];
  direction: MetricDirection;
  improving: Scalars['Boolean']['output'];
  metric: Scalars['String']['output'];
  series: Array<MonthlyPoint>;
  slope: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

/** Source of the metric measurement */
export enum MetricSource {
  CognitiveTest = 'cognitive_test',
  PpgSensor = 'ppg_sensor',
  SelfReported = 'self_reported'
}

export enum MetricTrend {
  Decreasing = 'decreasing',
  Increasing = 'increasing',
  InsufficientData = 'insufficient_data',
  Stable = 'stable'
}

/** Collection of mindstate metrics for a user */
export type Mindstate = {
  __typename: 'Mindstate';
  /** List of recorded metrics */
  metrics: Array<MindstateMetric>;
  /** Unique identifier */
  mindstateId: Scalars['ID']['output'];
  /** User who owns these metrics */
  userId: Scalars['String']['output'];
};

/** A recorded mindstate metric */
export type MindstateMetric = {
  __typename: 'MindstateMetric';
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** When the metric was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** Category of metric */
  type: MindstateMetricType;
  /** User who recorded the metric */
  userId: Scalars['String']['output'];
  /** Recorded enum values */
  values: Array<Scalars['String']['output']>;
};

/** Categories of mental health and wellbeing metrics */
export enum MindstateMetricType {
  SelfAssessment = 'self_assessment'
}

/** Represents a mobile widget with its configuration */
export type MobileWidget = Content & {
  __typename: 'MobileWidget';
  /** The kind of mobile widget */
  kind: MobileWidgetKind;
  /** Display title for the widget (derived from its kind) */
  title: Scalars['String']['output'];
};

/** Reference to a built-in mobile widget */
export type MobileWidgetId = ContentReference & {
  __typename: 'MobileWidgetId';
  hydratedContent?: Maybe<ActivityVideo | Article | ArticleTeaser | CustomActivity | DojoArticle | DojoChecklist | DojoNugget | DojoQuiz | DojoQuote | JourneyVideo | Lesson | MobileWidget | Story | StoryTeaser | VideoTeaser>;
  /** The specific kind of mobile widget being referenced */
  kind: MobileWidgetKind;
};

export type MobileWidgetIdInput = {
  kind: MobileWidgetKind;
};

/** Types of mobile widgets available in the application */
export enum MobileWidgetKind {
  /** Box breathing exercise widget for stress reduction */
  BoxBreathing = 'box_breathing',
  /** Check-in widget for recording current state */
  CheckIn = 'check_in',
  /** Daily journal entry widget */
  DailyJournal = 'daily_journal',
  /** Diaphragm breathing exercise widget for relaxation */
  DiaphragmBreathing = 'diaphragm_breathing',
  /** Lung capacity measurement test widget */
  LungCapacityTest = 'lung_capacity_test',
  /** PPG-based body scanning widget */
  PpgScan = 'ppg_scan',
  /** Vagus nerve stimulation session widget */
  VnsSession = 'vns_session'
}

/**
 * One modeEffectivenessByMode group (YOJO-3263). A legacy group (modeId null)
 * carries legacyMode; a mode-id group carries modeId, the newest stamped
 * modeDisplayName and deviceKind (null = not recorded).
 */
export type ModeEffectivenessByModeEntry = {
  __typename: 'ModeEffectivenessByModeEntry';
  avgHrvDelta?: Maybe<Scalars['Float']['output']>;
  avgParasympatheticDelta?: Maybe<Scalars['Float']['output']>;
  avgStressDelta?: Maybe<Scalars['Float']['output']>;
  deviceKind?: Maybe<VnsDeviceKind>;
  legacyMode?: Maybe<VnsMode>;
  modeDisplayName?: Maybe<Scalars['String']['output']>;
  modeId?: Maybe<Scalars['ID']['output']>;
  sampleSize: Scalars['Int']['output'];
  /** Null unless split by set version. */
  setVersion?: Maybe<Scalars['Int']['output']>;
};

/** A catalogue mode as the app reports it (YOJO-3300): its id and the parameter set version that ran. */
export type ModeReferenceInput = {
  /** The mode catalogue id of the mode */
  modeId: Scalars['ID']['input'];
  /** The mode's parameter set version */
  setVersion: Scalars['Int']['input'];
};

/**
 * Single sparkline data point. Either `value` (Int) or `valueDecimal` (BigDecimal) is set
 * depending on whether the metric is count-based or currency/percentage-based.
 */
export type MonthlyKpiPoint = {
  __typename: 'MonthlyKpiPoint';
  /** Year-month in yyyy-MM format, e.g. "2026-03" */
  month: Scalars['String']['output'];
  value?: Maybe<Scalars['Int']['output']>;
  valueDecimal?: Maybe<Scalars['BigDecimal']['output']>;
};

/** One month-bucket data point on a report chart's shared month axis. */
export type MonthlyPoint = {
  __typename: 'MonthlyPoint';
  afterBand: Scalars['Boolean']['output'];
  month: Scalars['String']['output'];
  partial: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type MonthlyRevenue = {
  __typename: 'MonthlyRevenue';
  currency: Scalars['String']['output'];
  customerCount: Scalars['Int']['output'];
  disputeAmount?: Maybe<Scalars['BigDecimal']['output']>;
  disputeCount?: Maybe<Scalars['Int']['output']>;
  estimatedFees: Scalars['BigDecimal']['output'];
  feeEnrichedPercent?: Maybe<Scalars['BigDecimal']['output']>;
  feePercentage: Scalars['BigDecimal']['output'];
  feeSource?: Maybe<Scalars['String']['output']>;
  month: Scalars['String']['output'];
  netBalance: Scalars['BigDecimal']['output'];
  paymentDistribution: Array<PaymentBucket>;
  percentOfTarget?: Maybe<Scalars['BigDecimal']['output']>;
  reconciliationPercent?: Maybe<Scalars['BigDecimal']['output']>;
  refundCount?: Maybe<Scalars['Int']['output']>;
  targetAmount?: Maybe<Scalars['BigDecimal']['output']>;
  totalAmount: Scalars['BigDecimal']['output'];
  totalRefunded?: Maybe<Scalars['BigDecimal']['output']>;
};

export type Mutation = {
  __typename: 'Mutation';
  /**
   * Activate an entitlement using an activation code, bound to the caller's own user id.
   * Retired as a member flow (ADR 0013); requires admin or operations role.
   */
  activateEntitlement: ActivateEntitlementResult;
  /** Add a coupon code to an acquisition source. */
  addCouponCode?: Maybe<AcquisitionSource>;
  /** Register a notification token for the current user */
  addNotificationToken: InputAcceptedResponse;
  /**
   * Add a new note for a participant.
   * Called when user clicks "Save" or "Publish" from localStorage draft.
   */
  addParticipantNote: InputAcceptedResponse;
  /** Add a path to a learning journey */
  addPathToLearningJourney: InputAcceptedResponse;
  /**
   * Adopt a Stripe-created Payment Link by adding yojo-api management metadata.
   * This adds yojo_env for proper webhook routing and marks it as managed.
   */
  adoptPaymentLink: PaymentLink;
  /**
   * Approve a `prepared` bulk content assignment (YOJO-1817). Transitions it to
   * `approved`; the fan-out then drives in_progress → completed/failed
   * asynchronously. approvedVia=care_portal. No-op (returns the entry unchanged)
   * if the assignment is not in `prepared`.
   */
  approveBulkAssignment: BulkAssignmentEntry;
  /**
   * Retire a package. Refused while it is the configured floor — designate another floor first — and
   * while another live package sits above it in the plan ladder (move those first).
   *
   * Archiving is the largest shrink there is: an archived package contributes nothing to anyone, so
   * every current holder loses its whole contents. `shrinkMode: grandfather` preserves those contents
   * for them as individual grants; omitting it (or `outright`) lets the package go dark for them.
   * Call `packageChangeImpact(changeKind: archive)` first — it is the only place the blast radius shows.
   *
   * `confirmedBy` is the admin's typed confirmation from that dialog. It is persisted on the event:
   * "the dialog was shown" is a client-side claim, and the event store is the only thing that can still
   * prove the archive was deliberate months later.
   */
  archiveCapabilityPackage: InputAcceptedResponse;
  /**
   * Archive a note (soft delete).
   * Archived notes are hidden from default view but still searchable.
   */
  archiveParticipantNote: InputAcceptedResponse;
  /**
   * Mark one or more governed first-time experiences as seen for the authenticated member.
   * Self-scoped (the subject is derived from the identity, never an argument), idempotent,
   * batch-capable, fire-and-forget.
   */
  assertExperiencesSeen: InputAcceptedResponse;
  /**
   * Assign roles to a user account (ADMIN only)
   * Replaces the account's roles with the given ones. Any role except 'participant' and 'user' can be
   * assigned: admin, nurse, content, developer, analyst, operations
   * Cannot assign 'participant' role (assigned during onboarding) or the legacy 'user' role
   * Cannot assign roles to existing participants (privilege escalation protection)
   */
  assignRoles: InputAcceptedResponse;
  /** Assign a user to a learning journey */
  assignUserToLearningJourney: InputAcceptedResponse;
  /** Bulk assign users to a learning journey */
  bulkAssignUsersToLearningJourney: InputAcceptedResponse;
  /** Bulk unassign users from a learning journey */
  bulkUnassignUsersFromLearningJourney: InputAcceptedResponse;
  /**
   * Cancel a scheduled consult.
   * Can only cancel consults that don't have an outcome yet.
   */
  cancelConsult: InputAcceptedResponse;
  /**
   * Cancel a member's Stripe subscription (identified explicitly by customerId + subscriptionId).
   * Default (immediate=false) schedules cancellation at the end of the current billing period
   * (member keeps access until then); immediate=true cancels the subscription now.
   *
   * This mutation ONLY calls Stripe — the customer.subscription.updated/deleted webhook cascade
   * owns all downstream entitlement/membership state (eventual consistency).
   *
   * Returns InputAcceptedResponse carrying the subscription id acted on. Errors cleanly when the
   * subscription is not an eligible, active subscription of that member.
   * Requires admin or operations role.
   */
  cancelMemberSubscription: InputAcceptedResponse;
  /** Cancel a scheduled notification */
  cancelNotification: InputAcceptedResponse;
  /** Cancel a service case. */
  cancelServiceCase?: Maybe<ServiceCase>;
  /**
   * Classify a user with a workflow status (test_account, churned, etc.).
   * Creates or updates the user's classification.
   */
  classifyUser: UserClassification;
  /** Mark a planned activity as completed */
  completeActivity: InputAcceptedResponse;
  /**
   * Create a new acquisition source.
   * Optionally attach coupon codes at creation time.
   */
  createAcquisitionSource?: Maybe<AcquisitionSource>;
  /**
   * Opens Stripe's hosted Customer Portal for the billing the caller bought
   * themselves (YOJO-3476 [member opens Stripe's billing portal for the
   * subscription they bought themselves]). Self-only: no user argument; the
   * caller's own account.
   */
  createBillingPortalSession: BillingPortalSessionResult;
  createCarrier?: Maybe<Carrier>;
  /** Create a custom activity for a user's activity planning */
  createCustomActivity: InputAcceptedResponse;
  /** Create a new learning journey */
  createLearningJourney: InputAcceptedResponse;
  /** Create a new learning path */
  createLearningPath: InputAcceptedResponse;
  /** Create a new Payment Link with consistent configuration */
  createPaymentLink: PaymentLink;
  /**
   * Create the member's personalised Stone mode from a name, an optional description and the eight values; the
   * shared vendor curve is added. Saved as parameter-set version 1, checked against the current safety limits.
   * Answers the new mode's id. One per member: remove the current one first. Admin or coach.
   * Refused: `extensions.code` (`no_stone`, `plan_excludes_personalised`, `personalised_mode_exists`, `no_limits`,
   * `outside_limits`, ...) and `extensions.violations`, codes listed on StoneModeCatalogue.
   */
  createPersonalisedStoneMode: InputAcceptedResponse;
  /** Create a new shipment for a customer. */
  createShipment?: Maybe<Shipment>;
  /**
   * Create a staff user (ADMIN only)
   * Finds or creates the sign-in for the address and creates the account with the chosen staff roles;
   * the person then signs in with Google on that address. This is the only way a staff account is
   * created: no role is ever derived from an email address. Returns the account id (act_ prefix).
   * Refused (violations[0].message, status 400) with one of these sentences:
   * "Choose at least one staff role" - no role given, or one that is not a staff role
   * "Staff need a @yojo.health or @luminapain.com address" - the address is on another domain
   * "Choose a valid timezone" - the timezone is not an IANA name
   * "Already a staff user; edit roles in the team list" - the address belongs to a staff account
   * "This address belongs to a member account" - the address belongs to a member
   * "This address already has an account." - an account exists for it that was created a moment ago
   * "A sign-in exists for this address that is not a verified Google sign-in" - the existing sign-in
   * is not a verified Google sign-in for this address (for example password-only or disabled)
   */
  createStaffUser: InputAcceptedResponse;
  /**
   * Create a Stone mode, disabled, with a generated id (returned as `id`), at `position` or at the end
   * (YOJO-3258). Admin or coach. Refused: `extensions.code` and `extensions.violations`, codes listed on
   * StoneModeCatalogue.
   */
  createStoneMode: InputAcceptedResponse;
  /** Deactivate an acquisition source. */
  deactivateAcquisitionSource?: Maybe<AcquisitionSource>;
  deactivateCarrier?: Maybe<Carrier>;
  /** Deactivate a Payment Link (cannot be reactivated) */
  deactivatePaymentLink: Scalars['Boolean']['output'];
  /**
   * Create a capability package. Admin only — a tier change is an attributed admin action, not a deploy.
   * Rejected when the packageKey is taken or a price ref is already claimed by another package.
   *
   * Since YOJO-3313 the retired stimulation capabilities (`stimulation_modes_all`,
   * `stimulation_mode_personalised`) cannot be added: refused with `extensions.code = VALIDATION_FAILED`,
   * `extensions.field = capabilities` and `extensions.reason = capability_retired`.
   */
  defineCapabilityPackage: InputAcceptedResponse;
  /**
   * Delete a manually logged VNS session (soft-delete with audit trail).
   * Only manual sessions can be deleted - device-recorded sessions are immutable.
   */
  deleteManualVnsSession: InputAcceptedResponse;
  /**
   * Delete a planned activity
   * Will remove it from the planning entirely
   */
  deletePlannedActivity: InputAcceptedResponse;
  deleteRevenueTarget: InputAcceptedResponse;
  /**
   * Disable a Stone mode; it keeps its place in the ordering. Alpha records are fixed. Admin or coach.
   * Refused: `extensions.code`, see StoneModeCatalogue.
   */
  disableStoneMode: InputAcceptedResponse;
  /**
   * Edit a manually logged VNS session.
   * Only manual sessions can be edited - device-recorded sessions are immutable.
   * Sessions can only be edited within 2 weeks of the original recording date.
   */
  editManualVnsSession: InputAcceptedResponse;
  /**
   * Enable a Stone mode: a Stone mode needs a parameter set inside the current limits. Admin or coach.
   * Refused: `extensions.code`, see StoneModeCatalogue.
   */
  enableStoneMode: InputAcceptedResponse;
  /** End a VNS therapy session that was previously started */
  endVnsSession: InputAcceptedResponse;
  /**
   * Erase a note from the caller's own journal (YOJO-3118). Always allowed, on every plan, also for a note older
   * than the plan lets the member see. Erasing an erased note answers success; an unknown note is not found.
   */
  eraseJournalNote: InputAcceptedResponse;
  /**
   * GDPR right-to-erasure: erase ONE partner enquiry (contact details included) from prospect-api, through the same
   * door as the erase_partner_enquiry MCP tool: an audit row (recordDataExport) on behalf of the staff member first,
   * then the erase; when the audit row cannot be recorded, nothing is erased and the call fails (YOJO-3403). Returns
   * the number erased: 1, or 0 when it was already gone. For sales, operations and admin (YOJO-3371).
   */
  erasePartnerEnquiry: PartnerEnquiryEraseResult;
  /**
   * GDPR right-to-erasure: erase ALL waitlist sign-ups for a given email from prospect-api.
   * Returns the number of sign-up rows erased. Audited (recordDataExport).
   */
  eraseWaitlistSignal: WaitlistEraseResult;
  /**
   * Export customer data to CSV format.
   * Admin-only operation with GDPR audit trail.
   *
   * Returns CSV content directly in the response.
   * Justification is required for audit compliance.
   */
  exportCustomers: ExportResult;
  /**
   * Audited, data-minimised CSV export of a single delivery country's waitlist sign-ups (PII).
   * A non-blank justification is REQUIRED (GDPR access gate); the export is blocked (denied) when the
   * justification is missing or blank. Test/internal sign-ups are excluded. The CSV columns are
   * data-minimised to exactly: email, delivery country, signup date, consent, source. Every export
   * writes a recordDataExport audit row (exporter, export type, columns, filters=country, recordCount,
   * justification).
   */
  exportWaitlistSignals: WaitlistExportResult;
  /**
   * Extend a member's Stripe subscription by N months (YOJO-2865/2867, ADR 0014). Allowed only when the live
   * Stripe status is active or trialing; refused for past_due, a pending cancel_at_period_end, or no known
   * subscription. months must be 1..12 and reason at least 10 chars.
   *
   * Stripe-first: pushes the renewal out via subscriptions.update(trial_end = current_period_end + N months,
   * proration_behavior = none) with audit metadata, THEN records an EntitlementSubscriptionExtendedEvent on
   * our side. Membership/billing lifecycle stays owned by the webhook cascade + reconciliation. No member
   * email is sent. Returns the Stripe-confirmed previous + new period end.
   * Requires admin or operations role.
   */
  extendMemberSubscription: ExtendMemberSubscriptionResponse;
  /** Finish a piece of content */
  finishContent: InputAcceptedResponse;
  /**
   * Comp a capability to ONE member — the per-member escape hatch, so support can say yes without a
   * deploy. admin OR operations: changing a tier is an admin act, comping one member is support's job.
   *
   * Every comp is audited. `sourceRef` (the ticket or actor reference) is REQUIRED: it is what the
   * event carries alongside the granting identity, and it is the refcount key the revoke matches on.
   *
   * Returns the member's capability-holder id.
   *
   * Since YOJO-3313 the retired stimulation capabilities (`stimulation_modes_all`,
   * `stimulation_mode_personalised`) cannot be comped: refused with `extensions.code = VALIDATION_FAILED`,
   * `extensions.field = capabilities` and `extensions.reason = capability_retired`.
   */
  grantCompCapability: InputAcceptedResponse;
  /**
   * Comp a whole TIER to ONE member — what the manual grant admin screen does. admin OR operations.
   *
   * Different from `grantCompCapability` in SHAPE, not in permission: a package grant keeps following
   * the tier as an admin edits it, while a capability comp is a frozen set. "Give them Elevate for
   * three months" means this one.
   *
   * `packageKey` must name a defined, non-archived package — a typo would otherwise be recorded and
   * hand the member nothing.
   *
   * `reason` is REQUIRED and is the audit trail; it is persisted on the event with the granting
   * identity. `ticketRef` is optional and becomes the refcount key when supplied, which makes the comp
   * idempotent (the same ticket twice is one grant) and gives the revoke something a human can retype.
   * Without one a fresh ref is minted per submit — read it back off `memberCapabilities`.
   *
   * Returns the member's capability-holder id.
   */
  grantCompPackage: InputAcceptedResponse;
  /**
   * Give ONE member a CUSTOM inline set (YOJO-2598 [custom capability grants]) — capabilities and/or
   * dials, with no package behind them. admin OR operations, the same door as the comps.
   *
   * What it replaces: a per-member custom set used to mean defining a PACKAGE first, i.e. a fleet-wide
   * artefact minted to serve one person and cluttering the tier editor forever.
   *
   * ADDITIVE, exactly like a package grant. It unions with the member's packages and the floor —
   * capabilities by union, dials through the same MAX with `-1` winning — so it can raise a member's
   * allowance above their tier's and can never lower anything. Floor resolution, the device intersection
   * and the nightly expiry sweep all apply to it unchanged.
   *
   * `reason` is REQUIRED. At least one of `capabilities` / `dials` must be non-empty; both empty is
   * refused by name. Revoked by ROW id via `revokeCustomCapabilityGrant`, NOT by ref.
   *
   * Returns the member's capability-holder id.
   *
   * Since YOJO-3313 the retired stimulation capabilities (`stimulation_modes_all`,
   * `stimulation_mode_personalised`) cannot be granted: refused with `extensions.code = VALIDATION_FAILED`,
   * `extensions.field = capabilities` and `extensions.reason = capability_retired`.
   */
  grantCustomCapabilities: InputAcceptedResponse;
  /**
   * Import one entry of the vendor's modes.json, pasted as raw JSON (`vendorEntryJson`), as a new version of the
   * parameter set of the Stone mode `modeId` (YOJO-3259). The vendor's own `modeId` and `name` are ignored: the
   * set lands on the mode you name. Saved with source `vendor_import` and the optional `sourceNote` (e.g. which
   * file it came from; trimmed, blank = none, at most 500 characters or `invalid_input`). An entry that cannot be
   * read, or is over 64 KiB, is refused `malformed_import`, every problem named and listed in
   * `extensions.problems`; paste ONE entry (the {...} after its name). The entry's curve must be the shared vendor
   * curve. Admin or coach (checked before the entry is read). Answers the mode's id.
   * Refused: `extensions.code`, `extensions.violations`, `extensions.curveProblem` and `extensions.problems`, see
   * StoneModeCatalogue.
   */
  importStoneModeParameters: InputAcceptedResponse;
  /**
   * Initiate a new bulk-message broadcast.
   *
   * Returns the freshly-created BroadcastEntry in status `pending`. The
   * Phase 3 BroadcastFanOutService (YOJO-1728) drives the lifecycle from
   * pending → in_progress → completed/failed.
   */
  initiateBroadcast: BroadcastEntry;
  /**
   * Initiate a new bulk content assignment — the composer one-click path.
   *
   * YOJO-1817: dispatches a PrepareBulkAssignmentCommand (preparedVia=composer).
   * With the default autoApprove=true, prepare and approve happen atomically so
   * the fan-out fires immediately; the returned entry is in status `approved`
   * (fan-out then drives in_progress → completed/failed asynchronously). With
   * autoApprove=false the entry is returned in status `prepared`, awaiting an
   * explicit approveBulkAssignment.
   */
  initiateBulkAssignment: BulkAssignmentEntry;
  /** Initiate a return for a service case. */
  initiateReturn?: Maybe<ServiceCase>;
  /** Like a piece of content */
  likeContent: InputAcceptedResponse;
  /**
   * Link (assign or reassign) an entitlement to a user.
   * Assigns a provisioned entitlement, or reassigns an active one to a different user
   * (gift correction). The entitlement becomes active, owned by the given user.
   * Requires admin or operations role.
   *
   * Returns InputAcceptedResponse (CQRS eventual consistency): the command is dispatched
   * synchronously so validation surfaces to the client, but the entitlement projection
   * updates asynchronously - clients must poll for the linked state.
   */
  linkEntitlementToUser: InputAcceptedResponse;
  /** Link a replacement shipment to a service case. */
  linkReplacementShipment?: Maybe<ServiceCase>;
  /**
   * Log a manual VNS session (single-step, for retrospectively recording sessions done offline).
   * Manual sessions are editable and deletable, unlike device-recorded sessions.
   */
  logManualVnsSession: InputAcceptedResponse;
  /**
   * Map a stimulation capability (balance or all modes) to the Stone mode ids it stands for. Admin or coach.
   * Refused: `extensions.code`, see StoneModeCatalogue. Retired (YOJO-3313): every call is refused `capability_retired`.
   * @deprecated Retired upon YOJO-3313 — a plan names its Stone modes (CapabilityPackage.modeIds)
   */
  mapStimulationCapability: InputAcceptedResponse;
  /**
   * Mark an entitlement's purchase as a gift (gift: true) or as self-bought (gift: false) for its CURRENT holder
   * (YOJO-2976 [member sees their own plan], plan ADR 0002 Amendment 1), overriding the mark stamped at link time.
   * The reason is required for the audit trail. Refused when the entitlement has
   * no holder; the same value as the current mark is a no-op.
   * Requires admin or operations role. Answers the entitlement as the read model holds it.
   */
  markEntitlementGift: Entitlement;
  /** Mark a return as received at the warehouse. */
  markReturnReceived?: Maybe<ServiceCase>;
  /** Mark a return as shipped by the customer. */
  markReturnShipped?: Maybe<ServiceCase>;
  /** Mark a shipment as delivered. */
  markShipmentDelivered?: Maybe<Shipment>;
  /**
   * Mark a shipment as returned (RMA). Records the physical fact that the unit came back.
   * `reason` is an optional short RMA note captured for the audit trail.
   */
  markShipmentReturned?: Maybe<Shipment>;
  /** Mark a shipment as shipped with tracking information. */
  markShipmentShipped?: Maybe<Shipment>;
  /**
   * Move one Stone mode to a 0-based position in the full ordering. Alpha records are fixed. Admin or coach.
   * Refused: `extensions.code`, see StoneModeCatalogue.
   */
  moveStoneMode: InputAcceptedResponse;
  /**
   * Onboards the signed-in member with the four-question flow: name, sex at birth,
   * birthday, and optionally a goal. Repairable: submitting again finishes what is
   * missing and repeats nothing (domain-design §3.3).
   */
  onboardMember: InputAcceptedResponse;
  /** @deprecated Removed upon YOJO-3297 */
  onboardParticipant: InputAcceptedResponse;
  /** Open a new service case for a customer. */
  openServiceCase?: Maybe<ServiceCase>;
  /**
   * Move a package in the plan ladder: `sitsAbove` names the plan it sits directly above. Order only —
   * the package keeps its full contents and capability resolution is unchanged.
   *
   * The package must be defined and not archived. The configured floor sits above nothing, so `sitsAbove`
   * must be null for it; every other plan must name one. The linked plan must be defined, not archived and
   * not this package, and the move must not make a loop. Placing a package where it already sits is a no-op.
   */
  placeCapabilityPackage: InputAcceptedResponse;
  /** Plan a new activity for a user */
  planActivity: InputAcceptedResponse;
  /**
   * Pre-register the manufacturer serial of the shipped device on an Entitlement (YOJO-2393, ADR-0013),
   * BEFORE the device first comes online. When a member later pairs a device carrying that serial, the
   * Entitlement auto-links and activates to the holder (possession-as-identity) — the canonical gift
   * redemption path. Ops writes it from JDM's shipped-serial notice; a future JDM API integration is another
   * caller of the same command.
   *
   * A duplicate serial across OPEN pre-registrations is rejected here (a human is present at entry);
   * consumed/revoked pre-registrations do not block refurb re-shipments. Requires admin or operations role.
   *
   * Returns InputAcceptedResponse (CQRS eventual consistency): the command is dispatched synchronously so
   * validation surfaces to the client, but the projection updates asynchronously - clients must poll.
   */
  preRegisterDeviceSerial: InputAcceptedResponse;
  /**
   * Prepare a bulk content assignment in the `prepared` state for later
   * approve/reject (YOJO-1817). The recipient resolver runs server-side. Exactly
   * one of input.selection or input.userIds must be set. preparedVia=composer.
   *
   * Returns the BulkAssignmentEntry in status `prepared`.
   */
  prepareBulkAssignment: BulkAssignmentEntry;
  /**
   * Reactivate a suspended entitlement.
   * Can only be used on suspended entitlements, not revoked ones.
   * Requires admin or operations role.
   */
  reactivateEntitlement: Entitlement;
  /** Record a biofeedback session with pre/post vital measurements */
  recordBiofeedbackSession: InputAcceptedResponse;
  /** Record a body metric like height or weight */
  recordBodyMetric: InputAcceptedResponse;
  /** Record a checkin session with vital, feeling and cognitive measurements */
  recordCheckinSession: InputAcceptedResponse;
  /** Record the outcome of a consult. */
  recordConsultOutcome: InputAcceptedResponse;
  /**
   * Retired: always refused with `extensions.code = JOURNAL_DIARY_RETIRED`. The per-day diary is replaced by journal
   * notes (recordJournalNote).
   * @deprecated Removed upon YOJO-3602
   */
  recordDailyLog: InputAcceptedResponse;
  /**
   * Retired: always refused with `extensions.code = JOURNAL_DIARY_RETIRED`. The per-day diary is replaced by journal
   * notes (recordJournalNote).
   * @deprecated Removed upon YOJO-3602
   */
  recordDailyPainLevel: InputAcceptedResponse;
  /** Record a daily wellness reflection */
  recordDailyReflection: InputAcceptedResponse;
  /**
   * Record a data export event for GDPR audit trail.
   * Must be called before downloading any data containing PII.
   */
  recordDataExport: DataExportAuditResult;
  /** Record progress for a dojo content item */
  recordDojoContentProgress: InputAcceptedResponse;
  /** Record an emotional state with descriptive feeling words */
  recordEmotionalState: InputAcceptedResponse;
  /** Record a feeling metric like stress or mood */
  recordFeelingMetric: InputAcceptedResponse;
  /**
   * Record a customer's first coaching consult date.
   * Requires admin or nurse role.
   */
  recordFirstConsult: Customer;
  /**
   * Record a note in the caller's own journal (YOJO-3118). `input.clientNoteKey` is the app's key for the draft: a
   * UUID the app mints once per draft and re-sends on every retry. The same key with the same content (text,
   * writtenAt, origin, originRef) is stored once (a retry answers success); the same key with a different content is
   * refused with `extensions.code = JOURNAL_NOTE_CONFLICT`. Answers the note's
   * server id (`jnote_…`), the id `journalNotes` serves
   * and `eraseJournalNote` takes. Other refusals: `JOURNAL_NOTE_LIMIT_REACHED` (too many new notes today) and
   * `JOURNAL_NOT_READY` (a brand-new journal is still being set up: retry the same request). Open to every plan.
   */
  recordJournalNote: InputAcceptedResponse;
  /** Record lessons progress */
  recordLessonsProgress: InputAcceptedResponse;
  /** Record a mindstate metric */
  recordMindstateMetric: InputAcceptedResponse;
  /**
   * Record a consult that already happened: schedules it and records its outcome
   * atomically, assigning the consult number server-side. Use for the care-portal
   * "Record Past Consult" action and the historical backfill. Creates the consults
   * aggregate if it doesn't exist yet.
   */
  recordPastConsult: InputAcceptedResponse;
  /**
   * Record the ops decision after reviewing a refunded buyer, for one entitlement (YOJO-3607 [refunded buyers: ops
   * records "keep access + reason" so the Refunded badge clears]): decision keep = the buyer keeps access, with a
   * required reason for the audit trail. Clears Customer.refundReviewPending when the entitlement is the primary one,
   * until a later refund is recorded. To END access use revokeEntitlement instead.
   * Refused when the entitlement is not the customer's, the reason is blank, or the customer has no recorded refund;
   * the same decision and reason again (with no newer refund) is a no-op.
   * Requires admin or operations role. Answers the Customer as the read model holds it; null when the decision was
   * recorded but the read model does not hold the customer yet (re-read it) — never an error for that lag.
   */
  recordRefundReview?: Maybe<Customer>;
  /** Record a vital metric like heart rate or blood pressure */
  recordVitalMetric: InputAcceptedResponse;
  /**
   * ⚠️ Legacy. Prefer startVnsSession + endVnsSession + recordVnsSessionPostVitals.
   * @deprecated Legacy one-shot API. Use startVnsSession + endVnsSession + recordVnsSessionPostVitals
   */
  recordVnsSession: InputAcceptedResponse;
  /** Record post-vitals for an existing VNS therapy session */
  recordVnsSessionPostVitals: InputAcceptedResponse;
  /**
   * Record a wearable heartbeat (YOJO-2964): a lightweight "this member's phone is alive and the app can
   * still read Health data" liveness ping, emitted on app open and on background-refresh slots. Feeds the
   * nightly wearable-stall detection. Ingest-only, high-frequency telemetry (a plain table, not an event).
   * userId is taken from the authenticated identity, never from the input.
   */
  recordWearableHeartbeat: InputAcceptedResponse;
  /** Register a user login event with timezone */
  registerLogin?: Maybe<InputAcceptedResponse>;
  /** Register a VNS device for the current user. */
  registerVnsDevice: InputAcceptedResponse;
  /**
   * Reject a `prepared` bulk content assignment (YOJO-1817). Transitions it to
   * the terminal `rejected` state. No-op (returns the entry unchanged) if the
   * assignment is not in `prepared`.
   */
  rejectBulkAssignment: BulkAssignmentEntry;
  /** Remove a coupon code from an acquisition source. */
  removeCouponCode?: Maybe<AcquisitionSource>;
  /** Remove a path from a learning journey */
  removePathFromLearningJourney: InputAcceptedResponse;
  /**
   * Remove the member's current personalised Stone mode; it stays readable as history and its id is never reused.
   * No device or plan check. Answers the removed mode's id. Admin or coach.
   * Refused: `extensions.code` (`no_personalised_mode` when there is nothing to remove), codes listed on
   * StoneModeCatalogue.
   */
  removePersonalisedStoneMode: InputAcceptedResponse;
  /** Replace an existing planned activity with new settings */
  replacePlannedActivity: InputAcceptedResponse;
  /**
   * The app reports which Stone mode, at which parameter-set version, it wrote to one of the member's own devices
   * (YOJO-3261), linked or not. Answers the device id. A malformed field is refused naming it; a device that is not
   * the member's is not found. Reporting the same write again is harmless.
   */
  reportStoneModeWritten: InputAcceptedResponse;
  /**
   * Resend activation email for an entitlement.
   * Requires admin or operations role.
   */
  resendActivationEmail: ResendEmailResult;
  /** Resolve a service case. */
  resolveServiceCase?: Maybe<ServiceCase>;
  /**
   * YOJO-1785 — re-deliver a completed broadcast to ONLY its still-failed recipients.
   *
   * Reuses the same broadcastId, so the idempotent per-recipient send dedupes any
   * recipient who actually received the original message; the result is MERGED into
   * the broadcast's tally (sentCount += newly-delivered, failedUserIds := still-failed)
   * without clobbering the originally-delivered recipients.
   *
   * CQRS: returns immediately with the broadcastId. No-op if the broadcast is not
   * `completed` or has no failed recipients. Clients poll the broadcast for the
   * updated tally.
   */
  retryFailedBroadcastRecipients?: Maybe<InputAcceptedResponse>;
  /**
   * Reveal one partner enquiry's contact details (email, phone, website, socials). Every call first writes one
   * audit row (who, which enquiry, when) through the same door as the get_partner_enquiry MCP tool; if that write
   * fails nothing is revealed. For sales, operations and admin (YOJO-3371).
   * Returns the details rather than InputAcceptedResponse: an audited read with no command, where a second fetch
   * would be an unaudited read.
   */
  revealPartnerEnquiryContact: PartnerEnquiryContact;
  /**
   * Reverse a member's PENDING period-end cancellation (sets cancel_at_period_end=false) on the
   * explicitly-identified subscription, keeping it live. Valid only while the subscription is still
   * active in Stripe.
   *
   * This mutation ONLY calls Stripe. Returns InputAcceptedResponse carrying the subscription id.
   * Requires admin or operations role.
   */
  reverseMemberSubscriptionCancellation: InputAcceptedResponse;
  /**
   * Take a comp back — a comped tier and a comped capability set alike, since it matches on the REF.
   * ONLY the (source=comp, sourceRef) grant is touched: a member's subscription, trial and grandfather
   * grants are structurally out of reach of this mutation, and a second comp on a different ref
   * survives.
   *
   * `reason` is REQUIRED and is persisted on the event with the revoking identity. A lapse explains
   * itself; a person taking a capability away from a member does not.
   *
   * Revoking a ref that holds nothing is a no-op; revoking for a member who has never been granted
   * anything is rejected.
   */
  revokeCompCapability: InputAcceptedResponse;
  /**
   * Take back ONE custom grant, by its ledger ROW id (YOJO-2598 [custom capability grants]).
   * admin OR operations.
   *
   * Row id and not ref, unlike every other revoke here, because resolution is a UNION: the same
   * capability can arrive from several live rows at once. Removing one row and letting the union
   * re-resolve is the only precise operation available — an overlapping capability another live row
   * still gives, the member still has. Nothing rewrites a stored set.
   *
   * ONLY a `custom` row can be taken back here: a grantId naming a subscription, trial, comp or
   * grandfather grant is refused, so subscriptions and entitlements are structurally out of reach.
   *
   * `reason` is REQUIRED and is persisted on the event with the revoking identity. Revoking an already
   * inactive row is a no-op; revoking for a member who has never been granted anything is rejected.
   *
   * Returns the member's capability-holder id.
   */
  revokeCustomCapabilityGrant: InputAcceptedResponse;
  /**
   * Permanently revoke an entitlement.
   * Used for refunds, abuse detection, or legal requests.
   * This action is permanent and cannot be undone.
   * Requires admin or operations role.
   */
  revokeEntitlement: Entitlement;
  /**
   * Schedule a consult for a participant.
   * Creates the consults aggregate if it doesn't exist yet.
   */
  scheduleConsult: InputAcceptedResponse;
  /** Send or schedule a push notification */
  sendPushNotification: InputAcceptedResponse;
  /**
   * Name the Stone modes a plan gives, by mode id, plus the personalised mark. A separate save
   * from the contents: the content hash, the grandfather fan-out and the price leg never see a mode change.
   *
   * `modeIds` is the FULL list after the save (an empty list names no modes). Each id must be in the Stone
   * mode catalogue; an ADDED id must be enabled and a Stone mode. An id already on the list is never
   * refused for being resent. Removing a mode from a list already saved, or unmarking personalised, requires
   * `confirmedBy` (the typed confirmation). The first save of a plan that never named modes takes nothing
   * away (such a plan gives nothing but the default — YOJO-3313), so it needs none. Saving the list the plan
   * already has is a no-op.
   */
  setCapabilityPackageModes: InputAcceptedResponse;
  /**
   * Set the default mode: an enabled mode with a parameter set. Admin or coach.
   * Refused: `extensions.code`, see StoneModeCatalogue.
   */
  setDefaultStoneMode: InputAcceptedResponse;
  /** Set, change or clear your own goal (YOJO-3286). Leave the goal out to clear it. Only for your own account. */
  setMemberGoal: InputAcceptedResponse;
  /**
   * Move one partner enquiry to a new status. prospect-api's status rule decides which moves are allowed (new →
   * contacted or declined; contacted → partnered or declined; partnered and declined are final) and refuses the rest.
   * For sales, operations and admin.
   */
  setPartnerEnquiryStatus: PartnerEnquiryStatusChange;
  /**
   * Save a new version of the member's current personalised mode's parameter set from the eight values; the shared
   * vendor curve is added, the optional `sourceNote` (at most 500 characters) kept with it. Identical values change
   * nothing. Answers the mode's id. Admin or coach.
   * Refused: `extensions.code` (`no_stone`, `plan_excludes_personalised`, `no_personalised_mode`, `no_limits`,
   * `outside_limits`, ...) and `extensions.violations`, codes listed on StoneModeCatalogue.
   */
  setPersonalisedStoneModeParameters: InputAcceptedResponse;
  /**
   * Answer the daily practice-reminder question for your own account (YOJO-3350). Three choices:
   * chosen = a daily reminder at a part of the day and a time in your own time zone (both required), skipped on a day
   * your session is already done; later = not now; off = no reminder; the time already on the record is kept (later
   * keeps none). Send no part of the day and no time with later or off. Answering at all stops the starter-reading
   * pushes.
   */
  setPracticeReminder: InputAcceptedResponse;
  /** Set the resolution action for a service case. */
  setResolution?: Maybe<ServiceCase>;
  setRevenueTarget: InputAcceptedResponse;
  /**
   * Save a new version of the safety limits (all eight ranges; max intensity at most 30). Admin or coach.
   * Refused: `extensions.code`, see StoneModeCatalogue.
   */
  setStoneModeLimits: InputAcceptedResponse;
  /**
   * Save a Stone mode's parameter set as a new version from the eight typed-in values (YOJO-3259). There is no
   * curve field: every set carries the shared vendor intensity curve, and the one known payload format. Saved
   * with source `manual`; identical values to the current set change nothing. Admin or coach. Answers the mode's
   * id; read the saved version from stoneModeCatalogue or stoneModeParameterHistory.
   * Refused: `extensions.code`, `extensions.violations` (every range broken) and `extensions.curveProblem`, see
   * StoneModeCatalogue.
   */
  setStoneModeParameters: InputAcceptedResponse;
  /**
   * Start or join a chat with a participant (NURSE only)
   * Returns the channel id. The caller's own chat token is me { ... on Nurse { messagingToken } }.
   */
  startChat: ChatChannel;
  /** Start a piece of content */
  startContent: InputAcceptedResponse;
  /** Start a VNS therapy session. Returns the session ID to use when ending the session. */
  startVnsSession: InputAcceptedResponse;
  /**
   * The signed-in member says "I'm still waiting for my device" (YOJO-3360). No arguments: always the caller's own
   * account. Its own statement beside "I don't have a device", which it never withdraws: the later of the two counts.
   * Refused (violations[0].message, status 400) while a device is linked to the account.
   * Accepted without change when a statement that still counts is already recorded.
   * Read it back as UserProfile.awaitingDeviceStatedAt and TodayDevice.statedAwaitingDeviceAt.
   */
  stateAwaitingDevice: InputAcceptedResponse;
  /**
   * The signed-in member says "I don't have a device" (YOJO-3271). No arguments: always the caller's own account.
   * Refused (violations[0].message, status 400) while a device is linked to the account.
   * Accepted without change when a statement that still counts is already recorded.
   * Read it back as UserProfile.noDeviceStatedAt; null there once a later "I'm still waiting for my device"
   * (stateAwaitingDevice) replaces it.
   */
  stateNoDevice: InputAcceptedResponse;
  /**
   * Submit feedback about the yojo app.
   * Users can provide sentiment (needs_love, loved_this, id_love) and optional comment.
   */
  submitAppFeedback: InputAcceptedResponse;
  /**
   * Submit per-component feedback (👍/👎) on a component of the authenticated member's OWN Member
   * Health Report (YOJO-1947). Own-data-only: the owning member is the caller; there is no path to
   * another member's report. A 👎 requires a reasonCode. Idempotent: a re-submit identical to the
   * stored value is a no-op. Returns immediately (CQRS).
   */
  submitComponentFeedback: InputAcceptedResponse;
  /**
   * Submit a device session trace ("flight recorder" black box) for a VNS BLE conversation or a
   * ShenAI scan timeline. The gzipped-NDJSON payload is stored write-once in GCS with one
   * searchable metadata row in BigQuery. Ingest-only. userId is taken from the authenticated
   * identity, never from the input.
   */
  submitDeviceSessionTrace?: Maybe<InputAcceptedResponse>;
  /**
   * Submit report-level feedback (👍/👎) on the authenticated member's OWN Member Health Report as a
   * whole (YOJO-1947) — not tied to a component. Own-data-only. A 👎 requires a reasonCode.
   * Idempotent re-submit. Returns immediately (CQRS).
   */
  submitReportFeedback: InputAcceptedResponse;
  /**
   * Temporarily suspend an entitlement.
   * Used for payment failures, investigations, or customer requests.
   * Requires admin or operations role.
   */
  suspendEntitlement: Entitlement;
  /**
   * Suspend a user account (NURSE only)
   * Disables the member at Identity Platform and revokes their refresh tokens: sign-in and
   * token refresh are blocked immediately, and write access is denied within seconds. An
   * already-issued access token can still READ for up to ~1h until it expires.
   * The member also drops out of care-plan fan-out (bulk assignment, broadcasts).
   */
  suspendUser: InputAcceptedResponse;
  /**
   * Resync user roles from the identity store to Firebase custom claims.
   * Use when roles are out of sync (e.g., after migration or manual fix).
   * Pass accountHolderIds to resync specific users, or omit to resync all internal users.
   */
  syncRolesToFirebase: SyncRolesResult;
  /**
   * Track when a user clicks on content from search results.
   * Used for CTR (Click-Through Rate) analytics.
   */
  trackContentClick?: Maybe<TrackContentClickPayload>;
  /** Unassign a user from a learning journey */
  unassignUserFromLearningJourney: InputAcceptedResponse;
  /** Unlike a piece of content */
  unlikeContent: InputAcceptedResponse;
  /**
   * Unlink a user from an entitlement, resetting it to provisioned status.
   * The entitlement can then be re-activated by a different user.
   * Requires admin or operations role.
   */
  unlinkEntitlementFromUser: Entitlement;
  /**
   * Unlink the subscription reference from an entitlement.
   * Used when subscription needs to be re-linked or is corrupted.
   * Requires admin or operations role.
   */
  unlinkSubscription: Entitlement;
  /**
   * Lift a suspension (NURSE only)
   * Marks the account active again and re-enables sign-in at Identity Platform.
   * The reason is optional — restoring access needs no justification, and an unsuspend is
   * often a repair. Safe to re-run: an already-active account still retries the access restore.
   */
  unsuspendUser: InputAcceptedResponse;
  /**
   * Update an existing acquisition source.
   * Null fields indicate no change (partial update).
   */
  updateAcquisitionSource?: Maybe<AcquisitionSource>;
  /**
   * Update the user's body measurements (height and/or weight).
   * At least one field must be provided.
   */
  updateBodyMeasurements: InputAcceptedResponse;
  /**
   * Admin / operations: set the broadcast opt-out flag on a target participant's Preferences.
   * Excludes the participant from any future care-team bulk-chat broadcast (1:1 messages unaffected).
   * If the participant has no Preferences aggregate yet, one is created on-demand before the flag is applied.
   */
  updateBroadcastOptOut: Preferences;
  /**
   * Replace a package's contents. A shrink requires shrinkMode (and confirmedBy for `outright`) —
   * silently removing a capability from members who hold it is refused.
   *
   * Shrinking the package that IS the configured floor is refused outright: the floor is resolved for
   * every member rather than granted, so there is no holder list to grandfather. Growing the floor is
   * allowed; removals go via a floor swap (define a successor package, then change floorPackageKey).
   *
   * Since YOJO-3313: ADDING a retired stimulation capability (`stimulation_modes_all`,
   * `stimulation_mode_personalised`) is refused `extensions.reason = capability_retired` (keeping one the
   * package already holds is fine); REMOVING one is refused `extensions.reason = modes_not_set` until every
   * live plan names its Stone modes. Both with `extensions.code = VALIDATION_FAILED`,
   * `extensions.field = capabilities`.
   */
  updateCapabilityPackageContents: InputAcceptedResponse;
  /**
   * Write the cross-package dials (floor package, trial length, grace, trial package, default purchase
   * product) as a full snapshot.
   */
  updateCapabilitySettings: InputAcceptedResponse;
  updateCarrier?: Maybe<Carrier>;
  /**
   * Admin/operations toggle for a participant's content-assignment opt-out flag (YOJO-1742).
   * When true, the participant is excluded from bulk content-assignment recipient resolution.
   */
  updateContentAssignmentOptOut: InputAcceptedResponse;
  /** Update an existing custom activity */
  updateCustomActivity: InputAcceptedResponse;
  /**
   * Set the most offline sessions the device itself accepts (from the vendor). Admin only. A whole
   * number of 1 or more; the offline session allowance is clamped to it.
   *
   * Returns the settings id.
   */
  updateDeviceOfflineCap: InputAcceptedResponse;
  /**
   * Set the device record window: days every member's Stone record runs from now, at least. A member with
   * current paid coverage gets the later of this and their coverage end + 7 days. The app renews the
   * record before then. One window for every member. Admin only. A whole number of 1 or more.
   *
   * Returns the settings id.
   */
  updateDeviceRecordWindowDays: InputAcceptedResponse;
  /** Update the user's identity information (name, date of birth, gender) */
  updateIdentityInformation: InputAcceptedResponse;
  /** Update an existing learning journey */
  updateLearningJourney: InputAcceptedResponse;
  /** Update an existing learning path */
  updateLearningPath: InputAcceptedResponse;
  /** Update the message read status for a delivered notification */
  updateMessageReadStatus: InputAcceptedResponse;
  /**
   * Set how many sessions the Stone may start from its own button without the phone before the app
   * must be opened again. admin OR operations —
   * this is ops' day-to-day dial. A whole number of 1 or more; the same value again changes nothing.
   *
   * Not checked against the device cap: when the allowance is above it, the device is served the cap.
   *
   * Returns the settings id.
   */
  updateOfflineSessionAllowance: InputAcceptedResponse;
  /**
   * Update an existing published note.
   * Cannot update archived notes.
   */
  updateParticipantNote: InputAcceptedResponse;
  /** Update personal goals preferences */
  updatePersonalGoals: InputAcceptedResponse;
  /**
   * Rename or re-describe the member's current personalised Stone mode. Leaving `description` out (or null) keeps
   * the current one; an empty string clears it. Answers the mode's id. Admin or coach.
   * Refused: `extensions.code` (`no_stone`, `plan_excludes_personalised`, `no_personalised_mode`), codes listed on
   * StoneModeCatalogue.
   */
  updatePersonalisedStoneModeDetails: InputAcceptedResponse;
  /** Update preferred check-in time block */
  updatePreferredCheckin: InputAcceptedResponse;
  /** Update tracking information for a shipment. */
  updateShipmentTracking?: Maybe<Shipment>;
  /**
   * Rename or re-describe a Stone mode; its id never changes. Leaving `description` out (or null) keeps the
   * current description; only an explicit empty string clears it. Admin or coach.
   * Refused: `extensions.code`, see StoneModeCatalogue.
   */
  updateStoneModeDetails: InputAcceptedResponse;
  /** Update target vitals to monitor */
  updateTargetVitals: InputAcceptedResponse;
  /** Update preferred times for time blocks */
  updateTimeBlockPreferences: InputAcceptedResponse;
  /** Update user's timezone when it changes */
  updateTimezone?: Maybe<InputAcceptedResponse>;
  /** Update the user's name information in PII storage */
  updateUserName: InputAcceptedResponse;
  /** Update the nickname of the user's VNS device. */
  updateVnsDeviceNickname: InputAcceptedResponse;
  /** Update weekly protocol commitments */
  updateWeeklyCommitment: InputAcceptedResponse;
  /**
   * The signed-in member takes back "I'm still waiting for my device" (YOJO-3360). No arguments: always the caller's
   * own account. Accepted without change when no statement is recorded. Never touches "I don't have a device".
   */
  withdrawAwaitingDeviceStatement: InputAcceptedResponse;
  /**
   * The signed-in member takes back "I don't have a device" (YOJO-3271). No arguments: always the caller's own
   * account. Accepted without change when no statement is recorded.
   */
  withdrawNoDeviceStatement: InputAcceptedResponse;
};


export type MutationActivateEntitlementArgs = {
  activationCode: Scalars['String']['input'];
};


export type MutationAddCouponCodeArgs = {
  couponCode: Scalars['String']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationAddNotificationTokenArgs = {
  input: AddNotificationTokenCommand;
};


export type MutationAddParticipantNoteArgs = {
  input: AddParticipantNoteInput;
};


export type MutationAddPathToLearningJourneyArgs = {
  command: AddPathToLearningJourneyCommand;
};


export type MutationAdoptPaymentLinkArgs = {
  input: AdoptPaymentLinkInput;
};


export type MutationApproveBulkAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveCapabilityPackageArgs = {
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  packageKey: Scalars['ID']['input'];
  shrinkMode?: InputMaybe<ShrinkMode>;
};


export type MutationArchiveParticipantNoteArgs = {
  input: ArchiveParticipantNoteInput;
};


export type MutationAssertExperiencesSeenArgs = {
  command: AssertExperiencesSeenCommand;
};


export type MutationAssignRolesArgs = {
  input: AssignRolesInput;
};


export type MutationAssignUserToLearningJourneyArgs = {
  command: AssignUserToJourneyCommand;
};


export type MutationBulkAssignUsersToLearningJourneyArgs = {
  command: BulkAssignUsersToLearningJourneyCommand;
};


export type MutationBulkUnassignUsersFromLearningJourneyArgs = {
  command: BulkUnassignUsersFromLearningJourneyCommand;
};


export type MutationCancelConsultArgs = {
  consultNumber: Scalars['Int']['input'];
  participantId: Scalars['ID']['input'];
};


export type MutationCancelMemberSubscriptionArgs = {
  input: CancelMemberSubscriptionInput;
};


export type MutationCancelNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelServiceCaseArgs = {
  input: CancelServiceCaseInput;
};


export type MutationClassifyUserArgs = {
  input: ClassifyUserInput;
};


export type MutationCompleteActivityArgs = {
  command: CompleteActivityCommand;
};


export type MutationCreateAcquisitionSourceArgs = {
  cmd: CreateAcquisitionSourceInput;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateBillingPortalSessionArgs = {
  input: CreateBillingPortalSessionInput;
};


export type MutationCreateCarrierArgs = {
  cmd: CreateCarrierInput;
};


export type MutationCreateCustomActivityArgs = {
  command: CreateCustomActivityCommand;
};


export type MutationCreateLearningJourneyArgs = {
  command: CreateLearningJourneyCommand;
};


export type MutationCreateLearningPathArgs = {
  command: CreateLearningPathCommand;
};


export type MutationCreatePaymentLinkArgs = {
  input: CreatePaymentLinkInput;
};


export type MutationCreatePersonalisedStoneModeArgs = {
  input: CreatePersonalisedStoneModeInput;
  userId: Scalars['ID']['input'];
};


export type MutationCreateShipmentArgs = {
  cmd: CreateShipmentInput;
};


export type MutationCreateStaffUserArgs = {
  input: CreateStaffUserInput;
};


export type MutationCreateStoneModeArgs = {
  input: CreateStoneModeInput;
};


export type MutationDeactivateAcquisitionSourceArgs = {
  sourceId: Scalars['ID']['input'];
};


export type MutationDeactivateCarrierArgs = {
  carrierId: Scalars['ID']['input'];
};


export type MutationDeactivatePaymentLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDefineCapabilityPackageArgs = {
  input: DefineCapabilityPackageInput;
};


export type MutationDeleteManualVnsSessionArgs = {
  input: DeleteManualVnsSessionInput;
};


export type MutationDeletePlannedActivityArgs = {
  command: DeletePlannedActivityCommand;
};


export type MutationDeleteRevenueTargetArgs = {
  month: Scalars['String']['input'];
};


export type MutationDisableStoneModeArgs = {
  modeId: Scalars['ID']['input'];
};


export type MutationEditManualVnsSessionArgs = {
  input: EditManualVnsSessionInput;
};


export type MutationEnableStoneModeArgs = {
  modeId: Scalars['ID']['input'];
};


export type MutationEndVnsSessionArgs = {
  input: EndVnsSessionCommand;
};


export type MutationEraseJournalNoteArgs = {
  input: EraseJournalNoteInput;
};


export type MutationErasePartnerEnquiryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEraseWaitlistSignalArgs = {
  email: Scalars['String']['input'];
};


export type MutationExportCustomersArgs = {
  columns: ExportColumnsInput;
  filter?: InputMaybe<CustomerFilter>;
  justification: Scalars['String']['input'];
};


export type MutationExportWaitlistSignalsArgs = {
  input: WaitlistExportInput;
};


export type MutationExtendMemberSubscriptionArgs = {
  input: ExtendMemberSubscriptionInput;
};


export type MutationFinishContentArgs = {
  input: FinishContentCommand;
};


export type MutationGrantCompCapabilityArgs = {
  input: GrantCompCapabilityInput;
};


export type MutationGrantCompPackageArgs = {
  input: GrantCompPackageInput;
};


export type MutationGrantCustomCapabilitiesArgs = {
  input: GrantCustomCapabilitiesInput;
};


export type MutationImportStoneModeParametersArgs = {
  modeId: Scalars['ID']['input'];
  sourceNote?: InputMaybe<Scalars['String']['input']>;
  vendorEntryJson: Scalars['String']['input'];
};


export type MutationInitiateBroadcastArgs = {
  input: InitiateBroadcastInput;
};


export type MutationInitiateBulkAssignmentArgs = {
  input: InitiateBulkAssignmentInput;
};


export type MutationInitiateReturnArgs = {
  input: InitiateReturnInput;
};


export type MutationLikeContentArgs = {
  input: LikeContentCommand;
};


export type MutationLinkEntitlementToUserArgs = {
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationLinkReplacementShipmentArgs = {
  input: LinkReplacementShipmentInput;
};


export type MutationLogManualVnsSessionArgs = {
  input: LogManualVnsSessionInput;
};


export type MutationMapStimulationCapabilityArgs = {
  capability: Capability;
  modeIds: Array<Scalars['ID']['input']>;
};


export type MutationMarkEntitlementGiftArgs = {
  input: MarkEntitlementGiftInput;
};


export type MutationMarkReturnReceivedArgs = {
  input: MarkReturnReceivedInput;
};


export type MutationMarkReturnShippedArgs = {
  input: MarkReturnShippedInput;
};


export type MutationMarkShipmentDeliveredArgs = {
  shipmentId: Scalars['ID']['input'];
};


export type MutationMarkShipmentReturnedArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  shipmentId: Scalars['ID']['input'];
};


export type MutationMarkShipmentShippedArgs = {
  cmd: MarkShipmentShippedInput;
};


export type MutationMoveStoneModeArgs = {
  modeId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};


export type MutationOnboardMemberArgs = {
  input: MemberOnboardingInput;
};


export type MutationOnboardParticipantArgs = {
  input: ParticipantOnboardingRequest;
};


export type MutationOpenServiceCaseArgs = {
  input: OpenServiceCaseInput;
};


export type MutationPlaceCapabilityPackageArgs = {
  packageKey: Scalars['ID']['input'];
  sitsAbove?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationPlanActivityArgs = {
  command: PlanActivityCommand;
};


export type MutationPreRegisterDeviceSerialArgs = {
  input: PreRegisterDeviceSerialInput;
};


export type MutationPrepareBulkAssignmentArgs = {
  input: PrepareBulkAssignmentInput;
};


export type MutationReactivateEntitlementArgs = {
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRecordBiofeedbackSessionArgs = {
  input: RecordBiofeedbackSessionCommand;
};


export type MutationRecordBodyMetricArgs = {
  input: RecordBodyMetricCommand;
};


export type MutationRecordCheckinSessionArgs = {
  input: RecordCheckinSessionCommand;
};


export type MutationRecordConsultOutcomeArgs = {
  consultNumber: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome: ConsultOutcome;
  participantId: Scalars['ID']['input'];
};


export type MutationRecordDailyLogArgs = {
  input: RecordDailyLogCommand;
};


export type MutationRecordDailyPainLevelArgs = {
  input: RecordDailyPainLevelCommand;
};


export type MutationRecordDailyReflectionArgs = {
  input: RecordDailyReflectionCommand;
};


export type MutationRecordDataExportArgs = {
  input: RecordDataExportInput;
};


export type MutationRecordDojoContentProgressArgs = {
  command: RecordDojoContentProgressCommand;
};


export type MutationRecordEmotionalStateArgs = {
  input: RecordEmotionalStateCommand;
};


export type MutationRecordFeelingMetricArgs = {
  input: RecordFeelingMetricCommand;
};


export type MutationRecordFirstConsultArgs = {
  consultDate: Scalars['Date']['input'];
  customerId: Scalars['ID']['input'];
};


export type MutationRecordJournalNoteArgs = {
  input: RecordJournalNoteInput;
};


export type MutationRecordLessonsProgressArgs = {
  input: RecordLessonsProgress;
};


export type MutationRecordMindstateMetricArgs = {
  input: RecordMindstateMetricCommand;
};


export type MutationRecordPastConsultArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome: ConsultOutcome;
  participantId: Scalars['ID']['input'];
  scheduledDate: Scalars['DateTime']['input'];
  type: ConsultType;
};


export type MutationRecordRefundReviewArgs = {
  input: RecordRefundReviewInput;
};


export type MutationRecordVitalMetricArgs = {
  input: RecordVitalMetricCommand;
};


export type MutationRecordVnsSessionArgs = {
  input: RecordVnsSessionCommand;
};


export type MutationRecordVnsSessionPostVitalsArgs = {
  input: RecordVnsSessionPostVitalsCommand;
};


export type MutationRecordWearableHeartbeatArgs = {
  input: WearableHeartbeatInput;
};


export type MutationRegisterLoginArgs = {
  timezone: Scalars['String']['input'];
};


export type MutationRegisterVnsDeviceArgs = {
  input: RegisterVnsDeviceInput;
};


export type MutationRejectBulkAssignmentArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveCouponCodeArgs = {
  couponCode: Scalars['String']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationRemovePathFromLearningJourneyArgs = {
  command: RemovePathFromJourneyCommand;
};


export type MutationRemovePersonalisedStoneModeArgs = {
  expectedModeId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationReplacePlannedActivityArgs = {
  command: ReplacePlannedActivityCommand;
};


export type MutationReportStoneModeWrittenArgs = {
  input: ReportStoneModeWrittenInput;
};


export type MutationResendActivationEmailArgs = {
  entitlementId: Scalars['ID']['input'];
};


export type MutationResolveServiceCaseArgs = {
  input: ResolveServiceCaseInput;
};


export type MutationRetryFailedBroadcastRecipientsArgs = {
  broadcastId: Scalars['ID']['input'];
};


export type MutationRevealPartnerEnquiryContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReverseMemberSubscriptionCancellationArgs = {
  customerId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type MutationRevokeCompCapabilityArgs = {
  input: RevokeCompCapabilityInput;
};


export type MutationRevokeCustomCapabilityGrantArgs = {
  input: RevokeCustomCapabilityGrantInput;
};


export type MutationRevokeEntitlementArgs = {
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationScheduleConsultArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  participantId: Scalars['ID']['input'];
  scheduledDate: Scalars['DateTime']['input'];
  type: ConsultType;
};


export type MutationSendPushNotificationArgs = {
  input: SendPushNotificationCommand;
};


export type MutationSetCapabilityPackageModesArgs = {
  input: SetCapabilityPackageModesInput;
};


export type MutationSetDefaultStoneModeArgs = {
  modeId: Scalars['ID']['input'];
};


export type MutationSetMemberGoalArgs = {
  goal?: InputMaybe<MemberGoal>;
};


export type MutationSetPartnerEnquiryStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationSetPersonalisedStoneModeParametersArgs = {
  expectedModeId?: InputMaybe<Scalars['ID']['input']>;
  parameters: StimulationParameterValuesInput;
  sourceNote?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationSetPracticeReminderArgs = {
  input: PracticeReminderInput;
};


export type MutationSetResolutionArgs = {
  input: SetResolutionInput;
};


export type MutationSetRevenueTargetArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  month: Scalars['String']['input'];
  targetAmount: Scalars['BigDecimal']['input'];
};


export type MutationSetStoneModeLimitsArgs = {
  input: SetStoneModeLimitsInput;
};


export type MutationSetStoneModeParametersArgs = {
  input: SetStoneModeParametersInput;
};


export type MutationStartChatArgs = {
  participantId: Scalars['ID']['input'];
};


export type MutationStartContentArgs = {
  input: StartContentCommand;
};


export type MutationStartVnsSessionArgs = {
  input: StartVnsSessionCommand;
};


export type MutationSubmitAppFeedbackArgs = {
  input: SubmitAppFeedbackInput;
};


export type MutationSubmitComponentFeedbackArgs = {
  input: SubmitComponentFeedbackCommand;
};


export type MutationSubmitDeviceSessionTraceArgs = {
  input: SubmitDeviceSessionTraceInput;
};


export type MutationSubmitReportFeedbackArgs = {
  input: SubmitReportFeedbackCommand;
};


export type MutationSuspendEntitlementArgs = {
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSuspendUserArgs = {
  participantId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSyncRolesToFirebaseArgs = {
  accountHolderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationTrackContentClickArgs = {
  input: TrackContentClickInput;
};


export type MutationUnassignUserFromLearningJourneyArgs = {
  command: UnassignUserFromJourneyCommand;
};


export type MutationUnlikeContentArgs = {
  input: UnlikeContentCommand;
};


export type MutationUnlinkEntitlementFromUserArgs = {
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationUnlinkSubscriptionArgs = {
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationUnsuspendUserArgs = {
  participantId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAcquisitionSourceArgs = {
  cmd: UpdateAcquisitionSourceInput;
};


export type MutationUpdateBodyMeasurementsArgs = {
  input: UpdateBodyMeasurementsInput;
};


export type MutationUpdateBroadcastOptOutArgs = {
  input: UpdateBroadcastOptOutInput;
};


export type MutationUpdateCapabilityPackageContentsArgs = {
  input: UpdateCapabilityPackageContentsInput;
};


export type MutationUpdateCapabilitySettingsArgs = {
  input: UpdateCapabilitySettingsInput;
};


export type MutationUpdateCarrierArgs = {
  cmd: UpdateCarrierInput;
};


export type MutationUpdateContentAssignmentOptOutArgs = {
  input: UpdateContentAssignmentOptOutInput;
};


export type MutationUpdateCustomActivityArgs = {
  command: UpdateCustomActivityCommand;
};


export type MutationUpdateDeviceOfflineCapArgs = {
  value: Scalars['Int']['input'];
};


export type MutationUpdateDeviceRecordWindowDaysArgs = {
  days: Scalars['Int']['input'];
};


export type MutationUpdateIdentityInformationArgs = {
  input: UpdateIdentityInformationInput;
};


export type MutationUpdateLearningJourneyArgs = {
  command: UpdateLearningJourneyCommand;
};


export type MutationUpdateLearningPathArgs = {
  command: UpdateLearningPathCommand;
};


export type MutationUpdateMessageReadStatusArgs = {
  messageReadStatus: MessageReadStatus;
  notificationDeliveryId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateOfflineSessionAllowanceArgs = {
  value: Scalars['Int']['input'];
};


export type MutationUpdateParticipantNoteArgs = {
  input: UpdateParticipantNoteInput;
};


export type MutationUpdatePersonalGoalsArgs = {
  command: UpdatePersonalGoalsCommand;
};


export type MutationUpdatePersonalisedStoneModeDetailsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  expectedModeId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdatePreferredCheckinArgs = {
  command: UpdatePreferredCheckinCommand;
};


export type MutationUpdateShipmentTrackingArgs = {
  cmd: UpdateShipmentTrackingInput;
};


export type MutationUpdateStoneModeDetailsArgs = {
  input: UpdateStoneModeDetailsInput;
};


export type MutationUpdateTargetVitalsArgs = {
  command: UpdateTargetVitalsCommand;
};


export type MutationUpdateTimeBlockPreferencesArgs = {
  command: UpdateTimeBlockPreferencesCommand;
};


export type MutationUpdateTimezoneArgs = {
  timezone: Scalars['String']['input'];
};


export type MutationUpdateUserNameArgs = {
  input: UpdateUserNameInput;
};


export type MutationUpdateVnsDeviceNicknameArgs = {
  input: UpdateVnsDeviceNicknameInput;
};


export type MutationUpdateWeeklyCommitmentArgs = {
  command: UpdateWeeklyCommitmentCommand;
};

/**
 * The health areas the care team records for a member (the care team's reading). Not the goal the member picks
 * for themselves, which is MemberGoal.
 */
export enum NeedsDomain {
  AnxietyDepression = 'anxiety_depression',
  DigestiveGut = 'digestive_gut',
  EnergyFatigue = 'energy_fatigue',
  GeneralPreventative = 'general_preventative',
  Hormonal = 'hormonal',
  InflammationLongevity = 'inflammation_longevity',
  Pain = 'pain',
  PerformanceRecovery = 'performance_recovery',
  SexualHealth = 'sexual_health',
  Sleep = 'sleep',
  StressBurnout = 'stress_burnout'
}

/**
 * Who recorded a health area: the member themself (member_stated; reserved, not written today), a coach set it, or
 * Claude derived it.
 */
export enum NeedsSource {
  ClaudeDerived = 'claude_derived',
  CoachSet = 'coach_set',
  MemberStated = 'member_stated'
}

/**
 * A single newsletter sign-up (PII) — a person who opted in to hear from us via the checkout
 * NewsletterCta. Only ever returned by the operations/admin-gated newsletterSignals query (YOJO-2233).
 * Unlike the waitlist views this list is NOT test-filtered — it shows ALL newsletter sign-ups.
 */
export type NewsletterSignal = {
  __typename: 'NewsletterSignal';
  consent: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export enum NoteCategory {
  Adherence = 'adherence',
  BehavioralPattern = 'behavioral_pattern',
  ConsultTranscript = 'consult_transcript',
  DeviceIssue = 'device_issue',
  DeviceUsage = 'device_usage',
  Exercise = 'exercise',
  General = 'general',
  LifeEvent = 'life_event',
  MentalHealth = 'mental_health',
  Nutrition = 'nutrition',
  ProgressMilestone = 'progress_milestone',
  Setback = 'setback',
  Sleep = 'sleep',
  Stress = 'stress',
  TavnsSideEffect = 'tavns_side_effect'
}

export enum NoteStatus {
  Archived = 'archived',
  Published = 'published'
}

export type NotificationDeliveryLog = {
  __typename: 'NotificationDeliveryLog';
  createdAtTz: Scalars['DateTime']['output'];
  deliveredAtTz?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  messageReadAtTz?: Maybe<Scalars['DateTime']['output']>;
  messageReadStatus: MessageReadStatus;
  notificationDeliveryId: Scalars['ID']['output'];
  payload: NotificationMessage;
  status: NotificationDeliveryStatus;
  tokenId: Scalars['String']['output'];
  type: NotificationTokenType;
  userId: Scalars['String']['output'];
};

export enum NotificationDeliveryStatus {
  Cancelled = 'cancelled',
  Failed = 'failed',
  Retrying = 'retrying',
  Sent = 'sent'
}

export type NotificationMessage = {
  __typename: 'NotificationMessage';
  additionalPayload: Scalars['JSON']['output'];
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export enum NotificationTokenType {
  Console = 'console',
  Firebase = 'firebase'
}

export type NumberedListBlock = {
  __typename: 'NumberedListBlock';
  items: Array<Scalars['String']['output']>;
};

export type Nurse = {
  __typename: 'Nurse';
  accountId: Scalars['ID']['output'];
  messagingToken?: Maybe<MessagingToken>;
  nurseId: Scalars['ID']['output'];
  pii?: Maybe<Pii>;
  roles: Array<Role>;
  status: UserStatus;
  timezone?: Maybe<Scalars['String']['output']>;
};

/** Reserved onboarding/stateful-progression container. */
export type OnboardingExperienceState = {
  __typename: 'OnboardingExperienceState';
  /**
   * Whether every starter item of the first 21 days that can still be planned has been planned (at some point: an
   * item the member or a coach removed, swapped or completed still counts). false = missing, and submitting the
   * onboarding again repairs it. null = not applicable: status pending, no onboarding session, or the first 21 days
   * have passed.
   */
  starterContentPlanned?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the member has been attached to the starting journey (at some point: a journey a coach later removed
   * still counts), or no journey is flagged as starting. false = missing, and submitting the onboarding again
   * repairs it. null = not applicable: status pending, no onboarding session, or the first 21 days have passed.
   */
  startingJourneysAssigned?: Maybe<Scalars['Boolean']['output']>;
  /** Current onboarding status. v1 mirrors the event-sourced Account onboarding state. */
  status: ParticipantOnboardingStatus;
};

/** AI-generated insight from an onboarding session */
export type OnboardingInsight = {
  __typename: 'OnboardingInsight';
  /** When this insight was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this insight */
  id: Scalars['ID']['output'];
  /** Personalized message with specific recommendation */
  message: Scalars['String']['output'];
  /** Priority level of the insight */
  priority: InsightPriority;
  /** Specific action to take */
  recommendation: Scalars['String']['output'];
  /** Recommended content IDs that might help the user */
  recommendedContent?: Maybe<Array<CustomActivityId | ExternalContentId | MobileWidgetId>>;
  /** Short, engaging title */
  title: Scalars['String']['output'];
};

/** Records an onboarding session with all user responses and measurements */
export type OnboardingSession = {
  __typename: 'OnboardingSession';
  /** Empty for sessions recorded before the four-question onboarding. */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** When the onboarding was completed */
  endTime: Scalars['DateTime']['output'];
  /** Sex at birth. */
  gender: Gender;
  /** The goal picked in this session. The member's current goal is Preferences.memberGoal. */
  goal?: Maybe<MemberGoal>;
  /** AI-generated insights based on this onboarding data */
  insights?: Maybe<Array<OnboardingInsight>>;
  /** Answers of the earlier onboarding. Empty for four-question sessions. */
  legacy?: Maybe<LegacyOnboardingAnswers>;
  /** User's name */
  name: Scalars['String']['output'];
  /** Unique identifier for this session */
  onboardingSessionId: Scalars['ID']['output'];
  /** When the onboarding started */
  startTime: Scalars['DateTime']['output'];
  /** User who completed the onboarding */
  userId: Scalars['String']['output'];
};

export type OpenServiceCaseInput = {
  customerId: Scalars['ID']['input'];
  deviceSerial?: InputMaybe<Scalars['String']['input']>;
  issueType: IssueType;
  performedBy: Scalars['String']['input'];
  reason: ServiceCaseReason;
  reasonDetail?: InputMaybe<Scalars['String']['input']>;
  shipmentId: Scalars['ID']['input'];
};

export enum OverallHealth {
  Excellent = 'excellent',
  Good = 'good',
  HardToSay = 'hard_to_say',
  NotGreat = 'not_great',
  Okay = 'okay',
  Poor = 'poor'
}

/**
 * The blast radius of a proposed change (ADR-0005 req #4) — live numbers in front of the admin at the
 * moment of the decision, not a CI artefact from the last deploy. Computed, never stored.
 */
export type PackageChangeImpact = {
  __typename: 'PackageChangeImpact';
  /** Capabilities the change would ADD. Growth needs no dialog; listed for completeness. */
  addedCapabilities: Array<Capability>;
  changeKind: PackageChangeKind;
  /**
   * One row per numeric dial the change would move (YOJO-2559 [scans/day package dial]). Empty when no
   * dial changes. Every TIGHTENING also produces a line in `warnings`, so an admin reading only the
   * warnings cannot miss it — and `fleetWide` is set, because a dial reaches every member the package
   * applies to and the holder counts above do not measure it.
   */
  dialChanges: Array<PackageDialChange>;
  /**
   * True only for a floor change. The floor is every member's baseline, so members with no grant record
   * at all — the majority — are affected too and cannot be counted from the holder view. Treat the
   * counts below as a lower bound over the known holders and the headline as "every member".
   */
  fleetWide: Scalars['Boolean']['output'];
  /** How many holders the counts were computed over: the package's live holders, or every known holder. */
  holdersInScope: Scalars['Int']['output'];
  /** The package being changed — for a floor change, the package proposed as the NEW floor. */
  packageKey: Scalars['ID']['output'];
  /** One row per capability the change would remove. */
  removedCapabilities: Array<CapabilityImpact>;
  /**
   * Configuration problems found while computing this — an unknown package key, an unbootstrapped
   * floor. Surfaced rather than thrown: a preview that errors teaches the admin nothing.
   */
  warnings: Array<Scalars['String']['output']>;
};

/**
 * Ask what a proposed change would cost before making it. One input for all three changes, because they
 * are one question ("who would lose what?") asked about a different substitution.
 */
export type PackageChangeImpactInput = {
  /**
   * The FULL proposed capability set, exactly as `updateCapabilityPackageContents` takes it. Required
   * for `contents_update`; ignored for `archive` and `floor_change`, where the proposed set is implied.
   */
  capabilities?: InputMaybe<Array<Capability>>;
  changeKind: PackageChangeKind;
  /**
   * The FULL proposed dial list, exactly as `updateCapabilityPackageContents` takes it. Optional: an
   * absent list previews "this package would have no dials", which for a package that has some is a
   * REMOVAL — a widening — so an editor that forgets to send it can only understate a tightening, never
   * invent one. Ignored for `floor_change`, where the incoming package's own dials are the proposal.
   */
  dials?: InputMaybe<Array<PackageDialInput>>;
  /**
   * The package being changed. For `floor_change` this is the package PROPOSED as the new floor — the
   * outgoing floor is read from the live settings, so a preview can never describe a floor that is not
   * actually in force.
   */
  packageKey: Scalars['ID']['input'];
};

/** Which change the blast-radius dry run is being asked about. */
export enum PackageChangeKind {
  /** The package stops contributing anything to anyone — the largest shrink there is. */
  Archive = 'archive',
  /** The package keeps existing with a different capability set. */
  ContentsUpdate = 'contents_update',
  /** A different package becomes every member's baseline. Fleet-wide. */
  FloorChange = 'floor_change'
}

/**
 * A NUMERIC per-package limit (YOJO-2559 [scans/day package dial], domain-model.md §Q15.11) — the second
 * half of a package's contents, alongside its capability set.
 *
 * A dial is for a number you SPEND (how many scans a day); a capability is for a thing you HOLD. The scan
 * itself stays a capability — this only limits how often it may be exercised.
 *
 * CLIENT GUARDRAIL: a dial that is ABSENT is never zero. Never read a missing dial, or a missing `dials`
 * list, as "you may do none of these" — that inverts the never-dark promise (ADR-0001). Zero is
 * expressible and means exactly what it says, but it has to be typed by an admin.
 *
 * UNLIMITED IS THE VALUE `-1`, the one reserved encoding (YOJO-2588 [B-43 unlimited dial value]). It
 * appears anywhere a dial value does, including `MemberCapabilities.effectiveDials`. Read it through a
 * single named helper (`isUnlimitedDial(value)`) — never an inline `value === -1`, and never render the
 * number itself, or a member eventually sees "-1 scans left".
 *
 * The two ways a package imposes no limit say DIFFERENT things:
 *   · dial ABSENT from a package's list → the package expresses no opinion; its holders inherit the
 *     floor's number (this is why a tier nobody dialled cannot leak the paid allowance)
 *   · value `-1` → the package says unlimited out loud, which beats every number in the MAX across the
 *     member's packages. This is how Activate/Elevate get unlimited scans while Free keeps 2/day.
 */
export enum PackageDial {
  /**
   * Face scans per day. Counted server-side at recording time over UTC day boundaries (member-local
   * midnight is deferred to YOJO-2572). One unit is a scan occasion (YOJO-3440 [a face-scan submission
   * carrying both a before and an after is one occasion]): a session's before and after together, or one
   * standalone capture. Joining an occasion already counted spends nothing.
   */
  ScansPerDay = 'scans_per_day'
}

/**
 * What a proposed change would do to ONE numeric dial (YOJO-2559 [scans/day package dial]).
 *
 * Reported FLEET-WIDE — a delta, not a holder count. The dial that usually matters is the FLOOR's, which
 * every member resolves without holding it, so a holder count would report zero affected about a change
 * that touches everybody. Nobody is shielded the way they are for capabilities either: the effective dial
 * is a MAX over the member's packages and any custom grants' dials (YOJO-2598 [custom capability
 * grants]); frozen-set individual grants (comp/grandfather) carry no dials.
 */
export type PackageDialChange = {
  __typename: 'PackageDialChange';
  /**
   * The value in force today. Null means the package names no dial (its holders inherit the floor's
   * number); `-1` means it names one and says unlimited.
   */
  currentValue?: Maybe<Scalars['Int']['output']>;
  dial: PackageDial;
  /**
   * The value after the change. Null means the change REMOVES the dial (back to inheriting); `-1` means
   * the change makes it unlimited. Both are widenings, so neither is ever `tightened`.
   */
  proposedValue?: Maybe<Scalars['Int']['output']>;
  /**
   * True when the change TIGHTENS the dial — a smaller number, or a limit where there was none. These
   * rows require shrinkMode=outright with a typed confirmation; loosening or removing needs no dialog.
   */
  tightened: Scalars['Boolean']['output'];
};

/**
 * One `dial → value` pair (YOJO-2559 [scans/day package dial]). Sent as a list because GraphQL has no
 * untyped map.
 *
 * The list is a full SNAPSHOT, and the two ways to impose no limit mean different things
 * (YOJO-2588 [B-43 unlimited dial value]):
 *
 *   · OMIT the dial → this package expresses no opinion, and its holders inherit the floor's number.
 *     That is the pricing-leak-by-omission guard: a tier somebody forgot to dial does not become free.
 *   · send `-1` (UNLIMITED) → this package says its holders have no limit, which beats every number in
 *     the MAX across the member's packages. This is how Activate/Elevate get unlimited scans.
 *
 * `-1` is the ONE reserved encoding. Every other negative is still rejected, and nullable-means-unlimited
 * does not exist here — absence already means something else.
 */
export type PackageDialInput = {
  dial: PackageDial;
  /**
   * The limit per period. 0 is legal and means 'none of these, ever'; `-1` means UNLIMITED. Any other
   * negative value is rejected.
   */
  value: Scalars['Int']['input'];
};

export type PageInfo = {
  __typename: 'PageInfo';
  /** ID of the last article in the page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more items after this page */
  hasNextPage: Scalars['Boolean']['output'];
};

/** Pagination using article ID as cursor. After parameter should contain the ID of the last article in previous page. */
export type PaginationInput = {
  /** ID of the last article from previous page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to fetch */
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ParagraphBlock = {
  __typename: 'ParagraphBlock';
  content?: Maybe<RichContent>;
};

export type ParagraphWithHeadingBlock = {
  __typename: 'ParagraphWithHeadingBlock';
  content?: Maybe<RichContent>;
  heading: Scalars['String']['output'];
};

export type ParagraphWithSubheadingBlock = {
  __typename: 'ParagraphWithSubheadingBlock';
  content?: Maybe<RichContent>;
  subheading: Scalars['String']['output'];
};

/** Where a saved parameter set came from (YOJO-3259): typed in (`manual`) or imported from a vendor modes.json entry. */
export enum ParameterSetSource {
  Manual = 'manual',
  VendorImport = 'vendor_import'
}

export type Participant = {
  __typename: 'Participant';
  /** Get all unrolled activities for this participant in a date range */
  activities: Array<Activity>;
  /** User's activity planning containing all their planned activities */
  activityPlanning?: Maybe<ActivityPlanning>;
  /**
   * Whether this member can post in their care chat. Read by the member themself
   * and by the care team (nurses, admins); anyone else reads an open chat.
   */
  careChat: CareChat;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Returns the first learning journey assigned to this participant.
   * Currently, we only support one type of journey (Dojo), but this may change in the future.
   * Returns null if no journey is assigned.
   */
  dojoLearningJourney?: Maybe<LearningJourney>;
  /**
   * Backend-governed first-time-experience state (YOJO-2016). The server bakes one
   * semantic value per governed experience; the client dispatches on it and performs
   * no eligibility arithmetic. Delivered in this single authenticated load. Member-self
   * only: null when resolved for any participant other than the authenticated member.
   */
  experienceState?: Maybe<ExperienceState>;
  /**
   * The member's own goal beside the care team's reading of them (YOJO-3288): the care team's primary and secondary
   * health area, the goal that applies, and whether the member picked their goal after the care team last
   * recorded one. For nurses and admins only; empty for everyone else, the member included. Empty when the
   * member has no preferences record. The member's own goal itself is on preferences.memberGoal.
   */
  goalOverview?: Maybe<GoalOverview>;
  learningJourneys?: Maybe<Array<LearningJourney>>;
  /** Customer record linked via activated entitlement (cross-context resolution: User → CRM) */
  linkedCustomer?: Maybe<Customer>;
  membership?: Maybe<Membership>;
  messagingToken?: Maybe<MessagingToken>;
  onboardingStatus: ParticipantOnboardingStatus;
  participantId: Scalars['ID']['output'];
  pii?: Maybe<Pii>;
  /** User's preferences including personal goals, weekly commitments and target vitals */
  preferences?: Maybe<Preferences>;
  status: UserStatus;
  timezone?: Maybe<Scalars['String']['output']>;
  /** The member's own Today. Null until onboarding is complete, and for anyone who is not this member (so: null in lists). */
  today?: Maybe<Today>;
  /** The member's own sessions for their day. Null for anyone who is not this member (so: null in lists). */
  todaySessions?: Maybe<TodaySessions>;
  updatedAt: Scalars['DateTime']['output'];
  usageStats?: Maybe<ParticipantUsageStats>;
  /** Get all wearable integrations for this participant */
  wearableIntegrations: Array<WearableIntegration>;
};


export type ParticipantActivitiesArgs = {
  dateRange: DateRangeInput;
};

export type ParticipantFilter = {
  emailContains?: InputMaybe<Scalars['String']['input']>;
  includeSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  includeTestAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  userIdEquals?: InputMaybe<Scalars['String']['input']>;
};

export type ParticipantMetrics = {
  __typename: 'ParticipantMetrics';
  activeParticipants: QuickStat;
  confirmedDiagnoses: QuickStat;
  needsAttention: QuickStat;
  treatmentAdherence: QuickStat;
};

/** Participant Notes - Type Definitions */
export type ParticipantNote = {
  __typename: 'ParticipantNote';
  authorId: Scalars['ID']['output'];
  categories: Array<NoteCategory>;
  /**
   * The consult this note links to (via linkedConsultNumber), within the same participant.
   * Null if the note has no linked consult or the referenced consult does not exist
   * (the link is a soft reference and dangling references are tolerated).
   */
  consult?: Maybe<Consult>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  flagReason?: Maybe<Scalars['String']['output']>;
  flagStatus: FlagStatus;
  linkedConsultNumber?: Maybe<Scalars['Int']['output']>;
  linkedToMessageId?: Maybe<Scalars['String']['output']>;
  noteId: Scalars['ID']['output'];
  participantId: Scalars['ID']['output'];
  status: NoteStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Removed upon YOJO-3297. Use `MemberOnboardingInput`. Installed app builds keep sending it until then. */
export type ParticipantOnboardingRequest = {
  /** Age bracket of the participant. */
  ageBracket?: InputMaybe<AgeBracket>;
  cognitiveMeasurements?: InputMaybe<Array<CognitiveMeasurementInput>>;
  /** Full date of birth (optional). When provided, stored as date_of_birth in PII for exact age calculation. */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  desiredState?: InputMaybe<Array<DesiredState>>;
  feelingMeasurements?: InputMaybe<Array<FeelingMeasurementInput>>;
  gender: Gender;
  height: HeightInput;
  motivationToImproveStress?: InputMaybe<StressMotivation>;
  /** Basic identity */
  name: Scalars['String']['input'];
  /** Self-reported health */
  overallHealth: OverallHealth;
  pastFailedStrategies?: InputMaybe<Array<StressStrategy>>;
  /** Stress impact - deprecated, nullable for backward compat with old mobile app versions */
  stressImpact?: InputMaybe<StressImpact>;
  stressManagementMethods?: InputMaybe<Array<StressManagementMethod>>;
  timeOfDayStress?: InputMaybe<Array<TimeOfDay>>;
  /** New measurement fields to replace ppgSession */
  vitalMeasurements?: InputMaybe<Array<VitalMeasurementInput>>;
  weight: WeightInput;
};

export enum ParticipantOnboardingStatus {
  Completed = 'completed',
  Pending = 'pending'
}

export type ParticipantSession = {
  __typename: 'ParticipantSession';
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  lastActiveAt: Scalars['DateTime']['output'];
  startedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type ParticipantUsageStats = {
  __typename: 'ParticipantUsageStats';
  lastActive?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerEnquiry = {
  __typename: 'PartnerEnquiry';
  businessName?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  receivedAt: Scalars['DateTime']['output'];
  source?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * One partner enquiry with its contact details. Only ever returned by revealPartnerEnquiryContact (YOJO-3371).
 * email and phone are always present (prospect-api requires them); website and socials may be absent.
 */
export type PartnerEnquiryContact = {
  __typename: 'PartnerEnquiryContact';
  businessName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  socials?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/**
 * Outcome of an erasePartnerEnquiry mutation (YOJO-3371). The erase is GDPR right-to-erasure and is audited;
 * erasedCount is 1 when the enquiry was erased and 0 when it was already gone.
 */
export type PartnerEnquiryEraseResult = {
  __typename: 'PartnerEnquiryEraseResult';
  erasedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

/** Partner enquiries staff-list filter (YOJO-3371); every field is optional. */
export type PartnerEnquiryFilterInput = {
  /** Default 25; clamped to 1..100 (same as the list_partner_enquiries MCP tool). */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Default 0; a negative value is clamped to 0 (same as the MCP tool). */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** First UTC day to include (inclusive). */
  receivedFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Last UTC day to include (inclusive). receivedFrom after receivedTo -> error. */
  receivedTo?: InputMaybe<Scalars['Date']['input']>;
  /** new | contacted | partnered | declined; omit for every status. Unknown value -> error before any downstream call. */
  status?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Partner enquiries staff list (YOJO-3371 [care-portal CRM page for partner enquiries]), slice 1. No contact
 * details on PartnerEnquiry: email, phone, website and socials only come through
 * the audited revealPartnerEnquiryContact (PartnerEnquiryContact).
 */
export type PartnerEnquiryPage = {
  __typename: 'PartnerEnquiryPage';
  enquiries: Array<PartnerEnquiry>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

/** The outcome of a status move, as prospect-api answered it. Re-read the list for the full row. */
export type PartnerEnquiryStatusChange = {
  __typename: 'PartnerEnquiryStatusChange';
  changed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  previousStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentBucket = {
  __typename: 'PaymentBucket';
  amount: Scalars['BigDecimal']['output'];
  count: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
};

/** Represents a Stripe Payment Link */
export type PaymentLink = {
  __typename: 'PaymentLink';
  /** Whether the payment link is currently active */
  active: Scalars['Boolean']['output'];
  /** Unique Stripe Payment Link ID (e.g., plink_xxx) */
  id: Scalars['ID']['output'];
  /** Internal reference name */
  name?: Maybe<Scalars['String']['output']>;
  /** Purpose/campaign identifier (e.g., marketing_campaign_q1) */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Source of the payment link (yojo_api or stripe) */
  source: PaymentLinkSource;
  /** The shareable URL for this payment link */
  url: Scalars['String']['output'];
};

/** Source/management status of a Payment Link */
export enum PaymentLinkSource {
  /** Created via Stripe Dashboard, may lack proper metadata */
  Stripe = 'stripe',
  /** Created and managed by yojo-api with proper metadata */
  YojoApi = 'yojo_api'
}

/** Payment strategy for Payment Links */
export enum PaymentLinkStrategy {
  /** Klarna Buy Now Pay Later */
  PayLater = 'PAY_LATER',
  /** Card payments (Visa, Mastercard, etc.) */
  PayNow = 'PAY_NOW'
}

/**
 * Whether the member's Stone has reported holding their current personalised mode. `reportedAt` null means not
 * confirmed on the device yet: the app has not reported it since the mode was saved.
 */
export type PersonalisedModeDeviceReport = {
  __typename: 'PersonalisedModeDeviceReport';
  reportedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Whether a member can have a personalised Stone mode now: a linked Stone (not an Alpha), and a plan that includes a
 * personalised mode. The plan is never named.
 */
export type PersonalisedModeEligibility = {
  __typename: 'PersonalisedModeEligibility';
  hasStone: Scalars['Boolean']['output'];
  planIncludesPersonalised: Scalars['Boolean']['output'];
};

/**
 * A member's own Stone mode, made for them by an admin or coach. It sits in the member's slot 0 and every shared mode
 * moves up one; nobody else sees it and it is not in the shared catalogue. `outsideCurrentLimits` flags a set saved
 * under limits that have since been tightened (the set is kept, not changed).
 */
export type PersonalisedStoneMode = {
  __typename: 'PersonalisedStoneMode';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detailsVersion: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  /** The safety-limits version the current set was checked against when it was saved. */
  limitsVersion: Scalars['Int']['output'];
  modeId: Scalars['ID']['output'];
  outsideCurrentLimits: Scalars['Boolean']['output'];
  parameters: StimulationParameters;
  parametersVersion: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * One member's personalised Stone mode in one read: whether they can have one now, their current mode (null when
 * they have none), every saved parameter-set version of every personalised mode they held, and whether their Stone
 * has confirmed holding the current mode.
 */
export type PersonalisedStoneModeRead = {
  __typename: 'PersonalisedStoneModeRead';
  deviceReport: PersonalisedModeDeviceReport;
  eligibility: PersonalisedModeEligibility;
  /** Every saved parameter-set version of every personalised mode the member held, oldest first; never changed. */
  history: Array<PersonalisedStoneModeVersion>;
  /** The member's current personalised mode; null when they have none (never created, or removed). */
  mode?: Maybe<PersonalisedStoneMode>;
  userId: Scalars['ID']['output'];
};

/**
 * One saved version of a personalised mode's parameter set, as recorded and never changed: the set, the limits
 * version it was checked against, its note, and who saved it and when. Version 1 is the set the mode was created with.
 */
export type PersonalisedStoneModeVersion = {
  __typename: 'PersonalisedStoneModeVersion';
  changedAt: Scalars['DateTime']['output'];
  changedBy: Scalars['String']['output'];
  limitsVersion: Scalars['Int']['output'];
  modeId: Scalars['ID']['output'];
  parameters: StimulationParameters;
  source: ParameterSetSource;
  sourceNote?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** Phone number representation */
export type PhoneNumber = {
  __typename: 'PhoneNumber';
  countryCode: Scalars['String']['output'];
  nationalNumber: Scalars['String']['output'];
};

export type Pii = {
  __typename: 'Pii';
  contactInformation: ContactInformation;
  identityInformation: IdentityInformation;
  piiId: Scalars['ID']['output'];
};

export type PlanActivityCommand = {
  /** ID of the planning to add activity to */
  activityPlanningId: Scalars['ID']['input'];
  /** Content reference to be planned */
  contentReference: ContentReferenceInput;
  /**
   * When to stop planning this activity (optional).
   *
   * If set, the activity will only appear in the user's schedule up to and including this date.
   * After this date passes, the activity will no longer appear in unrolled activities.
   *
   * Use cases:
   * - Day-specific onboarding content (e.g., set endDate to onboardingDate + 1 for Day 1 content)
   * - Limited-time challenges or seasonal activities
   * - Phased learning content that should only be available during specific periods
   *
   * Omit for indefinite planning (activity continues until completed with removeAfterCompletion=true
   * or manually deactivated).
   */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * The Stone mode to plan for a vns_session (optional; care team only). Omit for "member chooses".
   * Refused with extensions.code PLANNED_MODE_REFUSED and a reason when the member cannot run it now;
   * refused as invalid input when the content is not a vns_session or the id is malformed.
   */
  modeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Whether to remove activity after completion
   * Default false for recurring activities
   */
  removeAfterCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When to start planning this activity (optional).
   *
   * If set, the activity will only appear in the user's schedule starting from this date.
   * Before this date, the activity will not appear in unrolled activities.
   *
   * Use cases:
   * - Onboarding content that should start on a specific day
   * - Scheduled challenges or events that begin on a future date
   * - Content unlocking based on program milestones
   *
   * Omit for immediate planning (activity starts appearing right away).
   */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** When the activity should be performed */
  timeSlots: Array<ActivityTimeSlotInput>;
};

/**
 * Only the dates and amounts the plan line needs; each is null unless the line's payment/state uses it. Dates are in
 * the member's zone.
 */
export type PlanDetails = {
  __typename: 'PlanDetails';
  /** Included, yojo, partner or gift: when that coverage ends; null = open-ended. */
  coveredUntil?: Maybe<Scalars['Date']['output']>;
  /** State ended or suspended: when it ended; null = not known. */
  endedOn?: Maybe<Scalars['Date']['output']>;
  /** State ended or suspended: the plan that ended. */
  endedPlan?: Maybe<PlanTier>;
  /** State ending: the day the plan ends. */
  endsOn?: Maybe<Scalars['Date']['output']>;
  /** Payment you: the plan's price; null = unavailable. */
  price?: Maybe<PlanPrice>;
  /** Payment you, state active: the next billing date. */
  renewsOn?: Maybe<Scalars['Date']['output']>;
  /** State paused: the day collection resumes; null = indefinite. */
  resumesOn?: Maybe<Scalars['Date']['output']>;
  /** State grace: the date to update the card by. Null until a fact exists to set it. */
  updateBy?: Maybe<Scalars['Date']['output']>;
};

/** How often a plan price recurs. */
export enum PlanInterval {
  Month = 'month',
  Year = 'year'
}

/** Who pays for the member's plan. Parse tolerantly: values may be added. */
export enum PlanPayment {
  Gift = 'gift',
  Included = 'included',
  None = 'none',
  Partner = 'partner',
  Yojo = 'yojo',
  You = 'you'
}

export type PlanPrice = {
  __typename: 'PlanPrice';
  /** The amount in the currency's minor unit (pence, cents). */
  amountMinor: Scalars['Long']['output'];
  /** Three-letter currency code, lowercase as Stripe gives it (e.g. gbp). */
  currency: Scalars['String']['output'];
  /** How often it is charged. */
  interval: PlanInterval;
};

/** Whether the member's plan is running. Parse tolerantly: values may be added. */
export enum PlanState {
  Active = 'active',
  Ended = 'ended',
  Ending = 'ending',
  Grace = 'grace',
  Paused = 'paused',
  Suspended = 'suspended'
}

/** The member's plan one step ahead: emitted only when the plan or who pays changes. */
export type PlanStep = {
  __typename: 'PlanStep';
  /** Payment you: the first charge date. */
  chargesOn?: Maybe<Scalars['Date']['output']>;
  /** The day it changes; always after today. */
  from: Scalars['Date']['output'];
  /** Payment you: on a price that is no longer the plan's current one. */
  legacyPrice: Scalars['Boolean']['output'];
  /** Who pays from the day it changes. */
  payment: PlanPayment;
  /** The plan from the day it changes. */
  plan: PlanTier;
  /** Payment you: that price; null = unavailable. */
  price?: Maybe<PlanPrice>;
};

/** A plan, as data (not an enum): a new package needs no schema change. */
export type PlanTier = {
  __typename: 'PlanTier';
  /** The capability package key. */
  key: Scalars['String']['output'];
  /** The name the member sees; the key when the package carries no display name. */
  name: Scalars['String']['output'];
};

/** A planned activity with its timing configuration */
export type PlannedActivity = {
  __typename: 'PlannedActivity';
  /**
   * Whether this activity is still active. The activity
   * can become inactive if;
   * - the endDate has passed, or;
   * - it has been completed and removeAfterCompletion is true, or;
   * - it has been manually deactivated by care-team.
   *
   * In the latter case, the lastCompletedAt field will be null.
   */
  active: Scalars['Boolean']['output'];
  /** The content reference that needs to be performed */
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  /** When this activity was created */
  createdAt: Scalars['DateTime']['output'];
  /**
   * When this activity should stop being scheduled (optional).
   *
   * If set, the activity will only appear in the user's schedule up to and including this date.
   * After this date, the activity will no longer be included in unrolled activities,
   * regardless of whether it was completed.
   *
   * This is useful for:
   * - Time-limited content (e.g., "Day 1" onboarding content that expires after Day 1)
   * - Seasonal or promotional activities
   * - Phased learning journeys where content should only be available during specific periods
   *
   * If null, the activity continues indefinitely (until completed with removeAfterCompletion=true
   * or manually deactivated).
   */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** When this activity was last completed, if ever */
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Human readable name of the activity (resolved from contentReference) */
  name: Scalars['String']['output'];
  /** Unique identifier for this planned activity */
  plannedActivityId: Scalars['ID']['output'];
  /**
   * Who planned this activity: the starter list every new member gets, someone on the care team, or the
   * member. Null when unknown.
   */
  plannedBy?: Maybe<PlanningOrigin>;
  /**
   * The Stone mode the care team planned for this vns_session, as planned (never swapped). Null = the
   * member chooses.
   */
  plannedModeId?: Maybe<Scalars['ID']['output']>;
  /** Whether this activity should be removed from the planning after completion */
  removeAfterCompletion: Scalars['Boolean']['output'];
  /**
   * When this activity should start being scheduled (optional).
   *
   * If set, the activity will only appear in the user's schedule starting from this date.
   * Before this date, the activity will not appear in unrolled activities.
   *
   * This is useful for:
   * - Onboarding content that should start on a specific day
   * - Scheduled challenges or events that begin on a future date
   * - Content unlocking based on program milestones
   *
   * If null, the activity starts appearing immediately.
   */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** When this activity should be performed */
  timeSlots: Array<ActivityTimeSlot>;
};

/**
 * The served card for a planned Stone mode (YOJO-3301): what runs now instead of, or as, the planned
 * mode. The planned mode itself is never swapped.
 */
export type PlannedModeCard = {
  __typename: 'PlannedModeCard';
  /** The planned mode's display name. */
  plannedDisplayName?: Maybe<Scalars['String']['output']>;
  /** Why the planned mode is not served; null when it is. */
  reason?: Maybe<PlannedModeReason>;
  servedDisplayName?: Maybe<Scalars['String']['output']>;
  /** The mode served now; null when none can be (no device, no usable default) — never another mode. */
  servedModeId?: Maybe<Scalars['ID']['output']>;
  /** The planned mode is locked for the member's plan and the member can change their plan to include it. */
  upgradeable: Scalars['Boolean']['output'];
};

/**
 * Why a planned Stone mode is not served (YOJO-3301). Parse tolerantly: values may be added; treat an
 * unknown value as unavailable.
 */
export enum PlannedModeReason {
  /** The member has no linked device: nothing is runnable */
  NoDevice = 'no_device',
  /** Locked for the member's plan: the default mode is served instead */
  Plan = 'plan',
  /** Cannot be served (disabled, unknown, another device generation): the default mode is served instead */
  Unavailable = 'unavailable'
}

/**
 * Why a planned Stone mode is refused for a member (YOJO-3301): the same code at every planning door.
 * Parse tolerantly: values may be added.
 */
export enum PlannedModeRefusalReason {
  /** The member's modes could not be worked out right now */
  CannotCheck = 'cannot_check',
  /** In the catalogue, disabled */
  ModeDisabled = 'mode_disabled',
  /** The member has no linked device, or one that cannot be classified */
  NoDevice = 'no_device',
  /** Locked for the member's plan */
  NotInPlan = 'not_in_plan',
  /** Not in the catalogue, and not the member's own personalised mode */
  UnknownMode = 'unknown_mode',
  /** A mode of the other device generation */
  WrongDevice = 'wrong_device'
}

/** Who planned an activity (YOJO-3284). No value means unknown. */
export enum PlanningOrigin {
  /** Someone on the care team, one by one or through an approved plan or batch */
  CareTeam = 'care_team',
  /** The member, on their own plan */
  Member = 'member',
  /** The starter list every new member gets at onboarding */
  Starter = 'starter'
}

export type PopoutWithImageBlock = {
  __typename: 'PopoutWithImageBlock';
  altText: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PopoutWithTextBlock = {
  __typename: 'PopoutWithTextBlock';
  content?: Maybe<RichContent>;
  title: Scalars['String']['output'];
};

export type PpgScanInput = {
  heartRate?: InputMaybe<Scalars['Int']['input']>;
  heartRateVariability?: InputMaybe<Scalars['Int']['input']>;
  recordedAt: Scalars['DateTime']['input'];
  restingHeartRate?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The member's answer to the practice-reminder question (YOJO-3350). Only chosen sends a push: at this time in the
 * member's own time zone, skipped on a day their session is already done.
 */
export type PracticeReminder = {
  __typename: 'PracticeReminder';
  /** The member's answer: chosen, later or off */
  choice: PracticeReminderChoice;
  /** When the member decided */
  decidedAt: Scalars['DateTime']['output'];
  /** The time on the record, in the member's own time zone: always for chosen, kept for off, none for later */
  time?: Maybe<Scalars['LocalTime']['output']>;
  /** The part of the day on the record: always for chosen, kept for off, none for later */
  timeBlock?: Maybe<TimeBlock>;
};

/** The member's answer to "do you want a daily practice reminder?" (YOJO-3350). */
export enum PracticeReminderChoice {
  /** A daily reminder at the chosen part of the day and time */
  Chosen = 'chosen',
  /** Not now: no reminder and no time kept (a time on the record is dropped) */
  Later = 'later',
  /** No reminder; the time already on the record is kept (later keeps none) */
  Off = 'off'
}

/**
 * The member's answer to the practice-reminder question (YOJO-3350): chosen with a part of the day and a time (in the
 * member's own time zone), or later / off with neither.
 */
export type PracticeReminderInput = {
  /** The member's answer: chosen, later or off */
  choice: PracticeReminderChoice;
  /** The time of the reminder, in the member's own time zone: required for chosen, left out for later and off */
  time?: InputMaybe<Scalars['LocalTime']['input']>;
  /** The part of the day the reminder belongs to: required for chosen, left out for later and off */
  timeBlock?: InputMaybe<TimeBlock>;
};

/**
 * YOJO-2393 (ADR-0013) — input for preRegisterDeviceSerial: the Entitlement and the manufacturer serial of
 * the device shipped for it.
 */
export type PreRegisterDeviceSerialInput = {
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  serialNumber: Scalars['String']['input'];
};

/**
 * Whether a device pre-registration is still open (unlinked, redeemable by pairing) or consumed (already
 * linked). A serial with no pre-registration simply carries a null preRegistration.
 */
export enum PreRegistrationState {
  Consumed = 'consumed',
  Open = 'open'
}

/** Represents a user's preferences for the programme */
export type Preferences = {
  __typename: 'Preferences';
  /** When true, this user is excluded from any care-team bulk-chat broadcast. Per-1:1 messages are unaffected. */
  broadcastOptOut: Scalars['Boolean']['output'];
  /** Whether the participant has opted out of bulk content assignment from the care team (YOJO-1742). Defaults to false. */
  contentAssignmentOptOut: Scalars['Boolean']['output'];
  /** When these preferences were last updated */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The goal the member picked for themselves, and when. Empty when they have not picked one or cleared it (YOJO-3286) */
  memberGoal?: Maybe<MemberGoalStatement>;
  /** Personal goals selected by the user */
  personalGoals: Array<DesiredState>;
  /** The member's answer to the practice-reminder question; null = never asked (YOJO-3350) */
  practiceReminder?: Maybe<PracticeReminder>;
  /** Unique identifier for these preferences */
  preferencesId: Scalars['ID']['output'];
  /**
   * Preferred check-in time block for the user. In combination with
   * timeBlockPreferences, this indicates when the user prefers to check in
   */
  preferredCheckin: TimeBlock;
  /** Vital signs the user wants to monitor */
  targetVitals: Array<VitalType>;
  /** User's preferred times for each time block */
  timeBlockPreferences: Array<TimeBlockPreference>;
  /** User who owns these preferences */
  userId: Scalars['ID']['output'];
  /** Weekly time commitments for specific protocols */
  weeklyCommitments: Array<WeeklyCommitment>;
};

/**
 * Input for prepareBulkAssignment (YOJO-1817). Stages an assignment in the
 * `prepared` state for later approve/reject. The recipient resolver runs
 * server-side. Exactly ONE of selection or userIds must be set.
 *
 * `bulkAssignmentId` is optional (server generates if absent) but exposed so the
 * caller can pick a deterministic `bla_<uuid>` up front for idempotency.
 */
export type PrepareBulkAssignmentInput = {
  bulkAssignmentId?: InputMaybe<Scalars['ID']['input']>;
  payload: SingleContentPayloadInput;
  /** Audience-selection rule. Mutually exclusive with userIds. */
  selection?: InputMaybe<BulkAssignmentSelectionInput>;
  /** Explicit hand-picked recipient list. Mutually exclusive with selection. */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Provenance of a bulk-assignment preparation. */
export enum PreparedVia {
  Composer = 'composer',
  Mcp = 'mcp'
}

/** Product types that can be shipped. */
export enum ProductType {
  VnsDevice = 'vns_device'
}

/** Distribution of user progress in a journey */
export type ProgressDistribution = {
  __typename: 'ProgressDistribution';
  /** Number of users who have completed all content (100% progress) */
  completed: Scalars['Int']['output'];
  /**
   * Number of users who have started but not completed all content
   * Users with progress between 1% and 99%
   */
  inProgress: Scalars['Int']['output'];
  /** Number of assigned users who haven't started any content */
  notStarted: Scalars['Int']['output'];
};

export enum Protocol {
  Acupressure = 'acupressure',
  Biofeedback = 'biofeedback',
  Breathwork = 'breathwork',
  Community = 'community',
  CreativeArtTherapy = 'creative_art_therapy',
  DietAndNutrition = 'diet_and_nutrition',
  Empowerment = 'empowerment',
  HealthCoach = 'health_coach',
  Meditation = 'meditation',
  Movement = 'movement',
  Psychotherapy = 'psychotherapy',
  SleepRestoration = 'sleep_restoration',
  VagusNerveStimulation = 'vagus_nerve_stimulation',
  YourYojo = 'your_yojo'
}

/** Statistics per wearable provider */
export type ProviderStats = {
  __typename: 'ProviderStats';
  provider: Scalars['String']['output'];
  recordCount: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
};

/** Base schema defining core types and interfaces */
export type Query = {
  __typename: 'Query';
  /** Get a single acquisition source by ID. */
  acquisitionSource?: Maybe<AcquisitionSource>;
  /** List acquisition sources with optional filtering and cursor-based pagination. */
  acquisitionSources: AcquisitionSourceConnection;
  /** Get all unrolled activities for a user in a date range */
  activities: Array<Activity>;
  /** Get a user's activity planning */
  activityPlanning?: Maybe<ActivityPlanning>;
  /** Get all story videos */
  activityVideos: Array<ActivityVideo>;
  /** List all service cases regardless of status. */
  allServiceCases: Array<ServiceCase>;
  /**
   * Get a specific participant's feedback history.
   * Portal-only: requires nurse role.
   */
  appFeedback: Array<AppFeedback>;
  /** Get all app lifecycle content */
  appLifecycles: Array<AppLifecycle>;
  /** Get an article by ID */
  article?: Maybe<ActivityVideo | Article | JourneyVideo | Lesson | Story>;
  /** Get all article teasers */
  articleTeasers: Array<ArticleTeaser>;
  /** Get filtered articles with pagination and sorting */
  articles: ArticleConnection;
  /** Get a specific biofeedback session by ID */
  biofeedbackSession?: Maybe<BiofeedbackSession>;
  /** Get all biofeedback sessions for the current user */
  biofeedbackSessions: Array<BiofeedbackSession>;
  /**
   * Query body metrics within a time range
   * Note: Timezone is read from the user's profile and used to interpret the date range.
   */
  bodyMetrics: Array<BodyMetric>;
  /** Fetch a single broadcast by ID. Returns null if not found. */
  broadcast?: Maybe<BroadcastEntry>;
  /**
   * List broadcasts initiated by the care-team, optionally filtered to a
   * single sender. Cursor-based pagination.
   */
  broadcasts: BroadcastConnection;
  /** Fetch a single bulk assignment by ID. Returns null if not found. */
  bulkAssignment?: Maybe<BulkAssignmentEntry>;
  /**
   * Compute the consent / safety delta LIVE for a prepared batch, so the approver
   * signs off on the number that will actually be sent (ADR-005 / US-5, YOJO-1812).
   *
   * Re-runs the SAME RecipientSafetyFilter + predicates the approve-time fan-out runs,
   * against current participant / preferences state — so the previewed number equals the
   * sent number. Returns null when the batch is not found or is not in `prepared` status
   * (only a prepared batch is awaiting sign-off).
   */
  bulkAssignmentConsentPreview?: Maybe<BulkAssignmentConsentDelta>;
  /**
   * List bulk assignments initiated by the care team, optionally filtered to a
   * single sender and/or a single lifecycle status. Cursor-based pagination.
   *
   * For the "Awaiting approval" queue, call with status: prepared (and no
   * senderUserId) to return prepared batches across all senders.
   */
  bulkAssignments: BulkAssignmentConnection;
  /**
   * The code-shipped capability vocabulary, described: what may be composed into a package, how it
   * groups in the editor, and what physics constrains it. Static per deploy — the UI reads SDK and
   * hardware truth from the server rather than hardcoding it.
   */
  capabilityCatalog: Array<CapabilityDescriptor>;
  /**
   * Every capability package, for the admin package editor. Archived packages are excluded unless
   * includeArchived is true.
   */
  capabilityPackages: Array<CapabilityPackage>;
  /**
   * The cross-package dials. Null means the system has never been bootstrapped — until it is, every
   * member resolves to zero capabilities.
   */
  capabilitySettings?: Maybe<CapabilitySettings>;
  carrier?: Maybe<Carrier>;
  carriers: Array<Carrier>;
  /** Get chat inbox showing conversation status for each participant channel */
  chatInbox: ChatInbox;
  /** Get insights for a specific check-in session */
  checkinInsight?: Maybe<CheckinInsight>;
  /** Get a specific checkin session by ID */
  checkinSession?: Maybe<CheckinSession>;
  /** Get all checkin sessions for the current user */
  checkinSessions: Array<CheckinSession>;
  /**
   * Get per-participant coach engagement data for analytics export.
   * Returns all participants with their chat responsiveness, consult history,
   * and segment membership.
   */
  coachEngagementExport: Array<CoachEngagementEntry>;
  /** Query cognitive metrics within a time range */
  cognitiveMetrics: Array<CognitiveMetric>;
  /**
   * Get cohort analysis showing how health metrics change over time since user
   * start (aggregated analytics - accessible to content team)
   */
  cohortAnalysis: CohortAnalysis;
  /**
   * Get cohort analysis segmented by age bracket, showing how different age groups
   * respond over time (aggregated analytics - accessible to content team)
   */
  cohortAnalysisByAgeBracket: CohortAnalysisByAgeBracket;
  /**
   * Get cohort analysis segmented by one or more dimensions (composite
   * segmentation), enabling cross-dimensional analysis (e.g. age bracket + gender)
   */
  cohortAnalysisByCompositeSegment: CohortAnalysisByCompositeSegment;
  /**
   * Get cohort analysis segmented by gender, showing how different genders respond
   * over time (aggregated analytics - accessible to content team)
   */
  cohortAnalysisByGender: CohortAnalysisByGender;
  /**
   * Get cohort analysis segmented by baseline RMSSD group (low/medium/high HRV),
   * showing how users with different starting HRV respond over time (aggregated
   * analytics - accessible to content team)
   */
  cohortAnalysisByRmssdGroup: CohortAnalysisByRmssdGroup;
  /** Get members of a specific cohort. */
  cohortMembers: CohortWithMembers;
  /** Get all available cohorts with their current member counts. */
  cohorts: Array<Cohort>;
  /**
   * Canonical company-wide KPIs. Sourced from the in-memory KpiMonthlySnapshotView
   * projection plus cross-service revenue from accounting-api.
   * Accessible to all authenticated roles.
   */
  companyKpis: CompanyKpis;
  /**
   * Cross-participant consult roster for the care team: who has had a consult and who
   * hasn't, across ALL participants, with real names. This is a plain operational read —
   * nurse/admin are already authorised to see their members, so it does NOT impose the
   * anonymisation / GDPR-justification ceremony of the analytics coachEngagementExport.
   */
  consultRoster: Array<ConsultRosterEntry>;
  /** Get all consults for a participant. */
  consults: Array<Consult>;
  /** Get content analytics showing content consumption patterns (aggregated analytics - accessible to content team) */
  contentAnalytics: ContentAnalytics;
  /**
   * Get content organized by protocol categories.
   * Only shows categories with 5+ items.
   * Excludes empowerment and health_coach protocols.
   * Content is sorted by most recent first.
   */
  contentCategories: Array<ContentCategory>;
  /** Get all available courses */
  courses: Array<Course>;
  /** Get personalized course recommendations */
  coursesMadeForYou: Array<Course>;
  /**
   * Get information about the currently authenticated user.
   * Returns basic account information including roles.
   * Does NOT expose PII or medical data.
   * Safe for all authenticated users including Content role.
   */
  currentUser: CurrentUser;
  /** Get all custom activities for a user */
  customActivities: Array<CustomActivity>;
  /** Get a custom activity by ID */
  customActivity?: Maybe<CustomActivity>;
  /** Get a single customer by ID. */
  customer?: Maybe<Customer>;
  /**
   * Get the complete customer dashboard data for care team.
   * Requires admin or nurse role.
   */
  customerDashboard: CustomerDashboard;
  /**
   * Get paginated list of customers for Care Portal.
   * Requires admin or operations role.
   */
  customers: CustomerConnection;
  /** Get daily journal */
  dailyJournal: DailyJournal;
  /** Get daily reflections for the current user within a date range */
  dailyReflections: Array<DailyReflection>;
  /**
   * Get delivered FCM notifications for a user
   * If userId is null, fetches for current user
   * If userId is provided, performs ACL check for authorization
   * Optionally filter to only notifications since a specific timestamp
   */
  deliveredNotifications: Array<NotificationDeliveryLog>;
  /**
   * The Stone's offline settings: the offline session allowance, the device's cap on it, and the
   * rolling record window every member's Stone record gets at least. admin OR operations — ops read
   * what they set. Always answered; a null setting has never been configured.
   */
  deviceOfflineSettings: DeviceOfflineSettings;
  dojoArticles: Array<DojoArticle>;
  dojoChecklists: Array<DojoChecklist>;
  /** Get all available dojo content items */
  dojoContent: Array<ArticleTeaser | DojoArticle | DojoChecklist | DojoNugget | DojoQuiz | DojoQuote | StoryTeaser | VideoTeaser>;
  /** Get the personalized dojo feed items for the current user */
  dojoFeed: Array<ArticleTeaser | DojoArticle | DojoChecklist | DojoNugget | DojoQuiz | DojoQuote | StoryTeaser | VideoTeaser>;
  dojoNuggets: Array<DojoNugget>;
  dojoQuizzes: Array<DojoQuiz>;
  dojoQuotes: Array<DojoQuote>;
  /**
   * What the CALLING member can effectively do right now: the free floor, unioned with their live
   * grants, intersected with what their registered devices can physically execute.
   *
   * Always about the caller — a member cannot ask this about someone else.
   *
   * CLIENT GUARDRAIL: test membership with `contains()`; never map these values through a throwing
   * string→enum conversion.
   */
  effectiveCapabilities: Array<Capability>;
  /**
   * Query emotional states within a time range
   * Note: Timezone is read from the user's profile and used to interpret the date range.
   */
  emotionalStates: Array<EmotionalState>;
  /**
   * Get word cloud data for emotional states
   * Note: Timezone is read from the user's profile and used to interpret the date range.
   */
  emotionalWordCloud: Array<EmotionalWordCloudEntry>;
  /** Get engagement profile for the current user */
  engagementProfile?: Maybe<EngagementProfile>;
  /**
   * Query feeling metrics within a time range
   *
   * Note: Timezone is read from the user's profile and used to interpret the date range.
   */
  feelingMetrics: Array<FeelingMetric>;
  /**
   * The de-identified habituation cohort roll-up (YOJO-2876 / YOJO-2880): state tiles, the anonymous
   * four-quadrant scatter, plateau-aligned trajectories and the median plateau→drift / drift→baseline
   * durations. Carries no identities — open to analysts and the care team (overview decision 3;
   * deliberately WITHOUT "content"). Recompute-on-view, cached ~15 minutes server-side.
   */
  habituationCohort: HabituationCohort;
  /**
   * A single member's habituation detail — the Figure-1 triptych data plus the optional overnight
   * overlay (nurse/admin only). Null when the member is unknown / not entitled.
   */
  habituationMember?: Maybe<HabituationMemberDetail>;
  /**
   * The member table for the case review (nurse/admin only — per-member data), optionally filtered by
   * current habituation state.
   */
  habituationMembers: Array<HabituationMemberSummary>;
  /**
   * Check if the current user has an active GDPR justification (within 1-hour TTL).
   * Used by analytics pages to skip the justification dialog if recently justified on another page.
   */
  hasActiveGdprJustification: Scalars['Boolean']['output'];
  /**
   * Get all available impacted vitals. Used by CMS to populate
   * vital dropdowns.
   */
  impactedVitals: Array<ImpactedVital>;
  /** Get interaction timeline with filtering (individual user data - requires nurse or admin role) */
  interactionTimeline: InteractionTimeline;
  /**
   * Get all internal Yōjō team members: every account that holds a staff role
   * (admin, nurse, content, developer, analyst, operations), whatever its email address.
   * Accessible to admin, nurse, content, and developer roles.
   */
  internalUsers: Array<Nurse>;
  /**
   * Get all available intervention types. Used by CMS to populate
   * intervention type dropdowns.
   */
  interventionTypes: Array<InterventionType>;
  /**
   * The caller's own journal notes, newest first (YOJO-3118). No range = every note the member may see. On Free or
   * a lapsed plan only the last two weeks are served; older notes are kept and come back on a paid plan
   * (`myHistoryWindow.olderDataKept` tells the app they exist). Open to every plan.
   */
  journalNotes: Array<JournalNote>;
  /** Get all journey videos */
  journeyVideos: Array<JourneyVideo>;
  /** Query the latest body metrics for the current user, one for each type. */
  latestBodyMetrics: Array<BodyMetric>;
  /** Get the latest mindstate metrics for a participant, one for each type */
  latestMindstateMetrics: Array<MindstateMetric>;
  /** Get a specific learning journey by ID */
  learningJourney?: Maybe<LearningJourney>;
  /** Get all learning journeys */
  learningJourneys: Array<LearningJourney>;
  /** Get a specific learning path by ID */
  learningPath?: Maybe<LearningPath>;
  /** Get all learning paths */
  learningPaths: Array<LearningPath>;
  /** Get all available lessons */
  lessons: Array<Lesson>;
  /** Get lessons progress */
  lessonsProgress: LessonsProgress;
  /** Get the currently authenticated user */
  me: User;
  /** Staff parity (YOJO-3116): exactly what the member sees as myProfile.allowances. Unknown userId = not found. */
  memberAllowances?: Maybe<Allowances>;
  /**
   * Operator serial → member search (YOJO-2393, ADR-0013). Finds, across the union of registered device
   * serials AND pre-registered serials, every match for the given serial: exact match first, then a prefix
   * fallback (minimum 6 characters). Returns a LIST, one entry per distinct serial — never collapsed — so
   * shared/placeholder serials and prefix hits are all visible for a human to disambiguate.
   * Requires admin or operations role.
   */
  memberBySerial: Array<SerialMatch>;
  /**
   * Everything ops needs about ONE member's capabilities — the read behind the manual grant/revoke
   * screen. admin OR operations: looking up why a member cannot do something is support's daily work,
   * while the pricing configuration above is not.
   *
   * Returns the effective set (from the same resolver the member's own app calls, device intersection
   * included), every grant active or historical, and every booked change pending or terminal.
   *
   * A member with no grant ledger at all is answered, not refused: null holderId, empty grants, and the
   * free floor as their effective capabilities. That is the ordinary state of most members.
   */
  memberCapabilities: MemberCapabilities;
  /**
   * The authenticated member's own Member Health Report (YOJO-1894).
   *
   * Authed and STRICTLY own-data-only: a member can only ever read THEIR OWN report. The optional
   * memberId MUST equal the caller's own id when supplied (any other value is denied); normally it is
   * omitted and resolves to self.
   *
   * Returns the assembled, ordered zones when the lifecycle detector says IN_WINDOW, else the calm
   * holding-state payload (out-of-window / warming-up / lapsed / excluded) — never a fabricated report.
   */
  memberHealthReport: MemberHealthReport;
  /**
   * Ops parity (YOJO-2976 [member sees their own plan]): exactly what the member sees as myProfile.memberPlan,
   * computed in the member's zone.
   * Display only: never gate on it. Null = cannot be known right now.
   */
  memberPlan?: Maybe<MemberPlan>;
  /**
   * Staff view of one member's recent Stone session modes: exactly what the member sees as
   * myProfile.recentStoneModes, in the member's zone. Newest first, at most 10; the first is the previous mode. Not
   * listed: device-started sessions, sessions whose starter was not recorded (older app builds), sessions sent with
   * an unknown starter, deleted sessions, manually logged sessions, and sessions that named no catalogue mode
   * (skipped, so the next older one comes first). Empty = no app-started session that named a mode yet. An unknown
   * member (no account) is a not-found error. Returning it writes an audit row (who read whose). If that row cannot
   * be written, the field is an error with no data.
   */
  memberRecentStoneModes: RecentStoneModes;
  /**
   * Staff parity (YOJO-3261): exactly what the member sees as myProfile.stoneModes. Null = cannot be known right now.
   * A userId with no account is a not-found error, never an empty list. admin, operations and nurse only.
   * A member's personalised mode name and description can be text a coach wrote about that member; returning them
   * writes an audit row (who read whose). If that row cannot be written, the field is an error with no data.
   */
  memberStoneModes?: Maybe<MemberStoneModes>;
  /** Get membership details by membership ID */
  membership?: Maybe<Membership>;
  /** Get membership details for a specific user */
  membershipByUserId?: Maybe<Membership>;
  metricInsight?: Maybe<MetricInsight>;
  /** Get all mindstate metrics for the current user */
  mindstate?: Maybe<Mindstate>;
  /** Query mindstate metrics filtered by type */
  mindstateMetrics: Array<MindstateMetric>;
  /** Get the current user's feedback history. */
  myAppFeedback: Array<AppFeedback>;
  /**
   * Where the CALLING member's own visible history starts (YOJO-3379): the first day their history reads
   * return, in their profile timezone. A null `from` means nothing is limited (a paid plan, or tiering not
   * switched on). `olderDataKept` is true when their history is limited AND they have own records older
   * than `from`: those are kept, not deleted — the app shows the edge "older data is kept, it returns on a
   * paid plan". Wearable sleep counts too: it is checked last, and if that check fails the answer is as if
   * there were no older sleep.
   *
   * Always about the caller — a member cannot ask this about someone else.
   */
  myHistoryWindow: HistoryWindow;
  /**
   * Get the complete profile for the current user.
   * Aggregates data from PII, membership, VNS device, preferences, and account.
   */
  myProfile: UserProfile;
  /**
   * The current user's VNS device, singular (YOJO-2558) — their most recently linked one. Null if they have
   * never paired one, or have unlinked everything. For a member holding an exclusive-link device (Stone)
   * this is their only device; for a co-linked Alpha member it is a narrowing of `myVnsDevices`.
   */
  myVnsDevice?: Maybe<VnsDevice>;
  /**
   * The current user's currently LINKED VNS devices — all of them (YOJO-2582).
   *
   * Usually one. A member co-linked to several non-exclusive devices (the Alpha class) sees all of them:
   * the one-device rule applies to exclusive-link hardware (the Stone class), which is never co-linked with
   * anything, not to accounts. Devices leave this list only when they are actually unlinked.
   */
  myVnsDevices: Array<VnsDevice>;
  /**
   * ALL newsletter sign-ups (PII), newest-first — the checkout NewsletterCta opt-ins (YOJO-2233).
   * Newsletter is global (no country filter). Unlike the waitlist queries this is NOT test-filtered:
   * it shows every newsletter sign-up, including internal/test, per the ticket decision.
   */
  newsletterSignals: Array<NewsletterSignal>;
  /** Get onboarding session for a user */
  onboardingSession?: Maybe<OnboardingSession>;
  /** List all open service cases (not resolved or cancelled). */
  openServiceCases: Array<ServiceCase>;
  /**
   * DRY RUN: what a proposed package change would cost members, per removed capability — the
   * blast-radius preview the admin screen shows before every confirm.
   *
   * Nothing is written and nothing is dispatched, so it is safe to call as often as the editor changes.
   *
   * The counts are members whose EFFECTIVE capabilities would shrink, not members who hold the package:
   * someone who also gets a capability from the floor, from another package or from a comp keeps it
   * either way and is reported as retained. Device-bound capabilities are counted only for members whose
   * hardware can actually execute them.
   *
   * `changeKind: floor_change` treats `packageKey` as the PROPOSED new floor and answers the same
   * question fleet-wide — see `fleetWide` on the result.
   */
  packageChangeImpact: PackageChangeImpact;
  /** Get one participant by ID (NURSE only) */
  participant: Participant;
  /** Get daily reflections for a specific participant (care team access) */
  participantDailyReflections: Array<DailyReflection>;
  /** Get participant metrics for a date range (individual user data - requires nurse or admin role) */
  participantMetrics: ParticipantMetrics;
  /** Get a specific note by ID. */
  participantNote?: Maybe<ParticipantNote>;
  /**
   * Get all notes for a participant, optionally filtered by status.
   * Returns notes sorted by createdAt descending (newest first).
   */
  participantNotes: Array<ParticipantNote>;
  /** One member's Today, for care roles. Same answer the member sees. Null until that member's onboarding is complete. */
  participantToday?: Maybe<Today>;
  /** One member's sessions for that member's own day, for care roles. Null for an id that is not a participant. */
  participantTodaySessions?: Maybe<TodaySessions>;
  /**
   * Get all participants.
   * Accessible to all internal roles (admin, nurse, content, developer).
   * Note: Individual participant details (wellbeing pages) are restricted to nurse/admin only.
   */
  participants: Array<Participant>;
  /**
   * One page of partner enquiries (the website's /partners/join "Get a call back" form), newest first.
   * No contact details: email, phone, website and socials only come through the audited revealPartnerEnquiryContact mutation.
   * A prospect-api failure is a GraphQL error, never an empty page.
   * For sales, operations and admin (YOJO-3371 plan Q7); the waitlist and newsletter fields stay operations/admin only.
   */
  partnerEnquiries: PartnerEnquiryPage;
  /** Get a single Payment Link by ID */
  paymentLink?: Maybe<PaymentLink>;
  /** Get all Payment Links managed by yojo-api */
  paymentLinks: Array<PaymentLink>;
  /** List all shipments with pending status (awaiting fulfillment). */
  pendingShipments: Array<Shipment>;
  /**
   * One member's personalised Stone mode: eligibility (a Stone, a plan that includes one), the current mode, every
   * saved version, and the device report (reportedAt null = not confirmed on the device yet). Admin or coach.
   * A userId that is not a member id (usr_...) is refused with `extensions.code` `invalid_input`.
   */
  personalisedStoneMode: PersonalisedStoneModeRead;
  /** Get preferences for a specific user */
  preferences?: Maybe<Preferences>;
  /** Preview an article by ID without storing read status */
  previewArticle?: Maybe<ActivityVideo | Article | JourneyVideo | Lesson | Story>;
  /**
   * Get all available protocols. Used by CMS to populate
   * protocol dropdowns.
   */
  protocols: Array<Protocol>;
  /** Get a single quick stat by name (aggregated analytics - accessible to content team) */
  quickStat: QuickStat;
  /** Get time series data for a quick stat (aggregated analytics - accessible to content team) */
  quickStatTimeSeries: QuickStatTimeSeries;
  /** Get a random wisdom quote */
  randomWisdomQuote: WisdomQuote;
  /**
   * Get all app feedback across all users within a date range.
   * Portal-only: requires nurse or admin role.
   */
  recentAppFeedback: Array<AppFeedback>;
  /** Get all recent chat messages for a date range (individual user data - requires nurse or admin role) */
  recentMessages: Array<ChatLog>;
  /**
   * Run the recipient-resolution pipeline for a given selection input WITHOUT
   * creating a broadcast. The UI calls this from the review modal to display
   * "you're about to message X people (Y opted out, Z test users)" before the
   * care-team member confirms.
   */
  resolveBroadcastRecipients: ResolvedRecipients;
  /**
   * Run the recipient-resolution pipeline for a given selection input WITHOUT
   * creating a bulk assignment. Care-portal calls this from the Review modal
   * to show resolved recipients + filter summary + duplicate-warning before
   * the operator confirms.
   */
  resolveBulkAssignmentRecipients: BulkAssignmentResolvedRecipients;
  revenueTarget?: Maybe<RevenueTarget>;
  revenueTargets: Array<RevenueTarget>;
  /**
   * Get RMSSD stratification analysis showing how users are distributed across
   * beneficial/monitor/not_recommended strata (aggregated analytics - accessible
   * to content team)
   */
  rmssdStratification: RmssdStratification;
  /** Get a specific scheduled notification by ID */
  scheduledNotification?: Maybe<ScheduledNotification>;
  /** Get all scheduled notifications for the current user */
  scheduledNotifications: Array<ScheduledNotification>;
  /** Get wellness scores for a user */
  scores: Array<Score>;
  /** Search customers by email or activation code (partial match). */
  searchCustomers: Array<Customer>;
  /** Get members of a specific segment. */
  segmentMembers: SegmentWithMembers;
  /** Get summary statistics for all segments. */
  segmentSummary: SegmentSummary;
  /**
   * Get engagement data for users in a segment, with optional limit.
   * Includes classification, activity dates, and VNS session counts.
   */
  segmentUserData: Array<UserEngagementData>;
  /** Get all available segments with their current member counts. */
  segments: Array<Segment>;
  /** Get a single service case by ID. */
  serviceCase?: Maybe<ServiceCase>;
  /** List service cases for a customer. */
  serviceCases: Array<ServiceCase>;
  /** List service cases filtered by issue type. */
  serviceCasesByIssueType: Array<ServiceCase>;
  /** List service cases filtered by status. */
  serviceCasesByStatus: Array<ServiceCase>;
  /** Get a single shipment by ID. */
  shipment?: Maybe<Shipment>;
  /** List shipments for a customer. */
  shipments: Array<Shipment>;
  /** List shipments filtered by status. Returns all shipments when status is null. */
  shipmentsByStatus: Array<Shipment>;
  /** Sleep cohort analysis - tracks sleep metrics from Day 0 (first wearable connection, approximated by first sleep record) */
  sleepCohortAnalysis: CohortAnalysis;
  /** VNS dose-response - sleep improvement split by VNS session frequency */
  sleepDoseResponse: SleepDoseResponse;
  /** Get summary statistics for sleep metrics across all users */
  sleepMetricsSummary: SleepMetricsSummary;
  /**
   * Get daily sleep metrics trend for charts.
   * Care team can query any user; patients are scoped to their own data.
   */
  sleepMetricsTrend: Array<SleepMetricDataPoint>;
  /** Night-of analysis - sleep on VNS nights vs non-VNS nights */
  sleepNightOfAnalysis: SleepNightOfAnalysis;
  /** Get user distribution by wearable provider */
  sleepProviderStats: Array<ProviderStats>;
  /** List distinct wearable providers that have sleep data */
  sleepProviders: Array<Scalars['String']['output']>;
  /**
   * The Stone mode catalogue (YOJO-3258 [Stone mode catalogue as data]): modes in the admin's order, current
   * limits, the default-mode setting and the (retired, YOJO-3313) capability mapping history. Admin, coach and
   * operations can read.
   */
  stoneModeCatalogue: StoneModeCatalogue;
  /** Every version of the default-mode setting, oldest first, each with who set it and when. */
  stoneModeDefaultHistory: Array<StoneModeDefaultVersion>;
  /** Every version of the Stone mode safety limits, oldest first, each with who saved it and when. */
  stoneModeLimitsHistory: Array<StoneModeLimits>;
  /**
   * Every saved parameter-set version of one Stone mode, oldest first (YOJO-3259): the set, where it came from
   * (`manual` or `vendor_import`, with its note), the limits version it was checked against, and who saved it and
   * when. Append-only: an old version never changes. Empty for a mode with no set or an unknown mode.
   */
  stoneModeParameterHistory: Array<StoneModeParameterSetVersion>;
  /** Get all story teasers */
  storyTeasers: Array<StoryTeaser>;
  /**
   * Get subprotocols for a specific protocol. Used by CMS to populate
   * subprotocol dropdowns.
   */
  subprotocols: Array<Subprotocol>;
  /** Get the Tenpo Storefront content for the mobile app's carousel */
  tenpoStorefront?: Maybe<TenpoStorefront>;
  /**
   * Staff only (nurse, admin): the stored Stone sessions a member's phone uploaded that do NOT count for that
   * member, because the Stone was not theirs when the session started (for example a Stone that changed hands and
   * then drained its old records). They are kept aside, never in the member's own sessions, and credited to nobody.
   * Who held the Stone instead is never served (ADR 0016, YOJO-3557).
   */
  unattributedVnsSessions: Array<VnsSession>;
  /** Get all unlinked memberships for care team to manually link */
  unlinkedMemberships: Array<Membership>;
  /** Get user chat metrics for a date range (individual user data - requires nurse or admin role) */
  userChatMetrics: UserChatMetrics;
  /**
   * Get classification status for a user.
   * Returns null if user has not been explicitly classified.
   */
  userClassification?: Maybe<UserClassification>;
  /** Get all cohorts a specific user belongs to. */
  userCohorts: Array<Cohort>;
  /** Get user engagement metrics for a date range (individual user data - requires nurse or admin role) */
  userEngagement: UserEngagementMetrics;
  /**
   * Get all available user intents. Used by CMS to populate
   * user intent dropdowns.
   */
  userIntents: Array<UserIntent>;
  /** Get learning journeys assigned to a user */
  userLearningJourneys: Array<LearningJourney>;
  /**
   * Get individual user's RMSSD profile including their stratum and thresholds
   * (individual user data - requires nurse or admin role)
   */
  userRmssdProfile?: Maybe<UserRmssdProfile>;
  /** Get all segments a specific user belongs to, plus their engagement data. */
  userSegments: UserEngagementData;
  /**
   * Get individual sleep records for a user.
   * Care team can query any user; patients are scoped to their own data.
   */
  userSleepMetrics: Array<UserSleepMetric>;
  /** Get user vital metrics for a date range (individual user data - requires nurse or admin role) */
  userVitalMetrics: UserVitalMetrics;
  /** Get all video teasers */
  videoTeasers: Array<VideoTeaser>;
  /**
   * Query vital metrics within a time range
   *
   * Note: Timezone is read from the user's profile and used to interpret the date range.
   */
  vitalMetrics: Array<VitalMetric>;
  /**
   * Retrieve personal vitals data for the current user within a specified date range
   *
   * Note: Timezone is read from the user's profile and used to interpret the date range.
   */
  vitals?: Maybe<Vitals>;
  /**
   * Get all VNS devices registered to a specific participant.
   * Portal-only: requires nurse, admin, or operations role (YOJO-2393 widened for ops device visibility).
   *
   * The FULL history, newest link first, each device carrying its recorded status (linked/unlinked).
   * Deliberately wider than `myVnsDevices` — the device a member RETIRED is exactly what a support call is
   * about, and its unlink reason and replacement pointer are what explain it.
   */
  vnsDevices: Array<VnsDevice>;
  /** Get a specific VNS session by ID */
  vnsSession?: Maybe<VnsSession>;
  vnsSessionAnalytics: VnsSessionAnalytics;
  vnsSessionExport: VnsSessionExportResult;
  /**
   * Query VNS therapy sessions within a time range
   * Note: Timezone is read from the user's profile and used to interpret the date range.
   */
  vnsSessions: Array<VnsSession>;
  /** Calculate Pearson correlation between VNS metrics and sleep outcomes (aggregated analytics - accessible to content team) */
  vnsSleepCorrelationStats?: Maybe<CorrelationResult>;
  /**
   * Get detailed VNS-sleep correlation data points.
   * Care team can query any participant; patients are scoped to their own data.
   */
  vnsSleepCorrelations: Array<VnsSleepCorrelation>;
  /** Get comprehensive VNS-sleep correlation dashboard (aggregated analytics - accessible to content team) */
  vnsSleepDashboard: VnsSleepDashboard;
  /** Per-country waitlist demand (countries we don't yet ship to), test/internal sign-ups filtered out. */
  waitlistDemand: Array<WaitlistCountryDemand>;
  /**
   * The waitlist sign-ups (PII) for a single delivery country, test/internal sign-ups filtered out.
   * Resolved via a DataLoader so concurrent per-country loads collapse into one prospect-api call.
   */
  waitlistSignals: Array<WaitlistSignal>;
  /**
   * Weekly achievements tracking progress against protocol commitments. Defaults to the current week
   * and starts on Monday. If a weekDay is not a Monday, it will be adjusted to the previous Monday.
   *
   * If userId is not provided, it defaults to the current user.
   */
  weeklyAchievements: WeeklyAchievements;
  /**
   * Get widget analytics showing mobile widget usage patterns (aggregated
   * analytics - accessible to content team). Excludes VNS sessions which are
   * tracked in Health Analytics.
   */
  widgetAnalytics: WidgetAnalytics;
};


/** Base schema defining core types and interfaces */
export type QueryAcquisitionSourceArgs = {
  sourceId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryAcquisitionSourcesArgs = {
  filter?: InputMaybe<AcquisitionSourceFilter>;
  pagination?: InputMaybe<PaginationInput>;
};


/** Base schema defining core types and interfaces */
export type QueryActivitiesArgs = {
  dateRange: DateRangeInput;
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryActivityPlanningArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryAppFeedbackArgs = {
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryArticleArgs = {
  reference: ContentReferenceInput;
};


/** Base schema defining core types and interfaces */
export type QueryArticlesArgs = {
  filter?: InputMaybe<ArticleFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<ArticleSortInput>>;
};


/** Base schema defining core types and interfaces */
export type QueryBiofeedbackSessionArgs = {
  biofeedbackSessionId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryBiofeedbackSessionsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryBodyMetricsArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  type?: InputMaybe<BodyMetricType>;
};


/** Base schema defining core types and interfaces */
export type QueryBroadcastArgs = {
  id: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryBroadcastsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  senderUserId?: InputMaybe<Scalars['ID']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryBulkAssignmentArgs = {
  id: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryBulkAssignmentConsentPreviewArgs = {
  id: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryBulkAssignmentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  senderUserId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<BulkAssignmentStatus>;
};


/** Base schema defining core types and interfaces */
export type QueryCapabilityPackagesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryCarrierArgs = {
  carrierId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryCarriersArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryChatInboxArgs = {
  input?: InputMaybe<ChatInboxInput>;
};


/** Base schema defining core types and interfaces */
export type QueryCheckinInsightArgs = {
  checkinSessionId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryCheckinSessionArgs = {
  checkinSessionId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryCheckinSessionsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryCoachEngagementExportArgs = {
  input?: InputMaybe<CoachEngagementExportInput>;
};


/** Base schema defining core types and interfaces */
export type QueryCognitiveMetricsArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  type?: InputMaybe<CognitiveMetricType>;
};


/** Base schema defining core types and interfaces */
export type QueryCohortAnalysisArgs = {
  filter: CohortAnalysisFilter;
};


/** Base schema defining core types and interfaces */
export type QueryCohortAnalysisByAgeBracketArgs = {
  filter: CohortAnalysisFilter;
};


/** Base schema defining core types and interfaces */
export type QueryCohortAnalysisByCompositeSegmentArgs = {
  dimensions: Array<SegmentDimension>;
  filter: CohortAnalysisFilter;
};


/** Base schema defining core types and interfaces */
export type QueryCohortAnalysisByGenderArgs = {
  filter: CohortAnalysisFilter;
};


/** Base schema defining core types and interfaces */
export type QueryCohortAnalysisByRmssdGroupArgs = {
  filter: CohortAnalysisFilter;
};


/** Base schema defining core types and interfaces */
export type QueryCohortMembersArgs = {
  cohortId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryConsultsArgs = {
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryContentAnalyticsArgs = {
  input: ContentAnalyticsInput;
};


/** Base schema defining core types and interfaces */
export type QueryContentCategoriesArgs = {
  request?: InputMaybe<ContentCategoryRequest>;
};


/** Base schema defining core types and interfaces */
export type QueryCustomActivitiesArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryCustomActivityArgs = {
  customActivityId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<CustomerSortInput>;
};


/** Base schema defining core types and interfaces */
export type QueryDailyReflectionsArgs = {
  dateRange: DateRangeInput;
};


/** Base schema defining core types and interfaces */
export type QueryDeliveredNotificationsArgs = {
  since?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryEmotionalStatesArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryEmotionalWordCloudArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryEngagementProfileArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryFeelingMetricsArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  type?: InputMaybe<FeelingType>;
};


/** Base schema defining core types and interfaces */
export type QueryHabituationCohortArgs = {
  window: HabituationWindow;
};


/** Base schema defining core types and interfaces */
export type QueryHabituationMemberArgs = {
  memberId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryHabituationMembersArgs = {
  state?: InputMaybe<HabituationState>;
};


/** Base schema defining core types and interfaces */
export type QueryInteractionTimelineArgs = {
  filter: InteractionTimelineFilter;
};


/** Base schema defining core types and interfaces */
export type QueryJournalNotesArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


/** Base schema defining core types and interfaces */
export type QueryLatestBodyMetricsArgs = {
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryLatestMindstateMetricsArgs = {
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryLearningJourneyArgs = {
  learningJourneyId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryLearningPathArgs = {
  learningPathId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMemberAllowancesArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMemberBySerialArgs = {
  serial: Scalars['String']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMemberCapabilitiesArgs = {
  subjectId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMemberHealthReportArgs = {
  memberId?: InputMaybe<Scalars['ID']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryMemberPlanArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMemberRecentStoneModesArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMemberStoneModesArgs = {
  generation?: InputMaybe<StoneDeviceGeneration>;
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMembershipByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMetricInsightArgs = {
  metricId: Scalars['String']['input'];
  vitalsId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMindstateArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryMindstateMetricsArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  type?: InputMaybe<MindstateMetricType>;
};


/** Base schema defining core types and interfaces */
export type QueryOnboardingSessionArgs = {
  participantId?: InputMaybe<Scalars['ID']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryPackageChangeImpactArgs = {
  input: PackageChangeImpactInput;
};


/** Base schema defining core types and interfaces */
export type QueryParticipantArgs = {
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryParticipantDailyReflectionsArgs = {
  dateRange: DateRangeInput;
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryParticipantMetricsArgs = {
  dateRange: DateRangeInput;
  participantId?: InputMaybe<Scalars['String']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryParticipantNoteArgs = {
  noteId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryParticipantNotesArgs = {
  participantId: Scalars['ID']['input'];
  status?: InputMaybe<NoteStatus>;
};


/** Base schema defining core types and interfaces */
export type QueryParticipantTodayArgs = {
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryParticipantTodaySessionsArgs = {
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryParticipantsArgs = {
  filter?: InputMaybe<ParticipantFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryPartnerEnquiriesArgs = {
  filter?: InputMaybe<PartnerEnquiryFilterInput>;
};


/** Base schema defining core types and interfaces */
export type QueryPaymentLinkArgs = {
  id: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryPaymentLinksArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryPersonalisedStoneModeArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryPreferencesArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryPreviewArticleArgs = {
  reference: ContentReferenceInput;
};


/** Base schema defining core types and interfaces */
export type QueryQuickStatArgs = {
  filter: QuickStatFilterInput;
};


/** Base schema defining core types and interfaces */
export type QueryQuickStatTimeSeriesArgs = {
  filter: QuickStatTimeSeriesFilter;
};


/** Base schema defining core types and interfaces */
export type QueryRecentAppFeedbackArgs = {
  dateRange: DateRangeInput;
};


/** Base schema defining core types and interfaces */
export type QueryRecentMessagesArgs = {
  dateRange: DateRangeInput;
};


/** Base schema defining core types and interfaces */
export type QueryResolveBroadcastRecipientsArgs = {
  input: BroadcastSelectionInput;
};


/** Base schema defining core types and interfaces */
export type QueryResolveBulkAssignmentRecipientsArgs = {
  contentReference?: InputMaybe<ContentReferenceInput>;
  input: BulkAssignmentSelectionInput;
};


/** Base schema defining core types and interfaces */
export type QueryRevenueTargetArgs = {
  month: Scalars['String']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryRmssdStratificationArgs = {
  filter: RmssdStratificationFilter;
};


/** Base schema defining core types and interfaces */
export type QueryScheduledNotificationArgs = {
  id: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryScoresArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QuerySearchCustomersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/** Base schema defining core types and interfaces */
export type QuerySegmentMembersArgs = {
  segmentId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QuerySegmentUserDataArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  segmentId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryServiceCaseArgs = {
  serviceCaseId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryServiceCasesArgs = {
  customerId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryServiceCasesByIssueTypeArgs = {
  issueType: IssueType;
};


/** Base schema defining core types and interfaces */
export type QueryServiceCasesByStatusArgs = {
  status: ServiceCaseStatus;
};


/** Base schema defining core types and interfaces */
export type QueryShipmentArgs = {
  shipmentId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryShipmentsArgs = {
  customerId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryShipmentsByStatusArgs = {
  status?: InputMaybe<ShipmentStatus>;
};


/** Base schema defining core types and interfaces */
export type QuerySleepCohortAnalysisArgs = {
  filter: SleepCohortFilter;
};


/** Base schema defining core types and interfaces */
export type QuerySleepDoseResponseArgs = {
  dateRange: DateRangeInput;
  provider?: InputMaybe<Scalars['String']['input']>;
};


/** Base schema defining core types and interfaces */
export type QuerySleepMetricsSummaryArgs = {
  dateRange: DateRangeInput;
};


/** Base schema defining core types and interfaces */
export type QuerySleepMetricsTrendArgs = {
  dateRange: DateRangeInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** Base schema defining core types and interfaces */
export type QuerySleepNightOfAnalysisArgs = {
  dateRange: DateRangeInput;
  provider?: InputMaybe<Scalars['String']['input']>;
};


/** Base schema defining core types and interfaces */
export type QuerySleepProviderStatsArgs = {
  dateRange: DateRangeInput;
};


/** Base schema defining core types and interfaces */
export type QueryStoneModeParameterHistoryArgs = {
  modeId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryUnattributedVnsSessionsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryUserChatMetricsArgs = {
  dateRange: DateRangeInput;
  participantId?: InputMaybe<Scalars['String']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryUserClassificationArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryUserCohortsArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryUserEngagementArgs = {
  dateRange: DateRangeInput;
  participantId?: InputMaybe<Scalars['String']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryUserLearningJourneysArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryUserRmssdProfileArgs = {
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryUserSegmentsArgs = {
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryUserSleepMetricsArgs = {
  dateRange: DateRangeInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryUserVitalMetricsArgs = {
  dateRange: DateRangeInput;
  participantId?: InputMaybe<Scalars['String']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryVitalMetricsArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  type?: InputMaybe<VitalType>;
};


/** Base schema defining core types and interfaces */
export type QueryVitalsArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryVnsDevicesArgs = {
  participantId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryVnsSessionArgs = {
  vnsSessionId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryVnsSessionAnalyticsArgs = {
  input: VnsSessionAnalyticsInput;
};


/** Base schema defining core types and interfaces */
export type QueryVnsSessionExportArgs = {
  input: VnsSessionExportInput;
};


/** Base schema defining core types and interfaces */
export type QueryVnsSessionsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
  sessionStates?: InputMaybe<Array<VnsSessionState>>;
  status?: InputMaybe<VnsSessionStatus>;
};


/** Base schema defining core types and interfaces */
export type QueryVnsSleepCorrelationStatsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryVnsSleepCorrelationsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
  timeBlock?: InputMaybe<TimeBlock>;
};


/** Base schema defining core types and interfaces */
export type QueryVnsSleepDashboardArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


/** Base schema defining core types and interfaces */
export type QueryWaitlistSignalsArgs = {
  country: Scalars['String']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryWeeklyAchievementsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
  weekDay?: InputMaybe<Scalars['Date']['input']>;
};


/** Base schema defining core types and interfaces */
export type QueryWidgetAnalyticsArgs = {
  input: WidgetAnalyticsInput;
};

export type QuickStat = {
  __typename: 'QuickStat';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  trend?: Maybe<Trend>;
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type QuickStatDataPoint = {
  __typename: 'QuickStatDataPoint';
  count?: Maybe<Scalars['Int']['output']>;
  date: Scalars['String']['output'];
  rawData?: Maybe<Array<RawVitalMeasurement>>;
  rawVnsSessions?: Maybe<Array<RawVnsSession>>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Input for requesting a quick stat calculation */
export type QuickStatFilterInput = {
  /** How to aggregate the stat values */
  aggregationStrategy: AggregationStrategy;
  /** Date range for the stat calculation */
  dateRange: DateRangeInput;
  /** Optional custom description for the stat */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional custom label for the stat */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional participant ID to filter by specific participant */
  participantId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the stat to calculate (e.g., chatInboundMessages, chatOutboundMessages, chatResponseRate) */
  statName: Scalars['String']['input'];
};

export type QuickStatTimeSeries = {
  __typename: 'QuickStatTimeSeries';
  aggregationStrategy?: Maybe<AggregationStrategy>;
  dataPoints: Array<QuickStatDataPoint>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type QuickStatTimeSeriesFilter = {
  ageBrackets?: InputMaybe<Array<AgeBracket>>;
  aggregationStrategy?: InputMaybe<AggregationStrategy>;
  cohort?: InputMaybe<CohortType>;
  dateRange: DateRangeInput;
  genders?: InputMaybe<Array<Gender>>;
  granularity?: InputMaybe<TimeSeriesGranularity>;
  includeRawData?: InputMaybe<Scalars['Boolean']['input']>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
  rmssdGroups?: InputMaybe<Array<RmssdGroup>>;
  statName: Scalars['String']['input'];
  timeBlocks?: InputMaybe<Array<TimeBlock>>;
};

export type RawVitalMeasurement = {
  __typename: 'RawVitalMeasurement';
  recordedAt: Scalars['DateTime']['output'];
  source?: Maybe<MetricSource>;
  timeBlock?: Maybe<TimeBlock>;
  type: VitalType;
  unit: MeasurementUnit;
  userId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RawVnsSession = {
  __typename: 'RawVnsSession';
  deviceInfo?: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Float']['output'];
  endTime: Scalars['DateTime']['output'];
  hasPostVitals: Scalars['Boolean']['output'];
  hasPreVitals: Scalars['Boolean']['output'];
  startTime: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  timeBlock?: Maybe<TimeBlock>;
  userId: Scalars['String']['output'];
  vnsSessionId: Scalars['String']['output'];
};

/** The mode one app-started Stone session started in. */
export type RecentStoneMode = {
  __typename: 'RecentStoneMode';
  /**
   * Whether the member can run this mode today: it is enabled in the catalogue, or it is the member's current
   * personalised mode. False = pick the default mode instead.
   */
  available: Scalars['Boolean']['output'];
  /** The mode's name when the session was written (not renamed afterwards); null when not recorded. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The mode catalogue id the session started in. */
  modeId: Scalars['ID']['output'];
  /** The mode's parameter set version the session started with; null when the app did not report it. */
  setVersion?: Maybe<Scalars['Int']['output']>;
  /** When the session started. */
  startedAt: Scalars['DateTime']['output'];
};

/** The modes of a member's last app-started Stone sessions. */
export type RecentStoneModes = {
  __typename: 'RecentStoneModes';
  /**
   * At most 10 sessions, newest first; the first is the previous mode. Not listed: device-started sessions, sessions
   * whose starter was not recorded (older app builds), sessions sent with an unknown starter, deleted sessions,
   * manually logged sessions, and sessions that named no catalogue mode (skipped,
   * so the next older one comes first). Empty = no app-started session that named a mode yet.
   */
  sessions: Array<RecentStoneMode>;
  /**
   * The member's current profile timezone (for example Europe/London), to show when each session started in the
   * member's own day. It is the zone now, not stored per session. Null when unknown.
   */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** Command for recording a complete biofeedback session */
export type RecordBiofeedbackSessionCommand = {
  /** The activity performed during this session */
  activity?: InputMaybe<ContentReferenceInput>;
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
  /** When the session ended */
  endTime: Scalars['DateTime']['input'];
  /** Vital measurements taken after the activity */
  postVitals?: InputMaybe<Array<VitalMeasurementInput>>;
  /** Vital measurements taken before the activity */
  preVitals?: InputMaybe<Array<VitalMeasurementInput>>;
  /** When the session started */
  startTime: Scalars['DateTime']['input'];
};

/** Command for recording a body metric */
export type RecordBodyMetricCommand = {
  /** When the measurement was taken */
  recordedAt: Scalars['DateTime']['input'];
  /** Type of body measurement */
  type: BodyMetricType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** The measured value */
  value: Scalars['Float']['input'];
};

/** Command for recording a checkin session */
export type RecordCheckinSessionCommand = {
  /** Cognitive measurements taken during the session */
  cognitiveMeasurements?: InputMaybe<Array<CognitiveMeasurementInput>>;
  /** When the session ended */
  endTime: Scalars['DateTime']['input'];
  /** Feeling measurements taken during the session */
  feelingMeasurements?: InputMaybe<Array<FeelingMeasurementInput>>;
  /** When the session started */
  startTime: Scalars['DateTime']['input'];
  /** Vital measurements taken during the session */
  vitalMeasurements?: InputMaybe<Array<VitalMeasurementInput>>;
};

export type RecordDailyLogCommand = {
  day: Scalars['Date']['input'];
  log: Scalars['String']['input'];
};

export type RecordDailyPainLevelCommand = {
  day: Scalars['Date']['input'];
  painLevel: Scalars['Int']['input'];
};

/** Command for recording a daily reflection */
export type RecordDailyReflectionCommand = {
  /** Answers for each wellness metric (exactly 4 required) */
  answers: Array<ReflectAnswerInput>;
  /** When the user completed the reflection */
  completedAt: Scalars['DateTime']['input'];
  /** Date of the reflection */
  date: Scalars['Date']['input'];
  /** Optional free-text note */
  note?: InputMaybe<Scalars['String']['input']>;
};

export type RecordDataExportInput = {
  columns: Array<Scalars['String']['input']>;
  exportType: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
  justification: Scalars['String']['input'];
  recordCount: Scalars['Int']['input'];
};

export type RecordDojoContentProgressCommand = {
  /**
   * ContentReferenceInput is a discriminated union type that can represent different types of content references.
   * It can be an external content ID or a mobile widget ID.
   * This input is used to specify the content item for which progress is being recorded.
   */
  contentReference: ContentReferenceInput;
  /** learningJourneyId is the ID of the learning journey to which the content belongs. */
  learningJourneyId: Scalars['ID']['input'];
  /**
   * Progress is a percentage value (0-100). It indicates how much of the content has been completed.
   * For example, if a user has read 3 out of 5 articles, the progress would be 60. Setting it to 100 indicates that
   * the content is fully completed.
   */
  progress: Scalars['Int']['input'];
  /** userId is the ID of the user whose progress is being recorded. */
  userId: Scalars['ID']['input'];
};

/** Command for recording an emotional state */
export type RecordEmotionalStateCommand = {
  /** List of feeling words (1-5 words) */
  feelings: Array<Scalars['String']['input']>;
  /** When the emotional state was recorded */
  recordedAt: Scalars['DateTime']['input'];
};

/** Command for recording a feeling metric */
export type RecordFeelingMetricCommand = {
  /** Optional details or notes about the feeling */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID of the originating activity or session */
  originId?: InputMaybe<Scalars['String']['input']>;
  /** When the feeling was recorded */
  recordedAt: Scalars['DateTime']['input'];
  /** Source of the measurement */
  source: MetricSource;
  /** Type of feeling being recorded */
  type: FeelingType;
  /** Value on the specified scale */
  value: Scalars['Float']['input'];
};

/** The note to record (YOJO-3118). There is no journal id: it always lands in the caller's own journal. */
export type RecordJournalNoteInput = {
  /**
   * The app's key for this draft: a UUID minted once per draft (never the nil UUID) and re-sent on every retry. The
   * server turns it into the note's id (noteId, jnote_…). Required.
   */
  clientNoteKey: Scalars['ID']['input'];
  /** The note's text, at most 10000 characters. */
  noteText: Scalars['String']['input'];
  /** Where the note came from; omit for a standalone note. */
  origin?: InputMaybe<JournalNoteOrigin>;
  /** The VNS session (vns_session) or check-in (check_in) the note is about; coach takes none. */
  originRef?: InputMaybe<Scalars['ID']['input']>;
  /**
   * When the member wrote it, on their own clock; at most five minutes in the future.
   * Rule for retries: re-send the exact same value on every retry; stored to the millisecond.
   */
  writtenAt: Scalars['DateTime']['input'];
};

export type RecordLessonsProgress = {
  lessonsProgress: Array<LessonProgressInput>;
};

/** Command for recording a mindstate metric */
export type RecordMindstateMetricCommand = {
  /** When the metric was recorded */
  recordedAt: Scalars['DateTime']['input'];
  /** Category of metric */
  type: MindstateMetricType;
  /** Values to record */
  values: Array<Scalars['String']['input']>;
};

/** YOJO-3607 — input for recordRefundReview: the refunded buyer, the entitlement reviewed, the decision and why. */
export type RecordRefundReviewInput = {
  customerId: Scalars['ID']['input'];
  decision: RefundReviewDecision;
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** Command for recording a vital metric */
export type RecordVitalMetricCommand = {
  /** When the measurement was taken */
  recordedAt: Scalars['DateTime']['input'];
  /** Duration in seconds of the Shen.AI scan. Nullable — older clients omit it; null is interpreted as 30s at read time. */
  scanDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Source of the measurement */
  source: MetricSource;
  /** Type of vital being recorded */
  type: VitalType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** The measured value */
  value: Scalars['Float']['input'];
};

/** Input for recording a VNS therapy session */
export type RecordVnsSessionCommand = {
  /** Optional device information */
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
  /** When the session ended */
  endTime: Scalars['DateTime']['input'];
  /** Individual phases within the session */
  phases: Array<VnsPhaseInput>;
  /**
   * Optional delay duration for scheduling post-vitals reminder.
   * If not provided, defaults to 30 minutes.
   */
  postVitalsReminderDelay?: InputMaybe<Scalars['Duration']['input']>;
  /** Vital measurements taken before the VNS session */
  preVitals?: InputMaybe<Array<VitalMeasurementInput>>;
  /** When the session started */
  startTime: Scalars['DateTime']['input'];
  /** Status of the session completion */
  status: VnsSessionStatus;
  /** Total duration of the session */
  totalDuration: Scalars['Duration']['input'];
};

/** Input for recording post-vitals for an existing VNS therapy session */
export type RecordVnsSessionPostVitalsCommand = {
  /** Vital measurements taken after the VNS session */
  postVitals: Array<VitalMeasurementInput>;
  /** The session ID for which to record post-vitals */
  sessionId: Scalars['String']['input'];
};

/** A single metric answer within a daily reflection */
export type ReflectAnswer = {
  __typename: 'ReflectAnswer';
  /** Human-readable label for the value */
  label: Scalars['String']['output'];
  /** Which wellness metric this answer is for */
  metric: ReflectMetric;
  /** Numeric value (1-7 for all metrics) */
  value: Scalars['Int']['output'];
};

/** Input for a single metric answer */
export type ReflectAnswerInput = {
  /** Human-readable label for the value */
  label: Scalars['String']['input'];
  /** Which wellness metric this answer is for */
  metric: ReflectMetric;
  /** Numeric value (1-7 for all metrics) */
  value: Scalars['Int']['input'];
};

/** Categories of daily reflection wellness metrics */
export enum ReflectMetric {
  Energy = 'energy',
  Mood = 'mood',
  Resilience = 'resilience',
  Sleep = 'sleep'
}

export type RefundDetail = {
  __typename: 'RefundDetail';
  amountInCents: Scalars['Long']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  refundId: Scalars['ID']['output'];
  refundStatus?: Maybe<Scalars['String']['output']>;
};

/**
 * YOJO-3607 [refunded buyers: ops records "keep access + reason" so the Refunded badge clears] — the latest ops
 * decision on one entitlement after the buyer's refund. Record-only: it changes no access (ending access is
 * revokeEntitlement). A review covers the refunds recorded when it was made; a refund recorded later needs a new one.
 */
export type RefundReview = {
  __typename: 'RefundReview';
  decision: RefundReviewDecision;
  entitlementId: Scalars['ID']['output'];
  /** Audit trail: why the operator decided so (staff free text). */
  reason: Scalars['String']['output'];
  /** When the decision was recorded. */
  reviewedAt: Scalars['DateTime']['output'];
  /** usr_xxx of the operator who recorded it (null only if never captured). */
  reviewedBy?: Maybe<Scalars['String']['output']>;
};

/**
 * YOJO-3607 — what ops decided after reviewing a refunded buyer. Only keep for now; ending access stays
 * revokeEntitlement.
 */
export enum RefundReviewDecision {
  /** The buyer keeps access despite the refund; the Refunded highlight clears. */
  Keep = 'keep'
}

/** Input for registering a new VNS device */
export type RegisterVnsDeviceInput = {
  /** Device model (from device pairing) */
  model: Scalars['String']['input'];
  /** Optional user nickname for the device */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Device serial number (from device pairing) */
  serialNumber: Scalars['String']['input'];
};

export enum Relevance {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type RemovePathFromJourneyCommand = {
  learningJourneyId: Scalars['ID']['input'];
  learningPathId: Scalars['ID']['input'];
};

export type ReplacePlannedActivityCommand = {
  /**
   * Clear the planned Stone mode on the replacement (optional; care team only).
   * Absent or false: as before (the replacement keeps the replaced item's planned mode, or modeId replaces it).
   * true: the replacement has no planned mode ("member chooses"); a replacement that is not a vns_session has
   * no mode to clear, so true changes nothing there.
   * true together with modeId is refused as invalid input; true from a caller who is not care team is
   * refused as forbidden.
   */
  clearPlannedMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** New content reference for the activity */
  contentReference: ContentReferenceInput;
  /**
   * When to stop planning this activity (optional).
   *
   * If set, the activity will only appear in the user's schedule up to and including this date.
   * After this date passes, the activity will no longer appear in unrolled activities.
   *
   * Use cases:
   * - Day-specific onboarding content (e.g., set endDate to onboardingDate + 1 for Day 1 content)
   * - Limited-time challenges or seasonal activities
   * - Phased learning content that should only be available during specific periods
   *
   * Omit for indefinite planning (activity continues until completed with removeAfterCompletion=true
   * or manually deactivated).
   */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * A new Stone mode for the replacement (optional; care team only). Omit to keep the replaced item's
   * mode when both are a vns_session (unless clearPlannedMode is true). Checked like planActivity's modeId.
   */
  modeId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the activity to replace */
  plannedActivityId: Scalars['ID']['input'];
  /**
   * Whether to remove activity after completion
   * Default false for recurring activities
   */
  removeAfterCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When to start planning this activity (optional).
   *
   * If set, the activity will only appear in the user's schedule starting from this date.
   * Before this date, the activity will not appear in unrolled activities.
   *
   * Use cases:
   * - Onboarding content that should start on a specific day
   * - Scheduled challenges or events that begin on a future date
   * - Content unlocking based on program milestones
   *
   * Omit for immediate planning (activity starts appearing right away).
   */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** When the activity should be performed */
  timeSlots: Array<ActivityTimeSlotInput>;
};

/**
 * One placed component in the assembled report: a ComponentType bound to the Zone the recipe placed
 * it in, carrying that component's data-only payload. The Headline section carries the C1 type and the
 * deterministic one-liner (derived from the Hero) with a null payload.
 */
export type ReportSection = {
  __typename: 'ReportSection';
  componentType: ComponentType;
  /** Set only on the HEADLINE section — the deterministic one-liner derived from the Hero (C1). */
  headline?: Maybe<Scalars['String']['output']>;
  /** The data-only component payload — null on the HEADLINE section. */
  payload?: Maybe<ComponentPayloadData>;
  valence: Valence;
  zone: Zone;
};

/** What the app wrote to a member's device (YOJO-3261). */
export type ReportStoneModeWrittenInput = {
  /** The member's own device the mode was written to. */
  deviceId: Scalars['ID']['input'];
  /** The Stone mode written: an id from the member's Stone modes read. */
  modeId: Scalars['ID']['input'];
  /** The parameter-set version written (1 or more). */
  parametersVersion: Scalars['Int']['input'];
  /** The slot byte the app sent with that write (0..255); omit when unknown. */
  slot?: InputMaybe<Scalars['Int']['input']>;
  /** When the app wrote it to the device: from 2026-01-01, and at most 15 minutes ahead of the server's clock. */
  writtenAt: Scalars['DateTime']['input'];
};

/** Result of resending an activation email. */
export type ResendEmailResult = {
  __typename: 'ResendEmailResult';
  /** Status message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the resend was successful */
  success: Scalars['Boolean']['output'];
};

/** Resolution action for a service case. */
export enum ResolutionAction {
  Investigate = 'investigate',
  NoAction = 'no_action',
  Refund = 'refund',
  Reship = 'reship',
  SendReplacement = 'send_replacement'
}

export type ResolveServiceCaseInput = {
  performedBy: Scalars['String']['input'];
  resolutionNote?: InputMaybe<Scalars['String']['input']>;
  serviceCaseId: Scalars['ID']['input'];
};

/**
 * YOJO-1772: a single resolved broadcast recipient — user ID paired with the first
 * name we would greet them by (fallback chain Pii.firstName → displayName → 'there').
 * Lets the review modal show real recipient names instead of truncated user IDs.
 */
export type ResolvedRecipient = {
  __typename: 'ResolvedRecipient';
  resolvedFirstName: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

/**
 * Output of {@code resolveBroadcastRecipients}: the same filter pipeline result the
 * {@code initiateBroadcast} mutation would compute internally, but returned to the
 * client up front so the UI can render a review modal before confirmation.
 */
export type ResolvedRecipients = {
  __typename: 'ResolvedRecipients';
  /** Number of users dropped because they have no care channel in GetStream. */
  excludedNoChannel: Scalars['Int']['output'];
  /** Number of users dropped because they opted out of broadcasts. */
  excludedOptOut: Scalars['Int']['output'];
  /**
   * YOJO-3474 [a Free member's care chat pauses — broadcasts skip paused
   * channels]: number of users dropped because their care chat is paused (needs plan).
   */
  excludedPaused: Scalars['Int']['output'];
  /** Number of users dropped because they are flagged as test/internal accounts. */
  excludedTestUsers: Scalars['Int']['output'];
  /**
   * YOJO-1754: number of resolved recipients who would see the fallback greeting
   * ("Hi there, …") because no usable first name is on file. LIVE pre-send mirror of
   * BroadcastEntry.fallbackRecipientCount, so the review modal can warn before sending.
   */
  fallbackRecipientCount: Scalars['Int']['output'];
  /** YOJO-1772: per-recipient resolved first name (Pii.firstName → displayName → 'there'), same order as userIds. */
  recipients: Array<ResolvedRecipient>;
  /**
   * YOJO-1772: first NON-fallback recipient's real resolved first name
   * (usedFallback==false), for the illustrative example. Null when the whole
   * cohort is fallback or empty.
   */
  sampleResolvedFirstName?: Maybe<Scalars['String']['output']>;
  /** Human-readable description of the selection rule (e.g. 'hand_picked:3', 'all_active_participants'). */
  sourceRule: Scalars['String']['output'];
  /** Final recipient user IDs after all filters applied. */
  userIds: Array<Scalars['ID']['output']>;
};

/**
 * Counts of excluded recipients, broken out by exclusion rule, for the
 * 'Sent to X (Y opted out, Z test users)' UI summary.
 */
export type ResolvedRecipientsSummary = {
  __typename: 'ResolvedRecipientsSummary';
  excludedNoChannel: Scalars['Int']['output'];
  excludedOptOut: Scalars['Int']['output'];
  /**
   * YOJO-3474 [a Free member's care chat pauses — broadcasts skip paused
   * channels]: excluded because their care chat is paused (needs plan). 0 for
   * broadcasts recorded before this field existed.
   */
  excludedPaused: Scalars['Int']['output'];
  excludedTestUsers: Scalars['Int']['output'];
};

export type RevenueTarget = {
  __typename: 'RevenueTarget';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  month: Scalars['String']['output'];
  revenueTargetId: Scalars['ID']['output'];
  targetAmount: Scalars['BigDecimal']['output'];
};

export type Reviewer = {
  __typename: 'Reviewer';
  credentials?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Take a comp back. There is deliberately no `source` field: it is fixed to `comp`, so this can never
 * revoke a subscription, trial or grandfather grant.
 */
export type RevokeCompCapabilityInput = {
  /**
   * Why it is being taken back, e.g. 'device replaced'. REQUIRED, and persisted on the event with the
   * revoking identity.
   */
  reason: Scalars['String']['input'];
  /** The ref the comp was granted on — only that grant is taken back. */
  sourceRef: Scalars['ID']['input'];
  subjectId: Scalars['ID']['input'];
};

/**
 * Take back ONE custom grant, by its ledger ROW id (YOJO-2598 [custom capability grants]).
 *
 * A revoke removes a ROW; it never edits a set. Anything the member still holds from another live row,
 * they still hold — which is why "revoke this capability" is not offered: a union cannot honestly support
 * it. Only a `custom` row can be taken back here; a grantId naming a subscription, trial, comp or
 * grandfather grant is refused.
 */
export type RevokeCustomCapabilityGrantInput = {
  /** The row being taken back — `cgrant_…`, read off `memberCapabilities.grants`. */
  grantId: Scalars['ID']['input'];
  /**
   * Why it is being taken back, e.g. 'trial period over'. REQUIRED, and persisted on the event with the
   * revoking identity.
   */
  reason: Scalars['String']['input'];
  subjectId: Scalars['ID']['input'];
};

export type RichContent = {
  __typename: 'RichContent';
  textBlocks: Array<RichTextBlock>;
};

export type RichTextBlock = {
  __typename: 'RichTextBlock';
  children: Array<Span>;
  style: BlockStyle;
};

/**
 * RMSSD group classification based on baseline HRV measurements.
 * Users are segmented into groups based on their baseline RMSSD.
 */
export enum RmssdGroup {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

/** Cohort data for a specific RMSSD group (low/medium/high baseline HRV) */
export type RmssdGroupCohort = {
  __typename: 'RmssdGroupCohort';
  /** Area Under Curve summary for this RMSSD group's percentage change trend */
  auc?: Maybe<CohortAuc>;
  /** Time series data points for this RMSSD group */
  dataPoints: Array<CohortAnalysisDataPoint>;
  /** The RMSSD group this cohort represents */
  rmssdGroup: RmssdGroup;
  /** Upper bound of this group's RMSSD range in ms (null for 'high' group meaning no maximum) */
  thresholdMax?: Maybe<Scalars['Float']['output']>;
  /** Lower bound of this group's RMSSD range in ms (null for 'low' group meaning no minimum) */
  thresholdMin?: Maybe<Scalars['Float']['output']>;
  /** Number of users in this RMSSD group */
  userCount: Scalars['Int']['output'];
};

export type RmssdStratification = {
  __typename: 'RmssdStratification';
  strata: Array<RmssdStratumStats>;
  thresholds: Array<AgeAdjustedThreshold>;
  totalUsers: Scalars['Int']['output'];
  usersExcludedNoAge: Scalars['Int']['output'];
  usersExcludedNoRmssd: Scalars['Int']['output'];
};

export type RmssdStratificationFilter = {
  /** Number of days to look back for baseline calculation (default: 7) */
  baselineDays?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum baseline measurements required (default: 2) */
  minBaselineMeasurements?: InputMaybe<Scalars['Int']['input']>;
  /** Number of recent days for current value calculation (default: 7) */
  recentDays?: InputMaybe<Scalars['Int']['input']>;
};

export enum RmssdStratum {
  Beneficial = 'beneficial',
  Monitor = 'monitor',
  NotRecommended = 'not_recommended'
}

export type RmssdStratumStats = {
  __typename: 'RmssdStratumStats';
  avgBaselineRmssd?: Maybe<Scalars['Float']['output']>;
  avgPercentageChange?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  stratum: RmssdStratum;
};

/** Available system roles */
export enum Role {
  Admin = 'admin',
  Analyst = 'analyst',
  Content = 'content',
  Developer = 'developer',
  Growth = 'growth',
  Nurse = 'nurse',
  Operations = 'operations',
  Participant = 'participant',
  Sales = 'sales',
  User = 'user'
}

/** The lifecycle of a booked tier change (M3). Exactly one state is non-terminal. */
export enum ScheduledChangeStatus {
  /** The sweep applied it at the term boundary. */
  Applied = 'applied',
  /** A human called it off. */
  Cancelled = 'cancelled',
  /** Waiting for effectiveAt — the only state the nightly sweep acts on. */
  Pending = 'pending',
  /**
   * It stopped being relevant before it fired — a newer booking replaced it, or a grant/revoke on the
   * same sourceRef cancelled it. Recorded rather than deleted, so the trail shows what did NOT happen.
   */
  Superseded = 'superseded'
}

export type ScheduledNotification = {
  __typename: 'ScheduledNotification';
  id: Scalars['ID']['output'];
  scheduledTime: Scalars['DateTime']['output'];
  status: ScheduledNotificationStatus;
  userId: Scalars['String']['output'];
};

export enum ScheduledNotificationStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Scheduled = 'scheduled'
}

/** Represents a calculated score based on various metrics */
export type Score = {
  __typename: 'Score';
  /** When this score was calculated */
  calculatedAt: Scalars['DateTime']['output'];
  /** Description of what this score represents */
  description: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Name of the score */
  name: Scalars['String']['output'];
  type: ScoreType;
  /** User this score belongs to */
  userId: Scalars['String']['output'];
  /** The calculated score value (0-100) */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Types of wellness scores */
export enum ScoreType {
  BalanceIndex = 'balance_index',
  CognitiveIndex = 'cognitive_index',
  ProcessingSpeed = 'processing_speed',
  ReactionTime = 'reaction_time',
  StroopInhibition = 'stroop_inhibition'
}

/** A predefined user segment with computed membership. */
export type Segment = {
  __typename: 'Segment';
  /** Description of what this segment represents */
  description: Scalars['String']['output'];
  /** Unique segment identifier (e.g., 'app_at_risk', 'vns_never_started') */
  id: Scalars['ID']['output'];
  /** Number of users currently in this segment */
  memberCount: Scalars['Int']['output'];
  /** Human-readable segment name */
  name: Scalars['String']['output'];
};

/** Count for a single segment. */
export type SegmentCount = {
  __typename: 'SegmentCount';
  count: Scalars['Int']['output'];
  segmentId: Scalars['String']['output'];
};

/** Dimension to segment users by in composite segmentation */
export enum SegmentDimension {
  AgeBracket = 'ageBracket',
  ChatResponsiveness = 'chatResponsiveness',
  Gender = 'gender',
  RmssdGroup = 'rmssdGroup',
  TimeBlock = 'timeBlock',
  VnsConsistency = 'vnsConsistency',
  VnsUsage = 'vnsUsage'
}

export type SegmentStats = {
  __typename: 'SegmentStats';
  active: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Summary statistics for all segments. */
export type SegmentSummary = {
  __typename: 'SegmentSummary';
  /** Count per segment */
  segmentCounts: Array<SegmentCount>;
  /** Total participants tracked */
  totalParticipants: Scalars['Int']['output'];
};

/** Detailed segment information including members. */
export type SegmentWithMembers = {
  __typename: 'SegmentWithMembers';
  /** User IDs in this segment */
  memberIds: Array<Scalars['ID']['output']>;
  /** Segment metadata */
  segment: Segment;
};

export type SendPushNotificationCommand = {
  /** Notification body text */
  body: Scalars['String']['input'];
  /** Optional chat room ID if notification is related to chat */
  chatRoomId?: InputMaybe<Scalars['String']['input']>;
  /** Optional image URL to show with notification */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Optional scheduled time. If not set, notification is sent immediately */
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional notification sound (defaults to "default") */
  sound?: InputMaybe<Scalars['String']['input']>;
  /** Notification title */
  title: Scalars['String']['input'];
  /** User ID to send the notification to */
  to: Scalars['String']['input'];
};

/**
 * YOJO-2393 (ADR-0013) — one distinct serial matched by memberBySerial: everything known about that serial
 * across the possession world (members holding a device with it, the devices themselves) and the purchase
 * world (its pre-registration overlay, if any).
 */
export type SerialMatch = {
  __typename: 'SerialMatch';
  /** The registered devices carrying this serial. */
  devices: Array<VnsDevice>;
  /**
   * The members who have held a device with this serial: the possession history,
   * including an account whose link has since closed (a Stone moves to the latest
   * pairing, YOJO-3550). The devices list says who holds it now.
   */
  members: Array<SerialMatchMember>;
  /** The pre-registration overlay for this serial, or null if the serial was never pre-registered. */
  preRegistration?: Maybe<DeviceSerialPreRegistration>;
  serialNumber: Scalars['String']['output'];
};

/**
 * A member holding a device with the searched serial. Just the userId — the operator UI resolves member
 * detail through the existing participant queries.
 */
export type SerialMatchMember = {
  __typename: 'SerialMatchMember';
  userId: Scalars['ID']['output'];
};

/** A service case tracking a return, replacement, or lost shipment. */
export type ServiceCase = {
  __typename: 'ServiceCase';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  customerId: Scalars['ID']['output'];
  deviceSerial?: Maybe<Scalars['String']['output']>;
  issueType: IssueType;
  openedAt: Scalars['DateTime']['output'];
  performedBy: Scalars['String']['output'];
  reason: ServiceCaseReason;
  reasonDetail?: Maybe<Scalars['String']['output']>;
  replacementShipment?: Maybe<Shipment>;
  replacementShipmentId?: Maybe<Scalars['ID']['output']>;
  resolutionAction?: Maybe<ResolutionAction>;
  resolutionNote?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  returnCarrier?: Maybe<Scalars['String']['output']>;
  returnTrackingNumber?: Maybe<Scalars['String']['output']>;
  serviceCaseId: Scalars['ID']['output'];
  shipment?: Maybe<Shipment>;
  shipmentId: Scalars['ID']['output'];
  status: ServiceCaseStatus;
};

export type ServiceCaseOverview = {
  __typename: 'ServiceCaseOverview';
  awaitingReturn: Scalars['Int']['output'];
  openByIssueType?: Maybe<Scalars['JSON']['output']>;
  openCases: Scalars['Int']['output'];
  resolvedThisMonth: Scalars['Int']['output'];
};

/** Reason for opening a service case. */
export enum ServiceCaseReason {
  Cancellation = 'cancellation',
  Damaged = 'damaged',
  Defective = 'defective',
  EndOfSubscription = 'end_of_subscription',
  LostInTransit = 'lost_in_transit',
  NeverArrived = 'never_arrived',
  Other = 'other',
  VoluntaryReturn = 'voluntary_return'
}

/** Lifecycle status of a service case. */
export enum ServiceCaseStatus {
  AwaitingReturn = 'awaiting_return',
  Cancelled = 'cancelled',
  Investigating = 'investigating',
  Open = 'open',
  Resolved = 'resolved',
  ReturnInTransit = 'return_in_transit',
  ReturnReceived = 'return_received'
}

/**
 * The shortest and longest session a member may choose, in minutes, both inclusive (YOJO-3473 [member's Stone-modes
 * read carries the allowed session-length range]).
 */
export type SessionMinutesRange = {
  __typename: 'SessionMinutesRange';
  /** The longest allowed session, in minutes (inclusive). */
  max: Scalars['Int']['output'];
  /** The shortest allowed session, in minutes (inclusive). */
  min: Scalars['Int']['output'];
};

/**
 * A plan's FULL Stone mode list plus the personalised mark — the care-portal mode picker's save.
 * `confirmedBy` is the admin's typed confirmation, required when a save of a list already saved removes a
 * mode or unmarks personalised; a first save takes nothing away and needs none (YOJO-3313).
 */
export type SetCapabilityPackageModesInput = {
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  includesPersonalised: Scalars['Boolean']['input'];
  modeIds: Array<Scalars['ID']['input']>;
  packageKey: Scalars['ID']['input'];
};

export type SetResolutionInput = {
  performedBy: Scalars['String']['input'];
  resolutionAction: ResolutionAction;
  resolutionNote?: InputMaybe<Scalars['String']['input']>;
  serviceCaseId: Scalars['ID']['input'];
};

/** A new version of the safety limits: a range for every stimulation parameter. */
export type SetStoneModeLimitsInput = {
  ranges: Array<StimulationParameterRangeInput>;
};

/**
 * Save a Stone mode's parameter set (YOJO-3259): the mode and the eight bounded values, in domain units. Deliberately
 * NO curve and no payload format: every set carries the shared vendor intensity curve and the one known format.
 */
export type SetStoneModeParametersInput = {
  frequencyHz: Scalars['Int']['input'];
  intensityCeiling: Scalars['Int']['input'];
  modeId: Scalars['ID']['input'];
  offTimeMilliseconds: Scalars['Int']['input'];
  onTimeMilliseconds: Scalars['Int']['input'];
  pulseWidthMicroseconds: Scalars['Int']['input'];
  rampDown: Scalars['Int']['input'];
  rampUp: Scalars['Int']['input'];
  sessionMinutes: Scalars['Int']['input'];
};

/** A shipment of physical products to a customer. */
export type Shipment = {
  __typename: 'Shipment';
  carrier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  customerId: Scalars['ID']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  items: Array<ShipmentItem>;
  /**
   * ADR-0015 (ruling 9): coarse origin of the physical dispatch. Nullable —
   * pre-ADR/live shipments carry no origin. Additive read-only surface.
   */
  origin?: Maybe<ShipmentOrigin>;
  /** YOJO-2872: set when the shipment is marked returned (RMA). Nullable — most shipments never return. */
  returnedAt?: Maybe<Scalars['DateTime']['output']>;
  shipmentId: Scalars['ID']['output'];
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ADR-0015: nullable — imported SA sheet shipments carry no address (recipient name + box code + date only). */
  shippingAddress?: Maybe<ShipmentAddress>;
  status: ShipmentStatus;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

/** Physical address for shipping. */
export type ShipmentAddress = {
  __typename: 'ShipmentAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

/** Address input for shipment creation. */
export type ShipmentAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

/** An individual item within a shipment. */
export type ShipmentItem = {
  __typename: 'ShipmentItem';
  deviceSerial?: Maybe<Scalars['String']['output']>;
  entitlement?: Maybe<Entitlement>;
  entitlementId: Scalars['ID']['output'];
  productType: ProductType;
  shipmentItemId: Scalars['ID']['output'];
};

/** Shipment item input for shipment creation. */
export type ShipmentItemInput = {
  entitlementId: Scalars['ID']['input'];
  productType: ProductType;
};

/**
 * Coarse origin of a shipment (ADR-0015 ruling 9): where the physical dispatch came from.
 * Values are geographic/source acronyms (UPPERCASE) matching the Java enum
 * yojo.crm.shipment.domain.ShipmentOrigin — unlike ShipmentStatus (lowercase domain enum).
 */
export enum ShipmentOrigin {
  Jdm = 'JDM',
  Sa = 'SA',
  Uk = 'UK'
}

/** Shipment lifecycle status. */
export enum ShipmentStatus {
  Delivered = 'delivered',
  InTransit = 'in_transit',
  Pending = 'pending',
  Returned = 'returned',
  Shipped = 'shipped'
}

/**
 * Filter options for shipping status on customer queries.
 * Includes real shipment statuses plus no_shipment for customers with zero shipments.
 */
export enum ShippingFilterOption {
  Delivered = 'delivered',
  InTransit = 'in_transit',
  NoShipment = 'no_shipment',
  Pending = 'pending',
  Returned = 'returned',
  Shipped = 'shipped'
}

/**
 * How members who would LOSE a capability are handled when a package shrinks (P9). There is no silent
 * option: a shrink without one of these is rejected.
 *
 * NOT AVAILABLE FOR DIALS: `grandfather` works by minting the removed CAPABILITIES onto current holders
 * as individual grants, and a number cannot be minted as a capability — the mint would preserve nothing
 * while every holder took the cut. A dial decrease must therefore be `outright`, and `grandfather` is
 * rejected for one.
 */
export enum ShrinkMode {
  /** Preserve the removed capabilities for current holders as individual grants. */
  Grandfather = 'grandfather',
  /** Take the capabilities away from current holders too. Requires a typed confirmation. */
  Outright = 'outright'
}

/**
 * The single-content payload — what each recipient will get planned for them
 * when YOJO-1745's fan-out service dispatches per-user PlanActivityCommands.
 */
export type SingleContentPayload = {
  __typename: 'SingleContentPayload';
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  endDate?: Maybe<Scalars['Date']['output']>;
  /** The Stone mode planned for a vns_session; null = each recipient chooses. */
  modeId?: Maybe<Scalars['ID']['output']>;
  removeAfterCompletion: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  timeSlots: Array<ActivityTimeSlot>;
};

/** Phase 1 payload: one piece of content scheduled for every recipient. */
export type SingleContentPayloadInput = {
  contentReference: ContentReferenceInput;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * The Stone mode to plan for a vns_session (optional). Checked per member: a member who cannot run it
   * is left out (excludedSummary.plannedModeExclusions, with the reason) and the rest proceed.
   */
  modeId?: InputMaybe<Scalars['ID']['input']>;
  removeAfterCompletion: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  timeSlots: Array<ActivityTimeSlotInput>;
};

/** Filter for sleep cohort analysis */
export type SleepCohortFilter = {
  /** Number of days for baseline calculation (default 7) */
  baselineDays?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum days from Day 0 to include in the cohort analysis */
  maxDays: Scalars['Int']['input'];
  /** Sleep metric to analyze: sleepDuration, sleepEfficiency, deepSleepPercent, remSleepPercent, hrvRmssd */
  metric: Scalars['String']['input'];
  /** Minimum baseline measurements required (default 3) */
  minBaselineMeasurements?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Optional wearable provider filter (e.g. "whoop", "oura", "apple_health").
   * When set, only sleep records from this provider are included.
   */
  provider?: InputMaybe<Scalars['String']['input']>;
};

/** VNS dose-response analysis grouping users by VNS session frequency */
export type SleepDoseResponse = {
  __typename: 'SleepDoseResponse';
  /** Cohort analysis for users with 5+ VNS sessions/week */
  highFrequency: SleepDoseResponseGroup;
  /** Cohort analysis for users with 1-2 VNS sessions/week */
  lowFrequency: SleepDoseResponseGroup;
  /** Cohort analysis for users with 3-4 VNS sessions/week */
  mediumFrequency: SleepDoseResponseGroup;
};

/** A single dose-response group with VNS frequency and sleep improvement metrics */
export type SleepDoseResponseGroup = {
  __typename: 'SleepDoseResponseGroup';
  /** Average sleep efficiency improvement in percent (vs baseline) */
  avgEfficiencyImprovement?: Maybe<Scalars['Float']['output']>;
  /** Average HRV RMSSD improvement in percent (vs baseline) */
  avgHrvImprovement?: Maybe<Scalars['Float']['output']>;
  /** Average sleep duration improvement in percent (vs baseline) */
  avgSleepImprovement?: Maybe<Scalars['Float']['output']>;
  /** Human-readable label for this frequency group */
  label: Scalars['String']['output'];
  /** Number of users in this group */
  userCount: Scalars['Int']['output'];
};

/** Daily aggregated sleep metrics for trend charts */
export type SleepMetricDataPoint = {
  __typename: 'SleepMetricDataPoint';
  avgDeepSleepPercent?: Maybe<Scalars['Float']['output']>;
  avgEfficiencyPercent?: Maybe<Scalars['Float']['output']>;
  avgHrvRmssd?: Maybe<Scalars['Float']['output']>;
  avgSleepMinutes?: Maybe<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
  recordCount: Scalars['Int']['output'];
};

/** Summary statistics for sleep metrics */
export type SleepMetricsSummary = {
  __typename: 'SleepMetricsSummary';
  avgDeepSleepPercent?: Maybe<Scalars['Float']['output']>;
  avgEfficiencyPercent?: Maybe<Scalars['Float']['output']>;
  avgHrvRmssd?: Maybe<Scalars['Float']['output']>;
  avgRemSleepPercent?: Maybe<Scalars['Float']['output']>;
  avgSleepMinutes: Scalars['Float']['output'];
  totalSleepRecords: Scalars['Int']['output'];
  totalUsersWithSleepData: Scalars['Int']['output'];
};

/** Aggregated sleep metrics for a group of nights */
export type SleepNightMetrics = {
  __typename: 'SleepNightMetrics';
  /** Average deep sleep percentage */
  avgDeepSleepPercent?: Maybe<Scalars['Float']['output']>;
  /** Average sleep efficiency percent */
  avgEfficiency?: Maybe<Scalars['Float']['output']>;
  /** Average HRV RMSSD during sleep */
  avgHrvRmssd?: Maybe<Scalars['Float']['output']>;
  /** Average sleep duration in minutes */
  avgSleepMinutes?: Maybe<Scalars['Float']['output']>;
  /** Total number of nights in this group */
  nightCount: Scalars['Int']['output'];
};

/** Night-of analysis comparing sleep on VNS nights vs non-VNS nights */
export type SleepNightOfAnalysis = {
  __typename: 'SleepNightOfAnalysis';
  /** Average sleep metrics on nights without a preceding VNS session */
  nonVnsNights: SleepNightMetrics;
  /** Number of users with both VNS and non-VNS nights */
  userCount: Scalars['Int']['output'];
  /** Average sleep metrics on nights after a VNS session */
  vnsNights: SleepNightMetrics;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SourceCredit = {
  __typename: 'SourceCredit';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Span = {
  __typename: 'Span';
  marks?: Maybe<Array<MarkType>>;
  text: Scalars['String']['output'];
};

/** Command for starting content */
export type StartContentCommand = {
  /** Content to start */
  contentId: ContentReferenceInput;
  /** Optional source indicating where this content engagement originated from */
  source?: InputMaybe<ContentSource>;
};

/** Input for starting a VNS therapy session. Returns a generated session ID. */
export type StartVnsSessionCommand = {
  /** Device information */
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
  /** The kind of device driving the session (optional) */
  deviceKind?: InputMaybe<VnsDeviceKind>;
  /**
   * The serial of the Stone the session ran on, as the app read it. Optional;
   * absent = credited to the uploader as before. A stored (device_record) session
   * is credited only if this Stone was linked to the uploader at the session's
   * start — ADR 0016, YOJO-3557.
   */
  deviceSerial?: InputMaybe<Scalars['String']['input']>;
  /** Initial device settings */
  initialSettings: VnsSettingsInput;
  /** Who started the session (optional) */
  initiator?: InputMaybe<VnsSessionInitiator>;
  /**
   * Where this session is recorded from: live while the app runs it, or uploaded
   * later from the Stone's own store. Leave it out for a live session.
   */
  origin?: InputMaybe<VnsSessionOrigin>;
  /** The planned item (actitem_...) the session was started from (optional) */
  plannedActivityId?: InputMaybe<Scalars['ID']['input']>;
  /** Pre-vitals can be recorded at session start */
  preVitals?: InputMaybe<Array<VitalMeasurementInput>>;
  /** Optional session ID. If not provided, server will generate one. */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** When the session is starting */
  startTime: Scalars['DateTime']['input'];
};

/** Which Stone mode ids a stimulation capability stands for (admin data), in the admin's ordering. */
export type StimulationCapabilityModes = {
  __typename: 'StimulationCapabilityModes';
  capability: Capability;
  mappedAt: Scalars['DateTime']['output'];
  mappedBy: Scalars['String']['output'];
  modeIds: Array<Scalars['ID']['output']>;
};

/**
 * A stimulation parameter that safety limits bound (YOJO-3258). The intensity ceiling's max is at most 30
 * whatever the limits say.
 */
export enum StimulationParameter {
  Frequency = 'frequency',
  IntensityCeiling = 'intensity_ceiling',
  OffTime = 'off_time',
  OnTime = 'on_time',
  PulseWidth = 'pulse_width',
  RampDown = 'ramp_down',
  RampUp = 'ramp_up',
  SessionLength = 'session_length'
}

export type StimulationParameterRange = {
  __typename: 'StimulationParameterRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  parameter: StimulationParameter;
};

export type StimulationParameterRangeInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
  parameter: StimulationParameter;
};

/**
 * The eight values of a Stone parameter set, as a coach types them, in domain units. Deliberately NO curve and no
 * payload format: every set carries the shared vendor intensity curve and the one known format.
 */
export type StimulationParameterValuesInput = {
  /** Stimulation frequency, Hz. */
  frequencyHz: Scalars['Int']['input'];
  /** Max intensity level, at most 30. */
  intensityCeiling: Scalars['Int']['input'];
  /** Duty-cycle off time, milliseconds. */
  offTimeMilliseconds: Scalars['Int']['input'];
  /** Duty-cycle on time, milliseconds. */
  onTimeMilliseconds: Scalars['Int']['input'];
  /** Pulse width, microseconds. */
  pulseWidthMicroseconds: Scalars['Int']['input'];
  rampDown: Scalars['Int']['input'];
  rampUp: Scalars['Int']['input'];
  /** Session length, minutes. */
  sessionMinutes: Scalars['Int']['input'];
};

/** A Stone mode's parameter set, in domain units. */
export type StimulationParameters = {
  __typename: 'StimulationParameters';
  frequencyHz: Scalars['Int']['output'];
  intensityCeiling: Scalars['Int']['output'];
  intensityCurve: IntensityCurve;
  offTimeMilliseconds: Scalars['Int']['output'];
  onTimeMilliseconds: Scalars['Int']['output'];
  payloadFormatVersion: Scalars['Int']['output'];
  pulseWidthMicroseconds: Scalars['Int']['output'];
  rampDown: Scalars['Int']['output'];
  rampUp: Scalars['Int']['output'];
  sessionMinutes: Scalars['Int']['output'];
};

/** The device generation a Stone mode record is for (YOJO-3258 [Stone mode catalogue as data]). */
export enum StoneDeviceGeneration {
  Alpha = 'alpha',
  Stone = 'stone'
}

/**
 * One Stone mode record. `position` is its place in the admin's one ordering (disabled modes included), not a
 * device slot. `outsideCurrentLimits` flags a set saved under limits that have since been tightened.
 */
export type StoneMode = {
  __typename: 'StoneMode';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detailsVersion: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  generation: StoneDeviceGeneration;
  modeId: Scalars['ID']['output'];
  outsideCurrentLimits: Scalars['Boolean']['output'];
  parameters?: Maybe<StimulationParameters>;
  parametersVersion?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * The Stone mode catalogue in one read (YOJO-3258): every mode in the admin's order, the current safety limits
 * (null until an admin saves some), the default-mode setting and the stimulation-capability mapping (retired upon
 * YOJO-3313: a history read only, nothing reads it — a plan names its Stone modes). Nothing in code seeds any of it.
 *
 * Refusal codes. A refused catalogue mutation answers a GraphQL error whose `extensions.code` is one of the codes
 * below and whose `extensions.violations` lists every limit violation ({parameter, value, allowed {min, max}};
 * empty when the refusal is not about limits); `extensions.id` names the mode (or catalogue) concerned when there
 * is one, including a mode that WAS created when its move to the asked position is refused. When a parameter
 * set's intensity curve is not the shared vendor curve, `extensions.curveProblem` says how ({kind: `wrong_length`
 * or `not_shared_curve`, level (the first differing level, 0-based; null for wrong_length), given, expected});
 * absent otherwise. A set breaking both ranges and the curve is ONE refusal carrying both. A `malformed_import`
 * also carries `extensions.problems` ([String]: every problem with the pasted entry, one string each, in the
 * order found; read it instead of splitting the message, as a problem can itself contain "; "); absent on every
 * other code. The MCP tools answer the same code as `error`, the same `violations`, `curveProblem`, `problems`
 * and `id`. The codes are strings, not a served
 * enum (no field returns them):
 * - `invalid_generation`: a mode is for alpha or stone, not an unknown generation
 * - `mode_id_in_use`: that mode id was already issued; ids are never reused
 * - `unknown_mode`: no mode has that id
 * - `position_out_of_range`: the position is outside the ordering (nothing is created or moved)
 * - `alpha_record_fixed`: an Alpha record cannot be moved or disabled
 * - `alpha_parameters_read_only`: an Alpha record's parameter set is read-only
 * - `no_parameter_set`: a Stone mode needs a parameter set before it can be enabled
 * - `no_limits`: no safety limits are saved yet (the message still names an
 * off-curve set, with `curveProblem`, and a max intensity above 30)
 * - `outside_limits`: the parameter set is outside the current safety limits (every violation; and the curve, if off)
 * - `incomplete_limits`: the limits need a range for every stimulation parameter (every problem listed)
 * - `invalid_range`: a range's min is above its max (every problem listed)
 * - `ceiling_exceeded`: the intensity ceiling's max is above 30 (every problem listed)
 * - `default_mode_not_enabled`: the default must name an enabled mode
 * - `default_mode_has_no_set`: the default must name a mode with a parameter set
 * - `capability_not_mappable`: (retired YOJO-3313 — no longer returned) only stimulation_mode_balance and stimulation_modes_all could be mapped
 * - `unknown_catalogue`: there is exactly one catalogue
 * - `invalid_intensity_curve`: the set's intensity curve is not the shared vendor curve (see `curveProblem`)
 * - `alpha_record_not_mappable`: (retired YOJO-3313 — no longer returned) stimulation_modes_all could stand for Stone-generation modes only
 * - `balance_mapping_empty`: (retired YOJO-3313 — no longer returned) stimulation_mode_balance had to stand for at least one mode
 * - `malformed_import`: a vendor entry that cannot be read, or over 64 KiB (every
 * problem named in the message and listed in `problems`)
 * - `personalised_mode_exists`: the member already has a personalised mode (remove it before creating another)
 * - `no_personalised_mode`: the member has no current personalised mode
 * - `no_stone`: the member has no linked Stone (no device, or an Alpha): a personalised mode is Stone-only
 * - `plan_excludes_personalised`: the member's plan does not include a personalised mode
 * - `capability_retired`: mapping a stimulation capability to modes is retired (YOJO-3313) — a plan names its Stone modes
 *
 * Request codes. Before the catalogue judges a mutation, the request itself can be answered with one of these
 * transport-level codes in `extensions.code` (MCP: `error`), with a message naming the problem and nothing changed.
 * They are not refusal codes:
 * - `invalid_input`: the request cannot be read (a malformed mode id, a limits
 * parameter given twice, a `sourceNote` over 500 characters)
 * - `forbidden`: the caller's roles do not allow this write (admin or coach only)
 */
export type StoneModeCatalogue = {
  __typename: 'StoneModeCatalogue';
  /** @deprecated Retired upon YOJO-3313 — a plan names its Stone modes (CapabilityPackage.modeIds) */
  capabilityModes: Array<StimulationCapabilityModes>;
  defaultMode: StoneModeDefault;
  limits?: Maybe<StoneModeLimits>;
  modes: Array<StoneMode>;
};

/**
 * The default-mode setting as it reads now. When it was never set, or names a disabled mode or one without a
 * parameter set, `usable` is false and `reason` begins "no default set"; no other mode is named in its place.
 */
export type StoneModeDefault = {
  __typename: 'StoneModeDefault';
  modeId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  setAt?: Maybe<Scalars['DateTime']['output']>;
  setBy?: Maybe<Scalars['String']['output']>;
  usable: Scalars['Boolean']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

/** One recorded version of the default-mode setting. */
export type StoneModeDefaultVersion = {
  __typename: 'StoneModeDefaultVersion';
  modeId: Scalars['ID']['output'];
  setAt: Scalars['DateTime']['output'];
  setBy: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** One version of the Stone mode safety limits, with who saved it and when. */
export type StoneModeLimits = {
  __typename: 'StoneModeLimits';
  ranges: Array<StimulationParameterRange>;
  setAt: Scalars['DateTime']['output'];
  setBy: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Why a listed mode is locked. Parse tolerantly: values may be added. */
export enum StoneModeLockReason {
  /** The member has no linked device: nothing is runnable. */
  NoDevice = 'no_device',
  /** The member's plan does not include it. */
  Plan = 'plan'
}

/**
 * One saved version of a Stone mode's parameter set (YOJO-3259), as recorded and never changed: the set, its
 * source (a set saved before sources were recorded reads `manual`) and note, the limits version it was checked
 * against, and who saved it and when.
 */
export type StoneModeParameterSetVersion = {
  __typename: 'StoneModeParameterSetVersion';
  changedAt: Scalars['DateTime']['output'];
  changedBy: Scalars['String']['output'];
  limitsVersion: Scalars['Int']['output'];
  parameters: StimulationParameters;
  source: ParameterSetSource;
  sourceNote?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** Whether a member may run a mode now. Parse tolerantly: values may be added. */
export enum StoneModeStanding {
  /** Listed in its slot, but not runnable now; lockReason says why. */
  Locked = 'locked',
  /** The member may run it. */
  Open = 'open'
}

/** The mode and parameter-set version the app last reported writing to the member's device. */
export type StoneModeWrite = {
  __typename: 'StoneModeWrite';
  /** The mode written. */
  modeId: Scalars['ID']['output'];
  /** The parameter-set version written. */
  parametersVersion: Scalars['Int']['output'];
  /** When the server received the app's report. */
  reportedAt: Scalars['DateTime']['output'];
  /** The slot byte the app sent with that write (0..255); null when the app did not report it. */
  slot?: Maybe<Scalars['Int']['output']>;
  /** When the app wrote it to the device. */
  writtenAt: Scalars['DateTime']['output'];
};

/** Which device a member's Stone modes answer is for. Parse tolerantly: values may be added. */
export enum StoneModesDevice {
  /** An Alpha: its records, open. */
  Alpha = 'alpha',
  /** No linked device: every enabled Stone mode is listed, locked (no_device). */
  NoDevice = 'no_device',
  /** A Stone. */
  Stone = 'stone',
  /** A registered device that could not be classified: no mode is listed. */
  Unknown = 'unknown'
}

/**
 * The record the app writes to the member's Stone. Always valid when present: there is no status field, and
 * expiresAt is always in the future.
 */
export type StoneRecord = {
  __typename: 'StoneRecord';
  /** When the record on the Stone stops being valid; always in the future. Renew it before then. */
  expiresAt: Scalars['DateTime']['output'];
  /** How many sessions the Stone may start from its own button without the phone before the app must be opened again. */
  offlineAllowance: Scalars['Int']['output'];
};

export enum StoneStatus {
  InHand = 'in_hand',
  None = 'none',
  OnItsWay = 'on_its_way',
  Owed = 'owed',
  ShouldBeInHand = 'should_be_in_hand'
}

export type Story = BaseArticle & CmsDocument & Content & {
  __typename: 'Story';
  biopsychosocialScores: Array<BiopsychosocialScore>;
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  frames: Array<ContentFrame>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  impactedVitals?: Maybe<Array<ImpactedVital>>;
  interventionType?: Maybe<InterventionType>;
  mediaType?: Maybe<MediaType>;
  metadata: Metadata;
  protocols?: Maybe<Array<Protocol>>;
  reviewer?: Maybe<Reviewer>;
  subprotocols?: Maybe<Array<Subprotocol>>;
  thumbnail?: Maybe<Image>;
  /** Title of the article as defined in the CMS. */
  title: Scalars['String']['output'];
  userIntent?: Maybe<UserIntent>;
};

export type StoryTeaser = BaseTeaser & CmsDocument & Content & DojoElement & {
  __typename: 'StoryTeaser';
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  ctaButtonLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkedContent?: Maybe<CustomActivityId | ExternalContentId | MobileWidgetId>;
  media?: Maybe<File | Image | Video | VideoCaption>;
  /** @deprecated Renamed to `title` */
  name?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum StressImpact {
  MinorNegativeImpact = 'minor_negative_impact',
  ModerateNegativeImpact = 'moderate_negative_impact',
  NoImpact = 'no_impact',
  NotSure = 'not_sure',
  PositiveImpact = 'positive_impact',
  SignificantNegativeImpact = 'significant_negative_impact'
}

export enum StressManagementMethod {
  Compartmentalize = 'compartmentalize',
  Mindfulness = 'mindfulness',
  NotManagingWell = 'not_managing_well',
  Other = 'other',
  PowerThrough = 'power_through',
  ScreenDistraction = 'screen_distraction',
  StayActive = 'stay_active',
  TalkWithTrusted = 'talk_with_trusted'
}

export enum StressMotivation {
  ALittleMotivated = 'a_little_motivated',
  ExtremelyMotivated = 'extremely_motivated',
  NotFocused = 'not_focused',
  QuiteMotivated = 'quite_motivated',
  SomewhatMotivated = 'somewhat_motivated'
}

export enum StressStrategy {
  Articles = 'articles',
  Breathing = 'breathing',
  Meditation = 'meditation',
  Mindfulness = 'mindfulness',
  Nothing = 'nothing',
  PhysicalExercise = 'physical_exercise',
  Therapy = 'therapy',
  Yoga = 'yoga'
}

export type SubheadingBlock = {
  __typename: 'SubheadingBlock';
  text: Scalars['String']['output'];
};

/** Input for submitting app feedback */
export type SubmitAppFeedbackInput = {
  /** Optional free-text comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The sentiment category */
  sentiment?: InputMaybe<AppFeedbackSentiment>;
};

/**
 * Submit per-component feedback (👍/👎) on one component of the caller's own Member Health Report
 * (YOJO-1947). The owning member and the server-side ids are resolved from the authenticated
 * identity — never sent by the client. A `down` reaction REQUIRES a reasonCode.
 */
export type SubmitComponentFeedbackCommand = {
  /** Which catalogued component the feedback is about (e.g. C1_CHANGE_POINT_HERO). */
  componentType: ComponentType;
  /** Optional free-text elaboration (allowed for both 👍 and 👎). */
  freeText?: InputMaybe<Scalars['String']['input']>;
  /** 👍 (up) or 👎 (down). A 👎 requires a reasonCode. */
  reaction: FeedbackReaction;
  /** Required for a 👎; must be null/omitted for a 👍. */
  reasonCode?: InputMaybe<FeedbackReasonCode>;
  /** The report the feedback is about (the caller's own report). */
  reportId: Scalars['String']['input'];
};

/**
 * One uploaded device session trace ("black box") — a VNS BLE conversation or a ShenAI scan
 * timeline. The opaque gzipped-NDJSON payload rides in payloadGzipBase64; everything else is the
 * searchable metadata mirrored into the BigQuery index. userId is NOT a field — it is taken only
 * from the authenticated identity.
 */
export type SubmitDeviceSessionTraceInput = {
  /** Mobile app version that produced the trace. */
  appVersion: Scalars['String']['input'];
  /** BLE device serial, when applicable (null for a ShenAI scan). */
  deviceSerial?: InputMaybe<Scalars['String']['input']>;
  /** BLE disconnect count, when applicable. */
  disconnectCount?: InputMaybe<Scalars['Int']['input']>;
  /** Session end instant — must be >= startedAt. */
  endedAt: Scalars['DateTime']['input'];
  /** Opaque error flags raised during the session (may be empty). */
  errorFlags: Array<Scalars['String']['input']>;
  /** Number of frames / samples in the session. */
  frameCount: Scalars['Int']['input'];
  /** Trace kind, e.g. vns_ble or shenai_scan. Open string (NOT an enum), lowercase-snake. */
  kind: Scalars['String']['input'];
  /** Base64 of the raw gzip bytes of the NDJSON payload. */
  payloadGzipBase64: Scalars['String']['input'];
  /** Client platform, e.g. ios / android. */
  platform: Scalars['String']['input'];
  /** Client-declared payload schema version (accepted as-is at ingest). */
  schemaVersion: Scalars['Int']['input'];
  /** Firmware / hardware source version, when applicable. */
  sourceVersion?: InputMaybe<Scalars['String']['input']>;
  /** Session start instant (its UTC date drives the GCS object key). */
  startedAt: Scalars['DateTime']['input'];
  /** Client-generated trace id — must be a valid UUID (also the GCS object name). */
  traceId: Scalars['ID']['input'];
  /** Opaque VNS session ids this trace relates to (may be empty). */
  vnsSessionIds: Array<Scalars['String']['input']>;
};

/**
 * Submit report-level feedback (👍/👎) on the caller's own Member Health Report as a whole — NOT tied
 * to any single component (YOJO-1947). A `down` reaction REQUIRES a reasonCode.
 */
export type SubmitReportFeedbackCommand = {
  /** Optional free-text elaboration (allowed for both 👍 and 👎). */
  freeText?: InputMaybe<Scalars['String']['input']>;
  /** 👍 (up) or 👎 (down). A 👎 requires a reasonCode. */
  reaction: FeedbackReaction;
  /** Required for a 👎; must be null/omitted for a 👍. */
  reasonCode?: InputMaybe<FeedbackReasonCode>;
  /** The report the feedback is about (the caller's own report). */
  reportId: Scalars['String']['input'];
};

export enum Subprotocol {
  AcceptanceAndCommitmentTherapy = 'acceptance_and_commitment_therapy',
  ActionableHealthInsights = 'actionable_health_insights',
  Acupressure = 'acupressure',
  ArtTherapy = 'art_therapy',
  BodyScan = 'body_scan',
  BoxBreathing = 'box_breathing',
  CleansingBreath = 'cleansing_breath',
  CognitiveBehavioralTherapy = 'cognitive_behavioral_therapy',
  CoherentBreathing = 'coherent_breathing',
  DiaphragmaticBreathing = 'diaphragmatic_breathing',
  Diet = 'diet',
  Education = 'education',
  ExerciseSnacks = 'exercise_snacks',
  FourSevenEightBreathing = 'four_seven_eight_breathing',
  Guided = 'guided',
  HealthCoachChats = 'health_coach_chats',
  HealthMonitoring = 'health_monitoring',
  Journaling = 'journaling',
  JustSit = 'just_sit',
  MealPlanning = 'meal_planning',
  MindfulnessBasedStressReduction = 'mindfulness_based_stress_reduction',
  Mindset = 'mindset',
  OneToTwoRatioBreathing = 'one_to_two_ratio_breathing',
  Pilates = 'pilates',
  PreventativeStrength = 'preventative_strength',
  Qigong = 'qigong',
  SelfMassage = 'self_massage',
  SleepHygiene = 'sleep_hygiene',
  SoundTherapy = 'sound_therapy',
  Stretching = 'stretching',
  TaiChi = 'tai_chi',
  TranscutaneousAuricularVagusNerveStimulation = 'transcutaneous_auricular_vagus_nerve_stimulation',
  VagusNerveSelfActivation = 'vagus_nerve_self_activation',
  Yoga = 'yoga'
}

/**
 * One operator subscription-cancellation fact recorded on an entitlement (YOJO-2866, ADR 0014).
 * Audit-only — it records who/mode/why/when for a cancel or a reverse and drives no billing lifecycle
 * (the existing Stripe webhook cascade owns that). action discriminates a cancel (requested) from an
 * un-cancel (reversed); for a reversal both mode and reason are null.
 */
export type SubscriptionCancellation = {
  __typename: 'SubscriptionCancellation';
  /** Whether this row is a cancellation (requested) or a reversal (reversed). */
  action: SubscriptionCancellationAction;
  /** The cancel mode (period_end / immediate); null for a reversal. */
  mode?: Maybe<SubscriptionCancellationMode>;
  /** When the action was recorded (requestedAt or reversedAt). */
  occurredAt: Scalars['DateTime']['output'];
  /** usr_xxx operator who performed the action. */
  performedBy?: Maybe<Scalars['String']['output']>;
  /** Audit trail: why the subscription was cancelled (nullable; always null for a reversal). */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Whether a SubscriptionCancellation row records a cancel or an un-cancel (YOJO-2866, ADR 0014). */
export enum SubscriptionCancellationAction {
  /** A cancellation was requested at Stripe (period-end or immediate — see mode). */
  Requested = 'requested',
  /** A pending period-end cancellation was reversed (subscription kept live). */
  Reversed = 'reversed'
}

/** How an operator cancellation was performed (YOJO-2866, ADR 0014). */
export enum SubscriptionCancellationMode {
  /** Subscription.cancel() — access ends immediately. */
  Immediate = 'immediate',
  /** cancel_at_period_end=true — the member keeps access until the end of the billing period. */
  PeriodEnd = 'period_end'
}

/**
 * One operator subscription-extension fact recorded on an entitlement (YOJO-2865/2867, ADR 0014).
 * Audit-only — it records who/why/what and drives no billing lifecycle (the Stripe webhook cascade owns that).
 */
export type SubscriptionExtension = {
  __typename: 'SubscriptionExtension';
  /** When the extension was recorded. */
  extendedAt: Scalars['DateTime']['output'];
  /** usr_xxx operator who performed the extension. */
  extendedBy?: Maybe<Scalars['String']['output']>;
  /** How many months the renewal was pushed out. */
  months: Scalars['Int']['output'];
  /** The new renewal anchor (trial_end = previousPeriodEnd + months) set at Stripe. */
  newPeriodEnd: Scalars['DateTime']['output'];
  /** The subscription's current_period_end BEFORE the extension (nullable). */
  previousPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Audit trail: why the subscription was extended. */
  reason: Scalars['String']['output'];
};

/** Status of a Stripe subscription */
export enum SubscriptionStatus {
  /** Subscription is active and current */
  Active = 'ACTIVE',
  /** Subscription is cancelled */
  Cancelled = 'CANCELLED',
  /** Subscription has expired */
  Expired = 'EXPIRED',
  /** Subscription setup is incomplete */
  Incomplete = 'INCOMPLETE',
  /** Payment is past due */
  PastDue = 'PAST_DUE',
  /** Subscription is in trial period */
  Trialing = 'TRIALING'
}

export type SyncFailure = {
  __typename: 'SyncFailure';
  accountHolderId: Scalars['ID']['output'];
  error: Scalars['String']['output'];
};

export type SyncRolesResult = {
  __typename: 'SyncRolesResult';
  failedCount: Scalars['Int']['output'];
  failures: Array<SyncFailure>;
  syncedCount: Scalars['Int']['output'];
};

/**
 * Union of content types that can appear in the Tenpo Storefront.
 * Excludes DojoChecklist and DojoQuiz as they don't have visual media.
 */
export type TenpoElement = ArticleTeaser | DojoArticle | DojoNugget | DojoQuote | StoryTeaser | VideoTeaser;

/** The Tenpo Storefront singleton containing curated content for the mobile app's carousel */
export type TenpoStorefront = {
  __typename: 'TenpoStorefront';
  /** Curated content for the storefront */
  content: Array<TenpoElement>;
  id: Scalars['ID']['output'];
};

/** Time of day for activity planning */
export enum TimeBlock {
  Afternoon = 'afternoon',
  Bedtime = 'bedtime',
  Evening = 'evening',
  Morning = 'morning'
}

/** Represents a user's preferred time for a specific time block */
export type TimeBlockPreference = {
  __typename: 'TimeBlockPreference';
  /** User's preferred time for this block */
  preferredTime: Scalars['LocalTime']['output'];
  /** The time block (morning, afternoon, evening, bedtime) */
  timeBlock: TimeBlock;
};

export type TimeBlockPreferenceInput = {
  preferredTime: Scalars['LocalTime']['input'];
  timeBlock: TimeBlock;
};

/** Statistics for a specific time block */
export type TimeBlockStats = {
  __typename: 'TimeBlockStats';
  /** Average HRV improvement for this time block (ms) */
  avgHrvImprovement?: Maybe<Scalars['Float']['output']>;
  /** Average sleep improvement for this time block (minutes) */
  avgSleepImprovement?: Maybe<Scalars['Float']['output']>;
  /** Number of sessions in this time block */
  sessionCount: Scalars['Int']['output'];
  /** Time of day (morning, afternoon, evening, bedtime) */
  timeBlock: Scalars['String']['output'];
};

export enum TimeOfDay {
  Afternoon = 'afternoon',
  Always = 'always',
  EarlyMorning = 'early_morning',
  Evening = 'evening',
  LateMorning = 'late_morning',
  Night = 'night',
  NotSure = 'not_sure'
}

export enum TimeSeriesGranularity {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

/**
 * The member's Today: what to do next, the rest of the day, and what is done, for the member's own day
 * (it rolls over at 03:00 on the member's clock).
 */
export type Today = {
  __typename: 'Today';
  /** Shown above the next step, never in its place. */
  alerts: Array<TodayAlert>;
  /** The instant this Today was worked out at. */
  asOf: Scalars['DateTime']['output'];
  /** What is done today. */
  completed: Array<TodayItem>;
  /** The business date: the calendar date the member's current day started on. */
  date: Scalars['Date']['output'];
  device: TodayDevice;
  /** Everything else still open today, in order. */
  later: Array<TodayItem>;
  /** The one thing to do next. Never null: when nothing is open it is done_for_today. */
  next: TodayItem;
  /**
   * At most one upgrade offer: the plan directly above the member's, when their plan allows it (they pay nothing or
   * pay themselves, not on a legacy price, and the plan is active or ended; for a lapsed member, the plan above Free).
   * Shown beside the next step, never in its place. Empty otherwise.
   */
  offers: Array<TodayOffer>;
  /** The part of the day it is now, by the member's own times. */
  timeBlock: TimeBlock;
  /** The zone the answer was worked out in; null when the member has none (then UTC). */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Home's week track: seven days of VNS practice. Not a streak. Null when it was not worked out. */
  week?: Maybe<WeekTrack>;
};

/** The after-session scan still owed for the latest ended device session. */
export type TodayAfterScanOwed = {
  __typename: 'TodayAfterScanOwed';
  endTime: Scalars['DateTime']['output'];
  /** Until when the scan is owed. */
  until: Scalars['DateTime']['output'];
  vnsSessionId: Scalars['ID']['output'];
};

export type TodayAlert = {
  __typename: 'TodayAlert';
  kind: TodayAlertKind;
  /** Until when the alert holds. */
  until?: Maybe<Scalars['DateTime']['output']>;
};

export enum TodayAlertKind {
  PlanEnded = 'plan_ended',
  PostSessionScanWindow = 'post_session_scan_window'
}

/** The member's device situation, as Home reads it. */
export type TodayDevice = {
  __typename: 'TodayDevice';
  alpha: AlphaEvidence;
  situation: DeviceSituation;
  /**
   * The member's statement that they are still waiting for their device, only
   * while it counts; null otherwise. It never changes situation by itself (YOJO-3360).
   */
  statedAwaitingDeviceAt?: Maybe<Scalars['DateTime']['output']>;
  /** The member's statement that they have no device, only while it counts; null otherwise. */
  statedNoDeviceAt?: Maybe<Scalars['DateTime']['output']>;
  stone: StoneStatus;
};

/** A VNS session that ended inside the member's day. */
export type TodayDoneSession = {
  __typename: 'TodayDoneSession';
  deviceKind?: Maybe<VnsDeviceKind>;
  endTime: Scalars['DateTime']['output'];
  initiator?: Maybe<VnsSessionInitiator>;
  /** How it was linked; null when not linked. Read tolerantly: more values may come. */
  linkedBy?: Maybe<TodaySessionLink>;
  /** Logged by hand, not recorded by a device. */
  manual: Scalars['Boolean']['output'];
  /** The catalogue mode it ran; null when none was reported. */
  mode?: Maybe<VnsModeReference>;
  /** The planned session it is linked to; null when not linked. */
  plannedActivityId?: Maybe<Scalars['ID']['output']>;
  /** The after-session scan was recorded. */
  postVitalsRecorded: Scalars['Boolean']['output'];
  startTime: Scalars['DateTime']['output'];
  status?: Maybe<VnsSessionStatus>;
  vnsSessionId: Scalars['ID']['output'];
};

/** The device session running now. */
export type TodayInProgressSession = {
  __typename: 'TodayInProgressSession';
  deviceKind?: Maybe<VnsDeviceKind>;
  initiator?: Maybe<VnsSessionInitiator>;
  mode?: Maybe<VnsModeReference>;
  /** The planned item it was started from, as recorded; null when none. */
  plannedActivityId?: Maybe<Scalars['ID']['output']>;
  startTime: Scalars['DateTime']['output'];
  /** Until when it counts as in progress. */
  until: Scalars['DateTime']['output'];
  vnsSessionId: Scalars['ID']['output'];
};

/** One item on Home. */
export type TodayItem = {
  __typename: 'TodayItem';
  /** The planned activity behind a planned item; null for anything else. */
  activity?: Maybe<Activity>;
  /** The planned date (the app sends it back when completing the item). */
  date?: Maybe<Scalars['Date']['output']>;
  /** Stable for the day. */
  id: Scalars['ID']['output'];
  kind: TodayItemKind;
  /** What unlocks a locked item; null when it is not locked. */
  lock?: Maybe<TodayLock>;
  reason: TodayReason;
  /** Who put it there; null when not known. */
  source?: Maybe<TodaySource>;
  state: TodayItemState;
  timeBlock?: Maybe<TimeBlock>;
  timing: TodayTiming;
  /** The session to return to, or whose after-session scan is owed. */
  vnsSessionId?: Maybe<Scalars['ID']['output']>;
};

export enum TodayItemKind {
  ConnectDevice = 'connect_device',
  DoneForToday = 'done_for_today',
  PlannedActivity = 'planned_activity',
  PostSessionScan = 'post_session_scan',
  SelfActivation = 'self_activation',
  VnsSession = 'vns_session'
}

export enum TodayItemState {
  Done = 'done',
  InProgress = 'in_progress',
  Locked = 'locked',
  Open = 'open'
}

export enum TodayLock {
  NeedsDevice = 'needs_device',
  NeedsPlan = 'needs_plan'
}

export type TodayOffer = {
  __typename: 'TodayOffer';
  kind: TodayOfferKind;
  /** The plan offered. Set for upgrade. */
  plan?: Maybe<PlanTier>;
};

export enum TodayOfferKind {
  Upgrade = 'upgrade'
}

/** A VNS session planned for the member's day. */
export type TodayPlannedSession = {
  __typename: 'TodayPlannedSession';
  /** The planned activity behind this planned session. */
  activity?: Maybe<Activity>;
  /** When the planned item was completed; null when it is not. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  date: Scalars['Date']['output'];
  /** The done session that fulfils this planned session; null when none is linked. */
  fulfilledByVnsSessionId?: Maybe<Scalars['ID']['output']>;
  plannedActivityId: Scalars['ID']['output'];
  /** Who planned it; null when not known. */
  plannedBy?: Maybe<PlanningOrigin>;
  /** The mode the plan asks for; null when the plan names none. */
  plannedModeId?: Maybe<Scalars['ID']['output']>;
  timeBlock: TimeBlock;
};

export enum TodayReason {
  CoachPlan = 'coach_plan',
  FirstStep = 'first_step',
  InProgress = 'in_progress',
  NothingOpen = 'nothing_open',
  PlannedLater = 'planned_later',
  StandingStep = 'standing_step',
  YourJourney = 'your_journey'
}

/** How a done session was tied to a planned session. */
export enum TodaySessionLink {
  PlannedItemId = 'planned_item_id',
  TimeWindow = 'time_window'
}

/** One member's VNS sessions for the member's own day (it rolls over at 03:00 on the member's clock). */
export type TodaySessions = {
  __typename: 'TodaySessions';
  /** The after-session scan still owed; null when none. */
  afterScanOwed?: Maybe<TodayAfterScanOwed>;
  /** The instant this answer was worked out at. */
  asOf: Scalars['DateTime']['output'];
  /** The business date: the calendar date the member's current day started on. */
  date: Scalars['Date']['output'];
  /** 03:00 the next day in the member's zone, or the first moment after it on a daylight-saving-gap day; exclusive. */
  dayEnd: Scalars['DateTime']['output'];
  /** 03:00 on date in the member's zone, or the first moment after it on a daylight-saving-gap day; inclusive. */
  dayStart: Scalars['DateTime']['output'];
  /** The sessions that ended inside the day (manual logs included), earliest end first. */
  done: Array<TodayDoneSession>;
  /** The device session running now; null when none. */
  inProgress?: Maybe<TodayInProgressSession>;
  /** The VNS sessions planned for the day, one per planned item and block, in block order. */
  planned: Array<TodayPlannedSession>;
  /** The zone the answer was worked out in; null when the member has none (then UTC). */
  timezone?: Maybe<Scalars['String']['output']>;
};

export enum TodaySource {
  CareTeam = 'care_team',
  Member = 'member',
  Starter = 'starter',
  System = 'system'
}

export enum TodayTiming {
  EarlierToday = 'earlier_today',
  LaterToday = 'later_today',
  Now = 'now'
}

export type TrackContentClickInput = {
  /** Content ID that was clicked */
  contentId: Scalars['String']['input'];
  /** Title of the content clicked */
  contentTitle?: InputMaybe<Scalars['String']['input']>;
  /** Type of content clicked (article, story, lesson, activity) */
  contentType: Scalars['String']['input'];
  /** Page number in paginated results (1-indexed) */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Position of the content on current page (1-indexed) */
  pageRank?: InputMaybe<Scalars['Int']['input']>;
  /** Search ID from the original search results (ArticleConnection.searchId) */
  searchId: Scalars['String']['input'];
  /** Total number of results in the search */
  totalResults?: InputMaybe<Scalars['Int']['input']>;
};

export type TrackContentClickPayload = {
  __typename: 'TrackContentClickPayload';
  /** Whether the click was successfully tracked */
  success: Scalars['Boolean']['output'];
};

export type TransactionDetail = {
  __typename: 'TransactionDetail';
  amountInCents: Scalars['Long']['output'];
  attemptCount?: Maybe<Scalars['Int']['output']>;
  billingPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  billingPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  chargeId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  disputeAmountInCents: Scalars['Long']['output'];
  disputeCount: Scalars['Int']['output'];
  disputes?: Maybe<Array<DisputeDetail>>;
  feeDetails?: Maybe<Array<FeeDetail>>;
  feeInCents?: Maybe<Scalars['Long']['output']>;
  feeSource?: Maybe<Scalars['String']['output']>;
  invoiceDescription?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  netInCents?: Maybe<Scalars['Long']['output']>;
  nextPaymentAttempt?: Maybe<Scalars['DateTime']['output']>;
  payoutId?: Maybe<Scalars['String']['output']>;
  reconciled: Scalars['Boolean']['output'];
  refundCount: Scalars['Int']['output'];
  refunds?: Maybe<Array<RefundDetail>>;
  totalRefundedInCents: Scalars['Long']['output'];
};

export type Trend = {
  __typename: 'Trend';
  isIncrease?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  previousValue: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

/** C2 trend small-multiples — the full per-metric stack under one shared change-point band. */
export type TrendSmallMultiplesPayload = {
  __typename: 'TrendSmallMultiplesPayload';
  band: ChangePointBand;
  panels: Array<MetricPanel>;
};

export type UnassignUserFromJourneyCommand = {
  learningJourneyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Command for unliking content */
export type UnlikeContentCommand = {
  /** Content to unlike */
  contentId: ContentReferenceInput;
};

export type UnlockStatus = {
  __typename: 'UnlockStatus';
  /** Reason for the unlock, if applicable */
  reason?: Maybe<Scalars['String']['output']>;
  /** Whether the step is currently unlocked */
  unlocked: Scalars['Boolean']['output'];
};

/** Available unlock strategies for learning journey steps */
export enum UnlockStrategy {
  Custom = 'custom',
  PreviousPathCompleted = 'previous_path_completed',
  TimeBased = 'time_based',
  VitalsThreshold = 'vitals_threshold'
}

/**
 * Input for updating an existing acquisition source.
 * Null fields indicate no change.
 */
export type UpdateAcquisitionSourceInput = {
  defaultSegment?: InputMaybe<CustomerSegment>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/**
 * Input for updating a user's body measurements.
 * At least one field must be provided.
 */
export type UpdateBodyMeasurementsInput = {
  /** Height measurement */
  height?: InputMaybe<HeightInput>;
  /** Weight measurement */
  weight?: InputMaybe<WeightInput>;
};

/** Input for updateBroadcastOptOut admin mutation. */
export type UpdateBroadcastOptOutInput = {
  /** true = exclude from broadcasts, false = include. */
  optOut: Scalars['Boolean']['input'];
  /** Free-text justification (audit trail). */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Target participant whose Preferences to update. */
  userId: Scalars['ID']['input'];
};

/**
 * Replace a package's contents with the FULL target set (not a delta) — the server derives what was
 * added and removed.
 *
 * A save that REMOVES capabilities requires `shrinkMode`, and `outright` additionally requires
 * `confirmedBy` (the typed confirmation from the shrink dialog). Without them the write is rejected.
 *
 * A save that LOWERS a dial — or introduces one where there was none — is a shrink too, and the only mode
 * available for it is `outright` with `confirmedBy`. `grandfather` is REJECTED for a dial decrease: it
 * mints the lost capabilities onto current holders as individual grants, and a number cannot be minted as
 * a capability, so it would preserve nothing while every holder took the cut.
 */
export type UpdateCapabilityPackageContentsInput = {
  capabilities: Array<Capability>;
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  /**
   * The FULL new dial list — a snapshot, not a delta. Omitting a dial that is currently set REMOVES it
   * (holders go back to inheriting the floor's number), which needs no dialog. Setting a dial to `-1`
   * makes it unlimited, which is a widening and needs no dialog either.
   */
  dials?: InputMaybe<Array<PackageDialInput>>;
  packageKey: Scalars['ID']['input'];
  priceRefs?: InputMaybe<Array<CapabilityPriceRefInput>>;
  shrinkMode?: InputMaybe<ShrinkMode>;
};

/**
 * The cross-package dials, as a full snapshot. floorPackageKey (and trialPackageKey when set) must name
 * a defined, non-archived package.
 */
export type UpdateCapabilitySettingsInput = {
  /** The admin's typed confirmation — required whenever `enforcedGates` adds a key (the B-36 ceremony). */
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  defaultPurchaseProduct?: InputMaybe<Scalars['String']['input']>;
  /**
   * The per-gate allowlist (B-49). Omitted or null = UNCHANGED (a client that never sends it leaves the
   * list alone); an empty list = every gate off, for everyone (Stone Access testers included). ADDING a
   * key is a takeaway for every Free member and is refused unless `confirmedBy` carries the typed
   * confirmation; removing one is a plain change. Every change is one attributed CapabilitySettingsUpdatedEvent.
   */
  enforcedGates?: InputMaybe<Array<GateKey>>;
  /**
   * The enforcement master switch. `false` takes every listed gate down for everyone EXCEPT Stone Access
   * testers (YOJO-3332), for whom the listed gates stay live — without touching the dials. Omitted or
   * null means ON, which is what every settings record written before this lever existed means. The FULL
   * off-switch (nobody gated) is an empty `enforcedGates`. Note that CLEARING the settings is not an
   * off-switch: the floor is `floorPackageKey`, so unsetting them would resolve every member to zero
   * capabilities.
   */
  enforcementActive?: InputMaybe<Scalars['Boolean']['input']>;
  floorPackageKey: Scalars['ID']['input'];
  trialGraceDays: Scalars['Int']['input'];
  trialMonths: Scalars['Int']['input'];
  trialPackageKey?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCarrierInput = {
  carrierId: Scalars['ID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  trackingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
};

/** Input for admin/operations to toggle a participant's content-assignment opt-out flag. */
export type UpdateContentAssignmentOptOutInput = {
  /** True to opt the participant out of bulk content assignment; false to opt back in. */
  optOut: Scalars['Boolean']['input'];
  /** The participant whose flag is being toggled. */
  userId: Scalars['ID']['input'];
};

export type UpdateCustomActivityCommand = {
  /** ID of the custom activity to update */
  customActivityId: Scalars['ID']['input'];
  /** New description for the custom activity */
  description: Scalars['String']['input'];
  /** Updated vitals this activity may impact */
  impactedVitals?: InputMaybe<Array<ImpactedVital>>;
  /** Updated protocols this activity relates to */
  protocols?: InputMaybe<Array<Protocol>>;
  /** Updated subprotocols this activity relates to */
  subprotocols?: InputMaybe<Array<Subprotocol>>;
  /** New title for the custom activity */
  title: Scalars['String']['input'];
};

export type UpdateIdentityInformationInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLearningJourneyCommand = {
  assignDuringOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  learningJourneyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  steps: Array<LearningJourneyStepInput>;
};

export type UpdateLearningPathCommand = {
  contentItems: Array<ContentReferenceInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  learningPathId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateParticipantNoteInput = {
  categories?: InputMaybe<Array<NoteCategory>>;
  content: Scalars['String']['input'];
  flagReason?: InputMaybe<Scalars['String']['input']>;
  flagStatus?: InputMaybe<FlagStatus>;
  noteId: Scalars['ID']['input'];
};

/** Command for updating personal goals */
export type UpdatePersonalGoalsCommand = {
  /** List of desired states/goals */
  goals: Array<DesiredState>;
};

/** Command for updating preferred check-in time block */
export type UpdatePreferredCheckinCommand = {
  /** Preferred time block for check-ins */
  preferredCheckin: TimeBlock;
};

/** Input for updating shipment tracking information. */
export type UpdateShipmentTrackingInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  shipmentId: Scalars['ID']['input'];
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Rename or re-describe a Stone mode (YOJO-3258). `description` left out (or null) keeps the current one; an
 * explicit empty string clears it.
 */
export type UpdateStoneModeDetailsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  modeId: Scalars['ID']['input'];
};

/** Command for updating target vitals */
export type UpdateTargetVitalsCommand = {
  /** List of vital types to monitor */
  targetVitals: Array<VitalType>;
};

export type UpdateTimeBlockPreferencesCommand = {
  timeBlockPreferences: Array<TimeBlockPreferenceInput>;
};

/** Input for updating a user's name information */
export type UpdateUserNameInput = {
  /** First/given name */
  firstName: Scalars['String']['input'];
  /** Last/family name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Middle name(s) if any */
  middleName?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating device nickname */
export type UpdateVnsDeviceNicknameInput = {
  /** ID of the device to update (required for multi-device users, falls back to first device if omitted) */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** New nickname for the device */
  nickname: Scalars['String']['input'];
};

/** Command for updating weekly protocol commitments */
export type UpdateWeeklyCommitmentCommand = {
  /** List of protocol commitments with minutes per week */
  commitments: Array<WeeklyCommitmentInput>;
};

export type User = Nurse | Participant;

/** User chat behavior metrics for care team communication */
export type UserChatMetrics = {
  __typename: 'UserChatMetrics';
  /** Total messages from participants to care team */
  inboundMessages: QuickStat;
  /** Total messages from care team to participants */
  outboundMessages: QuickStat;
  /** Percentage of outbound messages with replies within 3 days */
  responseRate: QuickStat;
};

/** User classification entry with audit information. */
export type UserClassification = {
  __typename: 'UserClassification';
  /** Current classification */
  classification: Classification;
  /** When the classification was last changed */
  classificationChangedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who changed the classification */
  classificationChangedBy?: Maybe<Scalars['String']['output']>;
  /** Reason for the classification */
  classificationReason?: Maybe<Scalars['String']['output']>;
  /** User ID */
  userId: Scalars['ID']['output'];
};

/** User discovery patterns showing how users consume content */
export type UserDiscoveryPatterns = {
  __typename: 'UserDiscoveryPatterns';
  /** Number of users who only complete assigned content (coach or AI) */
  assignedOnly: Scalars['Int']['output'];
  /** Percentage of users who only complete assigned content */
  assignedOnlyPercentage: Scalars['Float']['output'];
  /** Detailed breakdown of all user patterns */
  breakdown: Array<UserPatternStats>;
  /** Number of users who explore content organically */
  exploresOrganically: Scalars['Int']['output'];
  /** Percentage of users who explore content organically */
  exploresOrganicallyPercentage: Scalars['Float']['output'];
  /** Total number of users in the analysis */
  totalUsers: Scalars['Int']['output'];
};

/** Per-user engagement data for dashboard display. */
export type UserEngagementData = {
  __typename: 'UserEngagementData';
  /** Chat response rate (null if no chat data, positive if participant has responded) */
  chatResponseRate?: Maybe<Scalars['Float']['output']>;
  /** Rolling 90-day chat responsiveness details */
  chatResponsiveness?: Maybe<ChatResponsiveness>;
  /** User's workflow status classification */
  classification?: Maybe<UserClassification>;
  /** Date of participant's first consult (ISO date string, null if no consult) */
  firstConsultDate?: Maybe<Scalars['String']['output']>;
  /** Last date of any app activity */
  lastAppActivity?: Maybe<Scalars['String']['output']>;
  /** Last date of VNS session */
  lastVnsSession?: Maybe<Scalars['String']['output']>;
  /** Personal information (requires PII access) */
  pii?: Maybe<Pii>;
  /** Segments this user belongs to */
  segmentIds: Array<Scalars['String']['output']>;
  /** User ID */
  userId: Scalars['ID']['output'];
  /** Total VNS session count */
  vnsSessionCount: Scalars['Int']['output'];
};

export type UserEngagementMetrics = {
  __typename: 'UserEngagementMetrics';
  activitiesCompleted: QuickStat;
  activitiesStarted: QuickStat;
  dojoContentProgress: QuickStat;
  journalsRecorded: QuickStat;
  logins: QuickStat;
};

export enum UserIntent {
  EnergizeMe = 'energize_me',
  GetMeThroughThisFeeling = 'get_me_through_this_feeling',
  GuideMeThroughThisCraving = 'guide_me_through_this_craving',
  SendMeToSleep = 'send_me_to_sleep',
  SharpenMeUp = 'sharpen_me_up',
  StopMeFromSpiralling = 'stop_me_from_spiralling'
}

/** Statistics for a specific user behavior pattern */
export type UserPatternStats = {
  __typename: 'UserPatternStats';
  /** Pattern name (e.g., assigned_only, explores_organically) */
  pattern: Scalars['String']['output'];
  /** Percentage of total users exhibiting this pattern */
  percentage: Scalars['Float']['output'];
  /** Number of users exhibiting this pattern */
  userCount: Scalars['Int']['output'];
};

/**
 * Comprehensive user profile aggregating data from multiple domains.
 * Used for the mobile profile screen.
 */
export type UserProfile = {
  __typename: 'UserProfile';
  /** Account identifier */
  accountId: Scalars['ID']['output'];
  /** The counted budgets the member's plan gives them. Every plan, Free included. Readable by the member only. */
  allowances: Allowances;
  /**
   * The member's own 'I'm still waiting for my device' statement while it counts;
   * null once a later link, dispatch, delivery, pre-registration or device session
   * overtakes it, or a later 'I don't have a device' statement replaces it (YOJO-3360)
   */
  awaitingDeviceStatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Age calculated from date of birth */
  calculatedAge?: Maybe<Scalars['Int']['output']>;
  /** Height measurement resolved from latest body metrics */
  height?: Maybe<Height>;
  /**
   * The member's own plan as one coherent line (Stone ADR 0002). Display only: never gate on it (tiering ADR 0004,
   * mobile ADR 0012 decision 4). Null = cannot be known right now: keep the last known. Readable by the member only;
   * anyone else gets an authorization error.
   */
  memberPlan?: Maybe<MemberPlan>;
  /** Membership and subscription information */
  membership?: Maybe<Membership>;
  /**
   * The member's own 'I don't have a device' statement while it counts; null once
   * a later link, dispatch, delivery or device session overtakes it (YOJO-3271),
   * or a later 'I'm still waiting for my device' statement replaces it (YOJO-3360)
   */
  noDeviceStatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User's personal information (name, email, DOB, gender, height, weight) */
  pii?: Maybe<Pii>;
  /** User preferences (notifications, units, etc.) */
  preferences?: Maybe<Preferences>;
  /**
   * The modes of the member's last Stone sessions started from the app, newest first, at most 10. The first entry is
   * the previous mode: the one the app pre-selects for the next session. Not listed: device-started sessions (the
   * device's own button), sessions whose starter was not recorded (older app builds), sessions sent with an unknown
   * starter, deleted sessions, manually logged sessions, and sessions that named
   * no catalogue mode — those are skipped, so the next older one comes first. An
   * empty list means
   * no app-started session that named a mode yet: use the default mode. Not limited by the plan's history window.
   * Readable by the member only; anyone else gets an authorization error.
   */
  recentStoneModes: RecentStoneModes;
  /** Account status (active, suspended, etc.) */
  status: UserStatus;
  /**
   * The member's own Stone modes on a device (YOJO-3261): each in its slot, open or locked and why, the pre-selected
   * mode and the default. Null = cannot be known right now: keep the last known. Readable by the member only; anyone
   * else gets an authorization error.
   */
  stoneModes?: Maybe<MemberStoneModes>;
  /**
   * What the app writes to the member's Stone: when the record expires and how many sessions the Stone may start
   * without the phone. Tied to the member's plan (the same facts as memberPlan). Null = cannot be known right now:
   * keep the record already on the Stone. Readable by the member only; anyone else gets an authorization error.
   */
  stoneRecord?: Maybe<StoneRecord>;
  /** Timezone */
  timezone?: Maybe<Scalars['String']['output']>;
  /** The member's currently linked VNS devices — all of them (YOJO-2582); retired ones are not listed here */
  vnsDevices: Array<VnsDevice>;
  /** Weight measurement resolved from latest body metrics */
  weight?: Maybe<Weight>;
};


/**
 * Comprehensive user profile aggregating data from multiple domains.
 * Used for the mobile profile screen.
 */
export type UserProfileStoneModesArgs = {
  generation?: InputMaybe<StoneDeviceGeneration>;
};

export type UserRmssdProfile = {
  __typename: 'UserRmssdProfile';
  ageBracket?: Maybe<AgeBracket>;
  baselineRmssd?: Maybe<Scalars['Float']['output']>;
  currentRmssd?: Maybe<Scalars['Float']['output']>;
  participantId: Scalars['ID']['output'];
  stratum: RmssdStratum;
  threshold: Scalars['Float']['output'];
};

/** Individual sleep record for a user */
export type UserSleepMetric = {
  __typename: 'UserSleepMetric';
  awakeMinutes?: Maybe<Scalars['Float']['output']>;
  breathingRate?: Maybe<Scalars['Float']['output']>;
  deepSleepMinutes?: Maybe<Scalars['Float']['output']>;
  hrvRmssd?: Maybe<Scalars['Float']['output']>;
  /**
   * Apple Watch overnight SDNN median (ms), provider-tagged. Distinct from
   * hrvRmssd — SDNN != RMSSD, never compared cross-device in absolute terms. Null
   * for Whoop/Oura.
   */
  hrvSdnn?: Maybe<Scalars['Float']['output']>;
  /** Mean SDNN over the sleep window (ms), companion to the median hrvSdnn. */
  hrvSdnnMean?: Maybe<Scalars['Float']['output']>;
  lightSleepMinutes?: Maybe<Scalars['Float']['output']>;
  provider: Scalars['String']['output'];
  remSleepMinutes?: Maybe<Scalars['Float']['output']>;
  restingHeartRate?: Maybe<Scalars['Float']['output']>;
  /** Number of SDNN sample readings aggregated for the night. */
  sdnnSampleCount?: Maybe<Scalars['Int']['output']>;
  sleepDate: Scalars['String']['output'];
  sleepEfficiencyPercent?: Maybe<Scalars['Float']['output']>;
  sleepEnd?: Maybe<Scalars['String']['output']>;
  sleepInterruptions?: Maybe<Scalars['Int']['output']>;
  sleepStart?: Maybe<Scalars['String']['output']>;
  totalSleepMinutes: Scalars['Float']['output'];
  userId: Scalars['ID']['output'];
};

export enum UserStatus {
  Active = 'active',
  Suspended = 'suspended'
}

/** User vital metrics and statistics */
export type UserVitalMetrics = {
  __typename: 'UserVitalMetrics';
  /** Total vital measurements recorded */
  vitalsRecorded: QuickStat;
  /** VNS therapy session completion rate */
  vnsTherapyCompletionRate: QuickStat;
  /** Average daily VNS therapy duration */
  vnsTherapyTime: QuickStat;
};

/** The emotional/clinical direction of a component (sibling to relevance; never summed). */
export enum Valence {
  Cautionary = 'CAUTIONARY',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type Video = Media & {
  __typename: 'Video';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoBlock = {
  __typename: 'VideoBlock';
  altText: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};

export type VideoCaption = Media & {
  __typename: 'VideoCaption';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoTeaser = BaseTeaser & CmsDocument & Content & DojoElement & {
  __typename: 'VideoTeaser';
  contentReference: CustomActivityId | ExternalContentId | MobileWidgetId;
  ctaButtonLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkedContent?: Maybe<CustomActivityId | ExternalContentId | MobileWidgetId>;
  media?: Maybe<File | Image | Video | VideoCaption>;
  /** @deprecated Renamed to `title` */
  name?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** A single vital measurement taken during a biofeedback session */
export type VitalMeasurement = {
  __typename: 'VitalMeasurement';
  /** When the measurement was taken */
  recordedAt: Scalars['DateTime']['output'];
  /** Duration in seconds of the Shen.AI scan behind this measurement. Null (older events/clients) is interpreted as 30s. */
  scanDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Source of the measurement */
  source: MetricSource;
  /** Type of vital being measured */
  type: VitalType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** The measured value */
  value: Scalars['Float']['output'];
};

/** Input for recording a vital measurement */
export type VitalMeasurementInput = {
  /** When the measurement was taken */
  recordedAt: Scalars['DateTime']['input'];
  /** Duration in seconds of the Shen.AI scan. Nullable — older clients omit it; null is interpreted as 30s at read time. */
  scanDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Shen.AI per-scan signal quality (0..1). Nullable — older clients omit it. */
  signalQuality?: InputMaybe<Scalars['Float']['input']>;
  /** Source of the measurement */
  source: MetricSource;
  /** Type of vital being measured */
  type: VitalType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** The measured value */
  value: Scalars['Float']['input'];
};

/** Represents a physiological vital metric measurement */
export type VitalMetric = BaseMetric & {
  __typename: 'VitalMetric';
  /** Unique identifier for the metric */
  id: Scalars['ID']['output'];
  /** When the measurement was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** Duration in seconds of the Shen.AI scan behind this metric. Null (older metrics/clients) is interpreted as 30s. */
  scanDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Source of the measurement */
  source: MetricSource;
  /** Type of vital measurement */
  type: VitalType;
  /** Unit of measurement */
  unit: MeasurementUnit;
  /** User who recorded the metric */
  userId: Scalars['String']['output'];
  /** Numeric value of the measurement */
  value: Scalars['Float']['output'];
};

/** Types of physiological measurements that can be recorded */
export enum VitalType {
  BloodPressureDiastolic = 'blood_pressure_diastolic',
  BloodPressureSystolic = 'blood_pressure_systolic',
  BreathingRate = 'breathing_rate',
  CardiacWorkload = 'cardiac_workload',
  HeartRate = 'heart_rate',
  HeartRateVariabilityLnrmssd = 'heart_rate_variability_lnrmssd',
  HeartRateVariabilitySdnn = 'heart_rate_variability_sdnn',
  LungCapacity = 'lung_capacity',
  ParasympatheticActivity = 'parasympathetic_activity',
  StressIndex = 'stress_index'
}

/** Collection of personal vital and feeling metrics for a user */
export type Vitals = {
  __typename: 'Vitals';
  /** List of body measurements */
  bodyMetrics: Array<BodyMetric>;
  /** List of cognitive metric measurements */
  cognitiveMetrics: Array<CognitiveMetric>;
  /** List of emotional state records */
  emotionalStates: Array<EmotionalState>;
  /** List of feeling measurements */
  feelings: Array<FeelingMetric>;
  /** @deprecated Generation intentionally disabled (YOJO-2590) — always answers []. Vitals-derived insights come from the metricInsight engine surface instead. */
  insights: Array<MetricInsight>;
  /** User who owns these metrics */
  userId: Scalars['ID']['output'];
  /** List of vital measurements */
  vitals: Array<VitalMetric>;
  /** Unique identifier for the vitals collection */
  vitalsId: Scalars['ID']['output'];
};

/** A registered VNS device for a user */
export type VnsDevice = {
  __typename: 'VnsDevice';
  deviceId: Scalars['ID']['output'];
  /**
   * The Stone mode and parameter-set version the app last reported writing to this device (YOJO-3261), by the time
   * the app wrote it. Null until one is recorded.
   */
  lastModeWrite?: Maybe<StoneModeWrite>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether this device is currently the member's (YOJO-2558, narrowed by YOJO-2582). The one-device rule
   * is about HARDWARE, not accounts: an exclusive-link device (the Stone class) is never co-linked with
   * anything, so a member holding one holds only that. Non-exclusive devices (Alpha) may be co-linked, and
   * such a member legitimately has several `linked` devices. A device becomes `unlinked` only when a real
   * unlink happens — a replacement pairing, an ops correction, or the member removing it.
   */
  linkStatus: VnsDeviceLinkStatus;
  /** When this device (last) became the member's. Defaults to registeredAt for devices paired before YOJO-2558. */
  linkedAt: Scalars['DateTime']['output'];
  /** Device model (read-only, from device) */
  model: Scalars['String']['output'];
  /** User-editable nickname for the device */
  nickname?: Maybe<Scalars['String']['output']>;
  registeredAt: Scalars['DateTime']['output'];
  /**
   * The device that took over, when this one was unlinked by a pairing: the
   * member's own replacement, or another account's device for
   * `paired_by_another_account`.
   */
  replacedByDeviceId?: Maybe<Scalars['ID']['output']>;
  /** Device serial number (read-only, from device) */
  serialNumber: Scalars['String']['output'];
  /** Why it was unlinked. Null unless linkStatus is `unlinked`. */
  unlinkReason?: Maybe<VnsDeviceUnlinkReason>;
  /** When this device stopped being the member's. Null unless linkStatus is `unlinked`. */
  unlinkedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

/** The kind of device that drove a VNS session (YOJO-3300) */
export enum VnsDeviceKind {
  Alpha = 'alpha',
  Stone = 'stone'
}

/**
 * Which of a member's devices are theirs right now (YOJO-2558, narrowed by YOJO-2582). Only `linked` and
 * `unlinked` are ever returned — both are RECORDED states of the device itself. An exclusive-link device
 * (Stone class) is never co-linked with anything; non-exclusive devices (Alpha) may be co-linked, so a
 * member can have several `linked` devices at once. `unlinked` is not terminal: re-pairing links it again.
 *
 * `superseded` is RETAINED FOR WIRE COMPATIBILITY ONLY and is no longer produced. It used to be stamped on
 * at read time, on a still-linked device that had lost to a later pairing, back when the invariant was
 * "one linked device per account". That invariant was withdrawn — co-linking is legal for non-exclusive
 * hardware — so no device is labelled by the read side any more. Clients must keep tolerating the value
 * (it may appear in old cached payloads) and treat it as "not currently linked".
 */
export enum VnsDeviceLinkStatus {
  Linked = 'linked',
  Superseded = 'superseded',
  Unlinked = 'unlinked'
}

/**
 * YOJO-2558 — why a device stopped being the member's. A warranty swap is `replaced_by_new_pairing` with
 * `replacedByDeviceId` set; a return with nothing paired in its place is an `ops_correction`. A Stone paired by a
 * different account is `paired_by_another_account` (YOJO-3550), with `replacedByDeviceId` set to that account's device.
 */
export enum VnsDeviceUnlinkReason {
  MemberRemoved = 'member_removed',
  OpsCorrection = 'ops_correction',
  PairedByAnotherAccount = 'paired_by_another_account',
  ReplacedByNewPairing = 'replaced_by_new_pairing'
}

/** Mode of VNS operation */
export enum VnsMode {
  Energy = 'energy',
  Relax = 'relax',
  Sleep = 'sleep',
  Stress = 'stress'
}

/** The catalogue mode a phase ran (YOJO-3300). Null on sessions that did not report one. */
export type VnsModeReference = {
  __typename: 'VnsModeReference';
  /** The mode's display name when the session was recorded */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The mode catalogue id of the mode */
  modeId: Scalars['ID']['output'];
  /** The mode's parameter set version the app reported */
  setVersion?: Maybe<Scalars['Int']['output']>;
};

/** A phase within a VNS session, representing continuous stimulation with specific settings */
export type VnsPhase = {
  __typename: 'VnsPhase';
  /** Duration of this phase */
  duration: Scalars['Duration']['output'];
  /** When this phase ended */
  endTime: Scalars['DateTime']['output'];
  /** Stimulation settings used */
  settings: VnsSettings;
  /** The device's slot byte (0-255) for this phase, a cross-check. Null when not reported (YOJO-3300). */
  slotByte?: Maybe<Scalars['Int']['output']>;
  /** Source of the phase data */
  source: VnsSource;
  /** When this phase started */
  startTime: Scalars['DateTime']['output'];
};

/** Input for a VNS session phase */
export type VnsPhaseInput = {
  /** Duration of this phase */
  duration: Scalars['Duration']['input'];
  /** When this phase ended */
  endTime: Scalars['DateTime']['input'];
  /** Stimulation settings used */
  settings: VnsSettingsInput;
  /** The device's slot byte (0-255) for this phase (optional) */
  slotByte?: InputMaybe<Scalars['Int']['input']>;
  /** Source of the phase data */
  source: VnsSource;
  /** When this phase started */
  startTime: Scalars['DateTime']['input'];
};

/** Records a VNS therapy session including all phases and settings */
export type VnsSession = {
  __typename: 'VnsSession';
  /**
   * Whether the session counts for the member whose profile it is on. False only
   * for a stored Stone session kept aside because the Stone was not theirs when it
   * started; a session recorded before this rule reads true (ADR 0016, YOJO-3557).
   */
  attributed: Scalars['Boolean']['output'];
  /** The device record's complete flag; status keeps its meaning. Null when not recorded. */
  complete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the device record reports a contact loss. Null when not recorded. */
  contactLost?: Maybe<Scalars['Boolean']['output']>;
  /** Optional device information */
  deviceInfo?: Maybe<Scalars['String']['output']>;
  /** The kind of device that drove the session, as the app reported it. Null when not recorded. */
  deviceKind?: Maybe<VnsDeviceKind>;
  /** The serial of the Stone the session ran on, exactly as the app sent it. Null when the app sent none (ADR 0016, YOJO-3557). */
  deviceSerial?: Maybe<Scalars['String']['output']>;
  /** When the session ended (null if session is in progress) */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** The settings the session started with; set while it runs and kept after it ends. Null when not recorded. */
  initialSettings?: Maybe<VnsSettings>;
  /** Who started the session. Null when not recorded. */
  initiator?: Maybe<VnsSessionInitiator>;
  /** AI-generated insight based on this VNS session and its outcomes */
  insight?: Maybe<VnsSessionInsight>;
  /** Whether this session was manually logged by the user (vs device-recorded) */
  isManual: Scalars['Boolean']['output'];
  /** Where the session was recorded, as its Start said. Live when the app did not say. */
  origin: VnsSessionOrigin;
  /** Individual phases within the session */
  phases: Array<VnsPhase>;
  /** The planned item the session was started from. Null when not linked by id. */
  plannedActivityId?: Maybe<Scalars['ID']['output']>;
  /** Vital measurements taken after the VNS session */
  postVitals?: Maybe<Array<VitalMeasurement>>;
  /** Vital measurements taken before the VNS session */
  preVitals?: Maybe<Array<VitalMeasurement>>;
  /** When the session was recorded/logged (for manual sessions, differs from startTime) */
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current state of the session */
  sessionState?: Maybe<VnsSessionState>;
  /** When the session started */
  startTime: Scalars['DateTime']['output'];
  /** Status of the session completion (null if session is in progress) */
  status?: Maybe<VnsSessionStatus>;
  /** Time block when this session occurred */
  timeBlock: TimeBlock;
  /** Total duration of the session (null if session is in progress) */
  totalDuration?: Maybe<Scalars['Duration']['output']>;
  /** Why a kept-aside session counts for nobody. Null for a session that counts (ADR 0016, YOJO-3557). */
  unattributedReason?: Maybe<VnsSessionUnattributedReason>;
  /** User who recorded the session */
  userId: Scalars['String']['output'];
  /** Unique identifier for this session */
  vnsSessionId: Scalars['ID']['output'];
};

export type VnsSessionAnalytics = {
  __typename: 'VnsSessionAnalytics';
  /** Average session duration in minutes (across all matching sessions) */
  avgDurationMinutes?: Maybe<Scalars['Float']['output']>;
  /** Average HRV delta across sessions that have pre+post vitals */
  avgHrvDelta?: Maybe<Scalars['Float']['output']>;
  /**
   * Average sessions per active day per user. For users who did VNS on a given
   * day, how many sessions did they average that day?
   */
  avgSessionsPerActiveDay?: Maybe<Scalars['Float']['output']>;
  /** Completion rate: % of matching sessions with status=completed */
  completionRate?: Maybe<Scalars['Float']['output']>;
  /** Breakdown of avg HRV delta by intensity band */
  intensityBands: Array<IntensityBandEntry>;
  /**
   * Breakdown by mode (first phase): sessions with a mode id by (modeId,
   * deviceKind), split by set version when bySetVersion is true; older sessions by
   * their legacy mode alone, unmapped (modeId null). Sessions with neither are in
   * no group. The input's `modes` filter (legacy modes) runs before grouping, so
   * passing it excludes sessions recorded with only a mode id.
   */
  modeEffectivenessByMode: Array<ModeEffectivenessByModeEntry>;
  /** Number of sessions with pre+post vitals (used for delta calculations) */
  sessionsWithVitals: Scalars['Int']['output'];
  /** Total number of sessions matching filters */
  totalSessions: Scalars['Int']['output'];
};


export type VnsSessionAnalyticsModeEffectivenessByModeArgs = {
  bySetVersion?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VnsSessionAnalyticsInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Legacy modes, matched on the first phase before any grouping: sessions recorded with only a mode id match none. */
  modes?: InputMaybe<Array<VnsMode>>;
  source?: InputMaybe<VnsSource>;
  statuses?: InputMaybe<Array<VnsSessionStatus>>;
};

export type VnsSessionExportEntry = {
  __typename: 'VnsSessionExportEntry';
  avgIntensity?: Maybe<Scalars['Float']['output']>;
  deviceInfo?: Maybe<Scalars['String']['output']>;
  /** The device kind the app reported. Null = not recorded. */
  deviceKind?: Maybe<VnsDeviceKind>;
  durationMinutes?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  hrvDelta?: Maybe<Scalars['Float']['output']>;
  intensity?: Maybe<Scalars['Int']['output']>;
  isManual: Scalars['Boolean']['output'];
  mode?: Maybe<VnsMode>;
  /** First phase's mode name as stamped when the session was written, never today's catalogue name. Null = not recorded. */
  modeDisplayName?: Maybe<Scalars['String']['output']>;
  /** First phase's mode catalogue id. Null = not recorded (YOJO-3263). */
  modeId?: Maybe<Scalars['ID']['output']>;
  /** First phase's mode parameter set version. Null = not recorded. */
  modeSetVersion?: Maybe<Scalars['Int']['output']>;
  parasympatheticDelta?: Maybe<Scalars['Float']['output']>;
  phases: Array<VnsSessionExportPhase>;
  postHrvSdnn?: Maybe<Scalars['Float']['output']>;
  postParasympathetic?: Maybe<Scalars['Float']['output']>;
  postStressIndex?: Maybe<Scalars['Float']['output']>;
  preHrvSdnn?: Maybe<Scalars['Float']['output']>;
  preParasympathetic?: Maybe<Scalars['Float']['output']>;
  preStressIndex?: Maybe<Scalars['Float']['output']>;
  sessionId: Scalars['ID']['output'];
  /** First phase's device slot byte. Null = not recorded. */
  slotByte?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['DateTime']['output'];
  /** Who started the session. Null = not recorded. */
  startedBy?: Maybe<VnsSessionInitiator>;
  status?: Maybe<VnsSessionStatus>;
  stressDelta?: Maybe<Scalars['Float']['output']>;
  timeBlock?: Maybe<TimeBlock>;
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type VnsSessionExportInput = {
  /** Whether to anonymize user IDs. Default: true. Set to false to reveal real IDs (requires gdprJustification). */
  anonymize?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** GDPR justification for accessing real user IDs. Required when anonymize=false. */
  gdprJustification?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modes?: InputMaybe<Array<VnsMode>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<VnsSessionExportSortField>;
  sortDirection?: InputMaybe<SortDirection>;
  source?: InputMaybe<VnsSource>;
  statuses?: InputMaybe<Array<VnsSessionStatus>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type VnsSessionExportPhase = {
  __typename: 'VnsSessionExportPhase';
  durationMinutes: Scalars['Float']['output'];
  endTime: Scalars['DateTime']['output'];
  intensity?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<VnsMode>;
  source: VnsSource;
  startTime: Scalars['DateTime']['output'];
};

export type VnsSessionExportResult = {
  __typename: 'VnsSessionExportResult';
  hasMore: Scalars['Boolean']['output'];
  sessions: Array<VnsSessionExportEntry>;
  totalCount: Scalars['Int']['output'];
};

export enum VnsSessionExportSortField {
  Duration = 'duration',
  Intensity = 'intensity',
  StartTime = 'startTime',
  Status = 'status'
}

/** Who started a VNS session (YOJO-3300) */
export enum VnsSessionInitiator {
  App = 'app',
  Device = 'device',
  Unknown = 'unknown'
}

/** AI-generated insight from a VNS session */
export type VnsSessionInsight = {
  __typename: 'VnsSessionInsight';
  /** When this insight was created */
  createdAt: Scalars['DateTime']['output'];
  /** Direct impact analysis of this VNS session */
  directImpactAnalysis?: Maybe<DirectImpactAnalysis>;
  /** Unique identifier for this insight */
  id: Scalars['ID']['output'];
  /** Long-term trend analysis over multiple sessions */
  longTermTrendAnalysis?: Maybe<LongTermTrendAnalysis>;
  /** Personalized message with specific recommendation */
  message: Scalars['String']['output'];
  /** Priority level of the insight */
  priority: InsightPriority;
  /** Specific action to take */
  recommendation: Scalars['String']['output'];
  /** Recommended content IDs that might help the user */
  recommendedContent?: Maybe<Array<CustomActivityId | ExternalContentId | MobileWidgetId>>;
  /** Short, engaging title */
  title: Scalars['String']['output'];
};

/** Where a VNS session was recorded: live in the app, or uploaded later from the device's own session store (YOJO-3104). */
export enum VnsSessionOrigin {
  DeviceRecord = 'device_record',
  Live = 'live'
}

/** State machine for a VNS session's lifecycle */
export enum VnsSessionState {
  Ended = 'ended',
  PostVitalsRecorded = 'post_vitals_recorded',
  Started = 'started'
}

/** Status of a VNS session */
export enum VnsSessionStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  DeviceError = 'device_error',
  Interrupted = 'interrupted'
}

/** Why a stored Stone session counts for nobody and is kept aside (ADR 0016, YOJO-3557). */
export enum VnsSessionUnattributedReason {
  /** Nobody held this Stone when the session started, and it was never linked to this member. */
  NeverLinked = 'never_linked',
  /** Nobody held this Stone when the session started; this member held it at another time. */
  OutsideUploaderLinks = 'outside_uploader_links',
  /** Another member held this Stone when the session started. */
  PreviousHolder = 'previous_holder'
}

/** Settings used for VNS stimulation */
export type VnsSettings = {
  __typename: 'VnsSettings';
  /** Stimulation intensity in mA */
  intensity: Scalars['Int']['output'];
  /**
   * Legacy operating mode for the stimulation. When the session stored none (it
   * named only its catalogue mode) this serves the placeholder relax. Read
   * modeReference instead.
   * @deprecated Removed upon YOJO-3381
   */
  mode: VnsMode;
  /** The catalogue mode this ran (YOJO-3300). Null on sessions that did not report one. */
  modeReference?: Maybe<VnsModeReference>;
};

/** Input for VNS stimulation settings */
export type VnsSettingsInput = {
  /** Stimulation intensity from 0 to 30 */
  intensity: Scalars['Int']['input'];
  /**
   * Legacy operating mode for the stimulation. Send it, modeReference, or both; never neither.
   * @deprecated Removed upon YOJO-3381
   */
  mode?: InputMaybe<VnsMode>;
  /** The catalogue mode that ran (YOJO-3300). Send it, mode, or both; never neither. */
  modeReference?: InputMaybe<ModeReferenceInput>;
};

/** VNS session correlated with same-night and next-day sleep metrics */
export type VnsSleepCorrelation = {
  __typename: 'VnsSleepCorrelation';
  /** Sleep efficiency improvement vs baseline (percentage points) */
  efficiencyVsBaseline?: Maybe<Scalars['Float']['output']>;
  /** HRV delta from pre to post VNS (post - pre) */
  hrvDelta?: Maybe<Scalars['Float']['output']>;
  /** HRV improvement vs baseline (ms) */
  hrvVsBaseline?: Maybe<Scalars['Float']['output']>;
  /** Next-day deep sleep percentage (0-100) */
  nextDayDeepPercent?: Maybe<Scalars['Float']['output']>;
  /** Next-day sleep efficiency percentage (0-100) */
  nextDayEfficiency?: Maybe<Scalars['Float']['output']>;
  /** Next-day average HRV during sleep */
  nextDayHrv?: Maybe<Scalars['Float']['output']>;
  /** Next-day sleep duration in minutes */
  nextDaySleepMinutes?: Maybe<Scalars['Float']['output']>;
  /** Parasympathetic activity delta (post - pre) */
  parasympatheticDelta?: Maybe<Scalars['Float']['output']>;
  /** Same-night deep sleep percentage (0-100) */
  sameNightDeepPercent?: Maybe<Scalars['Float']['output']>;
  /** Same-night sleep efficiency percentage (0-100) */
  sameNightEfficiency?: Maybe<Scalars['Float']['output']>;
  /** Same-night average HRV during sleep */
  sameNightHrv?: Maybe<Scalars['Float']['output']>;
  /** Same-night sleep duration in minutes */
  sameNightSleepMinutes?: Maybe<Scalars['Float']['output']>;
  /** Date of the VNS session (YYYY-MM-DD) */
  sessionDate: Scalars['String']['output'];
  /** Unique session identifier */
  sessionId: Scalars['ID']['output'];
  /** Sleep duration improvement vs baseline (minutes) */
  sleepVsBaseline?: Maybe<Scalars['Float']['output']>;
  /** Stress index delta (post - pre) */
  stressDelta?: Maybe<Scalars['Float']['output']>;
  /** Time of day the session occurred */
  timeBlock?: Maybe<TimeBlock>;
  /** User who performed the VNS session */
  userId: Scalars['ID']['output'];
  /** VNS mode used during session */
  vnsMode?: Maybe<Scalars['String']['output']>;
};

/** Complete VNS-sleep dashboard with analytics */
export type VnsSleepDashboard = {
  __typename: 'VnsSleepDashboard';
  /** Recent correlation data points */
  recentCorrelations: Array<VnsSleepCorrelation>;
  /** High-level summary statistics */
  summary: VnsSleepSummary;
  /** Analysis broken down by time of day */
  timeBlockAnalysis: Array<TimeBlockStats>;
};

/** Summary statistics for VNS-sleep correlations */
export type VnsSleepSummary = {
  __typename: 'VnsSleepSummary';
  /** Average efficiency improvement (percentage points) */
  avgEfficiencyImprovement?: Maybe<Scalars['Float']['output']>;
  /** Average HRV improvement during sleep (ms) */
  avgHrvImprovement?: Maybe<Scalars['Float']['output']>;
  /** Average sleep improvement across all sessions (minutes) */
  avgSleepImprovement?: Maybe<Scalars['Float']['output']>;
  /** Time block with best average sleep outcomes */
  bestTimeBlock?: Maybe<Scalars['String']['output']>;
  /** Number of sessions with matching sleep data */
  sessionsWithSleepData: Scalars['Int']['output'];
  /** Total number of VNS sessions analyzed */
  totalSessions: Scalars['Int']['output'];
};

/** Source of VNS session data */
export enum VnsSource {
  Device = 'device',
  Manual = 'manual'
}

/** Test-filtered waitlist demand for a single delivery country (a country we don't yet ship to). */
export type WaitlistCountryDemand = {
  __typename: 'WaitlistCountryDemand';
  /** Number of real (non-test) waitlist sign-ups for the country. */
  count: Scalars['Int']['output'];
  /** ISO country code, e.g. "US". */
  country: Scalars['String']['output'];
};

/**
 * Outcome of an eraseWaitlistSignal mutation (YOJO-2053). The erase is GDPR right-to-erasure and is
 * audited; erasedCount is the number of sign-up rows removed from prospect-api for the email.
 */
export type WaitlistEraseResult = {
  __typename: 'WaitlistEraseResult';
  email: Scalars['String']['output'];
  erasedCount: Scalars['Int']['output'];
};

/**
 * Input for the audited waitlist CSV export. The justification is a REQUIRED GDPR access gate — a
 * missing/blank justification blocks the export (denied/empty).
 */
export type WaitlistExportInput = {
  /** ISO country code whose waitlist sign-ups to export, e.g. "US". */
  country: Scalars['String']['input'];
  /** Required GDPR justification recorded in the export audit row. Must be non-blank. */
  justification: Scalars['String']['input'];
};

/**
 * Outcome of an exportWaitlistSignals mutation (YOJO-2053). When the GDPR justification gate passes the
 * CSV holds exactly the data-minimised columns (email, delivery country, signup date, consent, source)
 * for the country's real (non-test) sign-ups, and an audit row is written. When the gate fails the
 * export is blocked: granted=false and csv is null.
 */
export type WaitlistExportResult = {
  __typename: 'WaitlistExportResult';
  /** ISO country code that was exported. */
  country: Scalars['String']['output'];
  /** The data-minimised CSV (email, delivery country, signup date, consent, source); null when blocked. */
  csv?: Maybe<Scalars['String']['output']>;
  /** Whether the export was granted (justification present + non-blank). */
  granted: Scalars['Boolean']['output'];
  /** Number of (real, non-test) sign-up rows in the CSV; 0 when blocked. */
  recordCount: Scalars['Int']['output'];
};

/**
 * A single waitlist sign-up (PII) — a person who asked to be notified when we ship to their country.
 * Only ever returned by the operations/admin-gated waitlistSignals query.
 */
export type WaitlistSignal = {
  __typename: 'WaitlistSignal';
  consent: Scalars['Boolean']['output'];
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  signalType?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** C5 watch-card — one metric trending adverse, surfaced gently (cautionary; never a diagnosis). */
export type WatchCardPayload = {
  __typename: 'WatchCardPayload';
  baselineValue: Scalars['Float']['output'];
  caption: Scalars['String']['output'];
  direction: MetricDirection;
  metric: Scalars['String']['output'];
  recentValue: Scalars['Float']['output'];
  series: Array<MonthlyPoint>;
  thresholdLabel: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

/**
 * One wearable-liveness heartbeat from the mobile app (YOJO-2964). userId is deliberately absent — it is
 * taken from the authenticated identity in the resolver, never trusted from the client.
 */
export type WearableHeartbeatInput = {
  /** Mobile app version that emitted the heartbeat. */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** OS background-app-refresh permission state, when the client knows it. */
  backgroundAppRefresh?: InputMaybe<BackgroundAppRefreshStatus>;
  /**
   * Whether the app's request to Apple Health for background delivery was accepted
   * on this device (best-effort — not proof iOS delivers; null when unknown).
   */
  healthBackgroundDeliveryConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Health-data read permission is currently granted, when known. */
  healthPermissionGranted?: InputMaybe<Scalars['Boolean']['input']>;
  /** When the app last successfully read Health data, when known. */
  lastHealthReadAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Whether the device is in low-power mode, when the client knows it. */
  lowPowerMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** OS/platform version string. */
  platformVersion?: InputMaybe<Scalars['String']['input']>;
  /** When the client reports the heartbeat occurred. */
  reportedAt: Scalars['DateTime']['input'];
  /** What caused the ping. */
  trigger: WearableHeartbeatTrigger;
};

/** What caused the mobile app to emit a wearable heartbeat. */
export enum WearableHeartbeatTrigger {
  /** The member foregrounded the app. */
  AppOpen = 'app_open',
  /** An OS background-refresh slot fired. */
  BackgroundSlot = 'background_slot'
}

export type WearableIntegration = {
  __typename: 'WearableIntegration';
  lastSynced: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  provider: WearableProvider;
};

/**
 * Stable identifier for a wearable data provider, sourced from the Spike API
 * `provider` slug in BigQuery `spike_data`. `unknown` is a forward-compat
 * fallback so new providers added by Spike do not break GraphQL responses.
 */
export enum WearableProvider {
  AppleHealth = 'apple_health',
  Fitbit = 'fitbit',
  Garmin = 'garmin',
  GoogleFit = 'google_fit',
  Oura = 'oura',
  SamsungHealth = 'samsung_health',
  Unknown = 'unknown',
  Whoop = 'whoop'
}

/** Days of the week */
export enum WeekDay {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

/**
 * Home's week track: a gentle seven-day view of the member's VNS practice. Not a streak: it never counts
 * up to a number that resets to zero. Days are the member's own days (each rolls over at 03:00 on their
 * clock). A day counts as practised when a VNS session (any outcome, a manual log included) ended on it,
 * the same rule as "done for today". Worked out from all of the member's sessions: a
 * Free plan's history window does not apply to it.
 */
export type WeekTrack = {
  __typename: 'WeekTrack';
  /** Exactly seven days, oldest first. */
  days: Array<WeekTrackDay>;
  /** How many of the seven days are practised. */
  practisedDays: Scalars['Int']['output'];
  /** Where the member is on the track; it decides which seven days are shown. */
  state: WeekTrackState;
};

/** One day on the week track. */
export type WeekTrackDay = {
  __typename: 'WeekTrackDay';
  /** The member's day (it starts at 03:00 on their clock). */
  date: Scalars['Date']['output'];
  /** A VNS session ended on this day. Never true for an upcoming day. */
  practised: Scalars['Boolean']['output'];
  /** This is the member's today. Exactly one day is. */
  today: Scalars['Boolean']['output'];
  /**
   * This day is still to come: in the first seven days of a start, and on an
   * easing_back week (a fresh start, today first). Never practised.
   */
  upcoming: Scalars['Boolean']['output'];
};

/** Where the member is on the week track. */
export enum WeekTrackState {
  /**
   * Inside the first seven days of a start: from Day 1, or from the day the member
   * came back after seven or more days without practice. The seven days start on that day.
   */
  Building = 'building',
  /** Today is Day 1, the day onboarding finished. The seven days start today; the other six are upcoming. */
  DayOne = 'day_one',
  /**
   * No practice today and none in the seven days before it: the seven days start
   * again at today, today first, the other six upcoming. Practising today starts a
   * new first seven days on the same days. Not lapsed; that word is for an ended plan.
   */
  EasingBack = 'easing_back',
  /** Past the first seven days, with practice today or in the seven days before it: the last seven days, today last. */
  Steady = 'steady'
}

/** Tracks weekly progress against protocol commitments */
export type WeeklyAchievement = {
  __typename: 'WeeklyAchievement';
  /** Minutes committed per week */
  committedMinutes: Scalars['Int']['output'];
  /** Minutes completed this week */
  completedMinutes: Scalars['Int']['output'];
  /** Whether the weekly commitment was met */
  isCompleted: Scalars['Boolean']['output'];
  /** The protocol this achievement tracks */
  protocol: Protocol;
  /** Human readable remaining time, e.g. 'only 35 minutes to go' */
  remainingText: Scalars['String']['output'];
};

/** Container for weekly achievements across multiple weeks */
export type WeeklyAchievements = {
  __typename: 'WeeklyAchievements';
  /** List of achievements for protocols */
  achievements: Array<WeeklyAchievement>;
  /** The user these achievements belong to */
  userId: Scalars['ID']['output'];
  /** Start date of the week */
  weekStartDate: Scalars['String']['output'];
};

/** Represents a user's weekly commitment to a specific protocol */
export type WeeklyCommitment = {
  __typename: 'WeeklyCommitment';
  /** Minutes per week committed to this protocol */
  minutesPerWeek: Scalars['Int']['output'];
  /** The protocol being committed to */
  protocol: Protocol;
};

/** Input for weekly commitment to a protocol */
export type WeeklyCommitmentInput = {
  /** Minutes per week committed to this protocol */
  minutesPerWeek: Scalars['Int']['input'];
  /** The protocol being committed to */
  protocol: Protocol;
};

/** Input type for weight measurements */
export type Weight = {
  __typename: 'Weight';
  unit: WeightUnit;
  value: Scalars['Int']['output'];
};

/** Input type for weight measurements */
export type WeightInput = {
  unit: WeightUnit;
  value: Scalars['Int']['input'];
};

export enum WeightUnit {
  Kg = 'kg',
  Lb = 'lb'
}

/** Widget analytics overview - aggregated stats about mobile widget usage (excluding VNS) */
export type WidgetAnalytics = {
  __typename: 'WidgetAnalytics';
  /** Average time spent on widgets (seconds) */
  averageTimeSpentSeconds: Scalars['Float']['output'];
  /** Breakdown by widget type */
  completionsByType: Array<WidgetTypeStats>;
  /** Top users by widget completions */
  topUsers: Array<WidgetUserStats>;
  /** Total widget completions in the date range */
  totalCompletions: Scalars['Int']['output'];
  /** Number of unique users who completed widgets */
  uniqueUsers: Scalars['Int']['output'];
};

/** Input for widget analytics query */
export type WidgetAnalyticsInput = {
  /** End date for the analytics period */
  endDate: Scalars['DateTime']['input'];
  /** Start date for the analytics period */
  startDate: Scalars['DateTime']['input'];
  /** Maximum number of top users to return (default: 10) */
  topUsersLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Count of completions for a specific widget type */
export type WidgetTypeCount = {
  __typename: 'WidgetTypeCount';
  /** Number of completions */
  count: Scalars['Int']['output'];
  /** Widget kind identifier */
  widgetKind: Scalars['String']['output'];
};

/** Statistics for a specific widget type */
export type WidgetTypeStats = {
  __typename: 'WidgetTypeStats';
  /** Average time spent (seconds) */
  averageTimeSpentSeconds: Scalars['Float']['output'];
  /** Number of completions */
  completions: Scalars['Int']['output'];
  /** Human-readable display name */
  displayName: Scalars['String']['output'];
  /** Number of unique users */
  uniqueUsers: Scalars['Int']['output'];
  /** Widget kind identifier (e.g., daily_journal, box_breathing) */
  widgetKind: Scalars['String']['output'];
};

/** Widget usage statistics for a specific user */
export type WidgetUserStats = {
  __typename: 'WidgetUserStats';
  /** Breakdown of completions by widget type */
  completionsByType: Array<WidgetTypeCount>;
  /** Display name of the user */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Total widget completions by this user */
  totalCompletions: Scalars['Int']['output'];
  /** User ID */
  userId: Scalars['String']['output'];
};

export type WisdomQuote = {
  __typename: 'WisdomQuote';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** One pre→post lane for a metric: mean before, mean delta, mean after, across sessions. */
export type WithinSessionLane = {
  __typename: 'WithinSessionLane';
  caption: Scalars['String']['output'];
  direction: MetricDirection;
  meanDelta: Scalars['Float']['output'];
  meanPost: Scalars['Float']['output'];
  meanPre: Scalars['Float']['output'];
  metric: Scalars['String']['output'];
  sessions: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
};

/** C3 within-session pre/post — the pre→post delta one session produces ('calms you in the moment'). */
export type WithinSessionPayload = {
  __typename: 'WithinSessionPayload';
  intro: Scalars['String']['output'];
  lanes: Array<WithinSessionLane>;
};

/** The zones grammar (ADR-0005, D4). Declaration order is the canonical render order. */
export enum Zone {
  Headline = 'HEADLINE',
  Hero = 'HERO',
  KeepGoing = 'KEEP_GOING',
  Proof = 'PROOF',
  Watch = 'WATCH'
}

export type BroadcastEntryFieldsFragment = { __typename: 'BroadcastEntry', broadcastId: string, senderUserId: string, senderDisplayName?: string | null, status: BroadcastStatus, getstreamCampaignId?: string | null, body: string, recipientUserIds: Array<string>, sentCount: number, failedCount: number, failedUserIds: Array<string>, skippedPaused: number, failureReason?: string | null, initiatedAt: any, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BroadcastAllActiveParticipants', isAllActive: boolean } | { __typename: 'BroadcastCohort', cohortId: string } | { __typename: 'BroadcastHandPicked', userIds: Array<string> }, excludedSummary: { __typename: 'ResolvedRecipientsSummary', excludedOptOut: number, excludedTestUsers: number, excludedNoChannel: number, excludedPaused: number } };

export type InitiateBroadcastMutationVariables = Exact<{
  input: InitiateBroadcastInput;
}>;


export type InitiateBroadcastMutation = { __typename: 'Mutation', initiateBroadcast: { __typename: 'BroadcastEntry', broadcastId: string, senderUserId: string, senderDisplayName?: string | null, status: BroadcastStatus, getstreamCampaignId?: string | null, body: string, recipientUserIds: Array<string>, sentCount: number, failedCount: number, failedUserIds: Array<string>, skippedPaused: number, failureReason?: string | null, initiatedAt: any, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BroadcastAllActiveParticipants', isAllActive: boolean } | { __typename: 'BroadcastCohort', cohortId: string } | { __typename: 'BroadcastHandPicked', userIds: Array<string> }, excludedSummary: { __typename: 'ResolvedRecipientsSummary', excludedOptOut: number, excludedTestUsers: number, excludedNoChannel: number, excludedPaused: number } } };

export type RetryFailedBroadcastRecipientsMutationVariables = Exact<{
  broadcastId: Scalars['ID']['input'];
}>;


export type RetryFailedBroadcastRecipientsMutation = { __typename: 'Mutation', retryFailedBroadcastRecipients?: { __typename: 'InputAcceptedResponse', id: string } | null };

export type GetBroadcastsQueryVariables = Exact<{
  senderUserId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBroadcastsQuery = { __typename: 'Query', broadcasts: { __typename: 'BroadcastConnection', totalCount: number, nextCursor?: string | null, nodes: Array<{ __typename: 'BroadcastEntry', broadcastId: string, senderUserId: string, senderDisplayName?: string | null, status: BroadcastStatus, getstreamCampaignId?: string | null, body: string, recipientUserIds: Array<string>, sentCount: number, failedCount: number, failedUserIds: Array<string>, skippedPaused: number, failureReason?: string | null, initiatedAt: any, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BroadcastAllActiveParticipants', isAllActive: boolean } | { __typename: 'BroadcastCohort', cohortId: string } | { __typename: 'BroadcastHandPicked', userIds: Array<string> }, excludedSummary: { __typename: 'ResolvedRecipientsSummary', excludedOptOut: number, excludedTestUsers: number, excludedNoChannel: number, excludedPaused: number } }> } };

export type GetBroadcastQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBroadcastQuery = { __typename: 'Query', broadcast?: { __typename: 'BroadcastEntry', broadcastId: string, senderUserId: string, senderDisplayName?: string | null, status: BroadcastStatus, getstreamCampaignId?: string | null, body: string, recipientUserIds: Array<string>, sentCount: number, failedCount: number, failedUserIds: Array<string>, skippedPaused: number, failureReason?: string | null, initiatedAt: any, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BroadcastAllActiveParticipants', isAllActive: boolean } | { __typename: 'BroadcastCohort', cohortId: string } | { __typename: 'BroadcastHandPicked', userIds: Array<string> }, excludedSummary: { __typename: 'ResolvedRecipientsSummary', excludedOptOut: number, excludedTestUsers: number, excludedNoChannel: number, excludedPaused: number } } | null };

export type ResolveBroadcastRecipientsQueryVariables = Exact<{
  input: BroadcastSelectionInput;
}>;


export type ResolveBroadcastRecipientsQuery = { __typename: 'Query', resolveBroadcastRecipients: { __typename: 'ResolvedRecipients', userIds: Array<string>, excludedOptOut: number, excludedTestUsers: number, excludedNoChannel: number, excludedPaused: number, fallbackRecipientCount: number, sampleResolvedFirstName?: string | null, sourceRule: string, recipients: Array<{ __typename: 'ResolvedRecipient', userId: string, resolvedFirstName: string }> } };

export type BulkAssignmentConsentDeltaFieldsFragment = { __typename: 'BulkAssignmentConsentDelta', preparedCount: number, willSendCount: number, droppedSincePrepare: Array<{ __typename: 'BulkAssignmentDroppedRecipient', userId: string, reason: BulkAssignmentDropReason }> };

export type BulkAssignmentEntryFieldsFragment = { __typename: 'BulkAssignmentEntry', bulkAssignmentId: string, senderUserId: string, senderDisplayName?: string | null, status: BulkAssignmentStatus, recipientUserIds: Array<string>, failureReason?: string | null, preparedBy?: string | null, preparedVia?: PreparedVia | null, preparedAt?: any | null, approvedBy?: string | null, approvedVia?: ApprovedVia | null, approvedAt?: any | null, rejectedBy?: string | null, rejectedReason?: string | null, rejectedAt?: any | null, initiatedAt?: any | null, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BulkAssignmentAllActiveParticipants', isAllActive: boolean } | { __typename: 'BulkAssignmentCohort', cohortId: string } | { __typename: 'BulkAssignmentHandPicked', userIds: Array<string> }, payload: { __typename: 'SingleContentPayload', startDate?: any | null, endDate?: any | null, removeAfterCompletion: boolean, modeId?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, timeSlots: Array<{ __typename: 'ActivityTimeSlot', dayOfWeek: WeekDay, timeBlock: TimeBlock }> }, excludedSummary: { __typename: 'BulkAssignmentExcludedSummary', excludedOptOut: number, excludedTestUsers: number, excludedSuspended: number, alreadyPlanned: number, excludedPlannedMode: number, plannedModeReasonCounts: Array<{ __typename: 'BulkAssignmentPlannedModeReasonCount', reason: PlannedModeRefusalReason, count: number }>, plannedModeExclusions: Array<{ __typename: 'BulkAssignmentPlannedModeExclusion', userId: string, reason: PlannedModeRefusalReason }> }, stats?: { __typename: 'BulkAssignmentStats', assigned: number, failed: number } | null, perRecipientOutcomes: Array<{ __typename: 'BulkAssignmentRecipientOutcomeEntry', userId: string, outcome: { __typename: 'BulkAssignmentOutcomeAssigned', success: boolean } | { __typename: 'BulkAssignmentOutcomeCommandRejected', reason: string } | { __typename: 'BulkAssignmentOutcomeDispatchFailed', reason: string } }>, consentDelta?: { __typename: 'BulkAssignmentConsentDelta', preparedCount: number, willSendCount: number, droppedSincePrepare: Array<{ __typename: 'BulkAssignmentDroppedRecipient', userId: string, reason: BulkAssignmentDropReason }> } | null };

export type InitiateBulkAssignmentMutationVariables = Exact<{
  input: InitiateBulkAssignmentInput;
}>;


export type InitiateBulkAssignmentMutation = { __typename: 'Mutation', initiateBulkAssignment: { __typename: 'BulkAssignmentEntry', bulkAssignmentId: string, senderUserId: string, senderDisplayName?: string | null, status: BulkAssignmentStatus, recipientUserIds: Array<string>, failureReason?: string | null, preparedBy?: string | null, preparedVia?: PreparedVia | null, preparedAt?: any | null, approvedBy?: string | null, approvedVia?: ApprovedVia | null, approvedAt?: any | null, rejectedBy?: string | null, rejectedReason?: string | null, rejectedAt?: any | null, initiatedAt?: any | null, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BulkAssignmentAllActiveParticipants', isAllActive: boolean } | { __typename: 'BulkAssignmentCohort', cohortId: string } | { __typename: 'BulkAssignmentHandPicked', userIds: Array<string> }, payload: { __typename: 'SingleContentPayload', startDate?: any | null, endDate?: any | null, removeAfterCompletion: boolean, modeId?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, timeSlots: Array<{ __typename: 'ActivityTimeSlot', dayOfWeek: WeekDay, timeBlock: TimeBlock }> }, excludedSummary: { __typename: 'BulkAssignmentExcludedSummary', excludedOptOut: number, excludedTestUsers: number, excludedSuspended: number, alreadyPlanned: number, excludedPlannedMode: number, plannedModeReasonCounts: Array<{ __typename: 'BulkAssignmentPlannedModeReasonCount', reason: PlannedModeRefusalReason, count: number }>, plannedModeExclusions: Array<{ __typename: 'BulkAssignmentPlannedModeExclusion', userId: string, reason: PlannedModeRefusalReason }> }, stats?: { __typename: 'BulkAssignmentStats', assigned: number, failed: number } | null, perRecipientOutcomes: Array<{ __typename: 'BulkAssignmentRecipientOutcomeEntry', userId: string, outcome: { __typename: 'BulkAssignmentOutcomeAssigned', success: boolean } | { __typename: 'BulkAssignmentOutcomeCommandRejected', reason: string } | { __typename: 'BulkAssignmentOutcomeDispatchFailed', reason: string } }>, consentDelta?: { __typename: 'BulkAssignmentConsentDelta', preparedCount: number, willSendCount: number, droppedSincePrepare: Array<{ __typename: 'BulkAssignmentDroppedRecipient', userId: string, reason: BulkAssignmentDropReason }> } | null } };

export type PrepareBulkAssignmentMutationVariables = Exact<{
  input: PrepareBulkAssignmentInput;
}>;


export type PrepareBulkAssignmentMutation = { __typename: 'Mutation', prepareBulkAssignment: { __typename: 'BulkAssignmentEntry', bulkAssignmentId: string, senderUserId: string, senderDisplayName?: string | null, status: BulkAssignmentStatus, recipientUserIds: Array<string>, failureReason?: string | null, preparedBy?: string | null, preparedVia?: PreparedVia | null, preparedAt?: any | null, approvedBy?: string | null, approvedVia?: ApprovedVia | null, approvedAt?: any | null, rejectedBy?: string | null, rejectedReason?: string | null, rejectedAt?: any | null, initiatedAt?: any | null, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BulkAssignmentAllActiveParticipants', isAllActive: boolean } | { __typename: 'BulkAssignmentCohort', cohortId: string } | { __typename: 'BulkAssignmentHandPicked', userIds: Array<string> }, payload: { __typename: 'SingleContentPayload', startDate?: any | null, endDate?: any | null, removeAfterCompletion: boolean, modeId?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, timeSlots: Array<{ __typename: 'ActivityTimeSlot', dayOfWeek: WeekDay, timeBlock: TimeBlock }> }, excludedSummary: { __typename: 'BulkAssignmentExcludedSummary', excludedOptOut: number, excludedTestUsers: number, excludedSuspended: number, alreadyPlanned: number, excludedPlannedMode: number, plannedModeReasonCounts: Array<{ __typename: 'BulkAssignmentPlannedModeReasonCount', reason: PlannedModeRefusalReason, count: number }>, plannedModeExclusions: Array<{ __typename: 'BulkAssignmentPlannedModeExclusion', userId: string, reason: PlannedModeRefusalReason }> }, stats?: { __typename: 'BulkAssignmentStats', assigned: number, failed: number } | null, perRecipientOutcomes: Array<{ __typename: 'BulkAssignmentRecipientOutcomeEntry', userId: string, outcome: { __typename: 'BulkAssignmentOutcomeAssigned', success: boolean } | { __typename: 'BulkAssignmentOutcomeCommandRejected', reason: string } | { __typename: 'BulkAssignmentOutcomeDispatchFailed', reason: string } }>, consentDelta?: { __typename: 'BulkAssignmentConsentDelta', preparedCount: number, willSendCount: number, droppedSincePrepare: Array<{ __typename: 'BulkAssignmentDroppedRecipient', userId: string, reason: BulkAssignmentDropReason }> } | null } };

export type ApproveBulkAssignmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveBulkAssignmentMutation = { __typename: 'Mutation', approveBulkAssignment: { __typename: 'BulkAssignmentEntry', bulkAssignmentId: string, senderUserId: string, senderDisplayName?: string | null, status: BulkAssignmentStatus, recipientUserIds: Array<string>, failureReason?: string | null, preparedBy?: string | null, preparedVia?: PreparedVia | null, preparedAt?: any | null, approvedBy?: string | null, approvedVia?: ApprovedVia | null, approvedAt?: any | null, rejectedBy?: string | null, rejectedReason?: string | null, rejectedAt?: any | null, initiatedAt?: any | null, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BulkAssignmentAllActiveParticipants', isAllActive: boolean } | { __typename: 'BulkAssignmentCohort', cohortId: string } | { __typename: 'BulkAssignmentHandPicked', userIds: Array<string> }, payload: { __typename: 'SingleContentPayload', startDate?: any | null, endDate?: any | null, removeAfterCompletion: boolean, modeId?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, timeSlots: Array<{ __typename: 'ActivityTimeSlot', dayOfWeek: WeekDay, timeBlock: TimeBlock }> }, excludedSummary: { __typename: 'BulkAssignmentExcludedSummary', excludedOptOut: number, excludedTestUsers: number, excludedSuspended: number, alreadyPlanned: number, excludedPlannedMode: number, plannedModeReasonCounts: Array<{ __typename: 'BulkAssignmentPlannedModeReasonCount', reason: PlannedModeRefusalReason, count: number }>, plannedModeExclusions: Array<{ __typename: 'BulkAssignmentPlannedModeExclusion', userId: string, reason: PlannedModeRefusalReason }> }, stats?: { __typename: 'BulkAssignmentStats', assigned: number, failed: number } | null, perRecipientOutcomes: Array<{ __typename: 'BulkAssignmentRecipientOutcomeEntry', userId: string, outcome: { __typename: 'BulkAssignmentOutcomeAssigned', success: boolean } | { __typename: 'BulkAssignmentOutcomeCommandRejected', reason: string } | { __typename: 'BulkAssignmentOutcomeDispatchFailed', reason: string } }>, consentDelta?: { __typename: 'BulkAssignmentConsentDelta', preparedCount: number, willSendCount: number, droppedSincePrepare: Array<{ __typename: 'BulkAssignmentDroppedRecipient', userId: string, reason: BulkAssignmentDropReason }> } | null } };

export type RejectBulkAssignmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectBulkAssignmentMutation = { __typename: 'Mutation', rejectBulkAssignment: { __typename: 'BulkAssignmentEntry', bulkAssignmentId: string, senderUserId: string, senderDisplayName?: string | null, status: BulkAssignmentStatus, recipientUserIds: Array<string>, failureReason?: string | null, preparedBy?: string | null, preparedVia?: PreparedVia | null, preparedAt?: any | null, approvedBy?: string | null, approvedVia?: ApprovedVia | null, approvedAt?: any | null, rejectedBy?: string | null, rejectedReason?: string | null, rejectedAt?: any | null, initiatedAt?: any | null, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BulkAssignmentAllActiveParticipants', isAllActive: boolean } | { __typename: 'BulkAssignmentCohort', cohortId: string } | { __typename: 'BulkAssignmentHandPicked', userIds: Array<string> }, payload: { __typename: 'SingleContentPayload', startDate?: any | null, endDate?: any | null, removeAfterCompletion: boolean, modeId?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, timeSlots: Array<{ __typename: 'ActivityTimeSlot', dayOfWeek: WeekDay, timeBlock: TimeBlock }> }, excludedSummary: { __typename: 'BulkAssignmentExcludedSummary', excludedOptOut: number, excludedTestUsers: number, excludedSuspended: number, alreadyPlanned: number, excludedPlannedMode: number, plannedModeReasonCounts: Array<{ __typename: 'BulkAssignmentPlannedModeReasonCount', reason: PlannedModeRefusalReason, count: number }>, plannedModeExclusions: Array<{ __typename: 'BulkAssignmentPlannedModeExclusion', userId: string, reason: PlannedModeRefusalReason }> }, stats?: { __typename: 'BulkAssignmentStats', assigned: number, failed: number } | null, perRecipientOutcomes: Array<{ __typename: 'BulkAssignmentRecipientOutcomeEntry', userId: string, outcome: { __typename: 'BulkAssignmentOutcomeAssigned', success: boolean } | { __typename: 'BulkAssignmentOutcomeCommandRejected', reason: string } | { __typename: 'BulkAssignmentOutcomeDispatchFailed', reason: string } }>, consentDelta?: { __typename: 'BulkAssignmentConsentDelta', preparedCount: number, willSendCount: number, droppedSincePrepare: Array<{ __typename: 'BulkAssignmentDroppedRecipient', userId: string, reason: BulkAssignmentDropReason }> } | null } };

export type GetBulkAssignmentsQueryVariables = Exact<{
  senderUserId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<BulkAssignmentStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBulkAssignmentsQuery = { __typename: 'Query', bulkAssignments: { __typename: 'BulkAssignmentConnection', totalCount: number, nextCursor?: string | null, nodes: Array<{ __typename: 'BulkAssignmentEntry', bulkAssignmentId: string, senderUserId: string, senderDisplayName?: string | null, status: BulkAssignmentStatus, recipientUserIds: Array<string>, failureReason?: string | null, preparedBy?: string | null, preparedVia?: PreparedVia | null, preparedAt?: any | null, approvedBy?: string | null, approvedVia?: ApprovedVia | null, approvedAt?: any | null, rejectedBy?: string | null, rejectedReason?: string | null, rejectedAt?: any | null, initiatedAt?: any | null, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BulkAssignmentAllActiveParticipants', isAllActive: boolean } | { __typename: 'BulkAssignmentCohort', cohortId: string } | { __typename: 'BulkAssignmentHandPicked', userIds: Array<string> }, payload: { __typename: 'SingleContentPayload', startDate?: any | null, endDate?: any | null, removeAfterCompletion: boolean, modeId?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, timeSlots: Array<{ __typename: 'ActivityTimeSlot', dayOfWeek: WeekDay, timeBlock: TimeBlock }> }, excludedSummary: { __typename: 'BulkAssignmentExcludedSummary', excludedOptOut: number, excludedTestUsers: number, excludedSuspended: number, alreadyPlanned: number, excludedPlannedMode: number, plannedModeReasonCounts: Array<{ __typename: 'BulkAssignmentPlannedModeReasonCount', reason: PlannedModeRefusalReason, count: number }>, plannedModeExclusions: Array<{ __typename: 'BulkAssignmentPlannedModeExclusion', userId: string, reason: PlannedModeRefusalReason }> }, stats?: { __typename: 'BulkAssignmentStats', assigned: number, failed: number } | null, perRecipientOutcomes: Array<{ __typename: 'BulkAssignmentRecipientOutcomeEntry', userId: string, outcome: { __typename: 'BulkAssignmentOutcomeAssigned', success: boolean } | { __typename: 'BulkAssignmentOutcomeCommandRejected', reason: string } | { __typename: 'BulkAssignmentOutcomeDispatchFailed', reason: string } }>, consentDelta?: { __typename: 'BulkAssignmentConsentDelta', preparedCount: number, willSendCount: number, droppedSincePrepare: Array<{ __typename: 'BulkAssignmentDroppedRecipient', userId: string, reason: BulkAssignmentDropReason }> } | null }> } };

export type GetBulkAssignmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBulkAssignmentQuery = { __typename: 'Query', bulkAssignment?: { __typename: 'BulkAssignmentEntry', bulkAssignmentId: string, senderUserId: string, senderDisplayName?: string | null, status: BulkAssignmentStatus, recipientUserIds: Array<string>, failureReason?: string | null, preparedBy?: string | null, preparedVia?: PreparedVia | null, preparedAt?: any | null, approvedBy?: string | null, approvedVia?: ApprovedVia | null, approvedAt?: any | null, rejectedBy?: string | null, rejectedReason?: string | null, rejectedAt?: any | null, initiatedAt?: any | null, startedAt?: any | null, completedAt?: any | null, lastUpdatedAt: any, selection: { __typename: 'BulkAssignmentAllActiveParticipants', isAllActive: boolean } | { __typename: 'BulkAssignmentCohort', cohortId: string } | { __typename: 'BulkAssignmentHandPicked', userIds: Array<string> }, payload: { __typename: 'SingleContentPayload', startDate?: any | null, endDate?: any | null, removeAfterCompletion: boolean, modeId?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, timeSlots: Array<{ __typename: 'ActivityTimeSlot', dayOfWeek: WeekDay, timeBlock: TimeBlock }> }, excludedSummary: { __typename: 'BulkAssignmentExcludedSummary', excludedOptOut: number, excludedTestUsers: number, excludedSuspended: number, alreadyPlanned: number, excludedPlannedMode: number, plannedModeReasonCounts: Array<{ __typename: 'BulkAssignmentPlannedModeReasonCount', reason: PlannedModeRefusalReason, count: number }>, plannedModeExclusions: Array<{ __typename: 'BulkAssignmentPlannedModeExclusion', userId: string, reason: PlannedModeRefusalReason }> }, stats?: { __typename: 'BulkAssignmentStats', assigned: number, failed: number } | null, perRecipientOutcomes: Array<{ __typename: 'BulkAssignmentRecipientOutcomeEntry', userId: string, outcome: { __typename: 'BulkAssignmentOutcomeAssigned', success: boolean } | { __typename: 'BulkAssignmentOutcomeCommandRejected', reason: string } | { __typename: 'BulkAssignmentOutcomeDispatchFailed', reason: string } }>, consentDelta?: { __typename: 'BulkAssignmentConsentDelta', preparedCount: number, willSendCount: number, droppedSincePrepare: Array<{ __typename: 'BulkAssignmentDroppedRecipient', userId: string, reason: BulkAssignmentDropReason }> } | null } | null };

export type BulkAssignmentConsentPreviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BulkAssignmentConsentPreviewQuery = { __typename: 'Query', bulkAssignmentConsentPreview?: { __typename: 'BulkAssignmentConsentDelta', preparedCount: number, willSendCount: number, droppedSincePrepare: Array<{ __typename: 'BulkAssignmentDroppedRecipient', userId: string, reason: BulkAssignmentDropReason }> } | null };

export type ResolveBulkAssignmentRecipientsQueryVariables = Exact<{
  input: BulkAssignmentSelectionInput;
  contentReference?: InputMaybe<ContentReferenceInput>;
}>;


export type ResolveBulkAssignmentRecipientsQuery = { __typename: 'Query', resolveBulkAssignmentRecipients: { __typename: 'BulkAssignmentResolvedRecipients', userIds: Array<string>, excludedOptOut: number, excludedTestUsers: number, alreadyPlannedUserIds: Array<string>, sourceRule: string } };

export type GetCapabilityPackagesQueryVariables = Exact<{
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCapabilityPackagesQuery = { __typename: 'Query', capabilityPackages: Array<{ __typename: 'CapabilityPackage', packageId: string, packageKey: string, displayName: string, capabilities: Array<Capability>, archived: boolean, sitsAbove?: string | null, modeIds?: Array<string> | null, includesPersonalised: boolean, contentHash: string, definedBy: string, definedAt: any, lastUpdatedBy?: string | null, lastUpdatedAt?: any | null, priceRefs: Array<{ __typename: 'CapabilityPriceRef', cadence: string, priceRef: string }>, dials: Array<{ __typename: 'CapabilityPackageDial', dial: PackageDial, value: number }> }> };

export type GetCapabilityCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCapabilityCatalogQuery = { __typename: 'Query', capabilityCatalog: Array<{ __typename: 'CapabilityDescriptor', capability: Capability, group: CapabilityGroup, deviceBound: boolean, grantsScanSeconds?: number | null, minDerivableScanSeconds?: number | null, validatedAtScanSeconds?: number | null }> };

export type GetCapabilitySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCapabilitySettingsQuery = { __typename: 'Query', capabilitySettings?: { __typename: 'CapabilitySettings', settingsId: string, floorPackageKey: string, trialMonths: number, trialGraceDays: number, trialPackageKey?: string | null, defaultPurchaseProduct?: string | null, enforcementActive: boolean, enforcedGates: Array<GateKey>, updatedBy: string, updatedAt: any } | null };

export type GetPackageChangeImpactQueryVariables = Exact<{
  input: PackageChangeImpactInput;
}>;


export type GetPackageChangeImpactQuery = { __typename: 'Query', packageChangeImpact: { __typename: 'PackageChangeImpact', packageKey: string, changeKind: PackageChangeKind, fleetWide: boolean, holdersInScope: number, addedCapabilities: Array<Capability>, warnings: Array<string>, removedCapabilities: Array<{ __typename: 'CapabilityImpact', capability: Capability, affectedHolderCount: number, retainedHolderCount: number, sampleSubjectIds: Array<string> }>, dialChanges: Array<{ __typename: 'PackageDialChange', dial: PackageDial, currentValue?: number | null, proposedValue?: number | null, tightened: boolean }> } };

export type DefineCapabilityPackageMutationVariables = Exact<{
  input: DefineCapabilityPackageInput;
}>;


export type DefineCapabilityPackageMutation = { __typename: 'Mutation', defineCapabilityPackage: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateCapabilityPackageContentsMutationVariables = Exact<{
  input: UpdateCapabilityPackageContentsInput;
}>;


export type UpdateCapabilityPackageContentsMutation = { __typename: 'Mutation', updateCapabilityPackageContents: { __typename: 'InputAcceptedResponse', id: string } };

export type ArchiveCapabilityPackageMutationVariables = Exact<{
  packageKey: Scalars['ID']['input'];
  shrinkMode?: InputMaybe<ShrinkMode>;
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArchiveCapabilityPackageMutation = { __typename: 'Mutation', archiveCapabilityPackage: { __typename: 'InputAcceptedResponse', id: string } };

export type PlaceCapabilityPackageMutationVariables = Exact<{
  packageKey: Scalars['ID']['input'];
  sitsAbove?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PlaceCapabilityPackageMutation = { __typename: 'Mutation', placeCapabilityPackage: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateCapabilitySettingsMutationVariables = Exact<{
  input: UpdateCapabilitySettingsInput;
}>;


export type UpdateCapabilitySettingsMutation = { __typename: 'Mutation', updateCapabilitySettings: { __typename: 'InputAcceptedResponse', id: string } };

export type GetMemberCapabilitiesQueryVariables = Exact<{
  subjectId: Scalars['ID']['input'];
}>;


export type GetMemberCapabilitiesQuery = { __typename: 'Query', memberCapabilities: { __typename: 'MemberCapabilities', subjectId: string, holderId?: string | null, effectiveCapabilities: Array<Capability>, effectiveDials?: Array<{ __typename: 'CapabilityPackageDial', dial: PackageDial, value: number }> | null, provenance: Array<{ __typename: 'CapabilityProvenance', capability: Capability, sources: Array<{ __typename: 'CapabilityProvenanceSource', origin: CapabilityOrigin, packageKey?: string | null, packageName?: string | null, grantId?: string | null, grantSource?: GrantSource | null, reason?: string | null, grantedBy?: string | null, expiresAt?: any | null }> }>, grants: Array<{ __typename: 'MemberCapabilityGrant', grantId: string, packageKey?: string | null, capabilities?: Array<Capability> | null, source: GrantSource, sourceRef: string, reason?: string | null, grantedBy?: string | null, grantedAt: any, expiresAt?: any | null, active: boolean, dials?: Array<{ __typename: 'CapabilityPackageDial', dial: PackageDial, value: number }> | null }>, scheduledChanges: Array<{ __typename: 'MemberScheduledChange', changeId: string, fromPackageKey: string, toPackageKey?: string | null, effectiveAt: any, status: ScheduledChangeStatus, source: GrantSource, sourceRef: string }> } };

export type GrantCompPackageMutationVariables = Exact<{
  input: GrantCompPackageInput;
}>;


export type GrantCompPackageMutation = { __typename: 'Mutation', grantCompPackage: { __typename: 'InputAcceptedResponse', id: string } };

export type RevokeCompCapabilityMutationVariables = Exact<{
  input: RevokeCompCapabilityInput;
}>;


export type RevokeCompCapabilityMutation = { __typename: 'Mutation', revokeCompCapability: { __typename: 'InputAcceptedResponse', id: string } };

export type GrantCustomCapabilitiesMutationVariables = Exact<{
  input: GrantCustomCapabilitiesInput;
}>;


export type GrantCustomCapabilitiesMutation = { __typename: 'Mutation', grantCustomCapabilities: { __typename: 'InputAcceptedResponse', id: string } };

export type RevokeCustomCapabilityGrantMutationVariables = Exact<{
  input: RevokeCustomCapabilityGrantInput;
}>;


export type RevokeCustomCapabilityGrantMutation = { __typename: 'Mutation', revokeCustomCapabilityGrant: { __typename: 'InputAcceptedResponse', id: string } };

export type GetDeviceOfflineSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeviceOfflineSettingsQuery = { __typename: 'Query', deviceOfflineSettings: { __typename: 'DeviceOfflineSettings', offlineSessionAllowance?: { __typename: 'DeviceSettingValue', value: number, updatedBy: string, updatedByName?: string | null, updatedAt: any } | null, deviceOfflineCap?: { __typename: 'DeviceSettingValue', value: number, updatedBy: string, updatedByName?: string | null, updatedAt: any } | null, deviceRecordWindowDays?: { __typename: 'DeviceSettingValue', value: number, updatedBy: string, updatedByName?: string | null, updatedAt: any } | null } };

export type UpdateOfflineSessionAllowanceMutationVariables = Exact<{
  value: Scalars['Int']['input'];
}>;


export type UpdateOfflineSessionAllowanceMutation = { __typename: 'Mutation', updateOfflineSessionAllowance: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateDeviceOfflineCapMutationVariables = Exact<{
  value: Scalars['Int']['input'];
}>;


export type UpdateDeviceOfflineCapMutation = { __typename: 'Mutation', updateDeviceOfflineCap: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateDeviceRecordWindowDaysMutationVariables = Exact<{
  days: Scalars['Int']['input'];
}>;


export type UpdateDeviceRecordWindowDaysMutation = { __typename: 'Mutation', updateDeviceRecordWindowDays: { __typename: 'InputAcceptedResponse', id: string } };

export type GetStoneModesForPickerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoneModesForPickerQuery = { __typename: 'Query', stoneModeCatalogue: { __typename: 'StoneModeCatalogue', modes: Array<{ __typename: 'StoneMode', modeId: string, displayName: string, generation: StoneDeviceGeneration, enabled: boolean, position: number }> } };

export type SetCapabilityPackageModesMutationVariables = Exact<{
  input: SetCapabilityPackageModesInput;
}>;


export type SetCapabilityPackageModesMutation = { __typename: 'Mutation', setCapabilityPackageModes: { __typename: 'InputAcceptedResponse', id: string } };

export type StartChatMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type StartChatMutation = { __typename: 'Mutation', startChat: { __typename: 'ChatChannel', channelId: string, paused: boolean } };

export type GetChatUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChatUserQuery = { __typename: 'Query', me: { __typename: 'Nurse', nurseId: string, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, middleName?: string | null, lastName?: string | null } } | null, messagingToken?: { __typename: 'MessagingToken', token: string, provider: MessagingProvider } | null } | { __typename: 'Participant', participantId: string, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, middleName?: string | null, lastName?: string | null } } | null, messagingToken?: { __typename: 'MessagingToken', token: string, provider: MessagingProvider } | null } };

export type GetCohortsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCohortsQuery = { __typename: 'Query', cohorts: Array<{ __typename: 'Cohort', id: string, name: string, description: string, memberCount: number }> };

export type GetCohortMembersQueryVariables = Exact<{
  cohortId: Scalars['ID']['input'];
}>;


export type GetCohortMembersQuery = { __typename: 'Query', cohortMembers: { __typename: 'CohortWithMembers', memberIds: Array<string>, cohort: { __typename: 'Cohort', id: string, name: string, description: string, memberCount: number }, members: Array<{ __typename: 'CohortMember', userId: string, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null }> } };

export type GetConsultRosterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConsultRosterQuery = { __typename: 'Query', consultRoster: Array<{ __typename: 'ConsultRosterEntry', participantId: string, name?: string | null, email?: string | null, consultStatus: ConsultStatus, needsInitialConsult: boolean, totalConsults: number, attendedConsults: number, lastConsultDate?: string | null, nextScheduledDate?: string | null }> };

export type GetConsultsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type GetConsultsQuery = { __typename: 'Query', consults: Array<{ __typename: 'Consult', consultNumber: number, consultType: ConsultType, scheduledDate: string, outcome?: ConsultOutcome | null, notes?: string | null, scheduledBy: string, participantId: string, linkedNotes: Array<{ __typename: 'ParticipantNote', noteId: string, content: string, categories: Array<NoteCategory>, createdAt: any }> }> };

export type ScheduleConsultMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  type: ConsultType;
  scheduledDate: Scalars['DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScheduleConsultMutation = { __typename: 'Mutation', scheduleConsult: { __typename: 'InputAcceptedResponse', id: string } };

export type RecordPastConsultMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  type: ConsultType;
  scheduledDate: Scalars['DateTime']['input'];
  outcome: ConsultOutcome;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordPastConsultMutation = { __typename: 'Mutation', recordPastConsult: { __typename: 'InputAcceptedResponse', id: string } };

export type RecordConsultOutcomeMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  consultNumber: Scalars['Int']['input'];
  outcome: ConsultOutcome;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordConsultOutcomeMutation = { __typename: 'Mutation', recordConsultOutcome: { __typename: 'InputAcceptedResponse', id: string } };

export type CancelConsultMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  consultNumber: Scalars['Int']['input'];
}>;


export type CancelConsultMutation = { __typename: 'Mutation', cancelConsult: { __typename: 'InputAcceptedResponse', id: string } };

export type AcquisitionSourceFieldsFragment = { __typename: 'AcquisitionSource', sourceId: string, name: string, couponCodes: Array<string>, defaultSegment: CustomerSegment, partnerName?: string | null, startDate?: any | null, endDate?: any | null, active: boolean, metadata?: any | null, customerCount: number, createdAt: any, updatedAt: any };

export type GetAcquisitionSourcesQueryVariables = Exact<{
  filter?: InputMaybe<AcquisitionSourceFilter>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetAcquisitionSourcesQuery = { __typename: 'Query', acquisitionSources: { __typename: 'AcquisitionSourceConnection', totalCount: number, edges: Array<{ __typename: 'AcquisitionSourceEdge', cursor: string, node: { __typename: 'AcquisitionSource', sourceId: string, name: string, couponCodes: Array<string>, defaultSegment: CustomerSegment, partnerName?: string | null, startDate?: any | null, endDate?: any | null, active: boolean, metadata?: any | null, customerCount: number, createdAt: any, updatedAt: any } }>, pageInfo: { __typename: 'AcquisitionSourcePageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetAcquisitionSourceQueryVariables = Exact<{
  sourceId: Scalars['ID']['input'];
}>;


export type GetAcquisitionSourceQuery = { __typename: 'Query', acquisitionSource?: { __typename: 'AcquisitionSource', sourceId: string, name: string, couponCodes: Array<string>, defaultSegment: CustomerSegment, partnerName?: string | null, startDate?: any | null, endDate?: any | null, active: boolean, metadata?: any | null, customerCount: number, createdAt: any, updatedAt: any } | null };

export type CreateAcquisitionSourceMutationVariables = Exact<{
  cmd: CreateAcquisitionSourceInput;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateAcquisitionSourceMutation = { __typename: 'Mutation', createAcquisitionSource?: { __typename: 'AcquisitionSource', sourceId: string, name: string, couponCodes: Array<string>, defaultSegment: CustomerSegment, partnerName?: string | null, startDate?: any | null, endDate?: any | null, active: boolean, metadata?: any | null, customerCount: number, createdAt: any, updatedAt: any } | null };

export type UpdateAcquisitionSourceMutationVariables = Exact<{
  cmd: UpdateAcquisitionSourceInput;
}>;


export type UpdateAcquisitionSourceMutation = { __typename: 'Mutation', updateAcquisitionSource?: { __typename: 'AcquisitionSource', sourceId: string, name: string, couponCodes: Array<string>, defaultSegment: CustomerSegment, partnerName?: string | null, startDate?: any | null, endDate?: any | null, active: boolean, metadata?: any | null, customerCount: number, createdAt: any, updatedAt: any } | null };

export type AddCouponCodeMutationVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  couponCode: Scalars['String']['input'];
}>;


export type AddCouponCodeMutation = { __typename: 'Mutation', addCouponCode?: { __typename: 'AcquisitionSource', sourceId: string, name: string, couponCodes: Array<string>, defaultSegment: CustomerSegment, partnerName?: string | null, startDate?: any | null, endDate?: any | null, active: boolean, metadata?: any | null, customerCount: number, createdAt: any, updatedAt: any } | null };

export type RemoveCouponCodeMutationVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  couponCode: Scalars['String']['input'];
}>;


export type RemoveCouponCodeMutation = { __typename: 'Mutation', removeCouponCode?: { __typename: 'AcquisitionSource', sourceId: string, name: string, couponCodes: Array<string>, defaultSegment: CustomerSegment, partnerName?: string | null, startDate?: any | null, endDate?: any | null, active: boolean, metadata?: any | null, customerCount: number, createdAt: any, updatedAt: any } | null };

export type DeactivateAcquisitionSourceMutationVariables = Exact<{
  sourceId: Scalars['ID']['input'];
}>;


export type DeactivateAcquisitionSourceMutation = { __typename: 'Mutation', deactivateAcquisitionSource?: { __typename: 'AcquisitionSource', sourceId: string, name: string, couponCodes: Array<string>, defaultSegment: CustomerSegment, partnerName?: string | null, startDate?: any | null, endDate?: any | null, active: boolean, metadata?: any | null, customerCount: number, createdAt: any, updatedAt: any } | null };

export type CarrierFieldsFragment = { __typename: 'Carrier', carrierId: string, code: string, name: string, trackingUrlTemplate?: string | null, active: boolean, createdAt: any };

export type GetCarriersQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCarriersQuery = { __typename: 'Query', carriers: Array<{ __typename: 'Carrier', carrierId: string, code: string, name: string, trackingUrlTemplate?: string | null, active: boolean, createdAt: any }> };

export type GetCarrierQueryVariables = Exact<{
  carrierId: Scalars['ID']['input'];
}>;


export type GetCarrierQuery = { __typename: 'Query', carrier?: { __typename: 'Carrier', carrierId: string, code: string, name: string, trackingUrlTemplate?: string | null, active: boolean, createdAt: any } | null };

export type CreateCarrierMutationVariables = Exact<{
  cmd: CreateCarrierInput;
}>;


export type CreateCarrierMutation = { __typename: 'Mutation', createCarrier?: { __typename: 'Carrier', carrierId: string, code: string, name: string, trackingUrlTemplate?: string | null, active: boolean, createdAt: any } | null };

export type UpdateCarrierMutationVariables = Exact<{
  cmd: UpdateCarrierInput;
}>;


export type UpdateCarrierMutation = { __typename: 'Mutation', updateCarrier?: { __typename: 'Carrier', carrierId: string, code: string, name: string, trackingUrlTemplate?: string | null, active: boolean, createdAt: any } | null };

export type DeactivateCarrierMutationVariables = Exact<{
  carrierId: Scalars['ID']['input'];
}>;


export type DeactivateCarrierMutation = { __typename: 'Mutation', deactivateCarrier?: { __typename: 'Carrier', carrierId: string, code: string, name: string, trackingUrlTemplate?: string | null, active: boolean, createdAt: any } | null };

export type GetCustomersQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<CustomerSortInput>;
}>;


export type GetCustomersQuery = { __typename: 'Query', customers: { __typename: 'CustomerConnection', totalCount: number, edges: Array<{ __typename: 'CustomerEdge', cursor: string, node: { __typename: 'Customer', customerId: string, email?: string | null, segment: CustomerSegment, country?: string | null, couponCode?: string | null, amountPaid?: any | null, currency: string, createdAt: any, firstConsultDate?: any | null, stripeRefundCount: number, refundReviewPending: boolean, entitlements: Array<{ __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, activatedByUserId?: string | null, provisionedAt: any, activatedAt?: any | null, subscriptionId?: string | null, emailStatus?: { __typename: 'ActivationEmailStatus', status: EmailStatus } | null }>, primaryEntitlement?: { __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, activatedAt?: any | null } | null, linkedUser?: { __typename: 'Participant', participantId: string, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null } | null, engagement?: { __typename: 'EngagementStats', lastVnsSession?: any | null, totalVnsSessions: number, lastAppActivity?: any | null, isActive: boolean, currentProgram?: string | null } | null } }>, pageInfo: { __typename: 'CustomerPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetCustomerQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerQuery = { __typename: 'Query', customer?: { __typename: 'Customer', customerId: string, email?: string | null, stripeCustomerId?: string | null, segment: CustomerSegment, country?: string | null, couponCode?: string | null, amountPaid?: any | null, currency: string, createdAt: any, firstConsultDate?: any | null, stripeCustomerDeleted: boolean, stripeRefundCount: number, lastStripeRefundAt?: any | null, refundReviewPending: boolean, contactInformation?: { __typename: 'ContactInformation', email?: string | null, address?: string | null, country?: string | null, phoneNumber?: { __typename: 'PhoneNumber', countryCode: string, nationalNumber: string } | null } | null, acquisitionSource?: { __typename: 'CustomerAcquisitionSource', name: string, partnerName?: string | null, defaultSegment: CustomerSegment } | null, entitlements: Array<{ __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, billingStatus?: EntitlementBillingStatus | null, activatedByUserId?: string | null, provisionedAt: any, activatedAt?: any | null, subscriptionId?: string | null, currentPeriodEnd?: any | null, cancelAtPeriodEnd?: boolean | null, gift?: boolean | null, giftBasis?: string | null, activatedBy?: { __typename: 'Participant', participantId: string, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null } | null, emailStatus?: { __typename: 'ActivationEmailStatus', status: EmailStatus } | null, preRegistration?: { __typename: 'DeviceSerialPreRegistration', customerId: string, entitlementId: string, serialNumber: string, state: PreRegistrationState, preRegisteredAt?: any | null, preRegisteredBy?: string | null } | null, lastSubscriptionExtension?: { __typename: 'SubscriptionExtension', months: number, extendedBy?: string | null, extendedAt: any, previousPeriodEnd?: any | null, newPeriodEnd: any, reason: string } | null, subscriptionCancellations: Array<{ __typename: 'SubscriptionCancellation', action: SubscriptionCancellationAction, mode?: SubscriptionCancellationMode | null, performedBy?: string | null, occurredAt: any, reason?: string | null }> }>, primaryEntitlement?: { __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, activatedAt?: any | null } | null, linkedUser?: { __typename: 'Participant', participantId: string, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null } | null, engagement?: { __typename: 'EngagementStats', lastVnsSession?: any | null, totalVnsSessions: number, lastAppActivity?: any | null, isActive: boolean, currentProgram?: string | null } | null, financialSummary?: { __typename: 'FinancialSummary', totalPaidInCents: any, totalFeesInCents: any, totalNetInCents: any, totalRefundedInCents: any, currency: string, transactionCount: number, hasActualFees: boolean, refundCount: number, disputeCount: number, disputeAmountInCents: any, refundRate?: any | null } | null, transactions?: Array<{ __typename: 'TransactionDetail', chargeId: string, amountInCents: any, currency: string, feeInCents?: any | null, netInCents?: any | null, feeSource?: string | null, reconciled: boolean, totalRefundedInCents: any, refundCount: number, disputeCount: number, disputeAmountInCents: any, createdAt: any, payoutId?: string | null, refunds?: Array<{ __typename: 'RefundDetail', refundId: string, amountInCents: any, currency: string, reason?: string | null, createdAt: any }> | null, disputes?: Array<{ __typename: 'DisputeDetail', disputeId: string, amountInCents: any, currency: string, reason?: string | null, status: string, openedAt: any, closedAt?: any | null }> | null, feeDetails?: Array<{ __typename: 'FeeDetail', type: string, amountInCents: any, currency: string, description?: string | null }> | null }> | null, refundReviews: Array<{ __typename: 'RefundReview', entitlementId: string, decision: RefundReviewDecision, reason: string, reviewedAt: any, reviewedBy?: string | null }> } | null };

export type GetCustomerContactHistoryQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerContactHistoryQuery = { __typename: 'Query', customer?: { __typename: 'Customer', customerId: string, contactHistory?: { __typename: 'CustomerContactHistory', current: { __typename: 'CustomerContactCards', email?: string | null, delivery?: { __typename: 'DeliveryContact', firstName?: string | null, lastName?: string | null, address?: string | null, country?: string | null, phoneNumber?: string | null } | null, billing?: { __typename: 'BillingContact', name?: string | null, address?: string | null, country?: string | null } | null }, changes: Array<{ __typename: 'CustomerContactChange', field: CustomerContactField, oldValue?: string | null, newValue?: string | null, removed: boolean, source: ContactChangeSource, providerEventId?: string | null, changedBy?: string | null, changedAt: any, pending: boolean }>, observations: Array<{ __typename: 'ExternalContactObservation', providerEventId: string, observedAt: any, billingChanged: Array<string>, deliveryChanged: Array<string>, fieldsToApply: Array<CustomerContactField>, staleFields: Array<CustomerContactField>, disposition: ExternalContactDisposition }> } | null } | null };

export type SearchCustomersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCustomersQuery = { __typename: 'Query', searchCustomers: Array<{ __typename: 'Customer', customerId: string, email?: string | null, segment: CustomerSegment, entitlements: Array<{ __typename: 'Entitlement', entitlementId: string, status: EntitlementStatus, activationCode: string }>, primaryEntitlement?: { __typename: 'Entitlement', entitlementId: string, status: EntitlementStatus, activationCode: string } | null }> };

export type RecordFirstConsultMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  consultDate: Scalars['Date']['input'];
}>;


export type RecordFirstConsultMutation = { __typename: 'Mutation', recordFirstConsult: { __typename: 'Customer', customerId: string, firstConsultDate?: any | null } };

export type CustomerRefundReviewFieldsFragment = { __typename: 'Customer', refundReviewPending: boolean, refundReviews: Array<{ __typename: 'RefundReview', entitlementId: string, decision: RefundReviewDecision, reason: string, reviewedAt: any, reviewedBy?: string | null }> };

export type GetCustomerDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerDashboardQuery = { __typename: 'Query', customerDashboard: { __typename: 'CustomerDashboard', overview: { __typename: 'CustomerOverview', totalCustomers: number, activeEntitlements: number, pendingEntitlements: number, suspendedEntitlements: number, revokedEntitlements: number }, statusMatrix: { __typename: 'CustomerStatusMatrix', d2c: { __typename: 'SegmentStats', total: number, active: number, pending: number }, b2b2c: { __typename: 'SegmentStats', total: number, active: number, pending: number }, investor: { __typename: 'SegmentStats', total: number, active: number, pending: number }, internal: { __typename: 'SegmentStats', total: number, active: number, pending: number }, pilot: { __typename: 'SegmentStats', total: number, active: number, pending: number } }, deviceStatus: { __typename: 'DeviceStatusMatrix', totalShipments: number, pendingShipments: number, shippedShipments: number, deliveredShipments: number, shipmentsNeedingSerial: number }, monthlyRevenue: Array<{ __typename: 'MonthlyRevenue', month: string, totalAmount: any, currency: string, customerCount: number, estimatedFees: any, feePercentage: any, netBalance: any, targetAmount?: any | null, percentOfTarget?: any | null, feeSource?: string | null, disputeAmount?: any | null, reconciliationPercent?: any | null, feeEnrichedPercent?: any | null, paymentDistribution: Array<{ __typename: 'PaymentBucket', amount: any, currency: string, count: number }> }>, topAcquisitionSources: Array<{ __typename: 'AcquisitionSourceStats', sourceId?: string | null, sourceName: string, partnerName?: string | null, customerCount: number, activeCustomers: number, pendingCustomers: number, isActive: boolean, revenueByCurrency: Array<{ __typename: 'AcquisitionSourceCurrencyRevenue', currency: string, totalAmount: any }> }> } };

export type MemberBySerialQueryVariables = Exact<{
  serial: Scalars['String']['input'];
}>;


export type MemberBySerialQuery = { __typename: 'Query', memberBySerial: Array<{ __typename: 'SerialMatch', serialNumber: string, members: Array<{ __typename: 'SerialMatchMember', userId: string }>, devices: Array<{ __typename: 'VnsDevice', deviceId: string, userId: string, serialNumber: string, model: string }>, preRegistration?: { __typename: 'DeviceSerialPreRegistration', customerId: string, entitlementId: string, serialNumber: string, state: PreRegistrationState, preRegisteredAt?: any | null, preRegisteredBy?: string | null } | null }> };

export type PreRegisterDeviceSerialMutationVariables = Exact<{
  input: PreRegisterDeviceSerialInput;
}>;


export type PreRegisterDeviceSerialMutation = { __typename: 'Mutation', preRegisterDeviceSerial: { __typename: 'InputAcceptedResponse', id: string } };

export type ResendActivationEmailMutationVariables = Exact<{
  entitlementId: Scalars['ID']['input'];
}>;


export type ResendActivationEmailMutation = { __typename: 'Mutation', resendActivationEmail: { __typename: 'ResendEmailResult', success: boolean, message?: string | null } };

export type LinkEntitlementToUserMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type LinkEntitlementToUserMutation = { __typename: 'Mutation', linkEntitlementToUser: { __typename: 'InputAcceptedResponse', id: string } };

export type UnlinkEntitlementFromUserMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type UnlinkEntitlementFromUserMutation = { __typename: 'Mutation', unlinkEntitlementFromUser: { __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, activatedByUserId?: string | null, provisionedAt: any, activatedAt?: any | null, subscriptionId?: string | null } };

export type UnlinkSubscriptionMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type UnlinkSubscriptionMutation = { __typename: 'Mutation', unlinkSubscription: { __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, activatedByUserId?: string | null, provisionedAt: any, activatedAt?: any | null, subscriptionId?: string | null } };

export type SuspendEntitlementMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type SuspendEntitlementMutation = { __typename: 'Mutation', suspendEntitlement: { __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, activatedByUserId?: string | null, provisionedAt: any, activatedAt?: any | null, subscriptionId?: string | null } };

export type RevokeEntitlementMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type RevokeEntitlementMutation = { __typename: 'Mutation', revokeEntitlement: { __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, activatedByUserId?: string | null, provisionedAt: any, activatedAt?: any | null, subscriptionId?: string | null } };

export type ReactivateEntitlementMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  entitlementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type ReactivateEntitlementMutation = { __typename: 'Mutation', reactivateEntitlement: { __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, activatedByUserId?: string | null, provisionedAt: any, activatedAt?: any | null, subscriptionId?: string | null } };

export type MarkEntitlementGiftMutationVariables = Exact<{
  input: MarkEntitlementGiftInput;
}>;


export type MarkEntitlementGiftMutation = { __typename: 'Mutation', markEntitlementGift: { __typename: 'Entitlement', entitlementId: string, activationCode: string, status: EntitlementStatus, activatedByUserId?: string | null, provisionedAt: any, activatedAt?: any | null, subscriptionId?: string | null, gift?: boolean | null, giftBasis?: string | null } };

export type RecordRefundReviewMutationVariables = Exact<{
  input: RecordRefundReviewInput;
}>;


export type RecordRefundReviewMutation = { __typename: 'Mutation', recordRefundReview?: { __typename: 'Customer', customerId: string, refundReviewPending: boolean, refundReviews: Array<{ __typename: 'RefundReview', entitlementId: string, decision: RefundReviewDecision, reason: string, reviewedAt: any, reviewedBy?: string | null }> } | null };

export type ExportCustomersMutationVariables = Exact<{
  columns: ExportColumnsInput;
  filter?: InputMaybe<CustomerFilter>;
  justification: Scalars['String']['input'];
}>;


export type ExportCustomersMutation = { __typename: 'Mutation', exportCustomers: { __typename: 'ExportResult', success: boolean, csv?: string | null, recordCount: number, error?: string | null } };

export type CancelMemberSubscriptionMutationVariables = Exact<{
  input: CancelMemberSubscriptionInput;
}>;


export type CancelMemberSubscriptionMutation = { __typename: 'Mutation', cancelMemberSubscription: { __typename: 'InputAcceptedResponse', id: string } };

export type ReverseMemberSubscriptionCancellationMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
}>;


export type ReverseMemberSubscriptionCancellationMutation = { __typename: 'Mutation', reverseMemberSubscriptionCancellation: { __typename: 'InputAcceptedResponse', id: string } };

export type ExtendMemberSubscriptionMutationVariables = Exact<{
  input: ExtendMemberSubscriptionInput;
}>;


export type ExtendMemberSubscriptionMutation = { __typename: 'Mutation', extendMemberSubscription: { __typename: 'ExtendMemberSubscriptionResponse', subscriptionId: string, months: number, previousPeriodEnd?: any | null, newPeriodEnd: any } };

export type GetFinancialReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialReportsQuery = { __typename: 'Query', customerDashboard: { __typename: 'CustomerDashboard', monthlyRevenue: Array<{ __typename: 'MonthlyRevenue', month: string, totalAmount: any, currency: string, customerCount: number, estimatedFees: any, feePercentage: any, netBalance: any, targetAmount?: any | null, percentOfTarget?: any | null, feeSource?: string | null, totalRefunded?: any | null, refundCount?: number | null, disputeCount?: number | null, disputeAmount?: any | null, reconciliationPercent?: any | null, feeEnrichedPercent?: any | null }> } };

export type ServiceCaseFieldsFragment = { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null };

export type GetOpenServiceCasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpenServiceCasesQuery = { __typename: 'Query', openServiceCases: Array<{ __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null }> };

export type GetServiceCasesByStatusQueryVariables = Exact<{
  status: ServiceCaseStatus;
}>;


export type GetServiceCasesByStatusQuery = { __typename: 'Query', serviceCasesByStatus: Array<{ __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null }> };

export type GetServiceCasesByIssueTypeQueryVariables = Exact<{
  issueType: IssueType;
}>;


export type GetServiceCasesByIssueTypeQuery = { __typename: 'Query', serviceCasesByIssueType: Array<{ __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null }> };

export type GetServiceCaseQueryVariables = Exact<{
  serviceCaseId: Scalars['ID']['input'];
}>;


export type GetServiceCaseQuery = { __typename: 'Query', serviceCase?: { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null } | null };

export type GetCustomerServiceCasesQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerServiceCasesQuery = { __typename: 'Query', serviceCases: Array<{ __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null }> };

export type GetAllServiceCasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllServiceCasesQuery = { __typename: 'Query', allServiceCases: Array<{ __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null }> };

export type OpenServiceCaseMutationVariables = Exact<{
  input: OpenServiceCaseInput;
}>;


export type OpenServiceCaseMutation = { __typename: 'Mutation', openServiceCase?: { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null } | null };

export type SetServiceCaseResolutionMutationVariables = Exact<{
  input: SetResolutionInput;
}>;


export type SetServiceCaseResolutionMutation = { __typename: 'Mutation', setResolution?: { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null } | null };

export type InitiateReturnMutationVariables = Exact<{
  input: InitiateReturnInput;
}>;


export type InitiateReturnMutation = { __typename: 'Mutation', initiateReturn?: { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null } | null };

export type MarkReturnShippedMutationVariables = Exact<{
  input: MarkReturnShippedInput;
}>;


export type MarkReturnShippedMutation = { __typename: 'Mutation', markReturnShipped?: { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null } | null };

export type MarkReturnReceivedMutationVariables = Exact<{
  input: MarkReturnReceivedInput;
}>;


export type MarkReturnReceivedMutation = { __typename: 'Mutation', markReturnReceived?: { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null } | null };

export type LinkReplacementShipmentMutationVariables = Exact<{
  input: LinkReplacementShipmentInput;
}>;


export type LinkReplacementShipmentMutation = { __typename: 'Mutation', linkReplacementShipment?: { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null } | null };

export type ResolveServiceCaseMutationVariables = Exact<{
  input: ResolveServiceCaseInput;
}>;


export type ResolveServiceCaseMutation = { __typename: 'Mutation', resolveServiceCase?: { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null } | null };

export type CancelServiceCaseMutationVariables = Exact<{
  input: CancelServiceCaseInput;
}>;


export type CancelServiceCaseMutation = { __typename: 'Mutation', cancelServiceCase?: { __typename: 'ServiceCase', serviceCaseId: string, customerId: string, shipmentId: string, deviceSerial?: string | null, issueType: IssueType, reason: ServiceCaseReason, reasonDetail?: string | null, status: ServiceCaseStatus, resolutionAction?: ResolutionAction | null, resolutionNote?: string | null, replacementShipmentId?: string | null, returnTrackingNumber?: string | null, returnCarrier?: string | null, openedAt: any, resolvedAt?: any | null, cancelledAt?: any | null, performedBy: string, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null, replacementShipment?: { __typename: 'Shipment', shipmentId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null } | null } | null };

export type ShipmentFieldsFragment = { __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> };

export type GetPendingShipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingShipmentsQuery = { __typename: 'Query', pendingShipments: Array<{ __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> }> };

export type GetShipmentsQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetShipmentsQuery = { __typename: 'Query', shipments: Array<{ __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> }> };

export type GetShipmentQueryVariables = Exact<{
  shipmentId: Scalars['ID']['input'];
}>;


export type GetShipmentQuery = { __typename: 'Query', shipment?: { __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> } | null };

export type GetShipmentsByStatusQueryVariables = Exact<{
  status?: InputMaybe<ShipmentStatus>;
}>;


export type GetShipmentsByStatusQuery = { __typename: 'Query', shipmentsByStatus: Array<{ __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> }> };

export type CreateShipmentMutationVariables = Exact<{
  cmd: CreateShipmentInput;
}>;


export type CreateShipmentMutation = { __typename: 'Mutation', createShipment?: { __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> } | null };

export type MarkShipmentShippedMutationVariables = Exact<{
  cmd: MarkShipmentShippedInput;
}>;


export type MarkShipmentShippedMutation = { __typename: 'Mutation', markShipmentShipped?: { __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> } | null };

export type MarkShipmentDeliveredMutationVariables = Exact<{
  shipmentId: Scalars['ID']['input'];
}>;


export type MarkShipmentDeliveredMutation = { __typename: 'Mutation', markShipmentDelivered?: { __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> } | null };

export type MarkShipmentReturnedMutationVariables = Exact<{
  shipmentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarkShipmentReturnedMutation = { __typename: 'Mutation', markShipmentReturned?: { __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> } | null };

export type UpdateShipmentTrackingMutationVariables = Exact<{
  cmd: UpdateShipmentTrackingInput;
}>;


export type UpdateShipmentTrackingMutation = { __typename: 'Mutation', updateShipmentTracking?: { __typename: 'Shipment', shipmentId: string, customerId: string, status: ShipmentStatus, trackingNumber?: string | null, carrier?: string | null, origin?: ShipmentOrigin | null, createdAt: any, shippedAt?: any | null, deliveredAt?: any | null, returnedAt?: any | null, customer?: { __typename: 'Customer', customerId: string, email?: string | null } | null, shippingAddress?: { __typename: 'ShipmentAddress', name?: string | null, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country: string } | null, items: Array<{ __typename: 'ShipmentItem', shipmentItemId: string, entitlementId: string, productType: ProductType, deviceSerial?: string | null }> } | null };

export type GetChatInboxQueryVariables = Exact<{
  input?: InputMaybe<ChatInboxInput>;
}>;


export type GetChatInboxQuery = { __typename: 'Query', chatInbox: { __typename: 'ChatInbox', totalCount: number, items: Array<{ __typename: 'ChatInboxItem', channelId: string, participantId: string, lastMessagePreview?: string | null, lastMessageAt?: any | null, status: ChatInboxStatus, unreadCount: number, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null }> } };

export type GetRecentMessagesQueryVariables = Exact<{
  dateRange: DateRangeInput;
}>;


export type GetRecentMessagesQuery = { __typename: 'Query', recentMessages: Array<{ __typename: 'ChatLog', id: string, receivedAt: any, userId: string, channelId: string, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null }> };

export type GetInteractionTimelineQueryVariables = Exact<{
  filter: InteractionTimelineFilter;
}>;


export type GetInteractionTimelineQuery = { __typename: 'Query', interactionTimeline: { __typename: 'InteractionTimeline', interactions: Array<{ __typename: 'Interaction', actorId: string, targetId?: string | null, timestamp: any, interaction: string, icon?: string | null, importance: InteractionImportance, actor: { __typename: 'Actor', userId: string, displayName: string } }> } };

export type GetDashboardChatAnalyticsQueryVariables = Exact<{
  dateRange: DateRangeInput;
}>;


export type GetDashboardChatAnalyticsQuery = { __typename: 'Query', chatInbound: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, chatOutbound: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, chatResponseRate: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null } };

export type GetCohortAnalysisQueryVariables = Exact<{
  maxDays: Scalars['Int']['input'];
  baselineDays?: InputMaybe<Scalars['Int']['input']>;
  minBaselineMeasurements?: InputMaybe<Scalars['Int']['input']>;
  maxMeasurementGapDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCohortAnalysisQuery = { __typename: 'Query', hrvCohort: { __typename: 'CohortAnalysis', metric: string, unit: string, baselineValue?: number | null, dataPoints: Array<{ __typename: 'CohortAnalysisDataPoint', daysSinceStart: number, percentageChange?: number | null, absoluteChange?: number | null, actualValue?: number | null, baselineValue?: number | null, cohortCount: number, userCount: number }>, auc?: { __typename: 'CohortAuc', positiveAuc: number, negativeAuc: number, netAuc: number } | null }, rmssdCohort: { __typename: 'CohortAnalysis', metric: string, unit: string, baselineValue?: number | null, dataPoints: Array<{ __typename: 'CohortAnalysisDataPoint', daysSinceStart: number, percentageChange?: number | null, absoluteChange?: number | null, actualValue?: number | null, baselineValue?: number | null, cohortCount: number, userCount: number }>, auc?: { __typename: 'CohortAuc', positiveAuc: number, negativeAuc: number, netAuc: number } | null }, stressCohort: { __typename: 'CohortAnalysis', metric: string, unit: string, baselineValue?: number | null, dataPoints: Array<{ __typename: 'CohortAnalysisDataPoint', daysSinceStart: number, percentageChange?: number | null, absoluteChange?: number | null, actualValue?: number | null, baselineValue?: number | null, cohortCount: number, userCount: number }>, auc?: { __typename: 'CohortAuc', positiveAuc: number, negativeAuc: number, netAuc: number } | null }, parasympatheticCohort: { __typename: 'CohortAnalysis', metric: string, unit: string, baselineValue?: number | null, dataPoints: Array<{ __typename: 'CohortAnalysisDataPoint', daysSinceStart: number, percentageChange?: number | null, absoluteChange?: number | null, actualValue?: number | null, baselineValue?: number | null, cohortCount: number, userCount: number }>, auc?: { __typename: 'CohortAuc', positiveAuc: number, negativeAuc: number, netAuc: number } | null }, breathingRateCohort: { __typename: 'CohortAnalysis', metric: string, unit: string, baselineValue?: number | null, dataPoints: Array<{ __typename: 'CohortAnalysisDataPoint', daysSinceStart: number, percentageChange?: number | null, absoluteChange?: number | null, actualValue?: number | null, baselineValue?: number | null, cohortCount: number, userCount: number }>, auc?: { __typename: 'CohortAuc', positiveAuc: number, negativeAuc: number, netAuc: number } | null } };

export type GetCohortAnalysisByCompositeSegmentQueryVariables = Exact<{
  metricName: Scalars['String']['input'];
  maxDays: Scalars['Int']['input'];
  baselineDays?: InputMaybe<Scalars['Int']['input']>;
  minBaselineMeasurements?: InputMaybe<Scalars['Int']['input']>;
  maxMeasurementGapDays?: InputMaybe<Scalars['Int']['input']>;
  dimensions: Array<SegmentDimension> | SegmentDimension;
}>;


export type GetCohortAnalysisByCompositeSegmentQuery = { __typename: 'Query', cohortAnalysisByCompositeSegment: { __typename: 'CohortAnalysisByCompositeSegment', metric: string, unit: string, baselineValue?: number | null, dimensions: Array<SegmentDimension>, segments: Array<{ __typename: 'CompositeSegmentCohort', segmentKey: string, segmentLabel: string, userCount: number, dataPoints: Array<{ __typename: 'CohortAnalysisDataPoint', daysSinceStart: number, percentageChange?: number | null, absoluteChange?: number | null, actualValue?: number | null, baselineValue?: number | null, cohortCount: number, userCount: number }>, auc?: { __typename: 'CohortAuc', positiveAuc: number, negativeAuc: number, netAuc: number } | null }> } };

export type MonthlyKpiPointFieldsFragment = { __typename: 'MonthlyKpiPoint', month: string, value?: number | null, valueDecimal?: any | null };

export type GetCompanyKpisQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyKpisQuery = { __typename: 'Query', companyKpis: { __typename: 'CompanyKpis', members: { __typename: 'CompanyKpiMemberMetrics', totalMembersLifetime: number, newSignupsMonthToDate: number, newSignupsLastFullMonth: number, newSignupsPriorMonth: number, payingMembersCurrent: number, payingMembersLastFullMonth: number, payingMembersPriorMonth: number, churnMonthToDate: number, churnLastFullMonth: number, churnPriorMonth: number, newSignupsHistory: Array<{ __typename: 'MonthlyKpiPoint', month: string, value?: number | null, valueDecimal?: any | null }>, payingMembersHistory: Array<{ __typename: 'MonthlyKpiPoint', month: string, value?: number | null, valueDecimal?: any | null }>, churnHistory: Array<{ __typename: 'MonthlyKpiPoint', month: string, value?: number | null, valueDecimal?: any | null }> }, sessions: { __typename: 'CompanyKpiSessionMetrics', sessionsCompletedLifetime: number, sessionsCompletedMonthToDate: number, sessionsCompletedLastFullMonth: number, sessionsCompletedPriorMonth: number, percentStartedVnsCurrent: any, percentStartedVnsLastFullMonth: any, percentStartedVnsPriorMonth: any, sessionsCompletedHistory: Array<{ __typename: 'MonthlyKpiPoint', month: string, value?: number | null, valueDecimal?: any | null }>, percentStartedVnsHistory: Array<{ __typename: 'MonthlyKpiPoint', month: string, value?: number | null, valueDecimal?: any | null }> }, revenue: { __typename: 'CompanyKpiRevenueMetrics', currency: string, revenueUnavailable: boolean, revenueUnavailableReason?: string | null, headlineCoversAllRevenue: boolean, grossLifetime: any, grossMonthToDate: any, grossLastFullMonth: any, grossPriorMonth: any, netLifetime: any, netMonthToDate: any, netLastFullMonth: any, netPriorMonth: any, byCurrency: Array<{ __typename: 'CompanyKpiCurrencyRevenue', currency: string, grossLifetime: any, grossMonthToDate: any, grossLastFullMonth: any, netLifetime: any, netMonthToDate: any, netLastFullMonth: any }>, grossHistory: Array<{ __typename: 'MonthlyKpiPoint', month: string, value?: number | null, valueDecimal?: any | null }>, netHistory: Array<{ __typename: 'MonthlyKpiPoint', month: string, value?: number | null, valueDecimal?: any | null }> }, engagement: { __typename: 'CompanyKpiEngagementMetrics', activeLast7DaysCurrent: number, activeLast7DaysLastFullMonth: number, activeLast7DaysPriorMonth: number, activeLast7DaysHistory: Array<{ __typename: 'MonthlyKpiPoint', month: string, value?: number | null, valueDecimal?: any | null }> }, definitions: Array<{ __typename: 'KpiDefinition', metric: KpiMetric, summary: string, detail: string, sourceOfTruth: string, lastReviewedAt?: any | null }> } };

export type GetContentAnalyticsQueryVariables = Exact<{
  input: ContentAnalyticsInput;
}>;


export type GetContentAnalyticsQuery = { __typename: 'Query', contentAnalytics: { __typename: 'ContentAnalytics', totalCompletions: number, uniqueUsers: number, averageTimeSpentSeconds: number, completionsByType: Array<{ __typename: 'ContentTypeStats', contentType: string, completions: number, uniqueUsers: number, averageTimeSpentSeconds: number }>, topContent: Array<{ __typename: 'ContentStats', contentType: string, completions: number, uniqueUsers: number, averageTimeSpentSeconds: number, contentReference: { __typename: 'CustomActivityId', hydratedContent?: { __typename: 'ActivityVideo', title: string } | { __typename: 'Article', title: string } | { __typename: 'ArticleTeaser' } | { __typename: 'CustomActivity' } | { __typename: 'DojoArticle' } | { __typename: 'DojoChecklist' } | { __typename: 'DojoNugget' } | { __typename: 'DojoQuiz' } | { __typename: 'DojoQuote' } | { __typename: 'JourneyVideo', title: string } | { __typename: 'Lesson', title: string } | { __typename: 'MobileWidget' } | { __typename: 'Story', title: string } | { __typename: 'StoryTeaser' } | { __typename: 'VideoTeaser' } | null } | { __typename: 'ExternalContentId', reference: string, hydratedContent?: { __typename: 'ActivityVideo', title: string } | { __typename: 'Article', title: string } | { __typename: 'ArticleTeaser' } | { __typename: 'CustomActivity' } | { __typename: 'DojoArticle' } | { __typename: 'DojoChecklist' } | { __typename: 'DojoNugget' } | { __typename: 'DojoQuiz' } | { __typename: 'DojoQuote' } | { __typename: 'JourneyVideo', title: string } | { __typename: 'Lesson', title: string } | { __typename: 'MobileWidget' } | { __typename: 'Story', title: string } | { __typename: 'StoryTeaser' } | { __typename: 'VideoTeaser' } | null } | { __typename: 'MobileWidgetId', hydratedContent?: { __typename: 'ActivityVideo', title: string } | { __typename: 'Article', title: string } | { __typename: 'ArticleTeaser' } | { __typename: 'CustomActivity' } | { __typename: 'DojoArticle' } | { __typename: 'DojoChecklist' } | { __typename: 'DojoNugget' } | { __typename: 'DojoQuiz' } | { __typename: 'DojoQuote' } | { __typename: 'JourneyVideo', title: string } | { __typename: 'Lesson', title: string } | { __typename: 'MobileWidget' } | { __typename: 'Story', title: string } | { __typename: 'StoryTeaser' } | { __typename: 'VideoTeaser' } | null } }>, completionsOverTime: Array<{ __typename: 'ContentTimeSeriesPoint', date: string, count: number }>, completionsBySource: Array<{ __typename: 'ContentSourceStats', source: string, completions: number, uniqueUsers: number, avgPerUser: number }>, userDiscoveryPatterns: { __typename: 'UserDiscoveryPatterns', totalUsers: number, assignedOnly: number, exploresOrganically: number, assignedOnlyPercentage: number, exploresOrganicallyPercentage: number, breakdown: Array<{ __typename: 'UserPatternStats', pattern: string, userCount: number, percentage: number }> } } };

export type RecordDataExportMutationVariables = Exact<{
  input: RecordDataExportInput;
}>;


export type RecordDataExportMutation = { __typename: 'Mutation', recordDataExport: { __typename: 'DataExportAuditResult', success: boolean, exportId?: string | null, error?: string | null } };

export type GetDashboardHealthAnalyticsQueryVariables = Exact<{
  dateRange: DateRangeInput;
}>;


export type GetDashboardHealthAnalyticsQuery = { __typename: 'Query', avgHrv: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, avgParasympathetic: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, avgStress: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, avgBreathingRate: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, vnsCompletionRate: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, vnsTherapyTime: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, vnsImpactHrv: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, vnsImpactParasympathetic: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, vnsImpactStress: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, avgLnrmssd: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, vnsImpactLnrmssd: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, vitalsRecorded: { __typename: 'QuickStat', value: number, unit?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null } };

export type GetHealthAnalyticsTimeSeriesQueryVariables = Exact<{
  dateRange: DateRangeInput;
  granularity: TimeSeriesGranularity;
  genders?: InputMaybe<Array<Gender> | Gender>;
  ageBrackets?: InputMaybe<Array<AgeBracket> | AgeBracket>;
  rmssdGroups?: InputMaybe<Array<RmssdGroup> | RmssdGroup>;
  timeBlocks?: InputMaybe<Array<TimeBlock> | TimeBlock>;
}>;


export type GetHealthAnalyticsTimeSeriesQuery = { __typename: 'Query', hrvTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, hrvTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, hrvTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, lnrmssdTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, lnrmssdTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, lnrmssdTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, parasympatheticTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, parasympatheticTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, parasympatheticTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, stressTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, stressTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, stressTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, breathingRateTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, breathingRateTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, breathingRateTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsCompletionRateTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null, rawVnsSessions?: Array<{ __typename: 'RawVnsSession', userId: string, vnsSessionId: string, startTime: any, endTime: any, durationMinutes: number, status: string, timeBlock?: TimeBlock | null, deviceInfo?: string | null, hasPreVitals: boolean, hasPostVitals: boolean }> | null }> }, vnsCompletionRateTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null, rawVnsSessions?: Array<{ __typename: 'RawVnsSession', userId: string, vnsSessionId: string, startTime: any, endTime: any, durationMinutes: number, status: string, timeBlock?: TimeBlock | null, deviceInfo?: string | null, hasPreVitals: boolean, hasPostVitals: boolean }> | null }> }, vnsCompletionRateTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null, rawVnsSessions?: Array<{ __typename: 'RawVnsSession', userId: string, vnsSessionId: string, startTime: any, endTime: any, durationMinutes: number, status: string, timeBlock?: TimeBlock | null, deviceInfo?: string | null, hasPreVitals: boolean, hasPostVitals: boolean }> | null }> }, vnsTherapyTimeTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null, rawVnsSessions?: Array<{ __typename: 'RawVnsSession', userId: string, vnsSessionId: string, startTime: any, endTime: any, durationMinutes: number, status: string, timeBlock?: TimeBlock | null, deviceInfo?: string | null, hasPreVitals: boolean, hasPostVitals: boolean }> | null }> }, vnsTherapyTimeTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null, rawVnsSessions?: Array<{ __typename: 'RawVnsSession', userId: string, vnsSessionId: string, startTime: any, endTime: any, durationMinutes: number, status: string, timeBlock?: TimeBlock | null, deviceInfo?: string | null, hasPreVitals: boolean, hasPostVitals: boolean }> | null }> }, vnsTherapyTimeTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null, rawVnsSessions?: Array<{ __typename: 'RawVnsSession', userId: string, vnsSessionId: string, startTime: any, endTime: any, durationMinutes: number, status: string, timeBlock?: TimeBlock | null, deviceInfo?: string | null, hasPreVitals: boolean, hasPostVitals: boolean }> | null }> }, vnsImpactHrvTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactHrvTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactHrvTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactLnrmssdTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactLnrmssdTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactLnrmssdTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactParasympatheticTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactParasympatheticTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactParasympatheticTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactStressTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactStressTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vnsImpactStressTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vitalsRecordedTimeSeries: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vitalsRecordedTimeSeriesNew: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> }, vitalsRecordedTimeSeriesExperienced: { __typename: 'QuickStatTimeSeries', unit?: string | null, aggregationStrategy?: AggregationStrategy | null, dataPoints: Array<{ __typename: 'QuickStatDataPoint', date: string, value?: number | null, count?: number | null, rawData?: Array<{ __typename: 'RawVitalMeasurement', userId: string, type: VitalType, value: number, unit: MeasurementUnit, recordedAt: any, timeBlock?: TimeBlock | null, source?: MetricSource | null }> | null }> } };

export type GetParticipantSleepMetricsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  dateRange: DateRangeInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetParticipantSleepMetricsQuery = { __typename: 'Query', userSleepMetrics: Array<{ __typename: 'UserSleepMetric', userId: string, sleepDate: string, provider: string, totalSleepMinutes: number, deepSleepMinutes?: number | null, lightSleepMinutes?: number | null, remSleepMinutes?: number | null, awakeMinutes?: number | null, sleepEfficiencyPercent?: number | null, hrvRmssd?: number | null, hrvSdnn?: number | null, hrvSdnnMean?: number | null, sdnnSampleCount?: number | null, restingHeartRate?: number | null, breathingRate?: number | null, sleepInterruptions?: number | null }> };

export type GetParticipantSleepTrendQueryVariables = Exact<{
  dateRange: DateRangeInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetParticipantSleepTrendQuery = { __typename: 'Query', sleepMetricsTrend: Array<{ __typename: 'SleepMetricDataPoint', date: string, avgSleepMinutes?: number | null, avgEfficiencyPercent?: number | null, avgHrvRmssd?: number | null, avgDeepSleepPercent?: number | null, recordCount: number }> };

export type GetRecentAppFeedbackQueryVariables = Exact<{
  dateRange: DateRangeInput;
}>;


export type GetRecentAppFeedbackQuery = { __typename: 'Query', recentAppFeedback: Array<{ __typename: 'AppFeedback', feedbackId: string, userId: string, sentiment?: AppFeedbackSentiment | null, comment?: string | null, submittedAt: any, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null } } | null }> };

export type GetSleepAnalyticsDashboardQueryVariables = Exact<{
  dateRange: DateRangeInput;
}>;


export type GetSleepAnalyticsDashboardQuery = { __typename: 'Query', vnsSleepDashboard: { __typename: 'VnsSleepDashboard', summary: { __typename: 'VnsSleepSummary', totalSessions: number, sessionsWithSleepData: number, avgSleepImprovement?: number | null, avgHrvImprovement?: number | null, avgEfficiencyImprovement?: number | null, bestTimeBlock?: string | null }, timeBlockAnalysis: Array<{ __typename: 'TimeBlockStats', timeBlock: string, sessionCount: number, avgSleepImprovement?: number | null, avgHrvImprovement?: number | null }>, recentCorrelations: Array<{ __typename: 'VnsSleepCorrelation', sessionId: string, userId: string, sessionDate: string, timeBlock?: TimeBlock | null, hrvDelta?: number | null, parasympatheticDelta?: number | null, sameNightSleepMinutes?: number | null, sameNightEfficiency?: number | null, sleepVsBaseline?: number | null }> } };

export type GetUserSleepCorrelationsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  dateRange: DateRangeInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserSleepCorrelationsQuery = { __typename: 'Query', vnsSleepCorrelations: Array<{ __typename: 'VnsSleepCorrelation', sessionId: string, userId: string, sessionDate: string, timeBlock?: TimeBlock | null, vnsMode?: string | null, hrvDelta?: number | null, parasympatheticDelta?: number | null, stressDelta?: number | null, sameNightSleepMinutes?: number | null, sameNightEfficiency?: number | null, sameNightDeepPercent?: number | null, nextDaySleepMinutes?: number | null, nextDayEfficiency?: number | null, sleepVsBaseline?: number | null, hrvVsBaseline?: number | null }> };

export type GetSleepCorrelationStatsQueryVariables = Exact<{
  participantId?: InputMaybe<Scalars['ID']['input']>;
  dateRange: DateRangeInput;
}>;


export type GetSleepCorrelationStatsQuery = { __typename: 'Query', vnsSleepCorrelationStats?: { __typename: 'CorrelationResult', correlationCoefficient: number, strength: CorrelationStrength, sampleSize: number, pValue?: number | null } | null };

export type GetSleepCohortAnalysisQueryVariables = Exact<{
  filter: SleepCohortFilter;
}>;


export type GetSleepCohortAnalysisQuery = { __typename: 'Query', sleepCohortAnalysis: { __typename: 'CohortAnalysis', metric: string, unit: string, baselineValue?: number | null, dataPoints: Array<{ __typename: 'CohortAnalysisDataPoint', daysSinceStart: number, percentageChange?: number | null, absoluteChange?: number | null, actualValue?: number | null, baselineValue?: number | null, cohortCount: number, userCount: number }>, auc?: { __typename: 'CohortAuc', positiveAuc: number, negativeAuc: number, netAuc: number } | null } };

export type GetSleepProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSleepProvidersQuery = { __typename: 'Query', sleepProviders: Array<string> };

export type GetSleepDoseResponseQueryVariables = Exact<{
  dateRange: DateRangeInput;
  provider?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSleepDoseResponseQuery = { __typename: 'Query', sleepDoseResponse: { __typename: 'SleepDoseResponse', lowFrequency: { __typename: 'SleepDoseResponseGroup', label: string, userCount: number, avgSleepImprovement?: number | null, avgEfficiencyImprovement?: number | null, avgHrvImprovement?: number | null }, mediumFrequency: { __typename: 'SleepDoseResponseGroup', label: string, userCount: number, avgSleepImprovement?: number | null, avgEfficiencyImprovement?: number | null, avgHrvImprovement?: number | null }, highFrequency: { __typename: 'SleepDoseResponseGroup', label: string, userCount: number, avgSleepImprovement?: number | null, avgEfficiencyImprovement?: number | null, avgHrvImprovement?: number | null } } };

export type GetSleepNightOfAnalysisQueryVariables = Exact<{
  dateRange: DateRangeInput;
  provider?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSleepNightOfAnalysisQuery = { __typename: 'Query', sleepNightOfAnalysis: { __typename: 'SleepNightOfAnalysis', userCount: number, vnsNights: { __typename: 'SleepNightMetrics', avgSleepMinutes?: number | null, avgEfficiency?: number | null, avgHrvRmssd?: number | null, avgDeepSleepPercent?: number | null, nightCount: number }, nonVnsNights: { __typename: 'SleepNightMetrics', avgSleepMinutes?: number | null, avgEfficiency?: number | null, avgHrvRmssd?: number | null, avgDeepSleepPercent?: number | null, nightCount: number } } };

export type GetSleepMetricsSummaryQueryVariables = Exact<{
  dateRange: DateRangeInput;
}>;


export type GetSleepMetricsSummaryQuery = { __typename: 'Query', sleepMetricsSummary: { __typename: 'SleepMetricsSummary', totalUsersWithSleepData: number, avgSleepMinutes: number, avgEfficiencyPercent?: number | null, avgHrvRmssd?: number | null, avgDeepSleepPercent?: number | null, avgRemSleepPercent?: number | null, totalSleepRecords: number } };

export type GetSleepMetricsTrendQueryVariables = Exact<{
  dateRange: DateRangeInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSleepMetricsTrendQuery = { __typename: 'Query', sleepMetricsTrend: Array<{ __typename: 'SleepMetricDataPoint', date: string, avgSleepMinutes?: number | null, avgEfficiencyPercent?: number | null, avgHrvRmssd?: number | null, avgDeepSleepPercent?: number | null, recordCount: number }> };

export type GetSleepProviderStatsQueryVariables = Exact<{
  dateRange: DateRangeInput;
}>;


export type GetSleepProviderStatsQuery = { __typename: 'Query', sleepProviderStats: Array<{ __typename: 'ProviderStats', provider: string, userCount: number, recordCount: number }> };

export type GetVnsSessionAnalyticsQueryVariables = Exact<{
  input: VnsSessionAnalyticsInput;
}>;


export type GetVnsSessionAnalyticsQuery = { __typename: 'Query', vnsSessionAnalytics: { __typename: 'VnsSessionAnalytics', totalSessions: number, avgDurationMinutes?: number | null, avgHrvDelta?: number | null, completionRate?: number | null, sessionsWithVitals: number, avgSessionsPerActiveDay?: number | null, modeEffectivenessByMode: Array<{ __typename: 'ModeEffectivenessByModeEntry', modeId?: string | null, modeDisplayName?: string | null, deviceKind?: VnsDeviceKind | null, legacyMode?: VnsMode | null, avgHrvDelta?: number | null, avgParasympatheticDelta?: number | null, avgStressDelta?: number | null, sampleSize: number }>, intensityBands: Array<{ __typename: 'IntensityBandEntry', band: string, minIntensity: number, maxIntensity: number, avgHrvDelta?: number | null, sampleSize: number }> } };

export type GetVnsSessionExportQueryVariables = Exact<{
  input: VnsSessionExportInput;
}>;


export type GetVnsSessionExportQuery = { __typename: 'Query', vnsSessionExport: { __typename: 'VnsSessionExportResult', totalCount: number, hasMore: boolean, sessions: Array<{ __typename: 'VnsSessionExportEntry', sessionId: string, userId: string, userName?: string | null, startTime: any, endTime?: any | null, durationMinutes?: number | null, status?: VnsSessionStatus | null, mode?: VnsMode | null, intensity?: number | null, avgIntensity?: number | null, isManual: boolean, timeBlock?: TimeBlock | null, deviceInfo?: string | null, preHrvSdnn?: number | null, preParasympathetic?: number | null, preStressIndex?: number | null, postHrvSdnn?: number | null, postParasympathetic?: number | null, postStressIndex?: number | null, hrvDelta?: number | null, parasympatheticDelta?: number | null, stressDelta?: number | null, modeId?: string | null, modeDisplayName?: string | null, modeSetVersion?: number | null, startedBy?: VnsSessionInitiator | null, slotByte?: number | null, deviceKind?: VnsDeviceKind | null, phases: Array<{ __typename: 'VnsSessionExportPhase', startTime: any, endTime: any, durationMinutes: number, mode?: VnsMode | null, intensity?: number | null, source: VnsSource }> }> } };

export type GetWidgetAnalyticsQueryVariables = Exact<{
  input: WidgetAnalyticsInput;
}>;


export type GetWidgetAnalyticsQuery = { __typename: 'Query', widgetAnalytics: { __typename: 'WidgetAnalytics', totalCompletions: number, uniqueUsers: number, averageTimeSpentSeconds: number, completionsByType: Array<{ __typename: 'WidgetTypeStats', widgetKind: string, displayName: string, completions: number, uniqueUsers: number, averageTimeSpentSeconds: number }>, topUsers: Array<{ __typename: 'WidgetUserStats', userId: string, displayName?: string | null, totalCompletions: number, completionsByType: Array<{ __typename: 'WidgetTypeCount', widgetKind: string, count: number }> }> } };

export type ExampleQueryVariables = Exact<{ [key: string]: never; }>;


export type ExampleQuery = { __typename: 'Query', me: { __typename: 'Nurse', nurseId: string, timezone?: string | null } | { __typename: 'Participant', participantId: string, timezone?: string | null } };

export type HabituationCohortQueryVariables = Exact<{
  window: HabituationWindow;
}>;


export type HabituationCohortQuery = { __typename: 'Query', habituationCohort: { __typename: 'HabituationCohort', thresholdsVersion: string, medianPlateauToDriftWeeks?: number | null, medianDriftToBaselineWeeks?: number | null, notEvaluableInsufficientBaseline: number, notEvaluableNoPlateau: number, stateCounts: Array<{ __typename: 'HabituationStateCount', state: HabituationState, count: number }>, quadrant: Array<{ __typename: 'HabituationQuadrantPoint', useRatio: number, responseDelta: number, state: HabituationState }>, trajectories: Array<{ __typename: 'HabituationTrajectory', points: Array<{ __typename: 'HabituationTrajectoryPoint', weekSincePlateau: number, ariMinusP: number }> }> } };

export type HabituationMembersQueryVariables = Exact<{
  state?: InputMaybe<HabituationState>;
}>;


export type HabituationMembersQuery = { __typename: 'Query', habituationMembers: Array<{ __typename: 'HabituationMemberSummary', memberId: string, state: HabituationState, since?: string | null, plateauLevel?: number | null, currentMean14?: number | null, depth?: number | null, useRatio?: number | null, thresholdsVersion: string }> };

export type HabituationMemberQueryVariables = Exact<{
  memberId: Scalars['ID']['input'];
}>;


export type HabituationMemberQuery = { __typename: 'Query', habituationMember?: { __typename: 'HabituationMemberDetail', memberId: string, state: HabituationState, thresholdsVersion: string, tally: Array<number>, baseline: { __typename: 'HabituationBaseline', readingCount: number, sufficient: boolean, metrics: Array<{ __typename: 'HabituationMetricBaseline', metric: string, median: number, mad: number, presentCount: number }> }, plateau?: { __typename: 'HabituationPlateau', level: number, weekIndex: number } | null, episodes: Array<{ __typename: 'HabituationEpisode', kind: string, startWeek: number, endWeek: number, depth: number, durationWeeks: number }>, weeks: Array<{ __typename: 'HabituationWeeklyRow', weekIndex: number, weekStartDate?: string | null, ari?: number | null, mean14?: number | null, sessions: number, readings: number, f8Pass: boolean, meanIntensity?: number | null, state: HabituationState }>, overnight: Array<{ __typename: 'HabituationOvernightWeek', weekStart?: string | null, medianRmssd?: number | null, provider?: string | null }> } | null };

export type UserLearningProgressQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserLearningProgressQuery = { __typename: 'Query', userLearningJourneys: Array<{ __typename: 'LearningJourney', learningJourneyId: string, name: string, description?: string | null, progress: number, completedPaths: number, totalPaths: number, steps: Array<{ __typename: 'LearningJourneyStep', order: number, unlockStrategy: UnlockStrategy, unlockStatus: { __typename: 'UnlockStatus', unlocked: boolean, reason?: string | null }, learningPath: { __typename: 'LearningPath', learningPathId: string, name: string, description?: string | null, contentItems?: Array<{ __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }> | null, completedContentItems?: Array<{ __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }> | null } }> }> };

export type RegisterLoginMutationVariables = Exact<{
  timezone: Scalars['String']['input'];
}>;


export type RegisterLoginMutation = { __typename: 'Mutation', registerLogin?: { __typename: 'InputAcceptedResponse', id: string } | null };

export type RegisterFcmTokenMutationVariables = Exact<{
  input: AddNotificationTokenCommand;
}>;


export type RegisterFcmTokenMutation = { __typename: 'Mutation', addNotificationToken: { __typename: 'InputAcceptedResponse', id: string } };

export type GetNewsletterSignalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsletterSignalsQuery = { __typename: 'Query', newsletterSignals: Array<{ __typename: 'NewsletterSignal', email: string, name?: string | null, country?: string | null, consent: boolean, source?: string | null, createdAt?: any | null }> };

export type SendPushNotificationMutationVariables = Exact<{
  input: SendPushNotificationCommand;
}>;


export type SendPushNotificationMutation = { __typename: 'Mutation', sendPushNotification: { __typename: 'InputAcceptedResponse', id: string } };

export type GetScheduledNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScheduledNotificationsQuery = { __typename: 'Query', scheduledNotifications: Array<{ __typename: 'ScheduledNotification', id: string, userId: string, scheduledTime: any, status: ScheduledNotificationStatus }> };

export type ParticipantNoteFieldsFragment = { __typename: 'ParticipantNote', noteId: string, participantId: string, authorId: string, content: string, categories: Array<NoteCategory>, status: NoteStatus, flagStatus: FlagStatus, flagReason?: string | null, linkedToMessageId?: string | null, linkedConsultNumber?: number | null, createdAt: any, updatedAt: any };

export type GetParticipantNotesQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  status?: InputMaybe<NoteStatus>;
}>;


export type GetParticipantNotesQuery = { __typename: 'Query', participantNotes: Array<{ __typename: 'ParticipantNote', noteId: string, participantId: string, authorId: string, content: string, categories: Array<NoteCategory>, status: NoteStatus, flagStatus: FlagStatus, flagReason?: string | null, linkedToMessageId?: string | null, linkedConsultNumber?: number | null, createdAt: any, updatedAt: any }> };

export type GetParticipantNoteQueryVariables = Exact<{
  noteId: Scalars['ID']['input'];
}>;


export type GetParticipantNoteQuery = { __typename: 'Query', participantNote?: { __typename: 'ParticipantNote', noteId: string, participantId: string, authorId: string, content: string, categories: Array<NoteCategory>, status: NoteStatus, flagStatus: FlagStatus, flagReason?: string | null, linkedToMessageId?: string | null, linkedConsultNumber?: number | null, createdAt: any, updatedAt: any } | null };

export type AddParticipantNoteMutationVariables = Exact<{
  input: AddParticipantNoteInput;
}>;


export type AddParticipantNoteMutation = { __typename: 'Mutation', addParticipantNote: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateParticipantNoteMutationVariables = Exact<{
  input: UpdateParticipantNoteInput;
}>;


export type UpdateParticipantNoteMutation = { __typename: 'Mutation', updateParticipantNote: { __typename: 'InputAcceptedResponse', id: string } };

export type ArchiveParticipantNoteMutationVariables = Exact<{
  input: ArchiveParticipantNoteInput;
}>;


export type ArchiveParticipantNoteMutation = { __typename: 'Mutation', archiveParticipantNote: { __typename: 'InputAcceptedResponse', id: string } };

export type ErasePartnerEnquiryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ErasePartnerEnquiryMutation = { __typename: 'Mutation', erasePartnerEnquiry: { __typename: 'PartnerEnquiryEraseResult', id: string, erasedCount: number } };

export type GetPartnerEnquiriesQueryVariables = Exact<{
  filter?: InputMaybe<PartnerEnquiryFilterInput>;
}>;


export type GetPartnerEnquiriesQuery = { __typename: 'Query', partnerEnquiries: { __typename: 'PartnerEnquiryPage', limit: number, offset: number, hasMore: boolean, enquiries: Array<{ __typename: 'PartnerEnquiry', id: string, name?: string | null, businessName?: string | null, businessType?: string | null, location?: string | null, status: string, receivedAt: any, statusChangedAt?: any | null }> } };

export type RevealPartnerEnquiryContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevealPartnerEnquiryContactMutation = { __typename: 'Mutation', revealPartnerEnquiryContact: { __typename: 'PartnerEnquiryContact', id: string, name?: string | null, businessName?: string | null, email: string, phone: string, website?: string | null, socials?: string | null } };

export type SetPartnerEnquiryStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;


export type SetPartnerEnquiryStatusMutation = { __typename: 'Mutation', setPartnerEnquiryStatus: { __typename: 'PartnerEnquiryStatusChange', id: string, status: string, previousStatus: string, changed: boolean, statusChangedAt?: any | null } };

export type GetPaymentLinksQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPaymentLinksQuery = { __typename: 'Query', paymentLinks: Array<{ __typename: 'PaymentLink', id: string, url: string, active: boolean, name?: string | null, purpose?: string | null, source: PaymentLinkSource }> };

export type GetPaymentLinkQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPaymentLinkQuery = { __typename: 'Query', paymentLink?: { __typename: 'PaymentLink', id: string, url: string, active: boolean, name?: string | null, purpose?: string | null, source: PaymentLinkSource } | null };

export type CreatePaymentLinkMutationVariables = Exact<{
  input: CreatePaymentLinkInput;
}>;


export type CreatePaymentLinkMutation = { __typename: 'Mutation', createPaymentLink: { __typename: 'PaymentLink', id: string, url: string, active: boolean, name?: string | null, purpose?: string | null, source: PaymentLinkSource } };

export type DeactivatePaymentLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivatePaymentLinkMutation = { __typename: 'Mutation', deactivatePaymentLink: boolean };

export type AdoptPaymentLinkMutationVariables = Exact<{
  input: AdoptPaymentLinkInput;
}>;


export type AdoptPaymentLinkMutation = { __typename: 'Mutation', adoptPaymentLink: { __typename: 'PaymentLink', id: string, url: string, active: boolean, name?: string | null, purpose?: string | null, source: PaymentLinkSource } };

export type UpdateUserNameMutationVariables = Exact<{
  input: UpdateUserNameInput;
}>;


export type UpdateUserNameMutation = { __typename: 'Mutation', updateUserName: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateTimezoneMutationVariables = Exact<{
  timezone: Scalars['String']['input'];
}>;


export type UpdateTimezoneMutation = { __typename: 'Mutation', updateTimezone?: { __typename: 'InputAcceptedResponse', id: string } | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename: 'Query', me: { __typename: 'Nurse', nurseId: string, timezone?: string | null, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, middleName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null, messagingToken?: { __typename: 'MessagingToken', token: string, provider: MessagingProvider } | null } | { __typename: 'Participant', participantId: string, timezone?: string | null, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, middleName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null, messagingToken?: { __typename: 'MessagingToken', token: string, provider: MessagingProvider } | null } };

export type CreateLearningJourneyMutationVariables = Exact<{
  command: CreateLearningJourneyCommand;
}>;


export type CreateLearningJourneyMutation = { __typename: 'Mutation', createLearningJourney: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateLearningJourneyMutationVariables = Exact<{
  command: UpdateLearningJourneyCommand;
}>;


export type UpdateLearningJourneyMutation = { __typename: 'Mutation', updateLearningJourney: { __typename: 'InputAcceptedResponse', id: string } };

export type BulkAssignUsersToLearningJourneyMutationVariables = Exact<{
  command: BulkAssignUsersToLearningJourneyCommand;
}>;


export type BulkAssignUsersToLearningJourneyMutation = { __typename: 'Mutation', bulkAssignUsersToLearningJourney: { __typename: 'InputAcceptedResponse', id: string } };

export type BulkUnassignUsersFromLearningJourneyMutationVariables = Exact<{
  command: BulkUnassignUsersFromLearningJourneyCommand;
}>;


export type BulkUnassignUsersFromLearningJourneyMutation = { __typename: 'Mutation', bulkUnassignUsersFromLearningJourney: { __typename: 'InputAcceptedResponse', id: string } };

export type CreateLearningPathMutationVariables = Exact<{
  command: CreateLearningPathCommand;
}>;


export type CreateLearningPathMutation = { __typename: 'Mutation', createLearningPath: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateLearningPathMutationVariables = Exact<{
  command: UpdateLearningPathCommand;
}>;


export type UpdateLearningPathMutation = { __typename: 'Mutation', updateLearningPath: { __typename: 'InputAcceptedResponse', id: string } };

export type GetLearningPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLearningPathsQuery = { __typename: 'Query', learningPaths: Array<{ __typename: 'LearningPath', learningPathId: string, name: string, description?: string | null, assignedUserCount: number, completionRate: number, averageCompletionTimeSeconds: number, journeyCount: number, createdAt: any, updatedAt?: any | null, contentItems?: Array<{ __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }> | null, contentTypeDistribution: Array<{ __typename: 'ContentTypeCount', type: string, count: number }> }> };

export type GetLearningPathQueryVariables = Exact<{
  learningPathId: Scalars['ID']['input'];
}>;


export type GetLearningPathQuery = { __typename: 'Query', learningPath?: { __typename: 'LearningPath', learningPathId: string, name: string, description?: string | null, assignedUserCount: number, completionRate: number, averageCompletionTimeSeconds: number, journeyCount: number, createdAt: any, updatedAt?: any | null, contentItems?: Array<{ __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }> | null, contentTypeDistribution: Array<{ __typename: 'ContentTypeCount', type: string, count: number }> } | null };

export type GetDojoContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDojoContentQuery = { __typename: 'Query', dojoArticles: Array<{ __typename: 'DojoArticle', id: string, title: string, protocols?: Array<Protocol> | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, media?: { __typename: 'File', url?: string | null } | { __typename: 'Image', url?: string | null } | { __typename: 'Video', url?: string | null } | { __typename: 'VideoCaption', url?: string | null } | null }>, dojoChecklists: Array<{ __typename: 'DojoChecklist', id: string, title: string, paragraph?: string | null, items: Array<string>, completionMessage: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } }>, dojoNuggets: Array<{ __typename: 'DojoNugget', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, media?: { __typename: 'File', url?: string | null } | { __typename: 'Image', url?: string | null } | { __typename: 'Video', url?: string | null } | { __typename: 'VideoCaption', url?: string | null } | null }>, dojoQuizzes: Array<{ __typename: 'DojoQuiz', id: string, title: string, question: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, options: Array<{ __typename: 'DojoQuizAnswerOption', text: string, isCorrect: boolean, title?: string | null, name?: string | null }> }>, dojoQuotes: Array<{ __typename: 'DojoQuote', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, media?: { __typename: 'File', url?: string | null } | { __typename: 'Image', url?: string | null } | { __typename: 'Video', url?: string | null } | { __typename: 'VideoCaption', url?: string | null } | null }>, storyTeasers: Array<{ __typename: 'StoryTeaser', id: string, title: string, ctaButtonLabel?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, media?: { __typename: 'File', url?: string | null } | { __typename: 'Image', url?: string | null } | { __typename: 'Video', url?: string | null } | { __typename: 'VideoCaption', url?: string | null } | null }>, videoTeasers: Array<{ __typename: 'VideoTeaser', id: string, title: string, ctaButtonLabel?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, media?: { __typename: 'File', url?: string | null } | { __typename: 'Image', url?: string | null } | { __typename: 'Video', url?: string | null } | { __typename: 'VideoCaption', url?: string | null } | null }>, articleTeasers: Array<{ __typename: 'ArticleTeaser', id: string, title: string, ctaButtonLabel?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, media?: { __typename: 'File', url?: string | null } | { __typename: 'Image', url?: string | null } | { __typename: 'Video', url?: string | null } | { __typename: 'VideoCaption', url?: string | null } | null }> };

export type GetSimpleDojoContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSimpleDojoContentQuery = { __typename: 'Query', dojoContent: Array<{ __typename: 'ArticleTeaser', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } } | { __typename: 'DojoArticle', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } } | { __typename: 'DojoChecklist', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } } | { __typename: 'DojoNugget', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } } | { __typename: 'DojoQuiz', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } } | { __typename: 'DojoQuote', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } } | { __typename: 'StoryTeaser', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } } | { __typename: 'VideoTeaser', id: string, title: string, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } }> };

export type DojoGetParticipantsQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantFilter>;
}>;


export type DojoGetParticipantsQuery = { __typename: 'Query', participants: Array<{ __typename: 'Participant', participantId: string, onboardingStatus: ParticipantOnboardingStatus, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, middleName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null }> };

export type GetLearningJourneysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLearningJourneysQuery = { __typename: 'Query', learningJourneys: Array<{ __typename: 'LearningJourney', learningJourneyId: string, name: string, description?: string | null, assignedUserIds: Array<string>, assignDuringOnboarding: boolean, progress: number, completedPaths: number, totalPaths: number, timeSpentSeconds: number, averageCompletionTimeSeconds: number, completedUserCount: number, engagementRate: number, lastAccessedAt?: any | null, createdAt: any, updatedAt?: any | null, steps: Array<{ __typename: 'LearningJourneyStep', order: number, unlockStrategy: UnlockStrategy, learningPath: { __typename: 'LearningPath', learningPathId: string, name: string, description?: string | null, assignedUserCount: number, averageCompletionTimeSeconds: number, completionRate: number, journeyCount: number, createdAt: any, updatedAt?: any | null, contentItems?: Array<{ __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }> | null, contentTypeDistribution: Array<{ __typename: 'ContentTypeCount', type: string, count: number }>, progressDistribution: { __typename: 'ProgressDistribution', notStarted: number, inProgress: number, completed: number } }, unlockStatus: { __typename: 'UnlockStatus', reason?: string | null, unlocked: boolean } }>, progressDistribution: { __typename: 'ProgressDistribution', notStarted: number, inProgress: number, completed: number } }> };

export type GetLearningJourneyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLearningJourneyQuery = { __typename: 'Query', learningJourney?: { __typename: 'LearningJourney', learningJourneyId: string, name: string, description?: string | null, assignedUserIds: Array<string>, assignDuringOnboarding: boolean, createdAt: any, updatedAt?: any | null, steps: Array<{ __typename: 'LearningJourneyStep', order: number, unlockStrategy: UnlockStrategy, learningPath: { __typename: 'LearningPath', learningPathId: string, name: string, description?: string | null, contentItems?: Array<{ __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }> | null }, unlockStatus: { __typename: 'UnlockStatus', reason?: string | null, unlocked: boolean } }> } | null };

export type GetCoachEngagementExportQueryVariables = Exact<{
  input?: InputMaybe<CoachEngagementExportInput>;
}>;


export type GetCoachEngagementExportQuery = { __typename: 'Query', coachEngagementExport: Array<{ __typename: 'CoachEngagementEntry', userId: string, userName?: string | null, email?: string | null, totalConsults: number, attendedConsults: number, lastConsultDate?: string | null, firstConsultDate?: string | null, coachEngaged: boolean, segments: Array<string>, chatResponsiveness?: { __typename: 'ChatResponsiveness', currentRate: number, currentOutbound: number, currentResponded: number, previousRate: number, previousOutbound: number, previousResponded: number, trend: string } | null }> };

export type GetSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSegmentsQuery = { __typename: 'Query', segments: Array<{ __typename: 'Segment', id: string, name: string, description: string, memberCount: number }> };

export type GetSegmentUserDataQueryVariables = Exact<{
  segmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSegmentUserDataQuery = { __typename: 'Query', segmentUserData: Array<{ __typename: 'UserEngagementData', userId: string, lastAppActivity?: string | null, lastVnsSession?: string | null, vnsSessionCount: number, segmentIds: Array<string>, chatResponseRate?: number | null, firstConsultDate?: string | null, chatResponsiveness?: { __typename: 'ChatResponsiveness', currentRate: number, currentOutbound: number, currentResponded: number, previousRate: number, previousOutbound: number, previousResponded: number, trend: string } | null, classification?: { __typename: 'UserClassification', userId: string, classification: Classification, classificationReason?: string | null, classificationChangedAt?: any | null, classificationChangedBy?: string | null } | null, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null }> };

export type ClassifyUserMutationVariables = Exact<{
  input: ClassifyUserInput;
}>;


export type ClassifyUserMutation = { __typename: 'Mutation', classifyUser: { __typename: 'UserClassification', userId: string, classification: Classification, classificationReason?: string | null, classificationChangedAt?: any | null, classificationChangedBy?: string | null } };

export type GetPersonalisedStoneModeQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetPersonalisedStoneModeQuery = { __typename: 'Query', personalisedStoneMode: { __typename: 'PersonalisedStoneModeRead', userId: string, eligibility: { __typename: 'PersonalisedModeEligibility', hasStone: boolean, planIncludesPersonalised: boolean }, mode?: { __typename: 'PersonalisedStoneMode', modeId: string, displayName: string, description?: string | null, detailsVersion: number, parametersVersion: number, limitsVersion: number, outsideCurrentLimits: boolean, createdBy: string, createdAt: any, updatedBy: string, updatedAt: any, parameters: { __typename: 'StimulationParameters', frequencyHz: number, pulseWidthMicroseconds: number, onTimeMilliseconds: number, offTimeMilliseconds: number, sessionMinutes: number, intensityCeiling: number, rampUp: number, rampDown: number, payloadFormatVersion: number, intensityCurve: { __typename: 'IntensityCurve', levels: Array<number> } } } | null, history: Array<{ __typename: 'PersonalisedStoneModeVersion', modeId: string, version: number, source: ParameterSetSource, sourceNote?: string | null, limitsVersion: number, changedBy: string, changedAt: any, parameters: { __typename: 'StimulationParameters', frequencyHz: number, pulseWidthMicroseconds: number, onTimeMilliseconds: number, offTimeMilliseconds: number, sessionMinutes: number, intensityCeiling: number, rampUp: number, rampDown: number, payloadFormatVersion: number, intensityCurve: { __typename: 'IntensityCurve', levels: Array<number> } } }>, deviceReport: { __typename: 'PersonalisedModeDeviceReport', reportedAt?: any | null } } };

export type CreatePersonalisedStoneModeMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: CreatePersonalisedStoneModeInput;
}>;


export type CreatePersonalisedStoneModeMutation = { __typename: 'Mutation', createPersonalisedStoneMode: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdatePersonalisedStoneModeDetailsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  displayName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  expectedModeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdatePersonalisedStoneModeDetailsMutation = { __typename: 'Mutation', updatePersonalisedStoneModeDetails: { __typename: 'InputAcceptedResponse', id: string } };

export type SetPersonalisedStoneModeParametersMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  parameters: StimulationParameterValuesInput;
  sourceNote?: InputMaybe<Scalars['String']['input']>;
  expectedModeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetPersonalisedStoneModeParametersMutation = { __typename: 'Mutation', setPersonalisedStoneModeParameters: { __typename: 'InputAcceptedResponse', id: string } };

export type RemovePersonalisedStoneModeMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  expectedModeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RemovePersonalisedStoneModeMutation = { __typename: 'Mutation', removePersonalisedStoneMode: { __typename: 'InputAcceptedResponse', id: string } };

export type GetPlannableStoneModesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlannableStoneModesQuery = { __typename: 'Query', stoneModeCatalogue: { __typename: 'StoneModeCatalogue', modes: Array<{ __typename: 'StoneMode', modeId: string, displayName: string, generation: StoneDeviceGeneration, enabled: boolean, position: number }> } };

export type StoneModeParameterValuesFragment = { __typename: 'StimulationParameters', frequencyHz: number, pulseWidthMicroseconds: number, onTimeMilliseconds: number, offTimeMilliseconds: number, sessionMinutes: number, intensityCeiling: number, rampUp: number, rampDown: number, payloadFormatVersion: number, intensityCurve: { __typename: 'IntensityCurve', levels: Array<number> } };

export type StoneModeLimitsValuesFragment = { __typename: 'StoneModeLimits', version: number, setBy: string, setAt: any, ranges: Array<{ __typename: 'StimulationParameterRange', parameter: StimulationParameter, min: number, max: number }> };

export type GetStoneModeCatalogueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoneModeCatalogueQuery = { __typename: 'Query', stoneModeCatalogue: { __typename: 'StoneModeCatalogue', modes: Array<{ __typename: 'StoneMode', modeId: string, displayName: string, description?: string | null, generation: StoneDeviceGeneration, enabled: boolean, position: number, detailsVersion: number, parametersVersion?: number | null, outsideCurrentLimits: boolean, updatedBy: string, updatedAt: any, parameters?: { __typename: 'StimulationParameters', frequencyHz: number, pulseWidthMicroseconds: number, onTimeMilliseconds: number, offTimeMilliseconds: number, sessionMinutes: number, intensityCeiling: number, rampUp: number, rampDown: number, payloadFormatVersion: number, intensityCurve: { __typename: 'IntensityCurve', levels: Array<number> } } | null }>, limits?: { __typename: 'StoneModeLimits', version: number, setBy: string, setAt: any, ranges: Array<{ __typename: 'StimulationParameterRange', parameter: StimulationParameter, min: number, max: number }> } | null, defaultMode: { __typename: 'StoneModeDefault', version?: number | null, modeId?: string | null, usable: boolean, reason?: string | null, setBy?: string | null, setAt?: any | null } } };

export type GetStoneModeLimitsHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoneModeLimitsHistoryQuery = { __typename: 'Query', stoneModeLimitsHistory: Array<{ __typename: 'StoneModeLimits', version: number, setBy: string, setAt: any, ranges: Array<{ __typename: 'StimulationParameterRange', parameter: StimulationParameter, min: number, max: number }> }> };

export type GetStoneModeDefaultHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoneModeDefaultHistoryQuery = { __typename: 'Query', stoneModeDefaultHistory: Array<{ __typename: 'StoneModeDefaultVersion', version: number, modeId: string, setBy: string, setAt: any }> };

export type GetStoneModeParameterHistoryQueryVariables = Exact<{
  modeId: Scalars['ID']['input'];
}>;


export type GetStoneModeParameterHistoryQuery = { __typename: 'Query', stoneModeParameterHistory: Array<{ __typename: 'StoneModeParameterSetVersion', version: number, source: ParameterSetSource, sourceNote?: string | null, limitsVersion: number, changedBy: string, changedAt: any, parameters: { __typename: 'StimulationParameters', frequencyHz: number, pulseWidthMicroseconds: number, onTimeMilliseconds: number, offTimeMilliseconds: number, sessionMinutes: number, intensityCeiling: number, rampUp: number, rampDown: number, payloadFormatVersion: number, intensityCurve: { __typename: 'IntensityCurve', levels: Array<number> } } }> };

export type CreateStoneModeMutationVariables = Exact<{
  input: CreateStoneModeInput;
}>;


export type CreateStoneModeMutation = { __typename: 'Mutation', createStoneMode: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateStoneModeDetailsMutationVariables = Exact<{
  input: UpdateStoneModeDetailsInput;
}>;


export type UpdateStoneModeDetailsMutation = { __typename: 'Mutation', updateStoneModeDetails: { __typename: 'InputAcceptedResponse', id: string } };

export type EnableStoneModeMutationVariables = Exact<{
  modeId: Scalars['ID']['input'];
}>;


export type EnableStoneModeMutation = { __typename: 'Mutation', enableStoneMode: { __typename: 'InputAcceptedResponse', id: string } };

export type DisableStoneModeMutationVariables = Exact<{
  modeId: Scalars['ID']['input'];
}>;


export type DisableStoneModeMutation = { __typename: 'Mutation', disableStoneMode: { __typename: 'InputAcceptedResponse', id: string } };

export type MoveStoneModeMutationVariables = Exact<{
  modeId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}>;


export type MoveStoneModeMutation = { __typename: 'Mutation', moveStoneMode: { __typename: 'InputAcceptedResponse', id: string } };

export type SetStoneModeLimitsMutationVariables = Exact<{
  input: SetStoneModeLimitsInput;
}>;


export type SetStoneModeLimitsMutation = { __typename: 'Mutation', setStoneModeLimits: { __typename: 'InputAcceptedResponse', id: string } };

export type SetDefaultStoneModeMutationVariables = Exact<{
  modeId: Scalars['ID']['input'];
}>;


export type SetDefaultStoneModeMutation = { __typename: 'Mutation', setDefaultStoneMode: { __typename: 'InputAcceptedResponse', id: string } };

export type SetStoneModeParametersMutationVariables = Exact<{
  input: SetStoneModeParametersInput;
}>;


export type SetStoneModeParametersMutation = { __typename: 'Mutation', setStoneModeParameters: { __typename: 'InputAcceptedResponse', id: string } };

export type ImportStoneModeParametersMutationVariables = Exact<{
  modeId: Scalars['ID']['input'];
  vendorEntryJson: Scalars['String']['input'];
  sourceNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImportStoneModeParametersMutation = { __typename: 'Mutation', importStoneModeParameters: { __typename: 'InputAcceptedResponse', id: string } };

export type GetWaitlistDemandQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWaitlistDemandQuery = { __typename: 'Query', waitlistDemand: Array<{ __typename: 'WaitlistCountryDemand', country: string, count: number }> };

export type GetWaitlistSignalsQueryVariables = Exact<{
  country: Scalars['String']['input'];
}>;


export type GetWaitlistSignalsQuery = { __typename: 'Query', waitlistSignals: Array<{ __typename: 'WaitlistSignal', email: string, country: string, signalType?: string | null, consent: boolean, source?: string | null, createdAt?: any | null }> };

export type EraseWaitlistSignalMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type EraseWaitlistSignalMutation = { __typename: 'Mutation', eraseWaitlistSignal: { __typename: 'WaitlistEraseResult', email: string, erasedCount: number } };

export type ExportWaitlistSignalsMutationVariables = Exact<{
  input: WaitlistExportInput;
}>;


export type ExportWaitlistSignalsMutation = { __typename: 'Mutation', exportWaitlistSignals: { __typename: 'WaitlistExportResult', granted: boolean, country: string, recordCount: number, csv?: string | null } };

export type GetCurrentUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserRolesQuery = { __typename: 'Query', currentUser: { __typename: 'CurrentUser', accountId: string, roles: Array<Role>, email: string, status: UserStatus } };

export type WearableIntegrationFieldsFragment = { __typename: 'WearableIntegration', provider: WearableProvider, name: string, lastSynced: any };

export type GetParticipantsQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantFilter>;
}>;


export type GetParticipantsQuery = { __typename: 'Query', participants: Array<{ __typename: 'Participant', participantId: string, timezone?: string | null, createdAt: any, updatedAt: any, status: UserStatus, onboardingStatus: ParticipantOnboardingStatus, membership?: { __typename: 'Membership', membershipId: string, userId?: string | null, subscriptionStatus?: SubscriptionStatus | null, stripeCustomerId?: string | null, customerEmail?: string | null, customerName?: string | null, checkoutSessionId?: string | null, status?: MembershipStatus | null, linkingMethod?: LinkingMethod | null, createdAt: any, linkedAt?: any | null, paymentIntentId?: string | null, paymentAmount?: any | null, paymentDate?: any | null, stripeSubscriptionId?: string | null, subscriptionStartDate?: any | null, nextBillingDate?: any | null } | null, usageStats?: { __typename: 'ParticipantUsageStats', lastActive?: any | null } | null, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, middleName?: string | null, lastName?: string | null, dateOfBirth?: any | null, gender?: Gender | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null, phoneNumber?: { __typename: 'PhoneNumber', nationalNumber: string, countryCode: string } | null } } | null, learningJourneys?: Array<{ __typename: 'LearningJourney', learningJourneyId: string, name: string }> | null }> };

export type GetParticipantsMinimalQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantFilter>;
}>;


export type GetParticipantsMinimalQuery = { __typename: 'Query', participants: Array<{ __typename: 'Participant', participantId: string, timezone?: string | null, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null }> };

export type GetParticipantQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type GetParticipantQuery = { __typename: 'Query', participant: { __typename: 'Participant', participantId: string, timezone?: string | null, createdAt: any, updatedAt: any, status: UserStatus, membership?: { __typename: 'Membership', membershipId: string, userId?: string | null, subscriptionStatus?: SubscriptionStatus | null, stripeCustomerId?: string | null, customerEmail?: string | null, customerName?: string | null, checkoutSessionId?: string | null, status?: MembershipStatus | null, linkingMethod?: LinkingMethod | null, createdAt: any, linkedAt?: any | null, paymentIntentId?: string | null, paymentAmount?: any | null, paymentDate?: any | null, stripeSubscriptionId?: string | null, subscriptionStartDate?: any | null, nextBillingDate?: any | null } | null, usageStats?: { __typename: 'ParticipantUsageStats', lastActive?: any | null } | null, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, middleName?: string | null, lastName?: string | null, dateOfBirth?: any | null, gender?: Gender | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null, phoneNumber?: { __typename: 'PhoneNumber', nationalNumber: string, countryCode: string } | null } } | null, linkedCustomer?: { __typename: 'Customer', customerId: string, firstConsultDate?: any | null } | null, wearableIntegrations: Array<{ __typename: 'WearableIntegration', provider: WearableProvider, name: string, lastSynced: any }>, careChat: { __typename: 'CareChat', paused: boolean, pausedReason?: CareChatPausedReason | null } } };

export type SuspendUserMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type SuspendUserMutation = { __typename: 'Mutation', suspendUser: { __typename: 'InputAcceptedResponse', id: string } };

export type AssignRolesMutationVariables = Exact<{
  input: AssignRolesInput;
}>;


export type AssignRolesMutation = { __typename: 'Mutation', assignRoles: { __typename: 'InputAcceptedResponse', id: string } };

export type CreateStaffUserMutationVariables = Exact<{
  input: CreateStaffUserInput;
}>;


export type CreateStaffUserMutation = { __typename: 'Mutation', createStaffUser: { __typename: 'InputAcceptedResponse', id: string } };

export type GetInternalUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInternalUsersQuery = { __typename: 'Query', internalUsers: Array<{ __typename: 'Nurse', nurseId: string, accountId: string, timezone?: string | null, roles: Array<Role>, status: UserStatus, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, middleName?: string | null, lastName?: string | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null }> };

export type GetMemberTodayQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type GetMemberTodayQuery = { __typename: 'Query', participantTodaySessions?: { __typename: 'TodaySessions', date: any, timezone?: string | null, dayEnd: any } | null };

export type GetActivityPlanningQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetActivityPlanningQuery = { __typename: 'Query', activityPlanning?: { __typename: 'ActivityPlanning', activityPlanningId: string, userId: string, createdAt: any, updatedAt?: any | null, plannedActivities: Array<{ __typename: 'PlannedActivity', plannedActivityId: string, name: string, active: boolean, createdAt: any, lastCompletedAt?: any | null, startDate?: any | null, endDate?: any | null, removeAfterCompletion: boolean, plannedModeId?: string | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind }, timeSlots: Array<{ __typename: 'ActivityTimeSlot', dayOfWeek: WeekDay, timeBlock: TimeBlock }> }> } | null };

export type GetActivitiesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  dateRange: DateRangeInput;
}>;


export type GetActivitiesQuery = { __typename: 'Query', activities: Array<{ __typename: 'Activity', plannedActivityId: string, name: string, date: any, timeBlock: TimeBlock, active: boolean, createdAt: any, lastCompletedAt?: any | null, contentReference: { __typename: 'CustomActivityId', customActivityId: string } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId', kind: MobileWidgetKind } }> };

export type GetCustomActivitiesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetCustomActivitiesQuery = { __typename: 'Query', customActivities: Array<{ __typename: 'CustomActivity', customActivityId: string, title: string, createdAt: any, description: string, protocols?: Array<Protocol> | null, subprotocols?: Array<Subprotocol> | null, impactedVitals?: Array<ImpactedVital> | null }> };

export type GetCustomActivityQueryVariables = Exact<{
  customActivityId: Scalars['ID']['input'];
}>;


export type GetCustomActivityQuery = { __typename: 'Query', customActivity?: { __typename: 'CustomActivity', customActivityId: string, title: string, description: string, protocols?: Array<Protocol> | null, subprotocols?: Array<Subprotocol> | null, impactedVitals?: Array<ImpactedVital> | null, createdAt: any } | null };

export type GetArticlesQueryVariables = Exact<{
  filter?: InputMaybe<ArticleFilter>;
  sort?: InputMaybe<Array<ArticleSortInput> | ArticleSortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetArticlesQuery = { __typename: 'Query', articles: { __typename: 'ArticleConnection', articles: Array<{ __typename: 'ActivityVideo', id: string, title: string, protocols?: Array<Protocol> | null, impactedVitals?: Array<ImpactedVital> | null, thumbnail?: { __typename: 'Image', url?: string | null, title?: string | null } | null, reviewer?: { __typename: 'Reviewer', name?: string | null, credentials?: string | null, image?: { __typename: 'Image', url?: string | null } | null } | null, contentReference: { __typename: 'CustomActivityId' } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId' } } | { __typename: 'Article', id: string, title: string, protocols?: Array<Protocol> | null, impactedVitals?: Array<ImpactedVital> | null, thumbnail?: { __typename: 'Image', url?: string | null, title?: string | null } | null, reviewer?: { __typename: 'Reviewer', name?: string | null, credentials?: string | null, image?: { __typename: 'Image', url?: string | null } | null } | null, contentReference: { __typename: 'CustomActivityId' } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId' } } | { __typename: 'JourneyVideo', id: string, title: string, protocols?: Array<Protocol> | null, impactedVitals?: Array<ImpactedVital> | null, thumbnail?: { __typename: 'Image', url?: string | null, title?: string | null } | null, reviewer?: { __typename: 'Reviewer', name?: string | null, credentials?: string | null, image?: { __typename: 'Image', url?: string | null } | null } | null, contentReference: { __typename: 'CustomActivityId' } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId' } } | { __typename: 'Lesson', id: string, title: string, protocols?: Array<Protocol> | null, impactedVitals?: Array<ImpactedVital> | null, thumbnail?: { __typename: 'Image', url?: string | null, title?: string | null } | null, reviewer?: { __typename: 'Reviewer', name?: string | null, credentials?: string | null, image?: { __typename: 'Image', url?: string | null } | null } | null, contentReference: { __typename: 'CustomActivityId' } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId' } } | { __typename: 'Story', id: string, title: string, protocols?: Array<Protocol> | null, impactedVitals?: Array<ImpactedVital> | null, thumbnail?: { __typename: 'Image', url?: string | null, title?: string | null } | null, reviewer?: { __typename: 'Reviewer', name?: string | null, credentials?: string | null, image?: { __typename: 'Image', url?: string | null } | null } | null, contentReference: { __typename: 'CustomActivityId' } | { __typename: 'ExternalContentId', cms: Cms, contentType: ContentType, reference: string } | { __typename: 'MobileWidgetId' } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type PlanActivityMutationVariables = Exact<{
  command: PlanActivityCommand;
}>;


export type PlanActivityMutation = { __typename: 'Mutation', planActivity: { __typename: 'InputAcceptedResponse', id: string } };

export type CompleteActivityMutationVariables = Exact<{
  command: CompleteActivityCommand;
}>;


export type CompleteActivityMutation = { __typename: 'Mutation', completeActivity: { __typename: 'InputAcceptedResponse', id: string } };

export type DeletePlannedActivityMutationVariables = Exact<{
  command: DeletePlannedActivityCommand;
}>;


export type DeletePlannedActivityMutation = { __typename: 'Mutation', deletePlannedActivity: { __typename: 'InputAcceptedResponse', id: string } };

export type ReplacePlannedActivityMutationVariables = Exact<{
  command: ReplacePlannedActivityCommand;
}>;


export type ReplacePlannedActivityMutation = { __typename: 'Mutation', replacePlannedActivity: { __typename: 'InputAcceptedResponse', id: string } };

export type CreateCustomActivityMutationVariables = Exact<{
  command: CreateCustomActivityCommand;
}>;


export type CreateCustomActivityMutation = { __typename: 'Mutation', createCustomActivity: { __typename: 'InputAcceptedResponse', id: string } };

export type UpdateCustomActivityMutationVariables = Exact<{
  command: UpdateCustomActivityCommand;
}>;


export type UpdateCustomActivityMutation = { __typename: 'Mutation', updateCustomActivity: { __typename: 'InputAcceptedResponse', id: string } };

export type GetParticipantProfileQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type GetParticipantProfileQuery = { __typename: 'Query', participant: { __typename: 'Participant', participantId: string, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null, yearOfBirth?: number | null, gender?: Gender | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null } };

export type GetLatestBodyMetricsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type GetLatestBodyMetricsQuery = { __typename: 'Query', latestBodyMetrics: Array<{ __typename: 'BodyMetric', id: string, type: BodyMetricType, value: number, unit: MeasurementUnit, recordedAt: any }> };

export type GetLatestMindstateMetricsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type GetLatestMindstateMetricsQuery = { __typename: 'Query', latestMindstateMetrics: Array<{ __typename: 'MindstateMetric', id: string, type: MindstateMetricType, values: Array<string>, recordedAt: any }> };

export type GetDeliveredNotificationsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetDeliveredNotificationsQuery = { __typename: 'Query', deliveredNotifications: Array<{ __typename: 'NotificationDeliveryLog', notificationDeliveryId: string, createdAtTz: any, deliveredAtTz?: any | null, status: NotificationDeliveryStatus, messageReadStatus: MessageReadStatus, messageReadAtTz?: any | null, payload: { __typename: 'NotificationMessage', title: string, body: string, additionalPayload: any } }> };

export type UpdateMessageReadStatusMutationVariables = Exact<{
  notificationDeliveryId: Scalars['ID']['input'];
  messageReadStatus: MessageReadStatus;
  userId: Scalars['ID']['input'];
}>;


export type UpdateMessageReadStatusMutation = { __typename: 'Mutation', updateMessageReadStatus: { __typename: 'InputAcceptedResponse', id: string } };

export type GetVitalsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type GetVitalsQuery = { __typename: 'Query', vitals?: { __typename: 'Vitals', vitalsId: string, userId: string, vitals: Array<{ __typename: 'VitalMetric', id: string, type: VitalType, value: number, unit: MeasurementUnit, source: MetricSource, recordedAt: any, scanDurationSeconds?: number | null }>, feelings: Array<{ __typename: 'FeelingMetric', id: string, type: FeelingType, value: number, source: MetricSource, details?: string | null, originId?: string | null, recordedAt: any }>, emotionalStates: Array<{ __typename: 'EmotionalState', id: string, userId: string, feelings: Array<string>, recordedAt: any }> } | null };

export type GetEmotionalWordCloudQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type GetEmotionalWordCloudQuery = { __typename: 'Query', emotionalWordCloud: Array<{ __typename: 'EmotionalWordCloudEntry', word: string, count: number }> };

export type GetUserVitalMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput;
  participantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserVitalMetricsQuery = { __typename: 'Query', userVitalMetrics: { __typename: 'UserVitalMetrics', vitalsRecorded: { __typename: 'QuickStat', label: string, value: number, unit?: string | null, description?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, vnsTherapyTime: { __typename: 'QuickStat', label: string, value: number, unit?: string | null, description?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, vnsTherapyCompletionRate: { __typename: 'QuickStat', label: string, value: number, unit?: string | null, description?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null } } };

export type GetUserEngagementQueryVariables = Exact<{
  dateRange: DateRangeInput;
  participantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserEngagementQuery = { __typename: 'Query', userEngagement: { __typename: 'UserEngagementMetrics', logins: { __typename: 'QuickStat', label: string, value: number, unit?: string | null, description?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, dojoContentProgress: { __typename: 'QuickStat', label: string, value: number, unit?: string | null, description?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null } } };

export type GetVnsSessionsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  dateRange: DateRangeInput;
}>;


export type GetVnsSessionsQuery = { __typename: 'Query', vnsSessions: Array<{ __typename: 'VnsSession', vnsSessionId: string, userId: string, startTime: any, endTime?: any | null, totalDuration?: any | null, status?: VnsSessionStatus | null, deviceInfo?: string | null, timeBlock: TimeBlock, phases: Array<{ __typename: 'VnsPhase', startTime: any, endTime: any, settings: { __typename: 'VnsSettings', mode: VnsMode, intensity: number, modeReference?: { __typename: 'VnsModeReference', modeId: string, setVersion?: number | null, displayName?: string | null } | null } }>, initialSettings?: { __typename: 'VnsSettings', mode: VnsMode, modeReference?: { __typename: 'VnsModeReference', modeId: string, setVersion?: number | null, displayName?: string | null } | null } | null, insight?: { __typename: 'VnsSessionInsight', id: string, priority: InsightPriority, title: string, message: string, recommendation: string, createdAt: any, directImpactAnalysis?: { __typename: 'DirectImpactAnalysis', directImpactScore?: number | null, significantChanges?: Array<string> | null, impactSummary?: string | null, confidence?: number | null } | null, longTermTrendAnalysis?: { __typename: 'LongTermTrendAnalysis', longTermTrendScore?: number | null, improvingVitals?: Array<string> | null, plateauedVitals?: Array<string> | null, trendSummary?: string | null, weeksToNextMilestone?: number | null, adherenceImpact?: string | null } | null } | null }> };

export type GetUnattributedVnsSessionsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type GetUnattributedVnsSessionsQuery = { __typename: 'Query', unattributedVnsSessions: Array<{ __typename: 'VnsSession', vnsSessionId: string, startTime: any, totalDuration?: any | null, deviceSerial?: string | null, unattributedReason?: VnsSessionUnattributedReason | null }> };

export type GetCheckinSessionsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  dateRange: DateRangeInput;
}>;


export type GetCheckinSessionsQuery = { __typename: 'Query', checkinSessions: Array<{ __typename: 'CheckinSession', checkinSessionId: string, userId: string, startTime: any, endTime: any, vitalMeasurements?: Array<{ __typename: 'VitalMeasurement', type: VitalType, value: number, unit: MeasurementUnit, source: MetricSource, recordedAt: any, scanDurationSeconds?: number | null }> | null, feelingMeasurements?: Array<{ __typename: 'FeelingMeasurement', type: FeelingType, value: number, source: MetricSource, recordedAt: any }> | null }> };

export type GetBiofeedbackSessionsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  dateRange: DateRangeInput;
}>;


export type GetBiofeedbackSessionsQuery = { __typename: 'Query', biofeedbackSessions: Array<{ __typename: 'BiofeedbackSession', biofeedbackSessionId: string, userId: string, startTime: any, endTime: any, timeBlock: TimeBlock, activity?: { __typename: 'CustomActivityId', hydratedContent?: { __typename: 'ActivityVideo', id: string, title: string } | { __typename: 'Article', id: string, title: string } | { __typename: 'ArticleTeaser', id: string, title: string } | { __typename: 'CustomActivity', title: string } | { __typename: 'DojoArticle', id: string, title: string } | { __typename: 'DojoChecklist', id: string, title: string } | { __typename: 'DojoNugget', id: string, title: string } | { __typename: 'DojoQuiz', id: string, title: string } | { __typename: 'DojoQuote', id: string, title: string } | { __typename: 'JourneyVideo', id: string, title: string } | { __typename: 'Lesson', id: string, title: string } | { __typename: 'MobileWidget', title: string } | { __typename: 'Story', id: string, title: string } | { __typename: 'StoryTeaser', id: string, title: string } | { __typename: 'VideoTeaser', id: string, title: string } | null } | { __typename: 'ExternalContentId', hydratedContent?: { __typename: 'ActivityVideo', id: string, title: string } | { __typename: 'Article', id: string, title: string } | { __typename: 'ArticleTeaser', id: string, title: string } | { __typename: 'CustomActivity', title: string } | { __typename: 'DojoArticle', id: string, title: string } | { __typename: 'DojoChecklist', id: string, title: string } | { __typename: 'DojoNugget', id: string, title: string } | { __typename: 'DojoQuiz', id: string, title: string } | { __typename: 'DojoQuote', id: string, title: string } | { __typename: 'JourneyVideo', id: string, title: string } | { __typename: 'Lesson', id: string, title: string } | { __typename: 'MobileWidget', title: string } | { __typename: 'Story', id: string, title: string } | { __typename: 'StoryTeaser', id: string, title: string } | { __typename: 'VideoTeaser', id: string, title: string } | null } | { __typename: 'MobileWidgetId', hydratedContent?: { __typename: 'ActivityVideo', id: string, title: string } | { __typename: 'Article', id: string, title: string } | { __typename: 'ArticleTeaser', id: string, title: string } | { __typename: 'CustomActivity', title: string } | { __typename: 'DojoArticle', id: string, title: string } | { __typename: 'DojoChecklist', id: string, title: string } | { __typename: 'DojoNugget', id: string, title: string } | { __typename: 'DojoQuiz', id: string, title: string } | { __typename: 'DojoQuote', id: string, title: string } | { __typename: 'JourneyVideo', id: string, title: string } | { __typename: 'Lesson', id: string, title: string } | { __typename: 'MobileWidget', title: string } | { __typename: 'Story', id: string, title: string } | { __typename: 'StoryTeaser', id: string, title: string } | { __typename: 'VideoTeaser', id: string, title: string } | null } | null, preVitals?: Array<{ __typename: 'VitalMeasurement', type: VitalType, value: number, unit: MeasurementUnit, source: MetricSource, recordedAt: any, scanDurationSeconds?: number | null }> | null, postVitals?: Array<{ __typename: 'VitalMeasurement', type: VitalType, value: number, unit: MeasurementUnit, source: MetricSource, recordedAt: any, scanDurationSeconds?: number | null }> | null }> };

export type GetUserChatMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput;
  participantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserChatMetricsQuery = { __typename: 'Query', userChatMetrics: { __typename: 'UserChatMetrics', inboundMessages: { __typename: 'QuickStat', label: string, value: number, unit?: string | null, description?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, outboundMessages: { __typename: 'QuickStat', label: string, value: number, unit?: string | null, description?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null }, responseRate: { __typename: 'QuickStat', label: string, value: number, unit?: string | null, description?: string | null, trend?: { __typename: 'Trend', value: number, previousValue: number, isIncrease?: boolean | null, label: string } | null } } };

export type GetParticipantDailyReflectionsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  dateRange: DateRangeInput;
}>;


export type GetParticipantDailyReflectionsQuery = { __typename: 'Query', participantDailyReflections: Array<{ __typename: 'DailyReflection', reflectionId: string, date: any, note?: string | null, completedAt: any, createdAt: any, answers: Array<{ __typename: 'ReflectAnswer', metric: ReflectMetric, value: number, label: string }> }> };

export type GetUserRmssdProfileQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type GetUserRmssdProfileQuery = { __typename: 'Query', userRmssdProfile?: { __typename: 'UserRmssdProfile', participantId: string, baselineRmssd?: number | null, currentRmssd?: number | null, ageBracket?: AgeBracket | null, threshold: number, stratum: RmssdStratum } | null };

export type GetRmssdStratificationQueryVariables = Exact<{
  filter: RmssdStratificationFilter;
}>;


export type GetRmssdStratificationQuery = { __typename: 'Query', rmssdStratification: { __typename: 'RmssdStratification', totalUsers: number, usersExcludedNoAge: number, usersExcludedNoRmssd: number, strata: Array<{ __typename: 'RmssdStratumStats', stratum: RmssdStratum, count: number, percentage: number, avgBaselineRmssd?: number | null, avgPercentageChange?: number | null }>, thresholds: Array<{ __typename: 'AgeAdjustedThreshold', ageBracket: AgeBracket, threshold: number }> } };

export type GetParticipantBaselineQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type GetParticipantBaselineQuery = { __typename: 'Query', participant: { __typename: 'Participant', participantId: string, pii?: { __typename: 'Pii', identityInformation: { __typename: 'IdentityInformation', firstName?: string | null, lastName?: string | null, yearOfBirth?: number | null, gender?: Gender | null }, contactInformation: { __typename: 'ContactInformation', email?: string | null } } | null, wearableIntegrations: Array<{ __typename: 'WearableIntegration', provider: WearableProvider, name: string, lastSynced: any }> } };

export type UpdateBroadcastOptOutMutationVariables = Exact<{
  input: UpdateBroadcastOptOutInput;
}>;


export type UpdateBroadcastOptOutMutation = { __typename: 'Mutation', updateBroadcastOptOut: { __typename: 'Preferences', preferencesId: string, userId: string, broadcastOptOut: boolean, lastUpdatedAt?: any | null } };

export type UpdateContentAssignmentOptOutMutationVariables = Exact<{
  input: UpdateContentAssignmentOptOutInput;
}>;


export type UpdateContentAssignmentOptOutMutation = { __typename: 'Mutation', updateContentAssignmentOptOut: { __typename: 'InputAcceptedResponse', id: string } };

export type GetWeeklyAchievementsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  weekDay?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetWeeklyAchievementsQuery = { __typename: 'Query', weeklyAchievements: { __typename: 'WeeklyAchievements', userId: string, weekStartDate: string, achievements: Array<{ __typename: 'WeeklyAchievement', protocol: Protocol, committedMinutes: number, completedMinutes: number, isCompleted: boolean, remainingText: string }> } };

export const BroadcastEntryFieldsFragmentDoc = gql`
    fragment BroadcastEntryFields on BroadcastEntry {
  broadcastId
  senderUserId
  senderDisplayName
  status
  getstreamCampaignId
  selection {
    __typename
    ... on BroadcastAllActiveParticipants {
      isAllActive
    }
    ... on BroadcastCohort {
      cohortId
    }
    ... on BroadcastHandPicked {
      userIds
    }
  }
  body
  recipientUserIds
  excludedSummary {
    excludedOptOut
    excludedTestUsers
    excludedNoChannel
    excludedPaused
  }
  sentCount
  failedCount
  failedUserIds
  skippedPaused
  failureReason
  initiatedAt
  startedAt
  completedAt
  lastUpdatedAt
}
    `;
export const BulkAssignmentConsentDeltaFieldsFragmentDoc = gql`
    fragment BulkAssignmentConsentDeltaFields on BulkAssignmentConsentDelta {
  preparedCount
  willSendCount
  droppedSincePrepare {
    userId
    reason
  }
}
    `;
export const BulkAssignmentEntryFieldsFragmentDoc = gql`
    fragment BulkAssignmentEntryFields on BulkAssignmentEntry {
  bulkAssignmentId
  senderUserId
  senderDisplayName
  status
  selection {
    __typename
    ... on BulkAssignmentAllActiveParticipants {
      isAllActive
    }
    ... on BulkAssignmentCohort {
      cohortId
    }
    ... on BulkAssignmentHandPicked {
      userIds
    }
  }
  payload {
    contentReference {
      __typename
      ... on MobileWidgetId {
        kind
      }
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    timeSlots {
      dayOfWeek
      timeBlock
    }
    startDate
    endDate
    removeAfterCompletion
    modeId
  }
  recipientUserIds
  excludedSummary {
    excludedOptOut
    excludedTestUsers
    excludedSuspended
    alreadyPlanned
    excludedPlannedMode
    plannedModeReasonCounts {
      reason
      count
    }
    plannedModeExclusions {
      userId
      reason
    }
  }
  stats {
    assigned
    failed
  }
  perRecipientOutcomes {
    userId
    outcome {
      __typename
      ... on BulkAssignmentOutcomeAssigned {
        success
      }
      ... on BulkAssignmentOutcomeCommandRejected {
        reason
      }
      ... on BulkAssignmentOutcomeDispatchFailed {
        reason
      }
    }
  }
  failureReason
  preparedBy
  preparedVia
  preparedAt
  approvedBy
  approvedVia
  approvedAt
  rejectedBy
  rejectedReason
  rejectedAt
  consentDelta {
    ...BulkAssignmentConsentDeltaFields
  }
  initiatedAt
  startedAt
  completedAt
  lastUpdatedAt
}
    ${BulkAssignmentConsentDeltaFieldsFragmentDoc}`;
export const AcquisitionSourceFieldsFragmentDoc = gql`
    fragment AcquisitionSourceFields on AcquisitionSource {
  sourceId
  name
  couponCodes
  defaultSegment
  partnerName
  startDate
  endDate
  active
  metadata
  customerCount
  createdAt
  updatedAt
}
    `;
export const CarrierFieldsFragmentDoc = gql`
    fragment CarrierFields on Carrier {
  carrierId
  code
  name
  trackingUrlTemplate
  active
  createdAt
}
    `;
export const CustomerRefundReviewFieldsFragmentDoc = gql`
    fragment CustomerRefundReviewFields on Customer {
  refundReviewPending
  refundReviews {
    entitlementId
    decision
    reason
    reviewedAt
    reviewedBy
  }
}
    `;
export const ServiceCaseFieldsFragmentDoc = gql`
    fragment ServiceCaseFields on ServiceCase {
  serviceCaseId
  customerId
  customer {
    customerId
    email
  }
  shipmentId
  shipment {
    shipmentId
    status
    trackingNumber
    carrier
  }
  deviceSerial
  issueType
  reason
  reasonDetail
  status
  resolutionAction
  resolutionNote
  replacementShipmentId
  replacementShipment {
    shipmentId
    status
    trackingNumber
    carrier
  }
  returnTrackingNumber
  returnCarrier
  openedAt
  resolvedAt
  cancelledAt
  performedBy
}
    `;
export const ShipmentFieldsFragmentDoc = gql`
    fragment ShipmentFields on Shipment {
  shipmentId
  customerId
  customer {
    customerId
    email
  }
  status
  trackingNumber
  carrier
  shippingAddress {
    name
    line1
    line2
    city
    state
    postalCode
    country
  }
  items {
    shipmentItemId
    entitlementId
    productType
    deviceSerial
  }
  origin
  createdAt
  shippedAt
  deliveredAt
  returnedAt
}
    `;
export const MonthlyKpiPointFieldsFragmentDoc = gql`
    fragment MonthlyKpiPointFields on MonthlyKpiPoint {
  month
  value
  valueDecimal
}
    `;
export const ParticipantNoteFieldsFragmentDoc = gql`
    fragment ParticipantNoteFields on ParticipantNote {
  noteId
  participantId
  authorId
  content
  categories
  status
  flagStatus
  flagReason
  linkedToMessageId
  linkedConsultNumber
  createdAt
  updatedAt
}
    `;
export const StoneModeParameterValuesFragmentDoc = gql`
    fragment StoneModeParameterValues on StimulationParameters {
  frequencyHz
  pulseWidthMicroseconds
  onTimeMilliseconds
  offTimeMilliseconds
  sessionMinutes
  intensityCeiling
  rampUp
  rampDown
  intensityCurve {
    levels
  }
  payloadFormatVersion
}
    `;
export const StoneModeLimitsValuesFragmentDoc = gql`
    fragment StoneModeLimitsValues on StoneModeLimits {
  version
  ranges {
    parameter
    min
    max
  }
  setBy
  setAt
}
    `;
export const WearableIntegrationFieldsFragmentDoc = gql`
    fragment WearableIntegrationFields on WearableIntegration {
  provider
  name
  lastSynced
}
    `;
export const InitiateBroadcastDocument = gql`
    mutation InitiateBroadcast($input: InitiateBroadcastInput!) {
  initiateBroadcast(input: $input) {
    ...BroadcastEntryFields
  }
}
    ${BroadcastEntryFieldsFragmentDoc}`;
export type InitiateBroadcastMutationFn = Apollo.MutationFunction<InitiateBroadcastMutation, InitiateBroadcastMutationVariables>;

/**
 * __useInitiateBroadcastMutation__
 *
 * To run a mutation, you first call `useInitiateBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateBroadcastMutation, { data, loading, error }] = useInitiateBroadcastMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<InitiateBroadcastMutation, InitiateBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateBroadcastMutation, InitiateBroadcastMutationVariables>(InitiateBroadcastDocument, options);
      }
export type InitiateBroadcastMutationHookResult = ReturnType<typeof useInitiateBroadcastMutation>;
export type InitiateBroadcastMutationResult = Apollo.MutationResult<InitiateBroadcastMutation>;
export type InitiateBroadcastMutationOptions = Apollo.BaseMutationOptions<InitiateBroadcastMutation, InitiateBroadcastMutationVariables>;
export const RetryFailedBroadcastRecipientsDocument = gql`
    mutation RetryFailedBroadcastRecipients($broadcastId: ID!) {
  retryFailedBroadcastRecipients(broadcastId: $broadcastId) {
    id
  }
}
    `;
export type RetryFailedBroadcastRecipientsMutationFn = Apollo.MutationFunction<RetryFailedBroadcastRecipientsMutation, RetryFailedBroadcastRecipientsMutationVariables>;

/**
 * __useRetryFailedBroadcastRecipientsMutation__
 *
 * To run a mutation, you first call `useRetryFailedBroadcastRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryFailedBroadcastRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryFailedBroadcastRecipientsMutation, { data, loading, error }] = useRetryFailedBroadcastRecipientsMutation({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useRetryFailedBroadcastRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<RetryFailedBroadcastRecipientsMutation, RetryFailedBroadcastRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryFailedBroadcastRecipientsMutation, RetryFailedBroadcastRecipientsMutationVariables>(RetryFailedBroadcastRecipientsDocument, options);
      }
export type RetryFailedBroadcastRecipientsMutationHookResult = ReturnType<typeof useRetryFailedBroadcastRecipientsMutation>;
export type RetryFailedBroadcastRecipientsMutationResult = Apollo.MutationResult<RetryFailedBroadcastRecipientsMutation>;
export type RetryFailedBroadcastRecipientsMutationOptions = Apollo.BaseMutationOptions<RetryFailedBroadcastRecipientsMutation, RetryFailedBroadcastRecipientsMutationVariables>;
export const GetBroadcastsDocument = gql`
    query GetBroadcasts($senderUserId: ID, $limit: Int, $cursor: String) {
  broadcasts(senderUserId: $senderUserId, limit: $limit, cursor: $cursor) {
    nodes {
      ...BroadcastEntryFields
    }
    totalCount
    nextCursor
  }
}
    ${BroadcastEntryFieldsFragmentDoc}`;

/**
 * __useGetBroadcastsQuery__
 *
 * To run a query within a React component, call `useGetBroadcastsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastsQuery({
 *   variables: {
 *      senderUserId: // value for 'senderUserId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetBroadcastsQuery(baseOptions?: Apollo.QueryHookOptions<GetBroadcastsQuery, GetBroadcastsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastsQuery, GetBroadcastsQueryVariables>(GetBroadcastsDocument, options);
      }
export function useGetBroadcastsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastsQuery, GetBroadcastsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastsQuery, GetBroadcastsQueryVariables>(GetBroadcastsDocument, options);
        }
export function useGetBroadcastsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBroadcastsQuery, GetBroadcastsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBroadcastsQuery, GetBroadcastsQueryVariables>(GetBroadcastsDocument, options);
        }
export type GetBroadcastsQueryHookResult = ReturnType<typeof useGetBroadcastsQuery>;
export type GetBroadcastsLazyQueryHookResult = ReturnType<typeof useGetBroadcastsLazyQuery>;
export type GetBroadcastsSuspenseQueryHookResult = ReturnType<typeof useGetBroadcastsSuspenseQuery>;
export type GetBroadcastsQueryResult = Apollo.QueryResult<GetBroadcastsQuery, GetBroadcastsQueryVariables>;
export const GetBroadcastDocument = gql`
    query GetBroadcast($id: ID!) {
  broadcast(id: $id) {
    ...BroadcastEntryFields
  }
}
    ${BroadcastEntryFieldsFragmentDoc}`;

/**
 * __useGetBroadcastQuery__
 *
 * To run a query within a React component, call `useGetBroadcastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBroadcastQuery(baseOptions: Apollo.QueryHookOptions<GetBroadcastQuery, GetBroadcastQueryVariables> & ({ variables: GetBroadcastQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastQuery, GetBroadcastQueryVariables>(GetBroadcastDocument, options);
      }
export function useGetBroadcastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastQuery, GetBroadcastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastQuery, GetBroadcastQueryVariables>(GetBroadcastDocument, options);
        }
export function useGetBroadcastSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBroadcastQuery, GetBroadcastQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBroadcastQuery, GetBroadcastQueryVariables>(GetBroadcastDocument, options);
        }
export type GetBroadcastQueryHookResult = ReturnType<typeof useGetBroadcastQuery>;
export type GetBroadcastLazyQueryHookResult = ReturnType<typeof useGetBroadcastLazyQuery>;
export type GetBroadcastSuspenseQueryHookResult = ReturnType<typeof useGetBroadcastSuspenseQuery>;
export type GetBroadcastQueryResult = Apollo.QueryResult<GetBroadcastQuery, GetBroadcastQueryVariables>;
export const ResolveBroadcastRecipientsDocument = gql`
    query ResolveBroadcastRecipients($input: BroadcastSelectionInput!) {
  resolveBroadcastRecipients(input: $input) {
    userIds
    excludedOptOut
    excludedTestUsers
    excludedNoChannel
    excludedPaused
    fallbackRecipientCount
    sampleResolvedFirstName
    recipients {
      userId
      resolvedFirstName
    }
    sourceRule
  }
}
    `;

/**
 * __useResolveBroadcastRecipientsQuery__
 *
 * To run a query within a React component, call `useResolveBroadcastRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveBroadcastRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveBroadcastRecipientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveBroadcastRecipientsQuery(baseOptions: Apollo.QueryHookOptions<ResolveBroadcastRecipientsQuery, ResolveBroadcastRecipientsQueryVariables> & ({ variables: ResolveBroadcastRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveBroadcastRecipientsQuery, ResolveBroadcastRecipientsQueryVariables>(ResolveBroadcastRecipientsDocument, options);
      }
export function useResolveBroadcastRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveBroadcastRecipientsQuery, ResolveBroadcastRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveBroadcastRecipientsQuery, ResolveBroadcastRecipientsQueryVariables>(ResolveBroadcastRecipientsDocument, options);
        }
export function useResolveBroadcastRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveBroadcastRecipientsQuery, ResolveBroadcastRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveBroadcastRecipientsQuery, ResolveBroadcastRecipientsQueryVariables>(ResolveBroadcastRecipientsDocument, options);
        }
export type ResolveBroadcastRecipientsQueryHookResult = ReturnType<typeof useResolveBroadcastRecipientsQuery>;
export type ResolveBroadcastRecipientsLazyQueryHookResult = ReturnType<typeof useResolveBroadcastRecipientsLazyQuery>;
export type ResolveBroadcastRecipientsSuspenseQueryHookResult = ReturnType<typeof useResolveBroadcastRecipientsSuspenseQuery>;
export type ResolveBroadcastRecipientsQueryResult = Apollo.QueryResult<ResolveBroadcastRecipientsQuery, ResolveBroadcastRecipientsQueryVariables>;
export const InitiateBulkAssignmentDocument = gql`
    mutation InitiateBulkAssignment($input: InitiateBulkAssignmentInput!) {
  initiateBulkAssignment(input: $input) {
    ...BulkAssignmentEntryFields
  }
}
    ${BulkAssignmentEntryFieldsFragmentDoc}`;
export type InitiateBulkAssignmentMutationFn = Apollo.MutationFunction<InitiateBulkAssignmentMutation, InitiateBulkAssignmentMutationVariables>;

/**
 * __useInitiateBulkAssignmentMutation__
 *
 * To run a mutation, you first call `useInitiateBulkAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateBulkAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateBulkAssignmentMutation, { data, loading, error }] = useInitiateBulkAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateBulkAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<InitiateBulkAssignmentMutation, InitiateBulkAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateBulkAssignmentMutation, InitiateBulkAssignmentMutationVariables>(InitiateBulkAssignmentDocument, options);
      }
export type InitiateBulkAssignmentMutationHookResult = ReturnType<typeof useInitiateBulkAssignmentMutation>;
export type InitiateBulkAssignmentMutationResult = Apollo.MutationResult<InitiateBulkAssignmentMutation>;
export type InitiateBulkAssignmentMutationOptions = Apollo.BaseMutationOptions<InitiateBulkAssignmentMutation, InitiateBulkAssignmentMutationVariables>;
export const PrepareBulkAssignmentDocument = gql`
    mutation PrepareBulkAssignment($input: PrepareBulkAssignmentInput!) {
  prepareBulkAssignment(input: $input) {
    ...BulkAssignmentEntryFields
  }
}
    ${BulkAssignmentEntryFieldsFragmentDoc}`;
export type PrepareBulkAssignmentMutationFn = Apollo.MutationFunction<PrepareBulkAssignmentMutation, PrepareBulkAssignmentMutationVariables>;

/**
 * __usePrepareBulkAssignmentMutation__
 *
 * To run a mutation, you first call `usePrepareBulkAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareBulkAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareBulkAssignmentMutation, { data, loading, error }] = usePrepareBulkAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareBulkAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<PrepareBulkAssignmentMutation, PrepareBulkAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareBulkAssignmentMutation, PrepareBulkAssignmentMutationVariables>(PrepareBulkAssignmentDocument, options);
      }
export type PrepareBulkAssignmentMutationHookResult = ReturnType<typeof usePrepareBulkAssignmentMutation>;
export type PrepareBulkAssignmentMutationResult = Apollo.MutationResult<PrepareBulkAssignmentMutation>;
export type PrepareBulkAssignmentMutationOptions = Apollo.BaseMutationOptions<PrepareBulkAssignmentMutation, PrepareBulkAssignmentMutationVariables>;
export const ApproveBulkAssignmentDocument = gql`
    mutation ApproveBulkAssignment($id: ID!) {
  approveBulkAssignment(id: $id) {
    ...BulkAssignmentEntryFields
  }
}
    ${BulkAssignmentEntryFieldsFragmentDoc}`;
export type ApproveBulkAssignmentMutationFn = Apollo.MutationFunction<ApproveBulkAssignmentMutation, ApproveBulkAssignmentMutationVariables>;

/**
 * __useApproveBulkAssignmentMutation__
 *
 * To run a mutation, you first call `useApproveBulkAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBulkAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBulkAssignmentMutation, { data, loading, error }] = useApproveBulkAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveBulkAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<ApproveBulkAssignmentMutation, ApproveBulkAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveBulkAssignmentMutation, ApproveBulkAssignmentMutationVariables>(ApproveBulkAssignmentDocument, options);
      }
export type ApproveBulkAssignmentMutationHookResult = ReturnType<typeof useApproveBulkAssignmentMutation>;
export type ApproveBulkAssignmentMutationResult = Apollo.MutationResult<ApproveBulkAssignmentMutation>;
export type ApproveBulkAssignmentMutationOptions = Apollo.BaseMutationOptions<ApproveBulkAssignmentMutation, ApproveBulkAssignmentMutationVariables>;
export const RejectBulkAssignmentDocument = gql`
    mutation RejectBulkAssignment($id: ID!, $reason: String) {
  rejectBulkAssignment(id: $id, reason: $reason) {
    ...BulkAssignmentEntryFields
  }
}
    ${BulkAssignmentEntryFieldsFragmentDoc}`;
export type RejectBulkAssignmentMutationFn = Apollo.MutationFunction<RejectBulkAssignmentMutation, RejectBulkAssignmentMutationVariables>;

/**
 * __useRejectBulkAssignmentMutation__
 *
 * To run a mutation, you first call `useRejectBulkAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectBulkAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectBulkAssignmentMutation, { data, loading, error }] = useRejectBulkAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectBulkAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<RejectBulkAssignmentMutation, RejectBulkAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectBulkAssignmentMutation, RejectBulkAssignmentMutationVariables>(RejectBulkAssignmentDocument, options);
      }
export type RejectBulkAssignmentMutationHookResult = ReturnType<typeof useRejectBulkAssignmentMutation>;
export type RejectBulkAssignmentMutationResult = Apollo.MutationResult<RejectBulkAssignmentMutation>;
export type RejectBulkAssignmentMutationOptions = Apollo.BaseMutationOptions<RejectBulkAssignmentMutation, RejectBulkAssignmentMutationVariables>;
export const GetBulkAssignmentsDocument = gql`
    query GetBulkAssignments($senderUserId: ID, $status: BulkAssignmentStatus, $limit: Int, $cursor: String) {
  bulkAssignments(
    senderUserId: $senderUserId
    status: $status
    limit: $limit
    cursor: $cursor
  ) {
    nodes {
      ...BulkAssignmentEntryFields
    }
    totalCount
    nextCursor
  }
}
    ${BulkAssignmentEntryFieldsFragmentDoc}`;

/**
 * __useGetBulkAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetBulkAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkAssignmentsQuery({
 *   variables: {
 *      senderUserId: // value for 'senderUserId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetBulkAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetBulkAssignmentsQuery, GetBulkAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkAssignmentsQuery, GetBulkAssignmentsQueryVariables>(GetBulkAssignmentsDocument, options);
      }
export function useGetBulkAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkAssignmentsQuery, GetBulkAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkAssignmentsQuery, GetBulkAssignmentsQueryVariables>(GetBulkAssignmentsDocument, options);
        }
export function useGetBulkAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBulkAssignmentsQuery, GetBulkAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBulkAssignmentsQuery, GetBulkAssignmentsQueryVariables>(GetBulkAssignmentsDocument, options);
        }
export type GetBulkAssignmentsQueryHookResult = ReturnType<typeof useGetBulkAssignmentsQuery>;
export type GetBulkAssignmentsLazyQueryHookResult = ReturnType<typeof useGetBulkAssignmentsLazyQuery>;
export type GetBulkAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetBulkAssignmentsSuspenseQuery>;
export type GetBulkAssignmentsQueryResult = Apollo.QueryResult<GetBulkAssignmentsQuery, GetBulkAssignmentsQueryVariables>;
export const GetBulkAssignmentDocument = gql`
    query GetBulkAssignment($id: ID!) {
  bulkAssignment(id: $id) {
    ...BulkAssignmentEntryFields
  }
}
    ${BulkAssignmentEntryFieldsFragmentDoc}`;

/**
 * __useGetBulkAssignmentQuery__
 *
 * To run a query within a React component, call `useGetBulkAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBulkAssignmentQuery(baseOptions: Apollo.QueryHookOptions<GetBulkAssignmentQuery, GetBulkAssignmentQueryVariables> & ({ variables: GetBulkAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkAssignmentQuery, GetBulkAssignmentQueryVariables>(GetBulkAssignmentDocument, options);
      }
export function useGetBulkAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkAssignmentQuery, GetBulkAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkAssignmentQuery, GetBulkAssignmentQueryVariables>(GetBulkAssignmentDocument, options);
        }
export function useGetBulkAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBulkAssignmentQuery, GetBulkAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBulkAssignmentQuery, GetBulkAssignmentQueryVariables>(GetBulkAssignmentDocument, options);
        }
export type GetBulkAssignmentQueryHookResult = ReturnType<typeof useGetBulkAssignmentQuery>;
export type GetBulkAssignmentLazyQueryHookResult = ReturnType<typeof useGetBulkAssignmentLazyQuery>;
export type GetBulkAssignmentSuspenseQueryHookResult = ReturnType<typeof useGetBulkAssignmentSuspenseQuery>;
export type GetBulkAssignmentQueryResult = Apollo.QueryResult<GetBulkAssignmentQuery, GetBulkAssignmentQueryVariables>;
export const BulkAssignmentConsentPreviewDocument = gql`
    query BulkAssignmentConsentPreview($id: ID!) {
  bulkAssignmentConsentPreview(id: $id) {
    ...BulkAssignmentConsentDeltaFields
  }
}
    ${BulkAssignmentConsentDeltaFieldsFragmentDoc}`;

/**
 * __useBulkAssignmentConsentPreviewQuery__
 *
 * To run a query within a React component, call `useBulkAssignmentConsentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignmentConsentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkAssignmentConsentPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBulkAssignmentConsentPreviewQuery(baseOptions: Apollo.QueryHookOptions<BulkAssignmentConsentPreviewQuery, BulkAssignmentConsentPreviewQueryVariables> & ({ variables: BulkAssignmentConsentPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkAssignmentConsentPreviewQuery, BulkAssignmentConsentPreviewQueryVariables>(BulkAssignmentConsentPreviewDocument, options);
      }
export function useBulkAssignmentConsentPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkAssignmentConsentPreviewQuery, BulkAssignmentConsentPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkAssignmentConsentPreviewQuery, BulkAssignmentConsentPreviewQueryVariables>(BulkAssignmentConsentPreviewDocument, options);
        }
export function useBulkAssignmentConsentPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkAssignmentConsentPreviewQuery, BulkAssignmentConsentPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkAssignmentConsentPreviewQuery, BulkAssignmentConsentPreviewQueryVariables>(BulkAssignmentConsentPreviewDocument, options);
        }
export type BulkAssignmentConsentPreviewQueryHookResult = ReturnType<typeof useBulkAssignmentConsentPreviewQuery>;
export type BulkAssignmentConsentPreviewLazyQueryHookResult = ReturnType<typeof useBulkAssignmentConsentPreviewLazyQuery>;
export type BulkAssignmentConsentPreviewSuspenseQueryHookResult = ReturnType<typeof useBulkAssignmentConsentPreviewSuspenseQuery>;
export type BulkAssignmentConsentPreviewQueryResult = Apollo.QueryResult<BulkAssignmentConsentPreviewQuery, BulkAssignmentConsentPreviewQueryVariables>;
export const ResolveBulkAssignmentRecipientsDocument = gql`
    query ResolveBulkAssignmentRecipients($input: BulkAssignmentSelectionInput!, $contentReference: ContentReferenceInput) {
  resolveBulkAssignmentRecipients(
    input: $input
    contentReference: $contentReference
  ) {
    userIds
    excludedOptOut
    excludedTestUsers
    alreadyPlannedUserIds
    sourceRule
  }
}
    `;

/**
 * __useResolveBulkAssignmentRecipientsQuery__
 *
 * To run a query within a React component, call `useResolveBulkAssignmentRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveBulkAssignmentRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveBulkAssignmentRecipientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      contentReference: // value for 'contentReference'
 *   },
 * });
 */
export function useResolveBulkAssignmentRecipientsQuery(baseOptions: Apollo.QueryHookOptions<ResolveBulkAssignmentRecipientsQuery, ResolveBulkAssignmentRecipientsQueryVariables> & ({ variables: ResolveBulkAssignmentRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveBulkAssignmentRecipientsQuery, ResolveBulkAssignmentRecipientsQueryVariables>(ResolveBulkAssignmentRecipientsDocument, options);
      }
export function useResolveBulkAssignmentRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveBulkAssignmentRecipientsQuery, ResolveBulkAssignmentRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveBulkAssignmentRecipientsQuery, ResolveBulkAssignmentRecipientsQueryVariables>(ResolveBulkAssignmentRecipientsDocument, options);
        }
export function useResolveBulkAssignmentRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveBulkAssignmentRecipientsQuery, ResolveBulkAssignmentRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveBulkAssignmentRecipientsQuery, ResolveBulkAssignmentRecipientsQueryVariables>(ResolveBulkAssignmentRecipientsDocument, options);
        }
export type ResolveBulkAssignmentRecipientsQueryHookResult = ReturnType<typeof useResolveBulkAssignmentRecipientsQuery>;
export type ResolveBulkAssignmentRecipientsLazyQueryHookResult = ReturnType<typeof useResolveBulkAssignmentRecipientsLazyQuery>;
export type ResolveBulkAssignmentRecipientsSuspenseQueryHookResult = ReturnType<typeof useResolveBulkAssignmentRecipientsSuspenseQuery>;
export type ResolveBulkAssignmentRecipientsQueryResult = Apollo.QueryResult<ResolveBulkAssignmentRecipientsQuery, ResolveBulkAssignmentRecipientsQueryVariables>;
export const GetCapabilityPackagesDocument = gql`
    query GetCapabilityPackages($includeArchived: Boolean) {
  capabilityPackages(includeArchived: $includeArchived) {
    packageId
    packageKey
    displayName
    capabilities
    priceRefs {
      cadence
      priceRef
    }
    dials {
      dial
      value
    }
    archived
    sitsAbove
    modeIds
    includesPersonalised
    contentHash
    definedBy
    definedAt
    lastUpdatedBy
    lastUpdatedAt
  }
}
    `;

/**
 * __useGetCapabilityPackagesQuery__
 *
 * To run a query within a React component, call `useGetCapabilityPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapabilityPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapabilityPackagesQuery({
 *   variables: {
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetCapabilityPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GetCapabilityPackagesQuery, GetCapabilityPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapabilityPackagesQuery, GetCapabilityPackagesQueryVariables>(GetCapabilityPackagesDocument, options);
      }
export function useGetCapabilityPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapabilityPackagesQuery, GetCapabilityPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapabilityPackagesQuery, GetCapabilityPackagesQueryVariables>(GetCapabilityPackagesDocument, options);
        }
export function useGetCapabilityPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCapabilityPackagesQuery, GetCapabilityPackagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCapabilityPackagesQuery, GetCapabilityPackagesQueryVariables>(GetCapabilityPackagesDocument, options);
        }
export type GetCapabilityPackagesQueryHookResult = ReturnType<typeof useGetCapabilityPackagesQuery>;
export type GetCapabilityPackagesLazyQueryHookResult = ReturnType<typeof useGetCapabilityPackagesLazyQuery>;
export type GetCapabilityPackagesSuspenseQueryHookResult = ReturnType<typeof useGetCapabilityPackagesSuspenseQuery>;
export type GetCapabilityPackagesQueryResult = Apollo.QueryResult<GetCapabilityPackagesQuery, GetCapabilityPackagesQueryVariables>;
export const GetCapabilityCatalogDocument = gql`
    query GetCapabilityCatalog {
  capabilityCatalog {
    capability
    group
    deviceBound
    grantsScanSeconds
    minDerivableScanSeconds
    validatedAtScanSeconds
  }
}
    `;

/**
 * __useGetCapabilityCatalogQuery__
 *
 * To run a query within a React component, call `useGetCapabilityCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapabilityCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapabilityCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCapabilityCatalogQuery(baseOptions?: Apollo.QueryHookOptions<GetCapabilityCatalogQuery, GetCapabilityCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapabilityCatalogQuery, GetCapabilityCatalogQueryVariables>(GetCapabilityCatalogDocument, options);
      }
export function useGetCapabilityCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapabilityCatalogQuery, GetCapabilityCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapabilityCatalogQuery, GetCapabilityCatalogQueryVariables>(GetCapabilityCatalogDocument, options);
        }
export function useGetCapabilityCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCapabilityCatalogQuery, GetCapabilityCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCapabilityCatalogQuery, GetCapabilityCatalogQueryVariables>(GetCapabilityCatalogDocument, options);
        }
export type GetCapabilityCatalogQueryHookResult = ReturnType<typeof useGetCapabilityCatalogQuery>;
export type GetCapabilityCatalogLazyQueryHookResult = ReturnType<typeof useGetCapabilityCatalogLazyQuery>;
export type GetCapabilityCatalogSuspenseQueryHookResult = ReturnType<typeof useGetCapabilityCatalogSuspenseQuery>;
export type GetCapabilityCatalogQueryResult = Apollo.QueryResult<GetCapabilityCatalogQuery, GetCapabilityCatalogQueryVariables>;
export const GetCapabilitySettingsDocument = gql`
    query GetCapabilitySettings {
  capabilitySettings {
    settingsId
    floorPackageKey
    trialMonths
    trialGraceDays
    trialPackageKey
    defaultPurchaseProduct
    enforcementActive
    enforcedGates
    updatedBy
    updatedAt
  }
}
    `;

/**
 * __useGetCapabilitySettingsQuery__
 *
 * To run a query within a React component, call `useGetCapabilitySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapabilitySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapabilitySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCapabilitySettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetCapabilitySettingsQuery, GetCapabilitySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapabilitySettingsQuery, GetCapabilitySettingsQueryVariables>(GetCapabilitySettingsDocument, options);
      }
export function useGetCapabilitySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapabilitySettingsQuery, GetCapabilitySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapabilitySettingsQuery, GetCapabilitySettingsQueryVariables>(GetCapabilitySettingsDocument, options);
        }
export function useGetCapabilitySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCapabilitySettingsQuery, GetCapabilitySettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCapabilitySettingsQuery, GetCapabilitySettingsQueryVariables>(GetCapabilitySettingsDocument, options);
        }
export type GetCapabilitySettingsQueryHookResult = ReturnType<typeof useGetCapabilitySettingsQuery>;
export type GetCapabilitySettingsLazyQueryHookResult = ReturnType<typeof useGetCapabilitySettingsLazyQuery>;
export type GetCapabilitySettingsSuspenseQueryHookResult = ReturnType<typeof useGetCapabilitySettingsSuspenseQuery>;
export type GetCapabilitySettingsQueryResult = Apollo.QueryResult<GetCapabilitySettingsQuery, GetCapabilitySettingsQueryVariables>;
export const GetPackageChangeImpactDocument = gql`
    query GetPackageChangeImpact($input: PackageChangeImpactInput!) {
  packageChangeImpact(input: $input) {
    packageKey
    changeKind
    fleetWide
    holdersInScope
    addedCapabilities
    removedCapabilities {
      capability
      affectedHolderCount
      retainedHolderCount
      sampleSubjectIds
    }
    dialChanges {
      dial
      currentValue
      proposedValue
      tightened
    }
    warnings
  }
}
    `;

/**
 * __useGetPackageChangeImpactQuery__
 *
 * To run a query within a React component, call `useGetPackageChangeImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageChangeImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageChangeImpactQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPackageChangeImpactQuery(baseOptions: Apollo.QueryHookOptions<GetPackageChangeImpactQuery, GetPackageChangeImpactQueryVariables> & ({ variables: GetPackageChangeImpactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageChangeImpactQuery, GetPackageChangeImpactQueryVariables>(GetPackageChangeImpactDocument, options);
      }
export function useGetPackageChangeImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageChangeImpactQuery, GetPackageChangeImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageChangeImpactQuery, GetPackageChangeImpactQueryVariables>(GetPackageChangeImpactDocument, options);
        }
export function useGetPackageChangeImpactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPackageChangeImpactQuery, GetPackageChangeImpactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPackageChangeImpactQuery, GetPackageChangeImpactQueryVariables>(GetPackageChangeImpactDocument, options);
        }
export type GetPackageChangeImpactQueryHookResult = ReturnType<typeof useGetPackageChangeImpactQuery>;
export type GetPackageChangeImpactLazyQueryHookResult = ReturnType<typeof useGetPackageChangeImpactLazyQuery>;
export type GetPackageChangeImpactSuspenseQueryHookResult = ReturnType<typeof useGetPackageChangeImpactSuspenseQuery>;
export type GetPackageChangeImpactQueryResult = Apollo.QueryResult<GetPackageChangeImpactQuery, GetPackageChangeImpactQueryVariables>;
export const DefineCapabilityPackageDocument = gql`
    mutation DefineCapabilityPackage($input: DefineCapabilityPackageInput!) {
  defineCapabilityPackage(input: $input) {
    id
  }
}
    `;
export type DefineCapabilityPackageMutationFn = Apollo.MutationFunction<DefineCapabilityPackageMutation, DefineCapabilityPackageMutationVariables>;

/**
 * __useDefineCapabilityPackageMutation__
 *
 * To run a mutation, you first call `useDefineCapabilityPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineCapabilityPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineCapabilityPackageMutation, { data, loading, error }] = useDefineCapabilityPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefineCapabilityPackageMutation(baseOptions?: Apollo.MutationHookOptions<DefineCapabilityPackageMutation, DefineCapabilityPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DefineCapabilityPackageMutation, DefineCapabilityPackageMutationVariables>(DefineCapabilityPackageDocument, options);
      }
export type DefineCapabilityPackageMutationHookResult = ReturnType<typeof useDefineCapabilityPackageMutation>;
export type DefineCapabilityPackageMutationResult = Apollo.MutationResult<DefineCapabilityPackageMutation>;
export type DefineCapabilityPackageMutationOptions = Apollo.BaseMutationOptions<DefineCapabilityPackageMutation, DefineCapabilityPackageMutationVariables>;
export const UpdateCapabilityPackageContentsDocument = gql`
    mutation UpdateCapabilityPackageContents($input: UpdateCapabilityPackageContentsInput!) {
  updateCapabilityPackageContents(input: $input) {
    id
  }
}
    `;
export type UpdateCapabilityPackageContentsMutationFn = Apollo.MutationFunction<UpdateCapabilityPackageContentsMutation, UpdateCapabilityPackageContentsMutationVariables>;

/**
 * __useUpdateCapabilityPackageContentsMutation__
 *
 * To run a mutation, you first call `useUpdateCapabilityPackageContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapabilityPackageContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapabilityPackageContentsMutation, { data, loading, error }] = useUpdateCapabilityPackageContentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCapabilityPackageContentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCapabilityPackageContentsMutation, UpdateCapabilityPackageContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCapabilityPackageContentsMutation, UpdateCapabilityPackageContentsMutationVariables>(UpdateCapabilityPackageContentsDocument, options);
      }
export type UpdateCapabilityPackageContentsMutationHookResult = ReturnType<typeof useUpdateCapabilityPackageContentsMutation>;
export type UpdateCapabilityPackageContentsMutationResult = Apollo.MutationResult<UpdateCapabilityPackageContentsMutation>;
export type UpdateCapabilityPackageContentsMutationOptions = Apollo.BaseMutationOptions<UpdateCapabilityPackageContentsMutation, UpdateCapabilityPackageContentsMutationVariables>;
export const ArchiveCapabilityPackageDocument = gql`
    mutation ArchiveCapabilityPackage($packageKey: ID!, $shrinkMode: ShrinkMode, $confirmedBy: String) {
  archiveCapabilityPackage(
    packageKey: $packageKey
    shrinkMode: $shrinkMode
    confirmedBy: $confirmedBy
  ) {
    id
  }
}
    `;
export type ArchiveCapabilityPackageMutationFn = Apollo.MutationFunction<ArchiveCapabilityPackageMutation, ArchiveCapabilityPackageMutationVariables>;

/**
 * __useArchiveCapabilityPackageMutation__
 *
 * To run a mutation, you first call `useArchiveCapabilityPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCapabilityPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCapabilityPackageMutation, { data, loading, error }] = useArchiveCapabilityPackageMutation({
 *   variables: {
 *      packageKey: // value for 'packageKey'
 *      shrinkMode: // value for 'shrinkMode'
 *      confirmedBy: // value for 'confirmedBy'
 *   },
 * });
 */
export function useArchiveCapabilityPackageMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCapabilityPackageMutation, ArchiveCapabilityPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCapabilityPackageMutation, ArchiveCapabilityPackageMutationVariables>(ArchiveCapabilityPackageDocument, options);
      }
export type ArchiveCapabilityPackageMutationHookResult = ReturnType<typeof useArchiveCapabilityPackageMutation>;
export type ArchiveCapabilityPackageMutationResult = Apollo.MutationResult<ArchiveCapabilityPackageMutation>;
export type ArchiveCapabilityPackageMutationOptions = Apollo.BaseMutationOptions<ArchiveCapabilityPackageMutation, ArchiveCapabilityPackageMutationVariables>;
export const PlaceCapabilityPackageDocument = gql`
    mutation PlaceCapabilityPackage($packageKey: ID!, $sitsAbove: ID) {
  placeCapabilityPackage(packageKey: $packageKey, sitsAbove: $sitsAbove) {
    id
  }
}
    `;
export type PlaceCapabilityPackageMutationFn = Apollo.MutationFunction<PlaceCapabilityPackageMutation, PlaceCapabilityPackageMutationVariables>;

/**
 * __usePlaceCapabilityPackageMutation__
 *
 * To run a mutation, you first call `usePlaceCapabilityPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceCapabilityPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeCapabilityPackageMutation, { data, loading, error }] = usePlaceCapabilityPackageMutation({
 *   variables: {
 *      packageKey: // value for 'packageKey'
 *      sitsAbove: // value for 'sitsAbove'
 *   },
 * });
 */
export function usePlaceCapabilityPackageMutation(baseOptions?: Apollo.MutationHookOptions<PlaceCapabilityPackageMutation, PlaceCapabilityPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceCapabilityPackageMutation, PlaceCapabilityPackageMutationVariables>(PlaceCapabilityPackageDocument, options);
      }
export type PlaceCapabilityPackageMutationHookResult = ReturnType<typeof usePlaceCapabilityPackageMutation>;
export type PlaceCapabilityPackageMutationResult = Apollo.MutationResult<PlaceCapabilityPackageMutation>;
export type PlaceCapabilityPackageMutationOptions = Apollo.BaseMutationOptions<PlaceCapabilityPackageMutation, PlaceCapabilityPackageMutationVariables>;
export const UpdateCapabilitySettingsDocument = gql`
    mutation UpdateCapabilitySettings($input: UpdateCapabilitySettingsInput!) {
  updateCapabilitySettings(input: $input) {
    id
  }
}
    `;
export type UpdateCapabilitySettingsMutationFn = Apollo.MutationFunction<UpdateCapabilitySettingsMutation, UpdateCapabilitySettingsMutationVariables>;

/**
 * __useUpdateCapabilitySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCapabilitySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapabilitySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapabilitySettingsMutation, { data, loading, error }] = useUpdateCapabilitySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCapabilitySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCapabilitySettingsMutation, UpdateCapabilitySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCapabilitySettingsMutation, UpdateCapabilitySettingsMutationVariables>(UpdateCapabilitySettingsDocument, options);
      }
export type UpdateCapabilitySettingsMutationHookResult = ReturnType<typeof useUpdateCapabilitySettingsMutation>;
export type UpdateCapabilitySettingsMutationResult = Apollo.MutationResult<UpdateCapabilitySettingsMutation>;
export type UpdateCapabilitySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCapabilitySettingsMutation, UpdateCapabilitySettingsMutationVariables>;
export const GetMemberCapabilitiesDocument = gql`
    query GetMemberCapabilities($subjectId: ID!) {
  memberCapabilities(subjectId: $subjectId) {
    subjectId
    holderId
    effectiveCapabilities
    effectiveDials {
      dial
      value
    }
    provenance {
      capability
      sources {
        origin
        packageKey
        packageName
        grantId
        grantSource
        reason
        grantedBy
        expiresAt
      }
    }
    grants {
      grantId
      packageKey
      capabilities
      dials {
        dial
        value
      }
      source
      sourceRef
      reason
      grantedBy
      grantedAt
      expiresAt
      active
    }
    scheduledChanges {
      changeId
      fromPackageKey
      toPackageKey
      effectiveAt
      status
      source
      sourceRef
    }
  }
}
    `;

/**
 * __useGetMemberCapabilitiesQuery__
 *
 * To run a query within a React component, call `useGetMemberCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberCapabilitiesQuery({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *   },
 * });
 */
export function useGetMemberCapabilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetMemberCapabilitiesQuery, GetMemberCapabilitiesQueryVariables> & ({ variables: GetMemberCapabilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberCapabilitiesQuery, GetMemberCapabilitiesQueryVariables>(GetMemberCapabilitiesDocument, options);
      }
export function useGetMemberCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberCapabilitiesQuery, GetMemberCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberCapabilitiesQuery, GetMemberCapabilitiesQueryVariables>(GetMemberCapabilitiesDocument, options);
        }
export function useGetMemberCapabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMemberCapabilitiesQuery, GetMemberCapabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberCapabilitiesQuery, GetMemberCapabilitiesQueryVariables>(GetMemberCapabilitiesDocument, options);
        }
export type GetMemberCapabilitiesQueryHookResult = ReturnType<typeof useGetMemberCapabilitiesQuery>;
export type GetMemberCapabilitiesLazyQueryHookResult = ReturnType<typeof useGetMemberCapabilitiesLazyQuery>;
export type GetMemberCapabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetMemberCapabilitiesSuspenseQuery>;
export type GetMemberCapabilitiesQueryResult = Apollo.QueryResult<GetMemberCapabilitiesQuery, GetMemberCapabilitiesQueryVariables>;
export const GrantCompPackageDocument = gql`
    mutation GrantCompPackage($input: GrantCompPackageInput!) {
  grantCompPackage(input: $input) {
    id
  }
}
    `;
export type GrantCompPackageMutationFn = Apollo.MutationFunction<GrantCompPackageMutation, GrantCompPackageMutationVariables>;

/**
 * __useGrantCompPackageMutation__
 *
 * To run a mutation, you first call `useGrantCompPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantCompPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantCompPackageMutation, { data, loading, error }] = useGrantCompPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantCompPackageMutation(baseOptions?: Apollo.MutationHookOptions<GrantCompPackageMutation, GrantCompPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantCompPackageMutation, GrantCompPackageMutationVariables>(GrantCompPackageDocument, options);
      }
export type GrantCompPackageMutationHookResult = ReturnType<typeof useGrantCompPackageMutation>;
export type GrantCompPackageMutationResult = Apollo.MutationResult<GrantCompPackageMutation>;
export type GrantCompPackageMutationOptions = Apollo.BaseMutationOptions<GrantCompPackageMutation, GrantCompPackageMutationVariables>;
export const RevokeCompCapabilityDocument = gql`
    mutation RevokeCompCapability($input: RevokeCompCapabilityInput!) {
  revokeCompCapability(input: $input) {
    id
  }
}
    `;
export type RevokeCompCapabilityMutationFn = Apollo.MutationFunction<RevokeCompCapabilityMutation, RevokeCompCapabilityMutationVariables>;

/**
 * __useRevokeCompCapabilityMutation__
 *
 * To run a mutation, you first call `useRevokeCompCapabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCompCapabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCompCapabilityMutation, { data, loading, error }] = useRevokeCompCapabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeCompCapabilityMutation(baseOptions?: Apollo.MutationHookOptions<RevokeCompCapabilityMutation, RevokeCompCapabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeCompCapabilityMutation, RevokeCompCapabilityMutationVariables>(RevokeCompCapabilityDocument, options);
      }
export type RevokeCompCapabilityMutationHookResult = ReturnType<typeof useRevokeCompCapabilityMutation>;
export type RevokeCompCapabilityMutationResult = Apollo.MutationResult<RevokeCompCapabilityMutation>;
export type RevokeCompCapabilityMutationOptions = Apollo.BaseMutationOptions<RevokeCompCapabilityMutation, RevokeCompCapabilityMutationVariables>;
export const GrantCustomCapabilitiesDocument = gql`
    mutation GrantCustomCapabilities($input: GrantCustomCapabilitiesInput!) {
  grantCustomCapabilities(input: $input) {
    id
  }
}
    `;
export type GrantCustomCapabilitiesMutationFn = Apollo.MutationFunction<GrantCustomCapabilitiesMutation, GrantCustomCapabilitiesMutationVariables>;

/**
 * __useGrantCustomCapabilitiesMutation__
 *
 * To run a mutation, you first call `useGrantCustomCapabilitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantCustomCapabilitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantCustomCapabilitiesMutation, { data, loading, error }] = useGrantCustomCapabilitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantCustomCapabilitiesMutation(baseOptions?: Apollo.MutationHookOptions<GrantCustomCapabilitiesMutation, GrantCustomCapabilitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantCustomCapabilitiesMutation, GrantCustomCapabilitiesMutationVariables>(GrantCustomCapabilitiesDocument, options);
      }
export type GrantCustomCapabilitiesMutationHookResult = ReturnType<typeof useGrantCustomCapabilitiesMutation>;
export type GrantCustomCapabilitiesMutationResult = Apollo.MutationResult<GrantCustomCapabilitiesMutation>;
export type GrantCustomCapabilitiesMutationOptions = Apollo.BaseMutationOptions<GrantCustomCapabilitiesMutation, GrantCustomCapabilitiesMutationVariables>;
export const RevokeCustomCapabilityGrantDocument = gql`
    mutation RevokeCustomCapabilityGrant($input: RevokeCustomCapabilityGrantInput!) {
  revokeCustomCapabilityGrant(input: $input) {
    id
  }
}
    `;
export type RevokeCustomCapabilityGrantMutationFn = Apollo.MutationFunction<RevokeCustomCapabilityGrantMutation, RevokeCustomCapabilityGrantMutationVariables>;

/**
 * __useRevokeCustomCapabilityGrantMutation__
 *
 * To run a mutation, you first call `useRevokeCustomCapabilityGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCustomCapabilityGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCustomCapabilityGrantMutation, { data, loading, error }] = useRevokeCustomCapabilityGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeCustomCapabilityGrantMutation(baseOptions?: Apollo.MutationHookOptions<RevokeCustomCapabilityGrantMutation, RevokeCustomCapabilityGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeCustomCapabilityGrantMutation, RevokeCustomCapabilityGrantMutationVariables>(RevokeCustomCapabilityGrantDocument, options);
      }
export type RevokeCustomCapabilityGrantMutationHookResult = ReturnType<typeof useRevokeCustomCapabilityGrantMutation>;
export type RevokeCustomCapabilityGrantMutationResult = Apollo.MutationResult<RevokeCustomCapabilityGrantMutation>;
export type RevokeCustomCapabilityGrantMutationOptions = Apollo.BaseMutationOptions<RevokeCustomCapabilityGrantMutation, RevokeCustomCapabilityGrantMutationVariables>;
export const GetDeviceOfflineSettingsDocument = gql`
    query GetDeviceOfflineSettings {
  deviceOfflineSettings {
    offlineSessionAllowance {
      value
      updatedBy
      updatedByName
      updatedAt
    }
    deviceOfflineCap {
      value
      updatedBy
      updatedByName
      updatedAt
    }
    deviceRecordWindowDays {
      value
      updatedBy
      updatedByName
      updatedAt
    }
  }
}
    `;

/**
 * __useGetDeviceOfflineSettingsQuery__
 *
 * To run a query within a React component, call `useGetDeviceOfflineSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceOfflineSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceOfflineSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDeviceOfflineSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetDeviceOfflineSettingsQuery, GetDeviceOfflineSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceOfflineSettingsQuery, GetDeviceOfflineSettingsQueryVariables>(GetDeviceOfflineSettingsDocument, options);
      }
export function useGetDeviceOfflineSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceOfflineSettingsQuery, GetDeviceOfflineSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceOfflineSettingsQuery, GetDeviceOfflineSettingsQueryVariables>(GetDeviceOfflineSettingsDocument, options);
        }
export function useGetDeviceOfflineSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeviceOfflineSettingsQuery, GetDeviceOfflineSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeviceOfflineSettingsQuery, GetDeviceOfflineSettingsQueryVariables>(GetDeviceOfflineSettingsDocument, options);
        }
export type GetDeviceOfflineSettingsQueryHookResult = ReturnType<typeof useGetDeviceOfflineSettingsQuery>;
export type GetDeviceOfflineSettingsLazyQueryHookResult = ReturnType<typeof useGetDeviceOfflineSettingsLazyQuery>;
export type GetDeviceOfflineSettingsSuspenseQueryHookResult = ReturnType<typeof useGetDeviceOfflineSettingsSuspenseQuery>;
export type GetDeviceOfflineSettingsQueryResult = Apollo.QueryResult<GetDeviceOfflineSettingsQuery, GetDeviceOfflineSettingsQueryVariables>;
export const UpdateOfflineSessionAllowanceDocument = gql`
    mutation UpdateOfflineSessionAllowance($value: Int!) {
  updateOfflineSessionAllowance(value: $value) {
    id
  }
}
    `;
export type UpdateOfflineSessionAllowanceMutationFn = Apollo.MutationFunction<UpdateOfflineSessionAllowanceMutation, UpdateOfflineSessionAllowanceMutationVariables>;

/**
 * __useUpdateOfflineSessionAllowanceMutation__
 *
 * To run a mutation, you first call `useUpdateOfflineSessionAllowanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfflineSessionAllowanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfflineSessionAllowanceMutation, { data, loading, error }] = useUpdateOfflineSessionAllowanceMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateOfflineSessionAllowanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfflineSessionAllowanceMutation, UpdateOfflineSessionAllowanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfflineSessionAllowanceMutation, UpdateOfflineSessionAllowanceMutationVariables>(UpdateOfflineSessionAllowanceDocument, options);
      }
export type UpdateOfflineSessionAllowanceMutationHookResult = ReturnType<typeof useUpdateOfflineSessionAllowanceMutation>;
export type UpdateOfflineSessionAllowanceMutationResult = Apollo.MutationResult<UpdateOfflineSessionAllowanceMutation>;
export type UpdateOfflineSessionAllowanceMutationOptions = Apollo.BaseMutationOptions<UpdateOfflineSessionAllowanceMutation, UpdateOfflineSessionAllowanceMutationVariables>;
export const UpdateDeviceOfflineCapDocument = gql`
    mutation UpdateDeviceOfflineCap($value: Int!) {
  updateDeviceOfflineCap(value: $value) {
    id
  }
}
    `;
export type UpdateDeviceOfflineCapMutationFn = Apollo.MutationFunction<UpdateDeviceOfflineCapMutation, UpdateDeviceOfflineCapMutationVariables>;

/**
 * __useUpdateDeviceOfflineCapMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceOfflineCapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceOfflineCapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceOfflineCapMutation, { data, loading, error }] = useUpdateDeviceOfflineCapMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateDeviceOfflineCapMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceOfflineCapMutation, UpdateDeviceOfflineCapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceOfflineCapMutation, UpdateDeviceOfflineCapMutationVariables>(UpdateDeviceOfflineCapDocument, options);
      }
export type UpdateDeviceOfflineCapMutationHookResult = ReturnType<typeof useUpdateDeviceOfflineCapMutation>;
export type UpdateDeviceOfflineCapMutationResult = Apollo.MutationResult<UpdateDeviceOfflineCapMutation>;
export type UpdateDeviceOfflineCapMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceOfflineCapMutation, UpdateDeviceOfflineCapMutationVariables>;
export const UpdateDeviceRecordWindowDaysDocument = gql`
    mutation UpdateDeviceRecordWindowDays($days: Int!) {
  updateDeviceRecordWindowDays(days: $days) {
    id
  }
}
    `;
export type UpdateDeviceRecordWindowDaysMutationFn = Apollo.MutationFunction<UpdateDeviceRecordWindowDaysMutation, UpdateDeviceRecordWindowDaysMutationVariables>;

/**
 * __useUpdateDeviceRecordWindowDaysMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceRecordWindowDaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceRecordWindowDaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceRecordWindowDaysMutation, { data, loading, error }] = useUpdateDeviceRecordWindowDaysMutation({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useUpdateDeviceRecordWindowDaysMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceRecordWindowDaysMutation, UpdateDeviceRecordWindowDaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceRecordWindowDaysMutation, UpdateDeviceRecordWindowDaysMutationVariables>(UpdateDeviceRecordWindowDaysDocument, options);
      }
export type UpdateDeviceRecordWindowDaysMutationHookResult = ReturnType<typeof useUpdateDeviceRecordWindowDaysMutation>;
export type UpdateDeviceRecordWindowDaysMutationResult = Apollo.MutationResult<UpdateDeviceRecordWindowDaysMutation>;
export type UpdateDeviceRecordWindowDaysMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceRecordWindowDaysMutation, UpdateDeviceRecordWindowDaysMutationVariables>;
export const GetStoneModesForPickerDocument = gql`
    query GetStoneModesForPicker {
  stoneModeCatalogue {
    modes {
      modeId
      displayName
      generation
      enabled
      position
    }
  }
}
    `;

/**
 * __useGetStoneModesForPickerQuery__
 *
 * To run a query within a React component, call `useGetStoneModesForPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoneModesForPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoneModesForPickerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoneModesForPickerQuery(baseOptions?: Apollo.QueryHookOptions<GetStoneModesForPickerQuery, GetStoneModesForPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoneModesForPickerQuery, GetStoneModesForPickerQueryVariables>(GetStoneModesForPickerDocument, options);
      }
export function useGetStoneModesForPickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoneModesForPickerQuery, GetStoneModesForPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoneModesForPickerQuery, GetStoneModesForPickerQueryVariables>(GetStoneModesForPickerDocument, options);
        }
export function useGetStoneModesForPickerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoneModesForPickerQuery, GetStoneModesForPickerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoneModesForPickerQuery, GetStoneModesForPickerQueryVariables>(GetStoneModesForPickerDocument, options);
        }
export type GetStoneModesForPickerQueryHookResult = ReturnType<typeof useGetStoneModesForPickerQuery>;
export type GetStoneModesForPickerLazyQueryHookResult = ReturnType<typeof useGetStoneModesForPickerLazyQuery>;
export type GetStoneModesForPickerSuspenseQueryHookResult = ReturnType<typeof useGetStoneModesForPickerSuspenseQuery>;
export type GetStoneModesForPickerQueryResult = Apollo.QueryResult<GetStoneModesForPickerQuery, GetStoneModesForPickerQueryVariables>;
export const SetCapabilityPackageModesDocument = gql`
    mutation SetCapabilityPackageModes($input: SetCapabilityPackageModesInput!) {
  setCapabilityPackageModes(input: $input) {
    id
  }
}
    `;
export type SetCapabilityPackageModesMutationFn = Apollo.MutationFunction<SetCapabilityPackageModesMutation, SetCapabilityPackageModesMutationVariables>;

/**
 * __useSetCapabilityPackageModesMutation__
 *
 * To run a mutation, you first call `useSetCapabilityPackageModesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCapabilityPackageModesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCapabilityPackageModesMutation, { data, loading, error }] = useSetCapabilityPackageModesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCapabilityPackageModesMutation(baseOptions?: Apollo.MutationHookOptions<SetCapabilityPackageModesMutation, SetCapabilityPackageModesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCapabilityPackageModesMutation, SetCapabilityPackageModesMutationVariables>(SetCapabilityPackageModesDocument, options);
      }
export type SetCapabilityPackageModesMutationHookResult = ReturnType<typeof useSetCapabilityPackageModesMutation>;
export type SetCapabilityPackageModesMutationResult = Apollo.MutationResult<SetCapabilityPackageModesMutation>;
export type SetCapabilityPackageModesMutationOptions = Apollo.BaseMutationOptions<SetCapabilityPackageModesMutation, SetCapabilityPackageModesMutationVariables>;
export const StartChatDocument = gql`
    mutation StartChat($participantId: ID!) {
  startChat(participantId: $participantId) {
    channelId
    paused
  }
}
    `;
export type StartChatMutationFn = Apollo.MutationFunction<StartChatMutation, StartChatMutationVariables>;

/**
 * __useStartChatMutation__
 *
 * To run a mutation, you first call `useStartChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startChatMutation, { data, loading, error }] = useStartChatMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useStartChatMutation(baseOptions?: Apollo.MutationHookOptions<StartChatMutation, StartChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartChatMutation, StartChatMutationVariables>(StartChatDocument, options);
      }
export type StartChatMutationHookResult = ReturnType<typeof useStartChatMutation>;
export type StartChatMutationResult = Apollo.MutationResult<StartChatMutation>;
export type StartChatMutationOptions = Apollo.BaseMutationOptions<StartChatMutation, StartChatMutationVariables>;
export const GetChatUserDocument = gql`
    query GetChatUser {
  me {
    ... on Participant {
      participantId
      pii {
        identityInformation {
          firstName
          middleName
          lastName
        }
      }
      messagingToken {
        token
        provider
      }
    }
    ... on Nurse {
      nurseId
      pii {
        identityInformation {
          firstName
          middleName
          lastName
        }
      }
      messagingToken {
        token
        provider
      }
    }
  }
}
    `;

/**
 * __useGetChatUserQuery__
 *
 * To run a query within a React component, call `useGetChatUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChatUserQuery(baseOptions?: Apollo.QueryHookOptions<GetChatUserQuery, GetChatUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatUserQuery, GetChatUserQueryVariables>(GetChatUserDocument, options);
      }
export function useGetChatUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatUserQuery, GetChatUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatUserQuery, GetChatUserQueryVariables>(GetChatUserDocument, options);
        }
export function useGetChatUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatUserQuery, GetChatUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatUserQuery, GetChatUserQueryVariables>(GetChatUserDocument, options);
        }
export type GetChatUserQueryHookResult = ReturnType<typeof useGetChatUserQuery>;
export type GetChatUserLazyQueryHookResult = ReturnType<typeof useGetChatUserLazyQuery>;
export type GetChatUserSuspenseQueryHookResult = ReturnType<typeof useGetChatUserSuspenseQuery>;
export type GetChatUserQueryResult = Apollo.QueryResult<GetChatUserQuery, GetChatUserQueryVariables>;
export const GetCohortsDocument = gql`
    query GetCohorts {
  cohorts {
    id
    name
    description
    memberCount
  }
}
    `;

/**
 * __useGetCohortsQuery__
 *
 * To run a query within a React component, call `useGetCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCohortsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCohortsQuery(baseOptions?: Apollo.QueryHookOptions<GetCohortsQuery, GetCohortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCohortsQuery, GetCohortsQueryVariables>(GetCohortsDocument, options);
      }
export function useGetCohortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCohortsQuery, GetCohortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCohortsQuery, GetCohortsQueryVariables>(GetCohortsDocument, options);
        }
export function useGetCohortsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCohortsQuery, GetCohortsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCohortsQuery, GetCohortsQueryVariables>(GetCohortsDocument, options);
        }
export type GetCohortsQueryHookResult = ReturnType<typeof useGetCohortsQuery>;
export type GetCohortsLazyQueryHookResult = ReturnType<typeof useGetCohortsLazyQuery>;
export type GetCohortsSuspenseQueryHookResult = ReturnType<typeof useGetCohortsSuspenseQuery>;
export type GetCohortsQueryResult = Apollo.QueryResult<GetCohortsQuery, GetCohortsQueryVariables>;
export const GetCohortMembersDocument = gql`
    query GetCohortMembers($cohortId: ID!) {
  cohortMembers(cohortId: $cohortId) {
    cohort {
      id
      name
      description
      memberCount
    }
    memberIds
    members {
      userId
      pii {
        identityInformation {
          firstName
          lastName
        }
        contactInformation {
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetCohortMembersQuery__
 *
 * To run a query within a React component, call `useGetCohortMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCohortMembersQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useGetCohortMembersQuery(baseOptions: Apollo.QueryHookOptions<GetCohortMembersQuery, GetCohortMembersQueryVariables> & ({ variables: GetCohortMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCohortMembersQuery, GetCohortMembersQueryVariables>(GetCohortMembersDocument, options);
      }
export function useGetCohortMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCohortMembersQuery, GetCohortMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCohortMembersQuery, GetCohortMembersQueryVariables>(GetCohortMembersDocument, options);
        }
export function useGetCohortMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCohortMembersQuery, GetCohortMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCohortMembersQuery, GetCohortMembersQueryVariables>(GetCohortMembersDocument, options);
        }
export type GetCohortMembersQueryHookResult = ReturnType<typeof useGetCohortMembersQuery>;
export type GetCohortMembersLazyQueryHookResult = ReturnType<typeof useGetCohortMembersLazyQuery>;
export type GetCohortMembersSuspenseQueryHookResult = ReturnType<typeof useGetCohortMembersSuspenseQuery>;
export type GetCohortMembersQueryResult = Apollo.QueryResult<GetCohortMembersQuery, GetCohortMembersQueryVariables>;
export const GetConsultRosterDocument = gql`
    query GetConsultRoster {
  consultRoster {
    participantId
    name
    email
    consultStatus
    needsInitialConsult
    totalConsults
    attendedConsults
    lastConsultDate
    nextScheduledDate
  }
}
    `;

/**
 * __useGetConsultRosterQuery__
 *
 * To run a query within a React component, call `useGetConsultRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultRosterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConsultRosterQuery(baseOptions?: Apollo.QueryHookOptions<GetConsultRosterQuery, GetConsultRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultRosterQuery, GetConsultRosterQueryVariables>(GetConsultRosterDocument, options);
      }
export function useGetConsultRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultRosterQuery, GetConsultRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultRosterQuery, GetConsultRosterQueryVariables>(GetConsultRosterDocument, options);
        }
export function useGetConsultRosterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsultRosterQuery, GetConsultRosterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultRosterQuery, GetConsultRosterQueryVariables>(GetConsultRosterDocument, options);
        }
export type GetConsultRosterQueryHookResult = ReturnType<typeof useGetConsultRosterQuery>;
export type GetConsultRosterLazyQueryHookResult = ReturnType<typeof useGetConsultRosterLazyQuery>;
export type GetConsultRosterSuspenseQueryHookResult = ReturnType<typeof useGetConsultRosterSuspenseQuery>;
export type GetConsultRosterQueryResult = Apollo.QueryResult<GetConsultRosterQuery, GetConsultRosterQueryVariables>;
export const GetConsultsDocument = gql`
    query GetConsults($participantId: ID!) {
  consults(participantId: $participantId) {
    consultNumber
    consultType
    scheduledDate
    outcome
    notes
    scheduledBy
    participantId
    linkedNotes {
      noteId
      content
      categories
      createdAt
    }
  }
}
    `;

/**
 * __useGetConsultsQuery__
 *
 * To run a query within a React component, call `useGetConsultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetConsultsQuery(baseOptions: Apollo.QueryHookOptions<GetConsultsQuery, GetConsultsQueryVariables> & ({ variables: GetConsultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultsQuery, GetConsultsQueryVariables>(GetConsultsDocument, options);
      }
export function useGetConsultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultsQuery, GetConsultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultsQuery, GetConsultsQueryVariables>(GetConsultsDocument, options);
        }
export function useGetConsultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsultsQuery, GetConsultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultsQuery, GetConsultsQueryVariables>(GetConsultsDocument, options);
        }
export type GetConsultsQueryHookResult = ReturnType<typeof useGetConsultsQuery>;
export type GetConsultsLazyQueryHookResult = ReturnType<typeof useGetConsultsLazyQuery>;
export type GetConsultsSuspenseQueryHookResult = ReturnType<typeof useGetConsultsSuspenseQuery>;
export type GetConsultsQueryResult = Apollo.QueryResult<GetConsultsQuery, GetConsultsQueryVariables>;
export const ScheduleConsultDocument = gql`
    mutation ScheduleConsult($participantId: ID!, $type: ConsultType!, $scheduledDate: DateTime!, $notes: String) {
  scheduleConsult(
    participantId: $participantId
    type: $type
    scheduledDate: $scheduledDate
    notes: $notes
  ) {
    id
  }
}
    `;
export type ScheduleConsultMutationFn = Apollo.MutationFunction<ScheduleConsultMutation, ScheduleConsultMutationVariables>;

/**
 * __useScheduleConsultMutation__
 *
 * To run a mutation, you first call `useScheduleConsultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleConsultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleConsultMutation, { data, loading, error }] = useScheduleConsultMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      type: // value for 'type'
 *      scheduledDate: // value for 'scheduledDate'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useScheduleConsultMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleConsultMutation, ScheduleConsultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleConsultMutation, ScheduleConsultMutationVariables>(ScheduleConsultDocument, options);
      }
export type ScheduleConsultMutationHookResult = ReturnType<typeof useScheduleConsultMutation>;
export type ScheduleConsultMutationResult = Apollo.MutationResult<ScheduleConsultMutation>;
export type ScheduleConsultMutationOptions = Apollo.BaseMutationOptions<ScheduleConsultMutation, ScheduleConsultMutationVariables>;
export const RecordPastConsultDocument = gql`
    mutation RecordPastConsult($participantId: ID!, $type: ConsultType!, $scheduledDate: DateTime!, $outcome: ConsultOutcome!, $notes: String) {
  recordPastConsult(
    participantId: $participantId
    type: $type
    scheduledDate: $scheduledDate
    outcome: $outcome
    notes: $notes
  ) {
    id
  }
}
    `;
export type RecordPastConsultMutationFn = Apollo.MutationFunction<RecordPastConsultMutation, RecordPastConsultMutationVariables>;

/**
 * __useRecordPastConsultMutation__
 *
 * To run a mutation, you first call `useRecordPastConsultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPastConsultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPastConsultMutation, { data, loading, error }] = useRecordPastConsultMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      type: // value for 'type'
 *      scheduledDate: // value for 'scheduledDate'
 *      outcome: // value for 'outcome'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useRecordPastConsultMutation(baseOptions?: Apollo.MutationHookOptions<RecordPastConsultMutation, RecordPastConsultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordPastConsultMutation, RecordPastConsultMutationVariables>(RecordPastConsultDocument, options);
      }
export type RecordPastConsultMutationHookResult = ReturnType<typeof useRecordPastConsultMutation>;
export type RecordPastConsultMutationResult = Apollo.MutationResult<RecordPastConsultMutation>;
export type RecordPastConsultMutationOptions = Apollo.BaseMutationOptions<RecordPastConsultMutation, RecordPastConsultMutationVariables>;
export const RecordConsultOutcomeDocument = gql`
    mutation RecordConsultOutcome($participantId: ID!, $consultNumber: Int!, $outcome: ConsultOutcome!, $notes: String) {
  recordConsultOutcome(
    participantId: $participantId
    consultNumber: $consultNumber
    outcome: $outcome
    notes: $notes
  ) {
    id
  }
}
    `;
export type RecordConsultOutcomeMutationFn = Apollo.MutationFunction<RecordConsultOutcomeMutation, RecordConsultOutcomeMutationVariables>;

/**
 * __useRecordConsultOutcomeMutation__
 *
 * To run a mutation, you first call `useRecordConsultOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordConsultOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordConsultOutcomeMutation, { data, loading, error }] = useRecordConsultOutcomeMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      consultNumber: // value for 'consultNumber'
 *      outcome: // value for 'outcome'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useRecordConsultOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<RecordConsultOutcomeMutation, RecordConsultOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordConsultOutcomeMutation, RecordConsultOutcomeMutationVariables>(RecordConsultOutcomeDocument, options);
      }
export type RecordConsultOutcomeMutationHookResult = ReturnType<typeof useRecordConsultOutcomeMutation>;
export type RecordConsultOutcomeMutationResult = Apollo.MutationResult<RecordConsultOutcomeMutation>;
export type RecordConsultOutcomeMutationOptions = Apollo.BaseMutationOptions<RecordConsultOutcomeMutation, RecordConsultOutcomeMutationVariables>;
export const CancelConsultDocument = gql`
    mutation CancelConsult($participantId: ID!, $consultNumber: Int!) {
  cancelConsult(participantId: $participantId, consultNumber: $consultNumber) {
    id
  }
}
    `;
export type CancelConsultMutationFn = Apollo.MutationFunction<CancelConsultMutation, CancelConsultMutationVariables>;

/**
 * __useCancelConsultMutation__
 *
 * To run a mutation, you first call `useCancelConsultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelConsultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelConsultMutation, { data, loading, error }] = useCancelConsultMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      consultNumber: // value for 'consultNumber'
 *   },
 * });
 */
export function useCancelConsultMutation(baseOptions?: Apollo.MutationHookOptions<CancelConsultMutation, CancelConsultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelConsultMutation, CancelConsultMutationVariables>(CancelConsultDocument, options);
      }
export type CancelConsultMutationHookResult = ReturnType<typeof useCancelConsultMutation>;
export type CancelConsultMutationResult = Apollo.MutationResult<CancelConsultMutation>;
export type CancelConsultMutationOptions = Apollo.BaseMutationOptions<CancelConsultMutation, CancelConsultMutationVariables>;
export const GetAcquisitionSourcesDocument = gql`
    query GetAcquisitionSources($filter: AcquisitionSourceFilter, $pagination: PaginationInput) {
  acquisitionSources(filter: $filter, pagination: $pagination) {
    edges {
      cursor
      node {
        ...AcquisitionSourceFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${AcquisitionSourceFieldsFragmentDoc}`;

/**
 * __useGetAcquisitionSourcesQuery__
 *
 * To run a query within a React component, call `useGetAcquisitionSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcquisitionSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcquisitionSourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAcquisitionSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetAcquisitionSourcesQuery, GetAcquisitionSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcquisitionSourcesQuery, GetAcquisitionSourcesQueryVariables>(GetAcquisitionSourcesDocument, options);
      }
export function useGetAcquisitionSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcquisitionSourcesQuery, GetAcquisitionSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcquisitionSourcesQuery, GetAcquisitionSourcesQueryVariables>(GetAcquisitionSourcesDocument, options);
        }
export function useGetAcquisitionSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAcquisitionSourcesQuery, GetAcquisitionSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAcquisitionSourcesQuery, GetAcquisitionSourcesQueryVariables>(GetAcquisitionSourcesDocument, options);
        }
export type GetAcquisitionSourcesQueryHookResult = ReturnType<typeof useGetAcquisitionSourcesQuery>;
export type GetAcquisitionSourcesLazyQueryHookResult = ReturnType<typeof useGetAcquisitionSourcesLazyQuery>;
export type GetAcquisitionSourcesSuspenseQueryHookResult = ReturnType<typeof useGetAcquisitionSourcesSuspenseQuery>;
export type GetAcquisitionSourcesQueryResult = Apollo.QueryResult<GetAcquisitionSourcesQuery, GetAcquisitionSourcesQueryVariables>;
export const GetAcquisitionSourceDocument = gql`
    query GetAcquisitionSource($sourceId: ID!) {
  acquisitionSource(sourceId: $sourceId) {
    ...AcquisitionSourceFields
  }
}
    ${AcquisitionSourceFieldsFragmentDoc}`;

/**
 * __useGetAcquisitionSourceQuery__
 *
 * To run a query within a React component, call `useGetAcquisitionSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcquisitionSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcquisitionSourceQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useGetAcquisitionSourceQuery(baseOptions: Apollo.QueryHookOptions<GetAcquisitionSourceQuery, GetAcquisitionSourceQueryVariables> & ({ variables: GetAcquisitionSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcquisitionSourceQuery, GetAcquisitionSourceQueryVariables>(GetAcquisitionSourceDocument, options);
      }
export function useGetAcquisitionSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcquisitionSourceQuery, GetAcquisitionSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcquisitionSourceQuery, GetAcquisitionSourceQueryVariables>(GetAcquisitionSourceDocument, options);
        }
export function useGetAcquisitionSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAcquisitionSourceQuery, GetAcquisitionSourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAcquisitionSourceQuery, GetAcquisitionSourceQueryVariables>(GetAcquisitionSourceDocument, options);
        }
export type GetAcquisitionSourceQueryHookResult = ReturnType<typeof useGetAcquisitionSourceQuery>;
export type GetAcquisitionSourceLazyQueryHookResult = ReturnType<typeof useGetAcquisitionSourceLazyQuery>;
export type GetAcquisitionSourceSuspenseQueryHookResult = ReturnType<typeof useGetAcquisitionSourceSuspenseQuery>;
export type GetAcquisitionSourceQueryResult = Apollo.QueryResult<GetAcquisitionSourceQuery, GetAcquisitionSourceQueryVariables>;
export const CreateAcquisitionSourceDocument = gql`
    mutation CreateAcquisitionSource($cmd: CreateAcquisitionSourceInput!, $couponCodes: [String!]) {
  createAcquisitionSource(cmd: $cmd, couponCodes: $couponCodes) {
    ...AcquisitionSourceFields
  }
}
    ${AcquisitionSourceFieldsFragmentDoc}`;
export type CreateAcquisitionSourceMutationFn = Apollo.MutationFunction<CreateAcquisitionSourceMutation, CreateAcquisitionSourceMutationVariables>;

/**
 * __useCreateAcquisitionSourceMutation__
 *
 * To run a mutation, you first call `useCreateAcquisitionSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAcquisitionSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAcquisitionSourceMutation, { data, loading, error }] = useCreateAcquisitionSourceMutation({
 *   variables: {
 *      cmd: // value for 'cmd'
 *      couponCodes: // value for 'couponCodes'
 *   },
 * });
 */
export function useCreateAcquisitionSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAcquisitionSourceMutation, CreateAcquisitionSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAcquisitionSourceMutation, CreateAcquisitionSourceMutationVariables>(CreateAcquisitionSourceDocument, options);
      }
export type CreateAcquisitionSourceMutationHookResult = ReturnType<typeof useCreateAcquisitionSourceMutation>;
export type CreateAcquisitionSourceMutationResult = Apollo.MutationResult<CreateAcquisitionSourceMutation>;
export type CreateAcquisitionSourceMutationOptions = Apollo.BaseMutationOptions<CreateAcquisitionSourceMutation, CreateAcquisitionSourceMutationVariables>;
export const UpdateAcquisitionSourceDocument = gql`
    mutation UpdateAcquisitionSource($cmd: UpdateAcquisitionSourceInput!) {
  updateAcquisitionSource(cmd: $cmd) {
    ...AcquisitionSourceFields
  }
}
    ${AcquisitionSourceFieldsFragmentDoc}`;
export type UpdateAcquisitionSourceMutationFn = Apollo.MutationFunction<UpdateAcquisitionSourceMutation, UpdateAcquisitionSourceMutationVariables>;

/**
 * __useUpdateAcquisitionSourceMutation__
 *
 * To run a mutation, you first call `useUpdateAcquisitionSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAcquisitionSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAcquisitionSourceMutation, { data, loading, error }] = useUpdateAcquisitionSourceMutation({
 *   variables: {
 *      cmd: // value for 'cmd'
 *   },
 * });
 */
export function useUpdateAcquisitionSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAcquisitionSourceMutation, UpdateAcquisitionSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAcquisitionSourceMutation, UpdateAcquisitionSourceMutationVariables>(UpdateAcquisitionSourceDocument, options);
      }
export type UpdateAcquisitionSourceMutationHookResult = ReturnType<typeof useUpdateAcquisitionSourceMutation>;
export type UpdateAcquisitionSourceMutationResult = Apollo.MutationResult<UpdateAcquisitionSourceMutation>;
export type UpdateAcquisitionSourceMutationOptions = Apollo.BaseMutationOptions<UpdateAcquisitionSourceMutation, UpdateAcquisitionSourceMutationVariables>;
export const AddCouponCodeDocument = gql`
    mutation AddCouponCode($sourceId: ID!, $couponCode: String!) {
  addCouponCode(sourceId: $sourceId, couponCode: $couponCode) {
    ...AcquisitionSourceFields
  }
}
    ${AcquisitionSourceFieldsFragmentDoc}`;
export type AddCouponCodeMutationFn = Apollo.MutationFunction<AddCouponCodeMutation, AddCouponCodeMutationVariables>;

/**
 * __useAddCouponCodeMutation__
 *
 * To run a mutation, you first call `useAddCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCouponCodeMutation, { data, loading, error }] = useAddCouponCodeMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useAddCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<AddCouponCodeMutation, AddCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCouponCodeMutation, AddCouponCodeMutationVariables>(AddCouponCodeDocument, options);
      }
export type AddCouponCodeMutationHookResult = ReturnType<typeof useAddCouponCodeMutation>;
export type AddCouponCodeMutationResult = Apollo.MutationResult<AddCouponCodeMutation>;
export type AddCouponCodeMutationOptions = Apollo.BaseMutationOptions<AddCouponCodeMutation, AddCouponCodeMutationVariables>;
export const RemoveCouponCodeDocument = gql`
    mutation RemoveCouponCode($sourceId: ID!, $couponCode: String!) {
  removeCouponCode(sourceId: $sourceId, couponCode: $couponCode) {
    ...AcquisitionSourceFields
  }
}
    ${AcquisitionSourceFieldsFragmentDoc}`;
export type RemoveCouponCodeMutationFn = Apollo.MutationFunction<RemoveCouponCodeMutation, RemoveCouponCodeMutationVariables>;

/**
 * __useRemoveCouponCodeMutation__
 *
 * To run a mutation, you first call `useRemoveCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCouponCodeMutation, { data, loading, error }] = useRemoveCouponCodeMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useRemoveCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCouponCodeMutation, RemoveCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCouponCodeMutation, RemoveCouponCodeMutationVariables>(RemoveCouponCodeDocument, options);
      }
export type RemoveCouponCodeMutationHookResult = ReturnType<typeof useRemoveCouponCodeMutation>;
export type RemoveCouponCodeMutationResult = Apollo.MutationResult<RemoveCouponCodeMutation>;
export type RemoveCouponCodeMutationOptions = Apollo.BaseMutationOptions<RemoveCouponCodeMutation, RemoveCouponCodeMutationVariables>;
export const DeactivateAcquisitionSourceDocument = gql`
    mutation DeactivateAcquisitionSource($sourceId: ID!) {
  deactivateAcquisitionSource(sourceId: $sourceId) {
    ...AcquisitionSourceFields
  }
}
    ${AcquisitionSourceFieldsFragmentDoc}`;
export type DeactivateAcquisitionSourceMutationFn = Apollo.MutationFunction<DeactivateAcquisitionSourceMutation, DeactivateAcquisitionSourceMutationVariables>;

/**
 * __useDeactivateAcquisitionSourceMutation__
 *
 * To run a mutation, you first call `useDeactivateAcquisitionSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAcquisitionSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAcquisitionSourceMutation, { data, loading, error }] = useDeactivateAcquisitionSourceMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useDeactivateAcquisitionSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAcquisitionSourceMutation, DeactivateAcquisitionSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAcquisitionSourceMutation, DeactivateAcquisitionSourceMutationVariables>(DeactivateAcquisitionSourceDocument, options);
      }
export type DeactivateAcquisitionSourceMutationHookResult = ReturnType<typeof useDeactivateAcquisitionSourceMutation>;
export type DeactivateAcquisitionSourceMutationResult = Apollo.MutationResult<DeactivateAcquisitionSourceMutation>;
export type DeactivateAcquisitionSourceMutationOptions = Apollo.BaseMutationOptions<DeactivateAcquisitionSourceMutation, DeactivateAcquisitionSourceMutationVariables>;
export const GetCarriersDocument = gql`
    query GetCarriers($includeInactive: Boolean) {
  carriers(includeInactive: $includeInactive) {
    ...CarrierFields
  }
}
    ${CarrierFieldsFragmentDoc}`;

/**
 * __useGetCarriersQuery__
 *
 * To run a query within a React component, call `useGetCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarriersQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetCarriersQuery(baseOptions?: Apollo.QueryHookOptions<GetCarriersQuery, GetCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarriersQuery, GetCarriersQueryVariables>(GetCarriersDocument, options);
      }
export function useGetCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarriersQuery, GetCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarriersQuery, GetCarriersQueryVariables>(GetCarriersDocument, options);
        }
export function useGetCarriersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCarriersQuery, GetCarriersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarriersQuery, GetCarriersQueryVariables>(GetCarriersDocument, options);
        }
export type GetCarriersQueryHookResult = ReturnType<typeof useGetCarriersQuery>;
export type GetCarriersLazyQueryHookResult = ReturnType<typeof useGetCarriersLazyQuery>;
export type GetCarriersSuspenseQueryHookResult = ReturnType<typeof useGetCarriersSuspenseQuery>;
export type GetCarriersQueryResult = Apollo.QueryResult<GetCarriersQuery, GetCarriersQueryVariables>;
export const GetCarrierDocument = gql`
    query GetCarrier($carrierId: ID!) {
  carrier(carrierId: $carrierId) {
    ...CarrierFields
  }
}
    ${CarrierFieldsFragmentDoc}`;

/**
 * __useGetCarrierQuery__
 *
 * To run a query within a React component, call `useGetCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarrierQuery({
 *   variables: {
 *      carrierId: // value for 'carrierId'
 *   },
 * });
 */
export function useGetCarrierQuery(baseOptions: Apollo.QueryHookOptions<GetCarrierQuery, GetCarrierQueryVariables> & ({ variables: GetCarrierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarrierQuery, GetCarrierQueryVariables>(GetCarrierDocument, options);
      }
export function useGetCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarrierQuery, GetCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarrierQuery, GetCarrierQueryVariables>(GetCarrierDocument, options);
        }
export function useGetCarrierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCarrierQuery, GetCarrierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarrierQuery, GetCarrierQueryVariables>(GetCarrierDocument, options);
        }
export type GetCarrierQueryHookResult = ReturnType<typeof useGetCarrierQuery>;
export type GetCarrierLazyQueryHookResult = ReturnType<typeof useGetCarrierLazyQuery>;
export type GetCarrierSuspenseQueryHookResult = ReturnType<typeof useGetCarrierSuspenseQuery>;
export type GetCarrierQueryResult = Apollo.QueryResult<GetCarrierQuery, GetCarrierQueryVariables>;
export const CreateCarrierDocument = gql`
    mutation CreateCarrier($cmd: CreateCarrierInput!) {
  createCarrier(cmd: $cmd) {
    ...CarrierFields
  }
}
    ${CarrierFieldsFragmentDoc}`;
export type CreateCarrierMutationFn = Apollo.MutationFunction<CreateCarrierMutation, CreateCarrierMutationVariables>;

/**
 * __useCreateCarrierMutation__
 *
 * To run a mutation, you first call `useCreateCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierMutation, { data, loading, error }] = useCreateCarrierMutation({
 *   variables: {
 *      cmd: // value for 'cmd'
 *   },
 * });
 */
export function useCreateCarrierMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarrierMutation, CreateCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarrierMutation, CreateCarrierMutationVariables>(CreateCarrierDocument, options);
      }
export type CreateCarrierMutationHookResult = ReturnType<typeof useCreateCarrierMutation>;
export type CreateCarrierMutationResult = Apollo.MutationResult<CreateCarrierMutation>;
export type CreateCarrierMutationOptions = Apollo.BaseMutationOptions<CreateCarrierMutation, CreateCarrierMutationVariables>;
export const UpdateCarrierDocument = gql`
    mutation UpdateCarrier($cmd: UpdateCarrierInput!) {
  updateCarrier(cmd: $cmd) {
    ...CarrierFields
  }
}
    ${CarrierFieldsFragmentDoc}`;
export type UpdateCarrierMutationFn = Apollo.MutationFunction<UpdateCarrierMutation, UpdateCarrierMutationVariables>;

/**
 * __useUpdateCarrierMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierMutation, { data, loading, error }] = useUpdateCarrierMutation({
 *   variables: {
 *      cmd: // value for 'cmd'
 *   },
 * });
 */
export function useUpdateCarrierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierMutation, UpdateCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarrierMutation, UpdateCarrierMutationVariables>(UpdateCarrierDocument, options);
      }
export type UpdateCarrierMutationHookResult = ReturnType<typeof useUpdateCarrierMutation>;
export type UpdateCarrierMutationResult = Apollo.MutationResult<UpdateCarrierMutation>;
export type UpdateCarrierMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierMutation, UpdateCarrierMutationVariables>;
export const DeactivateCarrierDocument = gql`
    mutation DeactivateCarrier($carrierId: ID!) {
  deactivateCarrier(carrierId: $carrierId) {
    ...CarrierFields
  }
}
    ${CarrierFieldsFragmentDoc}`;
export type DeactivateCarrierMutationFn = Apollo.MutationFunction<DeactivateCarrierMutation, DeactivateCarrierMutationVariables>;

/**
 * __useDeactivateCarrierMutation__
 *
 * To run a mutation, you first call `useDeactivateCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCarrierMutation, { data, loading, error }] = useDeactivateCarrierMutation({
 *   variables: {
 *      carrierId: // value for 'carrierId'
 *   },
 * });
 */
export function useDeactivateCarrierMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateCarrierMutation, DeactivateCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateCarrierMutation, DeactivateCarrierMutationVariables>(DeactivateCarrierDocument, options);
      }
export type DeactivateCarrierMutationHookResult = ReturnType<typeof useDeactivateCarrierMutation>;
export type DeactivateCarrierMutationResult = Apollo.MutationResult<DeactivateCarrierMutation>;
export type DeactivateCarrierMutationOptions = Apollo.BaseMutationOptions<DeactivateCarrierMutation, DeactivateCarrierMutationVariables>;
export const GetCustomersDocument = gql`
    query GetCustomers($filter: CustomerFilter, $pagination: PaginationInput, $sort: CustomerSortInput) {
  customers(filter: $filter, pagination: $pagination, sort: $sort) {
    edges {
      node {
        customerId
        email
        segment
        country
        couponCode
        amountPaid
        currency
        createdAt
        firstConsultDate
        stripeRefundCount
        refundReviewPending
        entitlements {
          entitlementId
          activationCode
          status
          activatedByUserId
          provisionedAt
          activatedAt
          emailStatus {
            status
          }
          subscriptionId
        }
        primaryEntitlement {
          entitlementId
          activationCode
          status
          activatedAt
        }
        linkedUser {
          participantId
          pii {
            identityInformation {
              firstName
              lastName
            }
            contactInformation {
              email
            }
          }
        }
        engagement {
          lastVnsSession
          totalVnsSessions
          lastAppActivity
          isActive
          currentProgram
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($customerId: ID!) {
  customer(customerId: $customerId) {
    customerId
    email
    stripeCustomerId
    segment
    country
    couponCode
    amountPaid
    currency
    createdAt
    firstConsultDate
    contactInformation {
      email
      address
      phoneNumber {
        countryCode
        nationalNumber
      }
      country
    }
    acquisitionSource {
      name
      partnerName
      defaultSegment
    }
    stripeCustomerDeleted
    stripeRefundCount
    lastStripeRefundAt
    ...CustomerRefundReviewFields
    entitlements {
      entitlementId
      activationCode
      status
      billingStatus
      activatedByUserId
      activatedBy {
        participantId
        pii {
          identityInformation {
            firstName
            lastName
          }
          contactInformation {
            email
          }
        }
      }
      provisionedAt
      activatedAt
      emailStatus {
        status
      }
      subscriptionId
      currentPeriodEnd
      cancelAtPeriodEnd
      preRegistration {
        customerId
        entitlementId
        serialNumber
        state
        preRegisteredAt
        preRegisteredBy
      }
      lastSubscriptionExtension {
        months
        extendedBy
        extendedAt
        previousPeriodEnd
        newPeriodEnd
        reason
      }
      subscriptionCancellations {
        action
        mode
        performedBy
        occurredAt
        reason
      }
      gift
      giftBasis
    }
    primaryEntitlement {
      entitlementId
      activationCode
      status
      activatedAt
    }
    linkedUser {
      participantId
      pii {
        identityInformation {
          firstName
          lastName
        }
        contactInformation {
          email
        }
      }
    }
    engagement {
      lastVnsSession
      totalVnsSessions
      lastAppActivity
      isActive
      currentProgram
    }
    financialSummary {
      totalPaidInCents
      totalFeesInCents
      totalNetInCents
      totalRefundedInCents
      currency
      transactionCount
      hasActualFees
      refundCount
      disputeCount
      disputeAmountInCents
      refundRate
    }
    transactions {
      chargeId
      amountInCents
      currency
      feeInCents
      netInCents
      feeSource
      reconciled
      totalRefundedInCents
      refundCount
      disputeCount
      disputeAmountInCents
      createdAt
      refunds {
        refundId
        amountInCents
        currency
        reason
        createdAt
      }
      disputes {
        disputeId
        amountInCents
        currency
        reason
        status
        openedAt
        closedAt
      }
      feeDetails {
        type
        amountInCents
        currency
        description
      }
      payoutId
    }
  }
}
    ${CustomerRefundReviewFieldsFragmentDoc}`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables> & ({ variables: GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetCustomerContactHistoryDocument = gql`
    query GetCustomerContactHistory($customerId: ID!) {
  customer(customerId: $customerId) {
    customerId
    contactHistory {
      current {
        delivery {
          firstName
          lastName
          address
          country
          phoneNumber
        }
        billing {
          name
          address
          country
        }
        email
      }
      changes {
        field
        oldValue
        newValue
        removed
        source
        providerEventId
        changedBy
        changedAt
        pending
      }
      observations {
        providerEventId
        observedAt
        billingChanged
        deliveryChanged
        fieldsToApply
        staleFields
        disposition
      }
    }
  }
}
    `;

/**
 * __useGetCustomerContactHistoryQuery__
 *
 * To run a query within a React component, call `useGetCustomerContactHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContactHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContactHistoryQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerContactHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerContactHistoryQuery, GetCustomerContactHistoryQueryVariables> & ({ variables: GetCustomerContactHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerContactHistoryQuery, GetCustomerContactHistoryQueryVariables>(GetCustomerContactHistoryDocument, options);
      }
export function useGetCustomerContactHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerContactHistoryQuery, GetCustomerContactHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerContactHistoryQuery, GetCustomerContactHistoryQueryVariables>(GetCustomerContactHistoryDocument, options);
        }
export function useGetCustomerContactHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerContactHistoryQuery, GetCustomerContactHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerContactHistoryQuery, GetCustomerContactHistoryQueryVariables>(GetCustomerContactHistoryDocument, options);
        }
export type GetCustomerContactHistoryQueryHookResult = ReturnType<typeof useGetCustomerContactHistoryQuery>;
export type GetCustomerContactHistoryLazyQueryHookResult = ReturnType<typeof useGetCustomerContactHistoryLazyQuery>;
export type GetCustomerContactHistorySuspenseQueryHookResult = ReturnType<typeof useGetCustomerContactHistorySuspenseQuery>;
export type GetCustomerContactHistoryQueryResult = Apollo.QueryResult<GetCustomerContactHistoryQuery, GetCustomerContactHistoryQueryVariables>;
export const SearchCustomersDocument = gql`
    query SearchCustomers($query: String!, $limit: Int) {
  searchCustomers(query: $query, limit: $limit) {
    customerId
    email
    segment
    entitlements {
      entitlementId
      status
      activationCode
    }
    primaryEntitlement {
      entitlementId
      status
      activationCode
    }
  }
}
    `;

/**
 * __useSearchCustomersQuery__
 *
 * To run a query within a React component, call `useSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCustomersQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables> & ({ variables: SearchCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
      }
export function useSearchCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
        }
export function useSearchCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
        }
export type SearchCustomersQueryHookResult = ReturnType<typeof useSearchCustomersQuery>;
export type SearchCustomersLazyQueryHookResult = ReturnType<typeof useSearchCustomersLazyQuery>;
export type SearchCustomersSuspenseQueryHookResult = ReturnType<typeof useSearchCustomersSuspenseQuery>;
export type SearchCustomersQueryResult = Apollo.QueryResult<SearchCustomersQuery, SearchCustomersQueryVariables>;
export const RecordFirstConsultDocument = gql`
    mutation RecordFirstConsult($customerId: ID!, $consultDate: Date!) {
  recordFirstConsult(customerId: $customerId, consultDate: $consultDate) {
    customerId
    firstConsultDate
  }
}
    `;
export type RecordFirstConsultMutationFn = Apollo.MutationFunction<RecordFirstConsultMutation, RecordFirstConsultMutationVariables>;

/**
 * __useRecordFirstConsultMutation__
 *
 * To run a mutation, you first call `useRecordFirstConsultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordFirstConsultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordFirstConsultMutation, { data, loading, error }] = useRecordFirstConsultMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      consultDate: // value for 'consultDate'
 *   },
 * });
 */
export function useRecordFirstConsultMutation(baseOptions?: Apollo.MutationHookOptions<RecordFirstConsultMutation, RecordFirstConsultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordFirstConsultMutation, RecordFirstConsultMutationVariables>(RecordFirstConsultDocument, options);
      }
export type RecordFirstConsultMutationHookResult = ReturnType<typeof useRecordFirstConsultMutation>;
export type RecordFirstConsultMutationResult = Apollo.MutationResult<RecordFirstConsultMutation>;
export type RecordFirstConsultMutationOptions = Apollo.BaseMutationOptions<RecordFirstConsultMutation, RecordFirstConsultMutationVariables>;
export const GetCustomerDashboardDocument = gql`
    query GetCustomerDashboard {
  customerDashboard {
    overview {
      totalCustomers
      activeEntitlements
      pendingEntitlements
      suspendedEntitlements
      revokedEntitlements
    }
    statusMatrix {
      d2c {
        total
        active
        pending
      }
      b2b2c {
        total
        active
        pending
      }
      investor {
        total
        active
        pending
      }
      internal {
        total
        active
        pending
      }
      pilot {
        total
        active
        pending
      }
    }
    deviceStatus {
      totalShipments
      pendingShipments
      shippedShipments
      deliveredShipments
      shipmentsNeedingSerial
    }
    monthlyRevenue(months: 12) {
      month
      totalAmount
      currency
      customerCount
      estimatedFees
      feePercentage
      netBalance
      paymentDistribution {
        amount
        currency
        count
      }
      targetAmount
      percentOfTarget
      feeSource
      disputeAmount
      reconciliationPercent
      feeEnrichedPercent
    }
    topAcquisitionSources(limit: 10) {
      sourceId
      sourceName
      partnerName
      customerCount
      activeCustomers
      pendingCustomers
      revenueByCurrency {
        currency
        totalAmount
      }
      isActive
    }
  }
}
    `;

/**
 * __useGetCustomerDashboardQuery__
 *
 * To run a query within a React component, call `useGetCustomerDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerDashboardQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerDashboardQuery, GetCustomerDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerDashboardQuery, GetCustomerDashboardQueryVariables>(GetCustomerDashboardDocument, options);
      }
export function useGetCustomerDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerDashboardQuery, GetCustomerDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerDashboardQuery, GetCustomerDashboardQueryVariables>(GetCustomerDashboardDocument, options);
        }
export function useGetCustomerDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerDashboardQuery, GetCustomerDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerDashboardQuery, GetCustomerDashboardQueryVariables>(GetCustomerDashboardDocument, options);
        }
export type GetCustomerDashboardQueryHookResult = ReturnType<typeof useGetCustomerDashboardQuery>;
export type GetCustomerDashboardLazyQueryHookResult = ReturnType<typeof useGetCustomerDashboardLazyQuery>;
export type GetCustomerDashboardSuspenseQueryHookResult = ReturnType<typeof useGetCustomerDashboardSuspenseQuery>;
export type GetCustomerDashboardQueryResult = Apollo.QueryResult<GetCustomerDashboardQuery, GetCustomerDashboardQueryVariables>;
export const MemberBySerialDocument = gql`
    query MemberBySerial($serial: String!) {
  memberBySerial(serial: $serial) {
    serialNumber
    members {
      userId
    }
    devices {
      deviceId
      userId
      serialNumber
      model
    }
    preRegistration {
      customerId
      entitlementId
      serialNumber
      state
      preRegisteredAt
      preRegisteredBy
    }
  }
}
    `;

/**
 * __useMemberBySerialQuery__
 *
 * To run a query within a React component, call `useMemberBySerialQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberBySerialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberBySerialQuery({
 *   variables: {
 *      serial: // value for 'serial'
 *   },
 * });
 */
export function useMemberBySerialQuery(baseOptions: Apollo.QueryHookOptions<MemberBySerialQuery, MemberBySerialQueryVariables> & ({ variables: MemberBySerialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberBySerialQuery, MemberBySerialQueryVariables>(MemberBySerialDocument, options);
      }
export function useMemberBySerialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberBySerialQuery, MemberBySerialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberBySerialQuery, MemberBySerialQueryVariables>(MemberBySerialDocument, options);
        }
export function useMemberBySerialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberBySerialQuery, MemberBySerialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberBySerialQuery, MemberBySerialQueryVariables>(MemberBySerialDocument, options);
        }
export type MemberBySerialQueryHookResult = ReturnType<typeof useMemberBySerialQuery>;
export type MemberBySerialLazyQueryHookResult = ReturnType<typeof useMemberBySerialLazyQuery>;
export type MemberBySerialSuspenseQueryHookResult = ReturnType<typeof useMemberBySerialSuspenseQuery>;
export type MemberBySerialQueryResult = Apollo.QueryResult<MemberBySerialQuery, MemberBySerialQueryVariables>;
export const PreRegisterDeviceSerialDocument = gql`
    mutation PreRegisterDeviceSerial($input: PreRegisterDeviceSerialInput!) {
  preRegisterDeviceSerial(input: $input) {
    id
  }
}
    `;
export type PreRegisterDeviceSerialMutationFn = Apollo.MutationFunction<PreRegisterDeviceSerialMutation, PreRegisterDeviceSerialMutationVariables>;

/**
 * __usePreRegisterDeviceSerialMutation__
 *
 * To run a mutation, you first call `usePreRegisterDeviceSerialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreRegisterDeviceSerialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preRegisterDeviceSerialMutation, { data, loading, error }] = usePreRegisterDeviceSerialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreRegisterDeviceSerialMutation(baseOptions?: Apollo.MutationHookOptions<PreRegisterDeviceSerialMutation, PreRegisterDeviceSerialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreRegisterDeviceSerialMutation, PreRegisterDeviceSerialMutationVariables>(PreRegisterDeviceSerialDocument, options);
      }
export type PreRegisterDeviceSerialMutationHookResult = ReturnType<typeof usePreRegisterDeviceSerialMutation>;
export type PreRegisterDeviceSerialMutationResult = Apollo.MutationResult<PreRegisterDeviceSerialMutation>;
export type PreRegisterDeviceSerialMutationOptions = Apollo.BaseMutationOptions<PreRegisterDeviceSerialMutation, PreRegisterDeviceSerialMutationVariables>;
export const ResendActivationEmailDocument = gql`
    mutation ResendActivationEmail($entitlementId: ID!) {
  resendActivationEmail(entitlementId: $entitlementId) {
    success
    message
  }
}
    `;
export type ResendActivationEmailMutationFn = Apollo.MutationFunction<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>;

/**
 * __useResendActivationEmailMutation__
 *
 * To run a mutation, you first call `useResendActivationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendActivationEmailMutation, { data, loading, error }] = useResendActivationEmailMutation({
 *   variables: {
 *      entitlementId: // value for 'entitlementId'
 *   },
 * });
 */
export function useResendActivationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>(ResendActivationEmailDocument, options);
      }
export type ResendActivationEmailMutationHookResult = ReturnType<typeof useResendActivationEmailMutation>;
export type ResendActivationEmailMutationResult = Apollo.MutationResult<ResendActivationEmailMutation>;
export type ResendActivationEmailMutationOptions = Apollo.BaseMutationOptions<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>;
export const LinkEntitlementToUserDocument = gql`
    mutation LinkEntitlementToUser($customerId: ID!, $entitlementId: ID!, $userId: ID!, $reason: String!) {
  linkEntitlementToUser(
    customerId: $customerId
    entitlementId: $entitlementId
    userId: $userId
    reason: $reason
  ) {
    id
  }
}
    `;
export type LinkEntitlementToUserMutationFn = Apollo.MutationFunction<LinkEntitlementToUserMutation, LinkEntitlementToUserMutationVariables>;

/**
 * __useLinkEntitlementToUserMutation__
 *
 * To run a mutation, you first call `useLinkEntitlementToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEntitlementToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEntitlementToUserMutation, { data, loading, error }] = useLinkEntitlementToUserMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      entitlementId: // value for 'entitlementId'
 *      userId: // value for 'userId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useLinkEntitlementToUserMutation(baseOptions?: Apollo.MutationHookOptions<LinkEntitlementToUserMutation, LinkEntitlementToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkEntitlementToUserMutation, LinkEntitlementToUserMutationVariables>(LinkEntitlementToUserDocument, options);
      }
export type LinkEntitlementToUserMutationHookResult = ReturnType<typeof useLinkEntitlementToUserMutation>;
export type LinkEntitlementToUserMutationResult = Apollo.MutationResult<LinkEntitlementToUserMutation>;
export type LinkEntitlementToUserMutationOptions = Apollo.BaseMutationOptions<LinkEntitlementToUserMutation, LinkEntitlementToUserMutationVariables>;
export const UnlinkEntitlementFromUserDocument = gql`
    mutation UnlinkEntitlementFromUser($customerId: ID!, $entitlementId: ID!, $reason: String!) {
  unlinkEntitlementFromUser(
    customerId: $customerId
    entitlementId: $entitlementId
    reason: $reason
  ) {
    entitlementId
    activationCode
    status
    activatedByUserId
    provisionedAt
    activatedAt
    subscriptionId
  }
}
    `;
export type UnlinkEntitlementFromUserMutationFn = Apollo.MutationFunction<UnlinkEntitlementFromUserMutation, UnlinkEntitlementFromUserMutationVariables>;

/**
 * __useUnlinkEntitlementFromUserMutation__
 *
 * To run a mutation, you first call `useUnlinkEntitlementFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntitlementFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntitlementFromUserMutation, { data, loading, error }] = useUnlinkEntitlementFromUserMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      entitlementId: // value for 'entitlementId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUnlinkEntitlementFromUserMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkEntitlementFromUserMutation, UnlinkEntitlementFromUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkEntitlementFromUserMutation, UnlinkEntitlementFromUserMutationVariables>(UnlinkEntitlementFromUserDocument, options);
      }
export type UnlinkEntitlementFromUserMutationHookResult = ReturnType<typeof useUnlinkEntitlementFromUserMutation>;
export type UnlinkEntitlementFromUserMutationResult = Apollo.MutationResult<UnlinkEntitlementFromUserMutation>;
export type UnlinkEntitlementFromUserMutationOptions = Apollo.BaseMutationOptions<UnlinkEntitlementFromUserMutation, UnlinkEntitlementFromUserMutationVariables>;
export const UnlinkSubscriptionDocument = gql`
    mutation UnlinkSubscription($customerId: ID!, $entitlementId: ID!, $reason: String!) {
  unlinkSubscription(
    customerId: $customerId
    entitlementId: $entitlementId
    reason: $reason
  ) {
    entitlementId
    activationCode
    status
    activatedByUserId
    provisionedAt
    activatedAt
    subscriptionId
  }
}
    `;
export type UnlinkSubscriptionMutationFn = Apollo.MutationFunction<UnlinkSubscriptionMutation, UnlinkSubscriptionMutationVariables>;

/**
 * __useUnlinkSubscriptionMutation__
 *
 * To run a mutation, you first call `useUnlinkSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkSubscriptionMutation, { data, loading, error }] = useUnlinkSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      entitlementId: // value for 'entitlementId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUnlinkSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkSubscriptionMutation, UnlinkSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkSubscriptionMutation, UnlinkSubscriptionMutationVariables>(UnlinkSubscriptionDocument, options);
      }
export type UnlinkSubscriptionMutationHookResult = ReturnType<typeof useUnlinkSubscriptionMutation>;
export type UnlinkSubscriptionMutationResult = Apollo.MutationResult<UnlinkSubscriptionMutation>;
export type UnlinkSubscriptionMutationOptions = Apollo.BaseMutationOptions<UnlinkSubscriptionMutation, UnlinkSubscriptionMutationVariables>;
export const SuspendEntitlementDocument = gql`
    mutation SuspendEntitlement($customerId: ID!, $entitlementId: ID!, $reason: String!) {
  suspendEntitlement(
    customerId: $customerId
    entitlementId: $entitlementId
    reason: $reason
  ) {
    entitlementId
    activationCode
    status
    activatedByUserId
    provisionedAt
    activatedAt
    subscriptionId
  }
}
    `;
export type SuspendEntitlementMutationFn = Apollo.MutationFunction<SuspendEntitlementMutation, SuspendEntitlementMutationVariables>;

/**
 * __useSuspendEntitlementMutation__
 *
 * To run a mutation, you first call `useSuspendEntitlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendEntitlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendEntitlementMutation, { data, loading, error }] = useSuspendEntitlementMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      entitlementId: // value for 'entitlementId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useSuspendEntitlementMutation(baseOptions?: Apollo.MutationHookOptions<SuspendEntitlementMutation, SuspendEntitlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendEntitlementMutation, SuspendEntitlementMutationVariables>(SuspendEntitlementDocument, options);
      }
export type SuspendEntitlementMutationHookResult = ReturnType<typeof useSuspendEntitlementMutation>;
export type SuspendEntitlementMutationResult = Apollo.MutationResult<SuspendEntitlementMutation>;
export type SuspendEntitlementMutationOptions = Apollo.BaseMutationOptions<SuspendEntitlementMutation, SuspendEntitlementMutationVariables>;
export const RevokeEntitlementDocument = gql`
    mutation RevokeEntitlement($customerId: ID!, $entitlementId: ID!, $reason: String!) {
  revokeEntitlement(
    customerId: $customerId
    entitlementId: $entitlementId
    reason: $reason
  ) {
    entitlementId
    activationCode
    status
    activatedByUserId
    provisionedAt
    activatedAt
    subscriptionId
  }
}
    `;
export type RevokeEntitlementMutationFn = Apollo.MutationFunction<RevokeEntitlementMutation, RevokeEntitlementMutationVariables>;

/**
 * __useRevokeEntitlementMutation__
 *
 * To run a mutation, you first call `useRevokeEntitlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeEntitlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeEntitlementMutation, { data, loading, error }] = useRevokeEntitlementMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      entitlementId: // value for 'entitlementId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRevokeEntitlementMutation(baseOptions?: Apollo.MutationHookOptions<RevokeEntitlementMutation, RevokeEntitlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeEntitlementMutation, RevokeEntitlementMutationVariables>(RevokeEntitlementDocument, options);
      }
export type RevokeEntitlementMutationHookResult = ReturnType<typeof useRevokeEntitlementMutation>;
export type RevokeEntitlementMutationResult = Apollo.MutationResult<RevokeEntitlementMutation>;
export type RevokeEntitlementMutationOptions = Apollo.BaseMutationOptions<RevokeEntitlementMutation, RevokeEntitlementMutationVariables>;
export const ReactivateEntitlementDocument = gql`
    mutation ReactivateEntitlement($customerId: ID!, $entitlementId: ID!, $reason: String!) {
  reactivateEntitlement(
    customerId: $customerId
    entitlementId: $entitlementId
    reason: $reason
  ) {
    entitlementId
    activationCode
    status
    activatedByUserId
    provisionedAt
    activatedAt
    subscriptionId
  }
}
    `;
export type ReactivateEntitlementMutationFn = Apollo.MutationFunction<ReactivateEntitlementMutation, ReactivateEntitlementMutationVariables>;

/**
 * __useReactivateEntitlementMutation__
 *
 * To run a mutation, you first call `useReactivateEntitlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateEntitlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateEntitlementMutation, { data, loading, error }] = useReactivateEntitlementMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      entitlementId: // value for 'entitlementId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useReactivateEntitlementMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateEntitlementMutation, ReactivateEntitlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateEntitlementMutation, ReactivateEntitlementMutationVariables>(ReactivateEntitlementDocument, options);
      }
export type ReactivateEntitlementMutationHookResult = ReturnType<typeof useReactivateEntitlementMutation>;
export type ReactivateEntitlementMutationResult = Apollo.MutationResult<ReactivateEntitlementMutation>;
export type ReactivateEntitlementMutationOptions = Apollo.BaseMutationOptions<ReactivateEntitlementMutation, ReactivateEntitlementMutationVariables>;
export const MarkEntitlementGiftDocument = gql`
    mutation MarkEntitlementGift($input: MarkEntitlementGiftInput!) {
  markEntitlementGift(input: $input) {
    entitlementId
    activationCode
    status
    activatedByUserId
    provisionedAt
    activatedAt
    subscriptionId
    gift
    giftBasis
  }
}
    `;
export type MarkEntitlementGiftMutationFn = Apollo.MutationFunction<MarkEntitlementGiftMutation, MarkEntitlementGiftMutationVariables>;

/**
 * __useMarkEntitlementGiftMutation__
 *
 * To run a mutation, you first call `useMarkEntitlementGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEntitlementGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEntitlementGiftMutation, { data, loading, error }] = useMarkEntitlementGiftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkEntitlementGiftMutation(baseOptions?: Apollo.MutationHookOptions<MarkEntitlementGiftMutation, MarkEntitlementGiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEntitlementGiftMutation, MarkEntitlementGiftMutationVariables>(MarkEntitlementGiftDocument, options);
      }
export type MarkEntitlementGiftMutationHookResult = ReturnType<typeof useMarkEntitlementGiftMutation>;
export type MarkEntitlementGiftMutationResult = Apollo.MutationResult<MarkEntitlementGiftMutation>;
export type MarkEntitlementGiftMutationOptions = Apollo.BaseMutationOptions<MarkEntitlementGiftMutation, MarkEntitlementGiftMutationVariables>;
export const RecordRefundReviewDocument = gql`
    mutation RecordRefundReview($input: RecordRefundReviewInput!) {
  recordRefundReview(input: $input) {
    customerId
    ...CustomerRefundReviewFields
  }
}
    ${CustomerRefundReviewFieldsFragmentDoc}`;
export type RecordRefundReviewMutationFn = Apollo.MutationFunction<RecordRefundReviewMutation, RecordRefundReviewMutationVariables>;

/**
 * __useRecordRefundReviewMutation__
 *
 * To run a mutation, you first call `useRecordRefundReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordRefundReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordRefundReviewMutation, { data, loading, error }] = useRecordRefundReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordRefundReviewMutation(baseOptions?: Apollo.MutationHookOptions<RecordRefundReviewMutation, RecordRefundReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordRefundReviewMutation, RecordRefundReviewMutationVariables>(RecordRefundReviewDocument, options);
      }
export type RecordRefundReviewMutationHookResult = ReturnType<typeof useRecordRefundReviewMutation>;
export type RecordRefundReviewMutationResult = Apollo.MutationResult<RecordRefundReviewMutation>;
export type RecordRefundReviewMutationOptions = Apollo.BaseMutationOptions<RecordRefundReviewMutation, RecordRefundReviewMutationVariables>;
export const ExportCustomersDocument = gql`
    mutation ExportCustomers($columns: ExportColumnsInput!, $filter: CustomerFilter, $justification: String!) {
  exportCustomers(
    columns: $columns
    filter: $filter
    justification: $justification
  ) {
    success
    csv
    recordCount
    error
  }
}
    `;
export type ExportCustomersMutationFn = Apollo.MutationFunction<ExportCustomersMutation, ExportCustomersMutationVariables>;

/**
 * __useExportCustomersMutation__
 *
 * To run a mutation, you first call `useExportCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCustomersMutation, { data, loading, error }] = useExportCustomersMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      justification: // value for 'justification'
 *   },
 * });
 */
export function useExportCustomersMutation(baseOptions?: Apollo.MutationHookOptions<ExportCustomersMutation, ExportCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCustomersMutation, ExportCustomersMutationVariables>(ExportCustomersDocument, options);
      }
export type ExportCustomersMutationHookResult = ReturnType<typeof useExportCustomersMutation>;
export type ExportCustomersMutationResult = Apollo.MutationResult<ExportCustomersMutation>;
export type ExportCustomersMutationOptions = Apollo.BaseMutationOptions<ExportCustomersMutation, ExportCustomersMutationVariables>;
export const CancelMemberSubscriptionDocument = gql`
    mutation CancelMemberSubscription($input: CancelMemberSubscriptionInput!) {
  cancelMemberSubscription(input: $input) {
    id
  }
}
    `;
export type CancelMemberSubscriptionMutationFn = Apollo.MutationFunction<CancelMemberSubscriptionMutation, CancelMemberSubscriptionMutationVariables>;

/**
 * __useCancelMemberSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelMemberSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMemberSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMemberSubscriptionMutation, { data, loading, error }] = useCancelMemberSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelMemberSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelMemberSubscriptionMutation, CancelMemberSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMemberSubscriptionMutation, CancelMemberSubscriptionMutationVariables>(CancelMemberSubscriptionDocument, options);
      }
export type CancelMemberSubscriptionMutationHookResult = ReturnType<typeof useCancelMemberSubscriptionMutation>;
export type CancelMemberSubscriptionMutationResult = Apollo.MutationResult<CancelMemberSubscriptionMutation>;
export type CancelMemberSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelMemberSubscriptionMutation, CancelMemberSubscriptionMutationVariables>;
export const ReverseMemberSubscriptionCancellationDocument = gql`
    mutation ReverseMemberSubscriptionCancellation($customerId: ID!, $subscriptionId: ID!) {
  reverseMemberSubscriptionCancellation(
    customerId: $customerId
    subscriptionId: $subscriptionId
  ) {
    id
  }
}
    `;
export type ReverseMemberSubscriptionCancellationMutationFn = Apollo.MutationFunction<ReverseMemberSubscriptionCancellationMutation, ReverseMemberSubscriptionCancellationMutationVariables>;

/**
 * __useReverseMemberSubscriptionCancellationMutation__
 *
 * To run a mutation, you first call `useReverseMemberSubscriptionCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseMemberSubscriptionCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseMemberSubscriptionCancellationMutation, { data, loading, error }] = useReverseMemberSubscriptionCancellationMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useReverseMemberSubscriptionCancellationMutation(baseOptions?: Apollo.MutationHookOptions<ReverseMemberSubscriptionCancellationMutation, ReverseMemberSubscriptionCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseMemberSubscriptionCancellationMutation, ReverseMemberSubscriptionCancellationMutationVariables>(ReverseMemberSubscriptionCancellationDocument, options);
      }
export type ReverseMemberSubscriptionCancellationMutationHookResult = ReturnType<typeof useReverseMemberSubscriptionCancellationMutation>;
export type ReverseMemberSubscriptionCancellationMutationResult = Apollo.MutationResult<ReverseMemberSubscriptionCancellationMutation>;
export type ReverseMemberSubscriptionCancellationMutationOptions = Apollo.BaseMutationOptions<ReverseMemberSubscriptionCancellationMutation, ReverseMemberSubscriptionCancellationMutationVariables>;
export const ExtendMemberSubscriptionDocument = gql`
    mutation ExtendMemberSubscription($input: ExtendMemberSubscriptionInput!) {
  extendMemberSubscription(input: $input) {
    subscriptionId
    months
    previousPeriodEnd
    newPeriodEnd
  }
}
    `;
export type ExtendMemberSubscriptionMutationFn = Apollo.MutationFunction<ExtendMemberSubscriptionMutation, ExtendMemberSubscriptionMutationVariables>;

/**
 * __useExtendMemberSubscriptionMutation__
 *
 * To run a mutation, you first call `useExtendMemberSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendMemberSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendMemberSubscriptionMutation, { data, loading, error }] = useExtendMemberSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtendMemberSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ExtendMemberSubscriptionMutation, ExtendMemberSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtendMemberSubscriptionMutation, ExtendMemberSubscriptionMutationVariables>(ExtendMemberSubscriptionDocument, options);
      }
export type ExtendMemberSubscriptionMutationHookResult = ReturnType<typeof useExtendMemberSubscriptionMutation>;
export type ExtendMemberSubscriptionMutationResult = Apollo.MutationResult<ExtendMemberSubscriptionMutation>;
export type ExtendMemberSubscriptionMutationOptions = Apollo.BaseMutationOptions<ExtendMemberSubscriptionMutation, ExtendMemberSubscriptionMutationVariables>;
export const GetFinancialReportsDocument = gql`
    query GetFinancialReports {
  customerDashboard {
    monthlyRevenue(months: 12) {
      month
      totalAmount
      currency
      customerCount
      estimatedFees
      feePercentage
      netBalance
      targetAmount
      percentOfTarget
      feeSource
      totalRefunded
      refundCount
      disputeCount
      disputeAmount
      reconciliationPercent
      feeEnrichedPercent
    }
  }
}
    `;

/**
 * __useGetFinancialReportsQuery__
 *
 * To run a query within a React component, call `useGetFinancialReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancialReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialReportsQuery, GetFinancialReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialReportsQuery, GetFinancialReportsQueryVariables>(GetFinancialReportsDocument, options);
      }
export function useGetFinancialReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialReportsQuery, GetFinancialReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialReportsQuery, GetFinancialReportsQueryVariables>(GetFinancialReportsDocument, options);
        }
export function useGetFinancialReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFinancialReportsQuery, GetFinancialReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFinancialReportsQuery, GetFinancialReportsQueryVariables>(GetFinancialReportsDocument, options);
        }
export type GetFinancialReportsQueryHookResult = ReturnType<typeof useGetFinancialReportsQuery>;
export type GetFinancialReportsLazyQueryHookResult = ReturnType<typeof useGetFinancialReportsLazyQuery>;
export type GetFinancialReportsSuspenseQueryHookResult = ReturnType<typeof useGetFinancialReportsSuspenseQuery>;
export type GetFinancialReportsQueryResult = Apollo.QueryResult<GetFinancialReportsQuery, GetFinancialReportsQueryVariables>;
export const GetOpenServiceCasesDocument = gql`
    query GetOpenServiceCases {
  openServiceCases {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;

/**
 * __useGetOpenServiceCasesQuery__
 *
 * To run a query within a React component, call `useGetOpenServiceCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenServiceCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenServiceCasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpenServiceCasesQuery(baseOptions?: Apollo.QueryHookOptions<GetOpenServiceCasesQuery, GetOpenServiceCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenServiceCasesQuery, GetOpenServiceCasesQueryVariables>(GetOpenServiceCasesDocument, options);
      }
export function useGetOpenServiceCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenServiceCasesQuery, GetOpenServiceCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenServiceCasesQuery, GetOpenServiceCasesQueryVariables>(GetOpenServiceCasesDocument, options);
        }
export function useGetOpenServiceCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenServiceCasesQuery, GetOpenServiceCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpenServiceCasesQuery, GetOpenServiceCasesQueryVariables>(GetOpenServiceCasesDocument, options);
        }
export type GetOpenServiceCasesQueryHookResult = ReturnType<typeof useGetOpenServiceCasesQuery>;
export type GetOpenServiceCasesLazyQueryHookResult = ReturnType<typeof useGetOpenServiceCasesLazyQuery>;
export type GetOpenServiceCasesSuspenseQueryHookResult = ReturnType<typeof useGetOpenServiceCasesSuspenseQuery>;
export type GetOpenServiceCasesQueryResult = Apollo.QueryResult<GetOpenServiceCasesQuery, GetOpenServiceCasesQueryVariables>;
export const GetServiceCasesByStatusDocument = gql`
    query GetServiceCasesByStatus($status: ServiceCaseStatus!) {
  serviceCasesByStatus(status: $status) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;

/**
 * __useGetServiceCasesByStatusQuery__
 *
 * To run a query within a React component, call `useGetServiceCasesByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceCasesByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceCasesByStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetServiceCasesByStatusQuery(baseOptions: Apollo.QueryHookOptions<GetServiceCasesByStatusQuery, GetServiceCasesByStatusQueryVariables> & ({ variables: GetServiceCasesByStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceCasesByStatusQuery, GetServiceCasesByStatusQueryVariables>(GetServiceCasesByStatusDocument, options);
      }
export function useGetServiceCasesByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceCasesByStatusQuery, GetServiceCasesByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceCasesByStatusQuery, GetServiceCasesByStatusQueryVariables>(GetServiceCasesByStatusDocument, options);
        }
export function useGetServiceCasesByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceCasesByStatusQuery, GetServiceCasesByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceCasesByStatusQuery, GetServiceCasesByStatusQueryVariables>(GetServiceCasesByStatusDocument, options);
        }
export type GetServiceCasesByStatusQueryHookResult = ReturnType<typeof useGetServiceCasesByStatusQuery>;
export type GetServiceCasesByStatusLazyQueryHookResult = ReturnType<typeof useGetServiceCasesByStatusLazyQuery>;
export type GetServiceCasesByStatusSuspenseQueryHookResult = ReturnType<typeof useGetServiceCasesByStatusSuspenseQuery>;
export type GetServiceCasesByStatusQueryResult = Apollo.QueryResult<GetServiceCasesByStatusQuery, GetServiceCasesByStatusQueryVariables>;
export const GetServiceCasesByIssueTypeDocument = gql`
    query GetServiceCasesByIssueType($issueType: IssueType!) {
  serviceCasesByIssueType(issueType: $issueType) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;

/**
 * __useGetServiceCasesByIssueTypeQuery__
 *
 * To run a query within a React component, call `useGetServiceCasesByIssueTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceCasesByIssueTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceCasesByIssueTypeQuery({
 *   variables: {
 *      issueType: // value for 'issueType'
 *   },
 * });
 */
export function useGetServiceCasesByIssueTypeQuery(baseOptions: Apollo.QueryHookOptions<GetServiceCasesByIssueTypeQuery, GetServiceCasesByIssueTypeQueryVariables> & ({ variables: GetServiceCasesByIssueTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceCasesByIssueTypeQuery, GetServiceCasesByIssueTypeQueryVariables>(GetServiceCasesByIssueTypeDocument, options);
      }
export function useGetServiceCasesByIssueTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceCasesByIssueTypeQuery, GetServiceCasesByIssueTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceCasesByIssueTypeQuery, GetServiceCasesByIssueTypeQueryVariables>(GetServiceCasesByIssueTypeDocument, options);
        }
export function useGetServiceCasesByIssueTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceCasesByIssueTypeQuery, GetServiceCasesByIssueTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceCasesByIssueTypeQuery, GetServiceCasesByIssueTypeQueryVariables>(GetServiceCasesByIssueTypeDocument, options);
        }
export type GetServiceCasesByIssueTypeQueryHookResult = ReturnType<typeof useGetServiceCasesByIssueTypeQuery>;
export type GetServiceCasesByIssueTypeLazyQueryHookResult = ReturnType<typeof useGetServiceCasesByIssueTypeLazyQuery>;
export type GetServiceCasesByIssueTypeSuspenseQueryHookResult = ReturnType<typeof useGetServiceCasesByIssueTypeSuspenseQuery>;
export type GetServiceCasesByIssueTypeQueryResult = Apollo.QueryResult<GetServiceCasesByIssueTypeQuery, GetServiceCasesByIssueTypeQueryVariables>;
export const GetServiceCaseDocument = gql`
    query GetServiceCase($serviceCaseId: ID!) {
  serviceCase(serviceCaseId: $serviceCaseId) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;

/**
 * __useGetServiceCaseQuery__
 *
 * To run a query within a React component, call `useGetServiceCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceCaseQuery({
 *   variables: {
 *      serviceCaseId: // value for 'serviceCaseId'
 *   },
 * });
 */
export function useGetServiceCaseQuery(baseOptions: Apollo.QueryHookOptions<GetServiceCaseQuery, GetServiceCaseQueryVariables> & ({ variables: GetServiceCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceCaseQuery, GetServiceCaseQueryVariables>(GetServiceCaseDocument, options);
      }
export function useGetServiceCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceCaseQuery, GetServiceCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceCaseQuery, GetServiceCaseQueryVariables>(GetServiceCaseDocument, options);
        }
export function useGetServiceCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceCaseQuery, GetServiceCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceCaseQuery, GetServiceCaseQueryVariables>(GetServiceCaseDocument, options);
        }
export type GetServiceCaseQueryHookResult = ReturnType<typeof useGetServiceCaseQuery>;
export type GetServiceCaseLazyQueryHookResult = ReturnType<typeof useGetServiceCaseLazyQuery>;
export type GetServiceCaseSuspenseQueryHookResult = ReturnType<typeof useGetServiceCaseSuspenseQuery>;
export type GetServiceCaseQueryResult = Apollo.QueryResult<GetServiceCaseQuery, GetServiceCaseQueryVariables>;
export const GetCustomerServiceCasesDocument = gql`
    query GetCustomerServiceCases($customerId: ID!) {
  serviceCases(customerId: $customerId) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;

/**
 * __useGetCustomerServiceCasesQuery__
 *
 * To run a query within a React component, call `useGetCustomerServiceCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerServiceCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerServiceCasesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerServiceCasesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerServiceCasesQuery, GetCustomerServiceCasesQueryVariables> & ({ variables: GetCustomerServiceCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerServiceCasesQuery, GetCustomerServiceCasesQueryVariables>(GetCustomerServiceCasesDocument, options);
      }
export function useGetCustomerServiceCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerServiceCasesQuery, GetCustomerServiceCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerServiceCasesQuery, GetCustomerServiceCasesQueryVariables>(GetCustomerServiceCasesDocument, options);
        }
export function useGetCustomerServiceCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerServiceCasesQuery, GetCustomerServiceCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerServiceCasesQuery, GetCustomerServiceCasesQueryVariables>(GetCustomerServiceCasesDocument, options);
        }
export type GetCustomerServiceCasesQueryHookResult = ReturnType<typeof useGetCustomerServiceCasesQuery>;
export type GetCustomerServiceCasesLazyQueryHookResult = ReturnType<typeof useGetCustomerServiceCasesLazyQuery>;
export type GetCustomerServiceCasesSuspenseQueryHookResult = ReturnType<typeof useGetCustomerServiceCasesSuspenseQuery>;
export type GetCustomerServiceCasesQueryResult = Apollo.QueryResult<GetCustomerServiceCasesQuery, GetCustomerServiceCasesQueryVariables>;
export const GetAllServiceCasesDocument = gql`
    query GetAllServiceCases {
  allServiceCases {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;

/**
 * __useGetAllServiceCasesQuery__
 *
 * To run a query within a React component, call `useGetAllServiceCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllServiceCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllServiceCasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllServiceCasesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllServiceCasesQuery, GetAllServiceCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllServiceCasesQuery, GetAllServiceCasesQueryVariables>(GetAllServiceCasesDocument, options);
      }
export function useGetAllServiceCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllServiceCasesQuery, GetAllServiceCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllServiceCasesQuery, GetAllServiceCasesQueryVariables>(GetAllServiceCasesDocument, options);
        }
export function useGetAllServiceCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllServiceCasesQuery, GetAllServiceCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllServiceCasesQuery, GetAllServiceCasesQueryVariables>(GetAllServiceCasesDocument, options);
        }
export type GetAllServiceCasesQueryHookResult = ReturnType<typeof useGetAllServiceCasesQuery>;
export type GetAllServiceCasesLazyQueryHookResult = ReturnType<typeof useGetAllServiceCasesLazyQuery>;
export type GetAllServiceCasesSuspenseQueryHookResult = ReturnType<typeof useGetAllServiceCasesSuspenseQuery>;
export type GetAllServiceCasesQueryResult = Apollo.QueryResult<GetAllServiceCasesQuery, GetAllServiceCasesQueryVariables>;
export const OpenServiceCaseDocument = gql`
    mutation OpenServiceCase($input: OpenServiceCaseInput!) {
  openServiceCase(input: $input) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;
export type OpenServiceCaseMutationFn = Apollo.MutationFunction<OpenServiceCaseMutation, OpenServiceCaseMutationVariables>;

/**
 * __useOpenServiceCaseMutation__
 *
 * To run a mutation, you first call `useOpenServiceCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenServiceCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openServiceCaseMutation, { data, loading, error }] = useOpenServiceCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenServiceCaseMutation(baseOptions?: Apollo.MutationHookOptions<OpenServiceCaseMutation, OpenServiceCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenServiceCaseMutation, OpenServiceCaseMutationVariables>(OpenServiceCaseDocument, options);
      }
export type OpenServiceCaseMutationHookResult = ReturnType<typeof useOpenServiceCaseMutation>;
export type OpenServiceCaseMutationResult = Apollo.MutationResult<OpenServiceCaseMutation>;
export type OpenServiceCaseMutationOptions = Apollo.BaseMutationOptions<OpenServiceCaseMutation, OpenServiceCaseMutationVariables>;
export const SetServiceCaseResolutionDocument = gql`
    mutation SetServiceCaseResolution($input: SetResolutionInput!) {
  setResolution(input: $input) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;
export type SetServiceCaseResolutionMutationFn = Apollo.MutationFunction<SetServiceCaseResolutionMutation, SetServiceCaseResolutionMutationVariables>;

/**
 * __useSetServiceCaseResolutionMutation__
 *
 * To run a mutation, you first call `useSetServiceCaseResolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetServiceCaseResolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setServiceCaseResolutionMutation, { data, loading, error }] = useSetServiceCaseResolutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetServiceCaseResolutionMutation(baseOptions?: Apollo.MutationHookOptions<SetServiceCaseResolutionMutation, SetServiceCaseResolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetServiceCaseResolutionMutation, SetServiceCaseResolutionMutationVariables>(SetServiceCaseResolutionDocument, options);
      }
export type SetServiceCaseResolutionMutationHookResult = ReturnType<typeof useSetServiceCaseResolutionMutation>;
export type SetServiceCaseResolutionMutationResult = Apollo.MutationResult<SetServiceCaseResolutionMutation>;
export type SetServiceCaseResolutionMutationOptions = Apollo.BaseMutationOptions<SetServiceCaseResolutionMutation, SetServiceCaseResolutionMutationVariables>;
export const InitiateReturnDocument = gql`
    mutation InitiateReturn($input: InitiateReturnInput!) {
  initiateReturn(input: $input) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;
export type InitiateReturnMutationFn = Apollo.MutationFunction<InitiateReturnMutation, InitiateReturnMutationVariables>;

/**
 * __useInitiateReturnMutation__
 *
 * To run a mutation, you first call `useInitiateReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateReturnMutation, { data, loading, error }] = useInitiateReturnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateReturnMutation(baseOptions?: Apollo.MutationHookOptions<InitiateReturnMutation, InitiateReturnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateReturnMutation, InitiateReturnMutationVariables>(InitiateReturnDocument, options);
      }
export type InitiateReturnMutationHookResult = ReturnType<typeof useInitiateReturnMutation>;
export type InitiateReturnMutationResult = Apollo.MutationResult<InitiateReturnMutation>;
export type InitiateReturnMutationOptions = Apollo.BaseMutationOptions<InitiateReturnMutation, InitiateReturnMutationVariables>;
export const MarkReturnShippedDocument = gql`
    mutation MarkReturnShipped($input: MarkReturnShippedInput!) {
  markReturnShipped(input: $input) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;
export type MarkReturnShippedMutationFn = Apollo.MutationFunction<MarkReturnShippedMutation, MarkReturnShippedMutationVariables>;

/**
 * __useMarkReturnShippedMutation__
 *
 * To run a mutation, you first call `useMarkReturnShippedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkReturnShippedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markReturnShippedMutation, { data, loading, error }] = useMarkReturnShippedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkReturnShippedMutation(baseOptions?: Apollo.MutationHookOptions<MarkReturnShippedMutation, MarkReturnShippedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkReturnShippedMutation, MarkReturnShippedMutationVariables>(MarkReturnShippedDocument, options);
      }
export type MarkReturnShippedMutationHookResult = ReturnType<typeof useMarkReturnShippedMutation>;
export type MarkReturnShippedMutationResult = Apollo.MutationResult<MarkReturnShippedMutation>;
export type MarkReturnShippedMutationOptions = Apollo.BaseMutationOptions<MarkReturnShippedMutation, MarkReturnShippedMutationVariables>;
export const MarkReturnReceivedDocument = gql`
    mutation MarkReturnReceived($input: MarkReturnReceivedInput!) {
  markReturnReceived(input: $input) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;
export type MarkReturnReceivedMutationFn = Apollo.MutationFunction<MarkReturnReceivedMutation, MarkReturnReceivedMutationVariables>;

/**
 * __useMarkReturnReceivedMutation__
 *
 * To run a mutation, you first call `useMarkReturnReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkReturnReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markReturnReceivedMutation, { data, loading, error }] = useMarkReturnReceivedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkReturnReceivedMutation(baseOptions?: Apollo.MutationHookOptions<MarkReturnReceivedMutation, MarkReturnReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkReturnReceivedMutation, MarkReturnReceivedMutationVariables>(MarkReturnReceivedDocument, options);
      }
export type MarkReturnReceivedMutationHookResult = ReturnType<typeof useMarkReturnReceivedMutation>;
export type MarkReturnReceivedMutationResult = Apollo.MutationResult<MarkReturnReceivedMutation>;
export type MarkReturnReceivedMutationOptions = Apollo.BaseMutationOptions<MarkReturnReceivedMutation, MarkReturnReceivedMutationVariables>;
export const LinkReplacementShipmentDocument = gql`
    mutation LinkReplacementShipment($input: LinkReplacementShipmentInput!) {
  linkReplacementShipment(input: $input) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;
export type LinkReplacementShipmentMutationFn = Apollo.MutationFunction<LinkReplacementShipmentMutation, LinkReplacementShipmentMutationVariables>;

/**
 * __useLinkReplacementShipmentMutation__
 *
 * To run a mutation, you first call `useLinkReplacementShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkReplacementShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkReplacementShipmentMutation, { data, loading, error }] = useLinkReplacementShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkReplacementShipmentMutation(baseOptions?: Apollo.MutationHookOptions<LinkReplacementShipmentMutation, LinkReplacementShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkReplacementShipmentMutation, LinkReplacementShipmentMutationVariables>(LinkReplacementShipmentDocument, options);
      }
export type LinkReplacementShipmentMutationHookResult = ReturnType<typeof useLinkReplacementShipmentMutation>;
export type LinkReplacementShipmentMutationResult = Apollo.MutationResult<LinkReplacementShipmentMutation>;
export type LinkReplacementShipmentMutationOptions = Apollo.BaseMutationOptions<LinkReplacementShipmentMutation, LinkReplacementShipmentMutationVariables>;
export const ResolveServiceCaseDocument = gql`
    mutation ResolveServiceCase($input: ResolveServiceCaseInput!) {
  resolveServiceCase(input: $input) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;
export type ResolveServiceCaseMutationFn = Apollo.MutationFunction<ResolveServiceCaseMutation, ResolveServiceCaseMutationVariables>;

/**
 * __useResolveServiceCaseMutation__
 *
 * To run a mutation, you first call `useResolveServiceCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveServiceCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveServiceCaseMutation, { data, loading, error }] = useResolveServiceCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveServiceCaseMutation(baseOptions?: Apollo.MutationHookOptions<ResolveServiceCaseMutation, ResolveServiceCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveServiceCaseMutation, ResolveServiceCaseMutationVariables>(ResolveServiceCaseDocument, options);
      }
export type ResolveServiceCaseMutationHookResult = ReturnType<typeof useResolveServiceCaseMutation>;
export type ResolveServiceCaseMutationResult = Apollo.MutationResult<ResolveServiceCaseMutation>;
export type ResolveServiceCaseMutationOptions = Apollo.BaseMutationOptions<ResolveServiceCaseMutation, ResolveServiceCaseMutationVariables>;
export const CancelServiceCaseDocument = gql`
    mutation CancelServiceCase($input: CancelServiceCaseInput!) {
  cancelServiceCase(input: $input) {
    ...ServiceCaseFields
  }
}
    ${ServiceCaseFieldsFragmentDoc}`;
export type CancelServiceCaseMutationFn = Apollo.MutationFunction<CancelServiceCaseMutation, CancelServiceCaseMutationVariables>;

/**
 * __useCancelServiceCaseMutation__
 *
 * To run a mutation, you first call `useCancelServiceCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelServiceCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelServiceCaseMutation, { data, loading, error }] = useCancelServiceCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelServiceCaseMutation(baseOptions?: Apollo.MutationHookOptions<CancelServiceCaseMutation, CancelServiceCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelServiceCaseMutation, CancelServiceCaseMutationVariables>(CancelServiceCaseDocument, options);
      }
export type CancelServiceCaseMutationHookResult = ReturnType<typeof useCancelServiceCaseMutation>;
export type CancelServiceCaseMutationResult = Apollo.MutationResult<CancelServiceCaseMutation>;
export type CancelServiceCaseMutationOptions = Apollo.BaseMutationOptions<CancelServiceCaseMutation, CancelServiceCaseMutationVariables>;
export const GetPendingShipmentsDocument = gql`
    query GetPendingShipments {
  pendingShipments {
    ...ShipmentFields
  }
}
    ${ShipmentFieldsFragmentDoc}`;

/**
 * __useGetPendingShipmentsQuery__
 *
 * To run a query within a React component, call `useGetPendingShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingShipmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingShipmentsQuery, GetPendingShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingShipmentsQuery, GetPendingShipmentsQueryVariables>(GetPendingShipmentsDocument, options);
      }
export function useGetPendingShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingShipmentsQuery, GetPendingShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingShipmentsQuery, GetPendingShipmentsQueryVariables>(GetPendingShipmentsDocument, options);
        }
export function useGetPendingShipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingShipmentsQuery, GetPendingShipmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingShipmentsQuery, GetPendingShipmentsQueryVariables>(GetPendingShipmentsDocument, options);
        }
export type GetPendingShipmentsQueryHookResult = ReturnType<typeof useGetPendingShipmentsQuery>;
export type GetPendingShipmentsLazyQueryHookResult = ReturnType<typeof useGetPendingShipmentsLazyQuery>;
export type GetPendingShipmentsSuspenseQueryHookResult = ReturnType<typeof useGetPendingShipmentsSuspenseQuery>;
export type GetPendingShipmentsQueryResult = Apollo.QueryResult<GetPendingShipmentsQuery, GetPendingShipmentsQueryVariables>;
export const GetShipmentsDocument = gql`
    query GetShipments($customerId: ID!) {
  shipments(customerId: $customerId) {
    ...ShipmentFields
  }
}
    ${ShipmentFieldsFragmentDoc}`;

/**
 * __useGetShipmentsQuery__
 *
 * To run a query within a React component, call `useGetShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetShipmentsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables> & ({ variables: GetShipmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
      }
export function useGetShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
        }
export function useGetShipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
        }
export type GetShipmentsQueryHookResult = ReturnType<typeof useGetShipmentsQuery>;
export type GetShipmentsLazyQueryHookResult = ReturnType<typeof useGetShipmentsLazyQuery>;
export type GetShipmentsSuspenseQueryHookResult = ReturnType<typeof useGetShipmentsSuspenseQuery>;
export type GetShipmentsQueryResult = Apollo.QueryResult<GetShipmentsQuery, GetShipmentsQueryVariables>;
export const GetShipmentDocument = gql`
    query GetShipment($shipmentId: ID!) {
  shipment(shipmentId: $shipmentId) {
    ...ShipmentFields
  }
}
    ${ShipmentFieldsFragmentDoc}`;

/**
 * __useGetShipmentQuery__
 *
 * To run a query within a React component, call `useGetShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentQuery({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useGetShipmentQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables> & ({ variables: GetShipmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
      }
export function useGetShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
        }
export function useGetShipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
        }
export type GetShipmentQueryHookResult = ReturnType<typeof useGetShipmentQuery>;
export type GetShipmentLazyQueryHookResult = ReturnType<typeof useGetShipmentLazyQuery>;
export type GetShipmentSuspenseQueryHookResult = ReturnType<typeof useGetShipmentSuspenseQuery>;
export type GetShipmentQueryResult = Apollo.QueryResult<GetShipmentQuery, GetShipmentQueryVariables>;
export const GetShipmentsByStatusDocument = gql`
    query GetShipmentsByStatus($status: ShipmentStatus) {
  shipmentsByStatus(status: $status) {
    ...ShipmentFields
  }
}
    ${ShipmentFieldsFragmentDoc}`;

/**
 * __useGetShipmentsByStatusQuery__
 *
 * To run a query within a React component, call `useGetShipmentsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsByStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetShipmentsByStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetShipmentsByStatusQuery, GetShipmentsByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsByStatusQuery, GetShipmentsByStatusQueryVariables>(GetShipmentsByStatusDocument, options);
      }
export function useGetShipmentsByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsByStatusQuery, GetShipmentsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsByStatusQuery, GetShipmentsByStatusQueryVariables>(GetShipmentsByStatusDocument, options);
        }
export function useGetShipmentsByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentsByStatusQuery, GetShipmentsByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShipmentsByStatusQuery, GetShipmentsByStatusQueryVariables>(GetShipmentsByStatusDocument, options);
        }
export type GetShipmentsByStatusQueryHookResult = ReturnType<typeof useGetShipmentsByStatusQuery>;
export type GetShipmentsByStatusLazyQueryHookResult = ReturnType<typeof useGetShipmentsByStatusLazyQuery>;
export type GetShipmentsByStatusSuspenseQueryHookResult = ReturnType<typeof useGetShipmentsByStatusSuspenseQuery>;
export type GetShipmentsByStatusQueryResult = Apollo.QueryResult<GetShipmentsByStatusQuery, GetShipmentsByStatusQueryVariables>;
export const CreateShipmentDocument = gql`
    mutation CreateShipment($cmd: CreateShipmentInput!) {
  createShipment(cmd: $cmd) {
    ...ShipmentFields
  }
}
    ${ShipmentFieldsFragmentDoc}`;
export type CreateShipmentMutationFn = Apollo.MutationFunction<CreateShipmentMutation, CreateShipmentMutationVariables>;

/**
 * __useCreateShipmentMutation__
 *
 * To run a mutation, you first call `useCreateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentMutation, { data, loading, error }] = useCreateShipmentMutation({
 *   variables: {
 *      cmd: // value for 'cmd'
 *   },
 * });
 */
export function useCreateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateShipmentMutation, CreateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShipmentMutation, CreateShipmentMutationVariables>(CreateShipmentDocument, options);
      }
export type CreateShipmentMutationHookResult = ReturnType<typeof useCreateShipmentMutation>;
export type CreateShipmentMutationResult = Apollo.MutationResult<CreateShipmentMutation>;
export type CreateShipmentMutationOptions = Apollo.BaseMutationOptions<CreateShipmentMutation, CreateShipmentMutationVariables>;
export const MarkShipmentShippedDocument = gql`
    mutation MarkShipmentShipped($cmd: MarkShipmentShippedInput!) {
  markShipmentShipped(cmd: $cmd) {
    ...ShipmentFields
  }
}
    ${ShipmentFieldsFragmentDoc}`;
export type MarkShipmentShippedMutationFn = Apollo.MutationFunction<MarkShipmentShippedMutation, MarkShipmentShippedMutationVariables>;

/**
 * __useMarkShipmentShippedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentShippedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentShippedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentShippedMutation, { data, loading, error }] = useMarkShipmentShippedMutation({
 *   variables: {
 *      cmd: // value for 'cmd'
 *   },
 * });
 */
export function useMarkShipmentShippedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentShippedMutation, MarkShipmentShippedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentShippedMutation, MarkShipmentShippedMutationVariables>(MarkShipmentShippedDocument, options);
      }
export type MarkShipmentShippedMutationHookResult = ReturnType<typeof useMarkShipmentShippedMutation>;
export type MarkShipmentShippedMutationResult = Apollo.MutationResult<MarkShipmentShippedMutation>;
export type MarkShipmentShippedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentShippedMutation, MarkShipmentShippedMutationVariables>;
export const MarkShipmentDeliveredDocument = gql`
    mutation MarkShipmentDelivered($shipmentId: ID!) {
  markShipmentDelivered(shipmentId: $shipmentId) {
    ...ShipmentFields
  }
}
    ${ShipmentFieldsFragmentDoc}`;
export type MarkShipmentDeliveredMutationFn = Apollo.MutationFunction<MarkShipmentDeliveredMutation, MarkShipmentDeliveredMutationVariables>;

/**
 * __useMarkShipmentDeliveredMutation__
 *
 * To run a mutation, you first call `useMarkShipmentDeliveredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentDeliveredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentDeliveredMutation, { data, loading, error }] = useMarkShipmentDeliveredMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useMarkShipmentDeliveredMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentDeliveredMutation, MarkShipmentDeliveredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentDeliveredMutation, MarkShipmentDeliveredMutationVariables>(MarkShipmentDeliveredDocument, options);
      }
export type MarkShipmentDeliveredMutationHookResult = ReturnType<typeof useMarkShipmentDeliveredMutation>;
export type MarkShipmentDeliveredMutationResult = Apollo.MutationResult<MarkShipmentDeliveredMutation>;
export type MarkShipmentDeliveredMutationOptions = Apollo.BaseMutationOptions<MarkShipmentDeliveredMutation, MarkShipmentDeliveredMutationVariables>;
export const MarkShipmentReturnedDocument = gql`
    mutation MarkShipmentReturned($shipmentId: ID!, $reason: String) {
  markShipmentReturned(shipmentId: $shipmentId, reason: $reason) {
    ...ShipmentFields
  }
}
    ${ShipmentFieldsFragmentDoc}`;
export type MarkShipmentReturnedMutationFn = Apollo.MutationFunction<MarkShipmentReturnedMutation, MarkShipmentReturnedMutationVariables>;

/**
 * __useMarkShipmentReturnedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentReturnedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentReturnedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentReturnedMutation, { data, loading, error }] = useMarkShipmentReturnedMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useMarkShipmentReturnedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentReturnedMutation, MarkShipmentReturnedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentReturnedMutation, MarkShipmentReturnedMutationVariables>(MarkShipmentReturnedDocument, options);
      }
export type MarkShipmentReturnedMutationHookResult = ReturnType<typeof useMarkShipmentReturnedMutation>;
export type MarkShipmentReturnedMutationResult = Apollo.MutationResult<MarkShipmentReturnedMutation>;
export type MarkShipmentReturnedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentReturnedMutation, MarkShipmentReturnedMutationVariables>;
export const UpdateShipmentTrackingDocument = gql`
    mutation UpdateShipmentTracking($cmd: UpdateShipmentTrackingInput!) {
  updateShipmentTracking(cmd: $cmd) {
    ...ShipmentFields
  }
}
    ${ShipmentFieldsFragmentDoc}`;
export type UpdateShipmentTrackingMutationFn = Apollo.MutationFunction<UpdateShipmentTrackingMutation, UpdateShipmentTrackingMutationVariables>;

/**
 * __useUpdateShipmentTrackingMutation__
 *
 * To run a mutation, you first call `useUpdateShipmentTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentTrackingMutation, { data, loading, error }] = useUpdateShipmentTrackingMutation({
 *   variables: {
 *      cmd: // value for 'cmd'
 *   },
 * });
 */
export function useUpdateShipmentTrackingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShipmentTrackingMutation, UpdateShipmentTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShipmentTrackingMutation, UpdateShipmentTrackingMutationVariables>(UpdateShipmentTrackingDocument, options);
      }
export type UpdateShipmentTrackingMutationHookResult = ReturnType<typeof useUpdateShipmentTrackingMutation>;
export type UpdateShipmentTrackingMutationResult = Apollo.MutationResult<UpdateShipmentTrackingMutation>;
export type UpdateShipmentTrackingMutationOptions = Apollo.BaseMutationOptions<UpdateShipmentTrackingMutation, UpdateShipmentTrackingMutationVariables>;
export const GetChatInboxDocument = gql`
    query GetChatInbox($input: ChatInboxInput) {
  chatInbox(input: $input) {
    items {
      channelId
      participantId
      lastMessagePreview
      lastMessageAt
      status
      unreadCount
      pii {
        identityInformation {
          firstName
          lastName
        }
        contactInformation {
          email
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetChatInboxQuery__
 *
 * To run a query within a React component, call `useGetChatInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatInboxQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChatInboxQuery(baseOptions?: Apollo.QueryHookOptions<GetChatInboxQuery, GetChatInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatInboxQuery, GetChatInboxQueryVariables>(GetChatInboxDocument, options);
      }
export function useGetChatInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatInboxQuery, GetChatInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatInboxQuery, GetChatInboxQueryVariables>(GetChatInboxDocument, options);
        }
export function useGetChatInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatInboxQuery, GetChatInboxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatInboxQuery, GetChatInboxQueryVariables>(GetChatInboxDocument, options);
        }
export type GetChatInboxQueryHookResult = ReturnType<typeof useGetChatInboxQuery>;
export type GetChatInboxLazyQueryHookResult = ReturnType<typeof useGetChatInboxLazyQuery>;
export type GetChatInboxSuspenseQueryHookResult = ReturnType<typeof useGetChatInboxSuspenseQuery>;
export type GetChatInboxQueryResult = Apollo.QueryResult<GetChatInboxQuery, GetChatInboxQueryVariables>;
export const GetRecentMessagesDocument = gql`
    query GetRecentMessages($dateRange: DateRangeInput!) {
  recentMessages(dateRange: $dateRange) {
    id
    receivedAt
    userId
    channelId
    pii {
      identityInformation {
        firstName
        lastName
      }
      contactInformation {
        email
      }
    }
  }
}
    `;

/**
 * __useGetRecentMessagesQuery__
 *
 * To run a query within a React component, call `useGetRecentMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentMessagesQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetRecentMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetRecentMessagesQuery, GetRecentMessagesQueryVariables> & ({ variables: GetRecentMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentMessagesQuery, GetRecentMessagesQueryVariables>(GetRecentMessagesDocument, options);
      }
export function useGetRecentMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentMessagesQuery, GetRecentMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentMessagesQuery, GetRecentMessagesQueryVariables>(GetRecentMessagesDocument, options);
        }
export function useGetRecentMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentMessagesQuery, GetRecentMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentMessagesQuery, GetRecentMessagesQueryVariables>(GetRecentMessagesDocument, options);
        }
export type GetRecentMessagesQueryHookResult = ReturnType<typeof useGetRecentMessagesQuery>;
export type GetRecentMessagesLazyQueryHookResult = ReturnType<typeof useGetRecentMessagesLazyQuery>;
export type GetRecentMessagesSuspenseQueryHookResult = ReturnType<typeof useGetRecentMessagesSuspenseQuery>;
export type GetRecentMessagesQueryResult = Apollo.QueryResult<GetRecentMessagesQuery, GetRecentMessagesQueryVariables>;
export const GetInteractionTimelineDocument = gql`
    query GetInteractionTimeline($filter: InteractionTimelineFilter!) {
  interactionTimeline(filter: $filter) {
    interactions {
      actorId
      targetId
      timestamp
      interaction
      icon
      importance
      actor {
        userId
        displayName
      }
    }
  }
}
    `;

/**
 * __useGetInteractionTimelineQuery__
 *
 * To run a query within a React component, call `useGetInteractionTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInteractionTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInteractionTimelineQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetInteractionTimelineQuery(baseOptions: Apollo.QueryHookOptions<GetInteractionTimelineQuery, GetInteractionTimelineQueryVariables> & ({ variables: GetInteractionTimelineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInteractionTimelineQuery, GetInteractionTimelineQueryVariables>(GetInteractionTimelineDocument, options);
      }
export function useGetInteractionTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInteractionTimelineQuery, GetInteractionTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInteractionTimelineQuery, GetInteractionTimelineQueryVariables>(GetInteractionTimelineDocument, options);
        }
export function useGetInteractionTimelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInteractionTimelineQuery, GetInteractionTimelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInteractionTimelineQuery, GetInteractionTimelineQueryVariables>(GetInteractionTimelineDocument, options);
        }
export type GetInteractionTimelineQueryHookResult = ReturnType<typeof useGetInteractionTimelineQuery>;
export type GetInteractionTimelineLazyQueryHookResult = ReturnType<typeof useGetInteractionTimelineLazyQuery>;
export type GetInteractionTimelineSuspenseQueryHookResult = ReturnType<typeof useGetInteractionTimelineSuspenseQuery>;
export type GetInteractionTimelineQueryResult = Apollo.QueryResult<GetInteractionTimelineQuery, GetInteractionTimelineQueryVariables>;
export const GetDashboardChatAnalyticsDocument = gql`
    query GetDashboardChatAnalytics($dateRange: DateRangeInput!) {
  chatInbound: quickStat(
    filter: {statName: "chatInboundMessages", dateRange: $dateRange, aggregationStrategy: sum, label: "Inbound Messages", description: "Total messages from participants to care team"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  chatOutbound: quickStat(
    filter: {statName: "chatOutboundMessages", dateRange: $dateRange, aggregationStrategy: sum, label: "Outbound Messages", description: "Total messages from care team to participants"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  chatResponseRate: quickStat(
    filter: {statName: "chatResponseRate", dateRange: $dateRange, aggregationStrategy: average, label: "Response Rate", description: "Percentage of outbound messages with replies within 3 days"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
}
    `;

/**
 * __useGetDashboardChatAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDashboardChatAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardChatAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardChatAnalyticsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetDashboardChatAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardChatAnalyticsQuery, GetDashboardChatAnalyticsQueryVariables> & ({ variables: GetDashboardChatAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardChatAnalyticsQuery, GetDashboardChatAnalyticsQueryVariables>(GetDashboardChatAnalyticsDocument, options);
      }
export function useGetDashboardChatAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardChatAnalyticsQuery, GetDashboardChatAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardChatAnalyticsQuery, GetDashboardChatAnalyticsQueryVariables>(GetDashboardChatAnalyticsDocument, options);
        }
export function useGetDashboardChatAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardChatAnalyticsQuery, GetDashboardChatAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardChatAnalyticsQuery, GetDashboardChatAnalyticsQueryVariables>(GetDashboardChatAnalyticsDocument, options);
        }
export type GetDashboardChatAnalyticsQueryHookResult = ReturnType<typeof useGetDashboardChatAnalyticsQuery>;
export type GetDashboardChatAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDashboardChatAnalyticsLazyQuery>;
export type GetDashboardChatAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardChatAnalyticsSuspenseQuery>;
export type GetDashboardChatAnalyticsQueryResult = Apollo.QueryResult<GetDashboardChatAnalyticsQuery, GetDashboardChatAnalyticsQueryVariables>;
export const GetCohortAnalysisDocument = gql`
    query GetCohortAnalysis($maxDays: Int!, $baselineDays: Int, $minBaselineMeasurements: Int, $maxMeasurementGapDays: Int) {
  hrvCohort: cohortAnalysis(
    filter: {metricName: "hrv", maxDays: $maxDays, baselineDays: $baselineDays, minBaselineMeasurements: $minBaselineMeasurements, maxMeasurementGapDays: $maxMeasurementGapDays}
  ) {
    metric
    unit
    baselineValue
    dataPoints {
      daysSinceStart
      percentageChange
      absoluteChange
      actualValue
      baselineValue
      cohortCount
      userCount
    }
    auc {
      positiveAuc
      negativeAuc
      netAuc
    }
  }
  rmssdCohort: cohortAnalysis(
    filter: {metricName: "rmssd", maxDays: $maxDays, baselineDays: $baselineDays, minBaselineMeasurements: $minBaselineMeasurements, maxMeasurementGapDays: $maxMeasurementGapDays}
  ) {
    metric
    unit
    baselineValue
    dataPoints {
      daysSinceStart
      percentageChange
      absoluteChange
      actualValue
      baselineValue
      cohortCount
      userCount
    }
    auc {
      positiveAuc
      negativeAuc
      netAuc
    }
  }
  stressCohort: cohortAnalysis(
    filter: {metricName: "stressIndex", maxDays: $maxDays, baselineDays: $baselineDays, minBaselineMeasurements: $minBaselineMeasurements, maxMeasurementGapDays: $maxMeasurementGapDays}
  ) {
    metric
    unit
    baselineValue
    dataPoints {
      daysSinceStart
      percentageChange
      absoluteChange
      actualValue
      baselineValue
      cohortCount
      userCount
    }
    auc {
      positiveAuc
      negativeAuc
      netAuc
    }
  }
  parasympatheticCohort: cohortAnalysis(
    filter: {metricName: "parasympathetic", maxDays: $maxDays, baselineDays: $baselineDays, minBaselineMeasurements: $minBaselineMeasurements, maxMeasurementGapDays: $maxMeasurementGapDays}
  ) {
    metric
    unit
    baselineValue
    dataPoints {
      daysSinceStart
      percentageChange
      absoluteChange
      actualValue
      baselineValue
      cohortCount
      userCount
    }
    auc {
      positiveAuc
      negativeAuc
      netAuc
    }
  }
  breathingRateCohort: cohortAnalysis(
    filter: {metricName: "breathingRate", maxDays: $maxDays, baselineDays: $baselineDays, minBaselineMeasurements: $minBaselineMeasurements, maxMeasurementGapDays: $maxMeasurementGapDays}
  ) {
    metric
    unit
    baselineValue
    dataPoints {
      daysSinceStart
      percentageChange
      absoluteChange
      actualValue
      baselineValue
      cohortCount
      userCount
    }
    auc {
      positiveAuc
      negativeAuc
      netAuc
    }
  }
}
    `;

/**
 * __useGetCohortAnalysisQuery__
 *
 * To run a query within a React component, call `useGetCohortAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCohortAnalysisQuery({
 *   variables: {
 *      maxDays: // value for 'maxDays'
 *      baselineDays: // value for 'baselineDays'
 *      minBaselineMeasurements: // value for 'minBaselineMeasurements'
 *      maxMeasurementGapDays: // value for 'maxMeasurementGapDays'
 *   },
 * });
 */
export function useGetCohortAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetCohortAnalysisQuery, GetCohortAnalysisQueryVariables> & ({ variables: GetCohortAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCohortAnalysisQuery, GetCohortAnalysisQueryVariables>(GetCohortAnalysisDocument, options);
      }
export function useGetCohortAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCohortAnalysisQuery, GetCohortAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCohortAnalysisQuery, GetCohortAnalysisQueryVariables>(GetCohortAnalysisDocument, options);
        }
export function useGetCohortAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCohortAnalysisQuery, GetCohortAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCohortAnalysisQuery, GetCohortAnalysisQueryVariables>(GetCohortAnalysisDocument, options);
        }
export type GetCohortAnalysisQueryHookResult = ReturnType<typeof useGetCohortAnalysisQuery>;
export type GetCohortAnalysisLazyQueryHookResult = ReturnType<typeof useGetCohortAnalysisLazyQuery>;
export type GetCohortAnalysisSuspenseQueryHookResult = ReturnType<typeof useGetCohortAnalysisSuspenseQuery>;
export type GetCohortAnalysisQueryResult = Apollo.QueryResult<GetCohortAnalysisQuery, GetCohortAnalysisQueryVariables>;
export const GetCohortAnalysisByCompositeSegmentDocument = gql`
    query GetCohortAnalysisByCompositeSegment($metricName: String!, $maxDays: Int!, $baselineDays: Int, $minBaselineMeasurements: Int, $maxMeasurementGapDays: Int, $dimensions: [SegmentDimension!]!) {
  cohortAnalysisByCompositeSegment(
    filter: {metricName: $metricName, maxDays: $maxDays, baselineDays: $baselineDays, minBaselineMeasurements: $minBaselineMeasurements, maxMeasurementGapDays: $maxMeasurementGapDays}
    dimensions: $dimensions
  ) {
    metric
    unit
    baselineValue
    dimensions
    segments {
      segmentKey
      segmentLabel
      userCount
      dataPoints {
        daysSinceStart
        percentageChange
        absoluteChange
        actualValue
        baselineValue
        cohortCount
        userCount
      }
      auc {
        positiveAuc
        negativeAuc
        netAuc
      }
    }
  }
}
    `;

/**
 * __useGetCohortAnalysisByCompositeSegmentQuery__
 *
 * To run a query within a React component, call `useGetCohortAnalysisByCompositeSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortAnalysisByCompositeSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCohortAnalysisByCompositeSegmentQuery({
 *   variables: {
 *      metricName: // value for 'metricName'
 *      maxDays: // value for 'maxDays'
 *      baselineDays: // value for 'baselineDays'
 *      minBaselineMeasurements: // value for 'minBaselineMeasurements'
 *      maxMeasurementGapDays: // value for 'maxMeasurementGapDays'
 *      dimensions: // value for 'dimensions'
 *   },
 * });
 */
export function useGetCohortAnalysisByCompositeSegmentQuery(baseOptions: Apollo.QueryHookOptions<GetCohortAnalysisByCompositeSegmentQuery, GetCohortAnalysisByCompositeSegmentQueryVariables> & ({ variables: GetCohortAnalysisByCompositeSegmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCohortAnalysisByCompositeSegmentQuery, GetCohortAnalysisByCompositeSegmentQueryVariables>(GetCohortAnalysisByCompositeSegmentDocument, options);
      }
export function useGetCohortAnalysisByCompositeSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCohortAnalysisByCompositeSegmentQuery, GetCohortAnalysisByCompositeSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCohortAnalysisByCompositeSegmentQuery, GetCohortAnalysisByCompositeSegmentQueryVariables>(GetCohortAnalysisByCompositeSegmentDocument, options);
        }
export function useGetCohortAnalysisByCompositeSegmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCohortAnalysisByCompositeSegmentQuery, GetCohortAnalysisByCompositeSegmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCohortAnalysisByCompositeSegmentQuery, GetCohortAnalysisByCompositeSegmentQueryVariables>(GetCohortAnalysisByCompositeSegmentDocument, options);
        }
export type GetCohortAnalysisByCompositeSegmentQueryHookResult = ReturnType<typeof useGetCohortAnalysisByCompositeSegmentQuery>;
export type GetCohortAnalysisByCompositeSegmentLazyQueryHookResult = ReturnType<typeof useGetCohortAnalysisByCompositeSegmentLazyQuery>;
export type GetCohortAnalysisByCompositeSegmentSuspenseQueryHookResult = ReturnType<typeof useGetCohortAnalysisByCompositeSegmentSuspenseQuery>;
export type GetCohortAnalysisByCompositeSegmentQueryResult = Apollo.QueryResult<GetCohortAnalysisByCompositeSegmentQuery, GetCohortAnalysisByCompositeSegmentQueryVariables>;
export const GetCompanyKpisDocument = gql`
    query GetCompanyKpis {
  companyKpis {
    members {
      totalMembersLifetime
      newSignupsMonthToDate
      newSignupsLastFullMonth
      newSignupsPriorMonth
      newSignupsHistory {
        ...MonthlyKpiPointFields
      }
      payingMembersCurrent
      payingMembersLastFullMonth
      payingMembersPriorMonth
      payingMembersHistory {
        ...MonthlyKpiPointFields
      }
      churnMonthToDate
      churnLastFullMonth
      churnPriorMonth
      churnHistory {
        ...MonthlyKpiPointFields
      }
    }
    sessions {
      sessionsCompletedLifetime
      sessionsCompletedMonthToDate
      sessionsCompletedLastFullMonth
      sessionsCompletedPriorMonth
      sessionsCompletedHistory {
        ...MonthlyKpiPointFields
      }
      percentStartedVnsCurrent
      percentStartedVnsLastFullMonth
      percentStartedVnsPriorMonth
      percentStartedVnsHistory {
        ...MonthlyKpiPointFields
      }
    }
    revenue {
      currency
      revenueUnavailable
      revenueUnavailableReason
      headlineCoversAllRevenue
      byCurrency {
        currency
        grossLifetime
        grossMonthToDate
        grossLastFullMonth
        netLifetime
        netMonthToDate
        netLastFullMonth
      }
      grossLifetime
      grossMonthToDate
      grossLastFullMonth
      grossPriorMonth
      grossHistory {
        ...MonthlyKpiPointFields
      }
      netLifetime
      netMonthToDate
      netLastFullMonth
      netPriorMonth
      netHistory {
        ...MonthlyKpiPointFields
      }
    }
    engagement {
      activeLast7DaysCurrent
      activeLast7DaysLastFullMonth
      activeLast7DaysPriorMonth
      activeLast7DaysHistory {
        ...MonthlyKpiPointFields
      }
    }
    definitions {
      metric
      summary
      detail
      sourceOfTruth
      lastReviewedAt
    }
  }
}
    ${MonthlyKpiPointFieldsFragmentDoc}`;

/**
 * __useGetCompanyKpisQuery__
 *
 * To run a query within a React component, call `useGetCompanyKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyKpisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyKpisQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyKpisQuery, GetCompanyKpisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyKpisQuery, GetCompanyKpisQueryVariables>(GetCompanyKpisDocument, options);
      }
export function useGetCompanyKpisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyKpisQuery, GetCompanyKpisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyKpisQuery, GetCompanyKpisQueryVariables>(GetCompanyKpisDocument, options);
        }
export function useGetCompanyKpisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyKpisQuery, GetCompanyKpisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyKpisQuery, GetCompanyKpisQueryVariables>(GetCompanyKpisDocument, options);
        }
export type GetCompanyKpisQueryHookResult = ReturnType<typeof useGetCompanyKpisQuery>;
export type GetCompanyKpisLazyQueryHookResult = ReturnType<typeof useGetCompanyKpisLazyQuery>;
export type GetCompanyKpisSuspenseQueryHookResult = ReturnType<typeof useGetCompanyKpisSuspenseQuery>;
export type GetCompanyKpisQueryResult = Apollo.QueryResult<GetCompanyKpisQuery, GetCompanyKpisQueryVariables>;
export const GetContentAnalyticsDocument = gql`
    query GetContentAnalytics($input: ContentAnalyticsInput!) {
  contentAnalytics(input: $input) {
    totalCompletions
    uniqueUsers
    averageTimeSpentSeconds
    completionsByType {
      contentType
      completions
      uniqueUsers
      averageTimeSpentSeconds
    }
    topContent {
      contentReference {
        ... on ExternalContentId {
          reference
        }
        hydratedContent {
          ... on ActivityVideo {
            title
          }
          ... on Article {
            title
          }
          ... on JourneyVideo {
            title
          }
          ... on Lesson {
            title
          }
          ... on Story {
            title
          }
        }
      }
      contentType
      completions
      uniqueUsers
      averageTimeSpentSeconds
    }
    completionsOverTime {
      date
      count
    }
    completionsBySource {
      source
      completions
      uniqueUsers
      avgPerUser
    }
    userDiscoveryPatterns {
      totalUsers
      assignedOnly
      exploresOrganically
      assignedOnlyPercentage
      exploresOrganicallyPercentage
      breakdown {
        pattern
        userCount
        percentage
      }
    }
  }
}
    `;

/**
 * __useGetContentAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetContentAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContentAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetContentAnalyticsQuery, GetContentAnalyticsQueryVariables> & ({ variables: GetContentAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentAnalyticsQuery, GetContentAnalyticsQueryVariables>(GetContentAnalyticsDocument, options);
      }
export function useGetContentAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentAnalyticsQuery, GetContentAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentAnalyticsQuery, GetContentAnalyticsQueryVariables>(GetContentAnalyticsDocument, options);
        }
export function useGetContentAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentAnalyticsQuery, GetContentAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentAnalyticsQuery, GetContentAnalyticsQueryVariables>(GetContentAnalyticsDocument, options);
        }
export type GetContentAnalyticsQueryHookResult = ReturnType<typeof useGetContentAnalyticsQuery>;
export type GetContentAnalyticsLazyQueryHookResult = ReturnType<typeof useGetContentAnalyticsLazyQuery>;
export type GetContentAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetContentAnalyticsSuspenseQuery>;
export type GetContentAnalyticsQueryResult = Apollo.QueryResult<GetContentAnalyticsQuery, GetContentAnalyticsQueryVariables>;
export const RecordDataExportDocument = gql`
    mutation RecordDataExport($input: RecordDataExportInput!) {
  recordDataExport(input: $input) {
    success
    exportId
    error
  }
}
    `;
export type RecordDataExportMutationFn = Apollo.MutationFunction<RecordDataExportMutation, RecordDataExportMutationVariables>;

/**
 * __useRecordDataExportMutation__
 *
 * To run a mutation, you first call `useRecordDataExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordDataExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordDataExportMutation, { data, loading, error }] = useRecordDataExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordDataExportMutation(baseOptions?: Apollo.MutationHookOptions<RecordDataExportMutation, RecordDataExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordDataExportMutation, RecordDataExportMutationVariables>(RecordDataExportDocument, options);
      }
export type RecordDataExportMutationHookResult = ReturnType<typeof useRecordDataExportMutation>;
export type RecordDataExportMutationResult = Apollo.MutationResult<RecordDataExportMutation>;
export type RecordDataExportMutationOptions = Apollo.BaseMutationOptions<RecordDataExportMutation, RecordDataExportMutationVariables>;
export const GetDashboardHealthAnalyticsDocument = gql`
    query GetDashboardHealthAnalytics($dateRange: DateRangeInput!) {
  avgHrv: quickStat(
    filter: {statName: "baselineHrv", dateRange: $dateRange, aggregationStrategy: average, label: "Average HRV", description: "Team-wide average heart rate variability (higher is better)"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  avgParasympathetic: quickStat(
    filter: {statName: "baselineParasympathetic", dateRange: $dateRange, aggregationStrategy: average, label: "Average Parasympathetic Activity", description: "Team-wide nervous system balance (higher is better)"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  avgStress: quickStat(
    filter: {statName: "baselineStressIndex", dateRange: $dateRange, aggregationStrategy: average, label: "Average Stress Index", description: "Team-wide stress levels (lower is better)"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  avgBreathingRate: quickStat(
    filter: {statName: "baselineBreathingRate", dateRange: $dateRange, aggregationStrategy: average, label: "Average Breathing Rate", description: "Team-wide average breathing rate (lower is better)"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  vnsCompletionRate: quickStat(
    filter: {statName: "vnsTherapyCompletionRate", dateRange: $dateRange, aggregationStrategy: average, label: "VNS Completion Rate", description: "Percentage of VNS sessions completed across all participants"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  vnsTherapyTime: quickStat(
    filter: {statName: "vnsTherapyTime", dateRange: $dateRange, aggregationStrategy: average, label: "Avg VNS Time per User", description: "Average VNS therapy time per user per day"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  vnsImpactHrv: quickStat(
    filter: {statName: "vnsSessionImpactHrv", dateRange: $dateRange, aggregationStrategy: average, label: "VNS Success Rate (HRV)", description: "Percentage of VNS sessions that improved HRV (post > pre)"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  vnsImpactParasympathetic: quickStat(
    filter: {statName: "vnsSessionImpactParasympathetic", dateRange: $dateRange, aggregationStrategy: average, label: "VNS Success Rate (Parasympathetic)", description: "Percentage of VNS sessions that improved parasympathetic activity (post > pre)"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  vnsImpactStress: quickStat(
    filter: {statName: "vnsSessionImpactStress", dateRange: $dateRange, aggregationStrategy: average, label: "VNS Success Rate (Stress)", description: "Percentage of VNS sessions that reduced stress (post < pre)"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  avgLnrmssd: quickStat(
    filter: {statName: "baselineLnrmssd", dateRange: $dateRange, aggregationStrategy: average, label: "Average LnRMSSD", description: "Team-wide average LnRMSSD heart rate variability (higher is better)"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  vnsImpactLnrmssd: quickStat(
    filter: {statName: "vnsSessionImpactLnrmssd", dateRange: $dateRange, aggregationStrategy: average, label: "VNS Success Rate (LnRMSSD)", description: "Percentage of VNS sessions that improved LnRMSSD (post > pre)"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
  vitalsRecorded: quickStat(
    filter: {statName: "activeVitalsRecorded", dateRange: $dateRange, aggregationStrategy: sum, label: "Vitals Recorded", description: "Total vital measurements recorded across all participants"}
  ) {
    value
    unit
    trend {
      value
      previousValue
      isIncrease
      label
    }
  }
}
    `;

/**
 * __useGetDashboardHealthAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDashboardHealthAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardHealthAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardHealthAnalyticsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetDashboardHealthAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardHealthAnalyticsQuery, GetDashboardHealthAnalyticsQueryVariables> & ({ variables: GetDashboardHealthAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardHealthAnalyticsQuery, GetDashboardHealthAnalyticsQueryVariables>(GetDashboardHealthAnalyticsDocument, options);
      }
export function useGetDashboardHealthAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardHealthAnalyticsQuery, GetDashboardHealthAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardHealthAnalyticsQuery, GetDashboardHealthAnalyticsQueryVariables>(GetDashboardHealthAnalyticsDocument, options);
        }
export function useGetDashboardHealthAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardHealthAnalyticsQuery, GetDashboardHealthAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardHealthAnalyticsQuery, GetDashboardHealthAnalyticsQueryVariables>(GetDashboardHealthAnalyticsDocument, options);
        }
export type GetDashboardHealthAnalyticsQueryHookResult = ReturnType<typeof useGetDashboardHealthAnalyticsQuery>;
export type GetDashboardHealthAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDashboardHealthAnalyticsLazyQuery>;
export type GetDashboardHealthAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardHealthAnalyticsSuspenseQuery>;
export type GetDashboardHealthAnalyticsQueryResult = Apollo.QueryResult<GetDashboardHealthAnalyticsQuery, GetDashboardHealthAnalyticsQueryVariables>;
export const GetHealthAnalyticsTimeSeriesDocument = gql`
    query GetHealthAnalyticsTimeSeries($dateRange: DateRangeInput!, $granularity: TimeSeriesGranularity!, $genders: [Gender!], $ageBrackets: [AgeBracket!], $rmssdGroups: [RmssdGroup!], $timeBlocks: [TimeBlock!]) {
  hrvTimeSeries: quickStatTimeSeries(
    filter: {statName: "baselineHrv", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  hrvTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "baselineHrv", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  hrvTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "baselineHrv", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  lnrmssdTimeSeries: quickStatTimeSeries(
    filter: {statName: "baselineLnrmssd", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  lnrmssdTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "baselineLnrmssd", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  lnrmssdTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "baselineLnrmssd", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  parasympatheticTimeSeries: quickStatTimeSeries(
    filter: {statName: "baselineParasympathetic", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  parasympatheticTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "baselineParasympathetic", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  parasympatheticTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "baselineParasympathetic", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  stressTimeSeries: quickStatTimeSeries(
    filter: {statName: "baselineStressIndex", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  stressTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "baselineStressIndex", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  stressTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "baselineStressIndex", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  breathingRateTimeSeries: quickStatTimeSeries(
    filter: {statName: "baselineBreathingRate", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  breathingRateTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "baselineBreathingRate", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  breathingRateTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "baselineBreathingRate", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsCompletionRateTimeSeries: quickStatTimeSeries(
    filter: {statName: "vnsTherapyCompletionRate", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
      rawVnsSessions {
        userId
        vnsSessionId
        startTime
        endTime
        durationMinutes
        status
        timeBlock
        deviceInfo
        hasPreVitals
        hasPostVitals
      }
    }
    unit
    aggregationStrategy
  }
  vnsCompletionRateTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "vnsTherapyCompletionRate", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
      rawVnsSessions {
        userId
        vnsSessionId
        startTime
        endTime
        durationMinutes
        status
        timeBlock
        deviceInfo
        hasPreVitals
        hasPostVitals
      }
    }
    unit
    aggregationStrategy
  }
  vnsCompletionRateTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "vnsTherapyCompletionRate", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
      rawVnsSessions {
        userId
        vnsSessionId
        startTime
        endTime
        durationMinutes
        status
        timeBlock
        deviceInfo
        hasPreVitals
        hasPostVitals
      }
    }
    unit
    aggregationStrategy
  }
  vnsTherapyTimeTimeSeries: quickStatTimeSeries(
    filter: {statName: "vnsTherapyTime", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
      rawVnsSessions {
        userId
        vnsSessionId
        startTime
        endTime
        durationMinutes
        status
        timeBlock
        deviceInfo
        hasPreVitals
        hasPostVitals
      }
    }
    unit
    aggregationStrategy
  }
  vnsTherapyTimeTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "vnsTherapyTime", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
      rawVnsSessions {
        userId
        vnsSessionId
        startTime
        endTime
        durationMinutes
        status
        timeBlock
        deviceInfo
        hasPreVitals
        hasPostVitals
      }
    }
    unit
    aggregationStrategy
  }
  vnsTherapyTimeTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "vnsTherapyTime", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
      rawVnsSessions {
        userId
        vnsSessionId
        startTime
        endTime
        durationMinutes
        status
        timeBlock
        deviceInfo
        hasPreVitals
        hasPostVitals
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactHrvTimeSeries: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactHrv", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactHrvTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactHrv", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactHrvTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactHrv", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactLnrmssdTimeSeries: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactLnrmssd", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactLnrmssdTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactLnrmssd", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactLnrmssdTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactLnrmssd", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactParasympatheticTimeSeries: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactParasympathetic", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactParasympatheticTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactParasympathetic", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactParasympatheticTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactParasympathetic", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactStressTimeSeries: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactStress", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactStressTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactStress", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vnsImpactStressTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "vnsSessionImpactStress", dateRange: $dateRange, aggregationStrategy: average, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vitalsRecordedTimeSeries: quickStatTimeSeries(
    filter: {statName: "activeVitalsRecorded", dateRange: $dateRange, aggregationStrategy: sum, granularity: $granularity, cohort: all, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vitalsRecordedTimeSeriesNew: quickStatTimeSeries(
    filter: {statName: "activeVitalsRecorded", dateRange: $dateRange, aggregationStrategy: sum, granularity: $granularity, cohort: new_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
  vitalsRecordedTimeSeriesExperienced: quickStatTimeSeries(
    filter: {statName: "activeVitalsRecorded", dateRange: $dateRange, aggregationStrategy: sum, granularity: $granularity, cohort: experienced_users, includeRawData: true, genders: $genders, ageBrackets: $ageBrackets, rmssdGroups: $rmssdGroups, timeBlocks: $timeBlocks}
  ) {
    dataPoints {
      date
      value
      count
      rawData {
        userId
        type
        value
        unit
        recordedAt
        timeBlock
        source
      }
    }
    unit
    aggregationStrategy
  }
}
    `;

/**
 * __useGetHealthAnalyticsTimeSeriesQuery__
 *
 * To run a query within a React component, call `useGetHealthAnalyticsTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthAnalyticsTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthAnalyticsTimeSeriesQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      granularity: // value for 'granularity'
 *      genders: // value for 'genders'
 *      ageBrackets: // value for 'ageBrackets'
 *      rmssdGroups: // value for 'rmssdGroups'
 *      timeBlocks: // value for 'timeBlocks'
 *   },
 * });
 */
export function useGetHealthAnalyticsTimeSeriesQuery(baseOptions: Apollo.QueryHookOptions<GetHealthAnalyticsTimeSeriesQuery, GetHealthAnalyticsTimeSeriesQueryVariables> & ({ variables: GetHealthAnalyticsTimeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthAnalyticsTimeSeriesQuery, GetHealthAnalyticsTimeSeriesQueryVariables>(GetHealthAnalyticsTimeSeriesDocument, options);
      }
export function useGetHealthAnalyticsTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthAnalyticsTimeSeriesQuery, GetHealthAnalyticsTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthAnalyticsTimeSeriesQuery, GetHealthAnalyticsTimeSeriesQueryVariables>(GetHealthAnalyticsTimeSeriesDocument, options);
        }
export function useGetHealthAnalyticsTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthAnalyticsTimeSeriesQuery, GetHealthAnalyticsTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHealthAnalyticsTimeSeriesQuery, GetHealthAnalyticsTimeSeriesQueryVariables>(GetHealthAnalyticsTimeSeriesDocument, options);
        }
export type GetHealthAnalyticsTimeSeriesQueryHookResult = ReturnType<typeof useGetHealthAnalyticsTimeSeriesQuery>;
export type GetHealthAnalyticsTimeSeriesLazyQueryHookResult = ReturnType<typeof useGetHealthAnalyticsTimeSeriesLazyQuery>;
export type GetHealthAnalyticsTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useGetHealthAnalyticsTimeSeriesSuspenseQuery>;
export type GetHealthAnalyticsTimeSeriesQueryResult = Apollo.QueryResult<GetHealthAnalyticsTimeSeriesQuery, GetHealthAnalyticsTimeSeriesQueryVariables>;
export const GetParticipantSleepMetricsDocument = gql`
    query GetParticipantSleepMetrics($userId: ID!, $dateRange: DateRangeInput!, $limit: Int) {
  userSleepMetrics(userId: $userId, dateRange: $dateRange, limit: $limit) {
    userId
    sleepDate
    provider
    totalSleepMinutes
    deepSleepMinutes
    lightSleepMinutes
    remSleepMinutes
    awakeMinutes
    sleepEfficiencyPercent
    hrvRmssd
    hrvSdnn
    hrvSdnnMean
    sdnnSampleCount
    restingHeartRate
    breathingRate
    sleepInterruptions
  }
}
    `;

/**
 * __useGetParticipantSleepMetricsQuery__
 *
 * To run a query within a React component, call `useGetParticipantSleepMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantSleepMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantSleepMetricsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      dateRange: // value for 'dateRange'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetParticipantSleepMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantSleepMetricsQuery, GetParticipantSleepMetricsQueryVariables> & ({ variables: GetParticipantSleepMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantSleepMetricsQuery, GetParticipantSleepMetricsQueryVariables>(GetParticipantSleepMetricsDocument, options);
      }
export function useGetParticipantSleepMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantSleepMetricsQuery, GetParticipantSleepMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantSleepMetricsQuery, GetParticipantSleepMetricsQueryVariables>(GetParticipantSleepMetricsDocument, options);
        }
export function useGetParticipantSleepMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantSleepMetricsQuery, GetParticipantSleepMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantSleepMetricsQuery, GetParticipantSleepMetricsQueryVariables>(GetParticipantSleepMetricsDocument, options);
        }
export type GetParticipantSleepMetricsQueryHookResult = ReturnType<typeof useGetParticipantSleepMetricsQuery>;
export type GetParticipantSleepMetricsLazyQueryHookResult = ReturnType<typeof useGetParticipantSleepMetricsLazyQuery>;
export type GetParticipantSleepMetricsSuspenseQueryHookResult = ReturnType<typeof useGetParticipantSleepMetricsSuspenseQuery>;
export type GetParticipantSleepMetricsQueryResult = Apollo.QueryResult<GetParticipantSleepMetricsQuery, GetParticipantSleepMetricsQueryVariables>;
export const GetParticipantSleepTrendDocument = gql`
    query GetParticipantSleepTrend($dateRange: DateRangeInput!, $userId: ID) {
  sleepMetricsTrend(dateRange: $dateRange, userId: $userId) {
    date
    avgSleepMinutes
    avgEfficiencyPercent
    avgHrvRmssd
    avgDeepSleepPercent
    recordCount
  }
}
    `;

/**
 * __useGetParticipantSleepTrendQuery__
 *
 * To run a query within a React component, call `useGetParticipantSleepTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantSleepTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantSleepTrendQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetParticipantSleepTrendQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantSleepTrendQuery, GetParticipantSleepTrendQueryVariables> & ({ variables: GetParticipantSleepTrendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantSleepTrendQuery, GetParticipantSleepTrendQueryVariables>(GetParticipantSleepTrendDocument, options);
      }
export function useGetParticipantSleepTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantSleepTrendQuery, GetParticipantSleepTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantSleepTrendQuery, GetParticipantSleepTrendQueryVariables>(GetParticipantSleepTrendDocument, options);
        }
export function useGetParticipantSleepTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantSleepTrendQuery, GetParticipantSleepTrendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantSleepTrendQuery, GetParticipantSleepTrendQueryVariables>(GetParticipantSleepTrendDocument, options);
        }
export type GetParticipantSleepTrendQueryHookResult = ReturnType<typeof useGetParticipantSleepTrendQuery>;
export type GetParticipantSleepTrendLazyQueryHookResult = ReturnType<typeof useGetParticipantSleepTrendLazyQuery>;
export type GetParticipantSleepTrendSuspenseQueryHookResult = ReturnType<typeof useGetParticipantSleepTrendSuspenseQuery>;
export type GetParticipantSleepTrendQueryResult = Apollo.QueryResult<GetParticipantSleepTrendQuery, GetParticipantSleepTrendQueryVariables>;
export const GetRecentAppFeedbackDocument = gql`
    query GetRecentAppFeedback($dateRange: DateRangeInput!) {
  recentAppFeedback(dateRange: $dateRange) {
    feedbackId
    userId
    sentiment
    comment
    submittedAt
    pii {
      identityInformation {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetRecentAppFeedbackQuery__
 *
 * To run a query within a React component, call `useGetRecentAppFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentAppFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentAppFeedbackQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetRecentAppFeedbackQuery(baseOptions: Apollo.QueryHookOptions<GetRecentAppFeedbackQuery, GetRecentAppFeedbackQueryVariables> & ({ variables: GetRecentAppFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentAppFeedbackQuery, GetRecentAppFeedbackQueryVariables>(GetRecentAppFeedbackDocument, options);
      }
export function useGetRecentAppFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentAppFeedbackQuery, GetRecentAppFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentAppFeedbackQuery, GetRecentAppFeedbackQueryVariables>(GetRecentAppFeedbackDocument, options);
        }
export function useGetRecentAppFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentAppFeedbackQuery, GetRecentAppFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentAppFeedbackQuery, GetRecentAppFeedbackQueryVariables>(GetRecentAppFeedbackDocument, options);
        }
export type GetRecentAppFeedbackQueryHookResult = ReturnType<typeof useGetRecentAppFeedbackQuery>;
export type GetRecentAppFeedbackLazyQueryHookResult = ReturnType<typeof useGetRecentAppFeedbackLazyQuery>;
export type GetRecentAppFeedbackSuspenseQueryHookResult = ReturnType<typeof useGetRecentAppFeedbackSuspenseQuery>;
export type GetRecentAppFeedbackQueryResult = Apollo.QueryResult<GetRecentAppFeedbackQuery, GetRecentAppFeedbackQueryVariables>;
export const GetSleepAnalyticsDashboardDocument = gql`
    query GetSleepAnalyticsDashboard($dateRange: DateRangeInput!) {
  vnsSleepDashboard(dateRange: $dateRange) {
    summary {
      totalSessions
      sessionsWithSleepData
      avgSleepImprovement
      avgHrvImprovement
      avgEfficiencyImprovement
      bestTimeBlock
    }
    timeBlockAnalysis {
      timeBlock
      sessionCount
      avgSleepImprovement
      avgHrvImprovement
    }
    recentCorrelations {
      sessionId
      userId
      sessionDate
      timeBlock
      hrvDelta
      parasympatheticDelta
      sameNightSleepMinutes
      sameNightEfficiency
      sleepVsBaseline
    }
  }
}
    `;

/**
 * __useGetSleepAnalyticsDashboardQuery__
 *
 * To run a query within a React component, call `useGetSleepAnalyticsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSleepAnalyticsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSleepAnalyticsDashboardQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetSleepAnalyticsDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetSleepAnalyticsDashboardQuery, GetSleepAnalyticsDashboardQueryVariables> & ({ variables: GetSleepAnalyticsDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSleepAnalyticsDashboardQuery, GetSleepAnalyticsDashboardQueryVariables>(GetSleepAnalyticsDashboardDocument, options);
      }
export function useGetSleepAnalyticsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSleepAnalyticsDashboardQuery, GetSleepAnalyticsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSleepAnalyticsDashboardQuery, GetSleepAnalyticsDashboardQueryVariables>(GetSleepAnalyticsDashboardDocument, options);
        }
export function useGetSleepAnalyticsDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSleepAnalyticsDashboardQuery, GetSleepAnalyticsDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSleepAnalyticsDashboardQuery, GetSleepAnalyticsDashboardQueryVariables>(GetSleepAnalyticsDashboardDocument, options);
        }
export type GetSleepAnalyticsDashboardQueryHookResult = ReturnType<typeof useGetSleepAnalyticsDashboardQuery>;
export type GetSleepAnalyticsDashboardLazyQueryHookResult = ReturnType<typeof useGetSleepAnalyticsDashboardLazyQuery>;
export type GetSleepAnalyticsDashboardSuspenseQueryHookResult = ReturnType<typeof useGetSleepAnalyticsDashboardSuspenseQuery>;
export type GetSleepAnalyticsDashboardQueryResult = Apollo.QueryResult<GetSleepAnalyticsDashboardQuery, GetSleepAnalyticsDashboardQueryVariables>;
export const GetUserSleepCorrelationsDocument = gql`
    query GetUserSleepCorrelations($participantId: ID!, $dateRange: DateRangeInput!, $limit: Int) {
  vnsSleepCorrelations(
    participantId: $participantId
    dateRange: $dateRange
    limit: $limit
  ) {
    sessionId
    userId
    sessionDate
    timeBlock
    vnsMode
    hrvDelta
    parasympatheticDelta
    stressDelta
    sameNightSleepMinutes
    sameNightEfficiency
    sameNightDeepPercent
    nextDaySleepMinutes
    nextDayEfficiency
    sleepVsBaseline
    hrvVsBaseline
  }
}
    `;

/**
 * __useGetUserSleepCorrelationsQuery__
 *
 * To run a query within a React component, call `useGetUserSleepCorrelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSleepCorrelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSleepCorrelationsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      dateRange: // value for 'dateRange'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserSleepCorrelationsQuery(baseOptions: Apollo.QueryHookOptions<GetUserSleepCorrelationsQuery, GetUserSleepCorrelationsQueryVariables> & ({ variables: GetUserSleepCorrelationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSleepCorrelationsQuery, GetUserSleepCorrelationsQueryVariables>(GetUserSleepCorrelationsDocument, options);
      }
export function useGetUserSleepCorrelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSleepCorrelationsQuery, GetUserSleepCorrelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSleepCorrelationsQuery, GetUserSleepCorrelationsQueryVariables>(GetUserSleepCorrelationsDocument, options);
        }
export function useGetUserSleepCorrelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSleepCorrelationsQuery, GetUserSleepCorrelationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSleepCorrelationsQuery, GetUserSleepCorrelationsQueryVariables>(GetUserSleepCorrelationsDocument, options);
        }
export type GetUserSleepCorrelationsQueryHookResult = ReturnType<typeof useGetUserSleepCorrelationsQuery>;
export type GetUserSleepCorrelationsLazyQueryHookResult = ReturnType<typeof useGetUserSleepCorrelationsLazyQuery>;
export type GetUserSleepCorrelationsSuspenseQueryHookResult = ReturnType<typeof useGetUserSleepCorrelationsSuspenseQuery>;
export type GetUserSleepCorrelationsQueryResult = Apollo.QueryResult<GetUserSleepCorrelationsQuery, GetUserSleepCorrelationsQueryVariables>;
export const GetSleepCorrelationStatsDocument = gql`
    query GetSleepCorrelationStats($participantId: ID, $dateRange: DateRangeInput!) {
  vnsSleepCorrelationStats(participantId: $participantId, dateRange: $dateRange) {
    correlationCoefficient
    strength
    sampleSize
    pValue
  }
}
    `;

/**
 * __useGetSleepCorrelationStatsQuery__
 *
 * To run a query within a React component, call `useGetSleepCorrelationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSleepCorrelationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSleepCorrelationStatsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetSleepCorrelationStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSleepCorrelationStatsQuery, GetSleepCorrelationStatsQueryVariables> & ({ variables: GetSleepCorrelationStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSleepCorrelationStatsQuery, GetSleepCorrelationStatsQueryVariables>(GetSleepCorrelationStatsDocument, options);
      }
export function useGetSleepCorrelationStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSleepCorrelationStatsQuery, GetSleepCorrelationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSleepCorrelationStatsQuery, GetSleepCorrelationStatsQueryVariables>(GetSleepCorrelationStatsDocument, options);
        }
export function useGetSleepCorrelationStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSleepCorrelationStatsQuery, GetSleepCorrelationStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSleepCorrelationStatsQuery, GetSleepCorrelationStatsQueryVariables>(GetSleepCorrelationStatsDocument, options);
        }
export type GetSleepCorrelationStatsQueryHookResult = ReturnType<typeof useGetSleepCorrelationStatsQuery>;
export type GetSleepCorrelationStatsLazyQueryHookResult = ReturnType<typeof useGetSleepCorrelationStatsLazyQuery>;
export type GetSleepCorrelationStatsSuspenseQueryHookResult = ReturnType<typeof useGetSleepCorrelationStatsSuspenseQuery>;
export type GetSleepCorrelationStatsQueryResult = Apollo.QueryResult<GetSleepCorrelationStatsQuery, GetSleepCorrelationStatsQueryVariables>;
export const GetSleepCohortAnalysisDocument = gql`
    query GetSleepCohortAnalysis($filter: SleepCohortFilter!) {
  sleepCohortAnalysis(filter: $filter) {
    metric
    unit
    baselineValue
    dataPoints {
      daysSinceStart
      percentageChange
      absoluteChange
      actualValue
      baselineValue
      cohortCount
      userCount
    }
    auc {
      positiveAuc
      negativeAuc
      netAuc
    }
  }
}
    `;

/**
 * __useGetSleepCohortAnalysisQuery__
 *
 * To run a query within a React component, call `useGetSleepCohortAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSleepCohortAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSleepCohortAnalysisQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSleepCohortAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetSleepCohortAnalysisQuery, GetSleepCohortAnalysisQueryVariables> & ({ variables: GetSleepCohortAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSleepCohortAnalysisQuery, GetSleepCohortAnalysisQueryVariables>(GetSleepCohortAnalysisDocument, options);
      }
export function useGetSleepCohortAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSleepCohortAnalysisQuery, GetSleepCohortAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSleepCohortAnalysisQuery, GetSleepCohortAnalysisQueryVariables>(GetSleepCohortAnalysisDocument, options);
        }
export function useGetSleepCohortAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSleepCohortAnalysisQuery, GetSleepCohortAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSleepCohortAnalysisQuery, GetSleepCohortAnalysisQueryVariables>(GetSleepCohortAnalysisDocument, options);
        }
export type GetSleepCohortAnalysisQueryHookResult = ReturnType<typeof useGetSleepCohortAnalysisQuery>;
export type GetSleepCohortAnalysisLazyQueryHookResult = ReturnType<typeof useGetSleepCohortAnalysisLazyQuery>;
export type GetSleepCohortAnalysisSuspenseQueryHookResult = ReturnType<typeof useGetSleepCohortAnalysisSuspenseQuery>;
export type GetSleepCohortAnalysisQueryResult = Apollo.QueryResult<GetSleepCohortAnalysisQuery, GetSleepCohortAnalysisQueryVariables>;
export const GetSleepProvidersDocument = gql`
    query GetSleepProviders {
  sleepProviders
}
    `;

/**
 * __useGetSleepProvidersQuery__
 *
 * To run a query within a React component, call `useGetSleepProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSleepProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSleepProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSleepProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetSleepProvidersQuery, GetSleepProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSleepProvidersQuery, GetSleepProvidersQueryVariables>(GetSleepProvidersDocument, options);
      }
export function useGetSleepProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSleepProvidersQuery, GetSleepProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSleepProvidersQuery, GetSleepProvidersQueryVariables>(GetSleepProvidersDocument, options);
        }
export function useGetSleepProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSleepProvidersQuery, GetSleepProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSleepProvidersQuery, GetSleepProvidersQueryVariables>(GetSleepProvidersDocument, options);
        }
export type GetSleepProvidersQueryHookResult = ReturnType<typeof useGetSleepProvidersQuery>;
export type GetSleepProvidersLazyQueryHookResult = ReturnType<typeof useGetSleepProvidersLazyQuery>;
export type GetSleepProvidersSuspenseQueryHookResult = ReturnType<typeof useGetSleepProvidersSuspenseQuery>;
export type GetSleepProvidersQueryResult = Apollo.QueryResult<GetSleepProvidersQuery, GetSleepProvidersQueryVariables>;
export const GetSleepDoseResponseDocument = gql`
    query GetSleepDoseResponse($dateRange: DateRangeInput!, $provider: String) {
  sleepDoseResponse(dateRange: $dateRange, provider: $provider) {
    lowFrequency {
      label
      userCount
      avgSleepImprovement
      avgEfficiencyImprovement
      avgHrvImprovement
    }
    mediumFrequency {
      label
      userCount
      avgSleepImprovement
      avgEfficiencyImprovement
      avgHrvImprovement
    }
    highFrequency {
      label
      userCount
      avgSleepImprovement
      avgEfficiencyImprovement
      avgHrvImprovement
    }
  }
}
    `;

/**
 * __useGetSleepDoseResponseQuery__
 *
 * To run a query within a React component, call `useGetSleepDoseResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSleepDoseResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSleepDoseResponseQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useGetSleepDoseResponseQuery(baseOptions: Apollo.QueryHookOptions<GetSleepDoseResponseQuery, GetSleepDoseResponseQueryVariables> & ({ variables: GetSleepDoseResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSleepDoseResponseQuery, GetSleepDoseResponseQueryVariables>(GetSleepDoseResponseDocument, options);
      }
export function useGetSleepDoseResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSleepDoseResponseQuery, GetSleepDoseResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSleepDoseResponseQuery, GetSleepDoseResponseQueryVariables>(GetSleepDoseResponseDocument, options);
        }
export function useGetSleepDoseResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSleepDoseResponseQuery, GetSleepDoseResponseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSleepDoseResponseQuery, GetSleepDoseResponseQueryVariables>(GetSleepDoseResponseDocument, options);
        }
export type GetSleepDoseResponseQueryHookResult = ReturnType<typeof useGetSleepDoseResponseQuery>;
export type GetSleepDoseResponseLazyQueryHookResult = ReturnType<typeof useGetSleepDoseResponseLazyQuery>;
export type GetSleepDoseResponseSuspenseQueryHookResult = ReturnType<typeof useGetSleepDoseResponseSuspenseQuery>;
export type GetSleepDoseResponseQueryResult = Apollo.QueryResult<GetSleepDoseResponseQuery, GetSleepDoseResponseQueryVariables>;
export const GetSleepNightOfAnalysisDocument = gql`
    query GetSleepNightOfAnalysis($dateRange: DateRangeInput!, $provider: String) {
  sleepNightOfAnalysis(dateRange: $dateRange, provider: $provider) {
    vnsNights {
      avgSleepMinutes
      avgEfficiency
      avgHrvRmssd
      avgDeepSleepPercent
      nightCount
    }
    nonVnsNights {
      avgSleepMinutes
      avgEfficiency
      avgHrvRmssd
      avgDeepSleepPercent
      nightCount
    }
    userCount
  }
}
    `;

/**
 * __useGetSleepNightOfAnalysisQuery__
 *
 * To run a query within a React component, call `useGetSleepNightOfAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSleepNightOfAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSleepNightOfAnalysisQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useGetSleepNightOfAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetSleepNightOfAnalysisQuery, GetSleepNightOfAnalysisQueryVariables> & ({ variables: GetSleepNightOfAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSleepNightOfAnalysisQuery, GetSleepNightOfAnalysisQueryVariables>(GetSleepNightOfAnalysisDocument, options);
      }
export function useGetSleepNightOfAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSleepNightOfAnalysisQuery, GetSleepNightOfAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSleepNightOfAnalysisQuery, GetSleepNightOfAnalysisQueryVariables>(GetSleepNightOfAnalysisDocument, options);
        }
export function useGetSleepNightOfAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSleepNightOfAnalysisQuery, GetSleepNightOfAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSleepNightOfAnalysisQuery, GetSleepNightOfAnalysisQueryVariables>(GetSleepNightOfAnalysisDocument, options);
        }
export type GetSleepNightOfAnalysisQueryHookResult = ReturnType<typeof useGetSleepNightOfAnalysisQuery>;
export type GetSleepNightOfAnalysisLazyQueryHookResult = ReturnType<typeof useGetSleepNightOfAnalysisLazyQuery>;
export type GetSleepNightOfAnalysisSuspenseQueryHookResult = ReturnType<typeof useGetSleepNightOfAnalysisSuspenseQuery>;
export type GetSleepNightOfAnalysisQueryResult = Apollo.QueryResult<GetSleepNightOfAnalysisQuery, GetSleepNightOfAnalysisQueryVariables>;
export const GetSleepMetricsSummaryDocument = gql`
    query GetSleepMetricsSummary($dateRange: DateRangeInput!) {
  sleepMetricsSummary(dateRange: $dateRange) {
    totalUsersWithSleepData
    avgSleepMinutes
    avgEfficiencyPercent
    avgHrvRmssd
    avgDeepSleepPercent
    avgRemSleepPercent
    totalSleepRecords
  }
}
    `;

/**
 * __useGetSleepMetricsSummaryQuery__
 *
 * To run a query within a React component, call `useGetSleepMetricsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSleepMetricsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSleepMetricsSummaryQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetSleepMetricsSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetSleepMetricsSummaryQuery, GetSleepMetricsSummaryQueryVariables> & ({ variables: GetSleepMetricsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSleepMetricsSummaryQuery, GetSleepMetricsSummaryQueryVariables>(GetSleepMetricsSummaryDocument, options);
      }
export function useGetSleepMetricsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSleepMetricsSummaryQuery, GetSleepMetricsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSleepMetricsSummaryQuery, GetSleepMetricsSummaryQueryVariables>(GetSleepMetricsSummaryDocument, options);
        }
export function useGetSleepMetricsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSleepMetricsSummaryQuery, GetSleepMetricsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSleepMetricsSummaryQuery, GetSleepMetricsSummaryQueryVariables>(GetSleepMetricsSummaryDocument, options);
        }
export type GetSleepMetricsSummaryQueryHookResult = ReturnType<typeof useGetSleepMetricsSummaryQuery>;
export type GetSleepMetricsSummaryLazyQueryHookResult = ReturnType<typeof useGetSleepMetricsSummaryLazyQuery>;
export type GetSleepMetricsSummarySuspenseQueryHookResult = ReturnType<typeof useGetSleepMetricsSummarySuspenseQuery>;
export type GetSleepMetricsSummaryQueryResult = Apollo.QueryResult<GetSleepMetricsSummaryQuery, GetSleepMetricsSummaryQueryVariables>;
export const GetSleepMetricsTrendDocument = gql`
    query GetSleepMetricsTrend($dateRange: DateRangeInput!, $userId: ID) {
  sleepMetricsTrend(dateRange: $dateRange, userId: $userId) {
    date
    avgSleepMinutes
    avgEfficiencyPercent
    avgHrvRmssd
    avgDeepSleepPercent
    recordCount
  }
}
    `;

/**
 * __useGetSleepMetricsTrendQuery__
 *
 * To run a query within a React component, call `useGetSleepMetricsTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSleepMetricsTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSleepMetricsTrendQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSleepMetricsTrendQuery(baseOptions: Apollo.QueryHookOptions<GetSleepMetricsTrendQuery, GetSleepMetricsTrendQueryVariables> & ({ variables: GetSleepMetricsTrendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSleepMetricsTrendQuery, GetSleepMetricsTrendQueryVariables>(GetSleepMetricsTrendDocument, options);
      }
export function useGetSleepMetricsTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSleepMetricsTrendQuery, GetSleepMetricsTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSleepMetricsTrendQuery, GetSleepMetricsTrendQueryVariables>(GetSleepMetricsTrendDocument, options);
        }
export function useGetSleepMetricsTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSleepMetricsTrendQuery, GetSleepMetricsTrendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSleepMetricsTrendQuery, GetSleepMetricsTrendQueryVariables>(GetSleepMetricsTrendDocument, options);
        }
export type GetSleepMetricsTrendQueryHookResult = ReturnType<typeof useGetSleepMetricsTrendQuery>;
export type GetSleepMetricsTrendLazyQueryHookResult = ReturnType<typeof useGetSleepMetricsTrendLazyQuery>;
export type GetSleepMetricsTrendSuspenseQueryHookResult = ReturnType<typeof useGetSleepMetricsTrendSuspenseQuery>;
export type GetSleepMetricsTrendQueryResult = Apollo.QueryResult<GetSleepMetricsTrendQuery, GetSleepMetricsTrendQueryVariables>;
export const GetSleepProviderStatsDocument = gql`
    query GetSleepProviderStats($dateRange: DateRangeInput!) {
  sleepProviderStats(dateRange: $dateRange) {
    provider
    userCount
    recordCount
  }
}
    `;

/**
 * __useGetSleepProviderStatsQuery__
 *
 * To run a query within a React component, call `useGetSleepProviderStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSleepProviderStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSleepProviderStatsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetSleepProviderStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSleepProviderStatsQuery, GetSleepProviderStatsQueryVariables> & ({ variables: GetSleepProviderStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSleepProviderStatsQuery, GetSleepProviderStatsQueryVariables>(GetSleepProviderStatsDocument, options);
      }
export function useGetSleepProviderStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSleepProviderStatsQuery, GetSleepProviderStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSleepProviderStatsQuery, GetSleepProviderStatsQueryVariables>(GetSleepProviderStatsDocument, options);
        }
export function useGetSleepProviderStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSleepProviderStatsQuery, GetSleepProviderStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSleepProviderStatsQuery, GetSleepProviderStatsQueryVariables>(GetSleepProviderStatsDocument, options);
        }
export type GetSleepProviderStatsQueryHookResult = ReturnType<typeof useGetSleepProviderStatsQuery>;
export type GetSleepProviderStatsLazyQueryHookResult = ReturnType<typeof useGetSleepProviderStatsLazyQuery>;
export type GetSleepProviderStatsSuspenseQueryHookResult = ReturnType<typeof useGetSleepProviderStatsSuspenseQuery>;
export type GetSleepProviderStatsQueryResult = Apollo.QueryResult<GetSleepProviderStatsQuery, GetSleepProviderStatsQueryVariables>;
export const GetVnsSessionAnalyticsDocument = gql`
    query GetVnsSessionAnalytics($input: VnsSessionAnalyticsInput!) {
  vnsSessionAnalytics(input: $input) {
    totalSessions
    avgDurationMinutes
    avgHrvDelta
    completionRate
    sessionsWithVitals
    avgSessionsPerActiveDay
    modeEffectivenessByMode {
      modeId
      modeDisplayName
      deviceKind
      legacyMode
      avgHrvDelta
      avgParasympatheticDelta
      avgStressDelta
      sampleSize
    }
    intensityBands {
      band
      minIntensity
      maxIntensity
      avgHrvDelta
      sampleSize
    }
  }
}
    `;

/**
 * __useGetVnsSessionAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetVnsSessionAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVnsSessionAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVnsSessionAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVnsSessionAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetVnsSessionAnalyticsQuery, GetVnsSessionAnalyticsQueryVariables> & ({ variables: GetVnsSessionAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVnsSessionAnalyticsQuery, GetVnsSessionAnalyticsQueryVariables>(GetVnsSessionAnalyticsDocument, options);
      }
export function useGetVnsSessionAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVnsSessionAnalyticsQuery, GetVnsSessionAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVnsSessionAnalyticsQuery, GetVnsSessionAnalyticsQueryVariables>(GetVnsSessionAnalyticsDocument, options);
        }
export function useGetVnsSessionAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVnsSessionAnalyticsQuery, GetVnsSessionAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVnsSessionAnalyticsQuery, GetVnsSessionAnalyticsQueryVariables>(GetVnsSessionAnalyticsDocument, options);
        }
export type GetVnsSessionAnalyticsQueryHookResult = ReturnType<typeof useGetVnsSessionAnalyticsQuery>;
export type GetVnsSessionAnalyticsLazyQueryHookResult = ReturnType<typeof useGetVnsSessionAnalyticsLazyQuery>;
export type GetVnsSessionAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetVnsSessionAnalyticsSuspenseQuery>;
export type GetVnsSessionAnalyticsQueryResult = Apollo.QueryResult<GetVnsSessionAnalyticsQuery, GetVnsSessionAnalyticsQueryVariables>;
export const GetVnsSessionExportDocument = gql`
    query GetVnsSessionExport($input: VnsSessionExportInput!) {
  vnsSessionExport(input: $input) {
    totalCount
    hasMore
    sessions {
      sessionId
      userId
      userName
      startTime
      endTime
      durationMinutes
      status
      mode
      intensity
      avgIntensity
      phases {
        startTime
        endTime
        durationMinutes
        mode
        intensity
        source
      }
      isManual
      timeBlock
      deviceInfo
      preHrvSdnn
      preParasympathetic
      preStressIndex
      postHrvSdnn
      postParasympathetic
      postStressIndex
      hrvDelta
      parasympatheticDelta
      stressDelta
      modeId
      modeDisplayName
      modeSetVersion
      startedBy
      slotByte
      deviceKind
    }
  }
}
    `;

/**
 * __useGetVnsSessionExportQuery__
 *
 * To run a query within a React component, call `useGetVnsSessionExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVnsSessionExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVnsSessionExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVnsSessionExportQuery(baseOptions: Apollo.QueryHookOptions<GetVnsSessionExportQuery, GetVnsSessionExportQueryVariables> & ({ variables: GetVnsSessionExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVnsSessionExportQuery, GetVnsSessionExportQueryVariables>(GetVnsSessionExportDocument, options);
      }
export function useGetVnsSessionExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVnsSessionExportQuery, GetVnsSessionExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVnsSessionExportQuery, GetVnsSessionExportQueryVariables>(GetVnsSessionExportDocument, options);
        }
export function useGetVnsSessionExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVnsSessionExportQuery, GetVnsSessionExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVnsSessionExportQuery, GetVnsSessionExportQueryVariables>(GetVnsSessionExportDocument, options);
        }
export type GetVnsSessionExportQueryHookResult = ReturnType<typeof useGetVnsSessionExportQuery>;
export type GetVnsSessionExportLazyQueryHookResult = ReturnType<typeof useGetVnsSessionExportLazyQuery>;
export type GetVnsSessionExportSuspenseQueryHookResult = ReturnType<typeof useGetVnsSessionExportSuspenseQuery>;
export type GetVnsSessionExportQueryResult = Apollo.QueryResult<GetVnsSessionExportQuery, GetVnsSessionExportQueryVariables>;
export const GetWidgetAnalyticsDocument = gql`
    query GetWidgetAnalytics($input: WidgetAnalyticsInput!) {
  widgetAnalytics(input: $input) {
    totalCompletions
    uniqueUsers
    averageTimeSpentSeconds
    completionsByType {
      widgetKind
      displayName
      completions
      uniqueUsers
      averageTimeSpentSeconds
    }
    topUsers {
      userId
      displayName
      totalCompletions
      completionsByType {
        widgetKind
        count
      }
    }
  }
}
    `;

/**
 * __useGetWidgetAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetWidgetAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWidgetAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetAnalyticsQuery, GetWidgetAnalyticsQueryVariables> & ({ variables: GetWidgetAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetAnalyticsQuery, GetWidgetAnalyticsQueryVariables>(GetWidgetAnalyticsDocument, options);
      }
export function useGetWidgetAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetAnalyticsQuery, GetWidgetAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetAnalyticsQuery, GetWidgetAnalyticsQueryVariables>(GetWidgetAnalyticsDocument, options);
        }
export function useGetWidgetAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWidgetAnalyticsQuery, GetWidgetAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWidgetAnalyticsQuery, GetWidgetAnalyticsQueryVariables>(GetWidgetAnalyticsDocument, options);
        }
export type GetWidgetAnalyticsQueryHookResult = ReturnType<typeof useGetWidgetAnalyticsQuery>;
export type GetWidgetAnalyticsLazyQueryHookResult = ReturnType<typeof useGetWidgetAnalyticsLazyQuery>;
export type GetWidgetAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetWidgetAnalyticsSuspenseQuery>;
export type GetWidgetAnalyticsQueryResult = Apollo.QueryResult<GetWidgetAnalyticsQuery, GetWidgetAnalyticsQueryVariables>;
export const ExampleDocument = gql`
    query Example {
  me {
    ... on Nurse {
      nurseId
      timezone
    }
    ... on Participant {
      participantId
      timezone
    }
  }
}
    `;

/**
 * __useExampleQuery__
 *
 * To run a query within a React component, call `useExampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useExampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExampleQuery({
 *   variables: {
 *   },
 * });
 */
export function useExampleQuery(baseOptions?: Apollo.QueryHookOptions<ExampleQuery, ExampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExampleQuery, ExampleQueryVariables>(ExampleDocument, options);
      }
export function useExampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExampleQuery, ExampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExampleQuery, ExampleQueryVariables>(ExampleDocument, options);
        }
export function useExampleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExampleQuery, ExampleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExampleQuery, ExampleQueryVariables>(ExampleDocument, options);
        }
export type ExampleQueryHookResult = ReturnType<typeof useExampleQuery>;
export type ExampleLazyQueryHookResult = ReturnType<typeof useExampleLazyQuery>;
export type ExampleSuspenseQueryHookResult = ReturnType<typeof useExampleSuspenseQuery>;
export type ExampleQueryResult = Apollo.QueryResult<ExampleQuery, ExampleQueryVariables>;
export const HabituationCohortDocument = gql`
    query HabituationCohort($window: HabituationWindow!) {
  habituationCohort(window: $window) {
    thresholdsVersion
    stateCounts {
      state
      count
    }
    quadrant {
      useRatio
      responseDelta
      state
    }
    trajectories {
      points {
        weekSincePlateau
        ariMinusP
      }
    }
    medianPlateauToDriftWeeks
    medianDriftToBaselineWeeks
    notEvaluableInsufficientBaseline
    notEvaluableNoPlateau
  }
}
    `;

/**
 * __useHabituationCohortQuery__
 *
 * To run a query within a React component, call `useHabituationCohortQuery` and pass it any options that fit your needs.
 * When your component renders, `useHabituationCohortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHabituationCohortQuery({
 *   variables: {
 *      window: // value for 'window'
 *   },
 * });
 */
export function useHabituationCohortQuery(baseOptions: Apollo.QueryHookOptions<HabituationCohortQuery, HabituationCohortQueryVariables> & ({ variables: HabituationCohortQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HabituationCohortQuery, HabituationCohortQueryVariables>(HabituationCohortDocument, options);
      }
export function useHabituationCohortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HabituationCohortQuery, HabituationCohortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HabituationCohortQuery, HabituationCohortQueryVariables>(HabituationCohortDocument, options);
        }
export function useHabituationCohortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HabituationCohortQuery, HabituationCohortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HabituationCohortQuery, HabituationCohortQueryVariables>(HabituationCohortDocument, options);
        }
export type HabituationCohortQueryHookResult = ReturnType<typeof useHabituationCohortQuery>;
export type HabituationCohortLazyQueryHookResult = ReturnType<typeof useHabituationCohortLazyQuery>;
export type HabituationCohortSuspenseQueryHookResult = ReturnType<typeof useHabituationCohortSuspenseQuery>;
export type HabituationCohortQueryResult = Apollo.QueryResult<HabituationCohortQuery, HabituationCohortQueryVariables>;
export const HabituationMembersDocument = gql`
    query HabituationMembers($state: HabituationState) {
  habituationMembers(state: $state) {
    memberId
    state
    since
    plateauLevel
    currentMean14
    depth
    useRatio
    thresholdsVersion
  }
}
    `;

/**
 * __useHabituationMembersQuery__
 *
 * To run a query within a React component, call `useHabituationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHabituationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHabituationMembersQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useHabituationMembersQuery(baseOptions?: Apollo.QueryHookOptions<HabituationMembersQuery, HabituationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HabituationMembersQuery, HabituationMembersQueryVariables>(HabituationMembersDocument, options);
      }
export function useHabituationMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HabituationMembersQuery, HabituationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HabituationMembersQuery, HabituationMembersQueryVariables>(HabituationMembersDocument, options);
        }
export function useHabituationMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HabituationMembersQuery, HabituationMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HabituationMembersQuery, HabituationMembersQueryVariables>(HabituationMembersDocument, options);
        }
export type HabituationMembersQueryHookResult = ReturnType<typeof useHabituationMembersQuery>;
export type HabituationMembersLazyQueryHookResult = ReturnType<typeof useHabituationMembersLazyQuery>;
export type HabituationMembersSuspenseQueryHookResult = ReturnType<typeof useHabituationMembersSuspenseQuery>;
export type HabituationMembersQueryResult = Apollo.QueryResult<HabituationMembersQuery, HabituationMembersQueryVariables>;
export const HabituationMemberDocument = gql`
    query HabituationMember($memberId: ID!) {
  habituationMember(memberId: $memberId) {
    memberId
    state
    thresholdsVersion
    baseline {
      readingCount
      sufficient
      metrics {
        metric
        median
        mad
        presentCount
      }
    }
    plateau {
      level
      weekIndex
    }
    episodes {
      kind
      startWeek
      endWeek
      depth
      durationWeeks
    }
    weeks {
      weekIndex
      weekStartDate
      ari
      mean14
      sessions
      readings
      f8Pass
      meanIntensity
      state
    }
    tally
    overnight {
      weekStart
      medianRmssd
      provider
    }
  }
}
    `;

/**
 * __useHabituationMemberQuery__
 *
 * To run a query within a React component, call `useHabituationMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useHabituationMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHabituationMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useHabituationMemberQuery(baseOptions: Apollo.QueryHookOptions<HabituationMemberQuery, HabituationMemberQueryVariables> & ({ variables: HabituationMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HabituationMemberQuery, HabituationMemberQueryVariables>(HabituationMemberDocument, options);
      }
export function useHabituationMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HabituationMemberQuery, HabituationMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HabituationMemberQuery, HabituationMemberQueryVariables>(HabituationMemberDocument, options);
        }
export function useHabituationMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HabituationMemberQuery, HabituationMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HabituationMemberQuery, HabituationMemberQueryVariables>(HabituationMemberDocument, options);
        }
export type HabituationMemberQueryHookResult = ReturnType<typeof useHabituationMemberQuery>;
export type HabituationMemberLazyQueryHookResult = ReturnType<typeof useHabituationMemberLazyQuery>;
export type HabituationMemberSuspenseQueryHookResult = ReturnType<typeof useHabituationMemberSuspenseQuery>;
export type HabituationMemberQueryResult = Apollo.QueryResult<HabituationMemberQuery, HabituationMemberQueryVariables>;
export const UserLearningProgressDocument = gql`
    query UserLearningProgress($userId: ID!) {
  userLearningJourneys(userId: $userId) {
    learningJourneyId
    name
    description
    progress
    completedPaths
    totalPaths
    steps {
      order
      unlockStrategy
      unlockStatus(userId: $userId) {
        unlocked
        reason
      }
      learningPath {
        learningPathId
        name
        description
        contentItems {
          ... on ExternalContentId {
            cms
            contentType
            reference
          }
          ... on MobileWidgetId {
            kind
          }
          ... on CustomActivityId {
            customActivityId
          }
        }
        completedContentItems(userId: $userId) {
          ... on ExternalContentId {
            cms
            contentType
            reference
          }
          ... on MobileWidgetId {
            kind
          }
          ... on CustomActivityId {
            customActivityId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserLearningProgressQuery__
 *
 * To run a query within a React component, call `useUserLearningProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLearningProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLearningProgressQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserLearningProgressQuery(baseOptions: Apollo.QueryHookOptions<UserLearningProgressQuery, UserLearningProgressQueryVariables> & ({ variables: UserLearningProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserLearningProgressQuery, UserLearningProgressQueryVariables>(UserLearningProgressDocument, options);
      }
export function useUserLearningProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserLearningProgressQuery, UserLearningProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserLearningProgressQuery, UserLearningProgressQueryVariables>(UserLearningProgressDocument, options);
        }
export function useUserLearningProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserLearningProgressQuery, UserLearningProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserLearningProgressQuery, UserLearningProgressQueryVariables>(UserLearningProgressDocument, options);
        }
export type UserLearningProgressQueryHookResult = ReturnType<typeof useUserLearningProgressQuery>;
export type UserLearningProgressLazyQueryHookResult = ReturnType<typeof useUserLearningProgressLazyQuery>;
export type UserLearningProgressSuspenseQueryHookResult = ReturnType<typeof useUserLearningProgressSuspenseQuery>;
export type UserLearningProgressQueryResult = Apollo.QueryResult<UserLearningProgressQuery, UserLearningProgressQueryVariables>;
export const RegisterLoginDocument = gql`
    mutation RegisterLogin($timezone: String!) {
  registerLogin(timezone: $timezone) {
    id
  }
}
    `;
export type RegisterLoginMutationFn = Apollo.MutationFunction<RegisterLoginMutation, RegisterLoginMutationVariables>;

/**
 * __useRegisterLoginMutation__
 *
 * To run a mutation, you first call `useRegisterLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerLoginMutation, { data, loading, error }] = useRegisterLoginMutation({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useRegisterLoginMutation(baseOptions?: Apollo.MutationHookOptions<RegisterLoginMutation, RegisterLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterLoginMutation, RegisterLoginMutationVariables>(RegisterLoginDocument, options);
      }
export type RegisterLoginMutationHookResult = ReturnType<typeof useRegisterLoginMutation>;
export type RegisterLoginMutationResult = Apollo.MutationResult<RegisterLoginMutation>;
export type RegisterLoginMutationOptions = Apollo.BaseMutationOptions<RegisterLoginMutation, RegisterLoginMutationVariables>;
export const RegisterFcmTokenDocument = gql`
    mutation RegisterFcmToken($input: AddNotificationTokenCommand!) {
  addNotificationToken(input: $input) {
    id
  }
}
    `;
export type RegisterFcmTokenMutationFn = Apollo.MutationFunction<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>;

/**
 * __useRegisterFcmTokenMutation__
 *
 * To run a mutation, you first call `useRegisterFcmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterFcmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerFcmTokenMutation, { data, loading, error }] = useRegisterFcmTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterFcmTokenMutation(baseOptions?: Apollo.MutationHookOptions<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>(RegisterFcmTokenDocument, options);
      }
export type RegisterFcmTokenMutationHookResult = ReturnType<typeof useRegisterFcmTokenMutation>;
export type RegisterFcmTokenMutationResult = Apollo.MutationResult<RegisterFcmTokenMutation>;
export type RegisterFcmTokenMutationOptions = Apollo.BaseMutationOptions<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>;
export const GetNewsletterSignalsDocument = gql`
    query GetNewsletterSignals {
  newsletterSignals {
    email
    name
    country
    consent
    source
    createdAt
  }
}
    `;

/**
 * __useGetNewsletterSignalsQuery__
 *
 * To run a query within a React component, call `useGetNewsletterSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterSignalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsletterSignalsQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsletterSignalsQuery, GetNewsletterSignalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsletterSignalsQuery, GetNewsletterSignalsQueryVariables>(GetNewsletterSignalsDocument, options);
      }
export function useGetNewsletterSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsletterSignalsQuery, GetNewsletterSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsletterSignalsQuery, GetNewsletterSignalsQueryVariables>(GetNewsletterSignalsDocument, options);
        }
export function useGetNewsletterSignalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewsletterSignalsQuery, GetNewsletterSignalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewsletterSignalsQuery, GetNewsletterSignalsQueryVariables>(GetNewsletterSignalsDocument, options);
        }
export type GetNewsletterSignalsQueryHookResult = ReturnType<typeof useGetNewsletterSignalsQuery>;
export type GetNewsletterSignalsLazyQueryHookResult = ReturnType<typeof useGetNewsletterSignalsLazyQuery>;
export type GetNewsletterSignalsSuspenseQueryHookResult = ReturnType<typeof useGetNewsletterSignalsSuspenseQuery>;
export type GetNewsletterSignalsQueryResult = Apollo.QueryResult<GetNewsletterSignalsQuery, GetNewsletterSignalsQueryVariables>;
export const SendPushNotificationDocument = gql`
    mutation SendPushNotification($input: SendPushNotificationCommand!) {
  sendPushNotification(input: $input) {
    id
  }
}
    `;
export type SendPushNotificationMutationFn = Apollo.MutationFunction<SendPushNotificationMutation, SendPushNotificationMutationVariables>;

/**
 * __useSendPushNotificationMutation__
 *
 * To run a mutation, you first call `useSendPushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPushNotificationMutation, { data, loading, error }] = useSendPushNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPushNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendPushNotificationMutation, SendPushNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPushNotificationMutation, SendPushNotificationMutationVariables>(SendPushNotificationDocument, options);
      }
export type SendPushNotificationMutationHookResult = ReturnType<typeof useSendPushNotificationMutation>;
export type SendPushNotificationMutationResult = Apollo.MutationResult<SendPushNotificationMutation>;
export type SendPushNotificationMutationOptions = Apollo.BaseMutationOptions<SendPushNotificationMutation, SendPushNotificationMutationVariables>;
export const GetScheduledNotificationsDocument = gql`
    query GetScheduledNotifications {
  scheduledNotifications {
    id
    userId
    scheduledTime
    status
  }
}
    `;

/**
 * __useGetScheduledNotificationsQuery__
 *
 * To run a query within a React component, call `useGetScheduledNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScheduledNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>(GetScheduledNotificationsDocument, options);
      }
export function useGetScheduledNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>(GetScheduledNotificationsDocument, options);
        }
export function useGetScheduledNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>(GetScheduledNotificationsDocument, options);
        }
export type GetScheduledNotificationsQueryHookResult = ReturnType<typeof useGetScheduledNotificationsQuery>;
export type GetScheduledNotificationsLazyQueryHookResult = ReturnType<typeof useGetScheduledNotificationsLazyQuery>;
export type GetScheduledNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetScheduledNotificationsSuspenseQuery>;
export type GetScheduledNotificationsQueryResult = Apollo.QueryResult<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>;
export const GetParticipantNotesDocument = gql`
    query GetParticipantNotes($participantId: ID!, $status: NoteStatus) {
  participantNotes(participantId: $participantId, status: $status) {
    ...ParticipantNoteFields
  }
}
    ${ParticipantNoteFieldsFragmentDoc}`;

/**
 * __useGetParticipantNotesQuery__
 *
 * To run a query within a React component, call `useGetParticipantNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantNotesQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetParticipantNotesQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantNotesQuery, GetParticipantNotesQueryVariables> & ({ variables: GetParticipantNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantNotesQuery, GetParticipantNotesQueryVariables>(GetParticipantNotesDocument, options);
      }
export function useGetParticipantNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantNotesQuery, GetParticipantNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantNotesQuery, GetParticipantNotesQueryVariables>(GetParticipantNotesDocument, options);
        }
export function useGetParticipantNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantNotesQuery, GetParticipantNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantNotesQuery, GetParticipantNotesQueryVariables>(GetParticipantNotesDocument, options);
        }
export type GetParticipantNotesQueryHookResult = ReturnType<typeof useGetParticipantNotesQuery>;
export type GetParticipantNotesLazyQueryHookResult = ReturnType<typeof useGetParticipantNotesLazyQuery>;
export type GetParticipantNotesSuspenseQueryHookResult = ReturnType<typeof useGetParticipantNotesSuspenseQuery>;
export type GetParticipantNotesQueryResult = Apollo.QueryResult<GetParticipantNotesQuery, GetParticipantNotesQueryVariables>;
export const GetParticipantNoteDocument = gql`
    query GetParticipantNote($noteId: ID!) {
  participantNote(noteId: $noteId) {
    ...ParticipantNoteFields
  }
}
    ${ParticipantNoteFieldsFragmentDoc}`;

/**
 * __useGetParticipantNoteQuery__
 *
 * To run a query within a React component, call `useGetParticipantNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantNoteQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useGetParticipantNoteQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantNoteQuery, GetParticipantNoteQueryVariables> & ({ variables: GetParticipantNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantNoteQuery, GetParticipantNoteQueryVariables>(GetParticipantNoteDocument, options);
      }
export function useGetParticipantNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantNoteQuery, GetParticipantNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantNoteQuery, GetParticipantNoteQueryVariables>(GetParticipantNoteDocument, options);
        }
export function useGetParticipantNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantNoteQuery, GetParticipantNoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantNoteQuery, GetParticipantNoteQueryVariables>(GetParticipantNoteDocument, options);
        }
export type GetParticipantNoteQueryHookResult = ReturnType<typeof useGetParticipantNoteQuery>;
export type GetParticipantNoteLazyQueryHookResult = ReturnType<typeof useGetParticipantNoteLazyQuery>;
export type GetParticipantNoteSuspenseQueryHookResult = ReturnType<typeof useGetParticipantNoteSuspenseQuery>;
export type GetParticipantNoteQueryResult = Apollo.QueryResult<GetParticipantNoteQuery, GetParticipantNoteQueryVariables>;
export const AddParticipantNoteDocument = gql`
    mutation AddParticipantNote($input: AddParticipantNoteInput!) {
  addParticipantNote(input: $input) {
    id
  }
}
    `;
export type AddParticipantNoteMutationFn = Apollo.MutationFunction<AddParticipantNoteMutation, AddParticipantNoteMutationVariables>;

/**
 * __useAddParticipantNoteMutation__
 *
 * To run a mutation, you first call `useAddParticipantNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddParticipantNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addParticipantNoteMutation, { data, loading, error }] = useAddParticipantNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddParticipantNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddParticipantNoteMutation, AddParticipantNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddParticipantNoteMutation, AddParticipantNoteMutationVariables>(AddParticipantNoteDocument, options);
      }
export type AddParticipantNoteMutationHookResult = ReturnType<typeof useAddParticipantNoteMutation>;
export type AddParticipantNoteMutationResult = Apollo.MutationResult<AddParticipantNoteMutation>;
export type AddParticipantNoteMutationOptions = Apollo.BaseMutationOptions<AddParticipantNoteMutation, AddParticipantNoteMutationVariables>;
export const UpdateParticipantNoteDocument = gql`
    mutation UpdateParticipantNote($input: UpdateParticipantNoteInput!) {
  updateParticipantNote(input: $input) {
    id
  }
}
    `;
export type UpdateParticipantNoteMutationFn = Apollo.MutationFunction<UpdateParticipantNoteMutation, UpdateParticipantNoteMutationVariables>;

/**
 * __useUpdateParticipantNoteMutation__
 *
 * To run a mutation, you first call `useUpdateParticipantNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipantNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipantNoteMutation, { data, loading, error }] = useUpdateParticipantNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateParticipantNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParticipantNoteMutation, UpdateParticipantNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParticipantNoteMutation, UpdateParticipantNoteMutationVariables>(UpdateParticipantNoteDocument, options);
      }
export type UpdateParticipantNoteMutationHookResult = ReturnType<typeof useUpdateParticipantNoteMutation>;
export type UpdateParticipantNoteMutationResult = Apollo.MutationResult<UpdateParticipantNoteMutation>;
export type UpdateParticipantNoteMutationOptions = Apollo.BaseMutationOptions<UpdateParticipantNoteMutation, UpdateParticipantNoteMutationVariables>;
export const ArchiveParticipantNoteDocument = gql`
    mutation ArchiveParticipantNote($input: ArchiveParticipantNoteInput!) {
  archiveParticipantNote(input: $input) {
    id
  }
}
    `;
export type ArchiveParticipantNoteMutationFn = Apollo.MutationFunction<ArchiveParticipantNoteMutation, ArchiveParticipantNoteMutationVariables>;

/**
 * __useArchiveParticipantNoteMutation__
 *
 * To run a mutation, you first call `useArchiveParticipantNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveParticipantNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveParticipantNoteMutation, { data, loading, error }] = useArchiveParticipantNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveParticipantNoteMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveParticipantNoteMutation, ArchiveParticipantNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveParticipantNoteMutation, ArchiveParticipantNoteMutationVariables>(ArchiveParticipantNoteDocument, options);
      }
export type ArchiveParticipantNoteMutationHookResult = ReturnType<typeof useArchiveParticipantNoteMutation>;
export type ArchiveParticipantNoteMutationResult = Apollo.MutationResult<ArchiveParticipantNoteMutation>;
export type ArchiveParticipantNoteMutationOptions = Apollo.BaseMutationOptions<ArchiveParticipantNoteMutation, ArchiveParticipantNoteMutationVariables>;
export const ErasePartnerEnquiryDocument = gql`
    mutation ErasePartnerEnquiry($id: ID!) {
  erasePartnerEnquiry(id: $id) {
    id
    erasedCount
  }
}
    `;
export type ErasePartnerEnquiryMutationFn = Apollo.MutationFunction<ErasePartnerEnquiryMutation, ErasePartnerEnquiryMutationVariables>;

/**
 * __useErasePartnerEnquiryMutation__
 *
 * To run a mutation, you first call `useErasePartnerEnquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErasePartnerEnquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erasePartnerEnquiryMutation, { data, loading, error }] = useErasePartnerEnquiryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErasePartnerEnquiryMutation(baseOptions?: Apollo.MutationHookOptions<ErasePartnerEnquiryMutation, ErasePartnerEnquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ErasePartnerEnquiryMutation, ErasePartnerEnquiryMutationVariables>(ErasePartnerEnquiryDocument, options);
      }
export type ErasePartnerEnquiryMutationHookResult = ReturnType<typeof useErasePartnerEnquiryMutation>;
export type ErasePartnerEnquiryMutationResult = Apollo.MutationResult<ErasePartnerEnquiryMutation>;
export type ErasePartnerEnquiryMutationOptions = Apollo.BaseMutationOptions<ErasePartnerEnquiryMutation, ErasePartnerEnquiryMutationVariables>;
export const GetPartnerEnquiriesDocument = gql`
    query GetPartnerEnquiries($filter: PartnerEnquiryFilterInput) {
  partnerEnquiries(filter: $filter) {
    enquiries {
      id
      name
      businessName
      businessType
      location
      status
      receivedAt
      statusChangedAt
    }
    limit
    offset
    hasMore
  }
}
    `;

/**
 * __useGetPartnerEnquiriesQuery__
 *
 * To run a query within a React component, call `useGetPartnerEnquiriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerEnquiriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerEnquiriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPartnerEnquiriesQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerEnquiriesQuery, GetPartnerEnquiriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerEnquiriesQuery, GetPartnerEnquiriesQueryVariables>(GetPartnerEnquiriesDocument, options);
      }
export function useGetPartnerEnquiriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerEnquiriesQuery, GetPartnerEnquiriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerEnquiriesQuery, GetPartnerEnquiriesQueryVariables>(GetPartnerEnquiriesDocument, options);
        }
export function useGetPartnerEnquiriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerEnquiriesQuery, GetPartnerEnquiriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerEnquiriesQuery, GetPartnerEnquiriesQueryVariables>(GetPartnerEnquiriesDocument, options);
        }
export type GetPartnerEnquiriesQueryHookResult = ReturnType<typeof useGetPartnerEnquiriesQuery>;
export type GetPartnerEnquiriesLazyQueryHookResult = ReturnType<typeof useGetPartnerEnquiriesLazyQuery>;
export type GetPartnerEnquiriesSuspenseQueryHookResult = ReturnType<typeof useGetPartnerEnquiriesSuspenseQuery>;
export type GetPartnerEnquiriesQueryResult = Apollo.QueryResult<GetPartnerEnquiriesQuery, GetPartnerEnquiriesQueryVariables>;
export const RevealPartnerEnquiryContactDocument = gql`
    mutation RevealPartnerEnquiryContact($id: ID!) {
  revealPartnerEnquiryContact(id: $id) {
    id
    name
    businessName
    email
    phone
    website
    socials
  }
}
    `;
export type RevealPartnerEnquiryContactMutationFn = Apollo.MutationFunction<RevealPartnerEnquiryContactMutation, RevealPartnerEnquiryContactMutationVariables>;

/**
 * __useRevealPartnerEnquiryContactMutation__
 *
 * To run a mutation, you first call `useRevealPartnerEnquiryContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevealPartnerEnquiryContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revealPartnerEnquiryContactMutation, { data, loading, error }] = useRevealPartnerEnquiryContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevealPartnerEnquiryContactMutation(baseOptions?: Apollo.MutationHookOptions<RevealPartnerEnquiryContactMutation, RevealPartnerEnquiryContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevealPartnerEnquiryContactMutation, RevealPartnerEnquiryContactMutationVariables>(RevealPartnerEnquiryContactDocument, options);
      }
export type RevealPartnerEnquiryContactMutationHookResult = ReturnType<typeof useRevealPartnerEnquiryContactMutation>;
export type RevealPartnerEnquiryContactMutationResult = Apollo.MutationResult<RevealPartnerEnquiryContactMutation>;
export type RevealPartnerEnquiryContactMutationOptions = Apollo.BaseMutationOptions<RevealPartnerEnquiryContactMutation, RevealPartnerEnquiryContactMutationVariables>;
export const SetPartnerEnquiryStatusDocument = gql`
    mutation SetPartnerEnquiryStatus($id: ID!, $status: String!) {
  setPartnerEnquiryStatus(id: $id, status: $status) {
    id
    status
    previousStatus
    changed
    statusChangedAt
  }
}
    `;
export type SetPartnerEnquiryStatusMutationFn = Apollo.MutationFunction<SetPartnerEnquiryStatusMutation, SetPartnerEnquiryStatusMutationVariables>;

/**
 * __useSetPartnerEnquiryStatusMutation__
 *
 * To run a mutation, you first call `useSetPartnerEnquiryStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPartnerEnquiryStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPartnerEnquiryStatusMutation, { data, loading, error }] = useSetPartnerEnquiryStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetPartnerEnquiryStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetPartnerEnquiryStatusMutation, SetPartnerEnquiryStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPartnerEnquiryStatusMutation, SetPartnerEnquiryStatusMutationVariables>(SetPartnerEnquiryStatusDocument, options);
      }
export type SetPartnerEnquiryStatusMutationHookResult = ReturnType<typeof useSetPartnerEnquiryStatusMutation>;
export type SetPartnerEnquiryStatusMutationResult = Apollo.MutationResult<SetPartnerEnquiryStatusMutation>;
export type SetPartnerEnquiryStatusMutationOptions = Apollo.BaseMutationOptions<SetPartnerEnquiryStatusMutation, SetPartnerEnquiryStatusMutationVariables>;
export const GetPaymentLinksDocument = gql`
    query GetPaymentLinks($activeOnly: Boolean) {
  paymentLinks(activeOnly: $activeOnly) {
    id
    url
    active
    name
    purpose
    source
  }
}
    `;

/**
 * __useGetPaymentLinksQuery__
 *
 * To run a query within a React component, call `useGetPaymentLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentLinksQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useGetPaymentLinksQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentLinksQuery, GetPaymentLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentLinksQuery, GetPaymentLinksQueryVariables>(GetPaymentLinksDocument, options);
      }
export function useGetPaymentLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentLinksQuery, GetPaymentLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentLinksQuery, GetPaymentLinksQueryVariables>(GetPaymentLinksDocument, options);
        }
export function useGetPaymentLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinksQuery, GetPaymentLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentLinksQuery, GetPaymentLinksQueryVariables>(GetPaymentLinksDocument, options);
        }
export type GetPaymentLinksQueryHookResult = ReturnType<typeof useGetPaymentLinksQuery>;
export type GetPaymentLinksLazyQueryHookResult = ReturnType<typeof useGetPaymentLinksLazyQuery>;
export type GetPaymentLinksSuspenseQueryHookResult = ReturnType<typeof useGetPaymentLinksSuspenseQuery>;
export type GetPaymentLinksQueryResult = Apollo.QueryResult<GetPaymentLinksQuery, GetPaymentLinksQueryVariables>;
export const GetPaymentLinkDocument = gql`
    query GetPaymentLink($id: ID!) {
  paymentLink(id: $id) {
    id
    url
    active
    name
    purpose
    source
  }
}
    `;

/**
 * __useGetPaymentLinkQuery__
 *
 * To run a query within a React component, call `useGetPaymentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentLinkQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentLinkQuery, GetPaymentLinkQueryVariables> & ({ variables: GetPaymentLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>(GetPaymentLinkDocument, options);
      }
export function useGetPaymentLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>(GetPaymentLinkDocument, options);
        }
export function useGetPaymentLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>(GetPaymentLinkDocument, options);
        }
export type GetPaymentLinkQueryHookResult = ReturnType<typeof useGetPaymentLinkQuery>;
export type GetPaymentLinkLazyQueryHookResult = ReturnType<typeof useGetPaymentLinkLazyQuery>;
export type GetPaymentLinkSuspenseQueryHookResult = ReturnType<typeof useGetPaymentLinkSuspenseQuery>;
export type GetPaymentLinkQueryResult = Apollo.QueryResult<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>;
export const CreatePaymentLinkDocument = gql`
    mutation CreatePaymentLink($input: CreatePaymentLinkInput!) {
  createPaymentLink(input: $input) {
    id
    url
    active
    name
    purpose
    source
  }
}
    `;
export type CreatePaymentLinkMutationFn = Apollo.MutationFunction<CreatePaymentLinkMutation, CreatePaymentLinkMutationVariables>;

/**
 * __useCreatePaymentLinkMutation__
 *
 * To run a mutation, you first call `useCreatePaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentLinkMutation, { data, loading, error }] = useCreatePaymentLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentLinkMutation, CreatePaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentLinkMutation, CreatePaymentLinkMutationVariables>(CreatePaymentLinkDocument, options);
      }
export type CreatePaymentLinkMutationHookResult = ReturnType<typeof useCreatePaymentLinkMutation>;
export type CreatePaymentLinkMutationResult = Apollo.MutationResult<CreatePaymentLinkMutation>;
export type CreatePaymentLinkMutationOptions = Apollo.BaseMutationOptions<CreatePaymentLinkMutation, CreatePaymentLinkMutationVariables>;
export const DeactivatePaymentLinkDocument = gql`
    mutation DeactivatePaymentLink($id: ID!) {
  deactivatePaymentLink(id: $id)
}
    `;
export type DeactivatePaymentLinkMutationFn = Apollo.MutationFunction<DeactivatePaymentLinkMutation, DeactivatePaymentLinkMutationVariables>;

/**
 * __useDeactivatePaymentLinkMutation__
 *
 * To run a mutation, you first call `useDeactivatePaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivatePaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivatePaymentLinkMutation, { data, loading, error }] = useDeactivatePaymentLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivatePaymentLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeactivatePaymentLinkMutation, DeactivatePaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivatePaymentLinkMutation, DeactivatePaymentLinkMutationVariables>(DeactivatePaymentLinkDocument, options);
      }
export type DeactivatePaymentLinkMutationHookResult = ReturnType<typeof useDeactivatePaymentLinkMutation>;
export type DeactivatePaymentLinkMutationResult = Apollo.MutationResult<DeactivatePaymentLinkMutation>;
export type DeactivatePaymentLinkMutationOptions = Apollo.BaseMutationOptions<DeactivatePaymentLinkMutation, DeactivatePaymentLinkMutationVariables>;
export const AdoptPaymentLinkDocument = gql`
    mutation AdoptPaymentLink($input: AdoptPaymentLinkInput!) {
  adoptPaymentLink(input: $input) {
    id
    url
    active
    name
    purpose
    source
  }
}
    `;
export type AdoptPaymentLinkMutationFn = Apollo.MutationFunction<AdoptPaymentLinkMutation, AdoptPaymentLinkMutationVariables>;

/**
 * __useAdoptPaymentLinkMutation__
 *
 * To run a mutation, you first call `useAdoptPaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdoptPaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adoptPaymentLinkMutation, { data, loading, error }] = useAdoptPaymentLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdoptPaymentLinkMutation(baseOptions?: Apollo.MutationHookOptions<AdoptPaymentLinkMutation, AdoptPaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdoptPaymentLinkMutation, AdoptPaymentLinkMutationVariables>(AdoptPaymentLinkDocument, options);
      }
export type AdoptPaymentLinkMutationHookResult = ReturnType<typeof useAdoptPaymentLinkMutation>;
export type AdoptPaymentLinkMutationResult = Apollo.MutationResult<AdoptPaymentLinkMutation>;
export type AdoptPaymentLinkMutationOptions = Apollo.BaseMutationOptions<AdoptPaymentLinkMutation, AdoptPaymentLinkMutationVariables>;
export const UpdateUserNameDocument = gql`
    mutation UpdateUserName($input: UpdateUserNameInput!) {
  updateUserName(input: $input) {
    id
  }
}
    `;
export type UpdateUserNameMutationFn = Apollo.MutationFunction<UpdateUserNameMutation, UpdateUserNameMutationVariables>;

/**
 * __useUpdateUserNameMutation__
 *
 * To run a mutation, you first call `useUpdateUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNameMutation, { data, loading, error }] = useUpdateUserNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNameMutation, UpdateUserNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNameMutation, UpdateUserNameMutationVariables>(UpdateUserNameDocument, options);
      }
export type UpdateUserNameMutationHookResult = ReturnType<typeof useUpdateUserNameMutation>;
export type UpdateUserNameMutationResult = Apollo.MutationResult<UpdateUserNameMutation>;
export type UpdateUserNameMutationOptions = Apollo.BaseMutationOptions<UpdateUserNameMutation, UpdateUserNameMutationVariables>;
export const UpdateTimezoneDocument = gql`
    mutation UpdateTimezone($timezone: String!) {
  updateTimezone(timezone: $timezone) {
    id
  }
}
    `;
export type UpdateTimezoneMutationFn = Apollo.MutationFunction<UpdateTimezoneMutation, UpdateTimezoneMutationVariables>;

/**
 * __useUpdateTimezoneMutation__
 *
 * To run a mutation, you first call `useUpdateTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimezoneMutation, { data, loading, error }] = useUpdateTimezoneMutation({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useUpdateTimezoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimezoneMutation, UpdateTimezoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimezoneMutation, UpdateTimezoneMutationVariables>(UpdateTimezoneDocument, options);
      }
export type UpdateTimezoneMutationHookResult = ReturnType<typeof useUpdateTimezoneMutation>;
export type UpdateTimezoneMutationResult = Apollo.MutationResult<UpdateTimezoneMutation>;
export type UpdateTimezoneMutationOptions = Apollo.BaseMutationOptions<UpdateTimezoneMutation, UpdateTimezoneMutationVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  me {
    ... on Participant {
      participantId
      pii {
        identityInformation {
          firstName
          middleName
          lastName
        }
        contactInformation {
          email
        }
      }
      timezone
      messagingToken {
        token
        provider
      }
    }
    ... on Nurse {
      nurseId
      pii {
        identityInformation {
          firstName
          middleName
          lastName
        }
        contactInformation {
          email
        }
      }
      timezone
      messagingToken {
        token
        provider
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const CreateLearningJourneyDocument = gql`
    mutation CreateLearningJourney($command: CreateLearningJourneyCommand!) {
  createLearningJourney(command: $command) {
    id
  }
}
    `;
export type CreateLearningJourneyMutationFn = Apollo.MutationFunction<CreateLearningJourneyMutation, CreateLearningJourneyMutationVariables>;

/**
 * __useCreateLearningJourneyMutation__
 *
 * To run a mutation, you first call `useCreateLearningJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningJourneyMutation, { data, loading, error }] = useCreateLearningJourneyMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useCreateLearningJourneyMutation(baseOptions?: Apollo.MutationHookOptions<CreateLearningJourneyMutation, CreateLearningJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLearningJourneyMutation, CreateLearningJourneyMutationVariables>(CreateLearningJourneyDocument, options);
      }
export type CreateLearningJourneyMutationHookResult = ReturnType<typeof useCreateLearningJourneyMutation>;
export type CreateLearningJourneyMutationResult = Apollo.MutationResult<CreateLearningJourneyMutation>;
export type CreateLearningJourneyMutationOptions = Apollo.BaseMutationOptions<CreateLearningJourneyMutation, CreateLearningJourneyMutationVariables>;
export const UpdateLearningJourneyDocument = gql`
    mutation UpdateLearningJourney($command: UpdateLearningJourneyCommand!) {
  updateLearningJourney(command: $command) {
    id
  }
}
    `;
export type UpdateLearningJourneyMutationFn = Apollo.MutationFunction<UpdateLearningJourneyMutation, UpdateLearningJourneyMutationVariables>;

/**
 * __useUpdateLearningJourneyMutation__
 *
 * To run a mutation, you first call `useUpdateLearningJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningJourneyMutation, { data, loading, error }] = useUpdateLearningJourneyMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useUpdateLearningJourneyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearningJourneyMutation, UpdateLearningJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearningJourneyMutation, UpdateLearningJourneyMutationVariables>(UpdateLearningJourneyDocument, options);
      }
export type UpdateLearningJourneyMutationHookResult = ReturnType<typeof useUpdateLearningJourneyMutation>;
export type UpdateLearningJourneyMutationResult = Apollo.MutationResult<UpdateLearningJourneyMutation>;
export type UpdateLearningJourneyMutationOptions = Apollo.BaseMutationOptions<UpdateLearningJourneyMutation, UpdateLearningJourneyMutationVariables>;
export const BulkAssignUsersToLearningJourneyDocument = gql`
    mutation BulkAssignUsersToLearningJourney($command: BulkAssignUsersToLearningJourneyCommand!) {
  bulkAssignUsersToLearningJourney(command: $command) {
    id
  }
}
    `;
export type BulkAssignUsersToLearningJourneyMutationFn = Apollo.MutationFunction<BulkAssignUsersToLearningJourneyMutation, BulkAssignUsersToLearningJourneyMutationVariables>;

/**
 * __useBulkAssignUsersToLearningJourneyMutation__
 *
 * To run a mutation, you first call `useBulkAssignUsersToLearningJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignUsersToLearningJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignUsersToLearningJourneyMutation, { data, loading, error }] = useBulkAssignUsersToLearningJourneyMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useBulkAssignUsersToLearningJourneyMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssignUsersToLearningJourneyMutation, BulkAssignUsersToLearningJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignUsersToLearningJourneyMutation, BulkAssignUsersToLearningJourneyMutationVariables>(BulkAssignUsersToLearningJourneyDocument, options);
      }
export type BulkAssignUsersToLearningJourneyMutationHookResult = ReturnType<typeof useBulkAssignUsersToLearningJourneyMutation>;
export type BulkAssignUsersToLearningJourneyMutationResult = Apollo.MutationResult<BulkAssignUsersToLearningJourneyMutation>;
export type BulkAssignUsersToLearningJourneyMutationOptions = Apollo.BaseMutationOptions<BulkAssignUsersToLearningJourneyMutation, BulkAssignUsersToLearningJourneyMutationVariables>;
export const BulkUnassignUsersFromLearningJourneyDocument = gql`
    mutation BulkUnassignUsersFromLearningJourney($command: BulkUnassignUsersFromLearningJourneyCommand!) {
  bulkUnassignUsersFromLearningJourney(command: $command) {
    id
  }
}
    `;
export type BulkUnassignUsersFromLearningJourneyMutationFn = Apollo.MutationFunction<BulkUnassignUsersFromLearningJourneyMutation, BulkUnassignUsersFromLearningJourneyMutationVariables>;

/**
 * __useBulkUnassignUsersFromLearningJourneyMutation__
 *
 * To run a mutation, you first call `useBulkUnassignUsersFromLearningJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnassignUsersFromLearningJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnassignUsersFromLearningJourneyMutation, { data, loading, error }] = useBulkUnassignUsersFromLearningJourneyMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useBulkUnassignUsersFromLearningJourneyMutation(baseOptions?: Apollo.MutationHookOptions<BulkUnassignUsersFromLearningJourneyMutation, BulkUnassignUsersFromLearningJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUnassignUsersFromLearningJourneyMutation, BulkUnassignUsersFromLearningJourneyMutationVariables>(BulkUnassignUsersFromLearningJourneyDocument, options);
      }
export type BulkUnassignUsersFromLearningJourneyMutationHookResult = ReturnType<typeof useBulkUnassignUsersFromLearningJourneyMutation>;
export type BulkUnassignUsersFromLearningJourneyMutationResult = Apollo.MutationResult<BulkUnassignUsersFromLearningJourneyMutation>;
export type BulkUnassignUsersFromLearningJourneyMutationOptions = Apollo.BaseMutationOptions<BulkUnassignUsersFromLearningJourneyMutation, BulkUnassignUsersFromLearningJourneyMutationVariables>;
export const CreateLearningPathDocument = gql`
    mutation CreateLearningPath($command: CreateLearningPathCommand!) {
  createLearningPath(command: $command) {
    id
  }
}
    `;
export type CreateLearningPathMutationFn = Apollo.MutationFunction<CreateLearningPathMutation, CreateLearningPathMutationVariables>;

/**
 * __useCreateLearningPathMutation__
 *
 * To run a mutation, you first call `useCreateLearningPathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningPathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningPathMutation, { data, loading, error }] = useCreateLearningPathMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useCreateLearningPathMutation(baseOptions?: Apollo.MutationHookOptions<CreateLearningPathMutation, CreateLearningPathMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLearningPathMutation, CreateLearningPathMutationVariables>(CreateLearningPathDocument, options);
      }
export type CreateLearningPathMutationHookResult = ReturnType<typeof useCreateLearningPathMutation>;
export type CreateLearningPathMutationResult = Apollo.MutationResult<CreateLearningPathMutation>;
export type CreateLearningPathMutationOptions = Apollo.BaseMutationOptions<CreateLearningPathMutation, CreateLearningPathMutationVariables>;
export const UpdateLearningPathDocument = gql`
    mutation UpdateLearningPath($command: UpdateLearningPathCommand!) {
  updateLearningPath(command: $command) {
    id
  }
}
    `;
export type UpdateLearningPathMutationFn = Apollo.MutationFunction<UpdateLearningPathMutation, UpdateLearningPathMutationVariables>;

/**
 * __useUpdateLearningPathMutation__
 *
 * To run a mutation, you first call `useUpdateLearningPathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningPathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningPathMutation, { data, loading, error }] = useUpdateLearningPathMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useUpdateLearningPathMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearningPathMutation, UpdateLearningPathMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearningPathMutation, UpdateLearningPathMutationVariables>(UpdateLearningPathDocument, options);
      }
export type UpdateLearningPathMutationHookResult = ReturnType<typeof useUpdateLearningPathMutation>;
export type UpdateLearningPathMutationResult = Apollo.MutationResult<UpdateLearningPathMutation>;
export type UpdateLearningPathMutationOptions = Apollo.BaseMutationOptions<UpdateLearningPathMutation, UpdateLearningPathMutationVariables>;
export const GetLearningPathsDocument = gql`
    query GetLearningPaths {
  learningPaths {
    learningPathId
    name
    description
    contentItems {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    assignedUserCount
    contentTypeDistribution {
      type
      count
    }
    completionRate
    averageCompletionTimeSeconds
    journeyCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetLearningPathsQuery__
 *
 * To run a query within a React component, call `useGetLearningPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningPathsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLearningPathsQuery(baseOptions?: Apollo.QueryHookOptions<GetLearningPathsQuery, GetLearningPathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningPathsQuery, GetLearningPathsQueryVariables>(GetLearningPathsDocument, options);
      }
export function useGetLearningPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningPathsQuery, GetLearningPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningPathsQuery, GetLearningPathsQueryVariables>(GetLearningPathsDocument, options);
        }
export function useGetLearningPathsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningPathsQuery, GetLearningPathsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningPathsQuery, GetLearningPathsQueryVariables>(GetLearningPathsDocument, options);
        }
export type GetLearningPathsQueryHookResult = ReturnType<typeof useGetLearningPathsQuery>;
export type GetLearningPathsLazyQueryHookResult = ReturnType<typeof useGetLearningPathsLazyQuery>;
export type GetLearningPathsSuspenseQueryHookResult = ReturnType<typeof useGetLearningPathsSuspenseQuery>;
export type GetLearningPathsQueryResult = Apollo.QueryResult<GetLearningPathsQuery, GetLearningPathsQueryVariables>;
export const GetLearningPathDocument = gql`
    query GetLearningPath($learningPathId: ID!) {
  learningPath(learningPathId: $learningPathId) {
    learningPathId
    name
    description
    contentItems {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    assignedUserCount
    contentTypeDistribution {
      type
      count
    }
    completionRate
    averageCompletionTimeSeconds
    journeyCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetLearningPathQuery__
 *
 * To run a query within a React component, call `useGetLearningPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningPathQuery({
 *   variables: {
 *      learningPathId: // value for 'learningPathId'
 *   },
 * });
 */
export function useGetLearningPathQuery(baseOptions: Apollo.QueryHookOptions<GetLearningPathQuery, GetLearningPathQueryVariables> & ({ variables: GetLearningPathQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningPathQuery, GetLearningPathQueryVariables>(GetLearningPathDocument, options);
      }
export function useGetLearningPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningPathQuery, GetLearningPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningPathQuery, GetLearningPathQueryVariables>(GetLearningPathDocument, options);
        }
export function useGetLearningPathSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningPathQuery, GetLearningPathQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningPathQuery, GetLearningPathQueryVariables>(GetLearningPathDocument, options);
        }
export type GetLearningPathQueryHookResult = ReturnType<typeof useGetLearningPathQuery>;
export type GetLearningPathLazyQueryHookResult = ReturnType<typeof useGetLearningPathLazyQuery>;
export type GetLearningPathSuspenseQueryHookResult = ReturnType<typeof useGetLearningPathSuspenseQuery>;
export type GetLearningPathQueryResult = Apollo.QueryResult<GetLearningPathQuery, GetLearningPathQueryVariables>;
export const GetDojoContentDocument = gql`
    query GetDojoContent {
  dojoArticles {
    id
    title
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    media {
      url
    }
    protocols
  }
  dojoChecklists {
    id
    title
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    paragraph
    items
    completionMessage
  }
  dojoNuggets {
    id
    title
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    media {
      url
    }
  }
  dojoQuizzes {
    id
    title
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    question
    options {
      text
      isCorrect
      title
      name
    }
  }
  dojoQuotes {
    id
    title
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    media {
      url
    }
  }
  storyTeasers {
    id
    title
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    media {
      url
    }
    ctaButtonLabel
  }
  videoTeasers {
    id
    title
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    media {
      url
    }
    ctaButtonLabel
  }
  articleTeasers {
    id
    title
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    media {
      url
    }
    ctaButtonLabel
  }
}
    `;

/**
 * __useGetDojoContentQuery__
 *
 * To run a query within a React component, call `useGetDojoContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDojoContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDojoContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDojoContentQuery(baseOptions?: Apollo.QueryHookOptions<GetDojoContentQuery, GetDojoContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDojoContentQuery, GetDojoContentQueryVariables>(GetDojoContentDocument, options);
      }
export function useGetDojoContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDojoContentQuery, GetDojoContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDojoContentQuery, GetDojoContentQueryVariables>(GetDojoContentDocument, options);
        }
export function useGetDojoContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDojoContentQuery, GetDojoContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDojoContentQuery, GetDojoContentQueryVariables>(GetDojoContentDocument, options);
        }
export type GetDojoContentQueryHookResult = ReturnType<typeof useGetDojoContentQuery>;
export type GetDojoContentLazyQueryHookResult = ReturnType<typeof useGetDojoContentLazyQuery>;
export type GetDojoContentSuspenseQueryHookResult = ReturnType<typeof useGetDojoContentSuspenseQuery>;
export type GetDojoContentQueryResult = Apollo.QueryResult<GetDojoContentQuery, GetDojoContentQueryVariables>;
export const GetSimpleDojoContentDocument = gql`
    query GetSimpleDojoContent {
  dojoContent {
    id
    title
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
  }
}
    `;

/**
 * __useGetSimpleDojoContentQuery__
 *
 * To run a query within a React component, call `useGetSimpleDojoContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleDojoContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleDojoContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSimpleDojoContentQuery(baseOptions?: Apollo.QueryHookOptions<GetSimpleDojoContentQuery, GetSimpleDojoContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimpleDojoContentQuery, GetSimpleDojoContentQueryVariables>(GetSimpleDojoContentDocument, options);
      }
export function useGetSimpleDojoContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleDojoContentQuery, GetSimpleDojoContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimpleDojoContentQuery, GetSimpleDojoContentQueryVariables>(GetSimpleDojoContentDocument, options);
        }
export function useGetSimpleDojoContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSimpleDojoContentQuery, GetSimpleDojoContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSimpleDojoContentQuery, GetSimpleDojoContentQueryVariables>(GetSimpleDojoContentDocument, options);
        }
export type GetSimpleDojoContentQueryHookResult = ReturnType<typeof useGetSimpleDojoContentQuery>;
export type GetSimpleDojoContentLazyQueryHookResult = ReturnType<typeof useGetSimpleDojoContentLazyQuery>;
export type GetSimpleDojoContentSuspenseQueryHookResult = ReturnType<typeof useGetSimpleDojoContentSuspenseQuery>;
export type GetSimpleDojoContentQueryResult = Apollo.QueryResult<GetSimpleDojoContentQuery, GetSimpleDojoContentQueryVariables>;
export const DojoGetParticipantsDocument = gql`
    query DojoGetParticipants($filter: ParticipantFilter) {
  participants(filter: $filter) {
    participantId
    onboardingStatus
    pii {
      identityInformation {
        firstName
        middleName
        lastName
      }
      contactInformation {
        email
      }
    }
  }
}
    `;

/**
 * __useDojoGetParticipantsQuery__
 *
 * To run a query within a React component, call `useDojoGetParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDojoGetParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDojoGetParticipantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDojoGetParticipantsQuery(baseOptions?: Apollo.QueryHookOptions<DojoGetParticipantsQuery, DojoGetParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DojoGetParticipantsQuery, DojoGetParticipantsQueryVariables>(DojoGetParticipantsDocument, options);
      }
export function useDojoGetParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DojoGetParticipantsQuery, DojoGetParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DojoGetParticipantsQuery, DojoGetParticipantsQueryVariables>(DojoGetParticipantsDocument, options);
        }
export function useDojoGetParticipantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DojoGetParticipantsQuery, DojoGetParticipantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DojoGetParticipantsQuery, DojoGetParticipantsQueryVariables>(DojoGetParticipantsDocument, options);
        }
export type DojoGetParticipantsQueryHookResult = ReturnType<typeof useDojoGetParticipantsQuery>;
export type DojoGetParticipantsLazyQueryHookResult = ReturnType<typeof useDojoGetParticipantsLazyQuery>;
export type DojoGetParticipantsSuspenseQueryHookResult = ReturnType<typeof useDojoGetParticipantsSuspenseQuery>;
export type DojoGetParticipantsQueryResult = Apollo.QueryResult<DojoGetParticipantsQuery, DojoGetParticipantsQueryVariables>;
export const GetLearningJourneysDocument = gql`
    query GetLearningJourneys {
  learningJourneys {
    learningJourneyId
    name
    description
    steps {
      learningPath {
        learningPathId
        name
        description
        contentItems {
          ... on ExternalContentId {
            cms
            contentType
            reference
          }
          ... on MobileWidgetId {
            kind
          }
          ... on CustomActivityId {
            customActivityId
          }
        }
        assignedUserCount
        averageCompletionTimeSeconds
        completionRate
        contentTypeDistribution {
          type
          count
        }
        journeyCount
        progressDistribution {
          notStarted
          inProgress
          completed
        }
        createdAt
        updatedAt
      }
      order
      unlockStrategy
      unlockStatus {
        reason
        unlocked
      }
    }
    assignedUserIds
    assignDuringOnboarding
    progress
    completedPaths
    totalPaths
    timeSpentSeconds
    progressDistribution {
      notStarted
      inProgress
      completed
    }
    averageCompletionTimeSeconds
    completedUserCount
    engagementRate
    lastAccessedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetLearningJourneysQuery__
 *
 * To run a query within a React component, call `useGetLearningJourneysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningJourneysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningJourneysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLearningJourneysQuery(baseOptions?: Apollo.QueryHookOptions<GetLearningJourneysQuery, GetLearningJourneysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningJourneysQuery, GetLearningJourneysQueryVariables>(GetLearningJourneysDocument, options);
      }
export function useGetLearningJourneysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningJourneysQuery, GetLearningJourneysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningJourneysQuery, GetLearningJourneysQueryVariables>(GetLearningJourneysDocument, options);
        }
export function useGetLearningJourneysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningJourneysQuery, GetLearningJourneysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningJourneysQuery, GetLearningJourneysQueryVariables>(GetLearningJourneysDocument, options);
        }
export type GetLearningJourneysQueryHookResult = ReturnType<typeof useGetLearningJourneysQuery>;
export type GetLearningJourneysLazyQueryHookResult = ReturnType<typeof useGetLearningJourneysLazyQuery>;
export type GetLearningJourneysSuspenseQueryHookResult = ReturnType<typeof useGetLearningJourneysSuspenseQuery>;
export type GetLearningJourneysQueryResult = Apollo.QueryResult<GetLearningJourneysQuery, GetLearningJourneysQueryVariables>;
export const GetLearningJourneyDocument = gql`
    query GetLearningJourney($id: ID!) {
  learningJourney(learningJourneyId: $id) {
    learningJourneyId
    name
    description
    steps {
      learningPath {
        learningPathId
        name
        description
        contentItems {
          ... on ExternalContentId {
            cms
            contentType
            reference
          }
          ... on MobileWidgetId {
            kind
          }
          ... on CustomActivityId {
            customActivityId
          }
        }
      }
      order
      unlockStrategy
      unlockStatus {
        reason
        unlocked
      }
    }
    assignedUserIds
    assignDuringOnboarding
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetLearningJourneyQuery__
 *
 * To run a query within a React component, call `useGetLearningJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningJourneyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLearningJourneyQuery(baseOptions: Apollo.QueryHookOptions<GetLearningJourneyQuery, GetLearningJourneyQueryVariables> & ({ variables: GetLearningJourneyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningJourneyQuery, GetLearningJourneyQueryVariables>(GetLearningJourneyDocument, options);
      }
export function useGetLearningJourneyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningJourneyQuery, GetLearningJourneyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningJourneyQuery, GetLearningJourneyQueryVariables>(GetLearningJourneyDocument, options);
        }
export function useGetLearningJourneySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningJourneyQuery, GetLearningJourneyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningJourneyQuery, GetLearningJourneyQueryVariables>(GetLearningJourneyDocument, options);
        }
export type GetLearningJourneyQueryHookResult = ReturnType<typeof useGetLearningJourneyQuery>;
export type GetLearningJourneyLazyQueryHookResult = ReturnType<typeof useGetLearningJourneyLazyQuery>;
export type GetLearningJourneySuspenseQueryHookResult = ReturnType<typeof useGetLearningJourneySuspenseQuery>;
export type GetLearningJourneyQueryResult = Apollo.QueryResult<GetLearningJourneyQuery, GetLearningJourneyQueryVariables>;
export const GetCoachEngagementExportDocument = gql`
    query GetCoachEngagementExport($input: CoachEngagementExportInput) {
  coachEngagementExport(input: $input) {
    userId
    userName
    email
    chatResponsiveness {
      currentRate
      currentOutbound
      currentResponded
      previousRate
      previousOutbound
      previousResponded
      trend
    }
    totalConsults
    attendedConsults
    lastConsultDate
    firstConsultDate
    coachEngaged
    segments
  }
}
    `;

/**
 * __useGetCoachEngagementExportQuery__
 *
 * To run a query within a React component, call `useGetCoachEngagementExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachEngagementExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachEngagementExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCoachEngagementExportQuery(baseOptions?: Apollo.QueryHookOptions<GetCoachEngagementExportQuery, GetCoachEngagementExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachEngagementExportQuery, GetCoachEngagementExportQueryVariables>(GetCoachEngagementExportDocument, options);
      }
export function useGetCoachEngagementExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachEngagementExportQuery, GetCoachEngagementExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachEngagementExportQuery, GetCoachEngagementExportQueryVariables>(GetCoachEngagementExportDocument, options);
        }
export function useGetCoachEngagementExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoachEngagementExportQuery, GetCoachEngagementExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoachEngagementExportQuery, GetCoachEngagementExportQueryVariables>(GetCoachEngagementExportDocument, options);
        }
export type GetCoachEngagementExportQueryHookResult = ReturnType<typeof useGetCoachEngagementExportQuery>;
export type GetCoachEngagementExportLazyQueryHookResult = ReturnType<typeof useGetCoachEngagementExportLazyQuery>;
export type GetCoachEngagementExportSuspenseQueryHookResult = ReturnType<typeof useGetCoachEngagementExportSuspenseQuery>;
export type GetCoachEngagementExportQueryResult = Apollo.QueryResult<GetCoachEngagementExportQuery, GetCoachEngagementExportQueryVariables>;
export const GetSegmentsDocument = gql`
    query GetSegments {
  segments {
    id
    name
    description
    memberCount
  }
}
    `;

/**
 * __useGetSegmentsQuery__
 *
 * To run a query within a React component, call `useGetSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
      }
export function useGetSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
        }
export function useGetSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
        }
export type GetSegmentsQueryHookResult = ReturnType<typeof useGetSegmentsQuery>;
export type GetSegmentsLazyQueryHookResult = ReturnType<typeof useGetSegmentsLazyQuery>;
export type GetSegmentsSuspenseQueryHookResult = ReturnType<typeof useGetSegmentsSuspenseQuery>;
export type GetSegmentsQueryResult = Apollo.QueryResult<GetSegmentsQuery, GetSegmentsQueryVariables>;
export const GetSegmentUserDataDocument = gql`
    query GetSegmentUserData($segmentId: ID!, $limit: Int) {
  segmentUserData(segmentId: $segmentId, limit: $limit) {
    userId
    lastAppActivity
    lastVnsSession
    vnsSessionCount
    segmentIds
    chatResponseRate
    chatResponsiveness {
      currentRate
      currentOutbound
      currentResponded
      previousRate
      previousOutbound
      previousResponded
      trend
    }
    firstConsultDate
    classification {
      userId
      classification
      classificationReason
      classificationChangedAt
      classificationChangedBy
    }
    pii {
      identityInformation {
        firstName
        lastName
      }
      contactInformation {
        email
      }
    }
  }
}
    `;

/**
 * __useGetSegmentUserDataQuery__
 *
 * To run a query within a React component, call `useGetSegmentUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentUserDataQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSegmentUserDataQuery(baseOptions: Apollo.QueryHookOptions<GetSegmentUserDataQuery, GetSegmentUserDataQueryVariables> & ({ variables: GetSegmentUserDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentUserDataQuery, GetSegmentUserDataQueryVariables>(GetSegmentUserDataDocument, options);
      }
export function useGetSegmentUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentUserDataQuery, GetSegmentUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentUserDataQuery, GetSegmentUserDataQueryVariables>(GetSegmentUserDataDocument, options);
        }
export function useGetSegmentUserDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSegmentUserDataQuery, GetSegmentUserDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSegmentUserDataQuery, GetSegmentUserDataQueryVariables>(GetSegmentUserDataDocument, options);
        }
export type GetSegmentUserDataQueryHookResult = ReturnType<typeof useGetSegmentUserDataQuery>;
export type GetSegmentUserDataLazyQueryHookResult = ReturnType<typeof useGetSegmentUserDataLazyQuery>;
export type GetSegmentUserDataSuspenseQueryHookResult = ReturnType<typeof useGetSegmentUserDataSuspenseQuery>;
export type GetSegmentUserDataQueryResult = Apollo.QueryResult<GetSegmentUserDataQuery, GetSegmentUserDataQueryVariables>;
export const ClassifyUserDocument = gql`
    mutation ClassifyUser($input: ClassifyUserInput!) {
  classifyUser(input: $input) {
    userId
    classification
    classificationReason
    classificationChangedAt
    classificationChangedBy
  }
}
    `;
export type ClassifyUserMutationFn = Apollo.MutationFunction<ClassifyUserMutation, ClassifyUserMutationVariables>;

/**
 * __useClassifyUserMutation__
 *
 * To run a mutation, you first call `useClassifyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassifyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classifyUserMutation, { data, loading, error }] = useClassifyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClassifyUserMutation(baseOptions?: Apollo.MutationHookOptions<ClassifyUserMutation, ClassifyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClassifyUserMutation, ClassifyUserMutationVariables>(ClassifyUserDocument, options);
      }
export type ClassifyUserMutationHookResult = ReturnType<typeof useClassifyUserMutation>;
export type ClassifyUserMutationResult = Apollo.MutationResult<ClassifyUserMutation>;
export type ClassifyUserMutationOptions = Apollo.BaseMutationOptions<ClassifyUserMutation, ClassifyUserMutationVariables>;
export const GetPersonalisedStoneModeDocument = gql`
    query GetPersonalisedStoneMode($userId: ID!) {
  personalisedStoneMode(userId: $userId) {
    userId
    eligibility {
      hasStone
      planIncludesPersonalised
    }
    mode {
      modeId
      displayName
      description
      detailsVersion
      parameters {
        ...StoneModeParameterValues
      }
      parametersVersion
      limitsVersion
      outsideCurrentLimits
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    history {
      modeId
      version
      parameters {
        ...StoneModeParameterValues
      }
      source
      sourceNote
      limitsVersion
      changedBy
      changedAt
    }
    deviceReport {
      reportedAt
    }
  }
}
    ${StoneModeParameterValuesFragmentDoc}`;

/**
 * __useGetPersonalisedStoneModeQuery__
 *
 * To run a query within a React component, call `useGetPersonalisedStoneModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalisedStoneModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalisedStoneModeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPersonalisedStoneModeQuery(baseOptions: Apollo.QueryHookOptions<GetPersonalisedStoneModeQuery, GetPersonalisedStoneModeQueryVariables> & ({ variables: GetPersonalisedStoneModeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonalisedStoneModeQuery, GetPersonalisedStoneModeQueryVariables>(GetPersonalisedStoneModeDocument, options);
      }
export function useGetPersonalisedStoneModeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalisedStoneModeQuery, GetPersonalisedStoneModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonalisedStoneModeQuery, GetPersonalisedStoneModeQueryVariables>(GetPersonalisedStoneModeDocument, options);
        }
export function useGetPersonalisedStoneModeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonalisedStoneModeQuery, GetPersonalisedStoneModeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonalisedStoneModeQuery, GetPersonalisedStoneModeQueryVariables>(GetPersonalisedStoneModeDocument, options);
        }
export type GetPersonalisedStoneModeQueryHookResult = ReturnType<typeof useGetPersonalisedStoneModeQuery>;
export type GetPersonalisedStoneModeLazyQueryHookResult = ReturnType<typeof useGetPersonalisedStoneModeLazyQuery>;
export type GetPersonalisedStoneModeSuspenseQueryHookResult = ReturnType<typeof useGetPersonalisedStoneModeSuspenseQuery>;
export type GetPersonalisedStoneModeQueryResult = Apollo.QueryResult<GetPersonalisedStoneModeQuery, GetPersonalisedStoneModeQueryVariables>;
export const CreatePersonalisedStoneModeDocument = gql`
    mutation CreatePersonalisedStoneMode($userId: ID!, $input: CreatePersonalisedStoneModeInput!) {
  createPersonalisedStoneMode(userId: $userId, input: $input) {
    id
  }
}
    `;
export type CreatePersonalisedStoneModeMutationFn = Apollo.MutationFunction<CreatePersonalisedStoneModeMutation, CreatePersonalisedStoneModeMutationVariables>;

/**
 * __useCreatePersonalisedStoneModeMutation__
 *
 * To run a mutation, you first call `useCreatePersonalisedStoneModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonalisedStoneModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonalisedStoneModeMutation, { data, loading, error }] = useCreatePersonalisedStoneModeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePersonalisedStoneModeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonalisedStoneModeMutation, CreatePersonalisedStoneModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonalisedStoneModeMutation, CreatePersonalisedStoneModeMutationVariables>(CreatePersonalisedStoneModeDocument, options);
      }
export type CreatePersonalisedStoneModeMutationHookResult = ReturnType<typeof useCreatePersonalisedStoneModeMutation>;
export type CreatePersonalisedStoneModeMutationResult = Apollo.MutationResult<CreatePersonalisedStoneModeMutation>;
export type CreatePersonalisedStoneModeMutationOptions = Apollo.BaseMutationOptions<CreatePersonalisedStoneModeMutation, CreatePersonalisedStoneModeMutationVariables>;
export const UpdatePersonalisedStoneModeDetailsDocument = gql`
    mutation UpdatePersonalisedStoneModeDetails($userId: ID!, $displayName: String!, $description: String, $expectedModeId: ID) {
  updatePersonalisedStoneModeDetails(
    userId: $userId
    displayName: $displayName
    description: $description
    expectedModeId: $expectedModeId
  ) {
    id
  }
}
    `;
export type UpdatePersonalisedStoneModeDetailsMutationFn = Apollo.MutationFunction<UpdatePersonalisedStoneModeDetailsMutation, UpdatePersonalisedStoneModeDetailsMutationVariables>;

/**
 * __useUpdatePersonalisedStoneModeDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalisedStoneModeDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalisedStoneModeDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalisedStoneModeDetailsMutation, { data, loading, error }] = useUpdatePersonalisedStoneModeDetailsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      expectedModeId: // value for 'expectedModeId'
 *   },
 * });
 */
export function useUpdatePersonalisedStoneModeDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalisedStoneModeDetailsMutation, UpdatePersonalisedStoneModeDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalisedStoneModeDetailsMutation, UpdatePersonalisedStoneModeDetailsMutationVariables>(UpdatePersonalisedStoneModeDetailsDocument, options);
      }
export type UpdatePersonalisedStoneModeDetailsMutationHookResult = ReturnType<typeof useUpdatePersonalisedStoneModeDetailsMutation>;
export type UpdatePersonalisedStoneModeDetailsMutationResult = Apollo.MutationResult<UpdatePersonalisedStoneModeDetailsMutation>;
export type UpdatePersonalisedStoneModeDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalisedStoneModeDetailsMutation, UpdatePersonalisedStoneModeDetailsMutationVariables>;
export const SetPersonalisedStoneModeParametersDocument = gql`
    mutation SetPersonalisedStoneModeParameters($userId: ID!, $parameters: StimulationParameterValuesInput!, $sourceNote: String, $expectedModeId: ID) {
  setPersonalisedStoneModeParameters(
    userId: $userId
    parameters: $parameters
    sourceNote: $sourceNote
    expectedModeId: $expectedModeId
  ) {
    id
  }
}
    `;
export type SetPersonalisedStoneModeParametersMutationFn = Apollo.MutationFunction<SetPersonalisedStoneModeParametersMutation, SetPersonalisedStoneModeParametersMutationVariables>;

/**
 * __useSetPersonalisedStoneModeParametersMutation__
 *
 * To run a mutation, you first call `useSetPersonalisedStoneModeParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPersonalisedStoneModeParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPersonalisedStoneModeParametersMutation, { data, loading, error }] = useSetPersonalisedStoneModeParametersMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      parameters: // value for 'parameters'
 *      sourceNote: // value for 'sourceNote'
 *      expectedModeId: // value for 'expectedModeId'
 *   },
 * });
 */
export function useSetPersonalisedStoneModeParametersMutation(baseOptions?: Apollo.MutationHookOptions<SetPersonalisedStoneModeParametersMutation, SetPersonalisedStoneModeParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPersonalisedStoneModeParametersMutation, SetPersonalisedStoneModeParametersMutationVariables>(SetPersonalisedStoneModeParametersDocument, options);
      }
export type SetPersonalisedStoneModeParametersMutationHookResult = ReturnType<typeof useSetPersonalisedStoneModeParametersMutation>;
export type SetPersonalisedStoneModeParametersMutationResult = Apollo.MutationResult<SetPersonalisedStoneModeParametersMutation>;
export type SetPersonalisedStoneModeParametersMutationOptions = Apollo.BaseMutationOptions<SetPersonalisedStoneModeParametersMutation, SetPersonalisedStoneModeParametersMutationVariables>;
export const RemovePersonalisedStoneModeDocument = gql`
    mutation RemovePersonalisedStoneMode($userId: ID!, $expectedModeId: ID) {
  removePersonalisedStoneMode(userId: $userId, expectedModeId: $expectedModeId) {
    id
  }
}
    `;
export type RemovePersonalisedStoneModeMutationFn = Apollo.MutationFunction<RemovePersonalisedStoneModeMutation, RemovePersonalisedStoneModeMutationVariables>;

/**
 * __useRemovePersonalisedStoneModeMutation__
 *
 * To run a mutation, you first call `useRemovePersonalisedStoneModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePersonalisedStoneModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePersonalisedStoneModeMutation, { data, loading, error }] = useRemovePersonalisedStoneModeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      expectedModeId: // value for 'expectedModeId'
 *   },
 * });
 */
export function useRemovePersonalisedStoneModeMutation(baseOptions?: Apollo.MutationHookOptions<RemovePersonalisedStoneModeMutation, RemovePersonalisedStoneModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePersonalisedStoneModeMutation, RemovePersonalisedStoneModeMutationVariables>(RemovePersonalisedStoneModeDocument, options);
      }
export type RemovePersonalisedStoneModeMutationHookResult = ReturnType<typeof useRemovePersonalisedStoneModeMutation>;
export type RemovePersonalisedStoneModeMutationResult = Apollo.MutationResult<RemovePersonalisedStoneModeMutation>;
export type RemovePersonalisedStoneModeMutationOptions = Apollo.BaseMutationOptions<RemovePersonalisedStoneModeMutation, RemovePersonalisedStoneModeMutationVariables>;
export const GetPlannableStoneModesDocument = gql`
    query GetPlannableStoneModes {
  stoneModeCatalogue {
    modes {
      modeId
      displayName
      generation
      enabled
      position
    }
  }
}
    `;

/**
 * __useGetPlannableStoneModesQuery__
 *
 * To run a query within a React component, call `useGetPlannableStoneModesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannableStoneModesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannableStoneModesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlannableStoneModesQuery(baseOptions?: Apollo.QueryHookOptions<GetPlannableStoneModesQuery, GetPlannableStoneModesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannableStoneModesQuery, GetPlannableStoneModesQueryVariables>(GetPlannableStoneModesDocument, options);
      }
export function useGetPlannableStoneModesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannableStoneModesQuery, GetPlannableStoneModesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannableStoneModesQuery, GetPlannableStoneModesQueryVariables>(GetPlannableStoneModesDocument, options);
        }
export function useGetPlannableStoneModesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlannableStoneModesQuery, GetPlannableStoneModesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlannableStoneModesQuery, GetPlannableStoneModesQueryVariables>(GetPlannableStoneModesDocument, options);
        }
export type GetPlannableStoneModesQueryHookResult = ReturnType<typeof useGetPlannableStoneModesQuery>;
export type GetPlannableStoneModesLazyQueryHookResult = ReturnType<typeof useGetPlannableStoneModesLazyQuery>;
export type GetPlannableStoneModesSuspenseQueryHookResult = ReturnType<typeof useGetPlannableStoneModesSuspenseQuery>;
export type GetPlannableStoneModesQueryResult = Apollo.QueryResult<GetPlannableStoneModesQuery, GetPlannableStoneModesQueryVariables>;
export const GetStoneModeCatalogueDocument = gql`
    query GetStoneModeCatalogue {
  stoneModeCatalogue {
    modes {
      modeId
      displayName
      description
      generation
      enabled
      position
      detailsVersion
      parameters {
        ...StoneModeParameterValues
      }
      parametersVersion
      outsideCurrentLimits
      updatedBy
      updatedAt
    }
    limits {
      ...StoneModeLimitsValues
    }
    defaultMode {
      version
      modeId
      usable
      reason
      setBy
      setAt
    }
  }
}
    ${StoneModeParameterValuesFragmentDoc}
${StoneModeLimitsValuesFragmentDoc}`;

/**
 * __useGetStoneModeCatalogueQuery__
 *
 * To run a query within a React component, call `useGetStoneModeCatalogueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoneModeCatalogueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoneModeCatalogueQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoneModeCatalogueQuery(baseOptions?: Apollo.QueryHookOptions<GetStoneModeCatalogueQuery, GetStoneModeCatalogueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoneModeCatalogueQuery, GetStoneModeCatalogueQueryVariables>(GetStoneModeCatalogueDocument, options);
      }
export function useGetStoneModeCatalogueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoneModeCatalogueQuery, GetStoneModeCatalogueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoneModeCatalogueQuery, GetStoneModeCatalogueQueryVariables>(GetStoneModeCatalogueDocument, options);
        }
export function useGetStoneModeCatalogueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoneModeCatalogueQuery, GetStoneModeCatalogueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoneModeCatalogueQuery, GetStoneModeCatalogueQueryVariables>(GetStoneModeCatalogueDocument, options);
        }
export type GetStoneModeCatalogueQueryHookResult = ReturnType<typeof useGetStoneModeCatalogueQuery>;
export type GetStoneModeCatalogueLazyQueryHookResult = ReturnType<typeof useGetStoneModeCatalogueLazyQuery>;
export type GetStoneModeCatalogueSuspenseQueryHookResult = ReturnType<typeof useGetStoneModeCatalogueSuspenseQuery>;
export type GetStoneModeCatalogueQueryResult = Apollo.QueryResult<GetStoneModeCatalogueQuery, GetStoneModeCatalogueQueryVariables>;
export const GetStoneModeLimitsHistoryDocument = gql`
    query GetStoneModeLimitsHistory {
  stoneModeLimitsHistory {
    ...StoneModeLimitsValues
  }
}
    ${StoneModeLimitsValuesFragmentDoc}`;

/**
 * __useGetStoneModeLimitsHistoryQuery__
 *
 * To run a query within a React component, call `useGetStoneModeLimitsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoneModeLimitsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoneModeLimitsHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoneModeLimitsHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetStoneModeLimitsHistoryQuery, GetStoneModeLimitsHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoneModeLimitsHistoryQuery, GetStoneModeLimitsHistoryQueryVariables>(GetStoneModeLimitsHistoryDocument, options);
      }
export function useGetStoneModeLimitsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoneModeLimitsHistoryQuery, GetStoneModeLimitsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoneModeLimitsHistoryQuery, GetStoneModeLimitsHistoryQueryVariables>(GetStoneModeLimitsHistoryDocument, options);
        }
export function useGetStoneModeLimitsHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoneModeLimitsHistoryQuery, GetStoneModeLimitsHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoneModeLimitsHistoryQuery, GetStoneModeLimitsHistoryQueryVariables>(GetStoneModeLimitsHistoryDocument, options);
        }
export type GetStoneModeLimitsHistoryQueryHookResult = ReturnType<typeof useGetStoneModeLimitsHistoryQuery>;
export type GetStoneModeLimitsHistoryLazyQueryHookResult = ReturnType<typeof useGetStoneModeLimitsHistoryLazyQuery>;
export type GetStoneModeLimitsHistorySuspenseQueryHookResult = ReturnType<typeof useGetStoneModeLimitsHistorySuspenseQuery>;
export type GetStoneModeLimitsHistoryQueryResult = Apollo.QueryResult<GetStoneModeLimitsHistoryQuery, GetStoneModeLimitsHistoryQueryVariables>;
export const GetStoneModeDefaultHistoryDocument = gql`
    query GetStoneModeDefaultHistory {
  stoneModeDefaultHistory {
    version
    modeId
    setBy
    setAt
  }
}
    `;

/**
 * __useGetStoneModeDefaultHistoryQuery__
 *
 * To run a query within a React component, call `useGetStoneModeDefaultHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoneModeDefaultHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoneModeDefaultHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoneModeDefaultHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetStoneModeDefaultHistoryQuery, GetStoneModeDefaultHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoneModeDefaultHistoryQuery, GetStoneModeDefaultHistoryQueryVariables>(GetStoneModeDefaultHistoryDocument, options);
      }
export function useGetStoneModeDefaultHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoneModeDefaultHistoryQuery, GetStoneModeDefaultHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoneModeDefaultHistoryQuery, GetStoneModeDefaultHistoryQueryVariables>(GetStoneModeDefaultHistoryDocument, options);
        }
export function useGetStoneModeDefaultHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoneModeDefaultHistoryQuery, GetStoneModeDefaultHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoneModeDefaultHistoryQuery, GetStoneModeDefaultHistoryQueryVariables>(GetStoneModeDefaultHistoryDocument, options);
        }
export type GetStoneModeDefaultHistoryQueryHookResult = ReturnType<typeof useGetStoneModeDefaultHistoryQuery>;
export type GetStoneModeDefaultHistoryLazyQueryHookResult = ReturnType<typeof useGetStoneModeDefaultHistoryLazyQuery>;
export type GetStoneModeDefaultHistorySuspenseQueryHookResult = ReturnType<typeof useGetStoneModeDefaultHistorySuspenseQuery>;
export type GetStoneModeDefaultHistoryQueryResult = Apollo.QueryResult<GetStoneModeDefaultHistoryQuery, GetStoneModeDefaultHistoryQueryVariables>;
export const GetStoneModeParameterHistoryDocument = gql`
    query GetStoneModeParameterHistory($modeId: ID!) {
  stoneModeParameterHistory(modeId: $modeId) {
    version
    parameters {
      ...StoneModeParameterValues
    }
    source
    sourceNote
    limitsVersion
    changedBy
    changedAt
  }
}
    ${StoneModeParameterValuesFragmentDoc}`;

/**
 * __useGetStoneModeParameterHistoryQuery__
 *
 * To run a query within a React component, call `useGetStoneModeParameterHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoneModeParameterHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoneModeParameterHistoryQuery({
 *   variables: {
 *      modeId: // value for 'modeId'
 *   },
 * });
 */
export function useGetStoneModeParameterHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetStoneModeParameterHistoryQuery, GetStoneModeParameterHistoryQueryVariables> & ({ variables: GetStoneModeParameterHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoneModeParameterHistoryQuery, GetStoneModeParameterHistoryQueryVariables>(GetStoneModeParameterHistoryDocument, options);
      }
export function useGetStoneModeParameterHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoneModeParameterHistoryQuery, GetStoneModeParameterHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoneModeParameterHistoryQuery, GetStoneModeParameterHistoryQueryVariables>(GetStoneModeParameterHistoryDocument, options);
        }
export function useGetStoneModeParameterHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoneModeParameterHistoryQuery, GetStoneModeParameterHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoneModeParameterHistoryQuery, GetStoneModeParameterHistoryQueryVariables>(GetStoneModeParameterHistoryDocument, options);
        }
export type GetStoneModeParameterHistoryQueryHookResult = ReturnType<typeof useGetStoneModeParameterHistoryQuery>;
export type GetStoneModeParameterHistoryLazyQueryHookResult = ReturnType<typeof useGetStoneModeParameterHistoryLazyQuery>;
export type GetStoneModeParameterHistorySuspenseQueryHookResult = ReturnType<typeof useGetStoneModeParameterHistorySuspenseQuery>;
export type GetStoneModeParameterHistoryQueryResult = Apollo.QueryResult<GetStoneModeParameterHistoryQuery, GetStoneModeParameterHistoryQueryVariables>;
export const CreateStoneModeDocument = gql`
    mutation CreateStoneMode($input: CreateStoneModeInput!) {
  createStoneMode(input: $input) {
    id
  }
}
    `;
export type CreateStoneModeMutationFn = Apollo.MutationFunction<CreateStoneModeMutation, CreateStoneModeMutationVariables>;

/**
 * __useCreateStoneModeMutation__
 *
 * To run a mutation, you first call `useCreateStoneModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoneModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoneModeMutation, { data, loading, error }] = useCreateStoneModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStoneModeMutation(baseOptions?: Apollo.MutationHookOptions<CreateStoneModeMutation, CreateStoneModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStoneModeMutation, CreateStoneModeMutationVariables>(CreateStoneModeDocument, options);
      }
export type CreateStoneModeMutationHookResult = ReturnType<typeof useCreateStoneModeMutation>;
export type CreateStoneModeMutationResult = Apollo.MutationResult<CreateStoneModeMutation>;
export type CreateStoneModeMutationOptions = Apollo.BaseMutationOptions<CreateStoneModeMutation, CreateStoneModeMutationVariables>;
export const UpdateStoneModeDetailsDocument = gql`
    mutation UpdateStoneModeDetails($input: UpdateStoneModeDetailsInput!) {
  updateStoneModeDetails(input: $input) {
    id
  }
}
    `;
export type UpdateStoneModeDetailsMutationFn = Apollo.MutationFunction<UpdateStoneModeDetailsMutation, UpdateStoneModeDetailsMutationVariables>;

/**
 * __useUpdateStoneModeDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateStoneModeDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoneModeDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoneModeDetailsMutation, { data, loading, error }] = useUpdateStoneModeDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStoneModeDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStoneModeDetailsMutation, UpdateStoneModeDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStoneModeDetailsMutation, UpdateStoneModeDetailsMutationVariables>(UpdateStoneModeDetailsDocument, options);
      }
export type UpdateStoneModeDetailsMutationHookResult = ReturnType<typeof useUpdateStoneModeDetailsMutation>;
export type UpdateStoneModeDetailsMutationResult = Apollo.MutationResult<UpdateStoneModeDetailsMutation>;
export type UpdateStoneModeDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateStoneModeDetailsMutation, UpdateStoneModeDetailsMutationVariables>;
export const EnableStoneModeDocument = gql`
    mutation EnableStoneMode($modeId: ID!) {
  enableStoneMode(modeId: $modeId) {
    id
  }
}
    `;
export type EnableStoneModeMutationFn = Apollo.MutationFunction<EnableStoneModeMutation, EnableStoneModeMutationVariables>;

/**
 * __useEnableStoneModeMutation__
 *
 * To run a mutation, you first call `useEnableStoneModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableStoneModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableStoneModeMutation, { data, loading, error }] = useEnableStoneModeMutation({
 *   variables: {
 *      modeId: // value for 'modeId'
 *   },
 * });
 */
export function useEnableStoneModeMutation(baseOptions?: Apollo.MutationHookOptions<EnableStoneModeMutation, EnableStoneModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableStoneModeMutation, EnableStoneModeMutationVariables>(EnableStoneModeDocument, options);
      }
export type EnableStoneModeMutationHookResult = ReturnType<typeof useEnableStoneModeMutation>;
export type EnableStoneModeMutationResult = Apollo.MutationResult<EnableStoneModeMutation>;
export type EnableStoneModeMutationOptions = Apollo.BaseMutationOptions<EnableStoneModeMutation, EnableStoneModeMutationVariables>;
export const DisableStoneModeDocument = gql`
    mutation DisableStoneMode($modeId: ID!) {
  disableStoneMode(modeId: $modeId) {
    id
  }
}
    `;
export type DisableStoneModeMutationFn = Apollo.MutationFunction<DisableStoneModeMutation, DisableStoneModeMutationVariables>;

/**
 * __useDisableStoneModeMutation__
 *
 * To run a mutation, you first call `useDisableStoneModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableStoneModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableStoneModeMutation, { data, loading, error }] = useDisableStoneModeMutation({
 *   variables: {
 *      modeId: // value for 'modeId'
 *   },
 * });
 */
export function useDisableStoneModeMutation(baseOptions?: Apollo.MutationHookOptions<DisableStoneModeMutation, DisableStoneModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableStoneModeMutation, DisableStoneModeMutationVariables>(DisableStoneModeDocument, options);
      }
export type DisableStoneModeMutationHookResult = ReturnType<typeof useDisableStoneModeMutation>;
export type DisableStoneModeMutationResult = Apollo.MutationResult<DisableStoneModeMutation>;
export type DisableStoneModeMutationOptions = Apollo.BaseMutationOptions<DisableStoneModeMutation, DisableStoneModeMutationVariables>;
export const MoveStoneModeDocument = gql`
    mutation MoveStoneMode($modeId: ID!, $position: Int!) {
  moveStoneMode(modeId: $modeId, position: $position) {
    id
  }
}
    `;
export type MoveStoneModeMutationFn = Apollo.MutationFunction<MoveStoneModeMutation, MoveStoneModeMutationVariables>;

/**
 * __useMoveStoneModeMutation__
 *
 * To run a mutation, you first call `useMoveStoneModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveStoneModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveStoneModeMutation, { data, loading, error }] = useMoveStoneModeMutation({
 *   variables: {
 *      modeId: // value for 'modeId'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useMoveStoneModeMutation(baseOptions?: Apollo.MutationHookOptions<MoveStoneModeMutation, MoveStoneModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveStoneModeMutation, MoveStoneModeMutationVariables>(MoveStoneModeDocument, options);
      }
export type MoveStoneModeMutationHookResult = ReturnType<typeof useMoveStoneModeMutation>;
export type MoveStoneModeMutationResult = Apollo.MutationResult<MoveStoneModeMutation>;
export type MoveStoneModeMutationOptions = Apollo.BaseMutationOptions<MoveStoneModeMutation, MoveStoneModeMutationVariables>;
export const SetStoneModeLimitsDocument = gql`
    mutation SetStoneModeLimits($input: SetStoneModeLimitsInput!) {
  setStoneModeLimits(input: $input) {
    id
  }
}
    `;
export type SetStoneModeLimitsMutationFn = Apollo.MutationFunction<SetStoneModeLimitsMutation, SetStoneModeLimitsMutationVariables>;

/**
 * __useSetStoneModeLimitsMutation__
 *
 * To run a mutation, you first call `useSetStoneModeLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStoneModeLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStoneModeLimitsMutation, { data, loading, error }] = useSetStoneModeLimitsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetStoneModeLimitsMutation(baseOptions?: Apollo.MutationHookOptions<SetStoneModeLimitsMutation, SetStoneModeLimitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStoneModeLimitsMutation, SetStoneModeLimitsMutationVariables>(SetStoneModeLimitsDocument, options);
      }
export type SetStoneModeLimitsMutationHookResult = ReturnType<typeof useSetStoneModeLimitsMutation>;
export type SetStoneModeLimitsMutationResult = Apollo.MutationResult<SetStoneModeLimitsMutation>;
export type SetStoneModeLimitsMutationOptions = Apollo.BaseMutationOptions<SetStoneModeLimitsMutation, SetStoneModeLimitsMutationVariables>;
export const SetDefaultStoneModeDocument = gql`
    mutation SetDefaultStoneMode($modeId: ID!) {
  setDefaultStoneMode(modeId: $modeId) {
    id
  }
}
    `;
export type SetDefaultStoneModeMutationFn = Apollo.MutationFunction<SetDefaultStoneModeMutation, SetDefaultStoneModeMutationVariables>;

/**
 * __useSetDefaultStoneModeMutation__
 *
 * To run a mutation, you first call `useSetDefaultStoneModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultStoneModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultStoneModeMutation, { data, loading, error }] = useSetDefaultStoneModeMutation({
 *   variables: {
 *      modeId: // value for 'modeId'
 *   },
 * });
 */
export function useSetDefaultStoneModeMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultStoneModeMutation, SetDefaultStoneModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultStoneModeMutation, SetDefaultStoneModeMutationVariables>(SetDefaultStoneModeDocument, options);
      }
export type SetDefaultStoneModeMutationHookResult = ReturnType<typeof useSetDefaultStoneModeMutation>;
export type SetDefaultStoneModeMutationResult = Apollo.MutationResult<SetDefaultStoneModeMutation>;
export type SetDefaultStoneModeMutationOptions = Apollo.BaseMutationOptions<SetDefaultStoneModeMutation, SetDefaultStoneModeMutationVariables>;
export const SetStoneModeParametersDocument = gql`
    mutation SetStoneModeParameters($input: SetStoneModeParametersInput!) {
  setStoneModeParameters(input: $input) {
    id
  }
}
    `;
export type SetStoneModeParametersMutationFn = Apollo.MutationFunction<SetStoneModeParametersMutation, SetStoneModeParametersMutationVariables>;

/**
 * __useSetStoneModeParametersMutation__
 *
 * To run a mutation, you first call `useSetStoneModeParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStoneModeParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStoneModeParametersMutation, { data, loading, error }] = useSetStoneModeParametersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetStoneModeParametersMutation(baseOptions?: Apollo.MutationHookOptions<SetStoneModeParametersMutation, SetStoneModeParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStoneModeParametersMutation, SetStoneModeParametersMutationVariables>(SetStoneModeParametersDocument, options);
      }
export type SetStoneModeParametersMutationHookResult = ReturnType<typeof useSetStoneModeParametersMutation>;
export type SetStoneModeParametersMutationResult = Apollo.MutationResult<SetStoneModeParametersMutation>;
export type SetStoneModeParametersMutationOptions = Apollo.BaseMutationOptions<SetStoneModeParametersMutation, SetStoneModeParametersMutationVariables>;
export const ImportStoneModeParametersDocument = gql`
    mutation ImportStoneModeParameters($modeId: ID!, $vendorEntryJson: String!, $sourceNote: String) {
  importStoneModeParameters(
    modeId: $modeId
    vendorEntryJson: $vendorEntryJson
    sourceNote: $sourceNote
  ) {
    id
  }
}
    `;
export type ImportStoneModeParametersMutationFn = Apollo.MutationFunction<ImportStoneModeParametersMutation, ImportStoneModeParametersMutationVariables>;

/**
 * __useImportStoneModeParametersMutation__
 *
 * To run a mutation, you first call `useImportStoneModeParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoneModeParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoneModeParametersMutation, { data, loading, error }] = useImportStoneModeParametersMutation({
 *   variables: {
 *      modeId: // value for 'modeId'
 *      vendorEntryJson: // value for 'vendorEntryJson'
 *      sourceNote: // value for 'sourceNote'
 *   },
 * });
 */
export function useImportStoneModeParametersMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoneModeParametersMutation, ImportStoneModeParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoneModeParametersMutation, ImportStoneModeParametersMutationVariables>(ImportStoneModeParametersDocument, options);
      }
export type ImportStoneModeParametersMutationHookResult = ReturnType<typeof useImportStoneModeParametersMutation>;
export type ImportStoneModeParametersMutationResult = Apollo.MutationResult<ImportStoneModeParametersMutation>;
export type ImportStoneModeParametersMutationOptions = Apollo.BaseMutationOptions<ImportStoneModeParametersMutation, ImportStoneModeParametersMutationVariables>;
export const GetWaitlistDemandDocument = gql`
    query GetWaitlistDemand {
  waitlistDemand {
    country
    count
  }
}
    `;

/**
 * __useGetWaitlistDemandQuery__
 *
 * To run a query within a React component, call `useGetWaitlistDemandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitlistDemandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitlistDemandQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWaitlistDemandQuery(baseOptions?: Apollo.QueryHookOptions<GetWaitlistDemandQuery, GetWaitlistDemandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaitlistDemandQuery, GetWaitlistDemandQueryVariables>(GetWaitlistDemandDocument, options);
      }
export function useGetWaitlistDemandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaitlistDemandQuery, GetWaitlistDemandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaitlistDemandQuery, GetWaitlistDemandQueryVariables>(GetWaitlistDemandDocument, options);
        }
export function useGetWaitlistDemandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWaitlistDemandQuery, GetWaitlistDemandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWaitlistDemandQuery, GetWaitlistDemandQueryVariables>(GetWaitlistDemandDocument, options);
        }
export type GetWaitlistDemandQueryHookResult = ReturnType<typeof useGetWaitlistDemandQuery>;
export type GetWaitlistDemandLazyQueryHookResult = ReturnType<typeof useGetWaitlistDemandLazyQuery>;
export type GetWaitlistDemandSuspenseQueryHookResult = ReturnType<typeof useGetWaitlistDemandSuspenseQuery>;
export type GetWaitlistDemandQueryResult = Apollo.QueryResult<GetWaitlistDemandQuery, GetWaitlistDemandQueryVariables>;
export const GetWaitlistSignalsDocument = gql`
    query GetWaitlistSignals($country: String!) {
  waitlistSignals(country: $country) {
    email
    country
    signalType
    consent
    source
    createdAt
  }
}
    `;

/**
 * __useGetWaitlistSignalsQuery__
 *
 * To run a query within a React component, call `useGetWaitlistSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitlistSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitlistSignalsQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetWaitlistSignalsQuery(baseOptions: Apollo.QueryHookOptions<GetWaitlistSignalsQuery, GetWaitlistSignalsQueryVariables> & ({ variables: GetWaitlistSignalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaitlistSignalsQuery, GetWaitlistSignalsQueryVariables>(GetWaitlistSignalsDocument, options);
      }
export function useGetWaitlistSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaitlistSignalsQuery, GetWaitlistSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaitlistSignalsQuery, GetWaitlistSignalsQueryVariables>(GetWaitlistSignalsDocument, options);
        }
export function useGetWaitlistSignalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWaitlistSignalsQuery, GetWaitlistSignalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWaitlistSignalsQuery, GetWaitlistSignalsQueryVariables>(GetWaitlistSignalsDocument, options);
        }
export type GetWaitlistSignalsQueryHookResult = ReturnType<typeof useGetWaitlistSignalsQuery>;
export type GetWaitlistSignalsLazyQueryHookResult = ReturnType<typeof useGetWaitlistSignalsLazyQuery>;
export type GetWaitlistSignalsSuspenseQueryHookResult = ReturnType<typeof useGetWaitlistSignalsSuspenseQuery>;
export type GetWaitlistSignalsQueryResult = Apollo.QueryResult<GetWaitlistSignalsQuery, GetWaitlistSignalsQueryVariables>;
export const EraseWaitlistSignalDocument = gql`
    mutation EraseWaitlistSignal($email: String!) {
  eraseWaitlistSignal(email: $email) {
    email
    erasedCount
  }
}
    `;
export type EraseWaitlistSignalMutationFn = Apollo.MutationFunction<EraseWaitlistSignalMutation, EraseWaitlistSignalMutationVariables>;

/**
 * __useEraseWaitlistSignalMutation__
 *
 * To run a mutation, you first call `useEraseWaitlistSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEraseWaitlistSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eraseWaitlistSignalMutation, { data, loading, error }] = useEraseWaitlistSignalMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEraseWaitlistSignalMutation(baseOptions?: Apollo.MutationHookOptions<EraseWaitlistSignalMutation, EraseWaitlistSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EraseWaitlistSignalMutation, EraseWaitlistSignalMutationVariables>(EraseWaitlistSignalDocument, options);
      }
export type EraseWaitlistSignalMutationHookResult = ReturnType<typeof useEraseWaitlistSignalMutation>;
export type EraseWaitlistSignalMutationResult = Apollo.MutationResult<EraseWaitlistSignalMutation>;
export type EraseWaitlistSignalMutationOptions = Apollo.BaseMutationOptions<EraseWaitlistSignalMutation, EraseWaitlistSignalMutationVariables>;
export const ExportWaitlistSignalsDocument = gql`
    mutation ExportWaitlistSignals($input: WaitlistExportInput!) {
  exportWaitlistSignals(input: $input) {
    granted
    country
    recordCount
    csv
  }
}
    `;
export type ExportWaitlistSignalsMutationFn = Apollo.MutationFunction<ExportWaitlistSignalsMutation, ExportWaitlistSignalsMutationVariables>;

/**
 * __useExportWaitlistSignalsMutation__
 *
 * To run a mutation, you first call `useExportWaitlistSignalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportWaitlistSignalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportWaitlistSignalsMutation, { data, loading, error }] = useExportWaitlistSignalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportWaitlistSignalsMutation(baseOptions?: Apollo.MutationHookOptions<ExportWaitlistSignalsMutation, ExportWaitlistSignalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportWaitlistSignalsMutation, ExportWaitlistSignalsMutationVariables>(ExportWaitlistSignalsDocument, options);
      }
export type ExportWaitlistSignalsMutationHookResult = ReturnType<typeof useExportWaitlistSignalsMutation>;
export type ExportWaitlistSignalsMutationResult = Apollo.MutationResult<ExportWaitlistSignalsMutation>;
export type ExportWaitlistSignalsMutationOptions = Apollo.BaseMutationOptions<ExportWaitlistSignalsMutation, ExportWaitlistSignalsMutationVariables>;
export const GetCurrentUserRolesDocument = gql`
    query GetCurrentUserRoles {
  currentUser {
    accountId
    roles
    email
    status
  }
}
    `;

/**
 * __useGetCurrentUserRolesQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>(GetCurrentUserRolesDocument, options);
      }
export function useGetCurrentUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>(GetCurrentUserRolesDocument, options);
        }
export function useGetCurrentUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>(GetCurrentUserRolesDocument, options);
        }
export type GetCurrentUserRolesQueryHookResult = ReturnType<typeof useGetCurrentUserRolesQuery>;
export type GetCurrentUserRolesLazyQueryHookResult = ReturnType<typeof useGetCurrentUserRolesLazyQuery>;
export type GetCurrentUserRolesSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserRolesSuspenseQuery>;
export type GetCurrentUserRolesQueryResult = Apollo.QueryResult<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>;
export const GetParticipantsDocument = gql`
    query GetParticipants($filter: ParticipantFilter) {
  participants(filter: $filter) {
    participantId
    timezone
    createdAt
    updatedAt
    status
    membership {
      membershipId
      userId
      subscriptionStatus
      stripeCustomerId
      customerEmail
      customerName
      checkoutSessionId
      status
      linkingMethod
      createdAt
      linkedAt
      paymentIntentId
      paymentAmount
      paymentDate
      stripeSubscriptionId
      subscriptionStartDate
      nextBillingDate
    }
    usageStats {
      lastActive
    }
    pii {
      identityInformation {
        firstName
        middleName
        lastName
        dateOfBirth
        gender
      }
      contactInformation {
        email
        phoneNumber {
          nationalNumber
          countryCode
        }
      }
    }
    learningJourneys {
      learningJourneyId
      name
    }
    onboardingStatus
    timezone
  }
}
    `;

/**
 * __useGetParticipantsQuery__
 *
 * To run a query within a React component, call `useGetParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetParticipantsQuery(baseOptions?: Apollo.QueryHookOptions<GetParticipantsQuery, GetParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsQuery, GetParticipantsQueryVariables>(GetParticipantsDocument, options);
      }
export function useGetParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsQuery, GetParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsQuery, GetParticipantsQueryVariables>(GetParticipantsDocument, options);
        }
export function useGetParticipantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantsQuery, GetParticipantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantsQuery, GetParticipantsQueryVariables>(GetParticipantsDocument, options);
        }
export type GetParticipantsQueryHookResult = ReturnType<typeof useGetParticipantsQuery>;
export type GetParticipantsLazyQueryHookResult = ReturnType<typeof useGetParticipantsLazyQuery>;
export type GetParticipantsSuspenseQueryHookResult = ReturnType<typeof useGetParticipantsSuspenseQuery>;
export type GetParticipantsQueryResult = Apollo.QueryResult<GetParticipantsQuery, GetParticipantsQueryVariables>;
export const GetParticipantsMinimalDocument = gql`
    query GetParticipantsMinimal($filter: ParticipantFilter) {
  participants(filter: $filter) {
    participantId
    timezone
    pii {
      identityInformation {
        firstName
        lastName
      }
      contactInformation {
        email
      }
    }
  }
}
    `;

/**
 * __useGetParticipantsMinimalQuery__
 *
 * To run a query within a React component, call `useGetParticipantsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsMinimalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetParticipantsMinimalQuery(baseOptions?: Apollo.QueryHookOptions<GetParticipantsMinimalQuery, GetParticipantsMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsMinimalQuery, GetParticipantsMinimalQueryVariables>(GetParticipantsMinimalDocument, options);
      }
export function useGetParticipantsMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsMinimalQuery, GetParticipantsMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsMinimalQuery, GetParticipantsMinimalQueryVariables>(GetParticipantsMinimalDocument, options);
        }
export function useGetParticipantsMinimalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantsMinimalQuery, GetParticipantsMinimalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantsMinimalQuery, GetParticipantsMinimalQueryVariables>(GetParticipantsMinimalDocument, options);
        }
export type GetParticipantsMinimalQueryHookResult = ReturnType<typeof useGetParticipantsMinimalQuery>;
export type GetParticipantsMinimalLazyQueryHookResult = ReturnType<typeof useGetParticipantsMinimalLazyQuery>;
export type GetParticipantsMinimalSuspenseQueryHookResult = ReturnType<typeof useGetParticipantsMinimalSuspenseQuery>;
export type GetParticipantsMinimalQueryResult = Apollo.QueryResult<GetParticipantsMinimalQuery, GetParticipantsMinimalQueryVariables>;
export const GetParticipantDocument = gql`
    query GetParticipant($participantId: ID!) {
  participant(participantId: $participantId) {
    participantId
    timezone
    createdAt
    updatedAt
    status
    membership {
      membershipId
      userId
      subscriptionStatus
      stripeCustomerId
      customerEmail
      customerName
      checkoutSessionId
      status
      linkingMethod
      createdAt
      linkedAt
      paymentIntentId
      paymentAmount
      paymentDate
      stripeSubscriptionId
      subscriptionStartDate
      nextBillingDate
    }
    usageStats {
      lastActive
    }
    pii {
      identityInformation {
        firstName
        middleName
        lastName
        dateOfBirth
        gender
      }
      contactInformation {
        email
        phoneNumber {
          nationalNumber
          countryCode
        }
      }
    }
    linkedCustomer {
      customerId
      firstConsultDate
    }
    wearableIntegrations {
      ...WearableIntegrationFields
    }
    careChat {
      paused
      pausedReason
    }
  }
}
    ${WearableIntegrationFieldsFragmentDoc}`;

/**
 * __useGetParticipantQuery__
 *
 * To run a query within a React component, call `useGetParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables> & ({ variables: GetParticipantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
      }
export function useGetParticipantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
        }
export function useGetParticipantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
        }
export type GetParticipantQueryHookResult = ReturnType<typeof useGetParticipantQuery>;
export type GetParticipantLazyQueryHookResult = ReturnType<typeof useGetParticipantLazyQuery>;
export type GetParticipantSuspenseQueryHookResult = ReturnType<typeof useGetParticipantSuspenseQuery>;
export type GetParticipantQueryResult = Apollo.QueryResult<GetParticipantQuery, GetParticipantQueryVariables>;
export const SuspendUserDocument = gql`
    mutation SuspendUser($participantId: ID!, $reason: String!) {
  suspendUser(participantId: $participantId, reason: $reason) {
    id
  }
}
    `;
export type SuspendUserMutationFn = Apollo.MutationFunction<SuspendUserMutation, SuspendUserMutationVariables>;

/**
 * __useSuspendUserMutation__
 *
 * To run a mutation, you first call `useSuspendUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendUserMutation, { data, loading, error }] = useSuspendUserMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useSuspendUserMutation(baseOptions?: Apollo.MutationHookOptions<SuspendUserMutation, SuspendUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendUserMutation, SuspendUserMutationVariables>(SuspendUserDocument, options);
      }
export type SuspendUserMutationHookResult = ReturnType<typeof useSuspendUserMutation>;
export type SuspendUserMutationResult = Apollo.MutationResult<SuspendUserMutation>;
export type SuspendUserMutationOptions = Apollo.BaseMutationOptions<SuspendUserMutation, SuspendUserMutationVariables>;
export const AssignRolesDocument = gql`
    mutation AssignRoles($input: AssignRolesInput!) {
  assignRoles(input: $input) {
    id
  }
}
    `;
export type AssignRolesMutationFn = Apollo.MutationFunction<AssignRolesMutation, AssignRolesMutationVariables>;

/**
 * __useAssignRolesMutation__
 *
 * To run a mutation, you first call `useAssignRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRolesMutation, { data, loading, error }] = useAssignRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRolesMutation(baseOptions?: Apollo.MutationHookOptions<AssignRolesMutation, AssignRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRolesMutation, AssignRolesMutationVariables>(AssignRolesDocument, options);
      }
export type AssignRolesMutationHookResult = ReturnType<typeof useAssignRolesMutation>;
export type AssignRolesMutationResult = Apollo.MutationResult<AssignRolesMutation>;
export type AssignRolesMutationOptions = Apollo.BaseMutationOptions<AssignRolesMutation, AssignRolesMutationVariables>;
export const CreateStaffUserDocument = gql`
    mutation CreateStaffUser($input: CreateStaffUserInput!) {
  createStaffUser(input: $input) {
    id
  }
}
    `;
export type CreateStaffUserMutationFn = Apollo.MutationFunction<CreateStaffUserMutation, CreateStaffUserMutationVariables>;

/**
 * __useCreateStaffUserMutation__
 *
 * To run a mutation, you first call `useCreateStaffUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaffUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaffUserMutation, { data, loading, error }] = useCreateStaffUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStaffUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateStaffUserMutation, CreateStaffUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStaffUserMutation, CreateStaffUserMutationVariables>(CreateStaffUserDocument, options);
      }
export type CreateStaffUserMutationHookResult = ReturnType<typeof useCreateStaffUserMutation>;
export type CreateStaffUserMutationResult = Apollo.MutationResult<CreateStaffUserMutation>;
export type CreateStaffUserMutationOptions = Apollo.BaseMutationOptions<CreateStaffUserMutation, CreateStaffUserMutationVariables>;
export const GetInternalUsersDocument = gql`
    query GetInternalUsers {
  internalUsers {
    nurseId
    accountId
    timezone
    roles
    status
    pii {
      identityInformation {
        firstName
        middleName
        lastName
      }
      contactInformation {
        email
      }
    }
  }
}
    `;

/**
 * __useGetInternalUsersQuery__
 *
 * To run a query within a React component, call `useGetInternalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternalUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInternalUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetInternalUsersQuery, GetInternalUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternalUsersQuery, GetInternalUsersQueryVariables>(GetInternalUsersDocument, options);
      }
export function useGetInternalUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternalUsersQuery, GetInternalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternalUsersQuery, GetInternalUsersQueryVariables>(GetInternalUsersDocument, options);
        }
export function useGetInternalUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInternalUsersQuery, GetInternalUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInternalUsersQuery, GetInternalUsersQueryVariables>(GetInternalUsersDocument, options);
        }
export type GetInternalUsersQueryHookResult = ReturnType<typeof useGetInternalUsersQuery>;
export type GetInternalUsersLazyQueryHookResult = ReturnType<typeof useGetInternalUsersLazyQuery>;
export type GetInternalUsersSuspenseQueryHookResult = ReturnType<typeof useGetInternalUsersSuspenseQuery>;
export type GetInternalUsersQueryResult = Apollo.QueryResult<GetInternalUsersQuery, GetInternalUsersQueryVariables>;
export const GetMemberTodayDocument = gql`
    query GetMemberToday($participantId: ID!) {
  participantTodaySessions(participantId: $participantId) {
    date
    timezone
    dayEnd
  }
}
    `;

/**
 * __useGetMemberTodayQuery__
 *
 * To run a query within a React component, call `useGetMemberTodayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberTodayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberTodayQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetMemberTodayQuery(baseOptions: Apollo.QueryHookOptions<GetMemberTodayQuery, GetMemberTodayQueryVariables> & ({ variables: GetMemberTodayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberTodayQuery, GetMemberTodayQueryVariables>(GetMemberTodayDocument, options);
      }
export function useGetMemberTodayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberTodayQuery, GetMemberTodayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberTodayQuery, GetMemberTodayQueryVariables>(GetMemberTodayDocument, options);
        }
export function useGetMemberTodaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMemberTodayQuery, GetMemberTodayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberTodayQuery, GetMemberTodayQueryVariables>(GetMemberTodayDocument, options);
        }
export type GetMemberTodayQueryHookResult = ReturnType<typeof useGetMemberTodayQuery>;
export type GetMemberTodayLazyQueryHookResult = ReturnType<typeof useGetMemberTodayLazyQuery>;
export type GetMemberTodaySuspenseQueryHookResult = ReturnType<typeof useGetMemberTodaySuspenseQuery>;
export type GetMemberTodayQueryResult = Apollo.QueryResult<GetMemberTodayQuery, GetMemberTodayQueryVariables>;
export const GetActivityPlanningDocument = gql`
    query GetActivityPlanning($userId: ID!) {
  activityPlanning(userId: $userId) {
    activityPlanningId
    userId
    plannedActivities {
      plannedActivityId
      name
      contentReference {
        ... on ExternalContentId {
          cms
          contentType
          reference
        }
        ... on MobileWidgetId {
          kind
          __typename
        }
        ... on CustomActivityId {
          customActivityId
        }
      }
      timeSlots {
        dayOfWeek
        timeBlock
      }
      active
      createdAt
      lastCompletedAt
      startDate
      endDate
      removeAfterCompletion
      plannedModeId
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetActivityPlanningQuery__
 *
 * To run a query within a React component, call `useGetActivityPlanningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityPlanningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityPlanningQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetActivityPlanningQuery(baseOptions: Apollo.QueryHookOptions<GetActivityPlanningQuery, GetActivityPlanningQueryVariables> & ({ variables: GetActivityPlanningQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityPlanningQuery, GetActivityPlanningQueryVariables>(GetActivityPlanningDocument, options);
      }
export function useGetActivityPlanningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityPlanningQuery, GetActivityPlanningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityPlanningQuery, GetActivityPlanningQueryVariables>(GetActivityPlanningDocument, options);
        }
export function useGetActivityPlanningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityPlanningQuery, GetActivityPlanningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityPlanningQuery, GetActivityPlanningQueryVariables>(GetActivityPlanningDocument, options);
        }
export type GetActivityPlanningQueryHookResult = ReturnType<typeof useGetActivityPlanningQuery>;
export type GetActivityPlanningLazyQueryHookResult = ReturnType<typeof useGetActivityPlanningLazyQuery>;
export type GetActivityPlanningSuspenseQueryHookResult = ReturnType<typeof useGetActivityPlanningSuspenseQuery>;
export type GetActivityPlanningQueryResult = Apollo.QueryResult<GetActivityPlanningQuery, GetActivityPlanningQueryVariables>;
export const GetActivitiesDocument = gql`
    query GetActivities($userId: ID!, $dateRange: DateRangeInput!) {
  activities(userId: $userId, dateRange: $dateRange) {
    plannedActivityId
    name
    contentReference {
      ... on ExternalContentId {
        cms
        contentType
        reference
      }
      ... on MobileWidgetId {
        kind
      }
      ... on CustomActivityId {
        customActivityId
      }
    }
    date
    timeBlock
    active
    createdAt
    lastCompletedAt
  }
}
    `;

/**
 * __useGetActivitiesQuery__
 *
 * To run a query within a React component, call `useGetActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables> & ({ variables: GetActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
      }
export function useGetActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
        }
export function useGetActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
        }
export type GetActivitiesQueryHookResult = ReturnType<typeof useGetActivitiesQuery>;
export type GetActivitiesLazyQueryHookResult = ReturnType<typeof useGetActivitiesLazyQuery>;
export type GetActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetActivitiesSuspenseQuery>;
export type GetActivitiesQueryResult = Apollo.QueryResult<GetActivitiesQuery, GetActivitiesQueryVariables>;
export const GetCustomActivitiesDocument = gql`
    query GetCustomActivities($userId: ID!) {
  customActivities(userId: $userId) {
    customActivityId
    title
    createdAt
    description
    protocols
    subprotocols
    impactedVitals
    createdAt
  }
}
    `;

/**
 * __useGetCustomActivitiesQuery__
 *
 * To run a query within a React component, call `useGetCustomActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomActivitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCustomActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomActivitiesQuery, GetCustomActivitiesQueryVariables> & ({ variables: GetCustomActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomActivitiesQuery, GetCustomActivitiesQueryVariables>(GetCustomActivitiesDocument, options);
      }
export function useGetCustomActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomActivitiesQuery, GetCustomActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomActivitiesQuery, GetCustomActivitiesQueryVariables>(GetCustomActivitiesDocument, options);
        }
export function useGetCustomActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomActivitiesQuery, GetCustomActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomActivitiesQuery, GetCustomActivitiesQueryVariables>(GetCustomActivitiesDocument, options);
        }
export type GetCustomActivitiesQueryHookResult = ReturnType<typeof useGetCustomActivitiesQuery>;
export type GetCustomActivitiesLazyQueryHookResult = ReturnType<typeof useGetCustomActivitiesLazyQuery>;
export type GetCustomActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetCustomActivitiesSuspenseQuery>;
export type GetCustomActivitiesQueryResult = Apollo.QueryResult<GetCustomActivitiesQuery, GetCustomActivitiesQueryVariables>;
export const GetCustomActivityDocument = gql`
    query GetCustomActivity($customActivityId: ID!) {
  customActivity(customActivityId: $customActivityId) {
    customActivityId
    title
    description
    protocols
    subprotocols
    impactedVitals
    createdAt
  }
}
    `;

/**
 * __useGetCustomActivityQuery__
 *
 * To run a query within a React component, call `useGetCustomActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomActivityQuery({
 *   variables: {
 *      customActivityId: // value for 'customActivityId'
 *   },
 * });
 */
export function useGetCustomActivityQuery(baseOptions: Apollo.QueryHookOptions<GetCustomActivityQuery, GetCustomActivityQueryVariables> & ({ variables: GetCustomActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomActivityQuery, GetCustomActivityQueryVariables>(GetCustomActivityDocument, options);
      }
export function useGetCustomActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomActivityQuery, GetCustomActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomActivityQuery, GetCustomActivityQueryVariables>(GetCustomActivityDocument, options);
        }
export function useGetCustomActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomActivityQuery, GetCustomActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomActivityQuery, GetCustomActivityQueryVariables>(GetCustomActivityDocument, options);
        }
export type GetCustomActivityQueryHookResult = ReturnType<typeof useGetCustomActivityQuery>;
export type GetCustomActivityLazyQueryHookResult = ReturnType<typeof useGetCustomActivityLazyQuery>;
export type GetCustomActivitySuspenseQueryHookResult = ReturnType<typeof useGetCustomActivitySuspenseQuery>;
export type GetCustomActivityQueryResult = Apollo.QueryResult<GetCustomActivityQuery, GetCustomActivityQueryVariables>;
export const GetArticlesDocument = gql`
    query GetArticles($filter: ArticleFilter, $sort: [ArticleSortInput!], $pagination: PaginationInput) {
  articles(filter: $filter, sort: $sort, pagination: $pagination) {
    articles {
      id
      title
      protocols
      impactedVitals
      thumbnail {
        url
        title
      }
      reviewer {
        name
        credentials
        image {
          url
        }
      }
      contentReference {
        ... on ExternalContentId {
          cms
          contentType
          reference
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetArticlesQuery__
 *
 * To run a query within a React component, call `useGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
      }
export function useGetArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
export function useGetArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
export type GetArticlesQueryHookResult = ReturnType<typeof useGetArticlesQuery>;
export type GetArticlesLazyQueryHookResult = ReturnType<typeof useGetArticlesLazyQuery>;
export type GetArticlesSuspenseQueryHookResult = ReturnType<typeof useGetArticlesSuspenseQuery>;
export type GetArticlesQueryResult = Apollo.QueryResult<GetArticlesQuery, GetArticlesQueryVariables>;
export const PlanActivityDocument = gql`
    mutation PlanActivity($command: PlanActivityCommand!) {
  planActivity(command: $command) {
    id
  }
}
    `;
export type PlanActivityMutationFn = Apollo.MutationFunction<PlanActivityMutation, PlanActivityMutationVariables>;

/**
 * __usePlanActivityMutation__
 *
 * To run a mutation, you first call `usePlanActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planActivityMutation, { data, loading, error }] = usePlanActivityMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function usePlanActivityMutation(baseOptions?: Apollo.MutationHookOptions<PlanActivityMutation, PlanActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanActivityMutation, PlanActivityMutationVariables>(PlanActivityDocument, options);
      }
export type PlanActivityMutationHookResult = ReturnType<typeof usePlanActivityMutation>;
export type PlanActivityMutationResult = Apollo.MutationResult<PlanActivityMutation>;
export type PlanActivityMutationOptions = Apollo.BaseMutationOptions<PlanActivityMutation, PlanActivityMutationVariables>;
export const CompleteActivityDocument = gql`
    mutation CompleteActivity($command: CompleteActivityCommand!) {
  completeActivity(command: $command) {
    id
  }
}
    `;
export type CompleteActivityMutationFn = Apollo.MutationFunction<CompleteActivityMutation, CompleteActivityMutationVariables>;

/**
 * __useCompleteActivityMutation__
 *
 * To run a mutation, you first call `useCompleteActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeActivityMutation, { data, loading, error }] = useCompleteActivityMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useCompleteActivityMutation(baseOptions?: Apollo.MutationHookOptions<CompleteActivityMutation, CompleteActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteActivityMutation, CompleteActivityMutationVariables>(CompleteActivityDocument, options);
      }
export type CompleteActivityMutationHookResult = ReturnType<typeof useCompleteActivityMutation>;
export type CompleteActivityMutationResult = Apollo.MutationResult<CompleteActivityMutation>;
export type CompleteActivityMutationOptions = Apollo.BaseMutationOptions<CompleteActivityMutation, CompleteActivityMutationVariables>;
export const DeletePlannedActivityDocument = gql`
    mutation DeletePlannedActivity($command: DeletePlannedActivityCommand!) {
  deletePlannedActivity(command: $command) {
    id
  }
}
    `;
export type DeletePlannedActivityMutationFn = Apollo.MutationFunction<DeletePlannedActivityMutation, DeletePlannedActivityMutationVariables>;

/**
 * __useDeletePlannedActivityMutation__
 *
 * To run a mutation, you first call `useDeletePlannedActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlannedActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlannedActivityMutation, { data, loading, error }] = useDeletePlannedActivityMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useDeletePlannedActivityMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlannedActivityMutation, DeletePlannedActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlannedActivityMutation, DeletePlannedActivityMutationVariables>(DeletePlannedActivityDocument, options);
      }
export type DeletePlannedActivityMutationHookResult = ReturnType<typeof useDeletePlannedActivityMutation>;
export type DeletePlannedActivityMutationResult = Apollo.MutationResult<DeletePlannedActivityMutation>;
export type DeletePlannedActivityMutationOptions = Apollo.BaseMutationOptions<DeletePlannedActivityMutation, DeletePlannedActivityMutationVariables>;
export const ReplacePlannedActivityDocument = gql`
    mutation ReplacePlannedActivity($command: ReplacePlannedActivityCommand!) {
  replacePlannedActivity(command: $command) {
    id
  }
}
    `;
export type ReplacePlannedActivityMutationFn = Apollo.MutationFunction<ReplacePlannedActivityMutation, ReplacePlannedActivityMutationVariables>;

/**
 * __useReplacePlannedActivityMutation__
 *
 * To run a mutation, you first call `useReplacePlannedActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplacePlannedActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replacePlannedActivityMutation, { data, loading, error }] = useReplacePlannedActivityMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useReplacePlannedActivityMutation(baseOptions?: Apollo.MutationHookOptions<ReplacePlannedActivityMutation, ReplacePlannedActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplacePlannedActivityMutation, ReplacePlannedActivityMutationVariables>(ReplacePlannedActivityDocument, options);
      }
export type ReplacePlannedActivityMutationHookResult = ReturnType<typeof useReplacePlannedActivityMutation>;
export type ReplacePlannedActivityMutationResult = Apollo.MutationResult<ReplacePlannedActivityMutation>;
export type ReplacePlannedActivityMutationOptions = Apollo.BaseMutationOptions<ReplacePlannedActivityMutation, ReplacePlannedActivityMutationVariables>;
export const CreateCustomActivityDocument = gql`
    mutation CreateCustomActivity($command: CreateCustomActivityCommand!) {
  createCustomActivity(command: $command) {
    id
  }
}
    `;
export type CreateCustomActivityMutationFn = Apollo.MutationFunction<CreateCustomActivityMutation, CreateCustomActivityMutationVariables>;

/**
 * __useCreateCustomActivityMutation__
 *
 * To run a mutation, you first call `useCreateCustomActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomActivityMutation, { data, loading, error }] = useCreateCustomActivityMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useCreateCustomActivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomActivityMutation, CreateCustomActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomActivityMutation, CreateCustomActivityMutationVariables>(CreateCustomActivityDocument, options);
      }
export type CreateCustomActivityMutationHookResult = ReturnType<typeof useCreateCustomActivityMutation>;
export type CreateCustomActivityMutationResult = Apollo.MutationResult<CreateCustomActivityMutation>;
export type CreateCustomActivityMutationOptions = Apollo.BaseMutationOptions<CreateCustomActivityMutation, CreateCustomActivityMutationVariables>;
export const UpdateCustomActivityDocument = gql`
    mutation UpdateCustomActivity($command: UpdateCustomActivityCommand!) {
  updateCustomActivity(command: $command) {
    id
  }
}
    `;
export type UpdateCustomActivityMutationFn = Apollo.MutationFunction<UpdateCustomActivityMutation, UpdateCustomActivityMutationVariables>;

/**
 * __useUpdateCustomActivityMutation__
 *
 * To run a mutation, you first call `useUpdateCustomActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomActivityMutation, { data, loading, error }] = useUpdateCustomActivityMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useUpdateCustomActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomActivityMutation, UpdateCustomActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomActivityMutation, UpdateCustomActivityMutationVariables>(UpdateCustomActivityDocument, options);
      }
export type UpdateCustomActivityMutationHookResult = ReturnType<typeof useUpdateCustomActivityMutation>;
export type UpdateCustomActivityMutationResult = Apollo.MutationResult<UpdateCustomActivityMutation>;
export type UpdateCustomActivityMutationOptions = Apollo.BaseMutationOptions<UpdateCustomActivityMutation, UpdateCustomActivityMutationVariables>;
export const GetParticipantProfileDocument = gql`
    query GetParticipantProfile($participantId: ID!) {
  participant(participantId: $participantId) {
    participantId
    pii {
      identityInformation {
        firstName
        lastName
        yearOfBirth
        gender
      }
      contactInformation {
        email
      }
    }
  }
}
    `;

/**
 * __useGetParticipantProfileQuery__
 *
 * To run a query within a React component, call `useGetParticipantProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantProfileQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantProfileQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantProfileQuery, GetParticipantProfileQueryVariables> & ({ variables: GetParticipantProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantProfileQuery, GetParticipantProfileQueryVariables>(GetParticipantProfileDocument, options);
      }
export function useGetParticipantProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantProfileQuery, GetParticipantProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantProfileQuery, GetParticipantProfileQueryVariables>(GetParticipantProfileDocument, options);
        }
export function useGetParticipantProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantProfileQuery, GetParticipantProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantProfileQuery, GetParticipantProfileQueryVariables>(GetParticipantProfileDocument, options);
        }
export type GetParticipantProfileQueryHookResult = ReturnType<typeof useGetParticipantProfileQuery>;
export type GetParticipantProfileLazyQueryHookResult = ReturnType<typeof useGetParticipantProfileLazyQuery>;
export type GetParticipantProfileSuspenseQueryHookResult = ReturnType<typeof useGetParticipantProfileSuspenseQuery>;
export type GetParticipantProfileQueryResult = Apollo.QueryResult<GetParticipantProfileQuery, GetParticipantProfileQueryVariables>;
export const GetLatestBodyMetricsDocument = gql`
    query GetLatestBodyMetrics($participantId: ID!) {
  latestBodyMetrics(participantId: $participantId) {
    id
    type
    value
    unit
    recordedAt
  }
}
    `;

/**
 * __useGetLatestBodyMetricsQuery__
 *
 * To run a query within a React component, call `useGetLatestBodyMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestBodyMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestBodyMetricsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetLatestBodyMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetLatestBodyMetricsQuery, GetLatestBodyMetricsQueryVariables> & ({ variables: GetLatestBodyMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestBodyMetricsQuery, GetLatestBodyMetricsQueryVariables>(GetLatestBodyMetricsDocument, options);
      }
export function useGetLatestBodyMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestBodyMetricsQuery, GetLatestBodyMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestBodyMetricsQuery, GetLatestBodyMetricsQueryVariables>(GetLatestBodyMetricsDocument, options);
        }
export function useGetLatestBodyMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestBodyMetricsQuery, GetLatestBodyMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestBodyMetricsQuery, GetLatestBodyMetricsQueryVariables>(GetLatestBodyMetricsDocument, options);
        }
export type GetLatestBodyMetricsQueryHookResult = ReturnType<typeof useGetLatestBodyMetricsQuery>;
export type GetLatestBodyMetricsLazyQueryHookResult = ReturnType<typeof useGetLatestBodyMetricsLazyQuery>;
export type GetLatestBodyMetricsSuspenseQueryHookResult = ReturnType<typeof useGetLatestBodyMetricsSuspenseQuery>;
export type GetLatestBodyMetricsQueryResult = Apollo.QueryResult<GetLatestBodyMetricsQuery, GetLatestBodyMetricsQueryVariables>;
export const GetLatestMindstateMetricsDocument = gql`
    query GetLatestMindstateMetrics($participantId: ID!) {
  latestMindstateMetrics(participantId: $participantId) {
    id
    type
    values
    recordedAt
  }
}
    `;

/**
 * __useGetLatestMindstateMetricsQuery__
 *
 * To run a query within a React component, call `useGetLatestMindstateMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestMindstateMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestMindstateMetricsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetLatestMindstateMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetLatestMindstateMetricsQuery, GetLatestMindstateMetricsQueryVariables> & ({ variables: GetLatestMindstateMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestMindstateMetricsQuery, GetLatestMindstateMetricsQueryVariables>(GetLatestMindstateMetricsDocument, options);
      }
export function useGetLatestMindstateMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestMindstateMetricsQuery, GetLatestMindstateMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestMindstateMetricsQuery, GetLatestMindstateMetricsQueryVariables>(GetLatestMindstateMetricsDocument, options);
        }
export function useGetLatestMindstateMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestMindstateMetricsQuery, GetLatestMindstateMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestMindstateMetricsQuery, GetLatestMindstateMetricsQueryVariables>(GetLatestMindstateMetricsDocument, options);
        }
export type GetLatestMindstateMetricsQueryHookResult = ReturnType<typeof useGetLatestMindstateMetricsQuery>;
export type GetLatestMindstateMetricsLazyQueryHookResult = ReturnType<typeof useGetLatestMindstateMetricsLazyQuery>;
export type GetLatestMindstateMetricsSuspenseQueryHookResult = ReturnType<typeof useGetLatestMindstateMetricsSuspenseQuery>;
export type GetLatestMindstateMetricsQueryResult = Apollo.QueryResult<GetLatestMindstateMetricsQuery, GetLatestMindstateMetricsQueryVariables>;
export const GetDeliveredNotificationsDocument = gql`
    query GetDeliveredNotifications($userId: ID!) {
  deliveredNotifications(userId: $userId) {
    notificationDeliveryId
    payload {
      title
      body
      additionalPayload
    }
    createdAtTz
    deliveredAtTz
    status
    messageReadStatus
    messageReadAtTz
  }
}
    `;

/**
 * __useGetDeliveredNotificationsQuery__
 *
 * To run a query within a React component, call `useGetDeliveredNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveredNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveredNotificationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDeliveredNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveredNotificationsQuery, GetDeliveredNotificationsQueryVariables> & ({ variables: GetDeliveredNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveredNotificationsQuery, GetDeliveredNotificationsQueryVariables>(GetDeliveredNotificationsDocument, options);
      }
export function useGetDeliveredNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveredNotificationsQuery, GetDeliveredNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveredNotificationsQuery, GetDeliveredNotificationsQueryVariables>(GetDeliveredNotificationsDocument, options);
        }
export function useGetDeliveredNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveredNotificationsQuery, GetDeliveredNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveredNotificationsQuery, GetDeliveredNotificationsQueryVariables>(GetDeliveredNotificationsDocument, options);
        }
export type GetDeliveredNotificationsQueryHookResult = ReturnType<typeof useGetDeliveredNotificationsQuery>;
export type GetDeliveredNotificationsLazyQueryHookResult = ReturnType<typeof useGetDeliveredNotificationsLazyQuery>;
export type GetDeliveredNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetDeliveredNotificationsSuspenseQuery>;
export type GetDeliveredNotificationsQueryResult = Apollo.QueryResult<GetDeliveredNotificationsQuery, GetDeliveredNotificationsQueryVariables>;
export const UpdateMessageReadStatusDocument = gql`
    mutation UpdateMessageReadStatus($notificationDeliveryId: ID!, $messageReadStatus: MessageReadStatus!, $userId: ID!) {
  updateMessageReadStatus(
    notificationDeliveryId: $notificationDeliveryId
    messageReadStatus: $messageReadStatus
    userId: $userId
  ) {
    id
  }
}
    `;
export type UpdateMessageReadStatusMutationFn = Apollo.MutationFunction<UpdateMessageReadStatusMutation, UpdateMessageReadStatusMutationVariables>;

/**
 * __useUpdateMessageReadStatusMutation__
 *
 * To run a mutation, you first call `useUpdateMessageReadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageReadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageReadStatusMutation, { data, loading, error }] = useUpdateMessageReadStatusMutation({
 *   variables: {
 *      notificationDeliveryId: // value for 'notificationDeliveryId'
 *      messageReadStatus: // value for 'messageReadStatus'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateMessageReadStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageReadStatusMutation, UpdateMessageReadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageReadStatusMutation, UpdateMessageReadStatusMutationVariables>(UpdateMessageReadStatusDocument, options);
      }
export type UpdateMessageReadStatusMutationHookResult = ReturnType<typeof useUpdateMessageReadStatusMutation>;
export type UpdateMessageReadStatusMutationResult = Apollo.MutationResult<UpdateMessageReadStatusMutation>;
export type UpdateMessageReadStatusMutationOptions = Apollo.BaseMutationOptions<UpdateMessageReadStatusMutation, UpdateMessageReadStatusMutationVariables>;
export const GetVitalsDocument = gql`
    query GetVitals($userId: ID!, $startDate: Date!, $endDate: Date!) {
  vitals(userId: $userId, startDate: $startDate, endDate: $endDate) {
    vitalsId
    userId
    vitals {
      id
      type
      value
      unit
      source
      recordedAt
      scanDurationSeconds
    }
    feelings {
      id
      type
      value
      source
      details
      originId
      recordedAt
    }
    emotionalStates {
      id
      userId
      feelings
      recordedAt
    }
  }
}
    `;

/**
 * __useGetVitalsQuery__
 *
 * To run a query within a React component, call `useGetVitalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVitalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVitalsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetVitalsQuery(baseOptions: Apollo.QueryHookOptions<GetVitalsQuery, GetVitalsQueryVariables> & ({ variables: GetVitalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVitalsQuery, GetVitalsQueryVariables>(GetVitalsDocument, options);
      }
export function useGetVitalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVitalsQuery, GetVitalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVitalsQuery, GetVitalsQueryVariables>(GetVitalsDocument, options);
        }
export function useGetVitalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVitalsQuery, GetVitalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVitalsQuery, GetVitalsQueryVariables>(GetVitalsDocument, options);
        }
export type GetVitalsQueryHookResult = ReturnType<typeof useGetVitalsQuery>;
export type GetVitalsLazyQueryHookResult = ReturnType<typeof useGetVitalsLazyQuery>;
export type GetVitalsSuspenseQueryHookResult = ReturnType<typeof useGetVitalsSuspenseQuery>;
export type GetVitalsQueryResult = Apollo.QueryResult<GetVitalsQuery, GetVitalsQueryVariables>;
export const GetEmotionalWordCloudDocument = gql`
    query GetEmotionalWordCloud($startDate: Date!, $endDate: Date!) {
  emotionalWordCloud(startDate: $startDate, endDate: $endDate) {
    word
    count
  }
}
    `;

/**
 * __useGetEmotionalWordCloudQuery__
 *
 * To run a query within a React component, call `useGetEmotionalWordCloudQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmotionalWordCloudQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmotionalWordCloudQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEmotionalWordCloudQuery(baseOptions: Apollo.QueryHookOptions<GetEmotionalWordCloudQuery, GetEmotionalWordCloudQueryVariables> & ({ variables: GetEmotionalWordCloudQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmotionalWordCloudQuery, GetEmotionalWordCloudQueryVariables>(GetEmotionalWordCloudDocument, options);
      }
export function useGetEmotionalWordCloudLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmotionalWordCloudQuery, GetEmotionalWordCloudQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmotionalWordCloudQuery, GetEmotionalWordCloudQueryVariables>(GetEmotionalWordCloudDocument, options);
        }
export function useGetEmotionalWordCloudSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmotionalWordCloudQuery, GetEmotionalWordCloudQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmotionalWordCloudQuery, GetEmotionalWordCloudQueryVariables>(GetEmotionalWordCloudDocument, options);
        }
export type GetEmotionalWordCloudQueryHookResult = ReturnType<typeof useGetEmotionalWordCloudQuery>;
export type GetEmotionalWordCloudLazyQueryHookResult = ReturnType<typeof useGetEmotionalWordCloudLazyQuery>;
export type GetEmotionalWordCloudSuspenseQueryHookResult = ReturnType<typeof useGetEmotionalWordCloudSuspenseQuery>;
export type GetEmotionalWordCloudQueryResult = Apollo.QueryResult<GetEmotionalWordCloudQuery, GetEmotionalWordCloudQueryVariables>;
export const GetUserVitalMetricsDocument = gql`
    query GetUserVitalMetrics($dateRange: DateRangeInput!, $participantId: String) {
  userVitalMetrics(dateRange: $dateRange, participantId: $participantId) {
    vitalsRecorded {
      label
      value
      unit
      trend {
        value
        previousValue
        isIncrease
        label
      }
      description
    }
    vnsTherapyTime {
      label
      value
      unit
      trend {
        value
        previousValue
        isIncrease
        label
      }
      description
    }
    vnsTherapyCompletionRate {
      label
      value
      unit
      trend {
        value
        previousValue
        isIncrease
        label
      }
      description
    }
  }
}
    `;

/**
 * __useGetUserVitalMetricsQuery__
 *
 * To run a query within a React component, call `useGetUserVitalMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserVitalMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserVitalMetricsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetUserVitalMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetUserVitalMetricsQuery, GetUserVitalMetricsQueryVariables> & ({ variables: GetUserVitalMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserVitalMetricsQuery, GetUserVitalMetricsQueryVariables>(GetUserVitalMetricsDocument, options);
      }
export function useGetUserVitalMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserVitalMetricsQuery, GetUserVitalMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserVitalMetricsQuery, GetUserVitalMetricsQueryVariables>(GetUserVitalMetricsDocument, options);
        }
export function useGetUserVitalMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserVitalMetricsQuery, GetUserVitalMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserVitalMetricsQuery, GetUserVitalMetricsQueryVariables>(GetUserVitalMetricsDocument, options);
        }
export type GetUserVitalMetricsQueryHookResult = ReturnType<typeof useGetUserVitalMetricsQuery>;
export type GetUserVitalMetricsLazyQueryHookResult = ReturnType<typeof useGetUserVitalMetricsLazyQuery>;
export type GetUserVitalMetricsSuspenseQueryHookResult = ReturnType<typeof useGetUserVitalMetricsSuspenseQuery>;
export type GetUserVitalMetricsQueryResult = Apollo.QueryResult<GetUserVitalMetricsQuery, GetUserVitalMetricsQueryVariables>;
export const GetUserEngagementDocument = gql`
    query GetUserEngagement($dateRange: DateRangeInput!, $participantId: String) {
  userEngagement(dateRange: $dateRange, participantId: $participantId) {
    logins {
      label
      value
      unit
      trend {
        value
        previousValue
        isIncrease
        label
      }
      description
    }
    dojoContentProgress {
      label
      value
      unit
      trend {
        value
        previousValue
        isIncrease
        label
      }
      description
    }
  }
}
    `;

/**
 * __useGetUserEngagementQuery__
 *
 * To run a query within a React component, call `useGetUserEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEngagementQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetUserEngagementQuery(baseOptions: Apollo.QueryHookOptions<GetUserEngagementQuery, GetUserEngagementQueryVariables> & ({ variables: GetUserEngagementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEngagementQuery, GetUserEngagementQueryVariables>(GetUserEngagementDocument, options);
      }
export function useGetUserEngagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEngagementQuery, GetUserEngagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEngagementQuery, GetUserEngagementQueryVariables>(GetUserEngagementDocument, options);
        }
export function useGetUserEngagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserEngagementQuery, GetUserEngagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserEngagementQuery, GetUserEngagementQueryVariables>(GetUserEngagementDocument, options);
        }
export type GetUserEngagementQueryHookResult = ReturnType<typeof useGetUserEngagementQuery>;
export type GetUserEngagementLazyQueryHookResult = ReturnType<typeof useGetUserEngagementLazyQuery>;
export type GetUserEngagementSuspenseQueryHookResult = ReturnType<typeof useGetUserEngagementSuspenseQuery>;
export type GetUserEngagementQueryResult = Apollo.QueryResult<GetUserEngagementQuery, GetUserEngagementQueryVariables>;
export const GetVnsSessionsDocument = gql`
    query GetVnsSessions($participantId: ID!, $dateRange: DateRangeInput!) {
  vnsSessions(participantId: $participantId, dateRange: $dateRange) {
    vnsSessionId
    userId
    startTime
    endTime
    totalDuration
    status
    phases {
      startTime
      endTime
      settings {
        mode
        intensity
        modeReference {
          modeId
          setVersion
          displayName
        }
      }
    }
    deviceInfo
    timeBlock
    initialSettings {
      mode
      modeReference {
        modeId
        setVersion
        displayName
      }
    }
    insight {
      id
      priority
      title
      message
      recommendation
      createdAt
      directImpactAnalysis {
        directImpactScore
        significantChanges
        impactSummary
        confidence
      }
      longTermTrendAnalysis {
        longTermTrendScore
        improvingVitals
        plateauedVitals
        trendSummary
        weeksToNextMilestone
        adherenceImpact
      }
    }
  }
}
    `;

/**
 * __useGetVnsSessionsQuery__
 *
 * To run a query within a React component, call `useGetVnsSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVnsSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVnsSessionsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetVnsSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetVnsSessionsQuery, GetVnsSessionsQueryVariables> & ({ variables: GetVnsSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVnsSessionsQuery, GetVnsSessionsQueryVariables>(GetVnsSessionsDocument, options);
      }
export function useGetVnsSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVnsSessionsQuery, GetVnsSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVnsSessionsQuery, GetVnsSessionsQueryVariables>(GetVnsSessionsDocument, options);
        }
export function useGetVnsSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVnsSessionsQuery, GetVnsSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVnsSessionsQuery, GetVnsSessionsQueryVariables>(GetVnsSessionsDocument, options);
        }
export type GetVnsSessionsQueryHookResult = ReturnType<typeof useGetVnsSessionsQuery>;
export type GetVnsSessionsLazyQueryHookResult = ReturnType<typeof useGetVnsSessionsLazyQuery>;
export type GetVnsSessionsSuspenseQueryHookResult = ReturnType<typeof useGetVnsSessionsSuspenseQuery>;
export type GetVnsSessionsQueryResult = Apollo.QueryResult<GetVnsSessionsQuery, GetVnsSessionsQueryVariables>;
export const GetUnattributedVnsSessionsDocument = gql`
    query GetUnattributedVnsSessions($participantId: ID!, $dateRange: DateRangeInput) {
  unattributedVnsSessions(participantId: $participantId, dateRange: $dateRange) {
    vnsSessionId
    startTime
    totalDuration
    deviceSerial
    unattributedReason
  }
}
    `;

/**
 * __useGetUnattributedVnsSessionsQuery__
 *
 * To run a query within a React component, call `useGetUnattributedVnsSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnattributedVnsSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnattributedVnsSessionsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetUnattributedVnsSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetUnattributedVnsSessionsQuery, GetUnattributedVnsSessionsQueryVariables> & ({ variables: GetUnattributedVnsSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnattributedVnsSessionsQuery, GetUnattributedVnsSessionsQueryVariables>(GetUnattributedVnsSessionsDocument, options);
      }
export function useGetUnattributedVnsSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnattributedVnsSessionsQuery, GetUnattributedVnsSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnattributedVnsSessionsQuery, GetUnattributedVnsSessionsQueryVariables>(GetUnattributedVnsSessionsDocument, options);
        }
export function useGetUnattributedVnsSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnattributedVnsSessionsQuery, GetUnattributedVnsSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnattributedVnsSessionsQuery, GetUnattributedVnsSessionsQueryVariables>(GetUnattributedVnsSessionsDocument, options);
        }
export type GetUnattributedVnsSessionsQueryHookResult = ReturnType<typeof useGetUnattributedVnsSessionsQuery>;
export type GetUnattributedVnsSessionsLazyQueryHookResult = ReturnType<typeof useGetUnattributedVnsSessionsLazyQuery>;
export type GetUnattributedVnsSessionsSuspenseQueryHookResult = ReturnType<typeof useGetUnattributedVnsSessionsSuspenseQuery>;
export type GetUnattributedVnsSessionsQueryResult = Apollo.QueryResult<GetUnattributedVnsSessionsQuery, GetUnattributedVnsSessionsQueryVariables>;
export const GetCheckinSessionsDocument = gql`
    query GetCheckinSessions($participantId: ID!, $dateRange: DateRangeInput!) {
  checkinSessions(participantId: $participantId, dateRange: $dateRange) {
    checkinSessionId
    userId
    startTime
    endTime
    vitalMeasurements {
      type
      value
      unit
      source
      recordedAt
      scanDurationSeconds
    }
    feelingMeasurements {
      type
      value
      source
      recordedAt
    }
  }
}
    `;

/**
 * __useGetCheckinSessionsQuery__
 *
 * To run a query within a React component, call `useGetCheckinSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckinSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckinSessionsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetCheckinSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetCheckinSessionsQuery, GetCheckinSessionsQueryVariables> & ({ variables: GetCheckinSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckinSessionsQuery, GetCheckinSessionsQueryVariables>(GetCheckinSessionsDocument, options);
      }
export function useGetCheckinSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckinSessionsQuery, GetCheckinSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckinSessionsQuery, GetCheckinSessionsQueryVariables>(GetCheckinSessionsDocument, options);
        }
export function useGetCheckinSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCheckinSessionsQuery, GetCheckinSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckinSessionsQuery, GetCheckinSessionsQueryVariables>(GetCheckinSessionsDocument, options);
        }
export type GetCheckinSessionsQueryHookResult = ReturnType<typeof useGetCheckinSessionsQuery>;
export type GetCheckinSessionsLazyQueryHookResult = ReturnType<typeof useGetCheckinSessionsLazyQuery>;
export type GetCheckinSessionsSuspenseQueryHookResult = ReturnType<typeof useGetCheckinSessionsSuspenseQuery>;
export type GetCheckinSessionsQueryResult = Apollo.QueryResult<GetCheckinSessionsQuery, GetCheckinSessionsQueryVariables>;
export const GetBiofeedbackSessionsDocument = gql`
    query GetBiofeedbackSessions($participantId: ID!, $dateRange: DateRangeInput!) {
  biofeedbackSessions(participantId: $participantId, dateRange: $dateRange) {
    biofeedbackSessionId
    userId
    activity {
      hydratedContent {
        ... on CmsDocument {
          id
        }
        title
      }
    }
    preVitals {
      type
      value
      unit
      source
      recordedAt
      scanDurationSeconds
    }
    postVitals {
      type
      value
      unit
      source
      recordedAt
      scanDurationSeconds
    }
    startTime
    endTime
    timeBlock
  }
}
    `;

/**
 * __useGetBiofeedbackSessionsQuery__
 *
 * To run a query within a React component, call `useGetBiofeedbackSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBiofeedbackSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBiofeedbackSessionsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetBiofeedbackSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetBiofeedbackSessionsQuery, GetBiofeedbackSessionsQueryVariables> & ({ variables: GetBiofeedbackSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBiofeedbackSessionsQuery, GetBiofeedbackSessionsQueryVariables>(GetBiofeedbackSessionsDocument, options);
      }
export function useGetBiofeedbackSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBiofeedbackSessionsQuery, GetBiofeedbackSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBiofeedbackSessionsQuery, GetBiofeedbackSessionsQueryVariables>(GetBiofeedbackSessionsDocument, options);
        }
export function useGetBiofeedbackSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBiofeedbackSessionsQuery, GetBiofeedbackSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBiofeedbackSessionsQuery, GetBiofeedbackSessionsQueryVariables>(GetBiofeedbackSessionsDocument, options);
        }
export type GetBiofeedbackSessionsQueryHookResult = ReturnType<typeof useGetBiofeedbackSessionsQuery>;
export type GetBiofeedbackSessionsLazyQueryHookResult = ReturnType<typeof useGetBiofeedbackSessionsLazyQuery>;
export type GetBiofeedbackSessionsSuspenseQueryHookResult = ReturnType<typeof useGetBiofeedbackSessionsSuspenseQuery>;
export type GetBiofeedbackSessionsQueryResult = Apollo.QueryResult<GetBiofeedbackSessionsQuery, GetBiofeedbackSessionsQueryVariables>;
export const GetUserChatMetricsDocument = gql`
    query GetUserChatMetrics($dateRange: DateRangeInput!, $participantId: String) {
  userChatMetrics(dateRange: $dateRange, participantId: $participantId) {
    inboundMessages {
      label
      value
      unit
      trend {
        value
        previousValue
        isIncrease
        label
      }
      description
    }
    outboundMessages {
      label
      value
      unit
      trend {
        value
        previousValue
        isIncrease
        label
      }
      description
    }
    responseRate {
      label
      value
      unit
      trend {
        value
        previousValue
        isIncrease
        label
      }
      description
    }
  }
}
    `;

/**
 * __useGetUserChatMetricsQuery__
 *
 * To run a query within a React component, call `useGetUserChatMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserChatMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserChatMetricsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetUserChatMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetUserChatMetricsQuery, GetUserChatMetricsQueryVariables> & ({ variables: GetUserChatMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserChatMetricsQuery, GetUserChatMetricsQueryVariables>(GetUserChatMetricsDocument, options);
      }
export function useGetUserChatMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserChatMetricsQuery, GetUserChatMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserChatMetricsQuery, GetUserChatMetricsQueryVariables>(GetUserChatMetricsDocument, options);
        }
export function useGetUserChatMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserChatMetricsQuery, GetUserChatMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserChatMetricsQuery, GetUserChatMetricsQueryVariables>(GetUserChatMetricsDocument, options);
        }
export type GetUserChatMetricsQueryHookResult = ReturnType<typeof useGetUserChatMetricsQuery>;
export type GetUserChatMetricsLazyQueryHookResult = ReturnType<typeof useGetUserChatMetricsLazyQuery>;
export type GetUserChatMetricsSuspenseQueryHookResult = ReturnType<typeof useGetUserChatMetricsSuspenseQuery>;
export type GetUserChatMetricsQueryResult = Apollo.QueryResult<GetUserChatMetricsQuery, GetUserChatMetricsQueryVariables>;
export const GetParticipantDailyReflectionsDocument = gql`
    query GetParticipantDailyReflections($userId: ID!, $dateRange: DateRangeInput!) {
  participantDailyReflections(userId: $userId, dateRange: $dateRange) {
    reflectionId
    date
    answers {
      metric
      value
      label
    }
    note
    completedAt
    createdAt
  }
}
    `;

/**
 * __useGetParticipantDailyReflectionsQuery__
 *
 * To run a query within a React component, call `useGetParticipantDailyReflectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantDailyReflectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantDailyReflectionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetParticipantDailyReflectionsQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantDailyReflectionsQuery, GetParticipantDailyReflectionsQueryVariables> & ({ variables: GetParticipantDailyReflectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantDailyReflectionsQuery, GetParticipantDailyReflectionsQueryVariables>(GetParticipantDailyReflectionsDocument, options);
      }
export function useGetParticipantDailyReflectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantDailyReflectionsQuery, GetParticipantDailyReflectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantDailyReflectionsQuery, GetParticipantDailyReflectionsQueryVariables>(GetParticipantDailyReflectionsDocument, options);
        }
export function useGetParticipantDailyReflectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantDailyReflectionsQuery, GetParticipantDailyReflectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantDailyReflectionsQuery, GetParticipantDailyReflectionsQueryVariables>(GetParticipantDailyReflectionsDocument, options);
        }
export type GetParticipantDailyReflectionsQueryHookResult = ReturnType<typeof useGetParticipantDailyReflectionsQuery>;
export type GetParticipantDailyReflectionsLazyQueryHookResult = ReturnType<typeof useGetParticipantDailyReflectionsLazyQuery>;
export type GetParticipantDailyReflectionsSuspenseQueryHookResult = ReturnType<typeof useGetParticipantDailyReflectionsSuspenseQuery>;
export type GetParticipantDailyReflectionsQueryResult = Apollo.QueryResult<GetParticipantDailyReflectionsQuery, GetParticipantDailyReflectionsQueryVariables>;
export const GetUserRmssdProfileDocument = gql`
    query GetUserRmssdProfile($participantId: ID!) {
  userRmssdProfile(participantId: $participantId) {
    participantId
    baselineRmssd
    currentRmssd
    ageBracket
    threshold
    stratum
  }
}
    `;

/**
 * __useGetUserRmssdProfileQuery__
 *
 * To run a query within a React component, call `useGetUserRmssdProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRmssdProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRmssdProfileQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetUserRmssdProfileQuery(baseOptions: Apollo.QueryHookOptions<GetUserRmssdProfileQuery, GetUserRmssdProfileQueryVariables> & ({ variables: GetUserRmssdProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRmssdProfileQuery, GetUserRmssdProfileQueryVariables>(GetUserRmssdProfileDocument, options);
      }
export function useGetUserRmssdProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRmssdProfileQuery, GetUserRmssdProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRmssdProfileQuery, GetUserRmssdProfileQueryVariables>(GetUserRmssdProfileDocument, options);
        }
export function useGetUserRmssdProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRmssdProfileQuery, GetUserRmssdProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRmssdProfileQuery, GetUserRmssdProfileQueryVariables>(GetUserRmssdProfileDocument, options);
        }
export type GetUserRmssdProfileQueryHookResult = ReturnType<typeof useGetUserRmssdProfileQuery>;
export type GetUserRmssdProfileLazyQueryHookResult = ReturnType<typeof useGetUserRmssdProfileLazyQuery>;
export type GetUserRmssdProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserRmssdProfileSuspenseQuery>;
export type GetUserRmssdProfileQueryResult = Apollo.QueryResult<GetUserRmssdProfileQuery, GetUserRmssdProfileQueryVariables>;
export const GetRmssdStratificationDocument = gql`
    query GetRmssdStratification($filter: RmssdStratificationFilter!) {
  rmssdStratification(filter: $filter) {
    totalUsers
    usersExcludedNoAge
    usersExcludedNoRmssd
    strata {
      stratum
      count
      percentage
      avgBaselineRmssd
      avgPercentageChange
    }
    thresholds {
      ageBracket
      threshold
    }
  }
}
    `;

/**
 * __useGetRmssdStratificationQuery__
 *
 * To run a query within a React component, call `useGetRmssdStratificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRmssdStratificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRmssdStratificationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRmssdStratificationQuery(baseOptions: Apollo.QueryHookOptions<GetRmssdStratificationQuery, GetRmssdStratificationQueryVariables> & ({ variables: GetRmssdStratificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRmssdStratificationQuery, GetRmssdStratificationQueryVariables>(GetRmssdStratificationDocument, options);
      }
export function useGetRmssdStratificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRmssdStratificationQuery, GetRmssdStratificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRmssdStratificationQuery, GetRmssdStratificationQueryVariables>(GetRmssdStratificationDocument, options);
        }
export function useGetRmssdStratificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRmssdStratificationQuery, GetRmssdStratificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRmssdStratificationQuery, GetRmssdStratificationQueryVariables>(GetRmssdStratificationDocument, options);
        }
export type GetRmssdStratificationQueryHookResult = ReturnType<typeof useGetRmssdStratificationQuery>;
export type GetRmssdStratificationLazyQueryHookResult = ReturnType<typeof useGetRmssdStratificationLazyQuery>;
export type GetRmssdStratificationSuspenseQueryHookResult = ReturnType<typeof useGetRmssdStratificationSuspenseQuery>;
export type GetRmssdStratificationQueryResult = Apollo.QueryResult<GetRmssdStratificationQuery, GetRmssdStratificationQueryVariables>;
export const GetParticipantBaselineDocument = gql`
    query GetParticipantBaseline($participantId: ID!) {
  participant(participantId: $participantId) {
    participantId
    pii {
      identityInformation {
        firstName
        lastName
        yearOfBirth
        gender
      }
      contactInformation {
        email
      }
    }
    wearableIntegrations {
      ...WearableIntegrationFields
    }
  }
}
    ${WearableIntegrationFieldsFragmentDoc}`;

/**
 * __useGetParticipantBaselineQuery__
 *
 * To run a query within a React component, call `useGetParticipantBaselineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantBaselineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantBaselineQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantBaselineQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantBaselineQuery, GetParticipantBaselineQueryVariables> & ({ variables: GetParticipantBaselineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantBaselineQuery, GetParticipantBaselineQueryVariables>(GetParticipantBaselineDocument, options);
      }
export function useGetParticipantBaselineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantBaselineQuery, GetParticipantBaselineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantBaselineQuery, GetParticipantBaselineQueryVariables>(GetParticipantBaselineDocument, options);
        }
export function useGetParticipantBaselineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantBaselineQuery, GetParticipantBaselineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantBaselineQuery, GetParticipantBaselineQueryVariables>(GetParticipantBaselineDocument, options);
        }
export type GetParticipantBaselineQueryHookResult = ReturnType<typeof useGetParticipantBaselineQuery>;
export type GetParticipantBaselineLazyQueryHookResult = ReturnType<typeof useGetParticipantBaselineLazyQuery>;
export type GetParticipantBaselineSuspenseQueryHookResult = ReturnType<typeof useGetParticipantBaselineSuspenseQuery>;
export type GetParticipantBaselineQueryResult = Apollo.QueryResult<GetParticipantBaselineQuery, GetParticipantBaselineQueryVariables>;
export const UpdateBroadcastOptOutDocument = gql`
    mutation UpdateBroadcastOptOut($input: UpdateBroadcastOptOutInput!) {
  updateBroadcastOptOut(input: $input) {
    preferencesId
    userId
    broadcastOptOut
    lastUpdatedAt
  }
}
    `;
export type UpdateBroadcastOptOutMutationFn = Apollo.MutationFunction<UpdateBroadcastOptOutMutation, UpdateBroadcastOptOutMutationVariables>;

/**
 * __useUpdateBroadcastOptOutMutation__
 *
 * To run a mutation, you first call `useUpdateBroadcastOptOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBroadcastOptOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBroadcastOptOutMutation, { data, loading, error }] = useUpdateBroadcastOptOutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBroadcastOptOutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBroadcastOptOutMutation, UpdateBroadcastOptOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBroadcastOptOutMutation, UpdateBroadcastOptOutMutationVariables>(UpdateBroadcastOptOutDocument, options);
      }
export type UpdateBroadcastOptOutMutationHookResult = ReturnType<typeof useUpdateBroadcastOptOutMutation>;
export type UpdateBroadcastOptOutMutationResult = Apollo.MutationResult<UpdateBroadcastOptOutMutation>;
export type UpdateBroadcastOptOutMutationOptions = Apollo.BaseMutationOptions<UpdateBroadcastOptOutMutation, UpdateBroadcastOptOutMutationVariables>;
export const UpdateContentAssignmentOptOutDocument = gql`
    mutation UpdateContentAssignmentOptOut($input: UpdateContentAssignmentOptOutInput!) {
  updateContentAssignmentOptOut(input: $input) {
    id
  }
}
    `;
export type UpdateContentAssignmentOptOutMutationFn = Apollo.MutationFunction<UpdateContentAssignmentOptOutMutation, UpdateContentAssignmentOptOutMutationVariables>;

/**
 * __useUpdateContentAssignmentOptOutMutation__
 *
 * To run a mutation, you first call `useUpdateContentAssignmentOptOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentAssignmentOptOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentAssignmentOptOutMutation, { data, loading, error }] = useUpdateContentAssignmentOptOutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentAssignmentOptOutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentAssignmentOptOutMutation, UpdateContentAssignmentOptOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentAssignmentOptOutMutation, UpdateContentAssignmentOptOutMutationVariables>(UpdateContentAssignmentOptOutDocument, options);
      }
export type UpdateContentAssignmentOptOutMutationHookResult = ReturnType<typeof useUpdateContentAssignmentOptOutMutation>;
export type UpdateContentAssignmentOptOutMutationResult = Apollo.MutationResult<UpdateContentAssignmentOptOutMutation>;
export type UpdateContentAssignmentOptOutMutationOptions = Apollo.BaseMutationOptions<UpdateContentAssignmentOptOutMutation, UpdateContentAssignmentOptOutMutationVariables>;
export const GetWeeklyAchievementsDocument = gql`
    query GetWeeklyAchievements($userId: ID!, $weekDay: Date) {
  weeklyAchievements(userId: $userId, weekDay: $weekDay) {
    userId
    weekStartDate
    achievements {
      protocol
      committedMinutes
      completedMinutes
      isCompleted
      remainingText
    }
  }
}
    `;

/**
 * __useGetWeeklyAchievementsQuery__
 *
 * To run a query within a React component, call `useGetWeeklyAchievementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyAchievementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyAchievementsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      weekDay: // value for 'weekDay'
 *   },
 * });
 */
export function useGetWeeklyAchievementsQuery(baseOptions: Apollo.QueryHookOptions<GetWeeklyAchievementsQuery, GetWeeklyAchievementsQueryVariables> & ({ variables: GetWeeklyAchievementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyAchievementsQuery, GetWeeklyAchievementsQueryVariables>(GetWeeklyAchievementsDocument, options);
      }
export function useGetWeeklyAchievementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyAchievementsQuery, GetWeeklyAchievementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyAchievementsQuery, GetWeeklyAchievementsQueryVariables>(GetWeeklyAchievementsDocument, options);
        }
export function useGetWeeklyAchievementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWeeklyAchievementsQuery, GetWeeklyAchievementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWeeklyAchievementsQuery, GetWeeklyAchievementsQueryVariables>(GetWeeklyAchievementsDocument, options);
        }
export type GetWeeklyAchievementsQueryHookResult = ReturnType<typeof useGetWeeklyAchievementsQuery>;
export type GetWeeklyAchievementsLazyQueryHookResult = ReturnType<typeof useGetWeeklyAchievementsLazyQuery>;
export type GetWeeklyAchievementsSuspenseQueryHookResult = ReturnType<typeof useGetWeeklyAchievementsSuspenseQuery>;
export type GetWeeklyAchievementsQueryResult = Apollo.QueryResult<GetWeeklyAchievementsQuery, GetWeeklyAchievementsQueryVariables>;